(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
window.Backbone = require('backbone');

window.Backbone.$ = window.$;

require('../../modules/support/frontend/support');

require("./vendor_modules/jQuery/jQuery-ui-1.10.1.min.js");

require("./vendor_modules/jQuery/datetimepicker.js");

require("./vendor_modules/jQuery/pagination/jQuery-pagination-2.2.js");

require("./vendor_modules/mustache-0.7.2.js");



},{"../../modules/support/frontend/support":100,"./vendor_modules/jQuery/datetimepicker.js":3,"./vendor_modules/jQuery/jQuery-ui-1.10.1.min.js":4,"./vendor_modules/jQuery/pagination/jQuery-pagination-2.2.js":5,"./vendor_modules/mustache-0.7.2.js":6,"backbone":245}],2:[function(require,module,exports){
(function (process){
/*global setImmediate: false, setTimeout: false, console: false */
(function () {

    var async = {};

    // global on the server, window in the browser
    var root, previous_async;

    root = this;
    if (root != null) {
      previous_async = root.async;
    }

    async.noConflict = function () {
        root.async = previous_async;
        return async;
    };

    function only_once(fn) {
        var called = false;
        return function() {
            if (called) throw new Error("Callback was already called.");
            called = true;
            fn.apply(root, arguments);
        }
    }

    //// cross-browser compatiblity functions ////

    var _each = function (arr, iterator) {
        if (arr.forEach) {
            return arr.forEach(iterator);
        }
        for (var i = 0; i < arr.length; i += 1) {
            iterator(arr[i], i, arr);
        }
    };

    var _map = function (arr, iterator) {
        if (arr.map) {
            return arr.map(iterator);
        }
        var results = [];
        _each(arr, function (x, i, a) {
            results.push(iterator(x, i, a));
        });
        return results;
    };

    var _reduce = function (arr, iterator, memo) {
        if (arr.reduce) {
            return arr.reduce(iterator, memo);
        }
        _each(arr, function (x, i, a) {
            memo = iterator(memo, x, i, a);
        });
        return memo;
    };

    var _keys = function (obj) {
        if (Object.keys) {
            return Object.keys(obj);
        }
        var keys = [];
        for (var k in obj) {
            if (obj.hasOwnProperty(k)) {
                keys.push(k);
            }
        }
        return keys;
    };

    //// exported async module functions ////

    //// nextTick implementation with browser-compatible fallback ////
    if (typeof process === 'undefined' || !(process.nextTick)) {
        if (typeof setImmediate === 'function') {
            async.setImmediate = setImmediate;
            async.nextTick = setImmediate;
        }
        else {
            async.nextTick = function (fn) {
                setTimeout(fn, 0);
            };
            async.setImmediate = async.nextTick;
        }
    }
    else {
        async.nextTick = process.nextTick;
        if (typeof setImmediate !== 'undefined') {
            async.setImmediate = setImmediate;
        }
        else {
            async.setImmediate = async.nextTick;
        }
    }

    async.each = function (arr, iterator, callback) {
        callback = callback || function () {};
        if (!arr.length) {
            return callback();
        }
        var completed = 0;
        _each(arr, function (x) {
            iterator(x, only_once(function (err) {
                if (err) {
                    callback(err);
                    callback = function () {};
                }
                else {
                    completed += 1;
                    if (completed >= arr.length) {
                        callback(null);
                    }
                }
            }));
        });
    };
    async.forEach = async.each;

    async.eachSeries = function (arr, iterator, callback) {
        callback = callback || function () {};
        if (!arr.length) {
            return callback();
        }
        var completed = 0;
        var iterate = function () {
            iterator(arr[completed], function (err) {
                if (err) {
                    callback(err);
                    callback = function () {};
                }
                else {
                    completed += 1;
                    if (completed >= arr.length) {
                        callback(null);
                    }
                    else {
                        iterate();
                    }
                }
            });
        };
        iterate();
    };
    async.forEachSeries = async.eachSeries;

    async.eachLimit = function (arr, limit, iterator, callback) {
        var fn = _eachLimit(limit);
        fn.apply(null, [arr, iterator, callback]);
    };
    async.forEachLimit = async.eachLimit;

    var _eachLimit = function (limit) {

        return function (arr, iterator, callback) {
            callback = callback || function () {};
            if (!arr.length || limit <= 0) {
                return callback();
            }
            var completed = 0;
            var started = 0;
            var running = 0;

            (function replenish () {
                if (completed >= arr.length) {
                    return callback();
                }

                while (running < limit && started < arr.length) {
                    started += 1;
                    running += 1;
                    iterator(arr[started - 1], function (err) {
                        if (err) {
                            callback(err);
                            callback = function () {};
                        }
                        else {
                            completed += 1;
                            running -= 1;
                            if (completed >= arr.length) {
                                callback();
                            }
                            else {
                                replenish();
                            }
                        }
                    });
                }
            })();
        };
    };


    var doParallel = function (fn) {
        return function () {
            var args = Array.prototype.slice.call(arguments);
            return fn.apply(null, [async.each].concat(args));
        };
    };
    var doParallelLimit = function(limit, fn) {
        return function () {
            var args = Array.prototype.slice.call(arguments);
            return fn.apply(null, [_eachLimit(limit)].concat(args));
        };
    };
    var doSeries = function (fn) {
        return function () {
            var args = Array.prototype.slice.call(arguments);
            return fn.apply(null, [async.eachSeries].concat(args));
        };
    };


    var _asyncMap = function (eachfn, arr, iterator, callback) {
        var results = [];
        arr = _map(arr, function (x, i) {
            return {index: i, value: x};
        });
        eachfn(arr, function (x, callback) {
            iterator(x.value, function (err, v) {
                results[x.index] = v;
                callback(err);
            });
        }, function (err) {
            callback(err, results);
        });
    };
    async.map = doParallel(_asyncMap);
    async.mapSeries = doSeries(_asyncMap);
    async.mapLimit = function (arr, limit, iterator, callback) {
        return _mapLimit(limit)(arr, iterator, callback);
    };

    var _mapLimit = function(limit) {
        return doParallelLimit(limit, _asyncMap);
    };

    // reduce only has a series version, as doing reduce in parallel won't
    // work in many situations.
    async.reduce = function (arr, memo, iterator, callback) {
        async.eachSeries(arr, function (x, callback) {
            iterator(memo, x, function (err, v) {
                memo = v;
                callback(err);
            });
        }, function (err) {
            callback(err, memo);
        });
    };
    // inject alias
    async.inject = async.reduce;
    // foldl alias
    async.foldl = async.reduce;

    async.reduceRight = function (arr, memo, iterator, callback) {
        var reversed = _map(arr, function (x) {
            return x;
        }).reverse();
        async.reduce(reversed, memo, iterator, callback);
    };
    // foldr alias
    async.foldr = async.reduceRight;

    var _filter = function (eachfn, arr, iterator, callback) {
        var results = [];
        arr = _map(arr, function (x, i) {
            return {index: i, value: x};
        });
        eachfn(arr, function (x, callback) {
            iterator(x.value, function (v) {
                if (v) {
                    results.push(x);
                }
                callback();
            });
        }, function (err) {
            callback(_map(results.sort(function (a, b) {
                return a.index - b.index;
            }), function (x) {
                return x.value;
            }));
        });
    };
    async.filter = doParallel(_filter);
    async.filterSeries = doSeries(_filter);
    // select alias
    async.select = async.filter;
    async.selectSeries = async.filterSeries;

    var _reject = function (eachfn, arr, iterator, callback) {
        var results = [];
        arr = _map(arr, function (x, i) {
            return {index: i, value: x};
        });
        eachfn(arr, function (x, callback) {
            iterator(x.value, function (v) {
                if (!v) {
                    results.push(x);
                }
                callback();
            });
        }, function (err) {
            callback(_map(results.sort(function (a, b) {
                return a.index - b.index;
            }), function (x) {
                return x.value;
            }));
        });
    };
    async.reject = doParallel(_reject);
    async.rejectSeries = doSeries(_reject);

    var _detect = function (eachfn, arr, iterator, main_callback) {
        eachfn(arr, function (x, callback) {
            iterator(x, function (result) {
                if (result) {
                    main_callback(x);
                    main_callback = function () {};
                }
                else {
                    callback();
                }
            });
        }, function (err) {
            main_callback();
        });
    };
    async.detect = doParallel(_detect);
    async.detectSeries = doSeries(_detect);

    async.some = function (arr, iterator, main_callback) {
        async.each(arr, function (x, callback) {
            iterator(x, function (v) {
                if (v) {
                    main_callback(true);
                    main_callback = function () {};
                }
                callback();
            });
        }, function (err) {
            main_callback(false);
        });
    };
    // any alias
    async.any = async.some;

    async.every = function (arr, iterator, main_callback) {
        async.each(arr, function (x, callback) {
            iterator(x, function (v) {
                if (!v) {
                    main_callback(false);
                    main_callback = function () {};
                }
                callback();
            });
        }, function (err) {
            main_callback(true);
        });
    };
    // all alias
    async.all = async.every;

    async.sortBy = function (arr, iterator, callback) {
        async.map(arr, function (x, callback) {
            iterator(x, function (err, criteria) {
                if (err) {
                    callback(err);
                }
                else {
                    callback(null, {value: x, criteria: criteria});
                }
            });
        }, function (err, results) {
            if (err) {
                return callback(err);
            }
            else {
                var fn = function (left, right) {
                    var a = left.criteria, b = right.criteria;
                    return a < b ? -1 : a > b ? 1 : 0;
                };
                callback(null, _map(results.sort(fn), function (x) {
                    return x.value;
                }));
            }
        });
    };

    async.auto = function (tasks, callback) {
        callback = callback || function () {};
        var keys = _keys(tasks);
        if (!keys.length) {
            return callback(null);
        }

        var results = {};

        var listeners = [];
        var addListener = function (fn) {
            listeners.unshift(fn);
        };
        var removeListener = function (fn) {
            for (var i = 0; i < listeners.length; i += 1) {
                if (listeners[i] === fn) {
                    listeners.splice(i, 1);
                    return;
                }
            }
        };
        var taskComplete = function () {
            _each(listeners.slice(0), function (fn) {
                fn();
            });
        };

        addListener(function () {
            if (_keys(results).length === keys.length) {
                callback(null, results);
                callback = function () {};
            }
        });

        _each(keys, function (k) {
            var task = (tasks[k] instanceof Function) ? [tasks[k]]: tasks[k];
            var taskCallback = function (err) {
                var args = Array.prototype.slice.call(arguments, 1);
                if (args.length <= 1) {
                    args = args[0];
                }
                if (err) {
                    var safeResults = {};
                    _each(_keys(results), function(rkey) {
                        safeResults[rkey] = results[rkey];
                    });
                    safeResults[k] = args;
                    callback(err, safeResults);
                    // stop subsequent errors hitting callback multiple times
                    callback = function () {};
                }
                else {
                    results[k] = args;
                    async.setImmediate(taskComplete);
                }
            };
            var requires = task.slice(0, Math.abs(task.length - 1)) || [];
            var ready = function () {
                return _reduce(requires, function (a, x) {
                    return (a && results.hasOwnProperty(x));
                }, true) && !results.hasOwnProperty(k);
            };
            if (ready()) {
                task[task.length - 1](taskCallback, results);
            }
            else {
                var listener = function () {
                    if (ready()) {
                        removeListener(listener);
                        task[task.length - 1](taskCallback, results);
                    }
                };
                addListener(listener);
            }
        });
    };

    async.waterfall = function (tasks, callback) {
        callback = callback || function () {};
        if (tasks.constructor !== Array) {
          var err = new Error('First argument to waterfall must be an array of functions');
          return callback(err);
        }
        if (!tasks.length) {
            return callback();
        }
        var wrapIterator = function (iterator) {
            return function (err) {
                if (err) {
                    callback.apply(null, arguments);
                    callback = function () {};
                }
                else {
                    var args = Array.prototype.slice.call(arguments, 1);
                    var next = iterator.next();
                    if (next) {
                        args.push(wrapIterator(next));
                    }
                    else {
                        args.push(callback);
                    }
                    async.setImmediate(function () {
                        iterator.apply(null, args);
                    });
                }
            };
        };
        wrapIterator(async.iterator(tasks))();
    };

    var _parallel = function(eachfn, tasks, callback) {
        callback = callback || function () {};
        if (tasks.constructor === Array) {
            eachfn.map(tasks, function (fn, callback) {
                if (fn) {
                    fn(function (err) {
                        var args = Array.prototype.slice.call(arguments, 1);
                        if (args.length <= 1) {
                            args = args[0];
                        }
                        callback.call(null, err, args);
                    });
                }
            }, callback);
        }
        else {
            var results = {};
            eachfn.each(_keys(tasks), function (k, callback) {
                tasks[k](function (err) {
                    var args = Array.prototype.slice.call(arguments, 1);
                    if (args.length <= 1) {
                        args = args[0];
                    }
                    results[k] = args;
                    callback(err);
                });
            }, function (err) {
                callback(err, results);
            });
        }
    };

    async.parallel = function (tasks, callback) {
        _parallel({ map: async.map, each: async.each }, tasks, callback);
    };

    async.parallelLimit = function(tasks, limit, callback) {
        _parallel({ map: _mapLimit(limit), each: _eachLimit(limit) }, tasks, callback);
    };

    async.series = function (tasks, callback) {
        callback = callback || function () {};
        if (tasks.constructor === Array) {
            async.mapSeries(tasks, function (fn, callback) {
                if (fn) {
                    fn(function (err) {
                        var args = Array.prototype.slice.call(arguments, 1);
                        if (args.length <= 1) {
                            args = args[0];
                        }
                        callback.call(null, err, args);
                    });
                }
            }, callback);
        }
        else {
            var results = {};
            async.eachSeries(_keys(tasks), function (k, callback) {
                tasks[k](function (err) {
                    var args = Array.prototype.slice.call(arguments, 1);
                    if (args.length <= 1) {
                        args = args[0];
                    }
                    results[k] = args;
                    callback(err);
                });
            }, function (err) {
                callback(err, results);
            });
        }
    };

    async.iterator = function (tasks) {
        var makeCallback = function (index) {
            var fn = function () {
                if (tasks.length) {
                    tasks[index].apply(null, arguments);
                }
                return fn.next();
            };
            fn.next = function () {
                return (index < tasks.length - 1) ? makeCallback(index + 1): null;
            };
            return fn;
        };
        return makeCallback(0);
    };

    async.apply = function (fn) {
        var args = Array.prototype.slice.call(arguments, 1);
        return function () {
            return fn.apply(
                null, args.concat(Array.prototype.slice.call(arguments))
            );
        };
    };

    var _concat = function (eachfn, arr, fn, callback) {
        var r = [];
        eachfn(arr, function (x, cb) {
            fn(x, function (err, y) {
                r = r.concat(y || []);
                cb(err);
            });
        }, function (err) {
            callback(err, r);
        });
    };
    async.concat = doParallel(_concat);
    async.concatSeries = doSeries(_concat);

    async.whilst = function (test, iterator, callback) {
        if (test()) {
            iterator(function (err) {
                if (err) {
                    return callback(err);
                }
                async.whilst(test, iterator, callback);
            });
        }
        else {
            callback();
        }
    };

    async.doWhilst = function (iterator, test, callback) {
        iterator(function (err) {
            if (err) {
                return callback(err);
            }
            if (test()) {
                async.doWhilst(iterator, test, callback);
            }
            else {
                callback();
            }
        });
    };

    async.until = function (test, iterator, callback) {
        if (!test()) {
            iterator(function (err) {
                if (err) {
                    return callback(err);
                }
                async.until(test, iterator, callback);
            });
        }
        else {
            callback();
        }
    };

    async.doUntil = function (iterator, test, callback) {
        iterator(function (err) {
            if (err) {
                return callback(err);
            }
            if (!test()) {
                async.doUntil(iterator, test, callback);
            }
            else {
                callback();
            }
        });
    };

    async.queue = function (worker, concurrency) {
        if (concurrency === undefined) {
            concurrency = 1;
        }
        function _insert(q, data, pos, callback) {
          if(data.constructor !== Array) {
              data = [data];
          }
          _each(data, function(task) {
              var item = {
                  data: task,
                  callback: typeof callback === 'function' ? callback : null
              };

              if (pos) {
                q.tasks.unshift(item);
              } else {
                q.tasks.push(item);
              }

              if (q.saturated && q.tasks.length === concurrency) {
                  q.saturated();
              }
              async.setImmediate(q.process);
          });
        }

        var workers = 0;
        var q = {
            tasks: [],
            concurrency: concurrency,
            saturated: null,
            empty: null,
            drain: null,
            push: function (data, callback) {
              _insert(q, data, false, callback);
            },
            unshift: function (data, callback) {
              _insert(q, data, true, callback);
            },
            process: function () {
                if (workers < q.concurrency && q.tasks.length) {
                    var task = q.tasks.shift();
                    if (q.empty && q.tasks.length === 0) {
                        q.empty();
                    }
                    workers += 1;
                    var next = function () {
                        workers -= 1;
                        if (task.callback) {
                            task.callback.apply(task, arguments);
                        }
                        if (q.drain && q.tasks.length + workers === 0) {
                            q.drain();
                        }
                        q.process();
                    };
                    var cb = only_once(next);
                    worker(task.data, cb);
                }
            },
            length: function () {
                return q.tasks.length;
            },
            running: function () {
                return workers;
            }
        };
        return q;
    };

    async.cargo = function (worker, payload) {
        var working     = false,
            tasks       = [];

        var cargo = {
            tasks: tasks,
            payload: payload,
            saturated: null,
            empty: null,
            drain: null,
            push: function (data, callback) {
                if(data.constructor !== Array) {
                    data = [data];
                }
                _each(data, function(task) {
                    tasks.push({
                        data: task,
                        callback: typeof callback === 'function' ? callback : null
                    });
                    if (cargo.saturated && tasks.length === payload) {
                        cargo.saturated();
                    }
                });
                async.setImmediate(cargo.process);
            },
            process: function process() {
                if (working) return;
                if (tasks.length === 0) {
                    if(cargo.drain) cargo.drain();
                    return;
                }

                var ts = typeof payload === 'number'
                            ? tasks.splice(0, payload)
                            : tasks.splice(0);

                var ds = _map(ts, function (task) {
                    return task.data;
                });

                if(cargo.empty) cargo.empty();
                working = true;
                worker(ds, function () {
                    working = false;

                    var args = arguments;
                    _each(ts, function (data) {
                        if (data.callback) {
                            data.callback.apply(null, args);
                        }
                    });

                    process();
                });
            },
            length: function () {
                return tasks.length;
            },
            running: function () {
                return working;
            }
        };
        return cargo;
    };

    var _console_fn = function (name) {
        return function (fn) {
            var args = Array.prototype.slice.call(arguments, 1);
            fn.apply(null, args.concat([function (err) {
                var args = Array.prototype.slice.call(arguments, 1);
                if (typeof console !== 'undefined') {
                    if (err) {
                        if (console.error) {
                            console.error(err);
                        }
                    }
                    else if (console[name]) {
                        _each(args, function (x) {
                            console[name](x);
                        });
                    }
                }
            }]));
        };
    };
    async.log = _console_fn('log');
    async.dir = _console_fn('dir');
    /*async.info = _console_fn('info');
    async.warn = _console_fn('warn');
    async.error = _console_fn('error');*/

    async.memoize = function (fn, hasher) {
        var memo = {};
        var queues = {};
        hasher = hasher || function (x) {
            return x;
        };
        var memoized = function () {
            var args = Array.prototype.slice.call(arguments);
            var callback = args.pop();
            var key = hasher.apply(null, args);
            if (key in memo) {
                callback.apply(null, memo[key]);
            }
            else if (key in queues) {
                queues[key].push(callback);
            }
            else {
                queues[key] = [callback];
                fn.apply(null, args.concat([function () {
                    memo[key] = arguments;
                    var q = queues[key];
                    delete queues[key];
                    for (var i = 0, l = q.length; i < l; i++) {
                      q[i].apply(null, arguments);
                    }
                }]));
            }
        };
        memoized.memo = memo;
        memoized.unmemoized = fn;
        return memoized;
    };

    async.unmemoize = function (fn) {
      return function () {
        return (fn.unmemoized || fn).apply(null, arguments);
      };
    };

    async.times = function (count, iterator, callback) {
        var counter = [];
        for (var i = 0; i < count; i++) {
            counter.push(i);
        }
        return async.map(counter, iterator, callback);
    };

    async.timesSeries = function (count, iterator, callback) {
        var counter = [];
        for (var i = 0; i < count; i++) {
            counter.push(i);
        }
        return async.mapSeries(counter, iterator, callback);
    };

    async.compose = function (/* functions... */) {
        var fns = Array.prototype.reverse.call(arguments);
        return function () {
            var that = this;
            var args = Array.prototype.slice.call(arguments);
            var callback = args.pop();
            async.reduce(fns, args, function (newargs, fn, cb) {
                fn.apply(that, newargs.concat([function () {
                    var err = arguments[0];
                    var nextargs = Array.prototype.slice.call(arguments, 1);
                    cb(err, nextargs);
                }]))
            },
            function (err, results) {
                callback.apply(that, [err].concat(results));
            });
        };
    };

    var _applyEach = function (eachfn, fns /*args...*/) {
        var go = function () {
            var that = this;
            var args = Array.prototype.slice.call(arguments);
            var callback = args.pop();
            return eachfn(fns, function (fn, cb) {
                fn.apply(that, args.concat([cb]));
            },
            callback);
        };
        if (arguments.length > 2) {
            var args = Array.prototype.slice.call(arguments, 2);
            return go.apply(this, args);
        }
        else {
            return go;
        }
    };
    async.applyEach = doParallel(_applyEach);
    async.applyEachSeries = doSeries(_applyEach);

    async.forever = function (fn, callback) {
        function next(err) {
            if (err) {
                if (callback) {
                    return callback(err);
                }
                throw err;
            }
            fn(next);
        }
        next();
    };

    // AMD / RequireJS
    if (typeof define !== 'undefined' && define.amd) {
        define([], function () {
            return async;
        });
    }
    // Node.js
    else if (typeof module !== 'undefined' && module.exports) {
        module.exports = async;
    }
    // included directly via <script> tag
    else {
        root.async = async;
    }

}());
}).call(this,require('_process'))

},{"_process":246}],3:[function(require,module,exports){
/**
 * @preserve jQuery DateTimePicker plugin v2.3.4
 * @homepage http://xdsoft.net/jqplugins/datetimepicker/
 * (c) 2014, Chupurnov Valeriy.
 */
(function(e){"use strict";var t={i18n:{ar:{months:["كانون الثاني","شباط","آذار","نيسان","مايو","حزيران","تموز","آب","أيلول","تشرين الأول","تشرين الثاني","كانون الأول"],dayOfWeek:["ن","ث","ع","خ","ج","س","ح"]},ro:{months:["ianuarie","februarie","martie","aprilie","mai","iunie","iulie","august","septembrie","octombrie","noiembrie","decembrie"],dayOfWeek:["l","ma","mi","j","v","s","d"]},id:{months:["Januari","Februari","Maret","April","Mei","Juni","Juli","Agustus","September","Oktober","November","Desember"],dayOfWeek:["Sen","Sel","Rab","Kam","Jum","Sab","Min"]},bg:{months:["Януари","Февруари","Март","Април","Май","Юни","Юли","Август","Септември","Октомври","Ноември","Декември"],dayOfWeek:["Нд","Пн","Вт","Ср","Чт","Пт","Сб"]},fa:{months:["فروردین","اردیبهشت","خرداد","تیر","مرداد","شهریور","مهر","آبان","آذر","دی","بهمن","اسفند"],dayOfWeek:["یکشنبه","دوشنبه","سه شنبه","چهارشنبه","پنجشنبه","جمعه","شنبه"]},ru:{months:["Январь","Февраль","Март","Апрель","Май","Июнь","Июль","Август","Сентябрь","Октябрь","Ноябрь","Декабрь"],dayOfWeek:["Вск","Пн","Вт","Ср","Чт","Пт","Сб"]},uk:{months:["Січень","Лютий","Березень","Квітень","Травень","Червень","Липень","Серпень","Вересень","Жовтень","Листопад","Грудень"],dayOfWeek:["Ндл","Пнд","Втр","Срд","Чтв","Птн","Сбт"]},en:{months:["January","February","March","April","May","June","July","August","September","October","November","December"],dayOfWeek:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"]},el:{months:["Ιανουάριος","Φεβρουάριος","Μάρτιος","Απρίλιος","Μάιος","Ιούνιος","Ιούλιος","Αύγουστος","Σεπτέμβριος","Οκτώβριος","Νοέμβριος","Δεκέμβριος"],dayOfWeek:["Κυρ","Δευ","Τρι","Τετ","Πεμ","Παρ","Σαβ"]},de:{months:["Januar","Februar","März","April","Mai","Juni","Juli","August","September","Oktober","November","Dezember"],dayOfWeek:["So","Mo","Di","Mi","Do","Fr","Sa"]},nl:{months:["januari","februari","maart","april","mei","juni","juli","augustus","september","oktober","november","december"],dayOfWeek:["zo","ma","di","wo","do","vr","za"]},tr:{months:["Ocak","Şubat","Mart","Nisan","Mayıs","Haziran","Temmuz","Ağustos","Eylül","Ekim","Kasım","Aralık"],dayOfWeek:["Paz","Pts","Sal","Çar","Per","Cum","Cts"]},fr:{months:["Janvier","Février","Mars","Avril","Mai","Juin","Juillet","Août","Septembre","Octobre","Novembre","Décembre"],dayOfWeek:["Dim","Lun","Mar","Mer","Jeu","Ven","Sam"]},es:{months:["Enero","Febrero","Marzo","Abril","Mayo","Junio","Julio","Agosto","Septiembre","Octubre","Noviembre","Diciembre"],dayOfWeek:["Dom","Lun","Mar","Mié","Jue","Vie","Sáb"]},th:{months:["มกราคม","กุมภาพันธ์","มีนาคม","เมษายน","พฤษภาคม","มิถุนายน","กรกฎาคม","สิงหาคม","กันยายน","ตุลาคม","พฤศจิกายน","ธันวาคม"],dayOfWeek:["อา.","จ.","อ.","พ.","พฤ.","ศ.","ส."]},pl:{months:["styczeń","luty","marzec","kwiecień","maj","czerwiec","lipiec","sierpień","wrzesień","październik","listopad","grudzień"],dayOfWeek:["nd","pn","wt","śr","cz","pt","sb"]},pt:{months:["Janeiro","Fevereiro","Março","Abril","Maio","Junho","Julho","Agosto","Setembro","Outubro","Novembro","Dezembro"],dayOfWeek:["Dom","Seg","Ter","Qua","Qui","Sex","Sab"]},ch:{months:["一月","二月","三月","四月","五月","六月","七月","八月","九月","十月","十一月","十二月"],dayOfWeek:["日","一","二","三","四","五","六"]},se:{months:["Januari","Februari","Mars","April","Maj","Juni","Juli","Augusti","September","Oktober","November","December"],dayOfWeek:["Sön","Mån","Tis","Ons","Tor","Fre","Lör"]},kr:{months:["1월","2월","3월","4월","5월","6월","7월","8월","9월","10월","11월","12월"],dayOfWeek:["일","월","화","수","목","금","토"]},it:{months:["Gennaio","Febbraio","Marzo","Aprile","Maggio","Giugno","Luglio","Agosto","Settembre","Ottobre","Novembre","Dicembre"],dayOfWeek:["Dom","Lun","Mar","Mer","Gio","Ven","Sab"]},da:{months:["January","Februar","Marts","April","Maj","Juni","July","August","September","Oktober","November","December"],dayOfWeek:["Søn","Man","Tir","Ons","Tor","Fre","Lør"]},no:{months:["Januar","Februar","Mars","April","Mai","Juni","Juli","August","September","Oktober","November","Desember"],dayOfWeek:["Søn","Man","Tir","Ons","Tor","Fre","Lør"]},ja:{months:["1月","2月","3月","4月","5月","6月","7月","8月","9月","10月","11月","12月"],dayOfWeek:["日","月","火","水","木","金","土"]},vi:{months:["Tháng 1","Tháng 2","Tháng 3","Tháng 4","Tháng 5","Tháng 6","Tháng 7","Tháng 8","Tháng 9","Tháng 10","Tháng 11","Tháng 12"],dayOfWeek:["CN","T2","T3","T4","T5","T6","T7"]},sl:{months:["Januar","Februar","Marec","April","Maj","Junij","Julij","Avgust","September","Oktober","November","December"],dayOfWeek:["Ned","Pon","Tor","Sre","Čet","Pet","Sob"]},cs:{months:["Leden","Únor","Březen","Duben","Květen","Červen","Červenec","Srpen","Září","Říjen","Listopad","Prosinec"],dayOfWeek:["Ne","Po","Út","St","Čt","Pá","So"]},hu:{months:["Január","Február","Március","Április","Május","Június","Július","Augusztus","Szeptember","Október","November","December"],dayOfWeek:["Va","Hé","Ke","Sze","Cs","Pé","Szo"]}},value:"",lang:"en",format:"Y/m/d H:i",formatTime:"H:i",formatDate:"Y/m/d",startDate:false,step:60,monthChangeSpinner:true,closeOnDateSelect:false,closeOnWithoutClick:true,closeOnInputClick:true,timepicker:true,datepicker:true,weeks:false,defaultTime:false,defaultDate:false,minDate:false,maxDate:false,minTime:false,maxTime:false,allowTimes:[],opened:false,initTime:true,inline:false,onSelectDate:function(){},onSelectTime:function(){},onChangeMonth:function(){},onChangeDateTime:function(){},onShow:function(){},onClose:function(){},onGenerate:function(){},withoutCopyright:true,inverseButton:false,hours12:false,next:"xdsoft_next",prev:"xdsoft_prev",dayOfWeekStart:0,timeHeightInTimePicker:25,timepickerScrollbar:true,todayButton:true,defaultSelect:true,scrollMonth:true,scrollTime:true,scrollInput:true,lazyInit:false,mask:false,validateOnBlur:true,allowBlank:true,yearStart:1950,yearEnd:2050,style:"",id:"",fixed:false,roundTime:"round",className:"",weekends:[],yearOffset:0,beforeShowDay:null};if(!Array.prototype.indexOf){Array.prototype.indexOf=function(e,t){for(var n=t||0,r=this.length;n<r;n++){if(this[n]===e){return n}}return-1}}Date.prototype.countDaysInMonth=function(){return(new Date(this.getFullYear(),this.getMonth()+1,0)).getDate()};e.fn.xdsoftScroller=function(t){return this.each(function(){var n=e(this);if(!e(this).hasClass("xdsoft_scroller_box")){var r=function(e){var t={x:0,y:0};if(e.type=="touchstart"||e.type=="touchmove"||e.type=="touchend"||e.type=="touchcancel"){var n=e.originalEvent.touches[0]||e.originalEvent.changedTouches[0];t.x=n.pageX;t.y=n.pageY}else if(e.type=="mousedown"||e.type=="mouseup"||e.type=="mousemove"||e.type=="mouseover"||e.type=="mouseout"||e.type=="mouseenter"||e.type=="mouseleave"){t.x=e.pageX;t.y=e.pageY}return t},i=0,s=n.children().eq(0),o=n[0].clientHeight,u=s[0].offsetHeight,a=e('<div class="xdsoft_scrollbar"></div>'),f=e('<div class="xdsoft_scroller"></div>'),l=100,c=false;a.append(f);n.addClass("xdsoft_scroller_box").append(a);f.on("mousedown.xdsoft_scroller",function(r){if(!o)n.trigger("resize_scroll.xdsoft_scroller",[t]);var s=r.pageY,u=parseInt(f.css("margin-top")),c=a[0].offsetHeight;e(document.body).addClass("xdsoft_noselect");e([document.body,window]).on("mouseup.xdsoft_scroller",function h(){e([document.body,window]).off("mouseup.xdsoft_scroller",h).off("mousemove.xdsoft_scroller",i).removeClass("xdsoft_noselect")});e(document.body).on("mousemove.xdsoft_scroller",i=function(e){var t=e.pageY-s+u;if(t<0)t=0;if(t+f[0].offsetHeight>c)t=c-f[0].offsetHeight;n.trigger("scroll_element.xdsoft_scroller",[l?t/l:0])})});n.on("scroll_element.xdsoft_scroller",function(e,t){if(!o)n.trigger("resize_scroll.xdsoft_scroller",[t,true]);t=t>1?1:t<0||isNaN(t)?0:t;f.css("margin-top",l*t);setTimeout(function(){s.css("marginTop",-parseInt((s[0].offsetHeight-o)*t))},10)}).on("resize_scroll.xdsoft_scroller",function(e,t,r){o=n[0].clientHeight;u=s[0].offsetHeight;var i=o/u,c=i*a[0].offsetHeight;if(i>1)f.hide();else{f.show();f.css("height",parseInt(c>10?c:10));l=a[0].offsetHeight-f[0].offsetHeight;if(r!==true)n.trigger("scroll_element.xdsoft_scroller",[t?t:Math.abs(parseInt(s.css("marginTop")))/(u-o)])}});n.mousewheel&&n.mousewheel(function(e,t,r,i){var a=Math.abs(parseInt(s.css("marginTop")));n.trigger("scroll_element.xdsoft_scroller",[(a-t*20)/(u-o)]);e.stopPropagation();return false});n.on("touchstart",function(e){c=r(e)});n.on("touchmove",function(e){if(c){var t=r(e),i=Math.abs(parseInt(s.css("marginTop")));n.trigger("scroll_element.xdsoft_scroller",[(i-(t.y-c.y))/(u-o)]);e.stopPropagation();e.preventDefault();c=r(e)}});n.on("touchend touchcancel",function(e){c=false})}n.trigger("resize_scroll.xdsoft_scroller",[t])})};e.fn.datetimepicker=function(n){var r=48,i=57,s=96,o=105,u=17,a=46,f=13,l=27,c=8,h=37,p=38,d=39,v=40,m=9,g=116,y=65,b=67,w=86,E=90,S=89,x=false,T=e.isPlainObject(n)||!n?e.extend(true,{},t,n):e.extend({},t),N=0,C=function(e){e.on("open.xdsoft focusin.xdsoft mousedown.xdsoft",function t(n){if(e.is(":disabled")||e.is(":hidden")||!e.is(":visible")||e.data("xdsoft_datetimepicker"))return;clearTimeout(N);N=setTimeout(function(){if(!e.data("xdsoft_datetimepicker"))k(e);e.off("open.xdsoft focusin.xdsoft mousedown.xdsoft",t).trigger("open.xdsoft")},100)})},k=function(t){function X(){var e=false;if(T.startDate){e=j.strToDate(T.startDate)}else{e=T.value?T.value:t&&t.val&&t.val()?t.val():"";if(e){e=j.strToDateTime(e)}else if(T.defaultDate){e=j.strToDate(T.defaultDate)}}if(e&&j.isValidDate(e)){n.data("changed",true)}else{e=""}return e?e:0}var n=e("<div "+(T.id?'id="'+T.id+'"':"")+" "+(T.style?'style="'+T.style+'"':"")+' class="xdsoft_datetimepicker xdsoft_noselect '+(T.weeks?" xdsoft_showweeks":"")+T.className+'"></div>'),N=e('<div class="xdsoft_copyright"><a target="_blank" href="http://xdsoft.net/jqplugins/datetimepicker/">xdsoft.net</a></div>'),C=e('<div class="xdsoft_datepicker active"></div>'),k=e('<div class="xdsoft_mounthpicker"><button type="button" class="xdsoft_prev"></button><button type="button" class="xdsoft_today_button"></button><div class="xdsoft_label xdsoft_month"><span></span></div><div class="xdsoft_label xdsoft_year"><span></span></div><button type="button" class="xdsoft_next"></button></div>'),L=e('<div class="xdsoft_calendar"></div>'),A=e('<div class="xdsoft_timepicker active"><button type="button" class="xdsoft_prev"></button><div class="xdsoft_time_box"></div><button type="button" class="xdsoft_next"></button></div>'),O=A.find(".xdsoft_time_box").eq(0),M=e('<div class="xdsoft_time_variant"></div>'),_=e('<div class="xdsoft_scrollbar"></div>'),D=e('<div class="xdsoft_scroller"></div>'),P=e('<div class="xdsoft_select xdsoft_monthselect"><div></div></div>'),H=e('<div class="xdsoft_select xdsoft_yearselect"><div></div></div>');k.find(".xdsoft_month span").after(P);k.find(".xdsoft_year span").after(H);k.find(".xdsoft_month,.xdsoft_year").on("mousedown.xdsoft",function(t){k.find(".xdsoft_select").hide();var n=e(this).find(".xdsoft_select").eq(0),r=0,i=0;if(j.currentTime)r=j.currentTime[e(this).hasClass("xdsoft_month")?"getMonth":"getFullYear"]();n.show();for(var s=n.find("div.xdsoft_option"),o=0;o<s.length;o++){if(s.eq(o).data("value")==r){break}else i+=s[0].offsetHeight}n.xdsoftScroller(i/(n.children()[0].offsetHeight-n[0].clientHeight));t.stopPropagation();return false});k.find(".xdsoft_select").xdsoftScroller().on("mousedown.xdsoft",function(e){e.stopPropagation();e.preventDefault()}).on("mousedown.xdsoft",".xdsoft_option",function(t){if(j&&j.currentTime)j.currentTime[e(this).parent().parent().hasClass("xdsoft_monthselect")?"setMonth":"setFullYear"](e(this).data("value"));e(this).parent().parent().hide();n.trigger("xchange.xdsoft");T.onChangeMonth&&T.onChangeMonth.call&&T.onChangeMonth.call(n,j.currentTime,n.data("input"))});n.setOptions=function(N){T=e.extend(true,{},T,N);if(N.allowTimes&&e.isArray(N.allowTimes)&&N.allowTimes.length){T["allowTimes"]=e.extend(true,[],N.allowTimes)}if(N.weekends&&e.isArray(N.weekends)&&N.weekends.length){T["weekends"]=e.extend(true,[],N.weekends)}if((T.open||T.opened)&&!T.inline){t.trigger("open.xdsoft")}if(T.inline){q=true;n.addClass("xdsoft_inline");t.after(n).hide()}if(T.inverseButton){T.next="xdsoft_prev";T.prev="xdsoft_next"}if(T.datepicker)C.addClass("active");else C.removeClass("active");if(T.timepicker)A.addClass("active");else A.removeClass("active");if(T.value){t&&t.val&&t.val(T.value);j.setCurrentTime(T.value)}if(isNaN(T.dayOfWeekStart))T.dayOfWeekStart=0;else T.dayOfWeekStart=parseInt(T.dayOfWeekStart)%7;if(!T.timepickerScrollbar)_.hide();if(T.minDate&&/^-(.*)$/.test(T.minDate)){T.minDate=j.strToDateTime(T.minDate).dateFormat(T.formatDate)}if(T.maxDate&&/^\+(.*)$/.test(T.maxDate)){T.maxDate=j.strToDateTime(T.maxDate).dateFormat(T.formatDate)}k.find(".xdsoft_today_button").css("visibility",!T.todayButton?"hidden":"visible");if(T.mask){var L,O=function(e){try{if(document.selection&&document.selection.createRange){var t=document.selection.createRange();return t.getBookmark().charCodeAt(2)-2}else if(e.setSelectionRange)return e.selectionStart}catch(n){return 0}},M=function(e,t){e=typeof e=="string"||e instanceof String?document.getElementById(e):e;if(!e){return false}else if(e.createTextRange){var n=e.createTextRange();n.collapse(true);n.moveEnd(t);n.moveStart(t);n.select();return true}else if(e.setSelectionRange){e.setSelectionRange(t,t);return true}return false},D=function(e,t){var n=e.replace(/([\[\]\/\{\}\(\)\-\.\+]{1})/g,"\\$1").replace(/_/g,"{digit+}").replace(/([0-9]{1})/g,"{digit$1}").replace(/\{digit([0-9]{1})\}/g,"[0-$1_]{1}").replace(/\{digit[\+]\}/g,"[0-9_]{1}");return RegExp(n).test(t)};t.off("keydown.xdsoft");switch(true){case T.mask===true:T.mask=T.format.replace(/Y/g,"9999").replace(/F/g,"9999").replace(/m/g,"19").replace(/d/g,"39").replace(/H/g,"29").replace(/i/g,"59").replace(/s/g,"59");case e.type(T.mask)=="string":if(!D(T.mask,t.val()))t.val(T.mask.replace(/[0-9]/g,"_"));t.on("keydown.xdsoft",function(n){var N=this.value,C=n.which;switch(true){case C>=r&&C<=i||C>=s&&C<=o||C==c||C==a:var k=O(this),L=C!=c&&C!=a?String.fromCharCode(s<=C&&C<=o?C-r:C):"_";if((C==c||C==a)&&k){k--;L="_"}while(/[^0-9_]/.test(T.mask.substr(k,1))&&k<T.mask.length&&k>0)k+=C==c||C==a?-1:1;N=N.substr(0,k)+L+N.substr(k+1);if(e.trim(N)==""){N=T.mask.replace(/[0-9]/g,"_")}else{if(k==T.mask.length)break}k+=C==c||C==a?0:1;while(/[^0-9_]/.test(T.mask.substr(k,1))&&k<T.mask.length&&k>0)k+=C==c||C==a?-1:1;if(D(T.mask,N)){this.value=N;M(this,k)}else if(e.trim(N)=="")this.value=T.mask.replace(/[0-9]/g,"_");else{t.trigger("error_input.xdsoft")}break;case!!~[y,b,w,E,S].indexOf(C)&&x:case!!~[l,p,v,h,d,g,u,m,f].indexOf(C):return true}n.preventDefault();return false});break}}if(T.validateOnBlur){t.off("blur.xdsoft").on("blur.xdsoft",function(){if(T.allowBlank&&!e.trim(e(this).val()).length){e(this).val(null);n.data("xdsoft_datetime").empty()}else if(!Date.parseDate(e(this).val(),T.format)){e(this).val(j.now().dateFormat(T.format));n.data("xdsoft_datetime").setCurrentTime(e(this).val())}else{n.data("xdsoft_datetime").setCurrentTime(e(this).val())}n.trigger("changedatetime.xdsoft")})}T.dayOfWeekStartPrev=T.dayOfWeekStart==0?6:T.dayOfWeekStart-1;n.trigger("xchange.xdsoft").trigger("afterOpen.xdsoft")};n.data("options",T).on("mousedown.xdsoft",function(e){e.stopPropagation();e.preventDefault();H.hide();P.hide();return false});var B=A.find(".xdsoft_time_box");B.append(M);B.xdsoftScroller();n.on("afterOpen.xdsoft",function(){B.xdsoftScroller()});n.append(C).append(A);if(T.withoutCopyright!==true)n.append(N);C.append(k).append(L);e("body").append(n);var j=new function(){var e=this;e.now=function(t){var n=new Date;if(!t&&T.defaultDate){var r=e.strToDate(T.defaultDate);n.setFullYear(r.getFullYear());n.setMonth(r.getMonth());n.setDate(r.getDate())}if(T.yearOffset){n.setFullYear(n.getFullYear()+T.yearOffset)}if(!t&&T.defaultTime){var i=e.strtotime(T.defaultTime);n.setHours(i.getHours());n.setMinutes(i.getMinutes())}return n};e.isValidDate=function(e){if(Object.prototype.toString.call(e)!=="[object Date]")return false;return!isNaN(e.getTime())};e.setCurrentTime=function(t){e.currentTime=typeof t=="string"?e.strToDateTime(t):e.isValidDate(t)?t:e.now();n.trigger("xchange.xdsoft")};e.empty=function(){e.currentTime=null};e.getCurrentTime=function(t){return e.currentTime};e.nextMonth=function(){var t=e.currentTime.getMonth()+1;if(t==12){e.currentTime.setFullYear(e.currentTime.getFullYear()+1);t=0}e.currentTime.setDate(Math.min((new Date(e.currentTime.getFullYear(),t+1,0)).getDate(),e.currentTime.getDate()));e.currentTime.setMonth(t);T.onChangeMonth&&T.onChangeMonth.call&&T.onChangeMonth.call(n,j.currentTime,n.data("input"));n.trigger("xchange.xdsoft");return t};e.prevMonth=function(){var t=e.currentTime.getMonth()-1;if(t==-1){e.currentTime.setFullYear(e.currentTime.getFullYear()-1);t=11}e.currentTime.setDate(Math.min((new Date(e.currentTime.getFullYear(),t+1,0)).getDate(),e.currentTime.getDate()));e.currentTime.setMonth(t);T.onChangeMonth&&T.onChangeMonth.call&&T.onChangeMonth.call(n,j.currentTime,n.data("input"));n.trigger("xchange.xdsoft");return t};e.strToDateTime=function(t){if(t&&t instanceof Date&&e.isValidDate(t))return t;var n=[],r,i;if((n=/^(\+|\-)(.*)$/.exec(t))&&(n[2]=Date.parseDate(n[2],T.formatDate))){r=n[2].getTime()-n[2].getTimezoneOffset()*6e4;i=new Date(j.now().getTime()+parseInt(n[1]+"1")*r)}else i=t?Date.parseDate(t,T.format):e.now();if(!e.isValidDate(i))i=e.now();return i};e.strToDate=function(t){if(t&&t instanceof Date&&e.isValidDate(t))return t;var n=t?Date.parseDate(t,T.formatDate):e.now(true);if(!e.isValidDate(n))n=e.now(true);return n};e.strtotime=function(t){if(t&&t instanceof Date&&e.isValidDate(t))return t;var n=t?Date.parseDate(t,T.formatTime):e.now();if(!e.isValidDate(n))n=e.now(true);return n};e.str=function(){return e.currentTime.dateFormat(T.format)};e.currentTime=this.now()};k.find(".xdsoft_today_button").on("mousedown.xdsoft",function(){n.data("changed",true);j.setCurrentTime(0);n.trigger("afterOpen.xdsoft")}).on("dblclick.xdsoft",function(){t.val(j.str());n.trigger("close.xdsoft")});k.find(".xdsoft_prev,.xdsoft_next").on("mousedown.xdsoft",function(){var t=e(this),n=0,r=false;(function i(e){var s=j.currentTime.getMonth();if(t.hasClass(T.next)){j.nextMonth()}else if(t.hasClass(T.prev)){j.prevMonth()}if(T.monthChangeSpinner){!r&&(n=setTimeout(i,e?e:100))}})(500);e([document.body,window]).on("mouseup.xdsoft",function s(){clearTimeout(n);r=true;e([document.body,window]).off("mouseup.xdsoft",s)})});A.find(".xdsoft_prev,.xdsoft_next").on("mousedown.xdsoft",function(){var t=e(this),n=0,r=false,i=110;(function s(e){var o=O[0].clientHeight,u=M[0].offsetHeight,a=Math.abs(parseInt(M.css("marginTop")));if(t.hasClass(T.next)&&u-o-T.timeHeightInTimePicker>=a){M.css("marginTop","-"+(a+T.timeHeightInTimePicker)+"px")}else if(t.hasClass(T.prev)&&a-T.timeHeightInTimePicker>=0){M.css("marginTop","-"+(a-T.timeHeightInTimePicker)+"px")}O.trigger("scroll_element.xdsoft_scroller",[Math.abs(parseInt(M.css("marginTop"))/(u-o))]);i=i>10?10:i-10;!r&&(n=setTimeout(s,e?e:i))})(500);e([document.body,window]).on("mouseup.xdsoft",function o(){clearTimeout(n);r=true;e([document.body,window]).off("mouseup.xdsoft",o)})});var F=0;n.on("xchange.xdsoft",function(t){clearTimeout(F);F=setTimeout(function(){var t="",r=new Date(j.currentTime.getFullYear(),j.currentTime.getMonth(),1,12,0,0),i=0,s=j.now();while(r.getDay()!=T.dayOfWeekStart)r.setDate(r.getDate()-1);t+="<table><thead><tr>";if(T.weeks){t+="<th></th>"}for(var o=0;o<7;o++){t+="<th>"+T.i18n[T.lang].dayOfWeek[(o+T.dayOfWeekStart)%7]+"</th>"}t+="</tr></thead>";t+="<tbody>";var u=false,a=false;if(T.maxDate!==false){u=j.strToDate(T.maxDate);u=new Date(u.getFullYear(),u.getMonth(),u.getDate(),23,59,59,999)}if(T.minDate!==false){a=j.strToDate(T.minDate);a=new Date(a.getFullYear(),a.getMonth(),a.getDate())}var f,l,c,h,p=[],d,v=true;while(i<j.currentTime.countDaysInMonth()||r.getDay()!=T.dayOfWeekStart||j.currentTime.getMonth()==r.getMonth()){p=[];i++;f=r.getDate();l=r.getFullYear();c=r.getMonth();h=r.getWeekOfYear();p.push("xdsoft_date");if(T.beforeShowDay&&T.beforeShowDay.call){d=T.beforeShowDay.call(n,r)}else{d=null}if(u!==false&&r>u||a!==false&&r<a||d&&d[0]===false){p.push("xdsoft_disabled")}if(d&&d[1]!=""){p.push(d[1])}if(j.currentTime.getMonth()!=c)p.push("xdsoft_other_month");if((T.defaultSelect||n.data("changed"))&&j.currentTime.dateFormat(T.formatDate)==r.dateFormat(T.formatDate)){p.push("xdsoft_current")}if(s.dateFormat(T.formatDate)==r.dateFormat(T.formatDate)){p.push("xdsoft_today")}if(r.getDay()==0||r.getDay()==6||~T.weekends.indexOf(r.dateFormat(T.formatDate))){p.push("xdsoft_weekend")}if(T.beforeShowDay&&typeof T.beforeShowDay=="function"){p.push(T.beforeShowDay(r))}if(v){t+="<tr>";v=false;if(T.weeks){t+="<th>"+h+"</th>"}}t+='<td data-date="'+f+'" data-month="'+c+'" data-year="'+l+'"'+' class="xdsoft_date xdsoft_day_of_week'+r.getDay()+" "+p.join(" ")+'">'+"<div>"+f+"</div>"+"</td>";if(r.getDay()==T.dayOfWeekStartPrev){t+="</tr>";v=true}r.setDate(f+1)}t+="</tbody></table>";L.html(t);k.find(".xdsoft_label span").eq(0).text(T.i18n[T.lang].months[j.currentTime.getMonth()]);k.find(".xdsoft_label span").eq(1).text(j.currentTime.getFullYear());var m="",g="",c="",y=function(t,r){var i=j.now();i.setHours(t);t=parseInt(i.getHours());i.setMinutes(r);r=parseInt(i.getMinutes());p=[];if(T.maxTime!==false&&j.strtotime(T.maxTime).getTime()<i.getTime()||T.minTime!==false&&j.strtotime(T.minTime).getTime()>i.getTime())p.push("xdsoft_disabled");if((T.initTime||T.defaultSelect||n.data("changed"))&&parseInt(j.currentTime.getHours())==parseInt(t)&&(T.step>59||Math[T.roundTime](j.currentTime.getMinutes()/T.step)*T.step==parseInt(r))){if(T.defaultSelect||n.data("changed")){p.push("xdsoft_current")}else if(T.initTime){p.push("xdsoft_init_time")}}if(parseInt(s.getHours())==parseInt(t)&&parseInt(s.getMinutes())==parseInt(r))p.push("xdsoft_today");m+='<div class="xdsoft_time '+p.join(" ")+'" data-hour="'+t+'" data-minute="'+r+'">'+i.dateFormat(T.formatTime)+"</div>"};if(!T.allowTimes||!e.isArray(T.allowTimes)||!T.allowTimes.length){for(var i=0,o=0;i<(T.hours12?12:24);i++){for(o=0;o<60;o+=T.step){g=(i<10?"0":"")+i;c=(o<10?"0":"")+o;y(g,c)}}}else{for(var i=0;i<T.allowTimes.length;i++){g=j.strtotime(T.allowTimes[i]).getHours();c=j.strtotime(T.allowTimes[i]).getMinutes();y(g,c)}}M.html(m);var b="",i=0;for(i=parseInt(T.yearStart,10)+T.yearOffset;i<=parseInt(T.yearEnd,10)+T.yearOffset;i++){b+='<div class="xdsoft_option '+(j.currentTime.getFullYear()==i?"xdsoft_current":"")+'" data-value="'+i+'">'+i+"</div>"}H.children().eq(0).html(b);for(i=0,b="";i<=11;i++){b+='<div class="xdsoft_option '+(j.currentTime.getMonth()==i?"xdsoft_current":"")+'" data-value="'+i+'">'+T.i18n[T.lang].months[i]+"</div>"}P.children().eq(0).html(b);e(n).trigger("generate.xdsoft")},10);t.stopPropagation()}).on("afterOpen.xdsoft",function(){if(T.timepicker){var e;if(M.find(".xdsoft_current").length){e=".xdsoft_current"}else if(M.find(".xdsoft_init_time").length){e=".xdsoft_init_time"}if(e){var t=O[0].clientHeight,n=M[0].offsetHeight,r=M.find(e).index()*T.timeHeightInTimePicker+1;if(n-t<r)r=n-t;O.trigger("scroll_element.xdsoft_scroller",[parseInt(r)/(n-t)])}else{O.trigger("scroll_element.xdsoft_scroller",[0])}}});var I=0;L.on("click.xdsoft","td",function(r){r.stopPropagation();I++;var i=e(this),s=j.currentTime;if(s===undefined||s===null){j.currentTime=j.now();s=j.currentTime}if(i.hasClass("xdsoft_disabled"))return false;s.setDate(1);s.setFullYear(i.data("year"));s.setMonth(i.data("month"));s.setDate(i.data("date"));n.trigger("select.xdsoft",[s]);t.val(j.str());if((I>1||T.closeOnDateSelect===true||T.closeOnDateSelect===0&&!T.timepicker)&&!T.inline){n.trigger("close.xdsoft")}if(T.onSelectDate&&T.onSelectDate.call){T.onSelectDate.call(n,j.currentTime,n.data("input"))}n.data("changed",true);n.trigger("xchange.xdsoft");n.trigger("changedatetime.xdsoft");setTimeout(function(){I=0},200)});M.on("click.xdsoft","div",function(t){t.stopPropagation();var r=e(this),i=j.currentTime;if(i===undefined||i===null){j.currentTime=j.now();i=j.currentTime}if(r.hasClass("xdsoft_disabled"))return false;i.setHours(r.data("hour"));i.setMinutes(r.data("minute"));n.trigger("select.xdsoft",[i]);n.data("input").val(j.str());!T.inline&&n.trigger("close.xdsoft");if(T.onSelectTime&&T.onSelectTime.call){T.onSelectTime.call(n,j.currentTime,n.data("input"))}n.data("changed",true);n.trigger("xchange.xdsoft");n.trigger("changedatetime.xdsoft")});n.mousewheel&&C.mousewheel(function(e,t,n,r){if(!T.scrollMonth)return true;if(t<0)j.nextMonth();else j.prevMonth();return false});n.mousewheel&&O.unmousewheel().mousewheel(function(e,t,n,r){if(!T.scrollTime)return true;var i=O[0].clientHeight,s=M[0].offsetHeight,o=Math.abs(parseInt(M.css("marginTop"))),u=true;if(t<0&&s-i-T.timeHeightInTimePicker>=o){M.css("marginTop","-"+(o+T.timeHeightInTimePicker)+"px");u=false}else if(t>0&&o-T.timeHeightInTimePicker>=0){M.css("marginTop","-"+(o-T.timeHeightInTimePicker)+"px");u=false}O.trigger("scroll_element.xdsoft_scroller",[Math.abs(parseInt(M.css("marginTop"))/(s-i))]);e.stopPropagation();return u});var q=false;n.on("changedatetime.xdsoft",function(){if(T.onChangeDateTime&&T.onChangeDateTime.call){var e=n.data("input");T.onChangeDateTime.call(n,j.currentTime,e);delete T.value;e.trigger("change")}}).on("generate.xdsoft",function(){if(T.onGenerate&&T.onGenerate.call)T.onGenerate.call(n,j.currentTime,n.data("input"));if(q){n.trigger("afterOpen.xdsoft");q=false}}).on("click.xdsoft",function(e){e.stopPropagation()});var R=0;t.mousewheel&&t.mousewheel(function(e,r,i,s){if(!T.scrollInput)return true;if(!T.datepicker&&T.timepicker){R=M.find(".xdsoft_current").length?M.find(".xdsoft_current").eq(0).index():0;if(R+r>=0&&R+r<M.children().length)R+=r;M.children().eq(R).length&&M.children().eq(R).trigger("mousedown");return false}else if(T.datepicker&&!T.timepicker){C.trigger(e,[r,i,s]);t.val&&t.val(j.str());n.trigger("changedatetime.xdsoft");return false}});var U=function(){var t=n.data("input").offset(),r=t.top+n.data("input")[0].offsetHeight-1,i=t.left,s="absolute";if(T.fixed){r-=e(window).scrollTop();i-=e(window).scrollLeft();s="fixed"}else{if(r+n[0].offsetHeight>e(window).height()+e(window).scrollTop())r=t.top-n[0].offsetHeight+1;if(r<0)r=0;if(i+n[0].offsetWidth>e(window).width())i=t.left-n[0].offsetWidth+n.data("input")[0].offsetWidth}n.css({left:i,top:r,position:s})};n.on("open.xdsoft",function(){var t=true;if(T.onShow&&T.onShow.call){t=T.onShow.call(n,j.currentTime,n.data("input"))}if(t!==false){n.show();U();e(window).off("resize.xdsoft",U).on("resize.xdsoft",U);if(T.closeOnWithoutClick){e([document.body,window]).on("mousedown.xdsoft",function r(){n.trigger("close.xdsoft");e([document.body,window]).off("mousedown.xdsoft",r)})}}}).on("close.xdsoft",function(e){var t=true;if(T.onClose&&T.onClose.call){t=T.onClose.call(n,j.currentTime,n.data("input"))}if(t!==false&&!T.opened&&!T.inline){n.hide()}e.stopPropagation()}).data("input",t);var z=0,W=0;n.data("xdsoft_datetime",j);n.setOptions(T);j.setCurrentTime(X());t.data("xdsoft_datetimepicker",n).on("open.xdsoft focusin.xdsoft mousedown.xdsoft",function(e){if(t.is(":disabled")||t.is(":hidden")||!t.is(":visible")||t.data("xdsoft_datetimepicker").is(":visible")&&T.closeOnInputClick)return;clearTimeout(z);z=setTimeout(function(){if(t.is(":disabled")||t.is(":hidden")||!t.is(":visible"))return;q=true;j.setCurrentTime(X());n.trigger("open.xdsoft")},100)}).on("keydown.xdsoft",function(t){var r=this.value,i=t.which;switch(true){case!!~[f].indexOf(i):var s=e("input:visible,textarea:visible");n.trigger("close.xdsoft");s.eq(s.index(this)+1).focus();return false;case!!~[m].indexOf(i):n.trigger("close.xdsoft");return true}})},L=function(t){var n=t.data("xdsoft_datetimepicker");if(n){n.data("xdsoft_datetime",null);n.remove();t.data("xdsoft_datetimepicker",null).off("open.xdsoft focusin.xdsoft focusout.xdsoft mousedown.xdsoft blur.xdsoft keydown.xdsoft");e(window).off("resize.xdsoft");e([window,document.body]).off("mousedown.xdsoft");t.unmousewheel&&t.unmousewheel()}};e(document).off("keydown.xdsoftctrl keyup.xdsoftctrl").on("keydown.xdsoftctrl",function(e){if(e.keyCode==u)x=true}).on("keyup.xdsoftctrl",function(e){if(e.keyCode==u)x=false});return this.each(function(){var t;if(t=e(this).data("xdsoft_datetimepicker")){if(e.type(n)==="string"){switch(n){case"show":e(this).select().focus();t.trigger("open.xdsoft");break;case"hide":t.trigger("close.xdsoft");break;case"destroy":L(e(this));break;case"reset":this.value=this.defaultValue;if(!this.value||!t.data("xdsoft_datetime").isValidDate(Date.parseDate(this.value,T.format)))t.data("changed",false);t.data("xdsoft_datetime").setCurrentTime(this.value);break}}else{t.setOptions(n)}return 0}else if(e.type(n)!=="string"){if(!T.lazyInit||T.open||T.inline){k(e(this))}else C(e(this))}})};e.fn.datetimepicker.defaults=t})(jQuery);(function(e){if(typeof define==="function"&&define.amd){define(["jquery"],e)}else if(typeof exports==="object"){module.exports=e}else{e(jQuery)}})(function(e){function o(t){var n=t||window.event,s=[].slice.call(arguments,1),o=0,u=0,a=0,f=0,l=0,c;t=e.event.fix(n);t.type="mousewheel";if(n.wheelDelta){o=n.wheelDelta}if(n.detail){o=n.detail*-1}if(n.deltaY){a=n.deltaY*-1;o=a}if(n.deltaX){u=n.deltaX;o=u*-1}if(n.wheelDeltaY!==undefined){a=n.wheelDeltaY}if(n.wheelDeltaX!==undefined){u=n.wheelDeltaX*-1}f=Math.abs(o);if(!r||f<r){r=f}l=Math.max(Math.abs(a),Math.abs(u));if(!i||l<i){i=l}c=o>0?"floor":"ceil";o=Math[c](o/r);u=Math[c](u/i);a=Math[c](a/i);s.unshift(t,o,u,a);return(e.event.dispatch||e.event.handle).apply(this,s)}var t=["wheel","mousewheel","DOMMouseScroll","MozMousePixelScroll"];var n="onwheel"in document||document.documentMode>=9?["wheel"]:["mousewheel","DomMouseScroll","MozMousePixelScroll"];var r,i;if(e.event.fixHooks){for(var s=t.length;s;){e.event.fixHooks[t[--s]]=e.event.mouseHooks}}e.event.special.mousewheel={setup:function(){if(this.addEventListener){for(var e=n.length;e;){this.addEventListener(n[--e],o,false)}}else{this.onmousewheel=o}},teardown:function(){if(this.removeEventListener){for(var e=n.length;e;){this.removeEventListener(n[--e],o,false)}}else{this.onmousewheel=null}}};e.fn.extend({mousewheel:function(e){return e?this.bind("mousewheel",e):this.trigger("mousewheel")},unmousewheel:function(e){return this.unbind("mousewheel",e)}})});Date.parseFunctions={count:0};Date.parseRegexes=[];Date.formatFunctions={count:0};Date.prototype.dateFormat=function(e){if(e=="unixtime"){return parseInt(this.getTime()/1e3)}if(Date.formatFunctions[e]==null){Date.createNewFormat(e)}var t=Date.formatFunctions[e];return this[t]()};Date.createNewFormat=function(format){var funcName="format"+Date.formatFunctions.count++;Date.formatFunctions[format]=funcName;var code="Date.prototype."+funcName+" = function() {return ";var special=false;var ch="";for(var i=0;i<format.length;++i){ch=format.charAt(i);if(!special&&ch=="\\"){special=true}else{if(special){special=false;code+="'"+String.escape(ch)+"' + "}else{code+=Date.getFormatCode(ch)}}}eval(code.substring(0,code.length-3)+";}")};Date.getFormatCode=function(e){switch(e){case"d":return"String.leftPad(this.getDate(), 2, '0') + ";case"D":return"Date.dayNames[this.getDay()].substring(0, 3) + ";case"j":return"this.getDate() + ";case"l":return"Date.dayNames[this.getDay()] + ";case"S":return"this.getSuffix() + ";case"w":return"this.getDay() + ";case"z":return"this.getDayOfYear() + ";case"W":return"this.getWeekOfYear() + ";case"F":return"Date.monthNames[this.getMonth()] + ";case"m":return"String.leftPad(this.getMonth() + 1, 2, '0') + ";case"M":return"Date.monthNames[this.getMonth()].substring(0, 3) + ";case"n":return"(this.getMonth() + 1) + ";case"t":return"this.getDaysInMonth() + ";case"L":return"(this.isLeapYear() ? 1 : 0) + ";case"Y":return"this.getFullYear() + ";case"y":return"('' + this.getFullYear()).substring(2, 4) + ";case"a":return"(this.getHours() < 12 ? 'am' : 'pm') + ";case"A":return"(this.getHours() < 12 ? 'AM' : 'PM') + ";case"g":return"((this.getHours() %12) ? this.getHours() % 12 : 12) + ";case"G":return"this.getHours() + ";case"h":return"String.leftPad((this.getHours() %12) ? this.getHours() % 12 : 12, 2, '0') + ";case"H":return"String.leftPad(this.getHours(), 2, '0') + ";case"i":return"String.leftPad(this.getMinutes(), 2, '0') + ";case"s":return"String.leftPad(this.getSeconds(), 2, '0') + ";case"O":return"this.getGMTOffset() + ";case"T":return"this.getTimezone() + ";case"Z":return"(this.getTimezoneOffset() * -60) + ";default:return"'"+String.escape(e)+"' + "}};Date.parseDate=function(e,t){if(t=="unixtime"){return new Date(!isNaN(parseInt(e))?parseInt(e)*1e3:0)}if(Date.parseFunctions[t]==null){Date.createParser(t)}var n=Date.parseFunctions[t];return Date[n](e)};Date.createParser=function(format){var funcName="parse"+Date.parseFunctions.count++;var regexNum=Date.parseRegexes.length;var currentGroup=1;Date.parseFunctions[format]=funcName;var code="Date."+funcName+" = function(input) {\nvar y = -1, m = -1, d = -1, h = -1, i = -1, s = -1, z = -1;\nvar d = new Date();\ny = d.getFullYear();\nm = d.getMonth();\nd = d.getDate();\nvar results = input.match(Date.parseRegexes["+regexNum+"]);\nif (results && results.length > 0) {";var regex="";var special=false;var ch="";for(var i=0;i<format.length;++i){ch=format.charAt(i);if(!special&&ch=="\\"){special=true}else{if(special){special=false;regex+=String.escape(ch)}else{obj=Date.formatCodeToRegex(ch,currentGroup);currentGroup+=obj.g;regex+=obj.s;if(obj.g&&obj.c){code+=obj.c}}}}code+="if (y > 0 && z > 0){\nvar doyDate = new Date(y,0);\ndoyDate.setDate(z);\nm = doyDate.getMonth();\nd = doyDate.getDate();\n}";code+="if (y > 0 && m >= 0 && d > 0 && h >= 0 && i >= 0 && s >= 0)\n{return new Date(y, m, d, h, i, s);}\nelse if (y > 0 && m >= 0 && d > 0 && h >= 0 && i >= 0)\n{return new Date(y, m, d, h, i);}\nelse if (y > 0 && m >= 0 && d > 0 && h >= 0)\n{return new Date(y, m, d, h);}\nelse if (y > 0 && m >= 0 && d > 0)\n{return new Date(y, m, d);}\nelse if (y > 0 && m >= 0)\n{return new Date(y, m);}\nelse if (y > 0)\n{return new Date(y);}\n}return null;}";Date.parseRegexes[regexNum]=new RegExp("^"+regex+"$");eval(code)};Date.formatCodeToRegex=function(e,t){switch(e){case"D":return{g:0,c:null,s:"(?:Sun|Mon|Tue|Wed|Thu|Fri|Sat)"};case"j":case"d":return{g:1,c:"d = parseInt(results["+t+"], 10);\n",s:"(\\d{1,2})"};case"l":return{g:0,c:null,s:"(?:"+Date.dayNames.join("|")+")"};case"S":return{g:0,c:null,s:"(?:st|nd|rd|th)"};case"w":return{g:0,c:null,s:"\\d"};case"z":return{g:1,c:"z = parseInt(results["+t+"], 10);\n",s:"(\\d{1,3})"};case"W":return{g:0,c:null,s:"(?:\\d{2})"};case"F":return{g:1,c:"m = parseInt(Date.monthNumbers[results["+t+"].substring(0, 3)], 10);\n",s:"("+Date.monthNames.join("|")+")"};case"M":return{g:1,c:"m = parseInt(Date.monthNumbers[results["+t+"]], 10);\n",s:"(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)"};case"n":case"m":return{g:1,c:"m = parseInt(results["+t+"], 10) - 1;\n",s:"(\\d{1,2})"};case"t":return{g:0,c:null,s:"\\d{1,2}"};case"L":return{g:0,c:null,s:"(?:1|0)"};case"Y":return{g:1,c:"y = parseInt(results["+t+"], 10);\n",s:"(\\d{4})"};case"y":return{g:1,c:"var ty = parseInt(results["+t+"], 10);\ny = ty > Date.y2kYear ? 1900 + ty : 2000 + ty;\n",s:"(\\d{1,2})"};case"a":return{g:1,c:"if (results["+t+"] == 'am') {\nif (h == 12) { h = 0; }\n} else { if (h < 12) { h += 12; }}",s:"(am|pm)"};case"A":return{g:1,c:"if (results["+t+"] == 'AM') {\nif (h == 12) { h = 0; }\n} else { if (h < 12) { h += 12; }}",s:"(AM|PM)"};case"g":case"G":case"h":case"H":return{g:1,c:"h = parseInt(results["+t+"], 10);\n",s:"(\\d{1,2})"};case"i":return{g:1,c:"i = parseInt(results["+t+"], 10);\n",s:"(\\d{2})"};case"s":return{g:1,c:"s = parseInt(results["+t+"], 10);\n",s:"(\\d{2})"};case"O":return{g:0,c:null,s:"[+-]\\d{4}"};case"T":return{g:0,c:null,s:"[A-Z]{3}"};case"Z":return{g:0,c:null,s:"[+-]\\d{1,5}"};default:return{g:0,c:null,s:String.escape(e)}}};Date.prototype.getTimezone=function(){return this.toString().replace(/^.*? ([A-Z]{3}) [0-9]{4}.*$/,"$1").replace(/^.*?\(([A-Z])[a-z]+ ([A-Z])[a-z]+ ([A-Z])[a-z]+\)$/,"$1$2$3")};Date.prototype.getGMTOffset=function(){return(this.getTimezoneOffset()>0?"-":"+")+String.leftPad(Math.floor(Math.abs(this.getTimezoneOffset())/60),2,"0")+String.leftPad(Math.abs(this.getTimezoneOffset())%60,2,"0")};Date.prototype.getDayOfYear=function(){var e=0;Date.daysInMonth[1]=this.isLeapYear()?29:28;for(var t=0;t<this.getMonth();++t){e+=Date.daysInMonth[t]}return e+this.getDate()};Date.prototype.getWeekOfYear=function(){var e=this.getDayOfYear()+(4-this.getDay());var t=new Date(this.getFullYear(),0,1);var n=7-t.getDay()+4;return String.leftPad(Math.ceil((e-n)/7)+1,2,"0")};Date.prototype.isLeapYear=function(){var e=this.getFullYear();return(e&3)==0&&(e%100||e%400==0&&e)};Date.prototype.getFirstDayOfMonth=function(){var e=(this.getDay()-(this.getDate()-1))%7;return e<0?e+7:e};Date.prototype.getLastDayOfMonth=function(){var e=(this.getDay()+(Date.daysInMonth[this.getMonth()]-this.getDate()))%7;return e<0?e+7:e};Date.prototype.getDaysInMonth=function(){Date.daysInMonth[1]=this.isLeapYear()?29:28;return Date.daysInMonth[this.getMonth()]};Date.prototype.getSuffix=function(){switch(this.getDate()){case 1:case 21:case 31:return"st";case 2:case 22:return"nd";case 3:case 23:return"rd";default:return"th"}};String.escape=function(e){return e.replace(/('|\\)/g,"\\$1")};String.leftPad=function(e,t,n){var r=new String(e);if(n==null){n=" "}while(r.length<t){r=n+r}return r};Date.daysInMonth=[31,28,31,30,31,30,31,31,30,31,30,31];Date.monthNames=["January","February","March","April","May","June","July","August","September","October","November","December"];Date.dayNames=["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"];Date.y2kYear=50;Date.monthNumbers={Jan:0,Feb:1,Mar:2,Apr:3,May:4,Jun:5,Jul:6,Aug:7,Sep:8,Oct:9,Nov:10,Dec:11};Date.patterns={ISO8601LongPattern:"Y-m-d H:i:s",ISO8601ShortPattern:"Y-m-d",ShortDatePattern:"n/j/Y",LongDatePattern:"l, F d, Y",FullDateTimePattern:"l, F d, Y g:i:s A",MonthDayPattern:"F d",ShortTimePattern:"g:i A",LongTimePattern:"g:i:s A",SortableDateTimePattern:"Y-m-d\\TH:i:s",UniversalSortableDateTimePattern:"Y-m-d H:i:sO",YearMonthPattern:"F, Y"}
},{}],4:[function(require,module,exports){
/*! jQuery UI - v1.10.1 - 2013-02-15
* http://jqueryui.com
* Includes: jquery.ui.core.js, jquery.ui.widget.js, jquery.ui.mouse.js, jquery.ui.draggable.js, jquery.ui.droppable.js, jquery.ui.resizable.js, jquery.ui.selectable.js, jquery.ui.sortable.js, jquery.ui.effect.js, jquery.ui.accordion.js, jquery.ui.autocomplete.js, jquery.ui.button.js, jquery.ui.datepicker.js, jquery.ui.dialog.js, jquery.ui.effect-blind.js, jquery.ui.effect-bounce.js, jquery.ui.effect-clip.js, jquery.ui.effect-drop.js, jquery.ui.effect-explode.js, jquery.ui.effect-fade.js, jquery.ui.effect-fold.js, jquery.ui.effect-highlight.js, jquery.ui.effect-pulsate.js, jquery.ui.effect-scale.js, jquery.ui.effect-shake.js, jquery.ui.effect-slide.js, jquery.ui.effect-transfer.js, jquery.ui.menu.js, jquery.ui.position.js, jquery.ui.progressbar.js, jquery.ui.slider.js, jquery.ui.spinner.js, jquery.ui.tabs.js, jquery.ui.tooltip.js
* Copyright 2013 jQuery Foundation and other contributors; Licensed MIT */
(function(e,t){function i(t,n){var r,i,o,u=t.nodeName.toLowerCase();return"area"===u?(r=t.parentNode,i=r.name,!t.href||!i||r.nodeName.toLowerCase()!=="map"?!1:(o=e("img[usemap=#"+i+"]")[0],!!o&&s(o))):(/input|select|textarea|button|object/.test(u)?!t.disabled:"a"===u?t.href||n:n)&&s(t)}function s(t){return e.expr.filters.visible(t)&&!e(t).parents().addBack().filter(function(){return e.css(this,"visibility")==="hidden"}).length}var n=0,r=/^ui-id-\d+$/;e.ui=e.ui||{};if(e.ui.version)return;e.extend(e.ui,{version:"1.10.1",keyCode:{BACKSPACE:8,COMMA:188,DELETE:46,DOWN:40,END:35,ENTER:13,ESCAPE:27,HOME:36,LEFT:37,NUMPAD_ADD:107,NUMPAD_DECIMAL:110,NUMPAD_DIVIDE:111,NUMPAD_ENTER:108,NUMPAD_MULTIPLY:106,NUMPAD_SUBTRACT:109,PAGE_DOWN:34,PAGE_UP:33,PERIOD:190,RIGHT:39,SPACE:32,TAB:9,UP:38}}),e.fn.extend({_focus:e.fn.focus,focus:function(t,n){return typeof t=="number"?this.each(function(){var r=this;setTimeout(function(){e(r).focus(),n&&n.call(r)},t)}):this._focus.apply(this,arguments)},scrollParent:function(){var t;return e.ui.ie&&/(static|relative)/.test(this.css("position"))||/absolute/.test(this.css("position"))?t=this.parents().filter(function(){return/(relative|absolute|fixed)/.test(e.css(this,"position"))&&/(auto|scroll)/.test(e.css(this,"overflow")+e.css(this,"overflow-y")+e.css(this,"overflow-x"))}).eq(0):t=this.parents().filter(function(){return/(auto|scroll)/.test(e.css(this,"overflow")+e.css(this,"overflow-y")+e.css(this,"overflow-x"))}).eq(0),/fixed/.test(this.css("position"))||!t.length?e(document):t},zIndex:function(n){if(n!==t)return this.css("zIndex",n);if(this.length){var r=e(this[0]),i,s;while(r.length&&r[0]!==document){i=r.css("position");if(i==="absolute"||i==="relative"||i==="fixed"){s=parseInt(r.css("zIndex"),10);if(!isNaN(s)&&s!==0)return s}r=r.parent()}}return 0},uniqueId:function(){return this.each(function(){this.id||(this.id="ui-id-"+ ++n)})},removeUniqueId:function(){return this.each(function(){r.test(this.id)&&e(this).removeAttr("id")})}}),e.extend(e.expr[":"],{data:e.expr.createPseudo?e.expr.createPseudo(function(t){return function(n){return!!e.data(n,t)}}):function(t,n,r){return!!e.data(t,r[3])},focusable:function(t){return i(t,!isNaN(e.attr(t,"tabindex")))},tabbable:function(t){var n=e.attr(t,"tabindex"),r=isNaN(n);return(r||n>=0)&&i(t,!r)}}),e("<a>").outerWidth(1).jquery||e.each(["Width","Height"],function(n,r){function u(t,n,r,s){return e.each(i,function(){n-=parseFloat(e.css(t,"padding"+this))||0,r&&(n-=parseFloat(e.css(t,"border"+this+"Width"))||0),s&&(n-=parseFloat(e.css(t,"margin"+this))||0)}),n}var i=r==="Width"?["Left","Right"]:["Top","Bottom"],s=r.toLowerCase(),o={innerWidth:e.fn.innerWidth,innerHeight:e.fn.innerHeight,outerWidth:e.fn.outerWidth,outerHeight:e.fn.outerHeight};e.fn["inner"+r]=function(n){return n===t?o["inner"+r].call(this):this.each(function(){e(this).css(s,u(this,n)+"px")})},e.fn["outer"+r]=function(t,n){return typeof t!="number"?o["outer"+r].call(this,t):this.each(function(){e(this).css(s,u(this,t,!0,n)+"px")})}}),e.fn.addBack||(e.fn.addBack=function(e){return this.add(e==null?this.prevObject:this.prevObject.filter(e))}),e("<a>").data("a-b","a").removeData("a-b").data("a-b")&&(e.fn.removeData=function(t){return function(n){return arguments.length?t.call(this,e.camelCase(n)):t.call(this)}}(e.fn.removeData)),e.ui.ie=!!/msie [\w.]+/.exec(navigator.userAgent.toLowerCase()),e.support.selectstart="onselectstart"in document.createElement("div"),e.fn.extend({disableSelection:function(){return this.bind((e.support.selectstart?"selectstart":"mousedown")+".ui-disableSelection",function(e){e.preventDefault()})},enableSelection:function(){return this.unbind(".ui-disableSelection")}}),e.extend(e.ui,{plugin:{add:function(t,n,r){var i,s=e.ui[t].prototype;for(i in r)s.plugins[i]=s.plugins[i]||[],s.plugins[i].push([n,r[i]])},call:function(e,t,n){var r,i=e.plugins[t];if(!i||!e.element[0].parentNode||e.element[0].parentNode.nodeType===11)return;for(r=0;r<i.length;r++)e.options[i[r][0]]&&i[r][1].apply(e.element,n)}},hasScroll:function(t,n){if(e(t).css("overflow")==="hidden")return!1;var r=n&&n==="left"?"scrollLeft":"scrollTop",i=!1;return t[r]>0?!0:(t[r]=1,i=t[r]>0,t[r]=0,i)}})})(jQuery),function(e,t){var n=0,r=Array.prototype.slice,i=e.cleanData;e.cleanData=function(t){for(var n=0,r;(r=t[n])!=null;n++)try{e(r).triggerHandler("remove")}catch(s){}i(t)},e.widget=function(t,n,r){var i,s,o,u,a={},f=t.split(".")[0];t=t.split(".")[1],i=f+"-"+t,r||(r=n,n=e.Widget),e.expr[":"][i.toLowerCase()]=function(t){return!!e.data(t,i)},e[f]=e[f]||{},s=e[f][t],o=e[f][t]=function(e,t){if(!this._createWidget)return new o(e,t);arguments.length&&this._createWidget(e,t)},e.extend(o,s,{version:r.version,_proto:e.extend({},r),_childConstructors:[]}),u=new n,u.options=e.widget.extend({},u.options),e.each(r,function(t,r){if(!e.isFunction(r)){a[t]=r;return}a[t]=function(){var e=function(){return n.prototype[t].apply(this,arguments)},i=function(e){return n.prototype[t].apply(this,e)};return function(){var t=this._super,n=this._superApply,s;return this._super=e,this._superApply=i,s=r.apply(this,arguments),this._super=t,this._superApply=n,s}}()}),o.prototype=e.widget.extend(u,{widgetEventPrefix:s?u.widgetEventPrefix:t},a,{constructor:o,namespace:f,widgetName:t,widgetFullName:i}),s?(e.each(s._childConstructors,function(t,n){var r=n.prototype;e.widget(r.namespace+"."+r.widgetName,o,n._proto)}),delete s._childConstructors):n._childConstructors.push(o),e.widget.bridge(t,o)},e.widget.extend=function(n){var i=r.call(arguments,1),s=0,o=i.length,u,a;for(;s<o;s++)for(u in i[s])a=i[s][u],i[s].hasOwnProperty(u)&&a!==t&&(e.isPlainObject(a)?n[u]=e.isPlainObject(n[u])?e.widget.extend({},n[u],a):e.widget.extend({},a):n[u]=a);return n},e.widget.bridge=function(n,i){var s=i.prototype.widgetFullName||n;e.fn[n]=function(o){var u=typeof o=="string",a=r.call(arguments,1),f=this;return o=!u&&a.length?e.widget.extend.apply(null,[o].concat(a)):o,u?this.each(function(){var r,i=e.data(this,s);if(!i)return e.error("cannot call methods on "+n+" prior to initialization; "+"attempted to call method '"+o+"'");if(!e.isFunction(i[o])||o.charAt(0)==="_")return e.error("no such method '"+o+"' for "+n+" widget instance");r=i[o].apply(i,a);if(r!==i&&r!==t)return f=r&&r.jquery?f.pushStack(r.get()):r,!1}):this.each(function(){var t=e.data(this,s);t?t.option(o||{})._init():e.data(this,s,new i(o,this))}),f}},e.Widget=function(){},e.Widget._childConstructors=[],e.Widget.prototype={widgetName:"widget",widgetEventPrefix:"",defaultElement:"<div>",options:{disabled:!1,create:null},_createWidget:function(t,r){r=e(r||this.defaultElement||this)[0],this.element=e(r),this.uuid=n++,this.eventNamespace="."+this.widgetName+this.uuid,this.options=e.widget.extend({},this.options,this._getCreateOptions(),t),this.bindings=e(),this.hoverable=e(),this.focusable=e(),r!==this&&(e.data(r,this.widgetFullName,this),this._on(!0,this.element,{remove:function(e){e.target===r&&this.destroy()}}),this.document=e(r.style?r.ownerDocument:r.document||r),this.window=e(this.document[0].defaultView||this.document[0].parentWindow)),this._create(),this._trigger("create",null,this._getCreateEventData()),this._init()},_getCreateOptions:e.noop,_getCreateEventData:e.noop,_create:e.noop,_init:e.noop,destroy:function(){this._destroy(),this.element.unbind(this.eventNamespace).removeData(this.widgetName).removeData(this.widgetFullName).removeData(e.camelCase(this.widgetFullName)),this.widget().unbind(this.eventNamespace).removeAttr("aria-disabled").removeClass(this.widgetFullName+"-disabled "+"ui-state-disabled"),this.bindings.unbind(this.eventNamespace),this.hoverable.removeClass("ui-state-hover"),this.focusable.removeClass("ui-state-focus")},_destroy:e.noop,widget:function(){return this.element},option:function(n,r){var i=n,s,o,u;if(arguments.length===0)return e.widget.extend({},this.options);if(typeof n=="string"){i={},s=n.split("."),n=s.shift();if(s.length){o=i[n]=e.widget.extend({},this.options[n]);for(u=0;u<s.length-1;u++)o[s[u]]=o[s[u]]||{},o=o[s[u]];n=s.pop();if(r===t)return o[n]===t?null:o[n];o[n]=r}else{if(r===t)return this.options[n]===t?null:this.options[n];i[n]=r}}return this._setOptions(i),this},_setOptions:function(e){var t;for(t in e)this._setOption(t,e[t]);return this},_setOption:function(e,t){return this.options[e]=t,e==="disabled"&&(this.widget().toggleClass(this.widgetFullName+"-disabled ui-state-disabled",!!t).attr("aria-disabled",t),this.hoverable.removeClass("ui-state-hover"),this.focusable.removeClass("ui-state-focus")),this},enable:function(){return this._setOption("disabled",!1)},disable:function(){return this._setOption("disabled",!0)},_on:function(t,n,r){var i,s=this;typeof t!="boolean"&&(r=n,n=t,t=!1),r?(n=i=e(n),this.bindings=this.bindings.add(n)):(r=n,n=this.element,i=this.widget()),e.each(r,function(r,o){function u(){if(!t&&(s.options.disabled===!0||e(this).hasClass("ui-state-disabled")))return;return(typeof o=="string"?s[o]:o).apply(s,arguments)}typeof o!="string"&&(u.guid=o.guid=o.guid||u.guid||e.guid++);var a=r.match(/^(\w+)\s*(.*)$/),f=a[1]+s.eventNamespace,l=a[2];l?i.delegate(l,f,u):n.bind(f,u)})},_off:function(e,t){t=(t||"").split(" ").join(this.eventNamespace+" ")+this.eventNamespace,e.unbind(t).undelegate(t)},_delay:function(e,t){function n(){return(typeof e=="string"?r[e]:e).apply(r,arguments)}var r=this;return setTimeout(n,t||0)},_hoverable:function(t){this.hoverable=this.hoverable.add(t),this._on(t,{mouseenter:function(t){e(t.currentTarget).addClass("ui-state-hover")},mouseleave:function(t){e(t.currentTarget).removeClass("ui-state-hover")}})},_focusable:function(t){this.focusable=this.focusable.add(t),this._on(t,{focusin:function(t){e(t.currentTarget).addClass("ui-state-focus")},focusout:function(t){e(t.currentTarget).removeClass("ui-state-focus")}})},_trigger:function(t,n,r){var i,s,o=this.options[t];r=r||{},n=e.Event(n),n.type=(t===this.widgetEventPrefix?t:this.widgetEventPrefix+t).toLowerCase(),n.target=this.element[0],s=n.originalEvent;if(s)for(i in s)i in n||(n[i]=s[i]);return this.element.trigger(n,r),!(e.isFunction(o)&&o.apply(this.element[0],[n].concat(r))===!1||n.isDefaultPrevented())}},e.each({show:"fadeIn",hide:"fadeOut"},function(t,n){e.Widget.prototype["_"+t]=function(r,i,s){typeof i=="string"&&(i={effect:i});var o,u=i?i===!0||typeof i=="number"?n:i.effect||n:t;i=i||{},typeof i=="number"&&(i={duration:i}),o=!e.isEmptyObject(i),i.complete=s,i.delay&&r.delay(i.delay),o&&e.effects&&e.effects.effect[u]?r[t](i):u!==t&&r[u]?r[u](i.duration,i.easing,s):r.queue(function(n){e(this)[t](),s&&s.call(r[0]),n()})}})}(jQuery),function(e,t){var n=!1;e(document).mouseup(function(){n=!1}),e.widget("ui.mouse",{version:"1.10.1",options:{cancel:"input,textarea,button,select,option",distance:1,delay:0},_mouseInit:function(){var t=this;this.element.bind("mousedown."+this.widgetName,function(e){return t._mouseDown(e)}).bind("click."+this.widgetName,function(n){if(!0===e.data(n.target,t.widgetName+".preventClickEvent"))return e.removeData(n.target,t.widgetName+".preventClickEvent"),n.stopImmediatePropagation(),!1}),this.started=!1},_mouseDestroy:function(){this.element.unbind("."+this.widgetName),this._mouseMoveDelegate&&e(document).unbind("mousemove."+this.widgetName,this._mouseMoveDelegate).unbind("mouseup."+this.widgetName,this._mouseUpDelegate)},_mouseDown:function(t){if(n)return;this._mouseStarted&&this._mouseUp(t),this._mouseDownEvent=t;var r=this,i=t.which===1,s=typeof this.options.cancel=="string"&&t.target.nodeName?e(t.target).closest(this.options.cancel).length:!1;if(!i||s||!this._mouseCapture(t))return!0;this.mouseDelayMet=!this.options.delay,this.mouseDelayMet||(this._mouseDelayTimer=setTimeout(function(){r.mouseDelayMet=!0},this.options.delay));if(this._mouseDistanceMet(t)&&this._mouseDelayMet(t)){this._mouseStarted=this._mouseStart(t)!==!1;if(!this._mouseStarted)return t.preventDefault(),!0}return!0===e.data(t.target,this.widgetName+".preventClickEvent")&&e.removeData(t.target,this.widgetName+".preventClickEvent"),this._mouseMoveDelegate=function(e){return r._mouseMove(e)},this._mouseUpDelegate=function(e){return r._mouseUp(e)},e(document).bind("mousemove."+this.widgetName,this._mouseMoveDelegate).bind("mouseup."+this.widgetName,this._mouseUpDelegate),t.preventDefault(),n=!0,!0},_mouseMove:function(t){return e.ui.ie&&(!document.documentMode||document.documentMode<9)&&!t.button?this._mouseUp(t):this._mouseStarted?(this._mouseDrag(t),t.preventDefault()):(this._mouseDistanceMet(t)&&this._mouseDelayMet(t)&&(this._mouseStarted=this._mouseStart(this._mouseDownEvent,t)!==!1,this._mouseStarted?this._mouseDrag(t):this._mouseUp(t)),!this._mouseStarted)},_mouseUp:function(t){return e(document).unbind("mousemove."+this.widgetName,this._mouseMoveDelegate).unbind("mouseup."+this.widgetName,this._mouseUpDelegate),this._mouseStarted&&(this._mouseStarted=!1,t.target===this._mouseDownEvent.target&&e.data(t.target,this.widgetName+".preventClickEvent",!0),this._mouseStop(t)),!1},_mouseDistanceMet:function(e){return Math.max(Math.abs(this._mouseDownEvent.pageX-e.pageX),Math.abs(this._mouseDownEvent.pageY-e.pageY))>=this.options.distance},_mouseDelayMet:function(){return this.mouseDelayMet},_mouseStart:function(){},_mouseDrag:function(){},_mouseStop:function(){},_mouseCapture:function(){return!0}})}(jQuery),function(e,t){e.widget("ui.draggable",e.ui.mouse,{version:"1.10.1",widgetEventPrefix:"drag",options:{addClasses:!0,appendTo:"parent",axis:!1,connectToSortable:!1,containment:!1,cursor:"auto",cursorAt:!1,grid:!1,handle:!1,helper:"original",iframeFix:!1,opacity:!1,refreshPositions:!1,revert:!1,revertDuration:500,scope:"default",scroll:!0,scrollSensitivity:20,scrollSpeed:20,snap:!1,snapMode:"both",snapTolerance:20,stack:!1,zIndex:!1,drag:null,start:null,stop:null},_create:function(){this.options.helper==="original"&&!/^(?:r|a|f)/.test(this.element.css("position"))&&(this.element[0].style.position="relative"),this.options.addClasses&&this.element.addClass("ui-draggable"),this.options.disabled&&this.element.addClass("ui-draggable-disabled"),this._mouseInit()},_destroy:function(){this.element.removeClass("ui-draggable ui-draggable-dragging ui-draggable-disabled"),this._mouseDestroy()},_mouseCapture:function(t){var n=this.options;return this.helper||n.disabled||e(t.target).closest(".ui-resizable-handle").length>0?!1:(this.handle=this._getHandle(t),this.handle?(e(n.iframeFix===!0?"iframe":n.iframeFix).each(function(){e("<div class='ui-draggable-iframeFix' style='background: #fff;'></div>").css({width:this.offsetWidth+"px",height:this.offsetHeight+"px",position:"absolute",opacity:"0.001",zIndex:1e3}).css(e(this).offset()).appendTo("body")}),!0):!1)},_mouseStart:function(t){var n=this.options;return this.helper=this._createHelper(t),this.helper.addClass("ui-draggable-dragging"),this._cacheHelperProportions(),e.ui.ddmanager&&(e.ui.ddmanager.current=this),this._cacheMargins(),this.cssPosition=this.helper.css("position"),this.scrollParent=this.helper.scrollParent(),this.offset=this.positionAbs=this.element.offset(),this.offset={top:this.offset.top-this.margins.top,left:this.offset.left-this.margins.left},e.extend(this.offset,{click:{left:t.pageX-this.offset.left,top:t.pageY-this.offset.top},parent:this._getParentOffset(),relative:this._getRelativeOffset()}),this.originalPosition=this.position=this._generatePosition(t),this.originalPageX=t.pageX,this.originalPageY=t.pageY,n.cursorAt&&this._adjustOffsetFromHelper(n.cursorAt),n.containment&&this._setContainment(),this._trigger("start",t)===!1?(this._clear(),!1):(this._cacheHelperProportions(),e.ui.ddmanager&&!n.dropBehaviour&&e.ui.ddmanager.prepareOffsets(this,t),this._mouseDrag(t,!0),e.ui.ddmanager&&e.ui.ddmanager.dragStart(this,t),!0)},_mouseDrag:function(t,n){this.position=this._generatePosition(t),this.positionAbs=this._convertPositionTo("absolute");if(!n){var r=this._uiHash();if(this._trigger("drag",t,r)===!1)return this._mouseUp({}),!1;this.position=r.position}if(!this.options.axis||this.options.axis!=="y")this.helper[0].style.left=this.position.left+"px";if(!this.options.axis||this.options.axis!=="x")this.helper[0].style.top=this.position.top+"px";return e.ui.ddmanager&&e.ui.ddmanager.drag(this,t),!1},_mouseStop:function(t){var n,r=this,i=!1,s=!1;e.ui.ddmanager&&!this.options.dropBehaviour&&(s=e.ui.ddmanager.drop(this,t)),this.dropped&&(s=this.dropped,this.dropped=!1),n=this.element[0];while(n&&(n=n.parentNode))n===document&&(i=!0);return!i&&this.options.helper==="original"?!1:(this.options.revert==="invalid"&&!s||this.options.revert==="valid"&&s||this.options.revert===!0||e.isFunction(this.options.revert)&&this.options.revert.call(this.element,s)?e(this.helper).animate(this.originalPosition,parseInt(this.options.revertDuration,10),function(){r._trigger("stop",t)!==!1&&r._clear()}):this._trigger("stop",t)!==!1&&this._clear(),!1)},_mouseUp:function(t){return e("div.ui-draggable-iframeFix").each(function(){this.parentNode.removeChild(this)}),e.ui.ddmanager&&e.ui.ddmanager.dragStop(this,t),e.ui.mouse.prototype._mouseUp.call(this,t)},cancel:function(){return this.helper.is(".ui-draggable-dragging")?this._mouseUp({}):this._clear(),this},_getHandle:function(t){var n=!this.options.handle||!e(this.options.handle,this.element).length?!0:!1;return e(this.options.handle,this.element).find("*").addBack().each(function(){this===t.target&&(n=!0)}),n},_createHelper:function(t){var n=this.options,r=e.isFunction(n.helper)?e(n.helper.apply(this.element[0],[t])):n.helper==="clone"?this.element.clone().removeAttr("id"):this.element;return r.parents("body").length||r.appendTo(n.appendTo==="parent"?this.element[0].parentNode:n.appendTo),r[0]!==this.element[0]&&!/(fixed|absolute)/.test(r.css("position"))&&r.css("position","absolute"),r},_adjustOffsetFromHelper:function(t){typeof t=="string"&&(t=t.split(" ")),e.isArray(t)&&(t={left:+t[0],top:+t[1]||0}),"left"in t&&(this.offset.click.left=t.left+this.margins.left),"right"in t&&(this.offset.click.left=this.helperProportions.width-t.right+this.margins.left),"top"in t&&(this.offset.click.top=t.top+this.margins.top),"bottom"in t&&(this.offset.click.top=this.helperProportions.height-t.bottom+this.margins.top)},_getParentOffset:function(){this.offsetParent=this.helper.offsetParent();var t=this.offsetParent.offset();this.cssPosition==="absolute"&&this.scrollParent[0]!==document&&e.contains(this.scrollParent[0],this.offsetParent[0])&&(t.left+=this.scrollParent.scrollLeft(),t.top+=this.scrollParent.scrollTop());if(this.offsetParent[0]===document.body||this.offsetParent[0].tagName&&this.offsetParent[0].tagName.toLowerCase()==="html"&&e.ui.ie)t={top:0,left:0};return{top:t.top+(parseInt(this.offsetParent.css("borderTopWidth"),10)||0),left:t.left+(parseInt(this.offsetParent.css("borderLeftWidth"),10)||0)}},_getRelativeOffset:function(){if(this.cssPosition==="relative"){var e=this.element.position();return{top:e.top-(parseInt(this.helper.css("top"),10)||0)+this.scrollParent.scrollTop(),left:e.left-(parseInt(this.helper.css("left"),10)||0)+this.scrollParent.scrollLeft()}}return{top:0,left:0}},_cacheMargins:function(){this.margins={left:parseInt(this.element.css("marginLeft"),10)||0,top:parseInt(this.element.css("marginTop"),10)||0,right:parseInt(this.element.css("marginRight"),10)||0,bottom:parseInt(this.element.css("marginBottom"),10)||0}},_cacheHelperProportions:function(){this.helperProportions={width:this.helper.outerWidth(),height:this.helper.outerHeight()}},_setContainment:function(){var t,n,r,i=this.options;i.containment==="parent"&&(i.containment=this.helper[0].parentNode);if(i.containment==="document"||i.containment==="window")this.containment=[i.containment==="document"?0:e(window).scrollLeft()-this.offset.relative.left-this.offset.parent.left,i.containment==="document"?0:e(window).scrollTop()-this.offset.relative.top-this.offset.parent.top,(i.containment==="document"?0:e(window).scrollLeft())+e(i.containment==="document"?document:window).width()-this.helperProportions.width-this.margins.left,(i.containment==="document"?0:e(window).scrollTop())+(e(i.containment==="document"?document:window).height()||document.body.parentNode.scrollHeight)-this.helperProportions.height-this.margins.top];if(!/^(document|window|parent)$/.test(i.containment)&&i.containment.constructor!==Array){n=e(i.containment),r=n[0];if(!r)return;t=e(r).css("overflow")!=="hidden",this.containment=[(parseInt(e(r).css("borderLeftWidth"),10)||0)+(parseInt(e(r).css("paddingLeft"),10)||0),(parseInt(e(r).css("borderTopWidth"),10)||0)+(parseInt(e(r).css("paddingTop"),10)||0),(t?Math.max(r.scrollWidth,r.offsetWidth):r.offsetWidth)-(parseInt(e(r).css("borderLeftWidth"),10)||0)-(parseInt(e(r).css("paddingRight"),10)||0)-this.helperProportions.width-this.margins.left-this.margins.right,(t?Math.max(r.scrollHeight,r.offsetHeight):r.offsetHeight)-(parseInt(e(r).css("borderTopWidth"),10)||0)-(parseInt(e(r).css("paddingBottom"),10)||0)-this.helperProportions.height-this.margins.top-this.margins.bottom],this.relative_container=n}else i.containment.constructor===Array&&(this.containment=i.containment)},_convertPositionTo:function(t,n){n||(n=this.position);var r=t==="absolute"?1:-1,i=this.cssPosition!=="absolute"||this.scrollParent[0]!==document&&!!e.contains(this.scrollParent[0],this.offsetParent[0])?this.scrollParent:this.offsetParent,s=/(html|body)/i.test(i[0].tagName);return{top:n.top+this.offset.relative.top*r+this.offset.parent.top*r-(this.cssPosition==="fixed"?-this.scrollParent.scrollTop():s?0:i.scrollTop())*r,left:n.left+this.offset.relative.left*r+this.offset.parent.left*r-(this.cssPosition==="fixed"?-this.scrollParent.scrollLeft():s?0:i.scrollLeft())*r}},_generatePosition:function(t){var n,r,i,s,o=this.options,u=this.cssPosition!=="absolute"||this.scrollParent[0]!==document&&!!e.contains(this.scrollParent[0],this.offsetParent[0])?this.scrollParent:this.offsetParent,a=/(html|body)/i.test(u[0].tagName),f=t.pageX,l=t.pageY;return this.originalPosition&&(this.containment&&(this.relative_container?(r=this.relative_container.offset(),n=[this.containment[0]+r.left,this.containment[1]+r.top,this.containment[2]+r.left,this.containment[3]+r.top]):n=this.containment,t.pageX-this.offset.click.left<n[0]&&(f=n[0]+this.offset.click.left),t.pageY-this.offset.click.top<n[1]&&(l=n[1]+this.offset.click.top),t.pageX-this.offset.click.left>n[2]&&(f=n[2]+this.offset.click.left),t.pageY-this.offset.click.top>n[3]&&(l=n[3]+this.offset.click.top)),o.grid&&(i=o.grid[1]?this.originalPageY+Math.round((l-this.originalPageY)/o.grid[1])*o.grid[1]:this.originalPageY,l=n?i-this.offset.click.top>=n[1]||i-this.offset.click.top>n[3]?i:i-this.offset.click.top>=n[1]?i-o.grid[1]:i+o.grid[1]:i,s=o.grid[0]?this.originalPageX+Math.round((f-this.originalPageX)/o.grid[0])*o.grid[0]:this.originalPageX,f=n?s-this.offset.click.left>=n[0]||s-this.offset.click.left>n[2]?s:s-this.offset.click.left>=n[0]?s-o.grid[0]:s+o.grid[0]:s)),{top:l-this.offset.click.top-this.offset.relative.top-this.offset.parent.top+(this.cssPosition==="fixed"?-this.scrollParent.scrollTop():a?0:u.scrollTop()),left:f-this.offset.click.left-this.offset.relative.left-this.offset.parent.left+(this.cssPosition==="fixed"?-this.scrollParent.scrollLeft():a?0:u.scrollLeft())}},_clear:function(){this.helper.removeClass("ui-draggable-dragging"),this.helper[0]!==this.element[0]&&!this.cancelHelperRemoval&&this.helper.remove(),this.helper=null,this.cancelHelperRemoval=!1},_trigger:function(t,n,r){return r=r||this._uiHash(),e.ui.plugin.call(this,t,[n,r]),t==="drag"&&(this.positionAbs=this._convertPositionTo("absolute")),e.Widget.prototype._trigger.call(this,t,n,r)},plugins:{},_uiHash:function(){return{helper:this.helper,position:this.position,originalPosition:this.originalPosition,offset:this.positionAbs}}}),e.ui.plugin.add("draggable","connectToSortable",{start:function(t,n){var r=e(this).data("ui-draggable"),i=r.options,s=e.extend({},n,{item:r.element});r.sortables=[],e(i.connectToSortable).each(function(){var n=e.data(this,"ui-sortable");n&&!n.options.disabled&&(r.sortables.push({instance:n,shouldRevert:n.options.revert}),n.refreshPositions(),n._trigger("activate",t,s))})},stop:function(t,n){var r=e(this).data("ui-draggable"),i=e.extend({},n,{item:r.element});e.each(r.sortables,function(){this.instance.isOver?(this.instance.isOver=0,r.cancelHelperRemoval=!0,this.instance.cancelHelperRemoval=!1,this.shouldRevert&&(this.instance.options.revert=!0),this.instance._mouseStop(t),this.instance.options.helper=this.instance.options._helper,r.options.helper==="original"&&this.instance.currentItem.css({top:"auto",left:"auto"})):(this.instance.cancelHelperRemoval=!1,this.instance._trigger("deactivate",t,i))})},drag:function(t,n){var r=e(this).data("ui-draggable"),i=this;e.each(r.sortables,function(){var s=!1,o=this;this.instance.positionAbs=r.positionAbs,this.instance.helperProportions=r.helperProportions,this.instance.offset.click=r.offset.click,this.instance._intersectsWith(this.instance.containerCache)&&(s=!0,e.each(r.sortables,function(){return this.instance.positionAbs=r.positionAbs,this.instance.helperProportions=r.helperProportions,this.instance.offset.click=r.offset.click,this!==o&&this.instance._intersectsWith(this.instance.containerCache)&&e.contains(o.instance.element[0],this.instance.element[0])&&(s=!1),s})),s?(this.instance.isOver||(this.instance.isOver=1,this.instance.currentItem=e(i).clone().removeAttr("id").appendTo(this.instance.element).data("ui-sortable-item",!0),this.instance.options._helper=this.instance.options.helper,this.instance.options.helper=function(){return n.helper[0]},t.target=this.instance.currentItem[0],this.instance._mouseCapture(t,!0),this.instance._mouseStart(t,!0,!0),this.instance.offset.click.top=r.offset.click.top,this.instance.offset.click.left=r.offset.click.left,this.instance.offset.parent.left-=r.offset.parent.left-this.instance.offset.parent.left,this.instance.offset.parent.top-=r.offset.parent.top-this.instance.offset.parent.top,r._trigger("toSortable",t),r.dropped=this.instance.element,r.currentItem=r.element,this.instance.fromOutside=r),this.instance.currentItem&&this.instance._mouseDrag(t)):this.instance.isOver&&(this.instance.isOver=0,this.instance.cancelHelperRemoval=!0,this.instance.options.revert=!1,this.instance._trigger("out",t,this.instance._uiHash(this.instance)),this.instance._mouseStop(t,!0),this.instance.options.helper=this.instance.options._helper,this.instance.currentItem.remove(),this.instance.placeholder&&this.instance.placeholder.remove(),r._trigger("fromSortable",t),r.dropped=!1)})}}),e.ui.plugin.add("draggable","cursor",{start:function(){var t=e("body"),n=e(this).data("ui-draggable").options;t.css("cursor")&&(n._cursor=t.css("cursor")),t.css("cursor",n.cursor)},stop:function(){var t=e(this).data("ui-draggable").options;t._cursor&&e("body").css("cursor",t._cursor)}}),e.ui.plugin.add("draggable","opacity",{start:function(t,n){var r=e(n.helper),i=e(this).data("ui-draggable").options;r.css("opacity")&&(i._opacity=r.css("opacity")),r.css("opacity",i.opacity)},stop:function(t,n){var r=e(this).data("ui-draggable").options;r._opacity&&e(n.helper).css("opacity",r._opacity)}}),e.ui.plugin.add("draggable","scroll",{start:function(){var t=e(this).data("ui-draggable");t.scrollParent[0]!==document&&t.scrollParent[0].tagName!=="HTML"&&(t.overflowOffset=t.scrollParent.offset())},drag:function(t){var n=e(this).data("ui-draggable"),r=n.options,i=!1;if(n.scrollParent[0]!==document&&n.scrollParent[0].tagName!=="HTML"){if(!r.axis||r.axis!=="x")n.overflowOffset.top+n.scrollParent[0].offsetHeight-t.pageY<r.scrollSensitivity?n.scrollParent[0].scrollTop=i=n.scrollParent[0].scrollTop+r.scrollSpeed:t.pageY-n.overflowOffset.top<r.scrollSensitivity&&(n.scrollParent[0].scrollTop=i=n.scrollParent[0].scrollTop-r.scrollSpeed);if(!r.axis||r.axis!=="y")n.overflowOffset.left+n.scrollParent[0].offsetWidth-t.pageX<r.scrollSensitivity?n.scrollParent[0].scrollLeft=i=n.scrollParent[0].scrollLeft+r.scrollSpeed:t.pageX-n.overflowOffset.left<r.scrollSensitivity&&(n.scrollParent[0].scrollLeft=i=n.scrollParent[0].scrollLeft-r.scrollSpeed)}else{if(!r.axis||r.axis!=="x")t.pageY-e(document).scrollTop()<r.scrollSensitivity?i=e(document).scrollTop(e(document).scrollTop()-r.scrollSpeed):e(window).height()-(t.pageY-e(document).scrollTop())<r.scrollSensitivity&&(i=e(document).scrollTop(e(document).scrollTop()+r.scrollSpeed));if(!r.axis||r.axis!=="y")t.pageX-e(document).scrollLeft()<r.scrollSensitivity?i=e(document).scrollLeft(e(document).scrollLeft()-r.scrollSpeed):e(window).width()-(t.pageX-e(document).scrollLeft())<r.scrollSensitivity&&(i=e(document).scrollLeft(e(document).scrollLeft()+r.scrollSpeed))}i!==!1&&e.ui.ddmanager&&!r.dropBehaviour&&e.ui.ddmanager.prepareOffsets(n,t)}}),e.ui.plugin.add("draggable","snap",{start:function(){var t=e(this).data("ui-draggable"),n=t.options;t.snapElements=[],e(n.snap.constructor!==String?n.snap.items||":data(ui-draggable)":n.snap).each(function(){var n=e(this),r=n.offset();this!==t.element[0]&&t.snapElements.push({item:this,width:n.outerWidth(),height:n.outerHeight(),top:r.top,left:r.left})})},drag:function(t,n){var r,i,s,o,u,a,f,l,c,h,p=e(this).data("ui-draggable"),d=p.options,v=d.snapTolerance,m=n.offset.left,g=m+p.helperProportions.width,y=n.offset.top,b=y+p.helperProportions.height;for(c=p.snapElements.length-1;c>=0;c--){u=p.snapElements[c].left,a=u+p.snapElements[c].width,f=p.snapElements[c].top,l=f+p.snapElements[c].height;if(!(u-v<m&&m<a+v&&f-v<y&&y<l+v||u-v<m&&m<a+v&&f-v<b&&b<l+v||u-v<g&&g<a+v&&f-v<y&&y<l+v||u-v<g&&g<a+v&&f-v<b&&b<l+v)){p.snapElements[c].snapping&&p.options.snap.release&&p.options.snap.release.call(p.element,t,e.extend(p._uiHash(),{snapItem:p.snapElements[c].item})),p.snapElements[c].snapping=!1;continue}d.snapMode!=="inner"&&(r=Math.abs(f-b)<=v,i=Math.abs(l-y)<=v,s=Math.abs(u-g)<=v,o=Math.abs(a-m)<=v,r&&(n.position.top=p._convertPositionTo("relative",{top:f-p.helperProportions.height,left:0}).top-p.margins.top),i&&(n.position.top=p._convertPositionTo("relative",{top:l,left:0}).top-p.margins.top),s&&(n.position.left=p._convertPositionTo("relative",{top:0,left:u-p.helperProportions.width}).left-p.margins.left),o&&(n.position.left=p._convertPositionTo("relative",{top:0,left:a}).left-p.margins.left)),h=r||i||s||o,d.snapMode!=="outer"&&(r=Math.abs(f-y)<=v,i=Math.abs(l-b)<=v,s=Math.abs(u-m)<=v,o=Math.abs(a-g)<=v,r&&(n.position.top=p._convertPositionTo("relative",{top:f,left:0}).top-p.margins.top),i&&(n.position.top=p._convertPositionTo("relative",{top:l-p.helperProportions.height,left:0}).top-p.margins.top),s&&(n.position.left=p._convertPositionTo("relative",{top:0,left:u}).left-p.margins.left),o&&(n.position.left=p._convertPositionTo("relative",{top:0,left:a-p.helperProportions.width}).left-p.margins.left)),!p.snapElements[c].snapping&&(r||i||s||o||h)&&p.options.snap.snap&&p.options.snap.snap.call(p.element,t,e.extend(p._uiHash(),{snapItem:p.snapElements[c].item})),p.snapElements[c].snapping=r||i||s||o||h}}}),e.ui.plugin.add("draggable","stack",{start:function(){var t,n=this.data("ui-draggable").options,r=e.makeArray(e(n.stack)).sort(function(t,n){return(parseInt(e(t).css("zIndex"),10)||0)-(parseInt(e(n).css("zIndex"),10)||0)});if(!r.length)return;t=parseInt(e(r[0]).css("zIndex"),10)||0,e(r).each(function(n){e(this).css("zIndex",t+n)}),this.css("zIndex",t+r.length)}}),e.ui.plugin.add("draggable","zIndex",{start:function(t,n){var r=e(n.helper),i=e(this).data("ui-draggable").options;r.css("zIndex")&&(i._zIndex=r.css("zIndex")),r.css("zIndex",i.zIndex)},stop:function(t,n){var r=e(this).data("ui-draggable").options;r._zIndex&&e(n.helper).css("zIndex",r._zIndex)}})}(jQuery),function(e,t){function n(e,t,n){return e>t&&e<t+n}e.widget("ui.droppable",{version:"1.10.1",widgetEventPrefix:"drop",options:{accept:"*",activeClass:!1,addClasses:!0,greedy:!1,hoverClass:!1,scope:"default",tolerance:"intersect",activate:null,deactivate:null,drop:null,out:null,over:null},_create:function(){var t=this.options,n=t.accept;this.isover=!1,this.isout=!0,this.accept=e.isFunction(n)?n:function(e){return e.is(n)},this.proportions={width:this.element[0].offsetWidth,height:this.element[0].offsetHeight},e.ui.ddmanager.droppables[t.scope]=e.ui.ddmanager.droppables[t.scope]||[],e.ui.ddmanager.droppables[t.scope].push(this),t.addClasses&&this.element.addClass("ui-droppable")},_destroy:function(){var t=0,n=e.ui.ddmanager.droppables[this.options.scope];for(;t<n.length;t++)n[t]===this&&n.splice(t,1);this.element.removeClass("ui-droppable ui-droppable-disabled")},_setOption:function(t,n){t==="accept"&&(this.accept=e.isFunction(n)?n:function(e){return e.is(n)}),e.Widget.prototype._setOption.apply(this,arguments)},_activate:function(t){var n=e.ui.ddmanager.current;this.options.activeClass&&this.element.addClass(this.options.activeClass),n&&this._trigger("activate",t,this.ui(n))},_deactivate:function(t){var n=e.ui.ddmanager.current;this.options.activeClass&&this.element.removeClass(this.options.activeClass),n&&this._trigger("deactivate",t,this.ui(n))},_over:function(t){var n=e.ui.ddmanager.current;if(!n||(n.currentItem||n.element)[0]===this.element[0])return;this.accept.call(this.element[0],n.currentItem||n.element)&&(this.options.hoverClass&&this.element.addClass(this.options.hoverClass),this._trigger("over",t,this.ui(n)))},_out:function(t){var n=e.ui.ddmanager.current;if(!n||(n.currentItem||n.element)[0]===this.element[0])return;this.accept.call(this.element[0],n.currentItem||n.element)&&(this.options.hoverClass&&this.element.removeClass(this.options.hoverClass),this._trigger("out",t,this.ui(n)))},_drop:function(t,n){var r=n||e.ui.ddmanager.current,i=!1;return!r||(r.currentItem||r.element)[0]===this.element[0]?!1:(this.element.find(":data(ui-droppable)").not(".ui-draggable-dragging").each(function(){var t=e.data(this,"ui-droppable");if(t.options.greedy&&!t.options.disabled&&t.options.scope===r.options.scope&&t.accept.call(t.element[0],r.currentItem||r.element)&&e.ui.intersect(r,e.extend(t,{offset:t.element.offset()}),t.options.tolerance))return i=!0,!1}),i?!1:this.accept.call(this.element[0],r.currentItem||r.element)?(this.options.activeClass&&this.element.removeClass(this.options.activeClass),this.options.hoverClass&&this.element.removeClass(this.options.hoverClass),this._trigger("drop",t,this.ui(r)),this.element):!1)},ui:function(e){return{draggable:e.currentItem||e.element,helper:e.helper,position:e.position,offset:e.positionAbs}}}),e.ui.intersect=function(e,t,r){if(!t.offset)return!1;var i,s,o=(e.positionAbs||e.position.absolute).left,u=o+e.helperProportions.width,a=(e.positionAbs||e.position.absolute).top,f=a+e.helperProportions.height,l=t.offset.left,c=l+t.proportions.width,h=t.offset.top,p=h+t.proportions.height;switch(r){case"fit":return l<=o&&u<=c&&h<=a&&f<=p;case"intersect":return l<o+e.helperProportions.width/2&&u-e.helperProportions.width/2<c&&h<a+e.helperProportions.height/2&&f-e.helperProportions.height/2<p;case"pointer":return i=(e.positionAbs||e.position.absolute).left+(e.clickOffset||e.offset.click).left,s=(e.positionAbs||e.position.absolute).top+(e.clickOffset||e.offset.click).top,n(s,h,t.proportions.height)&&n(i,l,t.proportions.width);case"touch":return(a>=h&&a<=p||f>=h&&f<=p||a<h&&f>p)&&(o>=l&&o<=c||u>=l&&u<=c||o<l&&u>c);default:return!1}},e.ui.ddmanager={current:null,droppables:{"default":[]},prepareOffsets:function(t,n){var r,i,s=e.ui.ddmanager.droppables[t.options.scope]||[],o=n?n.type:null,u=(t.currentItem||t.element).find(":data(ui-droppable)").addBack();e:for(r=0;r<s.length;r++){if(s[r].options.disabled||t&&!s[r].accept.call(s[r].element[0],t.currentItem||t.element))continue;for(i=0;i<u.length;i++)if(u[i]===s[r].element[0]){s[r].proportions.height=0;continue e}s[r].visible=s[r].element.css("display")!=="none";if(!s[r].visible)continue;o==="mousedown"&&s[r]._activate.call(s[r],n),s[r].offset=s[r].element.offset(),s[r].proportions={width:s[r].element[0].offsetWidth,height:s[r].element[0].offsetHeight}}},drop:function(t,n){var r=!1;return e.each(e.ui.ddmanager.droppables[t.options.scope]||[],function(){if(!this.options)return;!this.options.disabled&&this.visible&&e.ui.intersect(t,this,this.options.tolerance)&&(r=this._drop.call(this,n)||r),!this.options.disabled&&this.visible&&this.accept.call(this.element[0],t.currentItem||t.element)&&(this.isout=!0,this.isover=!1,this._deactivate.call(this,n))}),r},dragStart:function(t,n){t.element.parentsUntil("body").bind("scroll.droppable",function(){t.options.refreshPositions||e.ui.ddmanager.prepareOffsets(t,n)})},drag:function(t,n){t.options.refreshPositions&&e.ui.ddmanager.prepareOffsets(t,n),e.each(e.ui.ddmanager.droppables[t.options.scope]||[],function(){if(this.options.disabled||this.greedyChild||!this.visible)return;var r,i,s,o=e.ui.intersect(t,this,this.options.tolerance),u=!o&&this.isover?"isout":o&&!this.isover?"isover":null;if(!u)return;this.options.greedy&&(i=this.options.scope,s=this.element.parents(":data(ui-droppable)").filter(function(){return e.data(this,"ui-droppable").options.scope===i}),s.length&&(r=e.data(s[0],"ui-droppable"),r.greedyChild=u==="isover")),r&&u==="isover"&&(r.isover=!1,r.isout=!0,r._out.call(r,n)),this[u]=!0,this[u==="isout"?"isover":"isout"]=!1,this[u==="isover"?"_over":"_out"].call(this,n),r&&u==="isout"&&(r.isout=!1,r.isover=!0,r._over.call(r,n))})},dragStop:function(t,n){t.element.parentsUntil("body").unbind("scroll.droppable"),t.options.refreshPositions||e.ui.ddmanager.prepareOffsets(t,n)}}}(jQuery),function(e,t){function n(e){return parseInt(e,10)||0}function r(e){return!isNaN(parseInt(e,10))}e.widget("ui.resizable",e.ui.mouse,{version:"1.10.1",widgetEventPrefix:"resize",options:{alsoResize:!1,animate:!1,animateDuration:"slow",animateEasing:"swing",aspectRatio:!1,autoHide:!1,containment:!1,ghost:!1,grid:!1,handles:"e,s,se",helper:!1,maxHeight:null,maxWidth:null,minHeight:10,minWidth:10,zIndex:90,resize:null,start:null,stop:null},_create:function(){var t,n,r,i,s,o=this,u=this.options;this.element.addClass("ui-resizable"),e.extend(this,{_aspectRatio:!!u.aspectRatio,aspectRatio:u.aspectRatio,originalElement:this.element,_proportionallyResizeElements:[],_helper:u.helper||u.ghost||u.animate?u.helper||"ui-resizable-helper":null}),this.element[0].nodeName.match(/canvas|textarea|input|select|button|img/i)&&(this.element.wrap(e("<div class='ui-wrapper' style='overflow: hidden;'></div>").css({position:this.element.css("position"),width:this.element.outerWidth(),height:this.element.outerHeight(),top:this.element.css("top"),left:this.element.css("left")})),this.element=this.element.parent().data("ui-resizable",this.element.data("ui-resizable")),this.elementIsWrapper=!0,this.element.css({marginLeft:this.originalElement.css("marginLeft"),marginTop:this.originalElement.css("marginTop"),marginRight:this.originalElement.css("marginRight"),marginBottom:this.originalElement.css("marginBottom")}),this.originalElement.css({marginLeft:0,marginTop:0,marginRight:0,marginBottom:0}),this.originalResizeStyle=this.originalElement.css("resize"),this.originalElement.css("resize","none"),this._proportionallyResizeElements.push(this.originalElement.css({position:"static",zoom:1,display:"block"})),this.originalElement.css({margin:this.originalElement.css("margin")}),this._proportionallyResize()),this.handles=u.handles||(e(".ui-resizable-handle",this.element).length?{n:".ui-resizable-n",e:".ui-resizable-e",s:".ui-resizable-s",w:".ui-resizable-w",se:".ui-resizable-se",sw:".ui-resizable-sw",ne:".ui-resizable-ne",nw:".ui-resizable-nw"}:"e,s,se");if(this.handles.constructor===String){this.handles==="all"&&(this.handles="n,e,s,w,se,sw,ne,nw"),t=this.handles.split(","),this.handles={};for(n=0;n<t.length;n++)r=e.trim(t[n]),s="ui-resizable-"+r,i=e("<div class='ui-resizable-handle "+s+"'></div>"),i.css({zIndex:u.zIndex}),"se"===r&&i.addClass("ui-icon ui-icon-gripsmall-diagonal-se"),this.handles[r]=".ui-resizable-"+r,this.element.append(i)}this._renderAxis=function(t){var n,r,i,s;t=t||this.element;for(n in this.handles){this.handles[n].constructor===String&&(this.handles[n]=e(this.handles[n],this.element).show()),this.elementIsWrapper&&this.originalElement[0].nodeName.match(/textarea|input|select|button/i)&&(r=e(this.handles[n],this.element),s=/sw|ne|nw|se|n|s/.test(n)?r.outerHeight():r.outerWidth(),i=["padding",/ne|nw|n/.test(n)?"Top":/se|sw|s/.test(n)?"Bottom":/^e$/.test(n)?"Right":"Left"].join(""),t.css(i,s),this._proportionallyResize());if(!e(this.handles[n]).length)continue}},this._renderAxis(this.element),this._handles=e(".ui-resizable-handle",this.element).disableSelection(),this._handles.mouseover(function(){o.resizing||(this.className&&(i=this.className.match(/ui-resizable-(se|sw|ne|nw|n|e|s|w)/i)),o.axis=i&&i[1]?i[1]:"se")}),u.autoHide&&(this._handles.hide(),e(this.element).addClass("ui-resizable-autohide").mouseenter(function(){if(u.disabled)return;e(this).removeClass("ui-resizable-autohide"),o._handles.show()}).mouseleave(function(){if(u.disabled)return;o.resizing||(e(this).addClass("ui-resizable-autohide"),o._handles.hide())})),this._mouseInit()},_destroy:function(){this._mouseDestroy();var t,n=function(t){e(t).removeClass("ui-resizable ui-resizable-disabled ui-resizable-resizing").removeData("resizable").removeData("ui-resizable").unbind(".resizable").find(".ui-resizable-handle").remove()};return this.elementIsWrapper&&(n(this.element),t=this.element,this.originalElement.css({position:t.css("position"),width:t.outerWidth(),height:t.outerHeight(),top:t.css("top"),left:t.css("left")}).insertAfter(t),t.remove()),this.originalElement.css("resize",this.originalResizeStyle),n(this.originalElement),this},_mouseCapture:function(t){var n,r,i=!1;for(n in this.handles){r=e(this.handles[n])[0];if(r===t.target||e.contains(r,t.target))i=!0}return!this.options.disabled&&i},_mouseStart:function(t){var r,i,s,o=this.options,u=this.element.position(),a=this.element;return this.resizing=!0,/absolute/.test(a.css("position"))?a.css({position:"absolute",top:a.css("top"),left:a.css("left")}):a.is(".ui-draggable")&&a.css({position:"absolute",top:u.top,left:u.left}),this._renderProxy(),r=n(this.helper.css("left")),i=n(this.helper.css("top")),o.containment&&(r+=e(o.containment).scrollLeft()||0,i+=e(o.containment).scrollTop()||0),this.offset=this.helper.offset(),this.position={left:r,top:i},this.size=this._helper?{width:a.outerWidth(),height:a.outerHeight()}:{width:a.width(),height:a.height()},this.originalSize=this._helper?{width:a.outerWidth(),height:a.outerHeight()}:{width:a.width(),height:a.height()},this.originalPosition={left:r,top:i},this.sizeDiff={width:a.outerWidth()-a.width(),height:a.outerHeight()-a.height()},this.originalMousePosition={left:t.pageX,top:t.pageY},this.aspectRatio=typeof o.aspectRatio=="number"?o.aspectRatio:this.originalSize.width/this.originalSize.height||1,s=e(".ui-resizable-"+this.axis).css("cursor"),e("body").css("cursor",s==="auto"?this.axis+"-resize":s),a.addClass("ui-resizable-resizing"),this._propagate("start",t),!0},_mouseDrag:function(t){var n,r=this.helper,i={},s=this.originalMousePosition,o=this.axis,u=this.position.top,a=this.position.left,f=this.size.width,l=this.size.height,c=t.pageX-s.left||0,h=t.pageY-s.top||0,p=this._change[o];if(!p)return!1;n=p.apply(this,[t,c,h]),this._updateVirtualBoundaries(t.shiftKey);if(this._aspectRatio||t.shiftKey)n=this._updateRatio(n,t);return n=this._respectSize(n,t),this._updateCache(n),this._propagate("resize",t),this.position.top!==u&&(i.top=this.position.top+"px"),this.position.left!==a&&(i.left=this.position.left+"px"),this.size.width!==f&&(i.width=this.size.width+"px"),this.size.height!==l&&(i.height=this.size.height+"px"),r.css(i),!this._helper&&this._proportionallyResizeElements.length&&this._proportionallyResize(),e.isEmptyObject(i)||this._trigger("resize",t,this.ui()),!1},_mouseStop:function(t){this.resizing=!1;var n,r,i,s,o,u,a,f=this.options,l=this;return this._helper&&(n=this._proportionallyResizeElements,r=n.length&&/textarea/i.test(n[0].nodeName),i=r&&e.ui.hasScroll(n[0],"left")?0:l.sizeDiff.height,s=r?0:l.sizeDiff.width,o={width:l.helper.width()-s,height:l.helper.height()-i},u=parseInt(l.element.css("left"),10)+(l.position.left-l.originalPosition.left)||null,a=parseInt(l.element.css("top"),10)+(l.position.top-l.originalPosition.top)||null,f.animate||this.element.css(e.extend(o,{top:a,left:u})),l.helper.height(l.size.height),l.helper.width(l.size.width),this._helper&&!f.animate&&this._proportionallyResize()),e("body").css("cursor","auto"),this.element.removeClass("ui-resizable-resizing"),this._propagate("stop",t),this._helper&&this.helper.remove(),!1},_updateVirtualBoundaries:function(e){var t,n,i,s,o,u=this.options;o={minWidth:r(u.minWidth)?u.minWidth:0,maxWidth:r(u.maxWidth)?u.maxWidth:Infinity,minHeight:r(u.minHeight)?u.minHeight:0,maxHeight:r(u.maxHeight)?u.maxHeight:Infinity};if(this._aspectRatio||e)t=o.minHeight*this.aspectRatio,i=o.minWidth/this.aspectRatio,n=o.maxHeight*this.aspectRatio,s=o.maxWidth/this.aspectRatio,t>o.minWidth&&(o.minWidth=t),i>o.minHeight&&(o.minHeight=i),n<o.maxWidth&&(o.maxWidth=n),s<o.maxHeight&&(o.maxHeight=s);this._vBoundaries=o},_updateCache:function(e){this.offset=this.helper.offset(),r(e.left)&&(this.position.left=e.left),r(e.top)&&(this.position.top=e.top),r(e.height)&&(this.size.height=e.height),r(e.width)&&(this.size.width=e.width)},_updateRatio:function(e){var t=this.position,n=this.size,i=this.axis;return r(e.height)?e.width=e.height*this.aspectRatio:r(e.width)&&(e.height=e.width/this.aspectRatio),i==="sw"&&(e.left=t.left+(n.width-e.width),e.top=null),i==="nw"&&(e.top=t.top+(n.height-e.height),e.left=t.left+(n.width-e.width)),e},_respectSize:function(e){var t=this._vBoundaries,n=this.axis,i=r(e.width)&&t.maxWidth&&t.maxWidth<e.width,s=r(e.height)&&t.maxHeight&&t.maxHeight<e.height,o=r(e.width)&&t.minWidth&&t.minWidth>e.width,u=r(e.height)&&t.minHeight&&t.minHeight>e.height,a=this.originalPosition.left+this.originalSize.width,f=this.position.top+this.size.height,l=/sw|nw|w/.test(n),c=/nw|ne|n/.test(n);return o&&(e.width=t.minWidth),u&&(e.height=t.minHeight),i&&(e.width=t.maxWidth),s&&(e.height=t.maxHeight),o&&l&&(e.left=a-t.minWidth),i&&l&&(e.left=a-t.maxWidth),u&&c&&(e.top=f-t.minHeight),s&&c&&(e.top=f-t.maxHeight),!e.width&&!e.height&&!e.left&&e.top?e.top=null:!e.width&&!e.height&&!e.top&&e.left&&(e.left=null),e},_proportionallyResize:function(){if(!this._proportionallyResizeElements.length)return;var e,t,n,r,i,s=this.helper||this.element;for(e=0;e<this._proportionallyResizeElements.length;e++){i=this._proportionallyResizeElements[e];if(!this.borderDif){this.borderDif=[],n=[i.css("borderTopWidth"),i.css("borderRightWidth"),i.css("borderBottomWidth"),i.css("borderLeftWidth")],r=[i.css("paddingTop"),i.css("paddingRight"),i.css("paddingBottom"),i.css("paddingLeft")];for(t=0;t<n.length;t++)this.borderDif[t]=(parseInt(n[t],10)||0)+(parseInt(r[t],10)||0)}i.css({height:s.height()-this.borderDif[0]-this.borderDif[2]||0,width:s.width()-this.borderDif[1]-this.borderDif[3]||0})}},_renderProxy:function(){var t=this.element,n=this.options;this.elementOffset=t.offset(),this._helper?(this.helper=this.helper||e("<div style='overflow:hidden;'></div>"),this.helper.addClass(this._helper).css({width:this.element.outerWidth()-1,height:this.element.outerHeight()-1,position:"absolute",left:this.elementOffset.left+"px",top:this.elementOffset.top+"px",zIndex:++n.zIndex}),this.helper.appendTo("body").disableSelection()):this.helper=this.element},_change:{e:function(e,t){return{width:this.originalSize.width+t}},w:function(e,t){var n=this.originalSize,r=this.originalPosition;return{left:r.left+t,width:n.width-t}},n:function(e,t,n){var r=this.originalSize,i=this.originalPosition;return{top:i.top+n,height:r.height-n}},s:function(e,t,n){return{height:this.originalSize.height+n}},se:function(t,n,r){return e.extend(this._change.s.apply(this,arguments),this._change.e.apply(this,[t,n,r]))},sw:function(t,n,r){return e.extend(this._change.s.apply(this,arguments),this._change.w.apply(this,[t,n,r]))},ne:function(t,n,r){return e.extend(this._change.n.apply(this,arguments),this._change.e.apply(this,[t,n,r]))},nw:function(t,n,r){return e.extend(this._change.n.apply(this,arguments),this._change.w.apply(this,[t,n,r]))}},_propagate:function(t,n){e.ui.plugin.call(this,t,[n,this.ui()]),t!=="resize"&&this._trigger(t,n,this.ui())},plugins:{},ui:function(){return{originalElement:this.originalElement,element:this.element,helper:this.helper,position:this.position,size:this.size,originalSize:this.originalSize,originalPosition:this.originalPosition}}}),e.ui.plugin.add("resizable","animate",{stop:function(t){var n=e(this).data("ui-resizable"),r=n.options,i=n._proportionallyResizeElements,s=i.length&&/textarea/i.test(i[0].nodeName),o=s&&e.ui.hasScroll(i[0],"left")?0:n.sizeDiff.height,u=s?0:n.sizeDiff.width,a={width:n.size.width-u,height:n.size.height-o},f=parseInt(n.element.css("left"),10)+(n.position.left-n.originalPosition.left)||null,l=parseInt(n.element.css("top"),10)+(n.position.top-n.originalPosition.top)||null;n.element.animate(e.extend(a,l&&f?{top:l,left:f}:{}),{duration:r.animateDuration,easing:r.animateEasing,step:function(){var r={width:parseInt(n.element.css("width"),10),height:parseInt(n.element.css("height"),10),top:parseInt(n.element.css("top"),10),left:parseInt(n.element.css("left"),10)};i&&i.length&&e(i[0]).css({width:r.width,height:r.height}),n._updateCache(r),n._propagate("resize",t)}})}}),e.ui.plugin.add("resizable","containment",{start:function(){var t,r,i,s,o,u,a,f=e(this).data("ui-resizable"),l=f.options,c=f.element,h=l.containment,p=h instanceof e?h.get(0):/parent/.test(h)?c.parent().get(0):h;if(!p)return;f.containerElement=e(p),/document/.test(h)||h===document?(f.containerOffset={left:0,top:0},f.containerPosition={left:0,top:0},f.parentData={element:e(document),left:0,top:0,width:e(document).width(),height:e(document).height()||document.body.parentNode.scrollHeight}):(t=e(p),r=[],e(["Top","Right","Left","Bottom"]).each(function(e,i){r[e]=n(t.css("padding"+i))}),f.containerOffset=t.offset(),f.containerPosition=t.position(),f.containerSize={height:t.innerHeight()-r[3],width:t.innerWidth()-r[1]},i=f.containerOffset,s=f.containerSize.height,o=f.containerSize.width,u=e.ui.hasScroll(p,"left")?p.scrollWidth:o,a=e.ui.hasScroll(p)?p.scrollHeight:s,f.parentData={element:p,left:i.left,top:i.top,width:u,height:a})},resize:function(t){var n,r,i,s,o=e(this).data("ui-resizable"),u=o.options,a=o.containerOffset,f=o.position,l=o._aspectRatio||t.shiftKey,c={top:0,left:0},h=o.containerElement;h[0]!==document&&/static/.test(h.css("position"))&&(c=a),f.left<(o._helper?a.left:0)&&(o.size.width=o.size.width+(o._helper?o.position.left-a.left:o.position.left-c.left),l&&(o.size.height=o.size.width/o.aspectRatio),o.position.left=u.helper?a.left:0),f.top<(o._helper?a.top:0)&&(o.size.height=o.size.height+(o._helper?o.position.top-a.top:o.position.top),l&&(o.size.width=o.size.height*o.aspectRatio),o.position.top=o._helper?a.top:0),o.offset.left=o.parentData.left+o.position.left,o.offset.top=o.parentData.top+o.position.top,n=Math.abs((o._helper?o.offset.left-c.left:o.offset.left-c.left)+o.sizeDiff.width),r=Math.abs((o._helper?o.offset.top-c.top:o.offset.top-a.top)+o.sizeDiff.height),i=o.containerElement.get(0)===o.element.parent().get(0),s=/relative|absolute/.test(o.containerElement.css("position")),i&&s&&(n-=o.parentData.left),n+o.size.width>=o.parentData.width&&(o.size.width=o.parentData.width-n,l&&(o.size.height=o.size.width/o.aspectRatio)),r+o.size.height>=o.parentData.height&&(o.size.height=o.parentData.height-r,l&&(o.size.width=o.size.height*o.aspectRatio))},stop:function(){var t=e(this).data("ui-resizable"),n=t.options,r=t.containerOffset,i=t.containerPosition,s=t.containerElement,o=e(t.helper),u=o.offset(),a=o.outerWidth()-t.sizeDiff.width,f=o.outerHeight()-t.sizeDiff.height;t._helper&&!n.animate&&/relative/.test(s.css("position"))&&e(this).css({left:u.left-i.left-r.left,width:a,height:f}),t._helper&&!n.animate&&/static/.test(s.css("position"))&&e(this).css({left:u.left-i.left-r.left,width:a,height:f})}}),e.ui.plugin.add("resizable","alsoResize",{start:function(){var t=e(this).data("ui-resizable"),n=t.options,r=function(t){e(t).each(function(){var t=e(this);t.data("ui-resizable-alsoresize",{width:parseInt(t.width(),10),height:parseInt(t.height(),10),left:parseInt(t.css("left"),10),top:parseInt(t.css("top"),10)})})};typeof n.alsoResize=="object"&&!n.alsoResize.parentNode?n.alsoResize.length?(n.alsoResize=n.alsoResize[0],r(n.alsoResize)):e.each(n.alsoResize,function(e){r(e)}):r(n.alsoResize)},resize:function(t,n){var r=e(this).data("ui-resizable"),i=r.options,s=r.originalSize,o=r.originalPosition,u={height:r.size.height-s.height||0,width:r.size.width-s.width||0,top:r.position.top-o.top||0,left:r.position.left-o.left||0},a=function(t,r){e(t).each(function(){var t=e(this),i=e(this).data("ui-resizable-alsoresize"),s={},o=r&&r.length?r:t.parents(n.originalElement[0]).length?["width","height"]:["width","height","top","left"];e.each(o,function(e,t){var n=(i[t]||0)+(u[t]||0);n&&n>=0&&(s[t]=n||null)}),t.css(s)})};typeof i.alsoResize=="object"&&!i.alsoResize.nodeType?e.each(i.alsoResize,function(e,t){a(e,t)}):a(i.alsoResize)},stop:function(){e(this).removeData("resizable-alsoresize")}}),e.ui.plugin.add("resizable","ghost",{start:function(){var t=e(this).data("ui-resizable"),n=t.options,r=t.size;t.ghost=t.originalElement.clone(),t.ghost.css({opacity:.25,display:"block",position:"relative",height:r.height,width:r.width,margin:0,left:0,top:0}).addClass("ui-resizable-ghost").addClass(typeof n.ghost=="string"?n.ghost:""),t.ghost.appendTo(t.helper)},resize:function(){var t=e(this).data("ui-resizable");t.ghost&&t.ghost.css({position:"relative",height:t.size.height,width:t.size.width})},stop:function(){var t=e(this).data("ui-resizable");t.ghost&&t.helper&&t.helper.get(0).removeChild(t.ghost.get(0))}}),e.ui.plugin.add("resizable","grid",{resize:function(){var t=e(this).data("ui-resizable"),n=t.options,r=t.size,i=t.originalSize,s=t.originalPosition,o=t.axis,u=typeof n.grid=="number"?[n.grid,n.grid]:n.grid,a=u[0]||1,f=u[1]||1,l=Math.round((r.width-i.width)/a)*a,c=Math.round((r.height-i.height)/f)*f,h=i.width+l,p=i.height+c,d=n.maxWidth&&n.maxWidth<h,v=n.maxHeight&&n.maxHeight<p,m=n.minWidth&&n.minWidth>h,g=n.minHeight&&n.minHeight>p;n.grid=u,m&&(h+=a),g&&(p+=f),d&&(h-=a),v&&(p-=f),/^(se|s|e)$/.test(o)?(t.size.width=h,t.size.height=p):/^(ne)$/.test(o)?(t.size.width=h,t.size.height=p,t.position.top=s.top-c):/^(sw)$/.test(o)?(t.size.width=h,t.size.height=p,t.position.left=s.left-l):(t.size.width=h,t.size.height=p,t.position.top=s.top-c,t.position.left=s.left-l)}})}(jQuery),function(e,t){e.widget("ui.selectable",e.ui.mouse,{version:"1.10.1",options:{appendTo:"body",autoRefresh:!0,distance:0,filter:"*",tolerance:"touch",selected:null,selecting:null,start:null,stop:null,unselected:null,unselecting:null},_create:function(){var t,n=this;this.element.addClass("ui-selectable"),this.dragged=!1,this.refresh=function(){t=e(n.options.filter,n.element[0]),t.addClass("ui-selectee"),t.each(function(){var t=e(this),n=t.offset();e.data(this,"selectable-item",{element:this,$element:t,left:n.left,top:n.top,right:n.left+t.outerWidth(),bottom:n.top+t.outerHeight(),startselected:!1,selected:t.hasClass("ui-selected"),selecting:t.hasClass("ui-selecting"),unselecting:t.hasClass("ui-unselecting")})})},this.refresh(),this.selectees=t.addClass("ui-selectee"),this._mouseInit(),this.helper=e("<div class='ui-selectable-helper'></div>")},_destroy:function(){this.selectees.removeClass("ui-selectee").removeData("selectable-item"),this.element.removeClass("ui-selectable ui-selectable-disabled"),this._mouseDestroy()},_mouseStart:function(t){var n=this,r=this.options;this.opos=[t.pageX,t.pageY];if(this.options.disabled)return;this.selectees=e(r.filter,this.element[0]),this._trigger("start",t),e(r.appendTo).append(this.helper),this.helper.css({left:t.pageX,top:t.pageY,width:0,height:0}),r.autoRefresh&&this.refresh(),this.selectees.filter(".ui-selected").each(function(){var r=e.data(this,"selectable-item");r.startselected=!0,!t.metaKey&&!t.ctrlKey&&(r.$element.removeClass("ui-selected"),r.selected=!1,r.$element.addClass("ui-unselecting"),r.unselecting=!0,n._trigger("unselecting",t,{unselecting:r.element}))}),e(t.target).parents().addBack().each(function(){var r,i=e.data(this,"selectable-item");if(i)return r=!t.metaKey&&!t.ctrlKey||!i.$element.hasClass("ui-selected"),i.$element.removeClass(r?"ui-unselecting":"ui-selected").addClass(r?"ui-selecting":"ui-unselecting"),i.unselecting=!r,i.selecting=r,i.selected=r,r?n._trigger("selecting",t,{selecting:i.element}):n._trigger("unselecting",t,{unselecting:i.element}),!1})},_mouseDrag:function(t){this.dragged=!0;if(this.options.disabled)return;var n,r=this,i=this.options,s=this.opos[0],o=this.opos[1],u=t.pageX,a=t.pageY;return s>u&&(n=u,u=s,s=n),o>a&&(n=a,a=o,o=n),this.helper.css({left:s,top:o,width:u-s,height:a-o}),this.selectees.each(function(){var n=e.data(this,"selectable-item"),f=!1;if(!n||n.element===r.element[0])return;i.tolerance==="touch"?f=!(n.left>u||n.right<s||n.top>a||n.bottom<o):i.tolerance==="fit"&&(f=n.left>s&&n.right<u&&n.top>o&&n.bottom<a),f?(n.selected&&(n.$element.removeClass("ui-selected"),n.selected=!1),n.unselecting&&(n.$element.removeClass("ui-unselecting"),n.unselecting=!1),n.selecting||(n.$element.addClass("ui-selecting"),n.selecting=!0,r._trigger("selecting",t,{selecting:n.element}))):(n.selecting&&((t.metaKey||t.ctrlKey)&&n.startselected?(n.$element.removeClass("ui-selecting"),n.selecting=!1,n.$element.addClass("ui-selected"),n.selected=!0):(n.$element.removeClass("ui-selecting"),n.selecting=!1,n.startselected&&(n.$element.addClass("ui-unselecting"),n.unselecting=!0),r._trigger("unselecting",t,{unselecting:n.element}))),n.selected&&!t.metaKey&&!t.ctrlKey&&!n.startselected&&(n.$element.removeClass("ui-selected"),n.selected=!1,n.$element.addClass("ui-unselecting"),n.unselecting=!0,r._trigger("unselecting",t,{unselecting:n.element})))}),!1},_mouseStop:function(t){var n=this;return this.dragged=!1,e(".ui-unselecting",this.element[0]).each(function(){var r=e.data(this,"selectable-item");r.$element.removeClass("ui-unselecting"),r.unselecting=!1,r.startselected=!1,n._trigger("unselected",t,{unselected:r.element})}),e(".ui-selecting",this.element[0]).each(function(){var r=e.data(this,"selectable-item");r.$element.removeClass("ui-selecting").addClass("ui-selected"),r.selecting=!1,r.selected=!0,r.startselected=!0,n._trigger("selected",t,{selected:r.element})}),this._trigger("stop",t),this.helper.remove(),!1}})}(jQuery),function(e,t){function n(e,t,n){return e>t&&e<t+n}e.widget("ui.sortable",e.ui.mouse,{version:"1.10.1",widgetEventPrefix:"sort",ready:!1,options:{appendTo:"parent",axis:!1,connectWith:!1,containment:!1,cursor:"auto",cursorAt:!1,dropOnEmpty:!0,forcePlaceholderSize:!1,forceHelperSize:!1,grid:!1,handle:!1,helper:"original",items:"> *",opacity:!1,placeholder:!1,revert:!1,scroll:!0,scrollSensitivity:20,scrollSpeed:20,scope:"default",tolerance:"intersect",zIndex:1e3,activate:null,beforeStop:null,change:null,deactivate:null,out:null,over:null,receive:null,remove:null,sort:null,start:null,stop:null,update:null},_create:function(){var e=this.options;this.containerCache={},this.element.addClass("ui-sortable"),this.refresh(),this.floating=this.items.length?e.axis==="x"||/left|right/.test(this.items[0].item.css("float"))||/inline|table-cell/.test(this.items[0].item.css("display")):!1,this.offset=this.element.offset(),this._mouseInit(),this.ready=!0},_destroy:function(){this.element.removeClass("ui-sortable ui-sortable-disabled"),this._mouseDestroy();for(var e=this.items.length-1;e>=0;e--)this.items[e].item.removeData(this.widgetName+"-item");return this},_setOption:function(t,n){t==="disabled"?(this.options[t]=n,this.widget().toggleClass("ui-sortable-disabled",!!n)):e.Widget.prototype._setOption.apply(this,arguments)},_mouseCapture:function(t,n){var r=null,i=!1,s=this;if(this.reverting)return!1;if(this.options.disabled||this.options.type==="static")return!1;this._refreshItems(t),e(t.target).parents().each(function(){if(e.data(this,s.widgetName+"-item")===s)return r=e(this),!1}),e.data(t.target,s.widgetName+"-item")===s&&(r=e(t.target));if(!r)return!1;if(this.options.handle&&!n){e(this.options.handle,r).find("*").addBack().each(function(){this===t.target&&(i=!0)});if(!i)return!1}return this.currentItem=r,this._removeCurrentsFromItems(),!0},_mouseStart:function(t,n,r){var i,s=this.options;this.currentContainer=this,this.refreshPositions(),this.helper=this._createHelper(t),this._cacheHelperProportions(),this._cacheMargins(),this.scrollParent=this.helper.scrollParent(),this.offset=this.currentItem.offset(),this.offset={top:this.offset.top-this.margins.top,left:this.offset.left-this.margins.left},e.extend(this.offset,{click:{left:t.pageX-this.offset.left,top:t.pageY-this.offset.top},parent:this._getParentOffset(),relative:this._getRelativeOffset()}),this.helper.css("position","absolute"),this.cssPosition=this.helper.css("position"),this.originalPosition=this._generatePosition(t),this.originalPageX=t.pageX,this.originalPageY=t.pageY,s.cursorAt&&this._adjustOffsetFromHelper(s.cursorAt),this.domPosition={prev:this.currentItem.prev()[0],parent:this.currentItem.parent()[0]},this.helper[0]!==this.currentItem[0]&&this.currentItem.hide(),this._createPlaceholder(),s.containment&&this._setContainment(),s.cursor&&(e("body").css("cursor")&&(this._storedCursor=e("body").css("cursor")),e("body").css("cursor",s.cursor)),s.opacity&&(this.helper.css("opacity")&&(this._storedOpacity=this.helper.css("opacity")),this.helper.css("opacity",s.opacity)),s.zIndex&&(this.helper.css("zIndex")&&(this._storedZIndex=this.helper.css("zIndex")),this.helper.css("zIndex",s.zIndex)),this.scrollParent[0]!==document&&this.scrollParent[0].tagName!=="HTML"&&(this.overflowOffset=this.scrollParent.offset()),this._trigger("start",t,this._uiHash()),this._preserveHelperProportions||this._cacheHelperProportions();if(!r)for(i=this.containers.length-1;i>=0;i--)this.containers[i]._trigger("activate",t,this._uiHash(this));return e.ui.ddmanager&&(e.ui.ddmanager.current=this),e.ui.ddmanager&&!s.dropBehaviour&&e.ui.ddmanager.prepareOffsets(this,t),this.dragging=!0,this.helper.addClass("ui-sortable-helper"),this._mouseDrag(t),!0},_mouseDrag:function(t){var n,r,i,s,o=this.options,u=!1;this.position=this._generatePosition(t),this.positionAbs=this._convertPositionTo("absolute"),this.lastPositionAbs||(this.lastPositionAbs=this.positionAbs),this.options.scroll&&(this.scrollParent[0]!==document&&this.scrollParent[0].tagName!=="HTML"?(this.overflowOffset.top+this.scrollParent[0].offsetHeight-t.pageY<o.scrollSensitivity?this.scrollParent[0].scrollTop=u=this.scrollParent[0].scrollTop+o.scrollSpeed:t.pageY-this.overflowOffset.top<o.scrollSensitivity&&(this.scrollParent[0].scrollTop=u=this.scrollParent[0].scrollTop-o.scrollSpeed),this.overflowOffset.left+this.scrollParent[0].offsetWidth-t.pageX<o.scrollSensitivity?this.scrollParent[0].scrollLeft=u=this.scrollParent[0].scrollLeft+o.scrollSpeed:t.pageX-this.overflowOffset.left<o.scrollSensitivity&&(this.scrollParent[0].scrollLeft=u=this.scrollParent[0].scrollLeft-o.scrollSpeed)):(t.pageY-e(document).scrollTop()<o.scrollSensitivity?u=e(document).scrollTop(e(document).scrollTop()-o.scrollSpeed):e(window).height()-(t.pageY-e(document).scrollTop())<o.scrollSensitivity&&(u=e(document).scrollTop(e(document).scrollTop()+o.scrollSpeed)),t.pageX-e(document).scrollLeft()<o.scrollSensitivity?u=e(document).scrollLeft(e(document).scrollLeft()-o.scrollSpeed):e(window).width()-(t.pageX-e(document).scrollLeft())<o.scrollSensitivity&&(u=e(document).scrollLeft(e(document).scrollLeft()+o.scrollSpeed))),u!==!1&&e.ui.ddmanager&&!o.dropBehaviour&&e.ui.ddmanager.prepareOffsets(this,t)),this.positionAbs=this._convertPositionTo("absolute");if(!this.options.axis||this.options.axis!=="y")this.helper[0].style.left=this.position.left+"px";if(!this.options.axis||this.options.axis!=="x")this.helper[0].style.top=this.position.top+"px";for(n=this.items.length-1;n>=0;n--){r=this.items[n],i=r.item[0],s=this._intersectsWithPointer(r);if(!s)continue;if(r.instance!==this.currentContainer)continue;if(i!==this.currentItem[0]&&this.placeholder[s===1?"next":"prev"]()[0]!==i&&!e.contains(this.placeholder[0],i)&&(this.options.type==="semi-dynamic"?!e.contains(this.element[0],i):!0)){this.direction=s===1?"down":"up";if(this.options.tolerance!=="pointer"&&!this._intersectsWithSides(r))break;this._rearrange(t,r),this._trigger("change",t,this._uiHash());break}}return this._contactContainers(t),e.ui.ddmanager&&e.ui.ddmanager.drag(this,t),this._trigger("sort",t,this._uiHash()),this.lastPositionAbs=this.positionAbs,!1},_mouseStop:function(t,n){if(!t)return;e.ui.ddmanager&&!this.options.dropBehaviour&&e.ui.ddmanager.drop(this,t);if(this.options.revert){var r=this,i=this.placeholder.offset();this.reverting=!0,e(this.helper).animate({left:i.left-this.offset.parent.left-this.margins.left+(this.offsetParent[0]===document.body?0:this.offsetParent[0].scrollLeft),top:i.top-this.offset.parent.top-this.margins.top+(this.offsetParent[0]===document.body?0:this.offsetParent[0].scrollTop)},parseInt(this.options.revert,10)||500,function(){r._clear(t)})}else this._clear(t,n);return!1},cancel:function(){if(this.dragging){this._mouseUp({target:null}),this.options.helper==="original"?this.currentItem.css(this._storedCSS).removeClass("ui-sortable-helper"):this.currentItem.show();for(var t=this.containers.length-1;t>=0;t--)this.containers[t]._trigger("deactivate",null,this._uiHash(this)),this.containers[t].containerCache.over&&(this.containers[t]._trigger("out",null,this._uiHash(this)),this.containers[t].containerCache.over=0)}return this.placeholder&&(this.placeholder[0].parentNode&&this.placeholder[0].parentNode.removeChild(this.placeholder[0]),this.options.helper!=="original"&&this.helper&&this.helper[0].parentNode&&this.helper.remove(),e.extend(this,{helper:null,dragging:!1,reverting:!1,_noFinalSort:null}),this.domPosition.prev?e(this.domPosition.prev).after(this.currentItem):e(this.domPosition.parent).prepend(this.currentItem)),this},serialize:function(t){var n=this._getItemsAsjQuery(t&&t.connected),r=[];return t=t||{},e(n).each(function(){var n=(e(t.item||this).attr(t.attribute||"id")||"").match(t.expression||/(.+)[\-=_](.+)/);n&&r.push((t.key||n[1]+"[]")+"="+(t.key&&t.expression?n[1]:n[2]))}),!r.length&&t.key&&r.push(t.key+"="),r.join("&")},toArray:function(t){var n=this._getItemsAsjQuery(t&&t.connected),r=[];return t=t||{},n.each(function(){r.push(e(t.item||this).attr(t.attribute||"id")||"")}),r},_intersectsWith:function(e){var t=this.positionAbs.left,n=t+this.helperProportions.width,r=this.positionAbs.top,i=r+this.helperProportions.height,s=e.left,o=s+e.width,u=e.top,a=u+e.height,f=this.offset.click.top,l=this.offset.click.left,c=r+f>u&&r+f<a&&t+l>s&&t+l<o;return this.options.tolerance==="pointer"||this.options.forcePointerForContainers||this.options.tolerance!=="pointer"&&this.helperProportions[this.floating?"width":"height"]>e[this.floating?"width":"height"]?c:s<t+this.helperProportions.width/2&&n-this.helperProportions.width/2<o&&u<r+this.helperProportions.height/2&&i-this.helperProportions.height/2<a},_intersectsWithPointer:function(e){var t=this.options.axis==="x"||n(this.positionAbs.top+this.offset.click.top,e.top,e.height),r=this.options.axis==="y"||n(this.positionAbs.left+this.offset.click.left,e.left,e.width),i=t&&r,s=this._getDragVerticalDirection(),o=this._getDragHorizontalDirection();return i?this.floating?o&&o==="right"||s==="down"?2:1:s&&(s==="down"?2:1):!1},_intersectsWithSides:function(e){var t=n(this.positionAbs.top+this.offset.click.top,e.top+e.height/2,e.height),r=n(this.positionAbs.left+this.offset.click.left,e.left+e.width/2,e.width),i=this._getDragVerticalDirection(),s=this._getDragHorizontalDirection();return this.floating&&s?s==="right"&&r||s==="left"&&!r:i&&(i==="down"&&t||i==="up"&&!t)},_getDragVerticalDirection:function(){var e=this.positionAbs.top-this.lastPositionAbs.top;return e!==0&&(e>0?"down":"up")},_getDragHorizontalDirection:function(){var e=this.positionAbs.left-this.lastPositionAbs.left;return e!==0&&(e>0?"right":"left")},refresh:function(e){return this._refreshItems(e),this.refreshPositions(),this},_connectWith:function(){var e=this.options;return e.connectWith.constructor===String?[e.connectWith]:e.connectWith},_getItemsAsjQuery:function(t){var n,r,i,s,o=[],u=[],a=this._connectWith();if(a&&t)for(n=a.length-1;n>=0;n--){i=e(a[n]);for(r=i.length-1;r>=0;r--)s=e.data(i[r],this.widgetFullName),s&&s!==this&&!s.options.disabled&&u.push([e.isFunction(s.options.items)?s.options.items.call(s.element):e(s.options.items,s.element).not(".ui-sortable-helper").not(".ui-sortable-placeholder"),s])}u.push([e.isFunction(this.options.items)?this.options.items.call(this.element,null,{options:this.options,item:this.currentItem}):e(this.options.items,this.element).not(".ui-sortable-helper").not(".ui-sortable-placeholder"),this]);for(n=u.length-1;n>=0;n--)u[n][0].each(function(){o.push(this)});return e(o)},_removeCurrentsFromItems:function(){var t=this.currentItem.find(":data("+this.widgetName+"-item)");this.items=e.grep(this.items,function(e){for(var n=0;n<t.length;n++)if(t[n]===e.item[0])return!1;return!0})},_refreshItems:function(t){this.items=[],this.containers=[this];var n,r,i,s,o,u,a,f,l=this.items,c=[[e.isFunction(this.options.items)?this.options.items.call(this.element[0],t,{item:this.currentItem}):e(this.options.items,this.element),this]],h=this._connectWith();if(h&&this.ready)for(n=h.length-1;n>=0;n--){i=e(h[n]);for(r=i.length-1;r>=0;r--)s=e.data(i[r],this.widgetFullName),s&&s!==this&&!s.options.disabled&&(c.push([e.isFunction(s.options.items)?s.options.items.call(s.element[0],t,{item:this.currentItem}):e(s.options.items,s.element),s]),this.containers.push(s))}for(n=c.length-1;n>=0;n--){o=c[n][1],u=c[n][0];for(r=0,f=u.length;r<f;r++)a=e(u[r]),a.data(this.widgetName+"-item",o),l.push({item:a,instance:o,width:0,height:0,left:0,top:0})}},refreshPositions:function(t){this.offsetParent&&this.helper&&(this.offset.parent=this._getParentOffset());var n,r,i,s;for(n=this.items.length-1;n>=0;n--){r=this.items[n];if(r.instance!==this.currentContainer&&this.currentContainer&&r.item[0]!==this.currentItem[0])continue;i=this.options.toleranceElement?e(this.options.toleranceElement,r.item):r.item,t||(r.width=i.outerWidth(),r.height=i.outerHeight()),s=i.offset(),r.left=s.left,r.top=s.top}if(this.options.custom&&this.options.custom.refreshContainers)this.options.custom.refreshContainers.call(this);else for(n=this.containers.length-1;n>=0;n--)s=this.containers[n].element.offset(),this.containers[n].containerCache.left=s.left,this.containers[n].containerCache.top=s.top,this.containers[n].containerCache.width=this.containers[n].element.outerWidth(),this.containers[n].containerCache.height=this.containers[n].element.outerHeight();return this},_createPlaceholder:function(t){t=t||this;var n,r=t.options;if(!r.placeholder||r.placeholder.constructor===String)n=r.placeholder,r.placeholder={element:function(){var r=e(document.createElement(t.currentItem[0].nodeName)).addClass(n||t.currentItem[0].className+" ui-sortable-placeholder").removeClass("ui-sortable-helper")[0];return n||(r.style.visibility="hidden"),r},update:function(e,i){if(n&&!r.forcePlaceholderSize)return;i.height()||i.height(t.currentItem.innerHeight()-parseInt(t.currentItem.css("paddingTop")||0,10)-parseInt(t.currentItem.css("paddingBottom")||0,10)),i.width()||i.width(t.currentItem.innerWidth()-parseInt(t.currentItem.css("paddingLeft")||0,10)-parseInt(t.currentItem.css("paddingRight")||0,10))}};t.placeholder=e(r.placeholder.element.call(t.element,t.currentItem)),t.currentItem.after(t.placeholder),r.placeholder.update(t,t.placeholder)},_contactContainers:function(t){var n,r,i,s,o,u,a,f,l,c=null,h=null;for(n=this.containers.length-1;n>=0;n--){if(e.contains(this.currentItem[0],this.containers[n].element[0]))continue;if(this._intersectsWith(this.containers[n].containerCache)){if(c&&e.contains(this.containers[n].element[0],c.element[0]))continue;c=this.containers[n],h=n}else this.containers[n].containerCache.over&&(this.containers[n]._trigger("out",t,this._uiHash(this)),this.containers[n].containerCache.over=0)}if(!c)return;if(this.containers.length===1)this.containers[h]._trigger("over",t,this._uiHash(this)),this.containers[h].containerCache.over=1;else{i=1e4,s=null,o=this.containers[h].floating?"left":"top",u=this.containers[h].floating?"width":"height",a=this.positionAbs[o]+this.offset.click[o];for(r=this.items.length-1;r>=0;r--){if(!e.contains(this.containers[h].element[0],this.items[r].item[0]))continue;if(this.items[r].item[0]===this.currentItem[0])continue;f=this.items[r].item.offset()[o],l=!1,Math.abs(f-a)>Math.abs(f+this.items[r][u]-a)&&(l=!0,f+=this.items[r][u]),Math.abs(f-a)<i&&(i=Math.abs(f-a),s=this.items[r],this.direction=l?"up":"down")}if(!s&&!this.options.dropOnEmpty)return;this.currentContainer=this.containers[h],s?this._rearrange(t,s,null,!0):this._rearrange(t,null,this.containers[h].element,!0),this._trigger("change",t,this._uiHash()),this.containers[h]._trigger("change",t,this._uiHash(this)),this.options.placeholder.update(this.currentContainer,this.placeholder),this.containers[h]._trigger("over",t,this._uiHash(this)),this.containers[h].containerCache.over=1}},_createHelper:function(t){var n=this.options,r=e.isFunction(n.helper)?e(n.helper.apply(this.element[0],[t,this.currentItem])):n.helper==="clone"?this.currentItem.clone():this.currentItem;return r.parents("body").length||e(n.appendTo!=="parent"?n.appendTo:this.currentItem[0].parentNode)[0].appendChild(r[0]),r[0]===this.currentItem[0]&&(this._storedCSS={width:this.currentItem[0].style.width,height:this.currentItem[0].style.height,position:this.currentItem.css("position"),top:this.currentItem.css("top"),left:this.currentItem.css("left")}),(!r[0].style.width||n.forceHelperSize)&&r.width(this.currentItem.width()),(!r[0].style.height||n.forceHelperSize)&&r.height(this.currentItem.height()),r},_adjustOffsetFromHelper:function(t){typeof t=="string"&&(t=t.split(" ")),e.isArray(t)&&(t={left:+t[0],top:+t[1]||0}),"left"in t&&(this.offset.click.left=t.left+this.margins.left),"right"in t&&(this.offset.click.left=this.helperProportions.width-t.right+this.margins.left),"top"in t&&(this.offset.click.top=t.top+this.margins.top),"bottom"in t&&(this.offset.click.top=this.helperProportions.height-t.bottom+this.margins.top)},_getParentOffset:function(){this.offsetParent=this.helper.offsetParent();var t=this.offsetParent.offset();this.cssPosition==="absolute"&&this.scrollParent[0]!==document&&e.contains(this.scrollParent[0],this.offsetParent[0])&&(t.left+=this.scrollParent.scrollLeft(),t.top+=this.scrollParent.scrollTop());if(this.offsetParent[0]===document.body||this.offsetParent[0].tagName&&this.offsetParent[0].tagName.toLowerCase()==="html"&&e.ui.ie)t={top:0,left:0};return{top:t.top+(parseInt(this.offsetParent.css("borderTopWidth"),10)||0),left:t.left+(parseInt(this.offsetParent.css("borderLeftWidth"),10)||0)}},_getRelativeOffset:function(){if(this.cssPosition==="relative"){var e=this.currentItem.position();return{top:e.top-(parseInt(this.helper.css("top"),10)||0)+this.scrollParent.scrollTop(),left:e.left-(parseInt(this.helper.css("left"),10)||0)+this.scrollParent.scrollLeft()}}return{top:0,left:0}},_cacheMargins:function(){this.margins={left:parseInt(this.currentItem.css("marginLeft"),10)||0,top:parseInt(this.currentItem.css("marginTop"),10)||0}},_cacheHelperProportions:function(){this.helperProportions={width:this.helper.outerWidth(),height:this.helper.outerHeight()}},_setContainment:function(){var t,n,r,i=this.options;i.containment==="parent"&&(i.containment=this.helper[0].parentNode);if(i.containment==="document"||i.containment==="window")this.containment=[0-this.offset.relative.left-this.offset.parent.left,0-this.offset.relative.top-this.offset.parent.top,e(i.containment==="document"?document:window).width()-this.helperProportions.width-this.margins.left,(e(i.containment==="document"?document:window).height()||document.body.parentNode.scrollHeight)-this.helperProportions.height-this.margins.top];/^(document|window|parent)$/.test(i.containment)||(t=e(i.containment)[0],n=e(i.containment).offset(),r=e(t).css("overflow")!=="hidden",this.containment=[n.left+(parseInt(e(t).css("borderLeftWidth"),10)||0)+(parseInt(e(t).css("paddingLeft"),10)||0)-this.margins.left,n.top+(parseInt(e(t).css("borderTopWidth"),10)||0)+(parseInt(e(t).css("paddingTop"),10)||0)-this.margins.top,n.left+(r?Math.max(t.scrollWidth,t.offsetWidth):t.offsetWidth)-(parseInt(e(t).css("borderLeftWidth"),10)||0)-(parseInt(e(t).css("paddingRight"),10)||0)-this.helperProportions.width-this.margins.left,n.top+(r?Math.max(t.scrollHeight,t.offsetHeight):t.offsetHeight)-(parseInt(e(t).css("borderTopWidth"),10)||0)-(parseInt(e(t).css("paddingBottom"),10)||0)-this.helperProportions.height-this.margins.top])},_convertPositionTo:function(t,n){n||(n=this.position);var r=t==="absolute"?1:-1,i=this.cssPosition!=="absolute"||this.scrollParent[0]!==document&&!!e.contains(this.scrollParent[0],this.offsetParent[0])?this.scrollParent:this.offsetParent,s=/(html|body)/i.test(i[0].tagName);return{top:n.top+this.offset.relative.top*r+this.offset.parent.top*r-(this.cssPosition==="fixed"?-this.scrollParent.scrollTop():s?0:i.scrollTop())*r,left:n.left+this.offset.relative.left*r+this.offset.parent.left*r-(this.cssPosition==="fixed"?-this.scrollParent.scrollLeft():s?0:i.scrollLeft())*r}},_generatePosition:function(t){var n,r,i=this.options,s=t.pageX,o=t.pageY,u=this.cssPosition!=="absolute"||this.scrollParent[0]!==document&&!!e.contains(this.scrollParent[0],this.offsetParent[0])?this.scrollParent:this.offsetParent,a=/(html|body)/i.test(u[0].tagName);return this.cssPosition==="relative"&&(this.scrollParent[0]===document||this.scrollParent[0]===this.offsetParent[0])&&(this.offset.relative=this._getRelativeOffset()),this.originalPosition&&(this.containment&&(t.pageX-this.offset.click.left<this.containment[0]&&(s=this.containment[0]+this.offset.click.left),t.pageY-this.offset.click.top<this.containment[1]&&(o=this.containment[1]+this.offset.click.top),t.pageX-this.offset.click.left>this.containment[2]&&(s=this.containment[2]+this.offset.click.left),t.pageY-this.offset.click.top>this.containment[3]&&(o=this.containment[3]+this.offset.click.top)),i.grid&&(n=this.originalPageY+Math.round((o-this.originalPageY)/i.grid[1])*i.grid[1],o=this.containment?n-this.offset.click.top>=this.containment[1]&&n-this.offset.click.top<=this.containment[3]?n:n-this.offset.click.top>=this.containment[1]?n-i.grid[1]:n+i.grid[1]:n,r=this.originalPageX+Math.round((s-this.originalPageX)/i.grid[0])*i.grid[0],s=this.containment?r-this.offset.click.left>=this.containment[0]&&r-this.offset.click.left<=this.containment[2]?r:r-this.offset.click.left>=this.containment[0]?r-i.grid[0]:r+i.grid[0]:r)),{top:o-this.offset.click.top-this.offset.relative.top-this.offset.parent.top+(this.cssPosition==="fixed"?-this.scrollParent.scrollTop():a?0:u.scrollTop()),left:s-this.offset.click.left-this.offset.relative.left-this.offset.parent.left+(this.cssPosition==="fixed"?-this.scrollParent.scrollLeft():a?0:u.scrollLeft())}},_rearrange:function(e,t,n,r){n?n[0].appendChild(this.placeholder[0]):t.item[0].parentNode.insertBefore(this.placeholder[0],this.direction==="down"?t.item[0]:t.item[0].nextSibling),this.counter=this.counter?++this.counter:1;var i=this.counter;this._delay(function(){i===this.counter&&this.refreshPositions(!r)})},_clear:function(t,n){this.reverting=!1;var r,i=[];!this._noFinalSort&&this.currentItem.parent().length&&this.placeholder.before(this.currentItem),this._noFinalSort=null;if(this.helper[0]===this.currentItem[0]){for(r in this._storedCSS)if(this._storedCSS[r]==="auto"||this._storedCSS[r]==="static")this._storedCSS[r]="";this.currentItem.css(this._storedCSS).removeClass("ui-sortable-helper")}else this.currentItem.show();this.fromOutside&&!n&&i.push(function(e){this._trigger("receive",e,this._uiHash(this.fromOutside))}),(this.fromOutside||this.domPosition.prev!==this.currentItem.prev().not(".ui-sortable-helper")[0]||this.domPosition.parent!==this.currentItem.parent()[0])&&!n&&i.push(function(e){this._trigger("update",e,this._uiHash())}),this!==this.currentContainer&&(n||(i.push(function(e){this._trigger("remove",e,this._uiHash())}),i.push(function(e){return function(t){e._trigger("receive",t,this._uiHash(this))}}.call(this,this.currentContainer)),i.push(function(e){return function(t){e._trigger("update",t,this._uiHash(this))}}.call(this,this.currentContainer))));for(r=this.containers.length-1;r>=0;r--)n||i.push(function(e){return function(t){e._trigger("deactivate",t,this._uiHash(this))}}.call(this,this.containers[r])),this.containers[r].containerCache.over&&(i.push(function(e){return function(t){e._trigger("out",t,this._uiHash(this))}}.call(this,this.containers[r])),this.containers[r].containerCache.over=0);this._storedCursor&&e("body").css("cursor",this._storedCursor),this._storedOpacity&&this.helper.css("opacity",this._storedOpacity),this._storedZIndex&&this.helper.css("zIndex",this._storedZIndex==="auto"?"":this._storedZIndex),this.dragging=!1;if(this.cancelHelperRemoval){if(!n){this._trigger("beforeStop",t,this._uiHash());for(r=0;r<i.length;r++)i[r].call(this,t);this._trigger("stop",t,this._uiHash())}return this.fromOutside=!1,!1}n||this._trigger("beforeStop",t,this._uiHash()),this.placeholder[0].parentNode.removeChild(this.placeholder[0]),this.helper[0]!==this.currentItem[0]&&this.helper.remove(),this.helper=null;if(!n){for(r=0;r<i.length;r++)i[r].call(this,t);this._trigger("stop",t,this._uiHash())}return this.fromOutside=!1,!0},_trigger:function(){e.Widget.prototype._trigger.apply(this,arguments)===!1&&this.cancel()},_uiHash:function(t){var n=t||this;return{helper:n.helper,placeholder:n.placeholder||e([]),position:n.position,originalPosition:n.originalPosition,offset:n.positionAbs,item:n.currentItem,sender:t?t.element:null}}})}(jQuery),jQuery.effects||function(e,t){var n="ui-effects-";e.effects={effect:{}},function(e,t){function h(e,t,n){var r=u[t.type]||{};return e==null?n||!t.def?null:t.def:(e=r.floor?~~e:parseFloat(e),isNaN(e)?t.def:r.mod?(e+r.mod)%r.mod:0>e?0:r.max<e?r.max:e)}function p(t){var n=s(),r=n._rgba=[];return t=t.toLowerCase(),c(i,function(e,i){var s,u=i.re.exec(t),a=u&&i.parse(u),f=i.space||"rgba";if(a)return s=n[f](a),n[o[f].cache]=s[o[f].cache],r=n._rgba=s._rgba,!1}),r.length?(r.join()==="0,0,0,0"&&e.extend(r,l.transparent),n):l[t]}function d(e,t,n){return n=(n+1)%1,n*6<1?e+(t-e)*n*6:n*2<1?t:n*3<2?e+(t-e)*(2/3-n)*6:e}var n="backgroundColor borderBottomColor borderLeftColor borderRightColor borderTopColor color columnRuleColor outlineColor textDecorationColor textEmphasisColor",r=/^([\-+])=\s*(\d+\.?\d*)/,i=[{re:/rgba?\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*(?:,\s*(\d?(?:\.\d+)?)\s*)?\)/,parse:function(e){return[e[1],e[2],e[3],e[4]]}},{re:/rgba?\(\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*(?:,\s*(\d?(?:\.\d+)?)\s*)?\)/,parse:function(e){return[e[1]*2.55,e[2]*2.55,e[3]*2.55,e[4]]}},{re:/#([a-f0-9]{2})([a-f0-9]{2})([a-f0-9]{2})/,parse:function(e){return[parseInt(e[1],16),parseInt(e[2],16),parseInt(e[3],16)]}},{re:/#([a-f0-9])([a-f0-9])([a-f0-9])/,parse:function(e){return[parseInt(e[1]+e[1],16),parseInt(e[2]+e[2],16),parseInt(e[3]+e[3],16)]}},{re:/hsla?\(\s*(\d+(?:\.\d+)?)\s*,\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*(?:,\s*(\d?(?:\.\d+)?)\s*)?\)/,space:"hsla",parse:function(e){return[e[1],e[2]/100,e[3]/100,e[4]]}}],s=e.Color=function(t,n,r,i){return new e.Color.fn.parse(t,n,r,i)},o={rgba:{props:{red:{idx:0,type:"byte"},green:{idx:1,type:"byte"},blue:{idx:2,type:"byte"}}},hsla:{props:{hue:{idx:0,type:"degrees"},saturation:{idx:1,type:"percent"},lightness:{idx:2,type:"percent"}}}},u={"byte":{floor:!0,max:255},percent:{max:1},degrees:{mod:360,floor:!0}},a=s.support={},f=e("<p>")[0],l,c=e.each;f.style.cssText="background-color:rgba(1,1,1,.5)",a.rgba=f.style.backgroundColor.indexOf("rgba")>-1,c(o,function(e,t){t.cache="_"+e,t.props.alpha={idx:3,type:"percent",def:1}}),s.fn=e.extend(s.prototype,{parse:function(n,r,i,u){if(n===t)return this._rgba=[null,null,null,null],this;if(n.jquery||n.nodeType)n=e(n).css(r),r=t;var a=this,f=e.type(n),d=this._rgba=[];r!==t&&(n=[n,r,i,u],f="array");if(f==="string")return this.parse(p(n)||l._default);if(f==="array")return c(o.rgba.props,function(e,t){d[t.idx]=h(n[t.idx],t)}),this;if(f==="object")return n instanceof s?c(o,function(e,t){n[t.cache]&&(a[t.cache]=n[t.cache].slice())}):c(o,function(t,r){var i=r.cache;c(r.props,function(e,t){if(!a[i]&&r.to){if(e==="alpha"||n[e]==null)return;a[i]=r.to(a._rgba)}a[i][t.idx]=h(n[e],t,!0)}),a[i]&&e.inArray(null,a[i].slice(0,3))<0&&(a[i][3]=1,r.from&&(a._rgba=r.from(a[i])))}),this},is:function(e){var t=s(e),n=!0,r=this;return c(o,function(e,i){var s,o=t[i.cache];return o&&(s=r[i.cache]||i.to&&i.to(r._rgba)||[],c(i.props,function(e,t){if(o[t.idx]!=null)return n=o[t.idx]===s[t.idx],n})),n}),n},_space:function(){var e=[],t=this;return c(o,function(n,r){t[r.cache]&&e.push(n)}),e.pop()},transition:function(e,t){var n=s(e),r=n._space(),i=o[r],a=this.alpha()===0?s("transparent"):this,f=a[i.cache]||i.to(a._rgba),l=f.slice();return n=n[i.cache],c(i.props,function(e,r){var i=r.idx,s=f[i],o=n[i],a=u[r.type]||{};if(o===null)return;s===null?l[i]=o:(a.mod&&(o-s>a.mod/2?s+=a.mod:s-o>a.mod/2&&(s-=a.mod)),l[i]=h((o-s)*t+s,r))}),this[r](l)},blend:function(t){if(this._rgba[3]===1)return this;var n=this._rgba.slice(),r=n.pop(),i=s(t)._rgba;return s(e.map(n,function(e,t){return(1-r)*i[t]+r*e}))},toRgbaString:function(){var t="rgba(",n=e.map(this._rgba,function(e,t){return e==null?t>2?1:0:e});return n[3]===1&&(n.pop(),t="rgb("),t+n.join()+")"},toHslaString:function(){var t="hsla(",n=e.map(this.hsla(),function(e,t){return e==null&&(e=t>2?1:0),t&&t<3&&(e=Math.round(e*100)+"%"),e});return n[3]===1&&(n.pop(),t="hsl("),t+n.join()+")"},toHexString:function(t){var n=this._rgba.slice(),r=n.pop();return t&&n.push(~~(r*255)),"#"+e.map(n,function(e){return e=(e||0).toString(16),e.length===1?"0"+e:e}).join("")},toString:function(){return this._rgba[3]===0?"transparent":this.toRgbaString()}}),s.fn.parse.prototype=s.fn,o.hsla.to=function(e){if(e[0]==null||e[1]==null||e[2]==null)return[null,null,null,e[3]];var t=e[0]/255,n=e[1]/255,r=e[2]/255,i=e[3],s=Math.max(t,n,r),o=Math.min(t,n,r),u=s-o,a=s+o,f=a*.5,l,c;return o===s?l=0:t===s?l=60*(n-r)/u+360:n===s?l=60*(r-t)/u+120:l=60*(t-n)/u+240,u===0?c=0:f<=.5?c=u/a:c=u/(2-a),[Math.round(l)%360,c,f,i==null?1:i]},o.hsla.from=function(e){if(e[0]==null||e[1]==null||e[2]==null)return[null,null,null,e[3]];var t=e[0]/360,n=e[1],r=e[2],i=e[3],s=r<=.5?r*(1+n):r+n-r*n,o=2*r-s;return[Math.round(d(o,s,t+1/3)*255),Math.round(d(o,s,t)*255),Math.round(d(o,s,t-1/3)*255),i]},c(o,function(n,i){var o=i.props,u=i.cache,a=i.to,f=i.from;s.fn[n]=function(n){a&&!this[u]&&(this[u]=a(this._rgba));if(n===t)return this[u].slice();var r,i=e.type(n),l=i==="array"||i==="object"?n:arguments,p=this[u].slice();return c(o,function(e,t){var n=l[i==="object"?e:t.idx];n==null&&(n=p[t.idx]),p[t.idx]=h(n,t)}),f?(r=s(f(p)),r[u]=p,r):s(p)},c(o,function(t,i){if(s.fn[t])return;s.fn[t]=function(s){var o=e.type(s),u=t==="alpha"?this._hsla?"hsla":"rgba":n,a=this[u](),f=a[i.idx],l;return o==="undefined"?f:(o==="function"&&(s=s.call(this,f),o=e.type(s)),s==null&&i.empty?this:(o==="string"&&(l=r.exec(s),l&&(s=f+parseFloat(l[2])*(l[1]==="+"?1:-1))),a[i.idx]=s,this[u](a)))}})}),s.hook=function(t){var n=t.split(" ");c(n,function(t,n){e.cssHooks[n]={set:function(t,r){var i,o,u="";if(r!=="transparent"&&(e.type(r)!=="string"||(i=p(r)))){r=s(i||r);if(!a.rgba&&r._rgba[3]!==1){o=n==="backgroundColor"?t.parentNode:t;while((u===""||u==="transparent")&&o&&o.style)try{u=e.css(o,"backgroundColor"),o=o.parentNode}catch(f){}r=r.blend(u&&u!=="transparent"?u:"_default")}r=r.toRgbaString()}try{t.style[n]=r}catch(f){}}},e.fx.step[n]=function(t){t.colorInit||(t.start=s(t.elem,n),t.end=s(t.end),t.colorInit=!0),e.cssHooks[n].set(t.elem,t.start.transition(t.end,t.pos))}})},s.hook(n),e.cssHooks.borderColor={expand:function(e){var t={};return c(["Top","Right","Bottom","Left"],function(n,r){t["border"+r+"Color"]=e}),t}},l=e.Color.names={aqua:"#00ffff",black:"#000000",blue:"#0000ff",fuchsia:"#ff00ff",gray:"#808080",green:"#008000",lime:"#00ff00",maroon:"#800000",navy:"#000080",olive:"#808000",purple:"#800080",red:"#ff0000",silver:"#c0c0c0",teal:"#008080",white:"#ffffff",yellow:"#ffff00",transparent:[null,null,null,0],_default:"#ffffff"}}(jQuery),function(){function i(t){var n,r,i=t.ownerDocument.defaultView?t.ownerDocument.defaultView.getComputedStyle(t,null):t.currentStyle,s={};if(i&&i.length&&i[0]&&i[i[0]]){r=i.length;while(r--)n=i[r],typeof i[n]=="string"&&(s[e.camelCase(n)]=i[n])}else for(n in i)typeof i[n]=="string"&&(s[n]=i[n]);return s}function s(t,n){var i={},s,o;for(s in n)o=n[s],t[s]!==o&&!r[s]&&(e.fx.step[s]||!isNaN(parseFloat(o)))&&(i[s]=o);return i}var n=["add","remove","toggle"],r={border:1,borderBottom:1,borderColor:1,borderLeft:1,borderRight:1,borderTop:1,borderWidth:1,margin:1,padding:1};e.each(["borderLeftStyle","borderRightStyle","borderBottomStyle","borderTopStyle"],function(t,n){e.fx.step[n]=function(e){if(e.end!=="none"&&!e.setAttr||e.pos===1&&!e.setAttr)jQuery.style(e.elem,n,e.end),e.setAttr=!0}}),e.fn.addBack||(e.fn.addBack=function(e){return this.add(e==null?this.prevObject:this.prevObject.filter(e))}),e.effects.animateClass=function(t,r,o,u){var a=e.speed(r,o,u);return this.queue(function(){var r=e(this),o=r.attr("class")||"",u,f=a.children?r.find("*").addBack():r;f=f.map(function(){var t=e(this);return{el:t,start:i(this)}}),u=function(){e.each(n,function(e,n){t[n]&&r[n+"Class"](t[n])})},u(),f=f.map(function(){return this.end=i(this.el[0]),this.diff=s(this.start,this.end),this}),r.attr("class",o),f=f.map(function(){var t=this,n=e.Deferred(),r=e.extend({},a,{queue:!1,complete:function(){n.resolve(t)}});return this.el.animate(this.diff,r),n.promise()}),e.when.apply(e,f.get()).done(function(){u(),e.each(arguments,function(){var t=this.el;e.each(this.diff,function(e){t.css(e,"")})}),a.complete.call(r[0])})})},e.fn.extend({_addClass:e.fn.addClass,addClass:function(t,n,r,i){return n?e.effects.animateClass.call(this,{add:t},n,r,i):this._addClass(t)},_removeClass:e.fn.removeClass,removeClass:function(t,n,r,i){return arguments.length>1?e.effects.animateClass.call(this,{remove:t},n,r,i):this._removeClass.apply(this,arguments)},_toggleClass:e.fn.toggleClass,toggleClass:function(n,r,i,s,o){return typeof r=="boolean"||r===t?i?e.effects.animateClass.call(this,r?{add:n}:{remove:n},i,s,o):this._toggleClass(n,r):e.effects.animateClass.call(this,{toggle:n},r,i,s)},switchClass:function(t,n,r,i,s){return e.effects.animateClass.call(this,{add:n,remove:t},r,i,s)}})}(),function(){function r(t,n,r,i){e.isPlainObject(t)&&(n=t,t=t.effect),t={effect:t},n==null&&(n={}),e.isFunction(n)&&(i=n,r=null,n={});if(typeof n=="number"||e.fx.speeds[n])i=r,r=n,n={};return e.isFunction(r)&&(i=r,r=null),n&&e.extend(t,n),r=r||n.duration,t.duration=e.fx.off?0:typeof r=="number"?r:r in e.fx.speeds?e.fx.speeds[r]:e.fx.speeds._default,t.complete=i||n.complete,t}function i(t){return!t||typeof t=="number"||e.fx.speeds[t]?!0:typeof t=="string"&&!e.effects.effect[t]}e.extend(e.effects,{version:"1.10.1",save:function(e,t){for(var r=0;r<t.length;r++)t[r]!==null&&e.data(n+t[r],e[0].style[t[r]])},restore:function(e,r){var i,s;for(s=0;s<r.length;s++)r[s]!==null&&(i=e.data(n+r[s]),i===t&&(i=""),e.css(r[s],i))},setMode:function(e,t){return t==="toggle"&&(t=e.is(":hidden")?"show":"hide"),t},getBaseline:function(e,t){var n,r;switch(e[0]){case"top":n=0;break;case"middle":n=.5;break;case"bottom":n=1;break;default:n=e[0]/t.height}switch(e[1]){case"left":r=0;break;case"center":r=.5;break;case"right":r=1;break;default:r=e[1]/t.width}return{x:r,y:n}},createWrapper:function(t){if(t.parent().is(".ui-effects-wrapper"))return t.parent();var n={width:t.outerWidth(!0),height:t.outerHeight(!0),"float":t.css("float")},r=e("<div></div>").addClass("ui-effects-wrapper").css({fontSize:"100%",background:"transparent",border:"none",margin:0,padding:0}),i={width:t.width(),height:t.height()},s=document.activeElement;try{s.id}catch(o){s=document.body}return t.wrap(r),(t[0]===s||e.contains(t[0],s))&&e(s).focus(),r=t.parent(),t.css("position")==="static"?(r.css({position:"relative"}),t.css({position:"relative"})):(e.extend(n,{position:t.css("position"),zIndex:t.css("z-index")}),e.each(["top","left","bottom","right"],function(e,r){n[r]=t.css(r),isNaN(parseInt(n[r],10))&&(n[r]="auto")}),t.css({position:"relative",top:0,left:0,right:"auto",bottom:"auto"})),t.css(i),r.css(n).show()},removeWrapper:function(t){var n=document.activeElement;return t.parent().is(".ui-effects-wrapper")&&(t.parent().replaceWith(t),(t[0]===n||e.contains(t[0],n))&&e(n).focus()),t},setTransition:function(t,n,r,i){return i=i||{},e.each(n,function(e,n){var s=t.cssUnit(n);s[0]>0&&(i[n]=s[0]*r+s[1])}),i}}),e.fn.extend({effect:function(){function o(n){function u(){e.isFunction(i)&&i.call(r[0]),e.isFunction(n)&&n()}var r=e(this),i=t.complete,o=t.mode;(r.is(":hidden")?o==="hide":o==="show")?u():s.call(r[0],t,u)}var t=r.apply(this,arguments),n=t.mode,i=t.queue,s=e.effects.effect[t.effect];return e.fx.off||!s?n?this[n](t.duration,t.complete):this.each(function(){t.complete&&t.complete.call(this)}):i===!1?this.each(o):this.queue(i||"fx",o)},_show:e.fn.show,show:function(e){if(i(e))return this._show.apply(this,arguments);var t=r.apply(this,arguments);return t.mode="show",this.effect.call(this,t)},_hide:e.fn.hide,hide:function(e){if(i(e))return this._hide.apply(this,arguments);var t=r.apply(this,arguments);return t.mode="hide",this.effect.call(this,t)},__toggle:e.fn.toggle,toggle:function(t){if(i(t)||typeof t=="boolean"||e.isFunction(t))return this.__toggle.apply(this,arguments);var n=r.apply(this,arguments);return n.mode="toggle",this.effect.call(this,n)},cssUnit:function(t){var n=this.css(t),r=[];return e.each(["em","px","%","pt"],function(e,t){n.indexOf(t)>0&&(r=[parseFloat(n),t])}),r}})}(),function(){var t={};e.each(["Quad","Cubic","Quart","Quint","Expo"],function(e,n){t[n]=function(t){return Math.pow(t,e+2)}}),e.extend(t,{Sine:function(e){return 1-Math.cos(e*Math.PI/2)},Circ:function(e){return 1-Math.sqrt(1-e*e)},Elastic:function(e){return e===0||e===1?e:-Math.pow(2,8*(e-1))*Math.sin(((e-1)*80-7.5)*Math.PI/15)},Back:function(e){return e*e*(3*e-2)},Bounce:function(e){var t,n=4;while(e<((t=Math.pow(2,--n))-1)/11);return 1/Math.pow(4,3-n)-7.5625*Math.pow((t*3-2)/22-e,2)}}),e.each(t,function(t,n){e.easing["easeIn"+t]=n,e.easing["easeOut"+t]=function(e){return 1-n(1-e)},e.easing["easeInOut"+t]=function(e){return e<.5?n(e*2)/2:1-n(e*-2+2)/2}})}()}(jQuery),function(e,t){var n=0,r={},i={};r.height=r.paddingTop=r.paddingBottom=r.borderTopWidth=r.borderBottomWidth="hide",i.height=i.paddingTop=i.paddingBottom=i.borderTopWidth=i.borderBottomWidth="show",e.widget("ui.accordion",{version:"1.10.1",options:{active:0,animate:{},collapsible:!1,event:"click",header:"> li > :first-child,> :not(li):even",heightStyle:"auto",icons:{activeHeader:"ui-icon-triangle-1-s",header:"ui-icon-triangle-1-e"},activate:null,beforeActivate:null},_create:function(){var t=this.options;this.prevShow=this.prevHide=e(),this.element.addClass("ui-accordion ui-widget ui-helper-reset").attr("role","tablist"),!t.collapsible&&(t.active===!1||t.active==null)&&(t.active=0),this._processPanels(),t.active<0&&(t.active+=this.headers.length),this._refresh()},_getCreateEventData:function(){return{header:this.active,panel:this.active.length?this.active.next():e(),content:this.active.length?this.active.next():e()}},_createIcons:function(){var t=this.options.icons;t&&(e("<span>").addClass("ui-accordion-header-icon ui-icon "+t.header).prependTo(this.headers),this.active.children(".ui-accordion-header-icon").removeClass(t.header).addClass(t.activeHeader),this.headers.addClass("ui-accordion-icons"))},_destroyIcons:function(){this.headers.removeClass("ui-accordion-icons").children(".ui-accordion-header-icon").remove()},_destroy:function(){var e;this.element.removeClass("ui-accordion ui-widget ui-helper-reset").removeAttr("role"),this.headers.removeClass("ui-accordion-header ui-accordion-header-active ui-helper-reset ui-state-default ui-corner-all ui-state-active ui-state-disabled ui-corner-top").removeAttr("role").removeAttr("aria-selected").removeAttr("aria-controls").removeAttr("tabIndex").each(function(){/^ui-accordion/.test(this.id)&&this.removeAttribute("id")}),this._destroyIcons(),e=this.headers.next().css("display","").removeAttr("role").removeAttr("aria-expanded").removeAttr("aria-hidden").removeAttr("aria-labelledby").removeClass("ui-helper-reset ui-widget-content ui-corner-bottom ui-accordion-content ui-accordion-content-active ui-state-disabled").each(function(){/^ui-accordion/.test(this.id)&&this.removeAttribute("id")}),this.options.heightStyle!=="content"&&e.css("height","")},_setOption:function(e,t){if(e==="active"){this._activate(t);return}e==="event"&&(this.options.event&&this._off(this.headers,this.options.event),this._setupEvents(t)),this._super(e,t),e==="collapsible"&&!t&&this.options.active===!1&&this._activate(0),e==="icons"&&(this._destroyIcons(),t&&this._createIcons()),e==="disabled"&&this.headers.add(this.headers.next()).toggleClass("ui-state-disabled",!!t)},_keydown:function(t){if(t.altKey||t.ctrlKey)return;var n=e.ui.keyCode,r=this.headers.length,i=this.headers.index(t.target),s=!1;switch(t.keyCode){case n.RIGHT:case n.DOWN:s=this.headers[(i+1)%r];break;case n.LEFT:case n.UP:s=this.headers[(i-1+r)%r];break;case n.SPACE:case n.ENTER:this._eventHandler(t);break;case n.HOME:s=this.headers[0];break;case n.END:s=this.headers[r-1]}s&&(e(t.target).attr("tabIndex",-1),e(s).attr("tabIndex",0),s.focus(),t.preventDefault())},_panelKeyDown:function(t){t.keyCode===e.ui.keyCode.UP&&t.ctrlKey&&e(t.currentTarget).prev().focus()},refresh:function(){var t=this.options;this._processPanels();if(t.active===!1&&t.collapsible===!0||!this.headers.length)t.active=!1,this.active=e();t.active===!1?this._activate(0):this.active.length&&!e.contains(this.element[0],this.active[0])?this.headers.length===this.headers.find(".ui-state-disabled").length?(t.active=!1,this.active=e()):this._activate(Math.max(0,t.active-1)):t.active=this.headers.index(this.active),this._destroyIcons(),this._refresh()},_processPanels:function(){this.headers=this.element.find(this.options.header).addClass("ui-accordion-header ui-helper-reset ui-state-default ui-corner-all"),this.headers.next().addClass("ui-accordion-content ui-helper-reset ui-widget-content ui-corner-bottom").filter(":not(.ui-accordion-content-active)").hide()},_refresh:function(){var t,r=this.options,i=r.heightStyle,s=this.element.parent(),o=this.accordionId="ui-accordion-"+(this.element.attr("id")||++n);this.active=this._findActive(r.active).addClass("ui-accordion-header-active ui-state-active ui-corner-top").removeClass("ui-corner-all"),this.active.next().addClass("ui-accordion-content-active").show(),this.headers.attr("role","tab").each(function(t){var n=e(this),r=n.attr("id"),i=n.next(),s=i.attr("id");r||(r=o+"-header-"+t,n.attr("id",r)),s||(s=o+"-panel-"+t,i.attr("id",s)),n.attr("aria-controls",s),i.attr("aria-labelledby",r)}).next().attr("role","tabpanel"),this.headers.not(this.active).attr({"aria-selected":"false",tabIndex:-1}).next().attr({"aria-expanded":"false","aria-hidden":"true"}).hide(),this.active.length?this.active.attr({"aria-selected":"true",tabIndex:0}).next().attr({"aria-expanded":"true","aria-hidden":"false"}):this.headers.eq(0).attr("tabIndex",0),this._createIcons(),this._setupEvents(r.event),i==="fill"?(t=s.height(),this.element.siblings(":visible").each(function(){var n=e(this),r=n.css("position");if(r==="absolute"||r==="fixed")return;t-=n.outerHeight(!0)}),this.headers.each(function(){t-=e(this).outerHeight(!0)}),this.headers.next().each(function(){e(this).height(Math.max(0,t-e(this).innerHeight()+e(this).height()))}).css("overflow","auto")):i==="auto"&&(t=0,this.headers.next().each(function(){t=Math.max(t,e(this).css("height","").height())}).height(t))},_activate:function(t){var n=this._findActive(t)[0];if(n===this.active[0])return;n=n||this.active[0],this._eventHandler({target:n,currentTarget:n,preventDefault:e.noop})},_findActive:function(t){return typeof t=="number"?this.headers.eq(t):e()},_setupEvents:function(t){var n={keydown:"_keydown"};t&&e.each(t.split(" "),function(e,t){n[t]="_eventHandler"}),this._off(this.headers.add(this.headers.next())),this._on(this.headers,n),this._on(this.headers.next(),{keydown:"_panelKeyDown"}),this._hoverable(this.headers),this._focusable(this.headers)},_eventHandler:function(t){var n=this.options,r=this.active,i=e(t.currentTarget),s=i[0]===r[0],o=s&&n.collapsible,u=o?e():i.next(),a=r.next(),f={oldHeader:r,oldPanel:a,newHeader:o?e():i,newPanel:u};t.preventDefault();if(s&&!n.collapsible||this._trigger("beforeActivate",t,f)===!1)return;n.active=o?!1:this.headers.index(i),this.active=s?e():i,this._toggle(f),r.removeClass("ui-accordion-header-active ui-state-active"),n.icons&&r.children(".ui-accordion-header-icon").removeClass(n.icons.activeHeader).addClass(n.icons.header),s||(i.removeClass("ui-corner-all").addClass("ui-accordion-header-active ui-state-active ui-corner-top"),n.icons&&i.children(".ui-accordion-header-icon").removeClass(n.icons.header).addClass(n.icons.activeHeader),i.next().addClass("ui-accordion-content-active"))},_toggle:function(t){var n=t.newPanel,r=this.prevShow.length?this.prevShow:t.oldPanel;this.prevShow.add(this.prevHide).stop(!0,!0),this.prevShow=n,this.prevHide=r,this.options.animate?this._animate(n,r,t):(r.hide(),n.show(),this._toggleComplete(t)),r.attr({"aria-expanded":"false","aria-hidden":"true"}),r.prev().attr("aria-selected","false"),n.length&&r.length?r.prev().attr("tabIndex",-1):n.length&&this.headers.filter(function(){return e(this).attr("tabIndex")===0}).attr("tabIndex",-1),n.attr({"aria-expanded":"true","aria-hidden":"false"}).prev().attr({"aria-selected":"true",tabIndex:0})},_animate:function(e,t,n){var s,o,u,a=this,f=0,l=e.length&&(!t.length||e.index()<t.index()),c=this.options.animate||{},h=l&&c.down||c,p=function(){a._toggleComplete(n)};typeof h=="number"&&(u=h),typeof h=="string"&&(o=h),o=o||h.easing||c.easing,u=u||h.duration||c.duration;if(!t.length)return e.animate(i,u,o,p);if(!e.length)return t.animate(r,u,o,p);s=e.show().outerHeight(),t.animate(r,{duration:u,easing:o,step:function(e,t){t.now=Math.round(e)}}),e.hide().animate(i,{duration:u,easing:o,complete:p,step:function(e,n){n.now=Math.round(e),n.prop!=="height"?f+=n.now:a.options.heightStyle!=="content"&&(n.now=Math.round(s-t.outerHeight()-f),f=0)}})},_toggleComplete:function(e){var t=e.oldPanel;t.removeClass("ui-accordion-content-active").prev().removeClass("ui-corner-top").addClass("ui-corner-all"),t.length&&(t.parent()[0].className=t.parent()[0].className),this._trigger("activate",null,e)}})}(jQuery),function(e,t){var n=0;e.widget("ui.autocomplete",{version:"1.10.1",defaultElement:"<input>",options:{appendTo:null,autoFocus:!1,delay:300,minLength:1,position:{my:"left top",at:"left bottom",collision:"none"},source:null,change:null,close:null,focus:null,open:null,response:null,search:null,select:null},pending:0,_create:function(){var t,n,r,i=this.element[0].nodeName.toLowerCase(),s=i==="textarea",o=i==="input";this.isMultiLine=s?!0:o?!1:this.element.prop("isContentEditable"),this.valueMethod=this.element[s||o?"val":"text"],this.isNewMenu=!0,this.element.addClass("ui-autocomplete-input").attr("autocomplete","off"),this._on(this.element,{keydown:function(i){if(this.element.prop("readOnly")){t=!0,r=!0,n=!0;return}t=!1,r=!1,n=!1;var s=e.ui.keyCode;switch(i.keyCode){case s.PAGE_UP:t=!0,this._move("previousPage",i);break;case s.PAGE_DOWN:t=!0,this._move("nextPage",i);break;case s.UP:t=!0,this._keyEvent("previous",i);break;case s.DOWN:t=!0,this._keyEvent("next",i);break;case s.ENTER:case s.NUMPAD_ENTER:this.menu.active&&(t=!0,i.preventDefault(),this.menu.select(i));break;case s.TAB:this.menu.active&&this.menu.select(i);break;case s.ESCAPE:this.menu.element.is(":visible")&&(this._value(this.term),this.close(i),i.preventDefault());break;default:n=!0,this._searchTimeout(i)}},keypress:function(r){if(t){t=!1,r.preventDefault();return}if(n)return;var i=e.ui.keyCode;switch(r.keyCode){case i.PAGE_UP:this._move("previousPage",r);break;case i.PAGE_DOWN:this._move("nextPage",r);break;case i.UP:this._keyEvent("previous",r);break;case i.DOWN:this._keyEvent("next",r)}},input:function(e){if(r){r=!1,e.preventDefault();return}this._searchTimeout(e)},focus:function(){this.selectedItem=null,this.previous=this._value()},blur:function(e){if(this.cancelBlur){delete this.cancelBlur;return}clearTimeout(this.searching),this.close(e),this._change(e)}}),this._initSource(),this.menu=e("<ul>").addClass("ui-autocomplete ui-front").appendTo(this._appendTo()).menu({input:e(),role:null}).hide().data("ui-menu"),this._on(this.menu.element,{mousedown:function(t){t.preventDefault(),this.cancelBlur=!0,this._delay(function(){delete this.cancelBlur});var n=this.menu.element[0];e(t.target).closest(".ui-menu-item").length||this._delay(function(){var t=this;this.document.one("mousedown",function(r){r.target!==t.element[0]&&r.target!==n&&!e.contains(n,r.target)&&t.close()})})},menufocus:function(t,n){if(this.isNewMenu){this.isNewMenu=!1;if(t.originalEvent&&/^mouse/.test(t.originalEvent.type)){this.menu.blur(),this.document.one("mousemove",function(){e(t.target).trigger(t.originalEvent)});return}}var r=n.item.data("ui-autocomplete-item");!1!==this._trigger("focus",t,{item:r})?t.originalEvent&&/^key/.test(t.originalEvent.type)&&this._value(r.value):this.liveRegion.text(r.value)},menuselect:function(e,t){var n=t.item.data("ui-autocomplete-item"),r=this.previous;this.element[0]!==this.document[0].activeElement&&(this.element.focus(),this.previous=r,this._delay(function(){this.previous=r,this.selectedItem=n})),!1!==this._trigger("select",e,{item:n})&&this._value(n.value),this.term=this._value(),this.close(e),this.selectedItem=n}}),this.liveRegion=e("<span>",{role:"status","aria-live":"polite"}).addClass("ui-helper-hidden-accessible").insertAfter(this.element),this._on(this.window,{beforeunload:function(){this.element.removeAttr("autocomplete")}})},_destroy:function(){clearTimeout(this.searching),this.element.removeClass("ui-autocomplete-input").removeAttr("autocomplete"),this.menu.element.remove(),this.liveRegion.remove()},_setOption:function(e,t){this._super(e,t),e==="source"&&this._initSource(),e==="appendTo"&&this.menu.element.appendTo(this._appendTo()),e==="disabled"&&t&&this.xhr&&this.xhr.abort()},_appendTo:function(){var t=this.options.appendTo;return t&&(t=t.jquery||t.nodeType?e(t):this.document.find(t).eq(0)),t||(t=this.element.closest(".ui-front")),t.length||(t=this.document[0].body),t},_initSource:function(){var t,n,r=this;e.isArray(this.options.source)?(t=this.options.source,this.source=function(n,r){r(e.ui.autocomplete.filter(t,n.term))}):typeof this.options.source=="string"?(n=this.options.source,this.source=function(t,i){r.xhr&&r.xhr.abort(),r.xhr=e.ajax({url:n,data:t,dataType:"json",success:function(e){i(e)},error:function(){i([])}})}):this.source=this.options.source},_searchTimeout:function(e){clearTimeout(this.searching),this.searching=this._delay(function(){this.term!==this._value()&&(this.selectedItem=null,this.search(null,e))},this.options.delay)},search:function(e,t){e=e!=null?e:this._value(),this.term=this._value();if(e.length<this.options.minLength)return this.close(t);if(this._trigger("search",t)===!1)return;return this._search(e)},_search:function(e){this.pending++,this.element.addClass("ui-autocomplete-loading"),this.cancelSearch=!1,this.source({term:e},this._response())},_response:function(){var e=this,t=++n;return function(r){t===n&&e.__response(r),e.pending--,e.pending||e.element.removeClass("ui-autocomplete-loading")}},__response:function(e){e&&(e=this._normalize(e)),this._trigger("response",null,{content:e}),!this.options.disabled&&e&&e.length&&!this.cancelSearch?(this._suggest(e),this._trigger("open")):this._close()},close:function(e){this.cancelSearch=!0,this._close(e)},_close:function(e){this.menu.element.is(":visible")&&(this.menu.element.hide(),this.menu.blur(),this.isNewMenu=!0,this._trigger("close",e))},_change:function(e){this.previous!==this._value()&&this._trigger("change",e,{item:this.selectedItem})},_normalize:function(t){return t.length&&t[0].label&&t[0].value?t:e.map(t,function(t){return typeof t=="string"?{label:t,value:t}:e.extend({label:t.label||t.value,value:t.value||t.label},t)})},_suggest:function(t){var n=this.menu.element.empty();this._renderMenu(n,t),this.menu.refresh(),n.show(),this._resizeMenu(),n.position(e.extend({of:this.element},this.options.position)),this.options.autoFocus&&this.menu.next()},_resizeMenu:function(){var e=this.menu.element;e.outerWidth(Math.max(e.width("").outerWidth()+1,this.element.outerWidth()))},_renderMenu:function(t,n){var r=this;e.each(n,function(e,n){r._renderItemData(t,n)})},_renderItemData:function(e,t){return this._renderItem(e,t).data("ui-autocomplete-item",t)},_renderItem:function(t,n){return e("<li>").append(e("<a>").text(n.label)).appendTo(t)},_move:function(e,t){if(!this.menu.element.is(":visible")){this.search(null,t);return}if(this.menu.isFirstItem()&&/^previous/.test(e)||this.menu.isLastItem()&&/^next/.test(e)){this._value(this.term),this.menu.blur();return}this.menu[e](t)},widget:function(){return this.menu.element},_value:function(){return this.valueMethod.apply(this.element,arguments)},_keyEvent:function(e,t){if(!this.isMultiLine||this.menu.element.is(":visible"))this._move(e,t),t.preventDefault()}}),e.extend(e.ui.autocomplete,{escapeRegex:function(e){return e.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g,"\\$&")},filter:function(t,n){var r=new RegExp(e.ui.autocomplete.escapeRegex(n),"i");return e.grep(t,function(e){return r.test(e.label||e.value||e)})}}),e.widget("ui.autocomplete",e.ui.autocomplete,{options:{messages:{noResults:"No search results.",results:function(e){return e+(e>1?" results are":" result is")+" available, use up and down arrow keys to navigate."}}},__response:function(e){var t;this._superApply(arguments);if(this.options.disabled||this.cancelSearch)return;e&&e.length?t=this.options.messages.results(e.length):t=this.options.messages.noResults,this.liveRegion.text(t)}})}(jQuery),function(e,t){var n,r,i,s,o="ui-button ui-widget ui-state-default ui-corner-all",u="ui-state-hover ui-state-active ",a="ui-button-icons-only ui-button-icon-only ui-button-text-icons ui-button-text-icon-primary ui-button-text-icon-secondary ui-button-text-only",f=function(){var t=e(this).find(":ui-button");setTimeout(function(){t.button("refresh")},1)},l=function(t){var n=t.name,r=t.form,i=e([]);return n&&(n=n.replace(/'/g,"\\'"),r?i=e(r).find("[name='"+n+"']"):i=e("[name='"+n+"']",t.ownerDocument).filter(function(){return!this.form})),i};e.widget("ui.button",{version:"1.10.1",defaultElement:"<button>",options:{disabled:null,text:!0,label:null,icons:{primary:null,secondary:null}},_create:function(){this.element.closest("form").unbind("reset"+this.eventNamespace).bind("reset"+this.eventNamespace,f),typeof this.options.disabled!="boolean"?this.options.disabled=!!this.element.prop("disabled"):this.element.prop("disabled",this.options.disabled),this._determineButtonType(),this.hasTitle=!!this.buttonElement.attr("title");var t=this,u=this.options,a=this.type==="checkbox"||this.type==="radio",c=a?"":"ui-state-active",h="ui-state-focus";u.label===null&&(u.label=this.type==="input"?this.buttonElement.val():this.buttonElement.html()),this._hoverable(this.buttonElement),this.buttonElement.addClass(o).attr("role","button").bind("mouseenter"+this.eventNamespace,function(){if(u.disabled)return;this===n&&e(this).addClass("ui-state-active")}).bind("mouseleave"+this.eventNamespace,function(){if(u.disabled)return;e(this).removeClass(c)}).bind("click"+this.eventNamespace,function(e){u.disabled&&(e.preventDefault(),e.stopImmediatePropagation())}),this.element.bind("focus"+this.eventNamespace,function(){t.buttonElement.addClass(h)}).bind("blur"+this.eventNamespace,function(){t.buttonElement.removeClass(h)}),a&&(this.element.bind("change"+this.eventNamespace,function(){if(s)return;t.refresh()}),this.buttonElement.bind("mousedown"+this.eventNamespace,function(e){if(u.disabled)return;s=!1,r=e.pageX,i=e.pageY}).bind("mouseup"+this.eventNamespace,function(e){if(u.disabled)return;if(r!==e.pageX||i!==e.pageY)s=!0})),this.type==="checkbox"?this.buttonElement.bind("click"+this.eventNamespace,function(){if(u.disabled||s)return!1}):this.type==="radio"?this.buttonElement.bind("click"+this.eventNamespace,function(){if(u.disabled||s)return!1;e(this).addClass("ui-state-active"),t.buttonElement.attr("aria-pressed","true");var n=t.element[0];l(n).not(n).map(function(){return e(this).button("widget")[0]}).removeClass("ui-state-active").attr("aria-pressed","false")}):(this.buttonElement.bind("mousedown"+this.eventNamespace,function(){if(u.disabled)return!1;e(this).addClass("ui-state-active"),n=this,t.document.one("mouseup",function(){n=null})}).bind("mouseup"+this.eventNamespace,function(){if(u.disabled)return!1;e(this).removeClass("ui-state-active")}).bind("keydown"+this.eventNamespace,function(t){if(u.disabled)return!1;(t.keyCode===e.ui.keyCode.SPACE||t.keyCode===e.ui.keyCode.ENTER)&&e(this).addClass("ui-state-active")}).bind("keyup"+this.eventNamespace+" blur"+this.eventNamespace,function(){e(this).removeClass("ui-state-active")}),this.buttonElement.is("a")&&this.buttonElement.keyup(function(t){t.keyCode===e.ui.keyCode.SPACE&&e(this).click()})),this._setOption("disabled",u.disabled),this._resetButton()},_determineButtonType:function(){var e,t,n;this.element.is("[type=checkbox]")?this.type="checkbox":this.element.is("[type=radio]")?this.type="radio":this.element.is("input")?this.type="input":this.type="button",this.type==="checkbox"||this.type==="radio"?(e=this.element.parents().last(),t="label[for='"+this.element.attr("id")+"']",this.buttonElement=e.find(t),this.buttonElement.length||(e=e.length?e.siblings():this.element.siblings(),this.buttonElement=e.filter(t),this.buttonElement.length||(this.buttonElement=e.find(t))),this.element.addClass("ui-helper-hidden-accessible"),n=this.element.is(":checked"),n&&this.buttonElement.addClass("ui-state-active"),this.buttonElement.prop("aria-pressed",n)):this.buttonElement=this.element},widget:function(){return this.buttonElement},_destroy:function(){this.element.removeClass("ui-helper-hidden-accessible"),this.buttonElement.removeClass(o+" "+u+" "+a).removeAttr("role").removeAttr("aria-pressed").html(this.buttonElement.find(".ui-button-text").html()),this.hasTitle||this.buttonElement.removeAttr("title")},_setOption:function(e,t){this._super(e,t);if(e==="disabled"){t?this.element.prop("disabled",!0):this.element.prop("disabled",!1);return}this._resetButton()},refresh:function(){var t=this.element.is("input, button")?this.element.is(":disabled"):this.element.hasClass("ui-button-disabled");t!==this.options.disabled&&this._setOption("disabled",t),this.type==="radio"?l(this.element[0]).each(function(){e(this).is(":checked")?e(this).button("widget").addClass("ui-state-active").attr("aria-pressed","true"):e(this).button("widget").removeClass("ui-state-active").attr("aria-pressed","false")}):this.type==="checkbox"&&(this.element.is(":checked")?this.buttonElement.addClass("ui-state-active").attr("aria-pressed","true"):this.buttonElement.removeClass("ui-state-active").attr("aria-pressed","false"))},_resetButton:function(){if(this.type==="input"){this.options.label&&this.element.val(this.options.label);return}var t=this.buttonElement.removeClass(a),n=e("<span></span>",this.document[0]).addClass("ui-button-text").html(this.options.label).appendTo(t.empty()).text(),r=this.options.icons,i=r.primary&&r.secondary,s=[];r.primary||r.secondary?(this.options.text&&s.push("ui-button-text-icon"+(i?"s":r.primary?"-primary":"-secondary")),r.primary&&t.prepend("<span class='ui-button-icon-primary ui-icon "+r.primary+"'></span>"),r.secondary&&t.append("<span class='ui-button-icon-secondary ui-icon "+r.secondary+"'></span>"),this.options.text||(s.push(i?"ui-button-icons-only":"ui-button-icon-only"),this.hasTitle||t.attr("title",e.trim(n)))):s.push("ui-button-text-only"),t.addClass(s.join(" "))}}),e.widget("ui.buttonset",{version:"1.10.1",options:{items:"button, input[type=button], input[type=submit], input[type=reset], input[type=checkbox], input[type=radio], a, :data(ui-button)"},_create:function(){this.element.addClass("ui-buttonset")},_init:function(){this.refresh()},_setOption:function(e,t){e==="disabled"&&this.buttons.button("option",e,t),this._super(e,t)},refresh:function(){var t=this.element.css("direction")==="rtl";this.buttons=this.element.find(this.options.items).filter(":ui-button").button("refresh").end().not(":ui-button").button().end().map(function(){return e(this).button("widget")[0]}).removeClass("ui-corner-all ui-corner-left ui-corner-right").filter(":first").addClass(t?"ui-corner-right":"ui-corner-left").end().filter(":last").addClass(t?"ui-corner-left":"ui-corner-right").end().end()},_destroy:function(){this.element.removeClass("ui-buttonset"),this.buttons.map(function(){return e(this).button("widget")[0]}).removeClass("ui-corner-left ui-corner-right").end().button("destroy")}})}(jQuery),function(e,t){function s(){this._curInst=null,this._keyEvent=!1,this._disabledInputs=[],this._datepickerShowing=!1,this._inDialog=!1,this._mainDivId="ui-datepicker-div",this._inlineClass="ui-datepicker-inline",this._appendClass="ui-datepicker-append",this._triggerClass="ui-datepicker-trigger",this._dialogClass="ui-datepicker-dialog",this._disableClass="ui-datepicker-disabled",this._unselectableClass="ui-datepicker-unselectable",this._currentClass="ui-datepicker-current-day",this._dayOverClass="ui-datepicker-days-cell-over",this.regional=[],this.regional[""]={closeText:"Done",prevText:"Prev",nextText:"Next",currentText:"Today",monthNames:["January","February","March","April","May","June","July","August","September","October","November","December"],monthNamesShort:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],dayNames:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"],dayNamesShort:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],dayNamesMin:["Su","Mo","Tu","We","Th","Fr","Sa"],weekHeader:"Wk",dateFormat:"mm/dd/yy",firstDay:0,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""},this._defaults={showOn:"focus",showAnim:"fadeIn",showOptions:{},defaultDate:null,appendText:"",buttonText:"...",buttonImage:"",buttonImageOnly:!1,hideIfNoPrevNext:!1,navigationAsDateFormat:!1,gotoCurrent:!1,changeMonth:!1,changeYear:!1,yearRange:"c-10:c+10",showOtherMonths:!1,selectOtherMonths:!1,showWeek:!1,calculateWeek:this.iso8601Week,shortYearCutoff:"+10",minDate:null,maxDate:null,duration:"fast",beforeShowDay:null,beforeShow:null,onSelect:null,onChangeMonthYear:null,onClose:null,numberOfMonths:1,showCurrentAtPos:0,stepMonths:1,stepBigMonths:12,altField:"",altFormat:"",constrainInput:!0,showButtonPanel:!1,autoSize:!1,disabled:!1},e.extend(this._defaults,this.regional[""]),this.dpDiv=o(e("<div id='"+this._mainDivId+"' class='ui-datepicker ui-widget ui-widget-content ui-helper-clearfix ui-corner-all'></div>"))}function o(t){var n="button, .ui-datepicker-prev, .ui-datepicker-next, .ui-datepicker-calendar td a";return t.delegate(n,"mouseout",function(){e(this).removeClass("ui-state-hover"),this.className.indexOf("ui-datepicker-prev")!==-1&&e(this).removeClass("ui-datepicker-prev-hover"),this.className.indexOf("ui-datepicker-next")!==-1&&e(this).removeClass("ui-datepicker-next-hover")}).delegate(n,"mouseover",function(){e.datepicker._isDisabledDatepicker(i.inline?t.parent()[0]:i.input[0])||(e(this).parents(".ui-datepicker-calendar").find("a").removeClass("ui-state-hover"),e(this).addClass("ui-state-hover"),this.className.indexOf("ui-datepicker-prev")!==-1&&e(this).addClass("ui-datepicker-prev-hover"),this.className.indexOf("ui-datepicker-next")!==-1&&e(this).addClass("ui-datepicker-next-hover"))})}function u(t,n){e.extend(t,n);for(var r in n)n[r]==null&&(t[r]=n[r]);return t}e.extend(e.ui,{datepicker:{version:"1.10.1"}});var n="datepicker",r=(new Date).getTime(),i;e.extend(s.prototype,{markerClassName:"hasDatepicker",maxRows:4,_widgetDatepicker:function(){return this.dpDiv},setDefaults:function(e){return u(this._defaults,e||{}),this},_attachDatepicker:function(t,n){var r,i,s;r=t.nodeName.toLowerCase(),i=r==="div"||r==="span",t.id||(this.uuid+=1,t.id="dp"+this.uuid),s=this._newInst(e(t),i),s.settings=e.extend({},n||{}),r==="input"?this._connectDatepicker(t,s):i&&this._inlineDatepicker(t,s)},_newInst:function(t,n){var r=t[0].id.replace(/([^A-Za-z0-9_\-])/g,"\\\\$1");return{id:r,input:t,selectedDay:0,selectedMonth:0,selectedYear:0,drawMonth:0,drawYear:0,inline:n,dpDiv:n?o(e("<div class='"+this._inlineClass+" ui-datepicker ui-widget ui-widget-content ui-helper-clearfix ui-corner-all'></div>")):this.dpDiv}},_connectDatepicker:function(t,r){var i=e(t);r.append=e([]),r.trigger=e([]);if(i.hasClass(this.markerClassName))return;this._attachments(i,r),i.addClass(this.markerClassName).keydown(this._doKeyDown).keypress(this._doKeyPress).keyup(this._doKeyUp),this._autoSize(r),e.data(t,n,r),r.settings.disabled&&this._disableDatepicker(t)},_attachments:function(t,n){var r,i,s,o=this._get(n,"appendText"),u=this._get(n,"isRTL");n.append&&n.append.remove(),o&&(n.append=e("<span class='"+this._appendClass+"'>"+o+"</span>"),t[u?"before":"after"](n.append)),t.unbind("focus",this._showDatepicker),n.trigger&&n.trigger.remove(),r=this._get(n,"showOn"),(r==="focus"||r==="both")&&t.focus(this._showDatepicker);if(r==="button"||r==="both")i=this._get(n,"buttonText"),s=this._get(n,"buttonImage"),n.trigger=e(this._get(n,"buttonImageOnly")?e("<img/>").addClass(this._triggerClass).attr({src:s,alt:i,title:i}):e("<button type='button'></button>").addClass(this._triggerClass).html(s?e("<img/>").attr({src:s,alt:i,title:i}):i)),t[u?"before":"after"](n.trigger),n.trigger.click(function(){return e.datepicker._datepickerShowing&&e.datepicker._lastInput===t[0]?e.datepicker._hideDatepicker():e.datepicker._datepickerShowing&&e.datepicker._lastInput!==t[0]?(e.datepicker._hideDatepicker(),e.datepicker._showDatepicker(t[0])):e.datepicker._showDatepicker(t[0]),!1})},_autoSize:function(e){if(this._get(e,"autoSize")&&!e.inline){var t,n,r,i,s=new Date(2009,11,20),o=this._get(e,"dateFormat");o.match(/[DM]/)&&(t=function(e){n=0,r=0;for(i=0;i<e.length;i++)e[i].length>n&&(n=e[i].length,r=i);return r},s.setMonth(t(this._get(e,o.match(/MM/)?"monthNames":"monthNamesShort"))),s.setDate(t(this._get(e,o.match(/DD/)?"dayNames":"dayNamesShort"))+20-s.getDay())),e.input.attr("size",this._formatDate(e,s).length)}},_inlineDatepicker:function(t,r){var i=e(t);if(i.hasClass(this.markerClassName))return;i.addClass(this.markerClassName).append(r.dpDiv),e.data(t,n,r),this._setDate(r,this._getDefaultDate(r),!0),this._updateDatepicker(r),this._updateAlternate(r),r.settings.disabled&&this._disableDatepicker(t),r.dpDiv.css("display","block")},_dialogDatepicker:function(t,r,i,s,o){var a,f,l,c,h,p=this._dialogInst;return p||(this.uuid+=1,a="dp"+this.uuid,this._dialogInput=e("<input type='text' id='"+a+"' style='position: absolute; top: -100px; width: 0px;'/>"),this._dialogInput.keydown(this._doKeyDown),e("body").append(this._dialogInput),p=this._dialogInst=this._newInst(this._dialogInput,!1),p.settings={},e.data(this._dialogInput[0],n,p)),u(p.settings,s||{}),r=r&&r.constructor===Date?this._formatDate(p,r):r,this._dialogInput.val(r),this._pos=o?o.length?o:[o.pageX,o.pageY]:null,this._pos||(f=document.documentElement.clientWidth,l=document.documentElement.clientHeight,c=document.documentElement.scrollLeft||document.body.scrollLeft,h=document.documentElement.scrollTop||document.body.scrollTop,this._pos=[f/2-100+c,l/2-150+h]),this._dialogInput.css("left",this._pos[0]+20+"px").css("top",this._pos[1]+"px"),p.settings.onSelect=i,this._inDialog=!0,this.dpDiv.addClass(this._dialogClass),this._showDatepicker(this._dialogInput[0]),e.blockUI&&e.blockUI(this.dpDiv),e.data(this._dialogInput[0],n,p),this},_destroyDatepicker:function(t){var r,i=e(t),s=e.data(t,n);if(!i.hasClass(this.markerClassName))return;r=t.nodeName.toLowerCase(),e.removeData(t,n),r==="input"?(s.append.remove(),s.trigger.remove(),i.removeClass(this.markerClassName).unbind("focus",this._showDatepicker).unbind("keydown",this._doKeyDown).unbind("keypress",this._doKeyPress).unbind("keyup",this._doKeyUp)):(r==="div"||r==="span")&&i.removeClass(this.markerClassName).empty()},_enableDatepicker:function(t){var r,i,s=e(t),o=e.data(t,n);if(!s.hasClass(this.markerClassName))return;r=t.nodeName.toLowerCase();if(r==="input")t.disabled=!1,o.trigger.filter("button").each(function(){this.disabled=!1}).end().filter("img").css({opacity:"1.0",cursor:""});else if(r==="div"||r==="span")i=s.children("."+this._inlineClass),i.children().removeClass("ui-state-disabled"),i.find("select.ui-datepicker-month, select.ui-datepicker-year").prop("disabled",!1);this._disabledInputs=e.map(this._disabledInputs,function(e){return e===t?null:e})},_disableDatepicker:function(t){var r,i,s=e(t),o=e.data(t,n);if(!s.hasClass(this.markerClassName))return;r=t.nodeName.toLowerCase();if(r==="input")t.disabled=!0,o.trigger.filter("button").each(function(){this.disabled=!0}).end().filter("img").css({opacity:"0.5",cursor:"default"});else if(r==="div"||r==="span")i=s.children("."+this._inlineClass),i.children().addClass("ui-state-disabled"),i.find("select.ui-datepicker-month, select.ui-datepicker-year").prop("disabled",!0);this._disabledInputs=e.map(this._disabledInputs,function(e){return e===t?null:e}),this._disabledInputs[this._disabledInputs.length]=t},_isDisabledDatepicker:function(e){if(!e)return!1;for(var t=0;t<this._disabledInputs.length;t++)if(this._disabledInputs[t]===e)return!0;return!1},_getInst:function(t){try{return e.data(t,n)}catch(r){throw"Missing instance data for this datepicker"}},_optionDatepicker:function(n,r,i){var s,o,a,f,l=this._getInst(n);if(arguments.length===2&&typeof r=="string")return r==="defaults"?e.extend({},e.datepicker._defaults):l?r==="all"?e.extend({},l.settings):this._get(l,r):null;s=r||{},typeof r=="string"&&(s={},s[r]=i),l&&(this._curInst===l&&this._hideDatepicker(),o=this._getDateDatepicker(n,!0),a=this._getMinMaxDate(l,"min"),f=this._getMinMaxDate(l,"max"),u(l.settings,s),a!==null&&s.dateFormat!==t&&s.minDate===t&&(l.settings.minDate=this._formatDate(l,a)),f!==null&&s.dateFormat!==t&&s.maxDate===t&&(l.settings.maxDate=this._formatDate(l,f)),"disabled"in s&&(s.disabled?this._disableDatepicker(n):this._enableDatepicker(n)),this._attachments(e(n),l),this._autoSize(l),this._setDate(l,o),this._updateAlternate(l),this._updateDatepicker(l))},_changeDatepicker:function(e,t,n){this._optionDatepicker(e,t,n)},_refreshDatepicker:function(e){var t=this._getInst(e);t&&this._updateDatepicker(t)},_setDateDatepicker:function(e,t){var n=this._getInst(e);n&&(this._setDate(n,t),this._updateDatepicker(n),this._updateAlternate(n))},_getDateDatepicker:function(e,t){var n=this._getInst(e);return n&&!n.inline&&this._setDateFromField(n,t),n?this._getDate(n):null},_doKeyDown:function(t){var n,r,i,s=e.datepicker._getInst(t.target),o=!0,u=s.dpDiv.is(".ui-datepicker-rtl");s._keyEvent=!0;if(e.datepicker._datepickerShowing)switch(t.keyCode){case 9:e.datepicker._hideDatepicker(),o=!1;break;case 13:return i=e("td."+e.datepicker._dayOverClass+":not(."+e.datepicker._currentClass+")",s.dpDiv),i[0]&&e.datepicker._selectDay(t.target,s.selectedMonth,s.selectedYear,i[0]),n=e.datepicker._get(s,"onSelect"),n?(r=e.datepicker._formatDate(s),n.apply(s.input?s.input[0]:null,[r,s])):e.datepicker._hideDatepicker(),!1;case 27:e.datepicker._hideDatepicker();break;case 33:e.datepicker._adjustDate(t.target,t.ctrlKey?-e.datepicker._get(s,"stepBigMonths"):-e.datepicker._get(s,"stepMonths"),"M");break;case 34:e.datepicker._adjustDate(t.target,t.ctrlKey?+e.datepicker._get(s,"stepBigMonths"):+e.datepicker._get(s,"stepMonths"),"M");break;case 35:(t.ctrlKey||t.metaKey)&&e.datepicker._clearDate(t.target),o=t.ctrlKey||t.metaKey;break;case 36:(t.ctrlKey||t.metaKey)&&e.datepicker._gotoToday(t.target),o=t.ctrlKey||t.metaKey;break;case 37:(t.ctrlKey||t.metaKey)&&e.datepicker._adjustDate(t.target,u?1:-1,"D"),o=t.ctrlKey||t.metaKey,t.originalEvent.altKey&&e.datepicker._adjustDate(t.target,t.ctrlKey?-e.datepicker._get(s,"stepBigMonths"):-e.datepicker._get(s,"stepMonths"),"M");break;case 38:(t.ctrlKey||t.metaKey)&&e.datepicker._adjustDate(t.target,-7,"D"),o=t.ctrlKey||t.metaKey;break;case 39:(t.ctrlKey||t.metaKey)&&e.datepicker._adjustDate(t.target,u?-1:1,"D"),o=t.ctrlKey||t.metaKey,t.originalEvent.altKey&&e.datepicker._adjustDate(t.target,t.ctrlKey?+e.datepicker._get(s,"stepBigMonths"):+e.datepicker._get(s,"stepMonths"),"M");break;case 40:(t.ctrlKey||t.metaKey)&&e.datepicker._adjustDate(t.target,7,"D"),o=t.ctrlKey||t.metaKey;break;default:o=!1}else t.keyCode===36&&t.ctrlKey?e.datepicker._showDatepicker(this):o=!1;o&&(t.preventDefault(),t.stopPropagation())},_doKeyPress:function(t){var n,r,i=e.datepicker._getInst(t.target);if(e.datepicker._get(i,"constrainInput"))return n=e.datepicker._possibleChars(e.datepicker._get(i,"dateFormat")),r=String.fromCharCode(t.charCode==null?t.keyCode:t.charCode),t.ctrlKey||t.metaKey||r<" "||!n||n.indexOf(r)>-1},_doKeyUp:function(t){var n,r=e.datepicker._getInst(t.target);if(r.input.val()!==r.lastVal)try{n=e.datepicker.parseDate(e.datepicker._get(r,"dateFormat"),r.input?r.input.val():null,e.datepicker._getFormatConfig(r)),n&&(e.datepicker._setDateFromField(r),e.datepicker._updateAlternate(r),e.datepicker._updateDatepicker(r))}catch(i){}return!0},_showDatepicker:function(t){t=t.target||t,t.nodeName.toLowerCase()!=="input"&&(t=e("input",t.parentNode)[0]);if(e.datepicker._isDisabledDatepicker(t)||e.datepicker._lastInput===t)return;var n,r,i,s,o,a,f;n=e.datepicker._getInst(t),e.datepicker._curInst&&e.datepicker._curInst!==n&&(e.datepicker._curInst.dpDiv.stop(!0,!0),n&&e.datepicker._datepickerShowing&&e.datepicker._hideDatepicker(e.datepicker._curInst.input[0])),r=e.datepicker._get(n,"beforeShow"),i=r?r.apply(t,[t,n]):{};if(i===!1)return;u(n.settings,i),n.lastVal=null,e.datepicker._lastInput=t,e.datepicker._setDateFromField(n),e.datepicker._inDialog&&(t.value=""),e.datepicker._pos||(e.datepicker._pos=e.datepicker._findPos(t),e.datepicker._pos[1]+=t.offsetHeight),s=!1,e(t).parents().each(function(){return s|=e(this).css("position")==="fixed",!s}),o={left:e.datepicker._pos[0],top:e.datepicker._pos[1]},e.datepicker._pos=null,n.dpDiv.empty(),n.dpDiv.css({position:"absolute",display:"block",top:"-1000px"}),e.datepicker._updateDatepicker(n),o=e.datepicker._checkOffset(n,o,s),n.dpDiv.css({position:e.datepicker._inDialog&&e.blockUI?"static":s?"fixed":"absolute",display:"none",left:o.left+"px",top:o.top+"px"}),n.inline||(a=e.datepicker._get(n,"showAnim"),f=e.datepicker._get(n,"duration"),n.dpDiv.zIndex(e(t).zIndex()+1),e.datepicker._datepickerShowing=!0,e.effects&&e.effects.effect[a]?n.dpDiv.show(a,e.datepicker._get(n,"showOptions"),f):n.dpDiv[a||"show"](a?f:null),n.input.is(":visible")&&!n.input.is(":disabled")&&n.input.focus(),e.datepicker._curInst=n)},_updateDatepicker:function(t){this.maxRows=4,i=t,t.dpDiv.empty().append(this._generateHTML(t)),this._attachHandlers(t),t.dpDiv.find("."+this._dayOverClass+" a").mouseover();var n,r=this._getNumberOfMonths(t),s=r[1],o=17;t.dpDiv.removeClass("ui-datepicker-multi-2 ui-datepicker-multi-3 ui-datepicker-multi-4").width(""),s>1&&t.dpDiv.addClass("ui-datepicker-multi-"+s).css("width",o*s+"em"),t.dpDiv[(r[0]!==1||r[1]!==1?"add":"remove")+"Class"]("ui-datepicker-multi"),t.dpDiv[(this._get(t,"isRTL")?"add":"remove")+"Class"]("ui-datepicker-rtl"),t===e.datepicker._curInst&&e.datepicker._datepickerShowing&&t.input&&t.input.is(":visible")&&!t.input.is(":disabled")&&t.input[0]!==document.activeElement&&t.input.focus(),t.yearshtml&&(n=t.yearshtml,setTimeout(function(){n===t.yearshtml&&t.yearshtml&&t.dpDiv.find("select.ui-datepicker-year:first").replaceWith(t.yearshtml),n=t.yearshtml=null},0))},_getBorders:function(e){var t=function(e){return{thin:1,medium:2,thick:3}[e]||e};return[parseFloat(t(e.css("border-left-width"))),parseFloat(t(e.css("border-top-width")))]},_checkOffset:function(t,n,r){var i=t.dpDiv.outerWidth(),s=t.dpDiv.outerHeight(),o=t.input?t.input.outerWidth():0,u=t.input?t.input.outerHeight():0,a=document.documentElement.clientWidth+(r?0:e(document).scrollLeft()),f=document.documentElement.clientHeight+(r?0:e(document).scrollTop());return n.left-=this._get(t,"isRTL")?i-o:0,n.left-=r&&n.left===t.input.offset().left?e(document).scrollLeft():0,n.top-=r&&n.top===t.input.offset().top+u?e(document).scrollTop():0,n.left-=Math.min(n.left,n.left+i>a&&a>i?Math.abs(n.left+i-a):0),n.top-=Math.min(n.top,n.top+s>f&&f>s?Math.abs(s+u):0),n},_findPos:function(t){var n,r=this._getInst(t),i=this._get(r,"isRTL");while(t&&(t.type==="hidden"||t.nodeType!==1||e.expr.filters.hidden(t)))t=t[i?"previousSibling":"nextSibling"];return n=e(t).offset(),[n.left,n.top]},_hideDatepicker:function(t){var r,i,s,o,u=this._curInst;if(!u||t&&u!==e.data(t,n))return;this._datepickerShowing&&(r=this._get(u,"showAnim"),i=this._get(u,"duration"),s=function(){e.datepicker._tidyDialog(u)},e.effects&&(e.effects.effect[r]||e.effects[r])?u.dpDiv.hide(r,e.datepicker._get(u,"showOptions"),i,s):u.dpDiv[r==="slideDown"?"slideUp":r==="fadeIn"?"fadeOut":"hide"](r?i:null,s),r||s(),this._datepickerShowing=!1,o=this._get(u,"onClose"),o&&o.apply(u.input?u.input[0]:null,[u.input?u.input.val():"",u]),this._lastInput=null,this._inDialog&&(this._dialogInput.css({position:"absolute",left:"0",top:"-100px"}),e.blockUI&&(e.unblockUI(),e("body").append(this.dpDiv))),this._inDialog=!1)},_tidyDialog:function(e){e.dpDiv.removeClass(this._dialogClass).unbind(".ui-datepicker-calendar")},_checkExternalClick:function(t){if(!e.datepicker._curInst)return;var n=e(t.target),r=e.datepicker._getInst(n[0]);(n[0].id!==e.datepicker._mainDivId&&n.parents("#"+e.datepicker._mainDivId).length===0&&!n.hasClass(e.datepicker.markerClassName)&&!n.closest("."+e.datepicker._triggerClass).length&&e.datepicker._datepickerShowing&&(!e.datepicker._inDialog||!e.blockUI)||n.hasClass(e.datepicker.markerClassName)&&e.datepicker._curInst!==r)&&e.datepicker._hideDatepicker()},_adjustDate:function(t,n,r){var i=e(t),s=this._getInst(i[0]);if(this._isDisabledDatepicker(i[0]))return;this._adjustInstDate(s,n+(r==="M"?this._get(s,"showCurrentAtPos"):0),r),this._updateDatepicker(s)},_gotoToday:function(t){var n,r=e(t),i=this._getInst(r[0]);this._get(i,"gotoCurrent")&&i.currentDay?(i.selectedDay=i.currentDay,i.drawMonth=i.selectedMonth=i.currentMonth,i.drawYear=i.selectedYear=i.currentYear):(n=new Date,i.selectedDay=n.getDate(),i.drawMonth=i.selectedMonth=n.getMonth(),i.drawYear=i.selectedYear=n.getFullYear()),this._notifyChange(i),this._adjustDate(r)},_selectMonthYear:function(t,n,r){var i=e(t),s=this._getInst(i[0]);s["selected"+(r==="M"?"Month":"Year")]=s["draw"+(r==="M"?"Month":"Year")]=parseInt(n.options[n.selectedIndex].value,10),this._notifyChange(s),this._adjustDate(i)},_selectDay:function(t,n,r,i){var s,o=e(t);if(e(i).hasClass(this._unselectableClass)||this._isDisabledDatepicker(o[0]))return;s=this._getInst(o[0]),s.selectedDay=s.currentDay=e("a",i).html(),s.selectedMonth=s.currentMonth=n,s.selectedYear=s.currentYear=r,this._selectDate(t,this._formatDate(s,s.currentDay,s.currentMonth,s.currentYear))},_clearDate:function(t){var n=e(t);this._selectDate(n,"")},_selectDate:function(t,n){var r,i=e(t),s=this._getInst(i[0]);n=n!=null?n:this._formatDate(s),s.input&&s.input.val(n),this._updateAlternate(s),r=this._get(s,"onSelect"),r?r.apply(s.input?s.input[0]:null,[n,s]):s.input&&s.input.trigger("change"),s.inline?this._updateDatepicker(s):(this._hideDatepicker(),this._lastInput=s.input[0],typeof s.input[0]!="object"&&s.input.focus(),this._lastInput=null)},_updateAlternate:function(t){var n,r,i,s=this._get(t,"altField");s&&(n=this._get(t,"altFormat")||this._get(t,"dateFormat"),r=this._getDate(t),i=this.formatDate(n,r,this._getFormatConfig(t)),e(s).each(function(){e(this).val(i)}))},noWeekends:function(e){var t=e.getDay();return[t>0&&t<6,""]},iso8601Week:function(e){var t,n=new Date(e.getTime());return n.setDate(n.getDate()+4-(n.getDay()||7)),t=n.getTime(),n.setMonth(0),n.setDate(1),Math.floor(Math.round((t-n)/864e5)/7)+1},parseDate:function(t,n,r){if(t==null||n==null)throw"Invalid arguments";n=typeof n=="object"?n.toString():n+"";if(n==="")return null;var i,s,o,u=0,a=(r?r.shortYearCutoff:null)||this._defaults.shortYearCutoff,f=typeof a!="string"?a:(new Date).getFullYear()%100+parseInt(a,10),l=(r?r.dayNamesShort:null)||this._defaults.dayNamesShort,c=(r?r.dayNames:null)||this._defaults.dayNames,h=(r?r.monthNamesShort:null)||this._defaults.monthNamesShort,p=(r?r.monthNames:null)||this._defaults.monthNames,d=-1,v=-1,m=-1,g=-1,y=!1,b,w=function(e){var n=i+1<t.length&&t.charAt(i+1)===e;return n&&i++,n},E=function(e){var t=w(e),r=e==="@"?14:e==="!"?20:e==="y"&&t?4:e==="o"?3:2,i=new RegExp("^\\d{1,"+r+"}"),s=n.substring(u).match(i);if(!s)throw"Missing number at position "+u;return u+=s[0].length,parseInt(s[0],10)},S=function(t,r,i){var s=-1,o=e.map(w(t)?i:r,function(e,t){return[[t,e]]}).sort(function(e,t){return-(e[1].length-t[1].length)});e.each(o,function(e,t){var r=t[1];if(n.substr(u,r.length).toLowerCase()===r.toLowerCase())return s=t[0],u+=r.length,!1});if(s!==-1)return s+1;throw"Unknown name at position "+u},x=function(){if(n.charAt(u)!==t.charAt(i))throw"Unexpected literal at position "+u;u++};for(i=0;i<t.length;i++)if(y)t.charAt(i)==="'"&&!w("'")?y=!1:x();else switch(t.charAt(i)){case"d":m=E("d");break;case"D":S("D",l,c);break;case"o":g=E("o");break;case"m":v=E("m");break;case"M":v=S("M",h,p);break;case"y":d=E("y");break;case"@":b=new Date(E("@")),d=b.getFullYear(),v=b.getMonth()+1,m=b.getDate();break;case"!":b=new Date((E("!")-this._ticksTo1970)/1e4),d=b.getFullYear(),v=b.getMonth()+1,m=b.getDate();break;case"'":w("'")?x():y=!0;break;default:x()}if(u<n.length){o=n.substr(u);if(!/^\s+/.test(o))throw"Extra/unparsed characters found in date: "+o}d===-1?d=(new Date).getFullYear():d<100&&(d+=(new Date).getFullYear()-(new Date).getFullYear()%100+(d<=f?0:-100));if(g>-1){v=1,m=g;do{s=this._getDaysInMonth(d,v-1);if(m<=s)break;v++,m-=s}while(!0)}b=this._daylightSavingAdjust(new Date(d,v-1,m));if(b.getFullYear()!==d||b.getMonth()+1!==v||b.getDate()!==m)throw"Invalid date";return b},ATOM:"yy-mm-dd",COOKIE:"D, dd M yy",ISO_8601:"yy-mm-dd",RFC_822:"D, d M y",RFC_850:"DD, dd-M-y",RFC_1036:"D, d M y",RFC_1123:"D, d M yy",RFC_2822:"D, d M yy",RSS:"D, d M y",TICKS:"!",TIMESTAMP:"@",W3C:"yy-mm-dd",_ticksTo1970:(718685+Math.floor(492.5)-Math.floor(19.7)+Math.floor(4.925))*24*60*60*1e7,formatDate:function(e,t,n){if(!t)return"";var r,i=(n?n.dayNamesShort:null)||this._defaults.dayNamesShort,s=(n?n.dayNames:null)||this._defaults.dayNames,o=(n?n.monthNamesShort:null)||this._defaults.monthNamesShort,u=(n?n.monthNames:null)||this._defaults.monthNames,a=function(t){var n=r+1<e.length&&e.charAt(r+1)===t;return n&&r++,n},f=function(e,t,n){var r=""+t;if(a(e))while(r.length<n)r="0"+r;return r},l=function(e,t,n,r){return a(e)?r[t]:n[t]},c="",h=!1;if(t)for(r=0;r<e.length;r++)if(h)e.charAt(r)==="'"&&!a("'")?h=!1:c+=e.charAt(r);else switch(e.charAt(r)){case"d":c+=f("d",t.getDate(),2);break;case"D":c+=l("D",t.getDay(),i,s);break;case"o":c+=f("o",Math.round(((new Date(t.getFullYear(),t.getMonth(),t.getDate())).getTime()-(new Date(t.getFullYear(),0,0)).getTime())/864e5),3);break;case"m":c+=f("m",t.getMonth()+1,2);break;case"M":c+=l("M",t.getMonth(),o,u);break;case"y":c+=a("y")?t.getFullYear():(t.getYear()%100<10?"0":"")+t.getYear()%100;break;case"@":c+=t.getTime();break;case"!":c+=t.getTime()*1e4+this._ticksTo1970;break;case"'":a("'")?c+="'":h=!0;break;default:c+=e.charAt(r)}return c},_possibleChars:function(e){var t,n="",r=!1,i=function(n){var r=t+1<e.length&&e.charAt(t+1)===n;return r&&t++,r};for(t=0;t<e.length;t++)if(r)e.charAt(t)==="'"&&!i("'")?r=!1:n+=e.charAt(t);else switch(e.charAt(t)){case"d":case"m":case"y":case"@":n+="0123456789";break;case"D":case"M":return null;case"'":i("'")?n+="'":r=!0;break;default:n+=e.charAt(t)}return n},_get:function(e,n){return e.settings[n]!==t?e.settings[n]:this._defaults[n]},_setDateFromField:function(e,t){if(e.input.val()===e.lastVal)return;var n=this._get(e,"dateFormat"),r=e.lastVal=e.input?e.input.val():null,i=this._getDefaultDate(e),s=i,o=this._getFormatConfig(e);try{s=this.parseDate(n,r,o)||i}catch(u){r=t?"":r}e.selectedDay=s.getDate(),e.drawMonth=e.selectedMonth=s.getMonth(),e.drawYear=e.selectedYear=s.getFullYear(),e.currentDay=r?s.getDate():0,e.currentMonth=r?s.getMonth():0,e.currentYear=r?s.getFullYear():0,this._adjustInstDate(e)},_getDefaultDate:function(e){return this._restrictMinMax(e,this._determineDate(e,this._get(e,"defaultDate"),new Date))},_determineDate:function(t,n,r){var i=function(e){var t=new Date;return t.setDate(t.getDate()+e),t},s=function(n){try{return e.datepicker.parseDate(e.datepicker._get(t,"dateFormat"),n,e.datepicker._getFormatConfig(t))}catch(r){}var i=(n.toLowerCase().match(/^c/)?e.datepicker._getDate(t):null)||new Date,s=i.getFullYear(),o=i.getMonth(),u=i.getDate(),a=/([+\-]?[0-9]+)\s*(d|D|w|W|m|M|y|Y)?/g,f=a.exec(n);while(f){switch(f[2]||"d"){case"d":case"D":u+=parseInt(f[1],10);break;case"w":case"W":u+=parseInt(f[1],10)*7;break;case"m":case"M":o+=parseInt(f[1],10),u=Math.min(u,e.datepicker._getDaysInMonth(s,o));break;case"y":case"Y":s+=parseInt(f[1],10),u=Math.min(u,e.datepicker._getDaysInMonth(s,o))}f=a.exec(n)}return new Date(s,o,u)},o=n==null||n===""?r:typeof n=="string"?s(n):typeof n=="number"?isNaN(n)?r:i(n):new Date(n.getTime());return o=o&&o.toString()==="Invalid Date"?r:o,o&&(o.setHours(0),o.setMinutes(0),o.setSeconds(0),o.setMilliseconds(0)),this._daylightSavingAdjust(o)},_daylightSavingAdjust:function(e){return e?(e.setHours(e.getHours()>12?e.getHours()+2:0),e):null},_setDate:function(e,t,n){var r=!t,i=e.selectedMonth,s=e.selectedYear,o=this._restrictMinMax(e,this._determineDate(e,t,new Date));e.selectedDay=e.currentDay=o.getDate(),e.drawMonth=e.selectedMonth=e.currentMonth=o.getMonth(),e.drawYear=e.selectedYear=e.currentYear=o.getFullYear(),(i!==e.selectedMonth||s!==e.selectedYear)&&!n&&this._notifyChange(e),this._adjustInstDate(e),e.input&&e.input.val(r?"":this._formatDate(e))},_getDate:function(e){var t=!e.currentYear||e.input&&e.input.val()===""?null:this._daylightSavingAdjust(new Date(e.currentYear,e.currentMonth,e.currentDay));return t},_attachHandlers:function(t){var n=this._get(t,"stepMonths"),i="#"+t.id.replace(/\\\\/g,"\\");t.dpDiv.find("[data-handler]").map(function(){var t={prev:function(){window["DP_jQuery_"+r].datepicker._adjustDate(i,-n,"M")},next:function(){window["DP_jQuery_"+r].datepicker._adjustDate(i,+n,"M")},hide:function(){window["DP_jQuery_"+r].datepicker._hideDatepicker()},today:function(){window["DP_jQuery_"+r].datepicker._gotoToday(i)},selectDay:function(){return window["DP_jQuery_"+r].datepicker._selectDay(i,+this.getAttribute("data-month"),+this.getAttribute("data-year"),this),!1},selectMonth:function(){return window["DP_jQuery_"+r].datepicker._selectMonthYear(i,this,"M"),!1},selectYear:function(){return window["DP_jQuery_"+r].datepicker._selectMonthYear(i,this,"Y"),!1}};e(this).bind(this.getAttribute("data-event"),t[this.getAttribute("data-handler")])})},_generateHTML:function(e){var t,n,r,i,s,o,u,a,f,l,c,h,p,d,v,m,g,y,b,w,E,S,x,T,N,C,k,L,A,O,M,_,D,P,H,B,j,F,I,q=new Date,R=this._daylightSavingAdjust(new Date(q.getFullYear(),q.getMonth(),q.getDate())),U=this._get(e,"isRTL"),z=this._get(e,"showButtonPanel"),W=this._get(e,"hideIfNoPrevNext"),X=this._get(e,"navigationAsDateFormat"),V=this._getNumberOfMonths(e),$=this._get(e,"showCurrentAtPos"),J=this._get(e,"stepMonths"),K=V[0]!==1||V[1]!==1,Q=this._daylightSavingAdjust(e.currentDay?new Date(e.currentYear,e.currentMonth,e.currentDay):new Date(9999,9,9)),G=this._getMinMaxDate(e,"min"),Y=this._getMinMaxDate(e,"max"),Z=e.drawMonth-$,et=e.drawYear;Z<0&&(Z+=12,et--);if(Y){t=this._daylightSavingAdjust(new Date(Y.getFullYear(),Y.getMonth()-V[0]*V[1]+1,Y.getDate())),t=G&&t<G?G:t;while(this._daylightSavingAdjust(new Date(et,Z,1))>t)Z--,Z<0&&(Z=11,et--)}e.drawMonth=Z,e.drawYear=et,n=this._get(e,"prevText"),n=X?this.formatDate(n,this._daylightSavingAdjust(new Date(et,Z-J,1)),this._getFormatConfig(e)):n,r=this._canAdjustMonth(e,-1,et,Z)?"<a class='ui-datepicker-prev ui-corner-all' data-handler='prev' data-event='click' title='"+n+"'><span class='ui-icon ui-icon-circle-triangle-"+(U?"e":"w")+"'>"+n+"</span></a>":W?"":"<a class='ui-datepicker-prev ui-corner-all ui-state-disabled' title='"+n+"'><span class='ui-icon ui-icon-circle-triangle-"+(U?"e":"w")+"'>"+n+"</span></a>",i=this._get(e,"nextText"),i=X?this.formatDate(i,this._daylightSavingAdjust(new Date(et,Z+J,1)),this._getFormatConfig(e)):i,s=this._canAdjustMonth(e,1,et,Z)?"<a class='ui-datepicker-next ui-corner-all' data-handler='next' data-event='click' title='"+i+"'><span class='ui-icon ui-icon-circle-triangle-"+(U?"w":"e")+"'>"+i+"</span></a>":W?"":"<a class='ui-datepicker-next ui-corner-all ui-state-disabled' title='"+i+"'><span class='ui-icon ui-icon-circle-triangle-"+(U?"w":"e")+"'>"+i+"</span></a>",o=this._get(e,"currentText"),u=this._get(e,"gotoCurrent")&&e.currentDay?Q:R,o=X?this.formatDate(o,u,this._getFormatConfig(e)):o,a=e.inline?"":"<button type='button' class='ui-datepicker-close ui-state-default ui-priority-primary ui-corner-all' data-handler='hide' data-event='click'>"+this._get(e,"closeText")+"</button>",f=z?"<div class='ui-datepicker-buttonpane ui-widget-content'>"+(U?a:"")+(this._isInRange(e,u)?"<button type='button' class='ui-datepicker-current ui-state-default ui-priority-secondary ui-corner-all' data-handler='today' data-event='click'>"+o+"</button>":"")+(U?"":a)+"</div>":"",l=parseInt(this._get(e,"firstDay"),10),l=isNaN(l)?0:l,c=this._get(e,"showWeek"),h=this._get(e,"dayNames"),p=this._get(e,"dayNamesMin"),d=this._get(e,"monthNames"),v=this._get(e,"monthNamesShort"),m=this._get(e,"beforeShowDay"),g=this._get(e,"showOtherMonths"),y=this._get(e,"selectOtherMonths"),b=this._getDefaultDate(e),w="",E;for(S=0;S<V[0];S++){x="",this.maxRows=4;for(T=0;T<V[1];T++){N=this._daylightSavingAdjust(new Date(et,Z,e.selectedDay)),C=" ui-corner-all",k="";if(K){k+="<div class='ui-datepicker-group";if(V[1]>1)switch(T){case 0:k+=" ui-datepicker-group-first",C=" ui-corner-"+(U?"right":"left");break;case V[1]-1:k+=" ui-datepicker-group-last",C=" ui-corner-"+(U?"left":"right");break;default:k+=" ui-datepicker-group-middle",C=""}k+="'>"}k+="<div class='ui-datepicker-header ui-widget-header ui-helper-clearfix"+C+"'>"+(/all|left/.test(C)&&S===0?U?s:r:"")+(/all|right/.test(C)&&S===0?U?r:s:"")+this._generateMonthYearHeader(e,Z,et,G,Y,S>0||T>0,d,v)+"</div><table class='ui-datepicker-calendar'><thead>"+"<tr>",L=c?"<th class='ui-datepicker-week-col'>"+this._get(e,"weekHeader")+"</th>":"";for(E=0;E<7;E++)A=(E+l)%7,L+="<th"+((E+l+6)%7>=5?" class='ui-datepicker-week-end'":"")+">"+"<span title='"+h[A]+"'>"+p[A]+"</span></th>";k+=L+"</tr></thead><tbody>",O=this._getDaysInMonth(et,Z),et===e.selectedYear&&Z===e.selectedMonth&&(e.selectedDay=Math.min(e.selectedDay,O)),M=(this._getFirstDayOfMonth(et,Z)-l+7)%7,_=Math.ceil((M+O)/7),D=K?this.maxRows>_?this.maxRows:_:_,this.maxRows=D,P=this._daylightSavingAdjust(new Date(et,Z,1-M));for(H=0;H<D;H++){k+="<tr>",B=c?"<td class='ui-datepicker-week-col'>"+this._get(e,"calculateWeek")(P)+"</td>":"";for(E=0;E<7;E++)j=m?m.apply(e.input?e.input[0]:null,[P]):[!0,""],F=P.getMonth()!==Z,I=F&&!y||!j[0]||G&&P<G||Y&&P>Y,B+="<td class='"+((E+l+6)%7>=5?" ui-datepicker-week-end":"")+(F?" ui-datepicker-other-month":"")+(P.getTime()===N.getTime()&&Z===e.selectedMonth&&e._keyEvent||b.getTime()===P.getTime()&&b.getTime()===N.getTime()?" "+this._dayOverClass:"")+(I?" "+this._unselectableClass+" ui-state-disabled":"")+(F&&!g?"":" "+j[1]+(P.getTime()===Q.getTime()?" "+this._currentClass:"")+(P.getTime()===R.getTime()?" ui-datepicker-today":""))+"'"+((!F||g)&&j[2]?" title='"+j[2].replace(/'/g,"&#39;")+"'":"")+(I?"":" data-handler='selectDay' data-event='click' data-month='"+P.getMonth()+"' data-year='"+P.getFullYear()+"'")+">"+(F&&!g?"&#xa0;":I?"<span class='ui-state-default'>"+P.getDate()+"</span>":"<a class='ui-state-default"+(P.getTime()===R.getTime()?" ui-state-highlight":"")+(P.getTime()===Q.getTime()?" ui-state-active":"")+(F?" ui-priority-secondary":"")+"' href='#'>"+P.getDate()+"</a>")+"</td>",P.setDate(P.getDate()+1),P=this._daylightSavingAdjust(P);k+=B+"</tr>"}Z++,Z>11&&(Z=0,et++),k+="</tbody></table>"+(K?"</div>"+(V[0]>0&&T===V[1]-1?"<div class='ui-datepicker-row-break'></div>":""):""),x+=k}w+=x}return w+=f,e._keyEvent=!1,w},_generateMonthYearHeader:function(e,t,n,r,i,s,o,u){var a,f,l,c,h,p,d,v,m=this._get(e,"changeMonth"),g=this._get(e,"changeYear"),y=this._get(e,"showMonthAfterYear"),b="<div class='ui-datepicker-title'>",w="";if(s||!m)w+="<span class='ui-datepicker-month'>"+o[t]+"</span>";else{a=r&&r.getFullYear()===n,f=i&&i.getFullYear()===n,w+="<select class='ui-datepicker-month' data-handler='selectMonth' data-event='change'>";for(l=0;l<12;l++)(!a||l>=r.getMonth())&&(!f||l<=i.getMonth())&&(w+="<option value='"+l+"'"+(l===t?" selected='selected'":"")+">"+u[l]+"</option>");w+="</select>"}y||(b+=w+(s||!m||!g?"&#xa0;":""));if(!e.yearshtml){e.yearshtml="";if(s||!g)b+="<span class='ui-datepicker-year'>"+n+"</span>";else{c=this._get(e,"yearRange").split(":"),h=(new Date).getFullYear(),p=function(e){var t=e.match(/c[+\-].*/)?n+parseInt(e.substring(1),10):e.match(/[+\-].*/)?h+parseInt(e,10):parseInt(e,10);return isNaN(t)?h:t},d=p(c[0]),v=Math.max(d,p(c[1]||"")),d=r?Math.max(d,r.getFullYear()):d,v=i?Math.min(v,i.getFullYear()):v,e.yearshtml+="<select class='ui-datepicker-year' data-handler='selectYear' data-event='change'>";for(;d<=v;d++)e.yearshtml+="<option value='"+d+"'"+(d===n?" selected='selected'":"")+">"+d+"</option>";e.yearshtml+="</select>",b+=e.yearshtml,e.yearshtml=null}}return b+=this._get(e,"yearSuffix"),y&&(b+=(s||!m||!g?"&#xa0;":"")+w),b+="</div>",b},_adjustInstDate:function(e,t,n){var r=e.drawYear+(n==="Y"?t:0),i=e.drawMonth+(n==="M"?t:0),s=Math.min(e.selectedDay,this._getDaysInMonth(r,i))+(n==="D"?t:0),o=this._restrictMinMax(e,this._daylightSavingAdjust(new Date(r,i,s)));e.selectedDay=o.getDate(),e.drawMonth=e.selectedMonth=o.getMonth(),e.drawYear=e.selectedYear=o.getFullYear(),(n==="M"||n==="Y")&&this._notifyChange(e)},_restrictMinMax:function(e,t){var n=this._getMinMaxDate(e,"min"),r=this._getMinMaxDate(e,"max"),i=n&&t<n?n:t;return r&&i>r?r:i},_notifyChange:function(e){var t=this._get(e,"onChangeMonthYear");t&&t.apply(e.input?e.input[0]:null,[e.selectedYear,e.selectedMonth+1,e])},_getNumberOfMonths:function(e){var t=this._get(e,"numberOfMonths");return t==null?[1,1]:typeof t=="number"?[1,t]:t},_getMinMaxDate:function(e,t){return this._determineDate(e,this._get(e,t+"Date"),null)},_getDaysInMonth:function(e,t){return 32-this._daylightSavingAdjust(new Date(e,t,32)).getDate()},_getFirstDayOfMonth:function(e,t){return(new Date(e,t,1)).getDay()},_canAdjustMonth:function(e,t,n,r){var i=this._getNumberOfMonths(e),s=this._daylightSavingAdjust(new Date(n,r+(t<0?t:i[0]*i[1]),1));return t<0&&s.setDate(this._getDaysInMonth(s.getFullYear(),s.getMonth())),this._isInRange(e,s)},_isInRange:function(e,t){var n,r,i=this._getMinMaxDate(e,"min"),s=this._getMinMaxDate(e,"max"),o=null,u=null,a=this._get(e,"yearRange");return a&&(n=a.split(":"),r=(new Date).getFullYear(),o=parseInt(n[0],10),u=parseInt(n[1],10),n[0].match(/[+\-].*/)&&(o+=r),n[1].match(/[+\-].*/)&&(u+=r)),(!i||t.getTime()>=i.getTime())&&(!s||t.getTime()<=s.getTime())&&(!o||t.getFullYear()>=o)&&(!u||t.getFullYear()<=u)},_getFormatConfig:function(e){var t=this._get(e,"shortYearCutoff");return t=typeof t!="string"?t:(new Date).getFullYear()%100+parseInt(t,10),{shortYearCutoff:t,dayNamesShort:this._get(e,"dayNamesShort"),dayNames:this._get(e,"dayNames"),monthNamesShort:this._get(e,"monthNamesShort"),monthNames:this._get(e,"monthNames")}},_formatDate:function(e,t,n,r){t||(e.currentDay=e.selectedDay,e.currentMonth=e.selectedMonth,e.currentYear=e.selectedYear);var i=t?typeof t=="object"?t:this._daylightSavingAdjust(new Date(r,n,t)):this._daylightSavingAdjust(new Date(e.currentYear,e.currentMonth,e.currentDay));return this.formatDate(this._get(e,"dateFormat"),i,this._getFormatConfig(e))}}),e.fn.datepicker=function(t){if(!this.length)return this;e.datepicker.initialized||(e(document).mousedown(e.datepicker._checkExternalClick),e.datepicker.initialized=!0),e("#"+e.datepicker._mainDivId).length===0&&e("body").append(e.datepicker.dpDiv);var n=Array.prototype.slice.call(arguments,1);return typeof t!="string"||t!=="isDisabled"&&t!=="getDate"&&t!=="widget"?t==="option"&&arguments.length===2&&typeof arguments[1]=="string"?e.datepicker["_"+t+"Datepicker"].apply(e.datepicker,[this[0]].concat(n)):this.each(function(){typeof t=="string"?e.datepicker["_"+t+"Datepicker"].apply(e.datepicker,[this].concat(n)):e.datepicker._attachDatepicker(this,t)}):e.datepicker["_"+t+"Datepicker"].apply(e.datepicker,[this[0]].concat(n))},e.datepicker=new s,e.datepicker.initialized=!1,e.datepicker.uuid=(new Date).getTime(),e.datepicker.version="1.10.1",window["DP_jQuery_"+r]=e}(jQuery),function(e,t){var n={buttons:!0,height:!0,maxHeight:!0,maxWidth:!0,minHeight:!0,minWidth:!0,width:!0},r={maxHeight:!0,maxWidth:!0,minHeight:!0,minWidth:!0};e.widget("ui.dialog",{version:"1.10.1",options:{appendTo:"body",autoOpen:!0,buttons:[],closeOnEscape:!0,closeText:"close",dialogClass:"",draggable:!0,hide:null,height:"auto",maxHeight:null,maxWidth:null,minHeight:150,minWidth:150,modal:!1,position:{my:"center",at:"center",of:window,collision:"fit",using:function(t){var n=e(this).css(t).offset().top;n<0&&e(this).css("top",t.top-n)}},resizable:!0,show:null,title:null,width:300,beforeClose:null,close:null,drag:null,dragStart:null,dragStop:null,focus:null,open:null,resize:null,resizeStart:null,resizeStop:null},_create:function(){this.originalCss={display:this.element[0].style.display,width:this.element[0].style.width,minHeight:this.element[0].style.minHeight,maxHeight:this.element[0].style.maxHeight,height:this.element[0].style.height},this.originalPosition={parent:this.element.parent(),index:this.element.parent().children().index(this.element)},this.originalTitle=this.element.attr("title"),this.options.title=this.options.title||this.originalTitle,this._createWrapper(),this.element.show().removeAttr("title").addClass("ui-dialog-content ui-widget-content").appendTo(this.uiDialog),this._createTitlebar(),this._createButtonPane(),this.options.draggable&&e.fn.draggable&&this._makeDraggable(),this.options.resizable&&e.fn.resizable&&this._makeResizable(),this._isOpen=!1},_init:function(){this.options.autoOpen&&this.open()},_appendTo:function(){var t=this.options.appendTo;return t&&(t.jquery||t.nodeType)?e(t):this.document.find(t||"body").eq(0)},_destroy:function(){var e,t=this.originalPosition;this._destroyOverlay(),this.element.removeUniqueId().removeClass("ui-dialog-content ui-widget-content").css(this.originalCss).detach(),this.uiDialog.stop(!0,!0).remove(),this.originalTitle&&this.element.attr("title",this.originalTitle),e=t.parent.children().eq(t.index),e.length&&e[0]!==this.element[0]?e.before(this.element):t.parent.append(this.element)},widget:function(){return this.uiDialog},disable:e.noop,enable:e.noop,close:function(t){var n=this;if(!this._isOpen||this._trigger("beforeClose",t)===!1)return;this._isOpen=!1,this._destroyOverlay(),this.opener.filter(":focusable").focus().length||e(this.document[0].activeElement).blur(),this._hide(this.uiDialog,this.options.hide,function(){n._trigger("close",t)})},isOpen:function(){return this._isOpen},moveToTop:function(){this._moveToTop()},_moveToTop:function(e,t){var n=!!this.uiDialog.nextAll(":visible").insertBefore(this.uiDialog).length;return n&&!t&&this._trigger("focus",e),n},open:function(){var t=this;if(this._isOpen){this._moveToTop()&&this._focusTabbable();return}this._isOpen=!0,this.opener=e(this.document[0].activeElement),this._size(),this._position(),this._createOverlay(),this._moveToTop(null,!0),this._show(this.uiDialog,this.options.show,function(){t._focusTabbable(),t._trigger("focus")}),this._trigger("open")},_focusTabbable:function(){var e=this.element.find("[autofocus]");e.length||(e=this.element.find(":tabbable")),e.length||(e=this.uiDialogButtonPane.find(":tabbable")),e.length||(e=this.uiDialogTitlebarClose.filter(":tabbable")),e.length||(e=this.uiDialog),e.eq(0).focus()},_keepFocus:function(t){function n(){var t=this.document[0].activeElement,n=this.uiDialog[0]===t||e.contains(this.uiDialog[0],t);n||this._focusTabbable()}t.preventDefault(),n.call(this),this._delay(n)},_createWrapper:function(){this.uiDialog=e("<div>").addClass("ui-dialog ui-widget ui-widget-content ui-corner-all ui-front "+this.options.dialogClass).hide().attr({tabIndex:-1,role:"dialog"}).appendTo(this._appendTo()),this._on(this.uiDialog,{keydown:function(t){if(this.options.closeOnEscape&&!t.isDefaultPrevented()&&t.keyCode&&t.keyCode===e.ui.keyCode.ESCAPE){t.preventDefault(),this.close(t);return}if(t.keyCode!==e.ui.keyCode.TAB)return;var n=this.uiDialog.find(":tabbable"),r=n.filter(":first"),i=n.filter(":last");t.target!==i[0]&&t.target!==this.uiDialog[0]||!!t.shiftKey?(t.target===r[0]||t.target===this.uiDialog[0])&&t.shiftKey&&(i.focus(1),t.preventDefault()):(r.focus(1),t.preventDefault())},mousedown:function(e){this._moveToTop(e)&&this._focusTabbable()}}),this.element.find("[aria-describedby]").length||this.uiDialog.attr({"aria-describedby":this.element.uniqueId().attr("id")})},_createTitlebar:function(){var t;this.uiDialogTitlebar=e("<div>").addClass("ui-dialog-titlebar ui-widget-header ui-corner-all ui-helper-clearfix").prependTo(this.uiDialog),this._on(this.uiDialogTitlebar,{mousedown:function(t){e(t.target).closest(".ui-dialog-titlebar-close")||this.uiDialog.focus()}}),this.uiDialogTitlebarClose=e("<button></button>").button({label:this.options.closeText,icons:{primary:"ui-icon-closethick"},text:!1}).addClass("ui-dialog-titlebar-close").appendTo(this.uiDialogTitlebar),this._on(this.uiDialogTitlebarClose,{click:function(e){e.preventDefault(),this.close(e)}}),t=e("<span>").uniqueId().addClass("ui-dialog-title").prependTo(this.uiDialogTitlebar),this._title(t),this.uiDialog.attr({"aria-labelledby":t.attr("id")})},_title:function(e){this.options.title||e.html("&#160;"),e.text(this.options.title)},_createButtonPane:function(){this.uiDialogButtonPane=e("<div>").addClass("ui-dialog-buttonpane ui-widget-content ui-helper-clearfix"),this.uiButtonSet=e("<div>").addClass("ui-dialog-buttonset").appendTo(this.uiDialogButtonPane),this._createButtons()},_createButtons:function(){var t=this,n=this.options.buttons;this.uiDialogButtonPane.remove(),this.uiButtonSet.empty();if(e.isEmptyObject(n)||e.isArray(n)&&!n.length){this.uiDialog.removeClass("ui-dialog-buttons");return}e.each(n,function(n,r){var i,s;r=e.isFunction(r)?{click:r,text:n}:r,r=e.extend({type:"button"},r),i=r.click,r.click=function(){i.apply(t.element[0],arguments)},s={icons:r.icons,text:r.showText},delete r.icons,delete r.showText,e("<button></button>",r).button(s).appendTo(t.uiButtonSet)}),this.uiDialog.addClass("ui-dialog-buttons"),this.uiDialogButtonPane.appendTo(this.uiDialog)},_makeDraggable:function(){function r(e){return{position:e.position,offset:e.offset}}var t=this,n=this.options;this.uiDialog.draggable({cancel:".ui-dialog-content, .ui-dialog-titlebar-close",handle:".ui-dialog-titlebar",containment:"document",start:function(n,i){e(this).addClass("ui-dialog-dragging"),t._blockFrames(),t._trigger("dragStart",n,r(i))},drag:function(e,n){t._trigger("drag",e,r(n))},stop:function(i,s){n.position=[s.position.left-t.document.scrollLeft(),s.position.top-t.document.scrollTop()],e(this).removeClass("ui-dialog-dragging"),t._unblockFrames(),t._trigger("dragStop",i,r(s))}})},_makeResizable:function(){function o(e){return{originalPosition:e.originalPosition,originalSize:e.originalSize,position:e.position,size:e.size}}var t=this,n=this.options,r=n.resizable,i=this.uiDialog.css("position"),s=typeof r=="string"?r:"n,e,s,w,se,sw,ne,nw";this.uiDialog.resizable({cancel:".ui-dialog-content",containment:"document",alsoResize:this.element,maxWidth:n.maxWidth,maxHeight:n.maxHeight,minWidth:n.minWidth,minHeight:this._minHeight(),handles:s,start:function(n,r){e(this).addClass("ui-dialog-resizing"),t._blockFrames(),t._trigger("resizeStart",n,o(r))},resize:function(e,n){t._trigger("resize",e,o(n))},stop:function(r,i){n.height=e(this).height(),n.width=e(this).width(),e(this).removeClass("ui-dialog-resizing"),t._unblockFrames(),t._trigger("resizeStop",r,o(i))}}).css("position",i)},_minHeight:function(){var e=this.options;return e.height==="auto"?e.minHeight:Math.min(e.minHeight,e.height)},_position:function(){var e=this.uiDialog.is(":visible");e||this.uiDialog.show(),this.uiDialog.position(this.options.position),e||this.uiDialog.hide()},_setOptions:function(t){var i=this,s=!1,o={};e.each(t,function(e,t){i._setOption(e,t),e in n&&(s=!0),e in r&&(o[e]=t)}),s&&(this._size(),this._position()),this.uiDialog.is(":data(ui-resizable)")&&this.uiDialog.resizable("option",o)},_setOption:function(e,t){var n,r,i=this.uiDialog;e==="dialogClass"&&i.removeClass(this.options.dialogClass).addClass(t);if(e==="disabled")return;this._super(e,t),e==="appendTo"&&this.uiDialog.appendTo(this._appendTo()),e==="buttons"&&this._createButtons(),e==="closeText"&&this.uiDialogTitlebarClose.button({label:""+t}),e==="draggable"&&(n=i.is(":data(ui-draggable)"),n&&!t&&i.draggable("destroy"),!n&&t&&this._makeDraggable()),e==="position"&&this._position(),e==="resizable"&&(r=i.is(":data(ui-resizable)"),r&&!t&&i.resizable("destroy"),r&&typeof t=="string"&&i.resizable("option","handles",t),!r&&t!==!1&&this._makeResizable()),e==="title"&&this._title(this.uiDialogTitlebar.find(".ui-dialog-title"))},_size:function(){var e,t,n,r=this.options;this.element.show().css({width:"auto",minHeight:0,maxHeight:"none",height:0}),r.minWidth>r.width&&(r.width=r.minWidth),e=this.uiDialog.css({height:"auto",width:r.width}).outerHeight(),t=Math.max(0,r.minHeight-e),n=typeof r.maxHeight=="number"?Math.max(0,r.maxHeight-e):"none",r.height==="auto"?this.element.css({minHeight:t,maxHeight:n,height:"auto"}):this.element.height(Math.max(0,r.height-e)),this.uiDialog.is(":data(ui-resizable)")&&this.uiDialog.resizable("option","minHeight",this._minHeight())},_blockFrames:function(){this.iframeBlocks=this.document.find("iframe").map(function(){var t=e(this);return e("<div>").css({position:"absolute",width:t.outerWidth(),height:t.outerHeight()}).appendTo(t.parent()).offset(t.offset())[0]})},_unblockFrames:function(){this.iframeBlocks&&(this.iframeBlocks.remove(),delete this.iframeBlocks)},_createOverlay:function(){if(!this.options.modal)return;e.ui.dialog.overlayInstances||this._delay(function(){e.ui.dialog.overlayInstances&&this.document.bind("focusin.dialog",function(t){!e(t.target).closest(".ui-dialog").length&&!e(t.target).closest(".ui-datepicker").length&&(t.preventDefault(),e(".ui-dialog:visible:last .ui-dialog-content").data("ui-dialog")._focusTabbable())})}),this.overlay=e("<div>").addClass("ui-widget-overlay ui-front").appendTo(this._appendTo()),this._on(this.overlay,{mousedown:"_keepFocus"}),e.ui.dialog.overlayInstances++},_destroyOverlay:function(){if(!this.options.modal)return;this.overlay&&(e.ui.dialog.overlayInstances--,e.ui.dialog.overlayInstances||this.document.unbind("focusin.dialog"),this.overlay.remove(),this.overlay=null)}}),e.ui.dialog.overlayInstances=0,e.uiBackCompat!==!1&&e.widget("ui.dialog",e.ui.dialog,{_position:function(){var t=this.options.position,n=[],r=[0,0],i;if(t){if(typeof t=="string"||typeof t=="object"&&"0"in t)n=t.split?t.split(" "):[t[0],t[1]],n.length===1&&(n[1]=n[0]),e.each(["left","top"],function(e,t){+n[e]===n[e]&&(r[e]=n[e],n[e]=t)}),t={my:n[0]+(r[0]<0?r[0]:"+"+r[0])+" "+n[1]+(r[1]<0?r[1]:"+"+r[1]),at:n.join(" ")};t=e.extend({},e.ui.dialog.prototype.options.position,t)}else t=e.ui.dialog.prototype.options.position;i=this.uiDialog.is(":visible"),i||this.uiDialog.show(),this.uiDialog.position(t),i||this.uiDialog.hide()}})}(jQuery),function(e,t){var n=/up|down|vertical/,r=/up|left|vertical|horizontal/;e.effects.effect.blind=function(t,i){var s=e(this),o=["position","top","bottom","left","right","height","width"],u=e.effects.setMode(s,t.mode||"hide"),a=t.direction||"up",f=n.test(a),l=f?"height":"width",c=f?"top":"left",h=r.test(a),p={},d=u==="show",v,m,g;s.parent().is(".ui-effects-wrapper")?e.effects.save(s.parent(),o):e.effects.save(s,o),s.show(),v=e.effects.createWrapper(s).css({overflow:"hidden"}),m=v[l](),g=parseFloat(v.css(c))||0,p[l]=d?m:0,h||(s.css(f?"bottom":"right",0).css(f?"top":"left","auto").css({position:"absolute"}),p[c]=d?g:m+g),d&&(v.css(l,0),h||v.css(c,g+m)),v.animate(p,{duration:t.duration,easing:t.easing,queue:!1,complete:function(){u==="hide"&&s.hide(),e.effects.restore(s,o),e.effects.removeWrapper(s),i()}})}}(jQuery),function(e,t){e.effects.effect.bounce=function(t,n){var r=e(this),i=["position","top","bottom","left","right","height","width"],s=e.effects.setMode(r,t.mode||"effect"),o=s==="hide",u=s==="show",a=t.direction||"up",f=t.distance,l=t.times||5,c=l*2+(u||o?1:0),h=t.duration/c,p=t.easing,d=a==="up"||a==="down"?"top":"left",v=a==="up"||a==="left",m,g,y,b=r.queue(),w=b.length;(u||o)&&i.push("opacity"),e.effects.save(r,i),r.show(),e.effects.createWrapper(r),f||(f=r[d==="top"?"outerHeight":"outerWidth"]()/3),u&&(y={opacity:1},y[d]=0,r.css("opacity",0).css(d,v?-f*2:f*2).animate(y,h,p)),o&&(f/=Math.pow(2,l-1)),y={},y[d]=0;for(m=0;m<l;m++)g={},g[d]=(v?"-=":"+=")+f,r.animate(g,h,p).animate(y,h,p),f=o?f*2:f/2;o&&(g={opacity:0},g[d]=(v?"-=":"+=")+f,r.animate(g,h,p)),r.queue(function(){o&&r.hide(),e.effects.restore(r,i),e.effects.removeWrapper(r),n()}),w>1&&b.splice.apply(b,[1,0].concat(b.splice(w,c+1))),r.dequeue()}}(jQuery),function(e,t){e.effects.effect.clip=function(t,n){var r=e(this),i=["position","top","bottom","left","right","height","width"],s=e.effects.setMode(r,t.mode||"hide"),o=s==="show",u=t.direction||"vertical",a=u==="vertical",f=a?"height":"width",l=a?"top":"left",c={},h,p,d;e.effects.save(r,i),r.show(),h=e.effects.createWrapper(r).css({overflow:"hidden"}),p=r[0].tagName==="IMG"?h:r,d=p[f](),o&&(p.css(f,0),p.css(l,d/2)),c[f]=o?d:0,c[l]=o?0:d/2,p.animate(c,{queue:!1,duration:t.duration,easing:t.easing,complete:function(){o||r.hide(),e.effects.restore(r,i),e.effects.removeWrapper(r),n()}})}}(jQuery),function(e,t){e.effects.effect.drop=function(t,n){var r=e(this),i=["position","top","bottom","left","right","opacity","height","width"],s=e.effects.setMode(r,t.mode||"hide"),o=s==="show",u=t.direction||"left",a=u==="up"||u==="down"?"top":"left",f=u==="up"||u==="left"?"pos":"neg",l={opacity:o?1:0},c;e.effects.save(r,i),r.show(),e.effects.createWrapper(r),c=t.distance||r[a==="top"?"outerHeight":"outerWidth"](!0)/2,o&&r.css("opacity",0).css(a,f==="pos"?-c:c),l[a]=(o?f==="pos"?"+=":"-=":f==="pos"?"-=":"+=")+c,r.animate(l,{queue:!1,duration:t.duration,easing:t.easing,complete:function(){s==="hide"&&r.hide(),e.effects.restore(r,i),e.effects.removeWrapper(r),n()}})}}(jQuery),function(e,t){e.effects.effect.explode=function(t,n){function y(){c.push(this),c.length===r*i&&b()}function b(){s.css({visibility:"visible"}),e(c).remove(),u||s.hide(),n()}var r=t.pieces?Math.round(Math.sqrt(t.pieces)):3,i=r,s=e(this),o=e.effects.setMode(s,t.mode||"hide"),u=o==="show",a=s.show().css("visibility","hidden").offset(),f=Math.ceil(s.outerWidth()/i),l=Math.ceil(s.outerHeight()/r),c=[],h,p,d,v,m,g;for(h=0;h<r;h++){v=a.top+h*l,g=h-(r-1)/2;for(p=0;p<i;p++)d=a.left+p*f,m=p-(i-1)/2,s.clone().appendTo("body").wrap("<div></div>").css({position:"absolute",visibility:"visible",left:-p*f,top:-h*l}).parent().addClass("ui-effects-explode").css({position:"absolute",overflow:"hidden",width:f,height:l,left:d+(u?m*f:0),top:v+(u?g*l:0),opacity:u?0:1}).animate({left:d+(u?0:m*f),top:v+(u?0:g*l),opacity:u?1:0},t.duration||500,t.easing,y)}}}(jQuery),function(e,t){e.effects.effect.fade=function(t,n){var r=e(this),i=e.effects.setMode(r,t.mode||"toggle");r.animate({opacity:i},{queue:!1,duration:t.duration,easing:t.easing,complete:n})}}(jQuery),function(e,t){e.effects.effect.fold=function(t,n){var r=e(this),i=["position","top","bottom","left","right","height","width"],s=e.effects.setMode(r,t.mode||"hide"),o=s==="show",u=s==="hide",a=t.size||15,f=/([0-9]+)%/.exec(a),l=!!t.horizFirst,c=o!==l,h=c?["width","height"]:["height","width"],p=t.duration/2,d,v,m={},g={};e.effects.save(r,i),r.show(),d=e.effects.createWrapper(r).css({overflow:"hidden"}),v=c?[d.width(),d.height()]:[d.height(),d.width()],f&&(a=parseInt(f[1],10)/100*v[u?0:1]),o&&d.css(l?{height:0,width:a}:{height:a,width:0}),m[h[0]]=o?v[0]:a,g[h[1]]=o?v[1]:0,d.animate(m,p,t.easing).animate(g,p,t.easing,function(){u&&r.hide(),e.effects.restore(r,i),e.effects.removeWrapper(r),n()})}}(jQuery),function(e,t){e.effects.effect.highlight=function(t,n){var r=e(this),i=["backgroundImage","backgroundColor","opacity"],s=e.effects.setMode(r,t.mode||"show"),o={backgroundColor:r.css("backgroundColor")};s==="hide"&&(o.opacity=0),e.effects.save(r,i),r.show().css({backgroundImage:"none",backgroundColor:t.color||"#ffff99"}).animate(o,{queue:!1,duration:t.duration,easing:t.easing,complete:function(){s==="hide"&&r.hide(),e.effects.restore(r,i),n()}})}}(jQuery),function(e,t){e.effects.effect.pulsate=function(t,n){var r=e(this),i=e.effects.setMode(r,t.mode||"show"),s=i==="show",o=i==="hide",u=s||i==="hide",a=(t.times||5)*2+(u?1:0),f=t.duration/a,l=0,c=r.queue(),h=c.length,p;if(s||!r.is(":visible"))r.css("opacity",0).show(),l=1;for(p=1;p<a;p++)r.animate({opacity:l},f,t.easing),l=1-l;r.animate({opacity:l},f,t.easing),r.queue(function(){o&&r.hide(),n()}),h>1&&c.splice.apply(c,[1,0].concat(c.splice(h,a+1))),r.dequeue()}}(jQuery),function(e,t){e.effects.effect.puff=function(t,n){var r=e(this),i=e.effects.setMode(r,t.mode||"hide"),s=i==="hide",o=parseInt(t.percent,10)||150,u=o/100,a={height:r.height(),width:r.width(),outerHeight:r.outerHeight(),outerWidth:r.outerWidth()};e.extend(t,{effect:"scale",queue:!1,fade:!0,mode:i,complete:n,percent:s?o:100,from:s?a:{height:a.height*u,width:a.width*u,outerHeight:a.outerHeight*u,outerWidth:a.outerWidth*u}}),r.effect(t)},e.effects.effect.scale=function(t,n){var r=e(this),i=e.extend(!0,{},t),s=e.effects.setMode(r,t.mode||"effect"),o=parseInt(t.percent,10)||(parseInt(t.percent,10)===0?0:s==="hide"?0:100),u=t.direction||"both",a=t.origin,f={height:r.height(),width:r.width(),outerHeight:r.outerHeight(),outerWidth:r.outerWidth()},l={y:u!=="horizontal"?o/100:1,x:u!=="vertical"?o/100:1};i.effect="size",i.queue=!1,i.complete=n,s!=="effect"&&(i.origin=a||["middle","center"],i.restore=!0),i.from=t.from||(s==="show"?{height:0,width:0,outerHeight:0,outerWidth:0}:f),i.to={height:f.height*l.y,width:f.width*l.x,outerHeight:f.outerHeight*l.y,outerWidth:f.outerWidth*l.x},i.fade&&(s==="show"&&(i.from.opacity=0,i.to.opacity=1),s==="hide"&&(i.from.opacity=1,i.to.opacity=0)),r.effect(i)},e.effects.effect.size=function(t,n){var r,i,s,o=e(this),u=["position","top","bottom","left","right","width","height","overflow","opacity"],a=["position","top","bottom","left","right","overflow","opacity"],f=["width","height","overflow"],l=["fontSize"],c=["borderTopWidth","borderBottomWidth","paddingTop","paddingBottom"],h=["borderLeftWidth","borderRightWidth","paddingLeft","paddingRight"],p=e.effects.setMode(o,t.mode||"effect"),d=t.restore||p!=="effect",v=t.scale||"both",m=t.origin||["middle","center"],g=o.css("position"),y=d?u:a,b={height:0,width:0,outerHeight:0,outerWidth:0};p==="show"&&o.show(),r={height:o.height(),width:o.width(),outerHeight:o.outerHeight(),outerWidth:o.outerWidth()},t.mode==="toggle"&&p==="show"?(o.from=t.to||b,o.to=t.from||r):(o.from=t.from||(p==="show"?b:r),o.to=t.to||(p==="hide"?b:r)),s={from:{y:o.from.height/r.height,x:o.from.width/r.width},to:{y:o.to.height/r.height,x:o.to.width/r.width}};if(v==="box"||v==="both")s.from.y!==s.to.y&&(y=y.concat(c),o.from=e.effects.setTransition(o,c,s.from.y,o.from),o.to=e.effects.setTransition(o,c,s.to.y,o.to)),s.from.x!==s.to.x&&(y=y.concat(h),o.from=e.effects.setTransition(o,h,s.from.x,o.from),o.to=e.effects.setTransition(o,h,s.to.x,o.to));(v==="content"||v==="both")&&s.from.y!==s.to.y&&(y=y.concat(l).concat(f),o.from=e.effects.setTransition(o,l,s.from.y,o.from),o.to=e.effects.setTransition(o,l,s.to.y,o.to)),e.effects.save(o,y),o.show(),e.effects.createWrapper(o),o.css("overflow","hidden").css(o.from),m&&(i=e.effects.getBaseline(m,r),o.from.top=(r.outerHeight-o.outerHeight())*i.y,o.from.left=(r.outerWidth-o.outerWidth())*i.x,o.to.top=(r.outerHeight-o.to.outerHeight)*i.y,o.to.left=(r.outerWidth-o.to.outerWidth)*i.x),o.css(o.from);if(v==="content"||v==="both")c=c.concat(["marginTop","marginBottom"]).concat(l),h=h.concat(["marginLeft","marginRight"]),f=u.concat(c).concat(h),o.find("*[width]").each(function(){var n=e(this),r={height:n.height(),width:n.width(),outerHeight:n.outerHeight(),outerWidth:n.outerWidth()};d&&e.effects.save(n,f),n.from={height:r.height*s.from.y,width:r.width*s.from.x,outerHeight:r.outerHeight*s.from.y,outerWidth:r.outerWidth*s.from.x},n.to={height:r.height*s.to.y,width:r.width*s.to.x,outerHeight:r.height*s.to.y,outerWidth:r.width*s.to.x},s.from.y!==s.to.y&&(n.from=e.effects.setTransition(n,c,s.from.y,n.from),n.to=e.effects.setTransition(n,c,s.to.y,n.to)),s.from.x!==s.to.x&&(n.from=e.effects.setTransition(n,h,s.from.x,n.from),n.to=e.effects.setTransition(n,h,s.to.x,n.to)),n.css(n.from),n.animate(n.to,t.duration,t.easing,function(){d&&e.effects.restore(n,f)})});o.animate(o.to,{queue:!1,duration:t.duration,easing:t.easing,complete:function(){o.to.opacity===0&&o.css("opacity",o.from.opacity),p==="hide"&&o.hide(),e.effects.restore(o,y),d||(g==="static"?o.css({position:"relative",top:o.to.top,left:o.to.left}):e.each(["top","left"],function(e,t){o.css(t,function(t,n){var r=parseInt(n,10),i=e?o.to.left:o.to.top;return n==="auto"?i+"px":r+i+"px"})})),e.effects.removeWrapper(o),n()}})}}(jQuery),function(e,t){e.effects.effect.shake=function(t,n){var r=e(this),i=["position","top","bottom","left","right","height","width"],s=e.effects.setMode(r,t.mode||"effect"),o=t.direction||"left",u=t.distance||20,a=t.times||3,f=a*2+1,l=Math.round(t.duration/f),c=o==="up"||o==="down"?"top":"left",h=o==="up"||o==="left",p={},d={},v={},m,g=r.queue(),y=g.length;e.effects.save(r,i),r.show(),e.effects.createWrapper(r),p[c]=(h?"-=":"+=")+u,d[c]=(h?"+=":"-=")+u*2,v[c]=(h?"-=":"+=")+u*2,r.animate(p,l,t.easing);for(m=1;m<a;m++)r.animate(d,l,t.easing).animate(v,l,t.easing);r.animate(d,l,t.easing).animate(p,l/2,t.easing).queue(function(){s==="hide"&&r.hide(),e.effects.restore(r,i),e.effects.removeWrapper(r),n()}),y>1&&g.splice.apply(g,[1,0].concat(g.splice(y,f+1))),r.dequeue()}}(jQuery),function(e,t){e.effects.effect.slide=function(t,n){var r=e(this),i=["position","top","bottom","left","right","width","height"],s=e.effects.setMode(r,t.mode||"show"),o=s==="show",u=t.direction||"left",a=u==="up"||u==="down"?"top":"left",f=u==="up"||u==="left",l,c={};e.effects.save(r,i),r.show(),l=t.distance||r[a==="top"?"outerHeight":"outerWidth"](!0),e.effects.createWrapper(r).css({overflow:"hidden"}),o&&r.css(a,f?isNaN(l)?"-"+l:-l:l),c[a]=(o?f?"+=":"-=":f?"-=":"+=")+l,r.animate(c,{queue:!1,duration:t.duration,easing:t.easing,complete:function(){s==="hide"&&r.hide(),e.effects.restore(r,i),e.effects.removeWrapper(r),n()}})}}(jQuery),function(e,t){e.effects.effect.transfer=function(t,n){var r=e(this),i=e(t.to),s=i.css("position")==="fixed",o=e("body"),u=s?o.scrollTop():0,a=s?o.scrollLeft():0,f=i.offset(),l={top:f.top-u,left:f.left-a,height:i.innerHeight(),width:i.innerWidth()},c=r.offset(),h=e("<div class='ui-effects-transfer'></div>").appendTo(document.body).addClass(t.className).css({top:c.top-u,left:c.left-a,height:r.innerHeight(),width:r.innerWidth(),position:s?"fixed":"absolute"}).animate(l,t.duration,t.easing,function(){h.remove(),n()})}}(jQuery),function(e,t){e.widget("ui.menu",{version:"1.10.1",defaultElement:"<ul>",delay:300,options:{icons:{submenu:"ui-icon-carat-1-e"},menus:"ul",position:{my:"left top",at:"right top"},role:"menu",blur:null,focus:null,select:null},_create:function(){this.activeMenu=this.element,this.mouseHandled=!1,this.element.uniqueId().addClass("ui-menu ui-widget ui-widget-content ui-corner-all").toggleClass("ui-menu-icons",!!this.element.find(".ui-icon").length).attr({role:this.options.role,tabIndex:0}).bind("click"+this.eventNamespace,e.proxy(function(e){this.options.disabled&&e.preventDefault()},this)),this.options.disabled&&this.element.addClass("ui-state-disabled").attr("aria-disabled","true"),this._on({"mousedown .ui-menu-item > a":function(e){e.preventDefault()},"click .ui-state-disabled > a":function(e){e.preventDefault()},"click .ui-menu-item:has(a)":function(t){var n=e(t.target).closest(".ui-menu-item");!this.mouseHandled&&n.not(".ui-state-disabled").length&&(this.mouseHandled=!0,this.select(t),n.has(".ui-menu").length?this.expand(t):this.element.is(":focus")||(this.element.trigger("focus",[!0]),this.active&&this.active.parents(".ui-menu").length===1&&clearTimeout(this.timer)))},"mouseenter .ui-menu-item":function(t){var n=e(t.currentTarget);n.siblings().children(".ui-state-active").removeClass("ui-state-active"),this.focus(t,n)},mouseleave:"collapseAll","mouseleave .ui-menu":"collapseAll",focus:function(e,t){var n=this.active||this.element.children(".ui-menu-item").eq(0);t||this.focus(e,n)},blur:function(t){this._delay(function(){e.contains(this.element[0],this.document[0].activeElement)||this.collapseAll(t)})},keydown:"_keydown"}),this.refresh(),this._on(this.document,{click:function(t){e(t.target).closest(".ui-menu").length||this.collapseAll(t),this.mouseHandled=!1}})},_destroy:function(){this.element.removeAttr("aria-activedescendant").find(".ui-menu").addBack().removeClass("ui-menu ui-widget ui-widget-content ui-corner-all ui-menu-icons").removeAttr("role").removeAttr("tabIndex").removeAttr("aria-labelledby").removeAttr("aria-expanded").removeAttr("aria-hidden").removeAttr("aria-disabled").removeUniqueId().show(),this.element.find(".ui-menu-item").removeClass("ui-menu-item").removeAttr("role").removeAttr("aria-disabled").children("a").removeUniqueId().removeClass("ui-corner-all ui-state-hover").removeAttr("tabIndex").removeAttr("role").removeAttr("aria-haspopup").children().each(function(){var t=e(this);t.data("ui-menu-submenu-carat")&&t.remove()}),this.element.find(".ui-menu-divider").removeClass("ui-menu-divider ui-widget-content")},_keydown:function(t){function a(e){return e.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g,"\\$&")}var n,r,i,s,o,u=!0;switch(t.keyCode){case e.ui.keyCode.PAGE_UP:this.previousPage(t);break;case e.ui.keyCode.PAGE_DOWN:this.nextPage(t);break;case e.ui.keyCode.HOME:this._move("first","first",t);break;case e.ui.keyCode.END:this._move("last","last",t);break;case e.ui.keyCode.UP:this.previous(t);break;case e.ui.keyCode.DOWN:this.next(t);break;case e.ui.keyCode.LEFT:this.collapse(t);break;case e.ui.keyCode.RIGHT:this.active&&!this.active.is(".ui-state-disabled")&&this.expand(t);break;case e.ui.keyCode.ENTER:case e.ui.keyCode.SPACE:this._activate(t);break;case e.ui.keyCode.ESCAPE:this.collapse(t);break;default:u=!1,r=this.previousFilter||"",i=String.fromCharCode(t.keyCode),s=!1,clearTimeout(this.filterTimer),i===r?s=!0:i=r+i,o=new RegExp("^"+a(i),"i"),n=this.activeMenu.children(".ui-menu-item").filter(function(){return o.test(e(this).children("a").text())}),n=s&&n.index(this.active.next())!==-1?this.active.nextAll(".ui-menu-item"):n,n.length||(i=String.fromCharCode(t.keyCode),o=new RegExp("^"+a(i),"i"),n=this.activeMenu.children(".ui-menu-item").filter(function(){return o.test(e(this).children("a").text())})),n.length?(this.focus(t,n),n.length>1?(this.previousFilter=i,this.filterTimer=this._delay(function(){delete this.previousFilter},1e3)):delete this.previousFilter):delete this.previousFilter}u&&t.preventDefault()},_activate:function(e){this.active.is(".ui-state-disabled")||(this.active.children("a[aria-haspopup='true']").length?this.expand(e):this.select(e))},refresh:function(){var t,n=this.options.icons.submenu,r=this.element.find(this.options.menus);r.filter(":not(.ui-menu)").addClass("ui-menu ui-widget ui-widget-content ui-corner-all").hide().attr({role:this.options.role,"aria-hidden":"true","aria-expanded":"false"}).each(function(){var t=e(this),r=t.prev("a"),i=e("<span>").addClass("ui-menu-icon ui-icon "+n).data("ui-menu-submenu-carat",!0);r.attr("aria-haspopup","true").prepend(i),t.attr("aria-labelledby",r.attr("id"))}),t=r.add(this.element),t.children(":not(.ui-menu-item):has(a)").addClass("ui-menu-item").attr("role","presentation").children("a").uniqueId().addClass("ui-corner-all").attr({tabIndex:-1,role:this._itemRole()}),t.children(":not(.ui-menu-item)").each(function(){var t=e(this);/[^\-\u2014\u2013\s]/.test(t.text())||t.addClass("ui-widget-content ui-menu-divider")}),t.children(".ui-state-disabled").attr("aria-disabled","true"),this.active&&!e.contains(this.element[0],this.active[0])&&this.blur()},_itemRole:function(){return{menu:"menuitem",listbox:"option"}[this.options.role]},_setOption:function(e,t){e==="icons"&&this.element.find(".ui-menu-icon").removeClass(this.options.icons.submenu).addClass(t.submenu),this._super(e,t)},focus:function(e,t){var n,r;this.blur(e,e&&e.type==="focus"),this._scrollIntoView(t),this.active=t.first(),r=this.active.children("a").addClass("ui-state-focus"),this.options.role&&this.element.attr("aria-activedescendant",r.attr("id")),this.active.parent().closest(".ui-menu-item").children("a:first").addClass("ui-state-active"),e&&e.type==="keydown"?this._close():this.timer=this._delay(function(){this._close()},this.delay),n=t.children(".ui-menu"),n.length&&/^mouse/.test(e.type)&&this._startOpening(n),this.activeMenu=t.parent(),this._trigger("focus",e,{item:t})},_scrollIntoView:function(t){var n,r,i,s,o,u;this._hasScroll()&&(n=parseFloat(e.css(this.activeMenu[0],"borderTopWidth"))||0,r=parseFloat(e.css(this.activeMenu[0],"paddingTop"))||0,i=t.offset().top-this.activeMenu.offset().top-n-r,s=this.activeMenu.scrollTop(),o=this.activeMenu.height(),u=t.height(),i<0?this.activeMenu.scrollTop(s+i):i+u>o&&this.activeMenu.scrollTop(s+i-o+u))},blur:function(e,t){t||clearTimeout(this.timer);if(!this.active)return;this.active.children("a").removeClass("ui-state-focus"),this.active=null,this._trigger("blur",e,{item:this.active})},_startOpening:function(e){clearTimeout(this.timer);if(e.attr("aria-hidden")!=="true")return;this.timer=this._delay(function(){this._close(),this._open(e)},this.delay)},_open:function(t){var n=e.extend({of:this.active},this.options.position);clearTimeout(this.timer),this.element.find(".ui-menu").not(t.parents(".ui-menu")).hide().attr("aria-hidden","true"),t.show().removeAttr("aria-hidden").attr("aria-expanded","true").position(n)},collapseAll:function(t,n){clearTimeout(this.timer),this.timer=this._delay(function(){var r=n?this.element:e(t&&t.target).closest(this.element.find(".ui-menu"));r.length||(r=this.element),this._close(r),this.blur(t),this.activeMenu=r},this.delay)},_close:function(e){e||(e=this.active?this.active.parent():this.element),e.find(".ui-menu").hide().attr("aria-hidden","true").attr("aria-expanded","false").end().find("a.ui-state-active").removeClass("ui-state-active")},collapse:function(e){var t=this.active&&this.active.parent().closest(".ui-menu-item",this.element);t&&t.length&&(this._close(),this.focus(e,t))},expand:function(e){var t=this.active&&this.active.children(".ui-menu ").children(".ui-menu-item").first();t&&t.length&&(this._open(t.parent()),this._delay(function(){this.focus(e,t)}))},next:function(e){this._move("next","first",e)},previous:function(e){this._move("prev","last",e)},isFirstItem:function(){return this.active&&!this.active.prevAll(".ui-menu-item").length},isLastItem:function(){return this.active&&!this.active.nextAll(".ui-menu-item").length},_move:function(e,t,n){var r;this.active&&(e==="first"||e==="last"?r=this.active[e==="first"?"prevAll":"nextAll"](".ui-menu-item").eq(-1):r=this.active[e+"All"](".ui-menu-item").eq(0));if(!r||!r.length||!this.active)r=this.activeMenu.children(".ui-menu-item")[t]();this.focus(n,r)},nextPage:function(t){var n,r,i;if(!this.active){this.next(t);return}if(this.isLastItem())return;this._hasScroll()?(r=this.active.offset().top,i=this.element.height(),this.active.nextAll(".ui-menu-item").each(function(){return n=e(this),n.offset().top-r-i<0}),this.focus(t,n)):this.focus(t,this.activeMenu.children(".ui-menu-item")[this.active?"last":"first"]())},previousPage:function(t){var n,r,i;if(!this.active){this.next(t);return}if(this.isFirstItem())return;this._hasScroll()?(r=this.active.offset().top,i=this.element.height(),this.active.prevAll(".ui-menu-item").each(function(){return n=e(this),n.offset().top-r+i>0}),this.focus(t,n)):this.focus(t,this.activeMenu.children(".ui-menu-item").first())},_hasScroll:function(){return this.element.outerHeight()<this.element.prop("scrollHeight")},select:function(t){this.active=this.active||e(t.target).closest(".ui-menu-item");var n={item:this.active};this.active.has(".ui-menu").length||this.collapseAll(t,!0),this._trigger("select",t,n)}})}(jQuery),function(e,t){function h(e,t,n){return[parseFloat(e[0])*(l.test(e[0])?t/100:1),parseFloat(e[1])*(l.test(e[1])?n/100:1)]}function p(t,n){return parseInt(e.css(t,n),10)||0}function d(t){var n=t[0];return n.nodeType===9?{width:t.width(),height:t.height(),offset:{top:0,left:0}}:e.isWindow(n)?{width:t.width(),height:t.height(),offset:{top:t.scrollTop(),left:t.scrollLeft()}}:n.preventDefault?{width:0,height:0,offset:{top:n.pageY,left:n.pageX}}:{width:t.outerWidth(),height:t.outerHeight(),offset:t.offset()}}e.ui=e.ui||{};var n,r=Math.max,i=Math.abs,s=Math.round,o=/left|center|right/,u=/top|center|bottom/,a=/[\+\-]\d+(\.[\d]+)?%?/,f=/^\w+/,l=/%$/,c=e.fn.position;e.position={scrollbarWidth:function(){if(n!==t)return n;var r,i,s=e("<div style='display:block;width:50px;height:50px;overflow:hidden;'><div style='height:100px;width:auto;'></div></div>"),o=s.children()[0];return e("body").append(s),r=o.offsetWidth,s.css("overflow","scroll"),i=o.offsetWidth,r===i&&(i=s[0].clientWidth),s.remove(),n=r-i},getScrollInfo:function(t){var n=t.isWindow?"":t.element.css("overflow-x"),r=t.isWindow?"":t.element.css("overflow-y"),i=n==="scroll"||n==="auto"&&t.width<t.element[0].scrollWidth,s=r==="scroll"||r==="auto"&&t.height<t.element[0].scrollHeight;return{width:i?e.position.scrollbarWidth():0,height:s?e.position.scrollbarWidth():0}},getWithinInfo:function(t){var n=e(t||window),r=e.isWindow(n[0]);return{element:n,isWindow:r,offset:n.offset()||{left:0,top:0},scrollLeft:n.scrollLeft(),scrollTop:n.scrollTop(),width:r?n.width():n.outerWidth(),height:r?n.height():n.outerHeight()}}},e.fn.position=function(t){if(!t||!t.of)return c.apply(this,arguments);t=e.extend({},t);var n,l,v,m,g,y,b=e(t.of),w=e.position.getWithinInfo(t.within),E=e.position.getScrollInfo(w),S=(t.collision||"flip").split(" "),x={};return y=d(b),b[0].preventDefault&&(t.at="left top"),l=y.width,v=y.height,m=y.offset,g=e.extend({},m),e.each(["my","at"],function(){var e=(t[this]||"").split(" "),n,r;e.length===1&&(e=o.test(e[0])?e.concat(["center"]):u.test(e[0])?["center"].concat(e):["center","center"]),e[0]=o.test(e[0])?e[0]:"center",e[1]=u.test(e[1])?e[1]:"center",n=a.exec(e[0]),r=a.exec(e[1]),x[this]=[n?n[0]:0,r?r[0]:0],t[this]=[f.exec(e[0])[0],f.exec(e[1])[0]]}),S.length===1&&(S[1]=S[0]),t.at[0]==="right"?g.left+=l:t.at[0]==="center"&&(g.left+=l/2),t.at[1]==="bottom"?g.top+=v:t.at[1]==="center"&&(g.top+=v/2),n=h(x.at,l,v),g.left+=n[0],g.top+=n[1],this.each(function(){var o,u,a=e(this),f=a.outerWidth(),c=a.outerHeight(),d=p(this,"marginLeft"),y=p(this,"marginTop"),T=f+d+p(this,"marginRight")+E.width,N=c+y+p(this,"marginBottom")+E.height,C=e.extend({},g),k=h(x.my,a.outerWidth(),a.outerHeight());t.my[0]==="right"?C.left-=f:t.my[0]==="center"&&(C.left-=f/2),t.my[1]==="bottom"?C.top-=c:t.my[1]==="center"&&(C.top-=c/2),C.left+=k[0],C.top+=k[1],e.support.offsetFractions||(C.left=s(C.left),C.top=s(C.top)),o={marginLeft:d,marginTop:y},e.each(["left","top"],function(r,i){e.ui.position[S[r]]&&e.ui.position[S[r]][i](C,{targetWidth:l,targetHeight:v,elemWidth:f,elemHeight:c,collisionPosition:o,collisionWidth:T,collisionHeight:N,offset:[n[0]+k[0],n[1]+k[1]],my:t.my,at:t.at,within:w,elem:a})}),t.using&&(u=function(e){var n=m.left-C.left,s=n+l-f,o=m.top-C.top,u=o+v-c,h={target:{element:b,left:m.left,top:m.top,width:l,height:v},element:{element:a,left:C.left,top:C.top,width:f,height:c},horizontal:s<0?"left":n>0?"right":"center",vertical:u<0?"top":o>0?"bottom":"middle"};l<f&&i(n+s)<l&&(h.horizontal="center"),v<c&&i(o+u)<v&&(h.vertical="middle"),r(i(n),i(s))>r(i(o),i(u))?h.important="horizontal":h.important="vertical",t.using.call(this,e,h)}),a.offset(e.extend(C,{using:u}))})},e.ui.position={fit:{left:function(e,t){var n=t.within,i=n.isWindow?n.scrollLeft:n.offset.left,s=n.width,o=e.left-t.collisionPosition.marginLeft,u=i-o,a=o+t.collisionWidth-s-i,f;t.collisionWidth>s?u>0&&a<=0?(f=e.left+u+t.collisionWidth-s-i,e.left+=u-f):a>0&&u<=0?e.left=i:u>a?e.left=i+s-t.collisionWidth:e.left=i:u>0?e.left+=u:a>0?e.left-=a:e.left=r(e.left-o,e.left)},top:function(e,t){var n=t.within,i=n.isWindow?n.scrollTop:n.offset.top,s=t.within.height,o=e.top-t.collisionPosition.marginTop,u=i-o,a=o+t.collisionHeight-s-i,f;t.collisionHeight>s?u>0&&a<=0?(f=e.top+u+t.collisionHeight-s-i,e.top+=u-f):a>0&&u<=0?e.top=i:u>a?e.top=i+s-t.collisionHeight:e.top=i:u>0?e.top+=u:a>0?e.top-=a:e.top=r(e.top-o,e.top)}},flip:{left:function(e,t){var n=t.within,r=n.offset.left+n.scrollLeft,s=n.width,o=n.isWindow?n.scrollLeft:n.offset.left,u=e.left-t.collisionPosition.marginLeft,a=u-o,f=u+t.collisionWidth-s-o,l=t.my[0]==="left"?-t.elemWidth:t.my[0]==="right"?t.elemWidth:0,c=t.at[0]==="left"?t.targetWidth:t.at[0]==="right"?-t.targetWidth:0,h=-2*t.offset[0],p,d;if(a<0){p=e.left+l+c+h+t.collisionWidth-s-r;if(p<0||p<i(a))e.left+=l+c+h}else if(f>0){d=e.left-t.collisionPosition.marginLeft+l+c+h-o;if(d>0||i(d)<f)e.left+=l+c+h}},top:function(e,t){var n=t.within,r=n.offset.top+n.scrollTop,s=n.height,o=n.isWindow?n.scrollTop:n.offset.top,u=e.top-t.collisionPosition.marginTop,a=u-o,f=u+t.collisionHeight-s-o,l=t.my[1]==="top",c=l?-t.elemHeight:t.my[1]==="bottom"?t.elemHeight:0,h=t.at[1]==="top"?t.targetHeight:t.at[1]==="bottom"?-t.targetHeight:0,p=-2*t.offset[1],d,v;a<0?(v=e.top+c+h+p+t.collisionHeight-s-r,e.top+c+h+p>a&&(v<0||v<i(a))&&(e.top+=c+h+p)):f>0&&(d=e.top-t.collisionPosition.marginTop+c+h+p-o,e.top+c+h+p>f&&(d>0||i(d)<f)&&(e.top+=c+h+p))}},flipfit:{left:function(){e.ui.position.flip.left.apply(this,arguments),e.ui.position.fit.left.apply(this,arguments)},top:function(){e.ui.position.flip.top.apply(this,arguments),e.ui.position.fit.top.apply(this,arguments)}}},function(){var t,n,r,i,s,o=document.getElementsByTagName("body")[0],u=document.createElement("div");t=document.createElement(o?"div":"body"),r={visibility:"hidden",width:0,height:0,border:0,margin:0,background:"none"},o&&e.extend(r,{position:"absolute",left:"-1000px",top:"-1000px"});for(s in r)t.style[s]=r[s];t.appendChild(u),n=o||document.documentElement,n.insertBefore(t,n.firstChild),u.style.cssText="position: absolute; left: 10.7432222px;",i=e(u).offset().left,e.support.offsetFractions=i>10&&i<11,t.innerHTML="",n.removeChild(t)}()}(jQuery),function(e,t){e.widget("ui.progressbar",{version:"1.10.1",options:{max:100,value:0,change:null,complete:null},min:0,_create:function(){this.oldValue=this.options.value=this._constrainedValue(),this.element.addClass("ui-progressbar ui-widget ui-widget-content ui-corner-all").attr({role:"progressbar","aria-valuemin":this.min}),this.valueDiv=e("<div class='ui-progressbar-value ui-widget-header ui-corner-left'></div>").appendTo(this.element),this._refreshValue()},_destroy:function(){this.element.removeClass("ui-progressbar ui-widget ui-widget-content ui-corner-all").removeAttr("role").removeAttr("aria-valuemin").removeAttr("aria-valuemax").removeAttr("aria-valuenow"),this.valueDiv.remove()},value:function(e){if(e===t)return this.options.value;this.options.value=this._constrainedValue(e),this._refreshValue()},_constrainedValue:function(e){return e===t&&(e=this.options.value),this.indeterminate=e===!1,typeof e!="number"&&(e=0),this.indeterminate?!1:Math.min(this.options.max,Math.max(this.min,e))},_setOptions:function(e){var t=e.value;delete e.value,this._super(e),this.options.value=this._constrainedValue(t),this._refreshValue()},_setOption:function(e,t){e==="max"&&(t=Math.max(this.min,t)),this._super(e,t)},_percentage:function(){return this.indeterminate?100:100*(this.options.value-this.min)/(this.options.max-this.min)},_refreshValue:function(){var t=this.options.value,n=this._percentage();this.valueDiv.toggle(this.indeterminate||t>this.min).toggleClass("ui-corner-right",t===this.options.max).width(n.toFixed(0)+"%"),this.element.toggleClass("ui-progressbar-indeterminate",this.indeterminate),this.indeterminate?(this.element.removeAttr("aria-valuenow"),this.overlayDiv||(this.overlayDiv=e("<div class='ui-progressbar-overlay'></div>").appendTo(this.valueDiv))):(this.element.attr({"aria-valuemax":this.options.max,"aria-valuenow":t}),this.overlayDiv&&(this.overlayDiv.remove(),this.overlayDiv=null)),this.oldValue!==t&&(this.oldValue=t,this._trigger("change")),t===this.options.max&&this._trigger("complete")}})}(jQuery),function(e,t){var n=5;e.widget("ui.slider",e.ui.mouse,{version:"1.10.1",widgetEventPrefix:"slide",options:{animate:!1,distance:0,max:100,min:0,orientation:"horizontal",range:!1,step:1,value:0,values:null,change:null,slide:null,start:null,stop:null},_create:function(){this._keySliding=!1,this._mouseSliding=!1,this._animateOff=!0,this._handleIndex=null,this._detectOrientation(),this._mouseInit(),this.element.addClass("ui-slider ui-slider-"+this.orientation+" ui-widget"+" ui-widget-content"+" ui-corner-all"),this._refresh(),this._setOption("disabled",this.options.disabled),this._animateOff=!1},_refresh:function(){this._createRange(),this._createHandles(),this._setupEvents(),this._refreshValue()},_createHandles:function(){var t,n,r=this.options,i=this.element.find(".ui-slider-handle").addClass("ui-state-default ui-corner-all"),s="<a class='ui-slider-handle ui-state-default ui-corner-all' href='#'></a>",o=[];n=r.values&&r.values.length||1,i.length>n&&(i.slice(n).remove(),i=i.slice(0,n));for(t=i.length;t<n;t++)o.push(s);this.handles=i.add(e(o.join("")).appendTo(this.element)),this.handle=this.handles.eq(0),this.handles.each(function(t){e(this).data("ui-slider-handle-index",t)})},_createRange:function(){var t=this.options,n="";t.range?(t.range===!0&&(t.values?t.values.length&&t.values.length!==2?t.values=[t.values[0],t.values[0]]:e.isArray(t.values)&&(t.values=t.values.slice(0)):t.values=[this._valueMin(),this._valueMin()]),!this.range||!this.range.length?(this.range=e("<div></div>").appendTo(this.element),n="ui-slider-range ui-widget-header ui-corner-all"):this.range.removeClass("ui-slider-range-min ui-slider-range-max").css({left:"",bottom:""}),this.range.addClass(n+(t.range==="min"||t.range==="max"?" ui-slider-range-"+t.range:""))):this.range=e([])},_setupEvents:function(){var e=this.handles.add(this.range).filter("a");this._off(e),this._on(e,this._handleEvents),this._hoverable(e),this._focusable(e)},_destroy:function(){this.handles.remove(),this.range.remove(),this.element.removeClass("ui-slider ui-slider-horizontal ui-slider-vertical ui-widget ui-widget-content ui-corner-all"),this._mouseDestroy()},_mouseCapture:function(t){var n,r,i,s,o,u,a,f,l=this,c=this.options;return c.disabled?!1:(this.elementSize={width:this.element.outerWidth(),height:this.element.outerHeight()},this.elementOffset=this.element.offset(),n={x:t.pageX,y:t.pageY},r=this._normValueFromMouse(n),i=this._valueMax()-this._valueMin()+1,this.handles.each(function(t){var n=Math.abs(r-l.values(t));if(i>n||i===n&&(t===l._lastChangedValue||l.values(t)===c.min))i=n,s=e(this),o=t}),u=this._start(t,o),u===!1?!1:(this._mouseSliding=!0,this._handleIndex=o,s.addClass("ui-state-active").focus(),a=s.offset(),f=!e(t.target).parents().addBack().is(".ui-slider-handle"),this._clickOffset=f?{left:0,top:0}:{left:t.pageX-a.left-s.width()/2,top:t.pageY-a.top-s.height()/2-(parseInt(s.css("borderTopWidth"),10)||0)-(parseInt(s.css("borderBottomWidth"),10)||0)+(parseInt(s.css("marginTop"),10)||0)},this.handles.hasClass("ui-state-hover")||this._slide(t,o,r),this._animateOff=!0,!0))},_mouseStart:function(){return!0},_mouseDrag:function(e){var t={x:e.pageX,y:e.pageY},n=this._normValueFromMouse(t);return this._slide(e,this._handleIndex,n),!1},_mouseStop:function(e){return this.handles.removeClass("ui-state-active"),this._mouseSliding=!1,this._stop(e,this._handleIndex),this._change(e,this._handleIndex),this._handleIndex=null,this._clickOffset=null,this._animateOff=!1,!1},_detectOrientation:function(){this.orientation=this.options.orientation==="vertical"?"vertical":"horizontal"},_normValueFromMouse:function(e){var t,n,r,i,s;return this.orientation==="horizontal"?(t=this.elementSize.width,n=e.x-this.elementOffset.left-(this._clickOffset?this._clickOffset.left:0)):(t=this.elementSize.height,n=e.y-this.elementOffset.top-(this._clickOffset?this._clickOffset.top:0)),r=n/t,r>1&&(r=1),r<0&&(r=0),this.orientation==="vertical"&&(r=1-r),i=this._valueMax()-this._valueMin(),s=this._valueMin()+r*i,this._trimAlignValue(s)},_start:function(e,t){var n={handle:this.handles[t],value:this.value()};return this.options.values&&this.options.values.length&&(n.value=this.values(t),n.values=this.values()),this._trigger("start",e,n)},_slide:function(e,t,n){var r,i,s;this.options.values&&this.options.values.length?(r=this.values(t?0:1),this.options.values.length===2&&this.options.range===!0&&(t===0&&n>r||t===1&&n<r)&&(n=r),n!==this.values(t)&&(i=this.values(),i[t]=n,s=this._trigger("slide",e,{handle:this.handles[t],value:n,values:i}),r=this.values(t?0:1),s!==!1&&this.values(t,n,!0))):n!==this.value()&&(s=this._trigger("slide",e,{handle:this.handles[t],value:n}),s!==!1&&this.value(n))},_stop:function(e,t){var n={handle:this.handles[t],value:this.value()};this.options.values&&this.options.values.length&&(n.value=this.values(t),n.values=this.values()),this._trigger("stop",e,n)},_change:function(e,t){if(!this._keySliding&&!this._mouseSliding){var n={handle:this.handles[t],value:this.value()};this.options.values&&this.options.values.length&&(n.value=this.values(t),n.values=this.values()),this._lastChangedValue=t,this._trigger("change",e,n)}},value:function(e){if(arguments.length){this.options.value=this._trimAlignValue(e),this._refreshValue(),this._change(null,0);return}return this._value()},values:function(t,n){var r,i,s;if(arguments.length>1){this.options.values[t]=this._trimAlignValue(n),this._refreshValue(),this._change(null,t);return}if(!arguments.length)return this._values();if(!e.isArray(arguments[0]))return this.options.values&&this.options.values.length?this._values(t):this.value();r=this.options.values,i=arguments[0];for(s=0;s<r.length;s+=1)r[s]=this._trimAlignValue(i[s]),this._change(null,s);this._refreshValue()},_setOption:function(t,n){var r,i=0;t==="range"&&this.options.range===!0&&(n==="min"?(this.options.value=this._values(0),this.options.values=null):n==="max"&&(this.options.value=this._values(this.options.values.length-1),this.options.values=null)),e.isArray(this.options.values)&&(i=this.options.values.length),e.Widget.prototype._setOption.apply(this,arguments);switch(t){case"orientation":this._detectOrientation(),this.element.removeClass("ui-slider-horizontal ui-slider-vertical").addClass("ui-slider-"+this.orientation),this._refreshValue();break;case"value":this._animateOff=!0,this._refreshValue(),this._change(null,0),this._animateOff=!1;break;case"values":this._animateOff=!0,this._refreshValue();for(r=0;r<i;r+=1)this._change(null,r);this._animateOff=!1;break;case"min":case"max":this._animateOff=!0,this._refreshValue(),this._animateOff=!1;break;case"range":this._animateOff=!0,this._refresh(),this._animateOff=!1}},_value:function(){var e=this.options.value;return e=this._trimAlignValue(e),e},_values:function(e){var t,n,r;if(arguments.length)return t=this.options.values[e],t=this._trimAlignValue(t),t;if(this.options.values&&this.options.values.length){n=this.options.values.slice();for(r=0;r<n.length;r+=1)n[r]=this._trimAlignValue(n[r]);return n}return[]},_trimAlignValue:function(e){if(e<=this._valueMin())return this._valueMin();if(e>=this._valueMax())return this._valueMax();var t=this.options.step>0?this.options.step:1,n=(e-this._valueMin())%t,r=e-n;return Math.abs(n)*2>=t&&(r+=n>0?t:-t),parseFloat(r.toFixed(5))},_valueMin:function(){return this.options.min},_valueMax:function(){return this.options.max},_refreshValue:function(){var t,n,r,i,s,o=this.options.range,u=this.options,a=this,f=this._animateOff?!1:u.animate,l={};this.options.values&&this.options.values.length?this.handles.each(function(r){n=(a.values(r)-a._valueMin())/(a._valueMax()-a._valueMin())*100,l[a.orientation==="horizontal"?"left":"bottom"]=n+"%",e(this).stop(1,1)[f?"animate":"css"](l,u.animate),a.options.range===!0&&(a.orientation==="horizontal"?(r===0&&a.range.stop(1,1)[f?"animate":"css"]({left:n+"%"},u.animate),r===1&&a.range[f?"animate":"css"]({width:n-t+"%"},{queue:!1,duration:u.animate})):(r===0&&a.range.stop(1,1)[f?"animate":"css"]({bottom:n+"%"},u.animate),r===1&&a.range[f?"animate":"css"]({height:n-t+"%"},{queue:!1,duration:u.animate}))),t=n}):(r=this.value(),i=this._valueMin(),s=this._valueMax(),n=s!==i?(r-i)/(s-i)*100:0,l[this.orientation==="horizontal"?"left":"bottom"]=n+"%",this.handle.stop(1,1)[f?"animate":"css"](l,u.animate),o==="min"&&this.orientation==="horizontal"&&this.range.stop(1,1)[f?"animate":"css"]({width:n+"%"},u.animate),o==="max"&&this.orientation==="horizontal"&&this.range[f?"animate":"css"]({width:100-n+"%"},{queue:!1,duration:u.animate}),o==="min"&&this.orientation==="vertical"&&this.range.stop(1,1)[f?"animate":"css"]({height:n+"%"},u.animate),o==="max"&&this.orientation==="vertical"&&this.range[f?"animate":"css"]({height:100-n+"%"},{queue:!1,duration:u.animate}))},_handleEvents:{keydown:function(t){var r,i,s,o,u=e(t.target).data("ui-slider-handle-index");switch(t.keyCode){case e.ui.keyCode.HOME:case e.ui.keyCode.END:case e.ui.keyCode.PAGE_UP:case e.ui.keyCode.PAGE_DOWN:case e.ui.keyCode.UP:case e.ui.keyCode.RIGHT:case e.ui.keyCode.DOWN:case e.ui.keyCode.LEFT:t.preventDefault();if(!this._keySliding){this._keySliding=!0,e(t.target).addClass("ui-state-active"),r=this._start(t,u);if(r===!1)return}}o=this.options.step,this.options.values&&this.options.values.length?i=s=this.values(u):i=s=this.value();switch(t.keyCode){case e.ui.keyCode.HOME:s=this._valueMin();break;case e.ui.keyCode.END:s=this._valueMax();break;case e.ui.keyCode.PAGE_UP:s=this._trimAlignValue(i+(this._valueMax()-this._valueMin())/n);break;case e.ui.keyCode.PAGE_DOWN:s=this._trimAlignValue(i-(this._valueMax()-this._valueMin())/n);break;case e.ui.keyCode.UP:case e.ui.keyCode.RIGHT:if(i===this._valueMax())return;s=this._trimAlignValue(i+o);break;case e.ui.keyCode.DOWN:case e.ui.keyCode.LEFT:if(i===this._valueMin())return;s=this._trimAlignValue(i-o)}this._slide(t,u,s)},click:function(e){e.preventDefault()},keyup:function(t){var n=e(t.target).data("ui-slider-handle-index");this._keySliding&&(this._keySliding=!1,this._stop(t,n),this._change(t,n),e(t.target).removeClass("ui-state-active"))}}})}(jQuery),function(e){function t(e){return function(){var t=this.element.val();e.apply(this,arguments),this._refresh(),t!==this.element.val()&&this._trigger("change")}}e.widget("ui.spinner",{version:"1.10.1",defaultElement:"<input>",widgetEventPrefix:"spin",options:{culture:null,icons:{down:"ui-icon-triangle-1-s",up:"ui-icon-triangle-1-n"},incremental:!0,max:null,min:null,numberFormat:null,page:10,step:1,change:null,spin:null,start:null,stop:null},_create:function(){this._setOption("max",this.options.max),this._setOption("min",this.options.min),this._setOption("step",this.options.step),this._value(this.element.val(),!0),this._draw(),this._on(this._events),this._refresh(),this._on(this.window,{beforeunload:function(){this.element.removeAttr("autocomplete")}})},_getCreateOptions:function(){var t={},n=this.element;return e.each(["min","max","step"],function(e,r){var i=n.attr(r);i!==undefined&&i.length&&(t[r]=i)}),t},_events:{keydown:function(e){this._start(e)&&this._keydown(e)&&e.preventDefault()},keyup:"_stop",focus:function(){this.previous=this.element.val()},blur:function(e){if(this.cancelBlur){delete this.cancelBlur;return}this._refresh(),this.previous!==this.element.val()&&this._trigger("change",e)},mousewheel:function(e,t){if(!t)return;if(!this.spinning&&!this._start(e))return!1;this._spin((t>0?1:-1)*this.options.step,e),clearTimeout(this.mousewheelTimer),this.mousewheelTimer=this._delay(function(){this.spinning&&this._stop(e)},100),e.preventDefault()},"mousedown .ui-spinner-button":function(t){function r(){var e=this.element[0]===this.document[0].activeElement;e||(this.element.focus(),this.previous=n,this._delay(function(){this.previous=n}))}var n;n=this.element[0]===this.document[0].activeElement?this.previous:this.element.val(),t.preventDefault(),r.call(this),this.cancelBlur=!0,this._delay(function(){delete this.cancelBlur,r.call(this)});if(this._start(t)===!1)return;this._repeat(null,e(t.currentTarget).hasClass("ui-spinner-up")?1:-1,t)},"mouseup .ui-spinner-button":"_stop","mouseenter .ui-spinner-button":function(t){if(!e(t.currentTarget).hasClass("ui-state-active"))return;if(this._start(t)===!1)return!1;this._repeat(null,e(t.currentTarget).hasClass("ui-spinner-up")?1:-1,t)},"mouseleave .ui-spinner-button":"_stop"},_draw:function(){var e=this.uiSpinner=this.element.addClass("ui-spinner-input").attr("autocomplete","off").wrap(this._uiSpinnerHtml()).parent().append(this._buttonHtml());this.element.attr("role","spinbutton"),this.buttons=e.find(".ui-spinner-button").attr("tabIndex",-1).button().removeClass("ui-corner-all"),this.buttons.height()>Math.ceil(e.height()*.5)&&e.height()>0&&e.height(e.height()),this.options.disabled&&this.disable()},_keydown:function(t){var n=this.options,r=e.ui.keyCode;switch(t.keyCode){case r.UP:return this._repeat(null,1,t),!0;case r.DOWN:return this._repeat(null,-1,t),!0;case r.PAGE_UP:return this._repeat(null,n.page,t),!0;case r.PAGE_DOWN:return this._repeat(null,-n.page,t),!0}return!1},_uiSpinnerHtml:function(){return"<span class='ui-spinner ui-widget ui-widget-content ui-corner-all'></span>"},_buttonHtml:function(){return"<a class='ui-spinner-button ui-spinner-up ui-corner-tr'><span class='ui-icon "+this.options.icons.up+"'>&#9650;</span>"+"</a>"+"<a class='ui-spinner-button ui-spinner-down ui-corner-br'>"+"<span class='ui-icon "+this.options.icons.down+"'>&#9660;</span>"+"</a>"},_start:function(e){return!this.spinning&&this._trigger("start",e)===!1?!1:(this.counter||(this.counter=1),this.spinning=!0,!0)},_repeat:function(e,t,n){e=e||500,clearTimeout(this.timer),this.timer=this._delay(function(){this._repeat(40,t,n)},e),this._spin(t*this.options.step,n)},_spin:function(e,t){var n=this.value()||0;this.counter||(this.counter=1),n=this._adjustValue(n+e*this._increment(this.counter));if(!this.spinning||this._trigger("spin",t,{value:n})!==!1)this._value(n),this.counter++},_increment:function(t){var n=this.options.incremental;return n?e.isFunction(n)?n(t):Math.floor(t*t*t/5e4-t*t/500+17*t/200+1):1},_precision:function(){var e=this._precisionOf(this.options.step);return this.options.min!==null&&(e=Math.max(e,this._precisionOf(this.options.min))),e},_precisionOf:function(e){var t=e.toString(),n=t.indexOf(".");return n===-1?0:t.length-n-1},_adjustValue:function(e){var t,n,r=this.options;return t=r.min!==null?r.min:0,n=e-t,n=Math.round(n/r.step)*r.step,e=t+n,e=parseFloat(e.toFixed(this._precision())),r.max!==null&&e>r.max?r.max:r.min!==null&&e<r.min?r.min:e},_stop:function(e){if(!this.spinning)return;clearTimeout(this.timer),clearTimeout(this.mousewheelTimer),this.counter=0,this.spinning=!1,this._trigger("stop",e)},_setOption:function(e,t){if(e==="culture"||e==="numberFormat"){var n=this._parse(this.element.val());this.options[e]=t,this.element.val(this._format(n));return}(e==="max"||e==="min"||e==="step")&&typeof t=="string"&&(t=this._parse(t)),e==="icons"&&(this.buttons.first().find(".ui-icon").removeClass(this.options.icons.up).addClass(t.up),this.buttons.last().find(".ui-icon").removeClass(this.options.icons.down).addClass(t.down)),this._super(e,t),e==="disabled"&&(t?(this.element.prop("disabled",!0),this.buttons.button("disable")):(this.element.prop("disabled",!1),this.buttons.button("enable")))},_setOptions:t(function(e){this._super(e),this._value(this.element.val())}),_parse:function(e){return typeof e=="string"&&e!==""&&(e=window.Globalize&&this.options.numberFormat?Globalize.parseFloat(e,10,this.options.culture):+e),e===""||isNaN(e)?null:e},_format:function(e){return e===""?"":window.Globalize&&this.options.numberFormat?Globalize.format(e,this.options.numberFormat,this.options.culture):e},_refresh:function(){this.element.attr({"aria-valuemin":this.options.min,"aria-valuemax":this.options.max,"aria-valuenow":this._parse(this.element.val())})},_value:function(e,t){var n;e!==""&&(n=this._parse(e),n!==null&&(t||(n=this._adjustValue(n)),e=this._format(n))),this.element.val(e),this._refresh()},_destroy:function(){this.element.removeClass("ui-spinner-input").prop("disabled",!1).removeAttr("autocomplete").removeAttr("role").removeAttr("aria-valuemin").removeAttr("aria-valuemax").removeAttr("aria-valuenow"),this.uiSpinner.replaceWith(this.element)},stepUp:t(function(e){this._stepUp(e)}),_stepUp:function(e){this._start()&&(this._spin((e||1)*this.options.step),this._stop())},stepDown:t(function(e){this._stepDown(e)}),_stepDown:function(e){this._start()&&(this._spin((e||1)*-this.options.step),this._stop())},pageUp:t(function(e){this._stepUp((e||1)*this.options.page)}),pageDown:t(function(e){this._stepDown((e||1)*this.options.page)}),value:function(e){if(!arguments.length)return this._parse(this.element.val());t(this._value).call(this,e)},widget:function(){return this.uiSpinner}})}(jQuery),function(e,t){function i(){return++n}function s(e){return e.hash.length>1&&decodeURIComponent(e.href.replace(r,""))===decodeURIComponent(location.href.replace(r,""))}var n=0,r=/#.*$/;e.widget("ui.tabs",{version:"1.10.1",delay:300,options:{active:null,collapsible:!1,event:"click",heightStyle:"content",hide:null,show:null,activate:null,beforeActivate:null,beforeLoad:null,load:null},_create:function(){var t=this,n=this.options;this.running=!1,this.element.addClass("ui-tabs ui-widget ui-widget-content ui-corner-all").toggleClass("ui-tabs-collapsible",n.collapsible).delegate(".ui-tabs-nav > li","mousedown"+this.eventNamespace,function(t){e(this).is(".ui-state-disabled")&&t.preventDefault()}).delegate(".ui-tabs-anchor","focus"+this.eventNamespace,function(){e(this).closest("li").is(".ui-state-disabled")&&this.blur()}),this._processTabs(),n.active=this._initialActive(),e.isArray(n.disabled)&&(n.disabled=e.unique(n.disabled.concat(e.map(this.tabs.filter(".ui-state-disabled"),function(e){return t.tabs.index(e)}))).sort()),this.options.active!==!1&&this.anchors.length?this.active=this._findActive(n.active):this.active=e(),this._refresh(),this.active.length&&this.load(n.active)},_initialActive:function(){var t=this.options.active,n=this.options.collapsible,r=location.hash.substring(1);if(t===null){r&&this.tabs.each(function(n,i){if(e(i).attr("aria-controls")===r)return t=n,!1}),t===null&&(t=this.tabs.index(this.tabs.filter(".ui-tabs-active")));if(t===null||t===-1)t=this.tabs.length?0:!1}return t!==!1&&(t=this.tabs.index(this.tabs.eq(t)),t===-1&&(t=n?!1:0)),!n&&t===!1&&this.anchors.length&&(t=0),t},_getCreateEventData:function(){return{tab:this.active,panel:this.active.length?this._getPanelForTab(this.active):e()}},_tabKeydown:function(t){var n=e(this.document[0].activeElement).closest("li"),r=this.tabs.index(n),i=!0;if(this._handlePageNav(t))return;switch(t.keyCode){case e.ui.keyCode.RIGHT:case e.ui.keyCode.DOWN:r++;break;case e.ui.keyCode.UP:case e.ui.keyCode.LEFT:i=!1,r--;break;case e.ui.keyCode.END:r=this.anchors.length-1;break;case e.ui.keyCode.HOME:r=0;break;case e.ui.keyCode.SPACE:t.preventDefault(),clearTimeout(this.activating),this._activate(r);return;case e.ui.keyCode.ENTER:t.preventDefault(),clearTimeout(this.activating),this._activate(r===this.options.active?!1:r);return;default:return}t.preventDefault(),clearTimeout(this.activating),r=this._focusNextTab(r,i),t.ctrlKey||(n.attr("aria-selected","false"),this.tabs.eq(r).attr("aria-selected","true"),this.activating=this._delay(function(){this.option("active",r)},this.delay))},_panelKeydown:function(t){if(this._handlePageNav(t))return;t.ctrlKey&&t.keyCode===e.ui.keyCode.UP&&(t.preventDefault(),this.active.focus())},_handlePageNav:function(t){if(t.altKey&&t.keyCode===e.ui.keyCode.PAGE_UP)return this._activate(this._focusNextTab(this.options.active-1,!1)),!0;if(t.altKey&&t.keyCode===e.ui.keyCode.PAGE_DOWN)return this._activate(this._focusNextTab(this.options.active+1,!0)),!0},_findNextTab:function(t,n){function i(){return t>r&&(t=0),t<0&&(t=r),t}var r=this.tabs.length-1;while(e.inArray(i(),this.options.disabled)!==-1)t=n?t+1:t-1;return t},_focusNextTab:function(e,t){return e=this._findNextTab(e,t),this.tabs.eq(e).focus(),e},_setOption:function(e,t){if(e==="active"){this._activate(t);return}if(e==="disabled"){this._setupDisabled(t);return}this._super(e,t),e==="collapsible"&&(this.element.toggleClass("ui-tabs-collapsible",t),!t&&this.options.active===!1&&this._activate(0)),e==="event"&&this._setupEvents(t),e==="heightStyle"&&this._setupHeightStyle(t)},_tabId:function(e){return e.attr("aria-controls")||"ui-tabs-"+i()},_sanitizeSelector:function(e){return e?e.replace(/[!"$%&'()*+,.\/:;<=>?@\[\]\^`{|}~]/g,"\\$&"):""},refresh:function(){var t=this.options,n=this.tablist.children(":has(a[href])");t.disabled=e.map(n.filter(".ui-state-disabled"),function(e){return n.index(e)}),this._processTabs(),t.active===!1||!this.anchors.length?(t.active=!1,this.active=e()):this.active.length&&!e.contains(this.tablist[0],this.active[0])?this.tabs.length===t.disabled.length?(t.active=!1,this.active=e()):this._activate(this._findNextTab(Math.max(0,t.active-1),!1)):t.active=this.tabs.index(this.active),this._refresh()},_refresh:function(){this._setupDisabled(this.options.disabled),this._setupEvents(this.options.event),this._setupHeightStyle(this.options.heightStyle),this.tabs.not(this.active).attr({"aria-selected":"false",tabIndex:-1}),this.panels.not(this._getPanelForTab(this.active)).hide().attr({"aria-expanded":"false","aria-hidden":"true"}),this.active.length?(this.active.addClass("ui-tabs-active ui-state-active").attr({"aria-selected":"true",tabIndex:0}),this._getPanelForTab(this.active).show().attr({"aria-expanded":"true","aria-hidden":"false"})):this.tabs.eq(0).attr("tabIndex",0)},_processTabs:function(){var t=this;this.tablist=this._getList().addClass("ui-tabs-nav ui-helper-reset ui-helper-clearfix ui-widget-header ui-corner-all").attr("role","tablist"),this.tabs=this.tablist.find("> li:has(a[href])").addClass("ui-state-default ui-corner-top").attr({role:"tab",tabIndex:-1}),this.anchors=this.tabs.map(function(){return e("a",this)[0]}).addClass("ui-tabs-anchor").attr({role:"presentation",tabIndex:-1}),this.panels=e(),this.anchors.each(function(n,r){var i,o,u,a=e(r).uniqueId().attr("id"),f=e(r).closest("li"),l=f.attr("aria-controls");s(r)?(i=r.hash,o=t.element.find(t._sanitizeSelector(i))):(u=t._tabId(f),i="#"+u,o=t.element.find(i),o.length||(o=t._createPanel(u),o.insertAfter(t.panels[n-1]||t.tablist)),o.attr("aria-live","polite")),o.length&&(t.panels=t.panels.add(o)),l&&f.data("ui-tabs-aria-controls",l),f.attr({"aria-controls":i.substring(1),"aria-labelledby":a}),o.attr("aria-labelledby",a)}),this.panels.addClass("ui-tabs-panel ui-widget-content ui-corner-bottom").attr("role","tabpanel")},_getList:function(){return this.element.find("ol,ul").eq(0)},_createPanel:function(t){return e("<div>").attr("id",t).addClass("ui-tabs-panel ui-widget-content ui-corner-bottom").data("ui-tabs-destroy",!0)},_setupDisabled:function(t){e.isArray(t)&&(t.length?t.length===this.anchors.length&&(t=!0):t=!1);for(var n=0,r;r=this.tabs[n];n++)t===!0||e.inArray(n,t)!==-1?e(r).addClass("ui-state-disabled").attr("aria-disabled","true"):e(r).removeClass("ui-state-disabled").removeAttr("aria-disabled");this.options.disabled=t},_setupEvents:function(t){var n={click:function(e){e.preventDefault()}};t&&e.each(t.split(" "),function(e,t){n[t]="_eventHandler"}),this._off(this.anchors.add(this.tabs).add(this.panels)),this._on(this.anchors,n),this._on(this.tabs,{keydown:"_tabKeydown"}),this._on(this.panels,{keydown:"_panelKeydown"}),this._focusable(this.tabs),this._hoverable(this.tabs)},_setupHeightStyle:function(t){var n,r=this.element.parent();t==="fill"?(n=r.height(),n-=this.element.outerHeight()-this.element.height(),this.element.siblings(":visible").each(function(){var t=e(this),r=t.css("position");if(r==="absolute"||r==="fixed")return;n-=t.outerHeight(!0)}),this.element.children().not(this.panels).each(function(){n-=e(this).outerHeight(!0)}),this.panels.each(function(){e(this).height(Math.max(0,n-e(this).innerHeight()+e(this).height()))}).css("overflow","auto")):t==="auto"&&(n=0,this.panels.each(function(){n=Math.max(n,e(this).height("").height())}).height(n))},_eventHandler:function(t){var n=this.options,r=this.active,i=e(t.currentTarget),s=i.closest("li"),o=s[0]===r[0],u=o&&n.collapsible,a=u?e():this._getPanelForTab(s),f=r.length?this._getPanelForTab(r):e(),l={oldTab:r,oldPanel:f,newTab:u?e():s,newPanel:a};t.preventDefault();if(s.hasClass("ui-state-disabled")||s.hasClass("ui-tabs-loading")||this.running||o&&!n.collapsible||this._trigger("beforeActivate",t,l)===!1)return;n.active=u?!1:this.tabs.index(s),this.active=o?e():s,this.xhr&&this.xhr.abort(),!f.length&&!a.length&&e.error("jQuery UI Tabs: Mismatching fragment identifier."),a.length&&this.load(this.tabs.index(s),t),this._toggle(t,l)},_toggle:function(t,n){function o(){r.running=!1,r._trigger("activate",t,n)}function u(){n.newTab.closest("li").addClass("ui-tabs-active ui-state-active"),i.length&&r.options.show?r._show(i,r.options.show,o):(i.show(),o())}var r=this,i=n.newPanel,s=n.oldPanel;this.running=!0,s.length&&this.options.hide?this._hide(s,this.options.hide,function(){n.oldTab.closest("li").removeClass("ui-tabs-active ui-state-active"),u()}):(n.oldTab.closest("li").removeClass("ui-tabs-active ui-state-active"),s.hide(),u()),s.attr({"aria-expanded":"false","aria-hidden":"true"}),n.oldTab.attr("aria-selected","false"),i.length&&s.length?n.oldTab.attr("tabIndex",-1):i.length&&this.tabs.filter(function(){return e(this).attr("tabIndex")===0}).attr("tabIndex",-1),i.attr({"aria-expanded":"true","aria-hidden":"false"}),n.newTab.attr({"aria-selected":"true",tabIndex:0})},_activate:function(t){var n,r=this._findActive(t);if(r[0]===this.active[0])return;r.length||(r=this.active),n=r.find(".ui-tabs-anchor")[0],this._eventHandler({target:n,currentTarget:n,preventDefault:e.noop})},_findActive:function(t){return t===!1?e():this.tabs.eq(t)},_getIndex:function(e){return typeof e=="string"&&(e=this.anchors.index(this.anchors.filter("[href$='"+e+"']"))),e},_destroy:function(){this.xhr&&this.xhr.abort(),this.element.removeClass("ui-tabs ui-widget ui-widget-content ui-corner-all ui-tabs-collapsible"),this.tablist.removeClass("ui-tabs-nav ui-helper-reset ui-helper-clearfix ui-widget-header ui-corner-all").removeAttr("role"),this.anchors.removeClass("ui-tabs-anchor").removeAttr("role").removeAttr("tabIndex").removeUniqueId(),this.tabs.add(this.panels).each(function(){e.data(this,"ui-tabs-destroy")?e(this).remove():e(this).removeClass("ui-state-default ui-state-active ui-state-disabled ui-corner-top ui-corner-bottom ui-widget-content ui-tabs-active ui-tabs-panel").removeAttr("tabIndex").removeAttr("aria-live").removeAttr("aria-busy").removeAttr("aria-selected").removeAttr("aria-labelledby").removeAttr("aria-hidden").removeAttr("aria-expanded").removeAttr("role")}),this.tabs.each(function(){var t=e(this),n=t.data("ui-tabs-aria-controls");n?t.attr("aria-controls",n).removeData("ui-tabs-aria-controls"):t.removeAttr("aria-controls")}),this.panels.show(),this.options.heightStyle!=="content"&&this.panels.css("height","")},enable:function(n){var r=this.options.disabled;if(r===!1)return;n===t?r=!1:(n=this._getIndex(n),e.isArray(r)?r=e.map(r,function(e){return e!==n?e:null}):r=e.map(this.tabs,function(e,t){return t!==n?t:null})),this._setupDisabled(r)},disable:function(n){var r=this.options.disabled;if(r===!0)return;if(n===t)r=!0;else{n=this._getIndex(n);if(e.inArray(n,r)!==-1)return;e.isArray(r)?r=e.merge([n],r).sort():r=[n]}this._setupDisabled(r)},load:function(t,n){t=this._getIndex(t);var r=this,i=this.tabs.eq(t),o=i.find(".ui-tabs-anchor"),u=this._getPanelForTab(i),a={tab:i,panel:u};if(s(o[0]))return;this.xhr=e.ajax(this._ajaxSettings(o,n,a)),this.xhr&&this.xhr.statusText!=="canceled"&&(i.addClass("ui-tabs-loading"),u.attr("aria-busy","true"),this.xhr.success(function(e){setTimeout(function(){u.html(e),r._trigger("load",n,a)},1)}).complete(function(e,t){setTimeout(function(){t==="abort"&&r.panels.stop(!1,!0),i.removeClass("ui-tabs-loading"),u.removeAttr("aria-busy"),e===r.xhr&&delete r.xhr},1)}))},_ajaxSettings:function(t,n,r){var i=this;return{url:t.attr("href"),beforeSend:function(t,s){return i._trigger("beforeLoad",n,e.extend({jqXHR:t,ajaxSettings:s},r))}}},_getPanelForTab:function(t){var n=e(t).attr("aria-controls");return this.element.find(this._sanitizeSelector("#"+n))}})}(jQuery),function(e){function n(t,n){var r=(t.attr("aria-describedby")||"").split(/\s+/);r.push(n),t.data("ui-tooltip-id",n).attr("aria-describedby",e.trim(r.join(" ")))}function r(t){var n=t.data("ui-tooltip-id"),r=(t.attr("aria-describedby")||"").split(/\s+/),i=e.inArray(n,r);i!==-1&&r.splice(i,1),t.removeData("ui-tooltip-id"),r=e.trim(r.join(" ")),r?t.attr("aria-describedby",r):t.removeAttr("aria-describedby")}var t=0;e.widget("ui.tooltip",{version:"1.10.1",options:{content:function(){var t=e(this).attr("title")||"";return e("<a>").text(t).html()},hide:!0,items:"[title]:not([disabled])",position:{my:"left top+15",at:"left bottom",collision:"flipfit flip"},show:!0,tooltipClass:null,track:!1,close:null,open:null},_create:function(){this._on({mouseover:"open",focusin:"open"}),this.tooltips={},this.parents={},this.options.disabled&&this._disable()},_setOption:function(t,n){var r=this;if(t==="disabled"){this[n?"_disable":"_enable"](),this.options[t]=n;return}this._super(t,n),t==="content"&&e.each(this.tooltips,function(e,t){r._updateContent(t)})},_disable:function(){var t=this;e.each(this.tooltips,function(n,r){var i=e.Event("blur");i.target=i.currentTarget=r[0],t.close(i,!0)}),this.element.find(this.options.items).addBack().each(function(){var t=e(this);t.is("[title]")&&t.data("ui-tooltip-title",t.attr("title")).attr("title","")})},_enable:function(){this.element.find(this.options.items).addBack().each(function(){var t=e(this);t.data("ui-tooltip-title")&&t.attr("title",t.data("ui-tooltip-title"))})},open:function(t){var n=this,r=e(t?t.target:this.element).closest(this.options.items);if(!r.length||r.data("ui-tooltip-id"))return;r.attr("title")&&r.data("ui-tooltip-title",r.attr("title")),r.data("ui-tooltip-open",!0),t&&t.type==="mouseover"&&r.parents().each(function(){var t=e(this),r;t.data("ui-tooltip-open")&&(r=e.Event("blur"),r.target=r.currentTarget=this,n.close(r,!0)),t.attr("title")&&(t.uniqueId(),n.parents[this.id]={element:this,title:t.attr("title")},t.attr("title",""))}),this._updateContent(r,t)},_updateContent:function(e,t){var n,r=this.options.content,i=this,s=t?t.type:null;if(typeof r=="string")return this._open(t,e,r);n=r.call(e[0],function(n){if(!e.data("ui-tooltip-open"))return;i._delay(function(){t&&(t.type=s),this._open(t,e,n)})}),n&&this._open(t,e,n)},_open:function(t,r,i){function f(e){a.of=e;if(s.is(":hidden"))return;s.position(a)}var s,o,u,a=e.extend({},this.options.position);if(!i)return;s=this._find(r);if(s.length){s.find(".ui-tooltip-content").html(i);return}r.is("[title]")&&(t&&t.type==="mouseover"?r.attr("title",""):r.removeAttr("title")),s=this._tooltip(r),n(r,s.attr("id")),s.find(".ui-tooltip-content").html(i),this.options.track&&t&&/^mouse/.test(t.type)?(this._on(this.document,{mousemove:f}),f(t)):s.position(e.extend({of:r},this.options.position)),s.hide(),this._show(s,this.options.show),this.options.show&&this.options.show.delay&&(u=this.delayedShow=setInterval(function(){s.is(":visible")&&(f(a.of),clearInterval(u))},e.fx.interval)),this._trigger("open",t,{tooltip:s}),o={keyup:function(t){if(t.keyCode===e.ui.keyCode.ESCAPE){var n=e.Event(t);n.currentTarget=r[0],this.close(n,!0)}},remove:function(){this._removeTooltip(s)}};if(!t||t.type==="mouseover")o.mouseleave="close";if(!t||t.type==="focusin")o.focusout="close";this._on(!0,r,o)},close:function(t){var n=this,i=e(t?t.currentTarget:this.element),s=this._find(i);if(this.closing)return;clearInterval(this.delayedShow),i.data("ui-tooltip-title")&&i.attr("title",i.data("ui-tooltip-title")),r(i),s.stop(!0),this._hide(s,this.options.hide,function(){n._removeTooltip(e(this))}),i.removeData("ui-tooltip-open"),this._off(i,"mouseleave focusout keyup"),i[0]!==this.element[0]&&this._off(i,"remove"),this._off(this.document,"mousemove"),t&&t.type==="mouseleave"&&e.each(this.parents,function(t,r){e(r.element).attr("title",r.title),delete n.parents[t]}),this.closing=!0,this._trigger("close",t,{tooltip:s}),this.closing=!1},_tooltip:function(n){var r="ui-tooltip-"+t++,i=e("<div>").attr({id:r,role:"tooltip"}).addClass("ui-tooltip ui-widget ui-corner-all ui-widget-content "+(this.options.tooltipClass||""));return e("<div>").addClass("ui-tooltip-content").appendTo(i),i.appendTo(this.document[0].body),this.tooltips[r]=n,i},_find:function(t){var n=t.data("ui-tooltip-id");return n?e("#"+n):e()},_removeTooltip:function(e){e.remove(),delete this.tooltips[e.attr("id")]},_destroy:function(){var t=this;e.each(this.tooltips,function(n,r){var i=e.Event("blur");i.target=i.currentTarget=r[0],t.close(i,!0),e("#"+n).remove(),r.data("ui-tooltip-title")&&(r.attr("title",r.data("ui-tooltip-title")),r.removeData("ui-tooltip-title"))})}})}(jQuery);
},{}],5:[function(require,module,exports){
/**
 * This jQuery plugin displays pagination links inside the selected elements.
 * 
 * This plugin needs at least jQuery 1.4.2
 *
 * @author Gabriel Birke (birke *at* d-scribe *dot* de)
 * @version 2.2
 * @param {int} maxentries Number of entries to paginate
 * @param {Object} opts Several options (see README for documentation)
 * @return {Object} jQuery Object
 */
 (function($){
	/**
	 * @class Class for calculating pagination values
	 */
	$.PaginationCalculator = function(maxentries, opts) {
		this.maxentries = maxentries;
		this.opts = opts;
	}
	
	$.extend($.PaginationCalculator.prototype, {
		/**
		 * Calculate the maximum number of pages
		 * @method
		 * @returns {Number}
		 */
		numPages:function() {
			return Math.ceil(this.maxentries/this.opts.items_per_page);
		},
		/**
		 * Calculate start and end point of pagination links depending on 
		 * current_page and num_display_entries.
		 * @returns {Array}
		 */
		getInterval:function(current_page)  {
			var ne_half = Math.floor(this.opts.num_display_entries/2);
			var np = this.numPages();
			var upper_limit = np - this.opts.num_display_entries;
			var start = current_page > ne_half ? Math.max( Math.min(current_page - ne_half, upper_limit), 0 ) : 0;
			var end = current_page > ne_half?Math.min(current_page+ne_half + (this.opts.num_display_entries % 2), np):Math.min(this.opts.num_display_entries, np);
			return {start:start, end:end};
		}
	});
	
	// Initialize jQuery object container for pagination renderers
	$.PaginationRenderers = {}
	
	/**
	 * @class Default renderer for rendering pagination links
	 */
	$.PaginationRenderers.defaultRenderer = function(maxentries, opts) {
		this.maxentries = maxentries;
		this.opts = opts;
		this.pc = new $.PaginationCalculator(maxentries, opts);
	}
	$.extend($.PaginationRenderers.defaultRenderer.prototype, {
		/**
		 * Helper function for generating a single link (or a span tag if it's the current page)
		 * @param {Number} page_id The page id for the new item
		 * @param {Number} current_page 
		 * @param {Object} appendopts Options for the new item: text and classes
		 * @returns {jQuery} jQuery object containing the link
		 */
		createLink:function(page_id, current_page, appendopts){
			var lnk, np = this.pc.numPages();
			page_id = page_id<0?0:(page_id<np?page_id:np-1); // Normalize page id to sane value
			appendopts = $.extend({text:page_id+1, classes:""}, appendopts||{});
			if(page_id == current_page){
				lnk = $("<span class='current'>" + appendopts.text + "</span>");
			}
			else
			{
				lnk = $("<a class='anchorHover'>" + appendopts.text + "</a>");
			}
			if(appendopts.classes){ lnk.addClass(appendopts.classes); }
			lnk.data('page_id', page_id);
			return lnk;
		},
		// Generate a range of numeric links 
		appendRange:function(container, current_page, start, end, opts) {
			var i;
			for(i=start; i<end; i++) {
				this.createLink(i, current_page, opts).appendTo(container);
			}
		},
		getLinks:function(current_page, eventHandler) {
			var begin, end,
				interval = this.pc.getInterval(current_page),
				np = this.pc.numPages(),
				fragment = $("<div class='pagination'></div>");
			
			// Generate "Previous"-Link
			if(this.opts.prev_text && (current_page > 0 || this.opts.prev_show_always)){
				fragment.append(this.createLink(current_page-1, current_page, {text:this.opts.prev_text, classes:"prev"}));
			}
			// Generate starting points
			if (interval.start > 0 && this.opts.num_edge_entries > 0)
			{
				end = Math.min(this.opts.num_edge_entries, interval.start);
				this.appendRange(fragment, current_page, 0, end, {classes:'sp'});
				if(this.opts.num_edge_entries < interval.start && this.opts.ellipse_text)
				{
					$("<span>"+this.opts.ellipse_text+"</span>").appendTo(fragment);
				}
			}
			// Generate interval links
			this.appendRange(fragment, current_page, interval.start, interval.end);
			// Generate ending points
			if (interval.end < np && this.opts.num_edge_entries > 0)
			{
				if(np-this.opts.num_edge_entries > interval.end && this.opts.ellipse_text)
				{
					$("<span>"+this.opts.ellipse_text+"</span>").appendTo(fragment);
				}
				begin = Math.max(np-this.opts.num_edge_entries, interval.end);
				this.appendRange(fragment, current_page, begin, np, {classes:'ep'});
				
			}
			// Generate "Next"-Link
			if(this.opts.next_text && (current_page < np-1 || this.opts.next_show_always)){
				fragment.append(this.createLink(current_page+1, current_page, {text:this.opts.next_text, classes:"next"}));
			}
			$('a', fragment).click(eventHandler);
			return fragment;
		}
	});
	
	// Extend jQuery
	$.fn.pagination = function(maxentries, opts){
		
		// Initialize options with default values
		opts = $.extend({
			items_per_page:10,
			num_display_entries:11,
			current_page:0,
			num_edge_entries:0,
			link_to:"#",
			prev_text:"Prev",
			next_text:"Next",
			ellipse_text:"...",
			prev_show_always:true,
			next_show_always:true,
			renderer:"defaultRenderer",
			show_if_single_page:false,
			load_first_page:true,
			callback:function(){return false;}
		},opts||{});
		
		var containers = this,
			renderer, links, current_page;
		
		/**
		 * This is the event handling function for the pagination links. 
		 * @param {int} page_id The new page number
		 */
		function paginationClickHandler(evt){
			var links, 
				new_current_page = $(evt.target).data('page_id'),
				continuePropagation = selectPage(new_current_page);
			if (!continuePropagation) {
				evt.stopPropagation();
			}
			return continuePropagation;
		}
		
		/**
		 * This is a utility function for the internal event handlers. 
		 * It sets the new current page on the pagination container objects, 
		 * generates a new HTMl fragment for the pagination links and calls
		 * the callback function.
		 */
		function selectPage(new_current_page) {
			// update the link display of a all containers
			containers.data('current_page', new_current_page);
			links = renderer.getLinks(new_current_page, paginationClickHandler);
			containers.empty();
			links.appendTo(containers);
			// call the callback and propagate the event if it does not return false
			var continuePropagation = opts.callback(new_current_page, containers);
			return continuePropagation;
		}
		
		// -----------------------------------
		// Initialize containers
		// -----------------------------------
                current_page = parseInt(opts.current_page);
		containers.data('current_page', current_page);
		// Create a sane value for maxentries and items_per_page
		maxentries = (!maxentries || maxentries < 0)?1:maxentries;
		opts.items_per_page = (!opts.items_per_page || opts.items_per_page < 0)?1:opts.items_per_page;
		
		if(!$.PaginationRenderers[opts.renderer])
		{
			throw new ReferenceError("Pagination renderer '" + opts.renderer + "' was not found in jQuery.PaginationRenderers object.");
		}
		renderer = new $.PaginationRenderers[opts.renderer](maxentries, opts);
		
		// Attach control events to the DOM elements
		var pc = new $.PaginationCalculator(maxentries, opts);
		var np = pc.numPages();
		containers.bind('setPage', {numPages:np}, function(evt, page_id) { 
				if(page_id >= 0 && page_id < evt.data.numPages) {
					selectPage(page_id); return false;
				}
		});
		containers.bind('prevPage', function(evt){
				var current_page = $(this).data('current_page');
				if (current_page > 0) {
					selectPage(current_page - 1);
				}
				return false;
		});
		containers.bind('nextPage', {numPages:np}, function(evt){
				var current_page = $(this).data('current_page');
				if(current_page < evt.data.numPages - 1) {
					selectPage(current_page + 1);
				}
				return false;
		});
		
		// When all initialisation is done, draw the links
		links = renderer.getLinks(current_page, paginationClickHandler);
		containers.empty();
		if(np > 1 || opts.show_if_single_page) {
			links.appendTo(containers);
		}
		// call callback function
		if(opts.load_first_page) {
			opts.callback(current_page, containers);
		}
	} // End of $.fn.pagination block
	
})(jQuery);

},{}],6:[function(require,module,exports){
/*!
 * mustache.js - Logic-less {{mustache}} templates with JavaScript
 * http://github.com/janl/mustache.js
 */

/*global define: false*/

(function (root, factory) {
  if (typeof exports === "object" && exports) {
    module.exports = factory; // CommonJS
  } else if (typeof define === "function" && define.amd) {
    define(factory); // AMD
  } else {
    root.Mustache = factory; // <script>
  }
}(this, (function () {

  var exports = {};

  exports.name = "mustache.js";
  exports.version = "0.7.2";
  exports.tags = ["{{", "}}"];

  exports.Scanner = Scanner;
  exports.Context = Context;
  exports.Writer = Writer;

  var whiteRe = /\s*/;
  var spaceRe = /\s+/;
  var nonSpaceRe = /\S/;
  var eqRe = /\s*=/;
  var curlyRe = /\s*\}/;
  var tagRe = /#|\^|\/|>|\{|&|=|!/;

  var _test = RegExp.prototype.test;
  var _toString = Object.prototype.toString;


  // Workaround for https://issues.apache.org/jira/browse/COUCHDB-577
  // See https://github.com/janl/mustache.js/issues/189
  function testRe(re, string) {
    return _test.call(re, string);
  }

  function isWhitespace(string) {
    return !testRe(nonSpaceRe, string);
  }

  var isArray = Array.isArray || function (obj) {
    return _toString.call(obj) === '[object Array]';
  };

  function escapeRe(string) {
    return string.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&");
  }

  var entityMap = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': '&quot;',
    "'": '&#39;',
    "/": '&#x2F;'
  };

  function escapeHtml(string) {
    return String(string).replace(/[&<>"'\/]/g, function (s) {
      return entityMap[s];
    });
  }

  // Export the escaping function so that the user may override it.
  // See https://github.com/janl/mustache.js/issues/244
  exports.escape = escapeHtml;

  function Scanner(string) {
    this.string = string;
    this.tail = string;
    this.pos = 0;
  }

  /**
   * Returns `true` if the tail is empty (end of string).
   */
  Scanner.prototype.eos = function () {
    return this.tail === "";
  };

  /**
   * Tries to match the given regular expression at the current position.
   * Returns the matched text if it can match, the empty string otherwise.
   */
  Scanner.prototype.scan = function (re) {
    var match = this.tail.match(re);

    if (match && match.index === 0) {
      this.tail = this.tail.substring(match[0].length);
      this.pos += match[0].length;
      return match[0];
    }

    return "";
  };

  /**
   * Skips all text until the given regular expression can be matched. Returns
   * the skipped string, which is the entire tail if no match can be made.
   */
  Scanner.prototype.scanUntil = function (re) {
    var match, pos = this.tail.search(re);

    switch (pos) {
    case -1:
      match = this.tail;
      this.pos += this.tail.length;
      this.tail = "";
      break;
    case 0:
      match = "";
      break;
    default:
      match = this.tail.substring(0, pos);
      this.tail = this.tail.substring(pos);
      this.pos += pos;
    }

    return match;
  };

  function Context(view, parent) {
    this.view = view;
    this.parent = parent;
    this._cache = {};
  }

  Context.make = function (view) {
    return (view instanceof Context) ? view : new Context(view);
  };

  Context.prototype.push = function (view) {
    return new Context(view, this);
  };

  Context.prototype.lookup = function (name) {
    var value = this._cache[name];

    if (!value) {
      if (name == '.') {
        value = this.view;
      } else {
        var context = this;

        while (context) {
          if (name.indexOf('.') > 0) {
            value = context.view;
            var names = name.split('.'), i = 0;
            while (value && i < names.length) {
              value = value[names[i++]];
            }
          } else {
            value = context.view[name];
          }

          if (value != null) break;

          context = context.parent;
        }
      }

      this._cache[name] = value;
    }

    if (typeof value === 'function') value = value.call(this.view);

    return value;
  };

  function Writer() {
    this.clearCache();
  }

  Writer.prototype.clearCache = function () {
    this._cache = {};
    this._partialCache = {};
  };

  Writer.prototype.compile = function (template, tags) {
    var fn = this._cache[template];

    if (!fn) {
      var tokens = exports.parse(template, tags);
      fn = this._cache[template] = this.compileTokens(tokens, template);
    }

    return fn;
  };

  Writer.prototype.compilePartial = function (name, template, tags) {
    var fn = this.compile(template, tags);
    this._partialCache[name] = fn;
    return fn;
  };

  Writer.prototype.getPartial = function (name) {
    if (!(name in this._partialCache) && this._loadPartial) {
      this.compilePartial(name, this._loadPartial(name));
    }

    return this._partialCache[name];
  };

  Writer.prototype.compileTokens = function (tokens, template) {
    var self = this;
    return function (view, partials) {
      if (partials) {
        if (typeof partials === 'function') {
          self._loadPartial = partials;
        } else {
          for (var name in partials) {
            self.compilePartial(name, partials[name]);
          }
        }
      }

      return renderTokens(tokens, self, Context.make(view), template);
    };
  };

  Writer.prototype.render = function (template, view, partials) {
    return this.compile(template)(view, partials);
  };

  /**
   * Low-level function that renders the given `tokens` using the given `writer`
   * and `context`. The `template` string is only needed for templates that use
   * higher-order sections to extract the portion of the original template that
   * was contained in that section.
   */
  function renderTokens(tokens, writer, context, template) {
    var buffer = '';

    var token, tokenValue, value;
    for (var i = 0, len = tokens.length; i < len; ++i) {
      token = tokens[i];
      tokenValue = token[1];

      switch (token[0]) {
      case '#':
        value = context.lookup(tokenValue);

        if (typeof value === 'object') {
          if (isArray(value)) {
            for (var j = 0, jlen = value.length; j < jlen; ++j) {
              buffer += renderTokens(token[4], writer, context.push(value[j]), template);
            }
          } else if (value) {
            buffer += renderTokens(token[4], writer, context.push(value), template);
          }
        } else if (typeof value === 'function') {
          var text = template == null ? null : template.slice(token[3], token[5]);
          value = value.call(context.view, text, function (template) {
            return writer.render(template, context);
          });
          if (value != null) buffer += value;
        } else if (value) {
          buffer += renderTokens(token[4], writer, context, template);
        }

        break;
      case '^':
        value = context.lookup(tokenValue);

        // Use JavaScript's definition of falsy. Include empty arrays.
        // See https://github.com/janl/mustache.js/issues/186
        if (!value || (isArray(value) && value.length === 0)) {
          buffer += renderTokens(token[4], writer, context, template);
        }

        break;
      case '>':
        value = writer.getPartial(tokenValue);
        if (typeof value === 'function') buffer += value(context);
        break;
      case '&':
        value = context.lookup(tokenValue);
        if (value != null) buffer += value;
        break;
      case 'name':
        value = context.lookup(tokenValue);
        if (value != null) buffer += exports.escape(value);
        break;
      case 'text':
        buffer += tokenValue;
        break;
      }
    }

    return buffer;
  }

  /**
   * Forms the given array of `tokens` into a nested tree structure where
   * tokens that represent a section have two additional items: 1) an array of
   * all tokens that appear in that section and 2) the index in the original
   * template that represents the end of that section.
   */
  function nestTokens(tokens) {
    var tree = [];
    var collector = tree;
    var sections = [];

    var token;
    for (var i = 0, len = tokens.length; i < len; ++i) {
      token = tokens[i];
      switch (token[0]) {
      case '#':
      case '^':
        sections.push(token);
        collector.push(token);
        collector = token[4] = [];
        break;
      case '/':
        var section = sections.pop();
        section[5] = token[2];
        collector = sections.length > 0 ? sections[sections.length - 1][4] : tree;
        break;
      default:
        collector.push(token);
      }
    }

    return tree;
  }

  /**
   * Combines the values of consecutive text tokens in the given `tokens` array
   * to a single token.
   */
  function squashTokens(tokens) {
    var squashedTokens = [];

    var token, lastToken;
    for (var i = 0, len = tokens.length; i < len; ++i) {
      token = tokens[i];
      if (token) {
        if (token[0] === 'text' && lastToken && lastToken[0] === 'text') {
          lastToken[1] += token[1];
          lastToken[3] = token[3];
        } else {
          lastToken = token;
          squashedTokens.push(token);
        }
      }
    }

    return squashedTokens;
  }

  function escapeTags(tags) {
    return [
      new RegExp(escapeRe(tags[0]) + "\\s*"),
      new RegExp("\\s*" + escapeRe(tags[1]))
    ];
  }

  /**
   * Breaks up the given `template` string into a tree of token objects. If
   * `tags` is given here it must be an array with two string values: the
   * opening and closing tags used in the template (e.g. ["<%", "%>"]). Of
   * course, the default is to use mustaches (i.e. Mustache.tags).
   */
  exports.parse = function (template, tags) {
    template = template || '';
    tags = tags || exports.tags;

    if (typeof tags === 'string') tags = tags.split(spaceRe);
    if (tags.length !== 2) throw new Error('Invalid tags: ' + tags.join(', '));

    var tagRes = escapeTags(tags);
    var scanner = new Scanner(template);

    var sections = [];     // Stack to hold section tokens
    var tokens = [];       // Buffer to hold the tokens
    var spaces = [];       // Indices of whitespace tokens on the current line
    var hasTag = false;    // Is there a {{tag}} on the current line?
    var nonSpace = false;  // Is there a non-space char on the current line?

    // Strips all whitespace tokens array for the current line
    // if there was a {{#tag}} on it and otherwise only space.
    function stripSpace() {
      if (hasTag && !nonSpace) {
        while (spaces.length) {
          delete tokens[spaces.pop()];
        }
      } else {
        spaces = [];
      }

      hasTag = false;
      nonSpace = false;
    }

    var start, type, value, chr, token;
    while (!scanner.eos()) {
      start = scanner.pos;

      // Match any text between tags.
      value = scanner.scanUntil(tagRes[0]);
      if (value) {
        for (var i = 0, len = value.length; i < len; ++i) {
          chr = value.charAt(i);

          if (isWhitespace(chr)) {
            spaces.push(tokens.length);
          } else {
            nonSpace = true;
          }

          tokens.push(['text', chr, start, start + 1]);
          start += 1;

          // Check for whitespace on the current line.
          if (chr == '\n') stripSpace();
        }
      }

      // Match the opening tag.
      if (!scanner.scan(tagRes[0])) break;
      hasTag = true;

      // Get the tag type.
      type = scanner.scan(tagRe) || 'name';
      scanner.scan(whiteRe);

      // Get the tag value.
      if (type === '=') {
        value = scanner.scanUntil(eqRe);
        scanner.scan(eqRe);
        scanner.scanUntil(tagRes[1]);
      } else if (type === '{') {
        value = scanner.scanUntil(new RegExp('\\s*' + escapeRe('}' + tags[1])));
        scanner.scan(curlyRe);
        scanner.scanUntil(tagRes[1]);
        type = '&';
      } else {
        value = scanner.scanUntil(tagRes[1]);
      }

      // Match the closing tag.
      if (!scanner.scan(tagRes[1])) throw new Error('Unclosed tag at ' + scanner.pos);

      token = [type, value, start, scanner.pos];
      tokens.push(token);

      if (type === '#' || type === '^') {
        sections.push(token);
      } else if (type === '/') {
        // Check section nesting.
        if (sections.length === 0) throw new Error('Unopened section "' + value + '" at ' + start);
        var openSection = sections.pop();
        if (openSection[1] !== value) throw new Error('Unclosed section "' + openSection[1] + '" at ' + start);
      } else if (type === 'name' || type === '{' || type === '&') {
        nonSpace = true;
      } else if (type === '=') {
        // Set the tags for the next time around.
        tags = value.split(spaceRe);
        if (tags.length !== 2) throw new Error('Invalid tags at ' + start + ': ' + tags.join(', '));
        tagRes = escapeTags(tags);
      }
    }

    // Make sure there are no open sections when we're done.
    var openSection = sections.pop();
    if (openSection) throw new Error('Unclosed section "' + openSection[1] + '" at ' + scanner.pos);

    tokens = squashTokens(tokens);

    return nestTokens(tokens);
  };

  // All Mustache.* functions use this writer.
  var _writer = new Writer();

  /**
   * Clears all cached templates and partials in the default writer.
   */
  exports.clearCache = function () {
    return _writer.clearCache();
  };

  /**
   * Compiles the given `template` to a reusable function using the default
   * writer.
   */
  exports.compile = function (template, tags) {
    return _writer.compile(template, tags);
  };

  /**
   * Compiles the partial with the given `name` and `template` to a reusable
   * function using the default writer.
   */
  exports.compilePartial = function (name, template, tags) {
    return _writer.compilePartial(name, template, tags);
  };

  /**
   * Compiles the given array of tokens (the output of a parse) to a reusable
   * function using the default writer.
   */
  exports.compileTokens = function (tokens, template) {
    return _writer.compileTokens(tokens, template);
  };

  /**
   * Renders the `template` with the given `view` and `partials` using the
   * default writer.
   */
  exports.render = function (template, view, partials) {
    return _writer.render(template, view, partials);
  };

  // This is here for backwards compatibility with 0.4.x.
  exports.to_html = function (template, view, partials, send) {
    view = injectTranslate(view);
    var result = exports.render(template, view, partials);

    if (typeof send === "function") {
      send(result);
    } else {
      return result;
    }
  };


  function translate() {
        return function(text) {
          return I18n.translate(text);
         }
  }

  function injectTranslate(view){

    if(view){
      if (typeof view === "object"){
        view.translate = translate;
        return view;
     }
     else if(typeof view === "function"){
        var obj = {};
        obj.translate = translate;
        if(view.name !== ""){
          var fnName = view.name;
          obj.fnName = view;
        }
        return obj;

     }
   }
 }

  
  return exports;

}())));

},{}],7:[function(require,module,exports){
var PresentersBase;

PresentersBase = {
  getI18n: function(I18nScope) {
    var scope;
    scope = I18nScope;
    if (scope != null) {
      return I18n.scoped(scope);
    } else {
      return I18n;
    }
  },
  toHashWithHelpers: function(hash, I18nScope) {
    var presenterHash;
    presenterHash = _.clone(hash);
    return I18n.mixin(presenterHash, this.getI18n(I18nScope));
  }
};

module.exports = PresentersBase;



},{}],8:[function(require,module,exports){
var Backbone, FAQHomeModel,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Backbone = require('backbone');

FAQHomeModel = (function(superClass) {
  extend(FAQHomeModel, superClass);

  function FAQHomeModel() {
    return FAQHomeModel.__super__.constructor.apply(this, arguments);
  }

  FAQHomeModel.prototype.initialize = function() {
    return this.url = window.FAQBASEURL + "/home?should_display_cms_content=" + experiments.shouldDisplayCMSContentForUS;
  };

  return FAQHomeModel;

})(Backbone.Model);

module.exports = FAQHomeModel;



},{"backbone":245}],9:[function(require,module,exports){
var Backbone, FAQTrendingArticlesView, FaqTrendingArticlesTemplate,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Backbone = require('backbone');

Backbone.$ = $;

FaqTrendingArticlesTemplate = require('../../trending_articles.html.mustache');

FAQTrendingArticlesView = (function(superClass) {
  extend(FAQTrendingArticlesView, superClass);

  function FAQTrendingArticlesView() {
    return FAQTrendingArticlesView.__super__.constructor.apply(this, arguments);
  }

  FAQTrendingArticlesView.prototype.initialize = function() {
    this.I18nScope = 'modules.faq';
    this.template = FaqTrendingArticlesTemplate;
    return this.container = $('#trending-articles');
  };

  FAQTrendingArticlesView.prototype.events = {
    "click .article-header": "toggleArticleSummary",
    "click .rating": "handleRatingClicked"
  };

  FAQTrendingArticlesView.prototype.toggleArticleSummary = function(event) {
    var $target, id;
    $target = $(event.target).closest('.article-header');
    id = $target.find('.article').attr('articleId');
    this.resetAllArticlesExceptTarget(id);
    $("#" + id).toggle();
    $target.find('.icon-arrow-right').toggle();
    $target.find('.icon-arrow-down').toggle();
    return scrollTo($target);
  };

  FAQTrendingArticlesView.prototype.resetAllArticlesExceptTarget = function(targetId) {
    return _.each($('.article'), (function(_this) {
      return function(article) {
        var $target, id;
        id = $(article).attr('articleId');
        if (id !== targetId) {
          $target = $(article).closest('.article-header');
          $("#" + id).hide();
          $target.find('.icon-arrow-right').show();
          return $target.find('.icon-arrow-down').hide();
        }
      };
    })(this));
  };

  FAQTrendingArticlesView.prototype.render = function() {
    return this.toHtml();
  };

  FAQTrendingArticlesView.prototype.handleRatingClicked = function(event) {
    var $target;
    $target = $(event.target).closest('.rating');
    $target.find('.ratings').hide();
    $target.find('.thanks').show();
    return true;
  };

  FAQTrendingArticlesView.prototype.toHtml = function() {
    var ref;
    this.$el.html(toHtml(this.template, {
      trendingArticleList: (ref = this.model.get('faqMain')) != null ? ref.trending_articles : void 0
    }, this.I18nScope));
    return this.container.html(this.el);
  };

  return FAQTrendingArticlesView;

})(Backbone.View);

module.exports = FAQTrendingArticlesView;



},{"../../trending_articles.html.mustache":10,"backbone":245}],10:[function(require,module,exports){
var Hogan = require('hogan.js');
module.exports = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");if(t.s(t.f("trendingArticleList",c,p,1),c,p,0,24,938,"{{ }}")){t.rs(c,p,function(c,p,t){if(t.s(t.f("trendingArticle",c,p,1),c,p,0,49,917,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("    <div class=\"article-header\">");t.b("\n" + i);t.b("      <div class=\"icon-arrow-right\"></div>");t.b("\n" + i);t.b("      <div class=\"icon-arrow-down\" style=\"display:none\"></div>");t.b("\n" + i);t.b("      <div class=\"article\" articleId=");t.b(t.v(t.f("id",c,p,0)));t.b(">");t.b(t.t(t.f("heading",c,p,0)));t.b("</div>");t.b("\n" + i);t.b("    </div>");t.b("\n" + i);t.b("    <div class=\"answer article-summary\" id=");t.b(t.v(t.f("id",c,p,0)));t.b(" style=\"display:none\">");t.b("\n" + i);t.b("      <span class=\"article-text-container\" >");t.b("\n" + i);t.b("          ");t.b(t.t(t.f("text",c,p,0)));t.b("\n" + i);t.b("      </span>");t.b("\n" + i);t.b("      <div class=\"rating\">");t.b("\n" + i);t.b("        <div class=\"ratings\" id=");t.b(t.v(t.f("id",c,p,0)));t.b(">");t.b("\n" + i);t.b("          <span>");if(t.s(t.f("translate",c,p,1),c,p,0,513,536,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.faq.helptext");});c.pop();}t.b("</span>");t.b("\n" + i);t.b("            <a data-bhw=\"article___");t.b(t.v(t.f("id",c,p,0)));t.b("___yes\" >");if(t.s(t.f("translate",c,p,1),c,p,0,622,640,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.faq.yes");});c.pop();}t.b("</a>");t.b("\n" + i);t.b("            |");t.b("\n" + i);t.b("            <a data-bhw=\"article___");t.b(t.v(t.f("id",c,p,0)));t.b("___no\">");if(t.s(t.f("translate",c,p,1),c,p,0,735,752,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.faq.no");});c.pop();}t.b("</a>");t.b("\n" + i);t.b("        </div>");t.b("\n" + i);t.b("        <div class=\"thanks\" style=\"display:none\">");if(t.s(t.f("translate",c,p,1),c,p,0,849,870,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.faq.thanks");});c.pop();}t.b("</div>");t.b("\n" + i);t.b("      </div>");t.b("\n" + i);t.b("    </div>");t.b("\n" + i);});c.pop();}});c.pop();}return t.fl(); },partials: {}, subs: {  }}, "{{#trendingArticleList}}  \n  {{#trendingArticle}}\n    <div class=\"article-header\">\n      <div class=\"icon-arrow-right\"></div>\n      <div class=\"icon-arrow-down\" style=\"display:none\"></div>\n      <div class=\"article\" articleId={{id}}>{{{heading}}}</div>\n    </div>\n    <div class=\"answer article-summary\" id={{id}} style=\"display:none\">\n      <span class=\"article-text-container\" >\n          {{{text}}}\n      </span>\n      <div class=\"rating\">\n        <div class=\"ratings\" id={{id}}>\n          <span>{{#translate}}js.modules.faq.helptext{{/translate}}</span>\n            <a data-bhw=\"article___{{id}}___yes\" >{{#translate}}js.modules.faq.yes{{/translate}}</a>\n            |\n            <a data-bhw=\"article___{{id}}___no\">{{#translate}}js.modules.faq.no{{/translate}}</a>\n        </div>\n        <div class=\"thanks\" style=\"display:none\">{{#translate}}js.modules.faq.thanks{{/translate}}</div>\n      </div>\n    </div>\n  {{/trendingArticle}}\n{{/trendingArticleList}} ", Hogan);
},{"hogan.js":248}],11:[function(require,module,exports){
var GrouponValidate;

GrouponValidate = {
  email: function(value) {
    var emailInvalidRegex, emailValidRegex, invalidMatch, validMatch;
    if (value.length > 100) {
      return false;
    }
    emailValidRegex = "^((\\\"[^\\\"\\f\\n\\r\\t\\v\\b]+\\\")|([\\.\\w=\\!\\#\\$\\%\\&\\'\\*\\+\\-\\~\\/\\^\\`\\|\\{\\}]+))@((\\[(((25[0-5])|(2[0-4][0-9])|([0-1]?[0-9]?[0-9]))\\.((25[0-5])|(2[0-4][0-9])|([0-1]?[0-9]?[0-9]))\\.((25[0-5])|(2[0-4][0-9])|([0-1]?[0-9]?[0-9]))\\.((25[0-5])|(2[0-4][0-9])|([0-1]?[0-9]?[0-9])))\\])|(((25[0-5])|(2[0-4][0-9])|([0-1]?[0-9]?[0-9]))\\.((25[0-5])|(2[0-4][0-9])|([0-1]?[0-9]?[0-9]))\\.((25[0-5])|(2[0-4][0-9])|([0-1]?[0-9]?[0-9]))\\.((25[0-5])|(2[0-4][0-9])|([0-1]?[0-9]?[0-9])))|((([A-Za-z0-9\\-])+\\.)+[A-Za-z\\-]+))$";
    validMatch = new RegExp(emailValidRegex);
    emailInvalidRegex = "<|`";
    invalidMatch = new RegExp(emailInvalidRegex);
    return validMatch.test(value) && !invalidMatch.test(value);
  },
  zip: function(value) {
    var regexp, zip;
    if (value === '' || value === 'undefined') {
      return false;
    }
    zip = $.trim(value);
    regexp = /(^([0-9]{5}(-[0-9]{4})?)$)|(^[ABCEGHJKLMNPRSTVXYabceghjklmnprstvxy]{1}\d{1}[A-Za-z]{1} *\d{1}[A-Za-z]{1}\d{1}$)/;
    return regexp.test(zip);
  },
  phone: function(value) {
    var phone, regExp;
    if (value.length === 0) {
      return false;
    }
    phone = $.trim(value);
    regExp = /^(?:\d{3}|\(\d{3}\))(?: *|-?)\d{3}(?: *|-?)\d{4}$/;
    return regExp.test(phone);
  },
  phoneInternational: function(value) {
    var phone, regExp, regExp1;
    if (value.length === 0) {
      return false;
    }
    phone = $.trim(value);
    regExp = /^[0-9]+$/;
    if (regExp.test(phone)) {
      return true;
    }
    regExp = /(?=^[\( *\-*\) *0-9+]*$)(?=^(?!\-+))(?=\((\d{1,} *\d{0,})\)|\((\d{1,}\-*\d{0,})\)|\((\d{1,})\))/m;
    regExp1 = /^[ *\-* *0-9+]*$/;
    if (regExp.test(phone)) {
      return true;
    } else {
      return regExp1.test(phone);
    }
  },
  creditCard: function(value) {
    var description, regExp;
    if (value.length === 0) {
      return false;
    }
    description = $.trim(value);
    regExp = /(cc#\s|credit\scard\s|Visa\s|visa\s|mastercard\s|Mastercard\sAmerican\s|american\sJCB\s|jcb\s|Discover\s|discover\s)((?:(?:4\d{3})|(?:5[1-5]\d{2})|6(?:011|5[0-9]{2}))(?:-?|\s*)(?:\d{4}(?:-?|\s*)){3}|(?:3[4,7]\d{2})(?:-?|\s*)\d{6}(?:-?|\s*)\d{5}|(?:2131|1800|3088|3337|3096\d{11})|((35\d{2}-?\s?)(\d{4}(-?\s?))))/;
    return regExp.test(description);
  }
};

module.exports = GrouponValidate;



},{}],12:[function(require,module,exports){
var Hogan = require('hogan.js');
module.exports = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");if(!t.s(t.f("isVertical",c,p,1),c,p,1,0,0,"")){t.b("  <div class=\"content\">");t.b("\n" + i);t.b("      <div class=\"page-error error text-center\">");t.b("\n" + i);if(t.s(t.f("errorHtmlText",c,p,1),c,p,0,117,156,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("          ");t.b(t.t(t.f("errorHtmlText",c,p,0)));t.b("\n" + i);});c.pop();}t.b("\n" + i);if(!t.s(t.f("errorHtmlText",c,p,1),c,p,1,0,0,"")){t.b("        <h1>");if(t.s(t.f("translate",c,p,1),c,p,0,229,252,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.oops");});c.pop();}t.b("</h1>");t.b("\n" + i);t.b("        <div class=\"error-content\">");t.b("\n" + i);t.b("            <p>");if(t.s(t.f("translate",c,p,1),c,p,0,337,369,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.error_happend");});c.pop();}t.b("</p>");t.b("\n" + i);t.b("            <p>");t.b("\n" + i);t.b("              <a class=\"error_reload\" href=\"javascript:;\">");if(t.s(t.f("translate",c,p,1),c,p,0,476,501,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.reload");});c.pop();}t.b("</a>");t.b("\n" + i);t.b("                ");if(t.s(t.f("translate",c,p,1),c,p,0,550,580,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.reload_text");});c.pop();}t.b("\n" + i);t.b("            </p>");t.b("\n" + i);t.b("        </div>");t.b("\n" + i);};t.b("\n" + i);t.b("      </div>");t.b("\n" + i);t.b("  </div>");t.b("\n" + i);};if(t.s(t.f("isVertical",c,p,1),c,p,0,708,819,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("  <div class=page-error>");t.b("\n" + i);t.b("    <h3>");if(t.s(t.f("translate",c,p,1),c,p,0,756,790,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.v2.ticket_error");});c.pop();}t.b("</h3>");t.b("\n" + i);t.b("  </div>");t.b("\n" + i);});c.pop();}return t.fl(); },partials: {}, subs: {  }}, "{{^isVertical}}  \n  <div class=\"content\">\n      <div class=\"page-error error text-center\">\n        {{#errorHtmlText}}\n          {{{errorHtmlText}}}\n        {{/errorHtmlText}}\n\n        {{^errorHtmlText}}\n        <h1>{{#translate}}js.modules.support.oops{{/translate}}</h1>\n        <div class=\"error-content\">\n            <p>{{#translate}}js.modules.support.error_happend{{/translate}}</p>\n            <p>\n              <a class=\"error_reload\" href=\"javascript:;\">{{#translate}}js.modules.support.reload{{/translate}}</a>\n                {{#translate}}js.modules.support.reload_text{{/translate}}\n            </p>\n        </div>\n        {{/errorHtmlText}}\n\n      </div>\n  </div>\n{{/isVertical}}\n{{#isVertical}}\n  <div class=page-error>\n    <h3>{{#translate}}js.modules.support.v2.ticket_error{{/translate}}</h3>\n  </div>\n{{/isVertical}}\n", Hogan);
},{"hogan.js":248}],13:[function(require,module,exports){
var Hogan = require('hogan.js');
module.exports = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<div id=\"footer_dynamic_links\" class='hide'>");t.b("\n" + i);t.b("  <h5>");if(t.s(t.f("translate",c,p,1),c,p,0,65,105,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.more_ways_to_get_help");});c.pop();}t.b("</h5>");t.b("\n" + i);t.b("  <div class=\"help_text\" style=\"font-size: 13px\">");t.b("\n" + i);t.b("    <div>");t.b("\n" + i);t.b("      <div>");t.b("\n" + i);t.b("        <span class=\"lnk-email-us lnk\" style=\"display:none\" data-bhw=\"email_us\">");if(t.s(t.f("translate",c,p,1),c,p,0,291,317,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.emailus");});c.pop();}t.b("</span>");t.b("\n" + i);t.b("      </div>");t.b("\n" + i);t.b("      <div>");t.b("\n" + i);t.b("        <span class=\"lnk-call-us\" id=\"normal\">");if(t.s(t.f("translate",c,p,1),c,p,0,424,449,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.callus");});c.pop();}t.b("</span>");t.b("\n" + i);t.b("      </div>");t.b("\n" + i);t.b("    </div>");t.b("\n" + i);t.b("  </div>");t.b("\n" + i);t.b("</div>");return t.fl(); },partials: {}, subs: {  }}, "<div id=\"footer_dynamic_links\" class='hide'>\n  <h5>{{#translate}}js.modules.support.more_ways_to_get_help{{/translate}}</h5>\n  <div class=\"help_text\" style=\"font-size: 13px\">\n    <div>\n      <div>\n        <span class=\"lnk-email-us lnk\" style=\"display:none\" data-bhw=\"email_us\">{{#translate}}js.modules.support.emailus{{/translate}}</span>\n      </div>\n      <div>\n        <span class=\"lnk-call-us\" id=\"normal\">{{#translate}}js.modules.support.callus{{/translate}}</span>\n      </div>\n    </div>\n  </div>\n</div>", Hogan);
},{"hogan.js":248}],14:[function(require,module,exports){
var Hogan = require('hogan.js');
module.exports = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<div class=\"support-info-wrapper\">");t.b("\n" + i);t.b("  <section class=\"main row support-info\">");t.b("\n" + i);t.b("    <div class=\"twelve columns\">");t.b("\n" + i);t.b("      <section class=\"module\" >");t.b("\n" + i);t.b("        <div class=\"module-body\" id=\"content\" >");t.b("\n" + i);t.b("          <div class=\"four columns\">");t.b("\n" + i);if(!t.s(t.f("faqInsteadHelpWizard",c,p,1),c,p,1,0,0,"")){t.b("            <h5>");if(t.s(t.f("translate",c,p,1),c,p,0,295,331,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.shared.enhance_your_exper");});c.pop();}t.b("</h5>");t.b("\n" + i);t.b("            <p>");t.b("\n" + i);t.b("              ");if(t.s(t.f("translate",c,p,1),c,p,0,395,431,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.shared.get_relevant_deals");});c.pop();}t.b("\n" + i);t.b("              <a class=\"location-lnk\" href=\"/users/");t.b(t.v(t.f("id",c,p,0)));t.b("/profile/edit\">");if(t.s(t.f("translate",c,p,1),c,p,0,532,559,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.shared.locations");});c.pop();}t.b("</a>");t.b("\n" + i);t.b("              <br/>");t.b("\n" + i);t.b("              ");if(t.s(t.f("translate",c,p,1),c,p,0,626,655,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.shared.let_us_know");});c.pop();}t.b("\n" + i);t.b("              <a class=\"preference-lnk\" href=\"/users/");t.b(t.v(t.f("id",c,p,0)));t.b("/profile/edit\">");if(t.s(t.f("translate",c,p,1),c,p,0,758,792,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.shared.deal_preferences");});c.pop();}t.b("</a>");t.b("\n" + i);t.b("            </p>");t.b("\n" + i);};if(t.s(t.f("faqInsteadHelpWizard",c,p,1),c,p,0,903,1474,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("            <h5>");if(t.s(t.f("translate",c,p,1),c,p,0,934,972,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.shared.access_your_groupons");});c.pop();}t.b("</h5>");t.b("\n" + i);t.b("            <p>");t.b("\n" + i);t.b("              <a class=\"groupons-lnk\" href=\"/users/");t.b(t.v(t.f("id",c,p,0)));t.b("/groupons\">");if(t.s(t.f("translate",c,p,1),c,p,0,1090,1119,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.shared.my_groupons");});c.pop();}t.b("</a>");t.b("\n" + i);t.b("              <br/>");t.b("\n" + i);t.b("              <a class=\"gift-lnk\" href=\"/users/");t.b(t.v(t.f("id",c,p,0)));t.b("/gift_cards\">");if(t.s(t.f("translate",c,p,1),c,p,0,1238,1264,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.shared.my_gifts");});c.pop();}t.b("</a>");t.b("\n" + i);t.b("              <br/>");t.b("\n" + i);t.b("              <a class=\"reservations-lnk\" href=\"/users/");t.b(t.v(t.f("id",c,p,0)));t.b("/reservations\">");if(t.s(t.f("translate",c,p,1),c,p,0,1393,1426,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.shared.my_reservations");});c.pop();}t.b("</a>");t.b("\n" + i);t.b("            </p>");t.b("\n" + i);});c.pop();}t.b("          </div>");t.b("\n" + i);t.b("          <div class=\"four columns\">");t.b("\n" + i);t.b("            <h5>");if(t.s(t.f("translate",c,p,1),c,p,0,1584,1621,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.shared.account_quick_links");});c.pop();}t.b("</h5>");t.b("\n" + i);if(!t.s(t.f("faqInsteadHelpWizard",c,p,1),c,p,1,0,0,"")){t.b("            <p>");t.b("\n" + i);t.b("              ");if(t.s(t.f("translate",c,p,1),c,p,0,1723,1756,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.shared.edit_your_email");});c.pop();}t.b("\n" + i);t.b("              <a class=\"myaccount-lnk\" href=\"/users/");t.b(t.v(t.f("id",c,p,0)));t.b("/account\">");if(t.s(t.f("translate",c,p,1),c,p,0,1853,1881,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.shared.my_account");});c.pop();}t.b("</a>");t.b("\n" + i);t.b("              <br/>");t.b("\n" + i);t.b("              ");if(t.s(t.f("translate",c,p,1),c,p,0,1948,1983,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.shared.manage_and_access");});c.pop();}t.b("\n" + i);t.b("              <a class=\"mygroupon-lnk\" href=\"/users/");t.b(t.v(t.f("id",c,p,0)));t.b("/groupons\">");if(t.s(t.f("translate",c,p,1),c,p,0,2081,2110,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.shared.my_groupons");});c.pop();}t.b("</a>");t.b("\n" + i);t.b("              <br/>");t.b("\n" + i);t.b("              <span>");t.b("\n" + i);t.b("              ");if(t.s(t.f("translate",c,p,1),c,p,0,2198,2227,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.shared.change_your");});c.pop();}t.b("\n" + i);t.b("              <a class=\"subscription-lnk\" href=\"/subscription_center\">");if(t.s(t.f("translate",c,p,1),c,p,0,2326,2363,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.shared.email_subscriptions");});c.pop();}t.b("</a>");t.b("\n" + i);t.b("              </span>");t.b("\n" + i);t.b("            </p>");t.b("\n" + i);};if(t.s(t.f("faqInsteadHelpWizard",c,p,1),c,p,0,2496,3037,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("            <p>");t.b("\n" + i);t.b("              <a class=\"credit-lnk\" href=\"/mybillingrecords\">");if(t.s(t.f("translate",c,p,1),c,p,0,2588,2627,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.shared.edit_credit_card_info");});c.pop();}t.b("</a>");t.b("\n" + i);t.b("              <br/>");t.b("\n" + i);t.b("              <span>");t.b("\n" + i);t.b("              <a class=\"subscription-lnk\" href=\"/subscription_center\">");if(t.s(t.f("translate",c,p,1),c,p,0,2771,2813,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.shared.edit_email_subscriptions");});c.pop();}t.b("</a>");t.b("\n" + i);t.b("              </span>");t.b("\n" + i);t.b("              <br/>");t.b("\n" + i);t.b("              <a class=\"myaccount-lnk\" href=\"/users/");t.b(t.v(t.f("id",c,p,0)));t.b("/account\">");if(t.s(t.f("translate",c,p,1),c,p,0,2956,2989,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.shared.change_password");});c.pop();}t.b("</a>");t.b("\n" + i);t.b("            </p>");t.b("\n" + i);});c.pop();}t.b("          </div>");t.b("\n" + i);t.b("          <div class=\"four columns support_help\">");t.b("\n" + i);t.b("            <h5>");if(t.s(t.f("translate",c,p,1),c,p,0,3160,3199,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.shared.more_ways_to_get_help");});c.pop();}t.b("</h5>");t.b("\n" + i);t.b("            <div class=\"help_text\" style=\"font-size: 13px\"></div>");t.b("\n" + i);t.b("          </div>");t.b("\n" + i);t.b("        </div>");t.b("\n" + i);t.b("      </section>");t.b("\n" + i);t.b("    </div>");t.b("\n" + i);t.b("  </section>");t.b("\n" + i);t.b("</div>");return t.fl(); },partials: {}, subs: {  }}, "<div class=\"support-info-wrapper\">\n  <section class=\"main row support-info\">\n    <div class=\"twelve columns\">\n      <section class=\"module\" >\n        <div class=\"module-body\" id=\"content\" >\n          <div class=\"four columns\">\n            {{^faqInsteadHelpWizard}}\n            <h5>{{#translate}}js.modules.shared.enhance_your_exper{{/translate}}</h5>\n            <p>\n              {{#translate}}js.modules.shared.get_relevant_deals{{/translate}}\n              <a class=\"location-lnk\" href=\"/users/{{id}}/profile/edit\">{{#translate}}js.modules.shared.locations{{/translate}}</a>\n              <br/>\n              {{#translate}}js.modules.shared.let_us_know{{/translate}}\n              <a class=\"preference-lnk\" href=\"/users/{{id}}/profile/edit\">{{#translate}}js.modules.shared.deal_preferences{{/translate}}</a>\n            </p>\n            {{/faqInsteadHelpWizard}}\n            {{#faqInsteadHelpWizard}}\n            <h5>{{#translate}}js.modules.shared.access_your_groupons{{/translate}}</h5>\n            <p>\n              <a class=\"groupons-lnk\" href=\"/users/{{id}}/groupons\">{{#translate}}js.modules.shared.my_groupons{{/translate}}</a>\n              <br/>\n              <a class=\"gift-lnk\" href=\"/users/{{id}}/gift_cards\">{{#translate}}js.modules.shared.my_gifts{{/translate}}</a>\n              <br/>\n              <a class=\"reservations-lnk\" href=\"/users/{{id}}/reservations\">{{#translate}}js.modules.shared.my_reservations{{/translate}}</a>\n            </p>\n            {{/faqInsteadHelpWizard}}\n          </div>\n          <div class=\"four columns\">\n            <h5>{{#translate}}js.modules.shared.account_quick_links{{/translate}}</h5>\n            {{^faqInsteadHelpWizard}}\n            <p>\n              {{#translate}}js.modules.shared.edit_your_email{{/translate}}\n              <a class=\"myaccount-lnk\" href=\"/users/{{id}}/account\">{{#translate}}js.modules.shared.my_account{{/translate}}</a>\n              <br/>\n              {{#translate}}js.modules.shared.manage_and_access{{/translate}}\n              <a class=\"mygroupon-lnk\" href=\"/users/{{id}}/groupons\">{{#translate}}js.modules.shared.my_groupons{{/translate}}</a>\n              <br/>\n              <span>\n              {{#translate}}js.modules.shared.change_your{{/translate}}\n              <a class=\"subscription-lnk\" href=\"/subscription_center\">{{#translate}}js.modules.shared.email_subscriptions{{/translate}}</a>\n              </span>\n            </p>\n            {{/faqInsteadHelpWizard}}\n            {{#faqInsteadHelpWizard}}\n            <p>\n              <a class=\"credit-lnk\" href=\"/mybillingrecords\">{{#translate}}js.modules.shared.edit_credit_card_info{{/translate}}</a>\n              <br/>\n              <span>\n              <a class=\"subscription-lnk\" href=\"/subscription_center\">{{#translate}}js.modules.shared.edit_email_subscriptions{{/translate}}</a>\n              </span>\n              <br/>\n              <a class=\"myaccount-lnk\" href=\"/users/{{id}}/account\">{{#translate}}js.modules.shared.change_password{{/translate}}</a>\n            </p>\n            {{/faqInsteadHelpWizard}}\n          </div>\n          <div class=\"four columns support_help\">\n            <h5>{{#translate}}js.modules.shared.more_ways_to_get_help{{/translate}}</h5>\n            <div class=\"help_text\" style=\"font-size: 13px\"></div>\n          </div>\n        </div>\n      </section>\n    </div>\n  </section>\n</div>", Hogan);
},{"hogan.js":248}],15:[function(require,module,exports){
var Hogan = require('hogan.js');
module.exports = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<div class=\"support-info-wrapper\">");t.b("\n" + i);t.b("  <section class=\"main row support-info\">");t.b("\n" + i);t.b("    <div class=\"twelve columns\">");t.b("\n" + i);t.b("      <section class=\"module\" >");t.b("\n" + i);t.b("        <div class=\"module-body\" id=\"content\" >");t.b("\n" + i);t.b("          <div class=\"four columns\">");t.b("\n" + i);if(!t.s(t.f("faqInsteadHelpWizard",c,p,1),c,p,1,0,0,"")){t.b("            <h5>");if(t.s(t.f("translate",c,p,1),c,p,0,295,331,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.shared.enhance_your_exper");});c.pop();}t.b("</h5>");t.b("\n" + i);t.b("            <p>");t.b("\n" + i);t.b("              ");if(t.s(t.f("translate",c,p,1),c,p,0,395,431,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.shared.get_relevant_deals");});c.pop();}t.b("\n" + i);t.b("              <a class=\"location-lnk\" href=\"/myprofile\">");if(t.s(t.f("translate",c,p,1),c,p,0,516,543,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.shared.locations");});c.pop();}t.b("</a>");t.b("\n" + i);t.b("              <br/>");t.b("\n" + i);t.b("              ");if(t.s(t.f("translate",c,p,1),c,p,0,610,639,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.shared.let_us_know");});c.pop();}t.b("\n" + i);t.b("              <a class=\"preference-lnk\" href=\"/myprofile\">");if(t.s(t.f("translate",c,p,1),c,p,0,726,760,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.shared.deal_preferences");});c.pop();}t.b("</a>");t.b("\n" + i);t.b("            </p>");t.b("\n" + i);};if(t.s(t.f("faqInsteadHelpWizard",c,p,1),c,p,0,871,1402,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("            <h5>");if(t.s(t.f("translate",c,p,1),c,p,0,902,940,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.shared.access_your_groupons");});c.pop();}t.b("</h5>");t.b("\n" + i);t.b("            <p>");t.b("\n" + i);t.b("              <a class=\"mygroupon-lnk\" href=\"/mygroupons\">");if(t.s(t.f("translate",c,p,1),c,p,0,1048,1077,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.shared.my_groupons");});c.pop();}t.b("</a>");t.b("\n" + i);t.b("              <br/>");t.b("\n" + i);t.b("              <a class=\"gifts-lnk\" href=\"/mygifts\">");if(t.s(t.f("translate",c,p,1),c,p,0,1181,1207,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.shared.my_gifts");});c.pop();}t.b("</a>");t.b("\n" + i);t.b("              <br/>");t.b("\n" + i);t.b("              <a class=\"reservations-lnk\" href=\"/mygroupons\">");if(t.s(t.f("translate",c,p,1),c,p,0,1321,1354,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.shared.my_reservations");});c.pop();}t.b("</a>");t.b("\n" + i);t.b("            </p>");t.b("\n" + i);});c.pop();}t.b("          </div>");t.b("\n" + i);t.b("          <div class=\"four columns\">");t.b("\n" + i);t.b("            <h5>");if(t.s(t.f("translate",c,p,1),c,p,0,1512,1549,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.shared.account_quick_links");});c.pop();}t.b("</h5>");t.b("\n" + i);if(!t.s(t.f("faqInsteadHelpWizard",c,p,1),c,p,1,0,0,"")){t.b("            <p>");t.b("\n" + i);t.b("              ");if(t.s(t.f("translate",c,p,1),c,p,0,1651,1686,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.shared.manage_and_access");});c.pop();}t.b("\n" + i);t.b("              <a class=\"mygroupon-lnk\" href=\"/mygroupons\">");if(t.s(t.f("translate",c,p,1),c,p,0,1773,1802,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.shared.my_groupons");});c.pop();}t.b("</a>");t.b("\n" + i);t.b("              <br/>");t.b("\n" + i);t.b("              ");if(t.s(t.f("translate",c,p,1),c,p,0,1869,1898,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.shared.change_your");});c.pop();}t.b("\n" + i);t.b("              <a class=\"subscription-lnk\" href=\"/subscription_center\">");if(t.s(t.f("translate",c,p,1),c,p,0,1997,2034,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.shared.email_subscriptions");});c.pop();}t.b("</a>");t.b("\n" + i);t.b("            </p>");t.b("\n" + i);};if(t.s(t.f("faqInsteadHelpWizard",c,p,1),c,p,0,2145,2678,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("            <p>");t.b("\n" + i);t.b("              <a class=\"myaccount-lnk\" href=\"/mybillingrecords\">");if(t.s(t.f("translate",c,p,1),c,p,0,2240,2279,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.shared.edit_credit_card_info");});c.pop();}t.b("</a>");t.b("\n" + i);t.b("              <br/>");t.b("\n" + i);t.b("              <span>");t.b("\n" + i);t.b("              <a class=\"subscription-lnk\" href=\"/subscription_center\">");if(t.s(t.f("translate",c,p,1),c,p,0,2423,2465,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.shared.edit_email_subscriptions");});c.pop();}t.b("</a>");t.b("\n" + i);t.b("              </span>");t.b("\n" + i);t.b("              <br/>");t.b("\n" + i);t.b("              <a class=\"myaccount-lnk\" href=\"/myaccount\">");if(t.s(t.f("translate",c,p,1),c,p,0,2597,2630,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.shared.change_password");});c.pop();}t.b("</a>");t.b("\n" + i);t.b("            </p>");t.b("\n" + i);});c.pop();}t.b("          </div>");t.b("\n" + i);t.b("          <div class=\"four columns support_help\">");t.b("\n" + i);t.b("            <h5>");if(t.s(t.f("translate",c,p,1),c,p,0,2801,2840,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.shared.more_ways_to_get_help");});c.pop();}t.b("</h5>");t.b("\n" + i);t.b("            <div class=\"help_text\" style=\"font-size: 13px\"></div>");t.b("\n" + i);t.b("          </div>");t.b("\n" + i);t.b("        </div>");t.b("\n" + i);t.b("      </section>");t.b("\n" + i);t.b("    </div>");t.b("\n" + i);t.b("  </section>");t.b("\n" + i);t.b("</div>");return t.fl(); },partials: {}, subs: {  }}, "<div class=\"support-info-wrapper\">\n  <section class=\"main row support-info\">\n    <div class=\"twelve columns\">\n      <section class=\"module\" >\n        <div class=\"module-body\" id=\"content\" >\n          <div class=\"four columns\">\n            {{^faqInsteadHelpWizard}}\n            <h5>{{#translate}}js.modules.shared.enhance_your_exper{{/translate}}</h5>\n            <p>\n              {{#translate}}js.modules.shared.get_relevant_deals{{/translate}}\n              <a class=\"location-lnk\" href=\"/myprofile\">{{#translate}}js.modules.shared.locations{{/translate}}</a>\n              <br/>\n              {{#translate}}js.modules.shared.let_us_know{{/translate}}\n              <a class=\"preference-lnk\" href=\"/myprofile\">{{#translate}}js.modules.shared.deal_preferences{{/translate}}</a>\n            </p>\n            {{/faqInsteadHelpWizard}}\n            {{#faqInsteadHelpWizard}}\n            <h5>{{#translate}}js.modules.shared.access_your_groupons{{/translate}}</h5>\n            <p>\n              <a class=\"mygroupon-lnk\" href=\"/mygroupons\">{{#translate}}js.modules.shared.my_groupons{{/translate}}</a>\n              <br/>\n              <a class=\"gifts-lnk\" href=\"/mygifts\">{{#translate}}js.modules.shared.my_gifts{{/translate}}</a>\n              <br/>\n              <a class=\"reservations-lnk\" href=\"/mygroupons\">{{#translate}}js.modules.shared.my_reservations{{/translate}}</a>\n            </p>\n            {{/faqInsteadHelpWizard}}\n          </div>\n          <div class=\"four columns\">\n            <h5>{{#translate}}js.modules.shared.account_quick_links{{/translate}}</h5>\n            {{^faqInsteadHelpWizard}}\n            <p>\n              {{#translate}}js.modules.shared.manage_and_access{{/translate}}\n              <a class=\"mygroupon-lnk\" href=\"/mygroupons\">{{#translate}}js.modules.shared.my_groupons{{/translate}}</a>\n              <br/>\n              {{#translate}}js.modules.shared.change_your{{/translate}}\n              <a class=\"subscription-lnk\" href=\"/subscription_center\">{{#translate}}js.modules.shared.email_subscriptions{{/translate}}</a>\n            </p>\n            {{/faqInsteadHelpWizard}}\n            {{#faqInsteadHelpWizard}}\n            <p>\n              <a class=\"myaccount-lnk\" href=\"/mybillingrecords\">{{#translate}}js.modules.shared.edit_credit_card_info{{/translate}}</a>\n              <br/>\n              <span>\n              <a class=\"subscription-lnk\" href=\"/subscription_center\">{{#translate}}js.modules.shared.edit_email_subscriptions{{/translate}}</a>\n              </span>\n              <br/>\n              <a class=\"myaccount-lnk\" href=\"/myaccount\">{{#translate}}js.modules.shared.change_password{{/translate}}</a>\n            </p>\n            {{/faqInsteadHelpWizard}}\n          </div>\n          <div class=\"four columns support_help\">\n            <h5>{{#translate}}js.modules.shared.more_ways_to_get_help{{/translate}}</h5>\n            <div class=\"help_text\" style=\"font-size: 13px\"></div>\n          </div>\n        </div>\n      </section>\n    </div>\n  </section>\n</div>", Hogan);
},{"hogan.js":248}],16:[function(require,module,exports){
var SharedUser;

SharedUser = {
  setGrpnUsrHeader: function(options) {
    if ((options != null ? options.headers : void 0) != null) {
      options.headers['x-csrf-token'] = $('meta[name="csrf-token"]').attr('content');
    }
    if (((options != null ? options.data : void 0) != null) && (options != null ? options.type : void 0) === 'POST') {
      return options.data._csrf = $('meta[name="csrf-token"]').attr('content');
    }
  }
};

module.exports = SharedUser;



},{}],17:[function(require,module,exports){
var PresentersBase, SharedUtilsHelper, SupportAPIHelper, SupportUtilsHelper;

PresentersBase = require('../../../backbone_base/frontend/presenters/base');

SupportUtilsHelper = require('../../../support/frontend/helpers/utils');

SupportAPIHelper = require('../../../support/frontend/helpers/API');

SharedUtilsHelper = {
  toHtml: (function(_this) {
    return function(template, hash, scope) {
      return template.render(PresentersBase.toHashWithHelpers(hash, scope));
    };
  })(this),
  redirectToFaq: function() {
    return window.location.href = "" + window.FAQBASEURL;
  },
  redirectToHelpWizard: function() {
    return window.location.href = "" + window.SUPPORTBASEURL;
  },
  scrollTo: function($container) {
    var hash, ref;
    if ($container) {
      hash = {
        scrollTop: (ref = $container.offset()) != null ? ref.top : void 0
      };
      return $('html, body').animate(hash, 1000);
    }
  },
  toggleCallUs: function(id) {
    var experiment;
    addWrapperLinkOverCallUs();
    experiment = $('span.lnk-call-us').attr('id');
    $('span.lnk-call-us').removeAttr('data-bhw-path');
    $('span.lnk-call-us').removeAttr('data-bhw');
    $('span.lnk-call-us').attr("data-bhw", "phone-number-" + experiment + "-" + id);
    return $('span.lnk-call-us').data("bhw", "phone-number-" + experiment + "-" + id);
  },
  addWrapperLinkOverCallUs: function() {
    $('.contact-number').addClass('hide');
    return $('span.lnk-call-us').addClass('lnk');
  },
  propagateEventBeforeReplacingElements: function(cb) {
    setTimeout(cb);
    return true;
  },
  removeSpecificParamFromUrl: function(url, parameter) {
    var hash, hashPresent, i, pars, prefix, queryString, urlBase, urlparts;
    if (url.indexOf('#') > 0) {
      hashPresent = true;
      hash = url.substr(url.indexOf('#') + 1);
    }
    urlparts = url.split("?");
    if (urlparts.length >= 2) {
      urlBase = urlparts.shift();
      queryString = urlparts.join("?");
      prefix = encodeURIComponent(parameter) + "=";
      pars = queryString.split(/[&;]/g);
      i = pars.length;
      while (i-- > 0) {
        if (pars[i].lastIndexOf(prefix, 0) !== -1) {
          pars.splice(i, 1);
        }
      }
      url = urlBase + "?" + pars.join("&");
    }
    if (url.indexOf('#') === -1 && hashPresent) {
      url = url + '#' + hash;
    }
    return url;
  },
  abortAjaxRequests: function(requests) {
    _.each(requests, function(req) {
      return req.abort();
    });
    return null;
  },
  startTimer: function(timer) {},
  stopTimer: function(timer) {},
  isIntl: function() {
    var ref;
    return checkIfIsEMEAByCountryCluster((ref = window.country) != null ? ref.cluster : void 0);
  },
  isUS: function() {
    var ref;
    return checkIfIsUSByCountryCluster((ref = window.country) != null ? ref.cluster : void 0);
  },
  isNeedish: function() {
    var ref;
    return checkIfIsNEEDISHByCountryCluster((ref = window.country) != null ? ref.cluster : void 0);
  },
  checkIfIsUSByCountry: function(country) {
    return getCountryCluster(country) === 'US';
  },
  checkIfIsEMEAByCountry: function(country) {
    return getCountryCluster(country) === 'EMEA';
  },
  checkIfIsNEEDISHByCountry: function(country) {
    return getCountryCluster(country) === 'NEEDISH';
  },
  checkIfIsUSByCountryCluster: function(countryCluster) {
    return countryCluster === 'US';
  },
  checkIfIsEMEAByCountryCluster: function(countryCluster) {
    return countryCluster === 'EMEA';
  },
  checkIfIsNEEDISHByCountryCluster: function(countryCluster) {
    return countryCluster === 'NEEDISH';
  },
  getCountryCluster: function(country) {
    if (country != null) {
      country = country.toUpperCase();
    }
    if (country === 'US' || country === 'IN') {
      return country;
    }
    if (country === 'PH' || country === 'TH') {
      return 'ASIA';
    }
    if (country === 'CL' || country === 'CO' || country === 'MX' || country === 'PA' || country === 'PE' || country === 'PR' || country === 'UY') {
      return 'NEEDISH';
    }
    return 'EMEA';
  },
  getCallUsMsg: function() {
    var customPhoneNumber;
    customPhoneNumber = getCustomPhoneNumber();
    if (customPhoneNumber != null) {
      return I18n.translate('js.modules.shared.call_us_message_with_custom_phone_number', {
        custom_phone_number: customPhoneNumber
      });
    } else {
      return I18n.translate('js.modules.shared.call_us_message');
    }
  },
  getCustomPhoneNumber: function() {
    var dealType, ref;
    dealType = (ref = Groupon.Support.currentOrder) != null ? ref.DEAL_TYPE : void 0;
    if ((typeof phoneNumbers !== "undefined" && phoneNumbers !== null ? phoneNumbers[dealType] : void 0) != null) {
      return phoneNumbers[dealType].custom;
    }
  },
  evaluate: function(key) {
    return (key != null) && (key === true || key === "true");
  },
  isCMSEnabled: function() {
    return (typeof experiments !== "undefined" && experiments !== null ? experiments.shouldDisplayCMSContentForUS : void 0) || !isUS();
  },
  showDOMElems: function(DOMElems) {
    addShowClass(DOMElems);
    return removeHideClass(DOMElems);
  },
  showDOMElemsInline: function(DOMElems) {
    removeHideClass(DOMElems);
    return addInlineClass(DOMElems);
  },
  hideDOMElems: function(DOMElems) {
    removeShowClass(DOMElems);
    return addHideClass(DOMElems);
  },
  addShowClass: function(DOMElems) {
    return addClassToDOMElems(DOMElems, 'show');
  },
  addInlineClass: function(DOMElems) {
    return addClassToDOMElems(DOMElems, 'display-inline');
  },
  removeDOMElemsInline: function(DOMElems) {
    return removeClassFromDOMElems(DOMElems, 'display-inline');
  },
  removeHideClass: function(DOMElems) {
    return removeClassFromDOMElems(DOMElems, 'hide');
  },
  removeShowClass: function(DOMElems) {
    return removeClassFromDOMElems(DOMElems, 'show');
  },
  addHideClass: function(DOMElems) {
    return addClassToDOMElems(DOMElems, 'hide');
  },
  addBtnPrimaryClass: function(DOMElems) {
    return addClassToDOMElems(DOMElems, 'btn-primary');
  },
  addBtnSecondaryClass: function(DOMElems) {
    return addClassToDOMElems(DOMElems, 'btn-invert');
  },
  addPreferredContactClass: function(DOMElems) {
    return addClassToDOMElems(DOMElems, 'preferred-contact-channel');
  },
  removeBtnPrimaryClass: function(DOMElems) {
    return removeClassFromDOMElems(DOMElems, 'btn-primary');
  },
  removeBtnSecondaryClass: function(DOMElems) {
    return removeClassFromDOMElems(DOMElems, 'btn-invert');
  },
  removePreferredContactClass: function(DOMElems) {
    return removeClassFromDOMElems(DOMElems, 'preferred-contact-channel');
  },
  addBloodHoundTagToDOMElems: function(DOMElems, tagName) {
    return manipulateDOMElems(DOMElems, window.addBloodHoundTagToDOMElem, tagName);
  },
  addClassToDOMElems: function(DOMElems, className) {
    return manipulateDOMElems(DOMElems, window.addClassToDOMElem, className);
  },
  removeClassFromDOMElems: function(DOMElems, className) {
    return manipulateDOMElems(DOMElems, window.removeClassFromDOMElem, className);
  },
  manipulateDOMElems: function(DOMElems, manipulateDOMElem, CSSSelector) {
    DOMElems = getInArrayFormat(DOMElems);
    return _.each(DOMElems, (function(_this) {
      return function(DOMElem, index) {
        return manipulateDOMElem(DOMElem, CSSSelector);
      };
    })(this));
  },
  addClassToDOMElem: function(DOMElem, className) {
    return DOMElem.addClass(className);
  },
  addBloodHoundTagToDOMElem: function(DOMElem, tagName) {
    DOMElem.removeAttr('data-bhw-path');
    DOMElem.removeAttr('data-bhw');
    DOMElem.attr("data-bhw", tagName);
    return DOMElem.data("bhw", tagName);
  },
  removeClassFromDOMElem: function(DOMElem, className) {
    return DOMElem.removeClass(className);
  },
  getInArrayFormat: function(elements) {
    if (_.isArray(elements)) {
      return elements;
    } else {
      return [elements];
    }
  },
  createTicket: (function(_this) {
    return function(data, successCb, errorCb, loadElem, loadingElemHeight) {
      return propagateEventBeforeReplacingElements(function() {
        var method, ref, tHubData, url;
        SupportUtilsHelper.showLoading(loadElem, loadingElemHeight);
        url = window.SUPPORTBASEURL + "/ticket/create";
        method = "POST";
        tHubData = {
          ticketParams: data,
          user: (ref = window.currentUser) != null ? ref.id : void 0
        };
        TrackingHub.add('ticket-create-params', {
          params: tHubData
        });
        return SupportAPIHelper.call(url, method, data, successCb, errorCb, false);
      });
    };
  })(this)
};

module.exports = SharedUtilsHelper;



},{"../../../backbone_base/frontend/presenters/base":7,"../../../support/frontend/helpers/API":51,"../../../support/frontend/helpers/utils":54}],18:[function(require,module,exports){
var SharedFeatureFlagModel;

SharedFeatureFlagModel = (function() {
  function SharedFeatureFlagModel() {}

  SharedFeatureFlagModel.prototype.isEnabled = function(key) {
    var ref;
    return window.evaluate((ref = window.featureFlagJSON) != null ? ref[key] : void 0);
  };

  SharedFeatureFlagModel.prototype.isRedesignOrdersUSEnabled = function() {
    return this.isEnabled("redesignOrdersUS");
  };

  SharedFeatureFlagModel.prototype.isShowLiveChatEnabled = function() {
    return this.isEnabled("showLiveChat");
  };

  SharedFeatureFlagModel.prototype.isShowMerchantInfoFieldsEnabled = function() {
    return this.isEnabled("showMerchantInfoFields");
  };

  SharedFeatureFlagModel.prototype.isShowUserContactInfoFieldsEnabled = function() {
    return this.isEnabled("showUserContactInfoFields");
  };

  SharedFeatureFlagModel.prototype.isSearchBasedDropDownsEnabled = function() {
    return this.isEnabled("searchBasedDropDowns");
  };

  return SharedFeatureFlagModel;

})();

module.exports = SharedFeatureFlagModel;



},{}],19:[function(require,module,exports){
var Backbone, SharedAjaxErrorTemplate, SharedAjaxErrorView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Backbone = require('backbone');

Backbone.$ = $;

SharedAjaxErrorTemplate = require('../../ajax_error.html.mustache');

SharedAjaxErrorView = (function(superClass) {
  extend(SharedAjaxErrorView, superClass);

  function SharedAjaxErrorView() {
    return SharedAjaxErrorView.__super__.constructor.apply(this, arguments);
  }

  SharedAjaxErrorView.prototype.initialize = function() {
    this.I18nScope = 'modules.shared';
    return this.template = SharedAjaxErrorTemplate;
  };

  SharedAjaxErrorView.prototype.render = function(hash) {
    if ((hash != null ? hash.container : void 0) != null) {
      this.$container = hash.container;
      this.$container.html(toHtml(this.template, hash, this.I18nScope));
      this.bindEvents();
      return this.$container;
    }
  };

  SharedAjaxErrorView.prototype.bindEvents = function() {
    return $(".error_reload", this.$container).on("click", function() {
      return window.location.reload();
    });
  };

  return SharedAjaxErrorView;

})(Backbone.View);

module.exports = SharedAjaxErrorView;



},{"../../ajax_error.html.mustache":12,"backbone":245}],20:[function(require,module,exports){
var Backbone, SharedFooterIntlMainView, SharedFooterIntlPhoneNumberView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Backbone = require('backbone');

Backbone.$ = $;

SharedFooterIntlPhoneNumberView = require('./phone_number_view');

SharedFooterIntlMainView = (function(superClass) {
  extend(SharedFooterIntlMainView, superClass);

  function SharedFooterIntlMainView() {
    return SharedFooterIntlMainView.__super__.constructor.apply(this, arguments);
  }

  SharedFooterIntlMainView.prototype["class"] = 'box support-footer';

  SharedFooterIntlMainView.prototype.id = 'intl_footer';

  SharedFooterIntlMainView.prototype.initialize = function(options) {
    this.options = options || {};
    _.bindAll.apply(_, [this].concat(_.functions(this)));
    this.I18nScope = 'modules.shared';
    this.template = this.options.template;
    return this.emailFormModel = this.options.model;
  };

  SharedFooterIntlMainView.prototype.renderPhoneNumberView = function() {
    return propagateEventBeforeReplacingElements((function(_this) {
      return function() {
        var phoneNumberView;
        phoneNumberView = new SharedFooterIntlPhoneNumberView({
          emailFormModel: _this.emailFormModel,
          renderPopup: true
        });
        return phoneNumberView.render();
      };
    })(this));
  };

  SharedFooterIntlMainView.prototype.renderEmailForm = function() {
    return this.options.emailUs();
  };

  SharedFooterIntlMainView.prototype.render = function() {
    return this.$el.append(toHtml(this.template, this.toHash(), this.I18nScope));
  };

  SharedFooterIntlMainView.prototype.toHash = function() {
    return window.getOrderInfoForBH(Groupon.Support.currentOrder);
  };

  SharedFooterIntlMainView.prototype.events = {
    "click span.lnk-call-us": "renderPhoneNumberView",
    "click span.lnk-email-us": "renderEmailForm"
  };

  return SharedFooterIntlMainView;

})(Backbone.View);

module.exports = SharedFooterIntlMainView;



},{"./phone_number_view":21,"backbone":245}],21:[function(require,module,exports){
var Backbone, SharedFooterIntlPhoneNumberView, SharedIntlCallUsTemplate, SharedTicketNumberMsgTemplate,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Backbone = require('backbone');

Backbone.$ = $;

SharedTicketNumberMsgTemplate = require('../../../../ticket_number_msg.html.mustache');

SharedIntlCallUsTemplate = require('../../../../intl_call_us.html.mustache');

SharedFooterIntlPhoneNumberView = (function(superClass) {
  extend(SharedFooterIntlPhoneNumberView, superClass);

  function SharedFooterIntlPhoneNumberView() {
    this.renderError = bind(this.renderError, this);
    this.renderSuccess = bind(this.renderSuccess, this);
    return SharedFooterIntlPhoneNumberView.__super__.constructor.apply(this, arguments);
  }

  SharedFooterIntlPhoneNumberView.prototype["class"] = 'support';

  SharedFooterIntlPhoneNumberView.prototype.initialize = function(options) {
    this.options = options || {};
    this.I18nScope = 'modules.support';
    this.template = SharedIntlCallUsTemplate;
    this.ticketNumberMsgTemplate = SharedTicketNumberMsgTemplate;
    this.popupContainer = $("#popup");
    this.emailFormModel = this.options.emailFormModel;
    return this.shouldRenderPopup = this.options.renderPopup;
  };

  SharedFooterIntlPhoneNumberView.prototype.render = function() {
    var data, ref;
    if (this.shouldRenderPopup) {
      this.renderPopup();
    } else {
      this.renderPhoneNumber();
    }
    if (((ref = window.experiments) != null ? ref.callTicketEnabled : void 0) && window.isLoggedIn) {
      data = this.emailFormModel.getBasicTicketData();
      data.synchronous = true;
      createTicket(data, this.renderSuccess, this.renderError, this.$el.find('#ticket-number-msg'), "100px");
      return propagateEventBeforeReplacingElements(function() {
        return $('#g-spinner').addClass('call-us-popup-spinner');
      });
    }
  };

  SharedFooterIntlPhoneNumberView.prototype.renderSuccess = function(response) {
    var ref, ticketNumber;
    ticketNumber = response != null ? (ref = response.res) != null ? ref.ticket_id : void 0 : void 0;
    if (ticketNumber != null) {
      return this.$el.find('#ticket-number-msg').html(toHtml(this.ticketNumberMsgTemplate, this.getTicketSuccessHash(ticketNumber), this.I18nScope));
    } else {
      return this.renderError();
    }
  };

  SharedFooterIntlPhoneNumberView.prototype.renderError = function() {
    return this.$el.find('#ticket-number-msg').html("");
  };

  SharedFooterIntlPhoneNumberView.prototype.renderPopup = function() {
    GIG.Modal.open({
      el: this.popupContainer,
      closeOnBgClick: true,
      closeOnEscKey: true
    });
    this.renderPhoneNumber();
    return this.popupContainer.html(this.el);
  };

  SharedFooterIntlPhoneNumberView.prototype.renderPhoneNumber = function() {
    return this.$el.append(toHtml(this.template, this.toHash(), this.I18nScope));
  };

  SharedFooterIntlPhoneNumberView.prototype.toHash = function() {
    return {
      call_us_message: getCallUsMsg(),
      shouldRenderPopup: this.shouldRenderPopup
    };
  };

  SharedFooterIntlPhoneNumberView.prototype.getTicketSuccessHash = function(ticketNumber) {
    return _.extend({
      ticket_number: ticketNumber
    }, window.getOrderInfoForBH(Groupon.Support.currentOrder));
  };

  SharedFooterIntlPhoneNumberView.prototype.closeModal = function() {
    GIG.Modal.close();
    return false;
  };

  SharedFooterIntlPhoneNumberView.prototype.events = {
    'click .close-modal': "closeModal",
    'click .b-close': "closeModal"
  };

  return SharedFooterIntlPhoneNumberView;

})(Backbone.View);

module.exports = SharedFooterIntlPhoneNumberView;



},{"../../../../intl_call_us.html.mustache":26,"../../../../ticket_number_msg.html.mustache":30,"backbone":245}],22:[function(require,module,exports){
var Backbone, SharedFooterLinksTemplate, SharedFooterLoggedTemplate, SharedFooterNotLoggedTemplate, SharedFooterUSMainView, SharedFooterUSPhoneNumberView, SupportPhoneNumberCallBackView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SharedFooterUSPhoneNumberView = require('./phone_number_view');

SupportPhoneNumberCallBackView = require('../../../../../support/frontend/views/email_form/US/phone_number_call_back_view');

Backbone = require('backbone');

Backbone.$ = $;

SharedFooterLoggedTemplate = require('../../../../footer_logged.html.mustache');

SharedFooterNotLoggedTemplate = require('../../../../footer_not_logged.html.mustache');

SharedFooterLinksTemplate = require('../../../../footer_links.html.mustache');

SharedFooterUSMainView = (function(superClass) {
  extend(SharedFooterUSMainView, superClass);

  function SharedFooterUSMainView() {
    return SharedFooterUSMainView.__super__.constructor.apply(this, arguments);
  }

  SharedFooterUSMainView.prototype["class"] = 'box support-footer';

  SharedFooterUSMainView.prototype.initialize = function() {
    this.I18nScope = 'modules.shared';
    this.user = window.currentUser;
    this.template = this.user != null ? SharedFooterLoggedTemplate : SharedFooterNotLoggedTemplate;
    return this.footerLinkTemplate = SharedFooterLinksTemplate;
  };

  SharedFooterUSMainView.prototype.render = function() {
    var ref;
    this.$el.append(toHtml(this.template, {
      id: (ref = this.user) != null ? ref.id : void 0,
      faqInsteadHelpWizard: window.faqInsteadHelpWizard
    }, this.I18nScope));
    return this.$el.find('.support_help').html(toHtml(this.footerLinkTemplate, this.user, this.I18nScope));
  };

  SharedFooterUSMainView.prototype.renderPhoneNumberView = function() {
    if (experiments.shouldDisplayCallBackOption && !window.isFAQ) {
      return this.renderPhoneNumberCallBackView();
    } else {
      return this.renderNormalPhoneNumberView();
    }
  };

  SharedFooterUSMainView.prototype.renderNormalPhoneNumberView = function() {
    return propagateEventBeforeReplacingElements((function(_this) {
      return function() {
        var phoneNumberView;
        phoneNumberView = new SharedFooterUSPhoneNumberView();
        return phoneNumberView.render();
      };
    })(this));
  };

  SharedFooterUSMainView.prototype.renderPhoneNumberCallBackView = function() {
    return propagateEventBeforeReplacingElements((function(_this) {
      return function() {
        _this.phoneNumberCallBackView = new SupportPhoneNumberCallBackView({
          mainView: _this
        });
        return _this.phoneNumberCallBackView.render();
      };
    })(this));
  };

  SharedFooterUSMainView.prototype.events = {
    "click span.lnk-call-us": "renderPhoneNumberView"
  };

  return SharedFooterUSMainView;

})(Backbone.View);

module.exports = SharedFooterUSMainView;



},{"../../../../../support/frontend/views/email_form/US/phone_number_call_back_view":141,"../../../../footer_links.html.mustache":13,"../../../../footer_logged.html.mustache":14,"../../../../footer_not_logged.html.mustache":15,"./phone_number_view":23,"backbone":245}],23:[function(require,module,exports){
var Backbone, SharedFooterUSPhoneNumberView, SharedPhoneNumberTemplate,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Backbone = require('backbone');

Backbone.$ = $;

SharedPhoneNumberTemplate = require('../../../../phone_number.html.mustache');

SharedFooterUSPhoneNumberView = (function(superClass) {
  extend(SharedFooterUSPhoneNumberView, superClass);

  function SharedFooterUSPhoneNumberView() {
    return SharedFooterUSPhoneNumberView.__super__.constructor.apply(this, arguments);
  }

  SharedFooterUSPhoneNumberView.prototype["class"] = 'support';

  SharedFooterUSPhoneNumberView.prototype.initialize = function(options) {
    if (options == null) {
      options = {};
    }
    this.I18nScope = 'modules.support';
    this.template = SharedPhoneNumberTemplate;
    return this.popupContainer = $("#popup");
  };

  SharedFooterUSPhoneNumberView.prototype.render = function() {
    GIG.Modal.open({
      el: this.popupContainer,
      closeOnBgClick: true,
      closeOnEscKey: true
    });
    this.$el.append(toHtml(this.template, this.toHash(), this.I18nScope));
    return this.popupContainer.html(this.el);
  };

  SharedFooterUSPhoneNumberView.prototype.toHash = function() {
    var deal, hash, ref, ref1;
    deal = ((ref = Groupon.Support) != null ? (ref1 = ref.currentOrder) != null ? ref1.DEAL_TYPE : void 0 : void 0) || null;
    hash = {
      showMRDealPhoneNumbers: deal === "GETAWAYS_MARKET_RATE"
    };
    if (deal === "GETAWAYS_MARKET_RATE") {
      TrackingHub.add("SUPPORT-APP-MARKET-RATE-CALL-US", {
        data: window.currentUser
      });
    }
    return hash;
  };

  SharedFooterUSPhoneNumberView.prototype.closeModal = function() {
    GIG.Modal.close();
    return false;
  };

  SharedFooterUSPhoneNumberView.prototype.events = {
    'click .close-modal': "closeModal",
    'click .b-close': "closeModal"
  };

  return SharedFooterUSPhoneNumberView;

})(Backbone.View);

module.exports = SharedFooterUSPhoneNumberView;



},{"../../../../phone_number.html.mustache":28,"backbone":245}],24:[function(require,module,exports){
var Backbone, SharedSpinnerTemplate, SharedSpinnerView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SharedSpinnerTemplate = require('../../spinner.html.mustache');

Backbone = require('backbone');

Backbone.$ = $;

SharedSpinnerView = (function(superClass) {
  extend(SharedSpinnerView, superClass);

  function SharedSpinnerView() {
    return SharedSpinnerView.__super__.constructor.apply(this, arguments);
  }

  SharedSpinnerView.prototype.initialize = function() {
    this.I18nScope = 'modules.shared';
    return this.template = SharedSpinnerTemplate;
  };

  SharedSpinnerView.prototype.show = function(hash) {
    if ((hash != null ? hash.container : void 0) != null) {
      this.$container = hash.container;
      this.$el.html(toHtml(this.template, hash, this.I18nScope));
      if (hash.append) {
        this.$container.append(this.$el);
      } else {
        this.$container.html(this.$el);
      }
      if (hash.height) {
        this.$el.css('height', hash.height);
        $('.g-spinner', this.$el).css('height', hash.height);
      }
      if (hash.id) {
        return this.$el.attr('id', hash.id);
      }
    }
  };

  SharedSpinnerView.prototype.hide = function() {
    return this.$el.empty();
  };

  SharedSpinnerView.prototype.remove = function() {
    return this.$el.remove();
  };

  return SharedSpinnerView;

})(Backbone.View);

module.exports = SharedSpinnerView;



},{"../../spinner.html.mustache":29,"backbone":245}],25:[function(require,module,exports){
var SharedWidgetLayoutView, WLS;

WLS = require('../../../../node_modules/widget-layout-assets/coffee/wls');

SharedWidgetLayoutView = {
  hideWidgets: function() {
    return $('.cross-sell-widgets').hide();
  },
  showWidgets: function(page_type) {
    var $crossSellWidgetContainer, $crossSellWidgetContentContainer, ref;
    if (this.isWidgetLayoutEnabled()) {
      $crossSellWidgetContainer = $('.cross-sell-widgets');
      $crossSellWidgetContentContainer = $('#cross-sell-widgets-content-container');
      $crossSellWidgetContentContainer.empty();
      if ((typeof widgetLayoutResponse !== "undefined" && widgetLayoutResponse !== null ? widgetLayoutResponse.RecentlyViewedDeals : void 0) != null) {
        $crossSellWidgetContentContainer.html(widgetLayoutResponse.RecentlyViewedDeals);
      }
      if ((typeof widgetLayoutResponse !== "undefined" && widgetLayoutResponse !== null ? widgetLayoutResponse.MoreRecommendations : void 0) != null) {
        $crossSellWidgetContentContainer.append(widgetLayoutResponse.MoreRecommendations);
      }
      switch (page_type) {
        case 'ticket-success':
          $crossSellWidgetContentContainer.removeClass('problem-solved-step');
          $crossSellWidgetContentContainer.addClass('ticket-success-step');
          break;
        case 'problem-solved':
          $crossSellWidgetContentContainer.removeClass('ticket-success-step');
          $crossSellWidgetContentContainer.addClass('problem-solved-step');
      }
      $crossSellWidgetContainer.show();
      if (((ref = window.WLS) != null ? ref.init : void 0) != null) {
        window.WLS.init();
        return $('.lazy-load').lazyload({});
      }
    }
  },
  isWidgetLayoutEnabled: function() {
    return ((typeof widgetLayoutResponse !== "undefined" && widgetLayoutResponse !== null ? widgetLayoutResponse.RecentlyViewedDeals : void 0) != null) || ((typeof widgetLayoutResponse !== "undefined" && widgetLayoutResponse !== null ? widgetLayoutResponse.MoreRecommendations : void 0) != null);
  }
};

module.exports = SharedWidgetLayoutView;



},{"../../../../node_modules/widget-layout-assets/coffee/wls":250}],26:[function(require,module,exports){
var Hogan = require('hogan.js');
module.exports = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");if(t.s(t.f("shouldRenderPopup",c,p,1),c,p,0,22,801,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("  <div  class=\"modal show-modal\">");t.b("\n" + i);t.b("    <div class=\"modal-body intl-call-us-popup\">");t.b("\n" + i);t.b("      <a href=\"javascript:;\" data-modal-id=\"popupContent\" class=\"close-modal icon-x\"></a>");t.b("\n" + i);t.b("      <h3 class=\"modal-title\">");t.b("\n" + i);t.b("        ");if(t.s(t.f("translate",c,p,1),c,p,0,248,273,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.shared.call_us");});c.pop();}t.b("\n" + i);t.b("      </h3>");t.b("\n" + i);t.b("      <div class=\"row\">");t.b("\n" + i);t.b("        <div class=\"twelve columns callUsPopupData call-us-msg-header\">");t.b("\n" + i);t.b("          <div>");t.b("\n" + i);t.b("            <span>");t.b("\n" + i);t.b("              ");t.b(t.v(t.f("call_us_message",c,p,0)));t.b("\n" + i);t.b("            </span>");t.b("\n" + i);t.b("          </div>");t.b("\n" + i);t.b("        </div>");t.b("\n" + i);t.b("      </div>");t.b("\n" + i);t.b("      <div id=\"ticket-number-msg\" class=\"row\">");t.b("\n" + i);t.b("      </div>");t.b("\n" + i);t.b("      <div class=\"modal-footer call-us-popup-footer\">");t.b("\n" + i);t.b("        <a class=\"close-modal\">");t.b("\n" + i);t.b("          ");if(t.s(t.f("translate",c,p,1),c,p,0,700,740,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.return_to_help_wizard");});c.pop();}t.b("\n" + i);t.b("        </a>");t.b("\n" + i);t.b("      </div>");t.b("\n" + i);t.b("    </div>");t.b("\n" + i);t.b("  </div>");t.b("\n" + i);});c.pop();}t.b("\n");t.b("\n" + i);if(!t.s(t.f("shouldRenderPopup",c,p,1),c,p,1,0,0,"")){t.b("  <div class='row'>");t.b("\n" + i);t.b("    <span class='icon-phone'></span>");t.b("\n" + i);t.b("    <span class='article-title'>");t.b("\n" + i);t.b("      ");if(t.s(t.f("translate",c,p,1),c,p,0,959,984,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.shared.call_us");});c.pop();}t.b("\n" + i);t.b("    </span>");t.b("\n" + i);t.b("  </div>");t.b("\n" + i);t.b("  <div class=\"row\">");t.b("\n" + i);t.b("    <div class=\"callUsPopupData call-us-msg-header\">");t.b("\n" + i);t.b("      <span>");t.b("\n" + i);t.b("        ");t.b(t.v(t.f("call_us_message",c,p,0)));t.b("\n" + i);t.b("      </span>");t.b("\n" + i);t.b("    </div>");t.b("\n" + i);t.b("  </div>");t.b("\n" + i);t.b("  <div id=\"ticket-number-msg\" class=\"row\"></div>");t.b("\n" + i);};return t.fl(); },partials: {}, subs: {  }}, "{{#shouldRenderPopup}}\n  <div  class=\"modal show-modal\">\n    <div class=\"modal-body intl-call-us-popup\">\n      <a href=\"javascript:;\" data-modal-id=\"popupContent\" class=\"close-modal icon-x\"></a>\n      <h3 class=\"modal-title\">\n        {{#translate}}js.modules.shared.call_us{{/translate}}\n      </h3>\n      <div class=\"row\">\n        <div class=\"twelve columns callUsPopupData call-us-msg-header\">\n          <div>\n            <span>\n              {{call_us_message}}\n            </span>\n          </div>\n        </div>\n      </div>\n      <div id=\"ticket-number-msg\" class=\"row\">\n      </div>\n      <div class=\"modal-footer call-us-popup-footer\">\n        <a class=\"close-modal\">\n          {{#translate}}js.modules.support.return_to_help_wizard{{/translate}}\n        </a>\n      </div>\n    </div>\n  </div>\n{{/shouldRenderPopup}}\n\n\n{{^shouldRenderPopup}}\n  <div class='row'>\n    <span class='icon-phone'></span>\n    <span class='article-title'>\n      {{#translate}}js.modules.shared.call_us{{/translate}}\n    </span>\n  </div>\n  <div class=\"row\">\n    <div class=\"callUsPopupData call-us-msg-header\">\n      <span>\n        {{call_us_message}}\n      </span>\n    </div>\n  </div>\n  <div id=\"ticket-number-msg\" class=\"row\"></div>\n{{/shouldRenderPopup}}", Hogan);
},{"hogan.js":248}],27:[function(require,module,exports){
var Hogan = require('hogan.js');
module.exports = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<div class=\"support-info-wrapper\">");t.b("\n" + i);t.b("  <div class=\"module-body intl-footer\" id=\"content\">");t.b("\n" + i);t.b("    <span>");if(t.s(t.f("translate",c,p,1),c,p,0,112,139,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.shared.help_text");});c.pop();}t.b("</span>");t.b("\n" + i);t.b("    <div class=\"help_text\" style=\"font-size: 13px\">");t.b("\n" + i);t.b("        <div>");t.b("\n" + i);t.b("          <span class=\"lnk-call-us lnk\" id=\"intl\" data-bhw=\"call-us__");t.b(t.v(t.f("id",c,p,0)));t.b("__");t.b(t.v(t.f("dealId",c,p,0)));t.b("__");t.b(t.v(t.f("channel",c,p,0)));t.b("__");t.b(t.v(t.f("country",c,p,0)));t.b("\">");if(t.s(t.f("translate",c,p,1),c,p,0,356,381,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.shared.call_us");});c.pop();}t.b("</span>");t.b("\n" + i);t.b("          <span>");if(t.s(t.f("translate",c,p,1),c,p,0,433,463,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.shared.call_us_time");});c.pop();}t.b("</span>");t.b("\n" + i);t.b("        </div>");t.b("\n" + i);t.b("    </div>");t.b("\n");t.b("\n" + i);t.b("  </div>");t.b("\n" + i);t.b("</div>");return t.fl(); },partials: {}, subs: {  }}, "<div class=\"support-info-wrapper\">\n  <div class=\"module-body intl-footer\" id=\"content\">\n    <span>{{#translate}}js.modules.shared.help_text{{/translate}}</span>\n    <div class=\"help_text\" style=\"font-size: 13px\">\n        <div>\n          <span class=\"lnk-call-us lnk\" id=\"intl\" data-bhw=\"call-us__{{id}}__{{dealId}}__{{channel}}__{{country}}\">{{#translate}}js.modules.shared.call_us{{/translate}}</span>\n          <span>{{#translate}}js.modules.shared.call_us_time{{/translate}}</span>\n        </div>\n    </div>\n\n  </div>\n</div>", Hogan);
},{"hogan.js":248}],28:[function(require,module,exports){
var Hogan = require('hogan.js');
module.exports = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<div  class=\"modal show-modal\">");t.b("\n" + i);t.b("  <div class=\"modal-body phone-number\">");t.b("\n" + i);t.b("    <a href=\"javascript:;\" data-modal-id=\"popupContent\" class=\"close-modal icon-x\"></a>");t.b("\n" + i);t.b("    <h3 class=\"modal-title\">");t.b("\n" + i);t.b("      ");if(t.s(t.f("translate",c,p,1),c,p,0,209,245,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.call_popup_header");});c.pop();}t.b("\n" + i);t.b("    </h3>");t.b("\n" + i);t.b("    <div class=\"row\">");t.b("\n" + i);t.b("      <div class=\"twelve columns callUsPopupData p20\">");t.b("\n" + i);t.b("        <div>");t.b("\n" + i);t.b("          <span class = \"high_volume_msg_warning\">");t.b("\n" + i);t.b("            ");if(t.s(t.f("translate",c,p,1),c,p,0,438,479,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.high_call_volume_msg_1");});c.pop();}t.b("\n" + i);t.b("          </span>");t.b("\n" + i);t.b("          <span>");t.b("\n" + i);t.b("            ");if(t.s(t.f("translate",c,p,1),c,p,0,555,596,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.high_call_volume_msg_2");});c.pop();}t.b("\n" + i);t.b("          </span>");t.b("\n" + i);t.b("        </div>");t.b("\n" + i);t.b("        <div class=\"normal-phone-hours\">");t.b("\n" + i);t.b("          <span>");t.b("\n" + i);if(!t.s(t.f("showMRDealPhoneNumbers",c,p,1),c,p,1,0,0,"")){t.b("            ");if(t.s(t.f("translate",c,p,1),c,p,0,768,816,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.high_call_volume_phone_number");});c.pop();}t.b("\n" + i);};t.b("\n" + i);if(t.s(t.f("showMRDealPhoneNumbers",c,p,1),c,p,0,911,1016,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("            ");if(t.s(t.f("translate",c,p,1),c,p,0,938,989,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.high_call_volume_phone_number_mr");});c.pop();}t.b("\n" + i);});c.pop();}t.b("          </span>");t.b("\n" + i);t.b("        </div>");t.b("\n" + i);t.b("      </div>");t.b("\n" + i);t.b("    </div>");t.b("\n" + i);t.b("    <div class=\"modal-footer\">");t.b("\n" + i);t.b("      <a class=\"close-modal\">");t.b("\n" + i);t.b("        ");if(t.s(t.f("translate",c,p,1),c,p,0,1184,1224,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.return_to_help_wizard");});c.pop();}t.b("\n" + i);t.b("      </a>");t.b("\n" + i);t.b("    </div>");t.b("\n" + i);t.b("  </div>");t.b("\n" + i);t.b("</div>");t.b("\n");return t.fl(); },partials: {}, subs: {  }}, "<div  class=\"modal show-modal\">\n  <div class=\"modal-body phone-number\">\n    <a href=\"javascript:;\" data-modal-id=\"popupContent\" class=\"close-modal icon-x\"></a>\n    <h3 class=\"modal-title\">\n      {{#translate}}js.modules.support.call_popup_header{{/translate}}\n    </h3>\n    <div class=\"row\">\n      <div class=\"twelve columns callUsPopupData p20\">\n        <div>\n          <span class = \"high_volume_msg_warning\">\n            {{#translate}}js.modules.support.high_call_volume_msg_1{{/translate}}\n          </span>\n          <span>\n            {{#translate}}js.modules.support.high_call_volume_msg_2{{/translate}}\n          </span>\n        </div>\n        <div class=\"normal-phone-hours\">\n          <span>\n            {{^showMRDealPhoneNumbers}}\n            {{#translate}}js.modules.support.high_call_volume_phone_number{{/translate}}\n            {{/showMRDealPhoneNumbers}}\n\n            {{#showMRDealPhoneNumbers}}\n            {{#translate}}js.modules.support.high_call_volume_phone_number_mr{{/translate}}\n            {{/showMRDealPhoneNumbers}}\n          </span>\n        </div>\n      </div>\n    </div>\n    <div class=\"modal-footer\">\n      <a class=\"close-modal\">\n        {{#translate}}js.modules.support.return_to_help_wizard{{/translate}}\n      </a>\n    </div>\n  </div>\n</div>\n", Hogan);
},{"hogan.js":248}],29:[function(require,module,exports){
var Hogan = require('hogan.js');
module.exports = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<div class=\"icon-g-loader g-spinner\"></div>");t.b("\n");return t.fl(); },partials: {}, subs: {  }}, "<div class=\"icon-g-loader g-spinner\"></div>\n", Hogan);
},{"hogan.js":248}],30:[function(require,module,exports){
var Hogan = require('hogan.js');
module.exports = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<div class=\"callUsPopupData call-us-msg-footer p15\">");t.b("\n" + i);t.b("  <div class=\"ticket-number\">");t.b("\n" + i);t.b("    <span data-bhw=\"call-us__");t.b(t.v(t.f("id",c,p,0)));t.b("__");t.b(t.v(t.f("dealId",c,p,0)));t.b("__");t.b(t.v(t.f("channel",c,p,0)));t.b("__");t.b(t.v(t.f("country",c,p,0)));t.b("\">");if(t.s(t.f("translate",c,p,1),c,p,0,172,199,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.shared.ticket_no");});c.pop();}t.b("</span> <span id=\"ticket-no\">");t.b(t.v(t.f("ticket_number",c,p,0)));t.b("</span>");t.b("\n" + i);t.b("  </div>");t.b("\n" + i);t.b("  <div class=\"call-us-faster-msg\">");t.b("\n" + i);t.b("    ");if(t.s(t.f("translate",c,p,1),c,p,0,329,373,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.shared.call_us_msg_save_ticket_no");});c.pop();}t.b("\n" + i);t.b("  </div>");t.b("\n" + i);t.b("</div>");return t.fl(); },partials: {}, subs: {  }}, "<div class=\"callUsPopupData call-us-msg-footer p15\">\n  <div class=\"ticket-number\">\n    <span data-bhw=\"call-us__{{id}}__{{dealId}}__{{channel}}__{{country}}\">{{#translate}}js.modules.shared.ticket_no{{/translate}}</span> <span id=\"ticket-no\">{{ticket_number}}</span>\n  </div>\n  <div class=\"call-us-faster-msg\">\n    {{#translate}}js.modules.shared.call_us_msg_save_ticket_no{{/translate}}\n  </div>\n</div>", Hogan);
},{"hogan.js":248}],31:[function(require,module,exports){
var Hogan = require('hogan.js');
module.exports = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<div class=\"ajaxshim\" style=\"position: fixed; top: 0px; right: 0px; bottom: 0px; left: 0px; opacity: 0.0; z-index: 9999;\"\"></div>");return t.fl(); },partials: {}, subs: {  }}, "<div class=\"ajaxshim\" style=\"position: fixed; top: 0px; right: 0px; bottom: 0px; left: 0px; opacity: 0.0; z-index: 9999;\"\"></div>", Hogan);
},{"hogan.js":248}],32:[function(require,module,exports){
var Hogan = require('hogan.js');
module.exports = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<div id=\"popupContent\" class=\"modal show-modal\">");t.b("\n" + i);t.b("	<div class=\"modal-body\">");t.b("\n" + i);t.b("		<a href=\"javascript:;\" data-modal-id=\"popupContent\" class=\"close-modal icon-x\"></a>");t.b("\n" + i);t.b("		<h3 class=\"modal-title\">");if(t.s(t.f("translate",c,p,1),c,p,0,201,226,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.selord");});c.pop();}t.b("</h3>");t.b("\n" + i);t.b("		<div class=\"row\">");t.b("\n" + i);t.b("			<div class=\"twelve columns\">");t.b("\n" + i);t.b("				<div class=\"orderPopupData orderPopupControl\">");t.b("\n" + i);t.b("					<div class=\"itemsPopupData\"></div>");t.b("\n" + i);t.b("				</div>");t.b("\n" + i);t.b("			</div>");t.b("\n" + i);t.b("		</div>");t.b("\n" + i);t.b("	</div>");t.b("\n" + i);t.b("</div>");return t.fl(); },partials: {}, subs: {  }}, "<div id=\"popupContent\" class=\"modal show-modal\">\n\t<div class=\"modal-body\">\n\t\t<a href=\"javascript:;\" data-modal-id=\"popupContent\" class=\"close-modal icon-x\"></a>\n\t\t<h3 class=\"modal-title\">{{#translate}}js.modules.support.selord{{/translate}}</h3>\n\t\t<div class=\"row\">\n\t\t\t<div class=\"twelve columns\">\n\t\t\t\t<div class=\"orderPopupData orderPopupControl\">\n\t\t\t\t\t<div class=\"itemsPopupData\"></div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>", Hogan);
},{"hogan.js":248}],33:[function(require,module,exports){
var Hogan = require('hogan.js');
module.exports = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");if(t.s(t.f("email_input_template",c,p,1),c,p,0,25,654,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("  <strong><div class='call-me-back-option-labels call-back-email'>");t.b(t.v(t.f("label",c,p,0)));t.b("</div></strong>");t.b("\n" + i);if(!t.s(t.f("isLoggedIn",c,p,1),c,p,1,0,0,"")){t.b("    <input class=\"inputField email_input call-back-inputs call-back-email-input\" size=\"40\" maxLength=");t.b(t.v(t.f("maxLength",c,p,0)));t.b(" type=\"text\" name=\"contactEmail\" placeholder=\"Required\" data-bhw='call-me-back-option-email' aria-label=");t.b(t.v(t.f("label",c,p,0)));t.b(">");t.b("\n" + i);t.b("    <span class=\"validateEmailInput invalid-input call-back-option-error initially-hidden\">");t.b("\n" + i);t.b("      ");if(t.s(t.f("translate",c,p,1),c,p,0,478,520,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.call_back_invalid_email");});c.pop();}t.b("\n" + i);t.b("    </span>");t.b("\n" + i);};if(t.s(t.f("isLoggedIn",c,p,1),c,p,0,582,638,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("    <p class=\"call-back-email-value\">");t.b(t.v(t.f("value",c,p,0)));t.b("</p>");t.b("\n" + i);});c.pop();}});c.pop();}t.b("\n" + i);if(t.s(t.f("user_name_input_template",c,p,1),c,p,0,710,1178,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("  <strong><div class='call-me-back-option-labels call-back-user-name'>");t.b(t.v(t.f("label",c,p,0)));t.b("</div></strong>");t.b("\n" + i);if(!t.s(t.f("isLoggedIn",c,p,1),c,p,1,0,0,"")){t.b("    <input class=\"inputField user_name_input call-back-inputs call-back-user-name-input\" size=\"40\" maxLength=");t.b(t.v(t.f("maxLength",c,p,0)));t.b(" type=\"text\" name=\"contactUserName\" data-bhw='call-me-back-option-user-name' placeholder=\"Required\" aria-label=");t.b(t.v(t.f("label",c,p,0)));t.b(">");t.b("\n" + i);};if(t.s(t.f("isLoggedIn",c,p,1),c,p,0,1104,1162,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("    <p class=\"call-back-user-name-value\">");t.b(t.v(t.f("value",c,p,0)));t.b("</p>");t.b("\n" + i);});c.pop();}});c.pop();}t.b("\n" + i);if(t.s(t.f("phone_input_template",c,p,1),c,p,0,1234,1773,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("  <strong><div class='call-me-back-option-labels call-back-phone-number-label'>");t.b(t.v(t.f("label",c,p,0)));t.b("</div></strong>");t.b("\n" + i);t.b("  <input class=\"inputField phone_number_input call-back-inputs call-back-phone-number-input\" maxLength=");t.b(t.v(t.f("maxLength",c,p,0)));t.b(" type=\"text\" name=\"contactPhone\" data-bhw='call-me-back-option-phone-number' placeholder=\"(XXX) XXX-XXXX\" aria-label=");t.b(t.v(t.f("label",c,p,0)));t.b("><br>");t.b("\n" + i);t.b("  <span class=\"validatePhoneNumberInput invalid-input initially-hidden call-back-option-error\"> ");if(t.s(t.f("translate",c,p,1),c,p,0,1697,1739,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.call_back_invalid_phone");});c.pop();}t.b("\n" + i);t.b("    <br>");t.b("\n" + i);t.b("  </span>");t.b("\n" + i);});c.pop();}return t.fl(); },partials: {}, subs: {  }}, "{{#email_input_template}}\n  <strong><div class='call-me-back-option-labels call-back-email'>{{label}}</div></strong>\n  {{^isLoggedIn}}  \n    <input class=\"inputField email_input call-back-inputs call-back-email-input\" size=\"40\" maxLength={{maxLength}} type=\"text\" name=\"contactEmail\" placeholder=\"Required\" data-bhw='call-me-back-option-email' aria-label={{label}}>\n    <span class=\"validateEmailInput invalid-input call-back-option-error initially-hidden\">\n      {{#translate}}js.modules.support.call_back_invalid_email{{/translate}}\n    </span>\n  {{/isLoggedIn}}\n  {{#isLoggedIn}}  \n    <p class=\"call-back-email-value\">{{value}}</p>\n  {{/isLoggedIn}}\n{{/email_input_template}}\n\n{{#user_name_input_template}}\n  <strong><div class='call-me-back-option-labels call-back-user-name'>{{label}}</div></strong>\n  {{^isLoggedIn}} \n    <input class=\"inputField user_name_input call-back-inputs call-back-user-name-input\" size=\"40\" maxLength={{maxLength}} type=\"text\" name=\"contactUserName\" data-bhw='call-me-back-option-user-name' placeholder=\"Required\" aria-label={{label}}>\n  {{/isLoggedIn}}\n  {{#isLoggedIn}}\n    <p class=\"call-back-user-name-value\">{{value}}</p>\n  {{/isLoggedIn}}\n{{/user_name_input_template}}\n\n{{#phone_input_template}}\n  <strong><div class='call-me-back-option-labels call-back-phone-number-label'>{{label}}</div></strong>\n  <input class=\"inputField phone_number_input call-back-inputs call-back-phone-number-input\" maxLength={{maxLength}} type=\"text\" name=\"contactPhone\" data-bhw='call-me-back-option-phone-number' placeholder=\"(XXX) XXX-XXXX\" aria-label={{label}}><br>\n  <span class=\"validatePhoneNumberInput invalid-input initially-hidden call-back-option-error\"> {{#translate}}js.modules.support.call_back_invalid_phone{{/translate}}\n    <br>\n  </span>\n{{/phone_input_template}}", Hogan);
},{"hogan.js":248}],34:[function(require,module,exports){
var Hogan = require('hogan.js');
module.exports = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<div class=\"dd-field row\">");t.b("\n" + i);if(!t.s(t.f("showVerticalPageFlow",c,p,1),c,p,1,0,0,"")){t.b("      <div data-bhw=\"isFilterDropdowns:");t.b(t.v(t.f("isFilterDropdowns",c,p,0)));t.b("\" class=\"three columns small-grid-four ineedhelpClass\">");if(t.s(t.f("translate",c,p,1),c,p,0,186,214,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.ineedhelp");});c.pop();}t.b("</div>");t.b("\n" + i);};if(t.s(t.f("showVerticalPageFlow",c,p,1),c,p,0,294,479,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("      <div data-bhw=\"isFilterDropdowns:");t.b(t.v(t.f("isFilterDropdowns",c,p,0)));t.b("\" class=\"three columns small-grid-four ineedhelpClass\">");if(t.s(t.f("translate",c,p,1),c,p,0,424,454,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.i_need_help");});c.pop();}t.b("</div>");t.b("\n" + i);});c.pop();}t.b("    <div class=\"nine columns small-grid-four\">");t.b("\n");t.b("\n" + i);t.b("        <select class=\"category eight columns\">");t.b("\n" + i);t.b("            <option value=\"\" selected>");if(t.s(t.f("translate",c,p,1),c,p,0,653,686,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.categoryselect");});c.pop();}t.b("</option>");t.b("\n" + i);if(t.s(t.f("categories",c,p,1),c,p,0,737,844,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("                <option data-bhw='category_dropdown__");t.b(t.v(t.f("id",c,p,0)));t.b("' value=\"");t.b(t.v(t.f("id",c,p,0)));t.b("\">");t.b(t.v(t.f("text",c,p,0)));t.b("</option>");t.b("\n" + i);});c.pop();}t.b("        </select>");t.b("\n" + i);t.b("    </div>");t.b("\n" + i);t.b("</div>");t.b("\n" + i);t.b("<div class=\"dd-field row\">");t.b("\n" + i);t.b("    <div class=\"three columns small-grid-four ineedhelpClass\">&nbsp;</div>");t.b("\n" + i);t.b("    <div class=\"nine columns small-grid-four sub-dropdown\"></div>");t.b("\n" + i);t.b("</div>");t.b("\n" + i);if(!t.s(t.f("showVerticalPageFlow",c,p,1),c,p,1,0,0,"")){t.b("    <div class=\"row\">");t.b("\n" + i);t.b("        <div class=\"twelve columns\">");t.b("\n" + i);t.b("            <div class=\"inbenta-content\">");t.b("\n" + i);t.b("            </div>");t.b("\n" + i);t.b("        </div>");t.b("\n" + i);t.b("    </div>");t.b("\n" + i);};if(t.s(t.f("showVerticalPageFlow",c,p,1),c,p,0,1294,1599,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("<div class=\"inbenta-content\">");t.b("\n" + i);t.b("</div>");t.b("\n" + i);t.b("<div class=\"row content-section\" style=\"display: none;\">");t.b("\n" + i);t.b("    <div class=\"twelve columns \">");t.b("\n" + i);t.b("        <div class=\"content-header\" >");if(t.s(t.f("translate",c,p,1),c,p,0,1474,1511,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.suggested_solution");});c.pop();}t.b("</div>");t.b("\n" + i);t.b("        <div class=\"cms-content\">");t.b("\n" + i);t.b("        </div>");t.b("\n" + i);t.b("    </div>");t.b("\n" + i);t.b("</div>");t.b("\n" + i);});c.pop();}return t.fl(); },partials: {}, subs: {  }}, "<div class=\"dd-field row\">\n    {{^showVerticalPageFlow}}\n      <div data-bhw=\"isFilterDropdowns:{{isFilterDropdowns}}\" class=\"three columns small-grid-four ineedhelpClass\">{{#translate}}js.modules.support.ineedhelp{{/translate}}</div>\n    {{/showVerticalPageFlow}}\n    {{#showVerticalPageFlow}}\n      <div data-bhw=\"isFilterDropdowns:{{isFilterDropdowns}}\" class=\"three columns small-grid-four ineedhelpClass\">{{#translate}}js.modules.support.i_need_help{{/translate}}</div>\n    {{/showVerticalPageFlow}}\n    <div class=\"nine columns small-grid-four\">\n\n        <select class=\"category eight columns\">\n            <option value=\"\" selected>{{#translate}}js.modules.support.categoryselect{{/translate}}</option>\n            {{#categories}}\n                <option data-bhw='category_dropdown__{{id}}' value=\"{{id}}\">{{text}}</option>\n            {{/categories}}\n        </select>\n    </div>\n</div>\n<div class=\"dd-field row\">\n    <div class=\"three columns small-grid-four ineedhelpClass\">&nbsp;</div>\n    <div class=\"nine columns small-grid-four sub-dropdown\"></div>\n</div>\n{{^showVerticalPageFlow}}\n    <div class=\"row\">\n        <div class=\"twelve columns\">\n            <div class=\"inbenta-content\">\n            </div>\n        </div>\n    </div>\n{{/showVerticalPageFlow}}\n{{#showVerticalPageFlow}}\n<div class=\"inbenta-content\">\n</div>\n<div class=\"row content-section\" style=\"display: none;\">\n    <div class=\"twelve columns \">\n        <div class=\"content-header\" >{{#translate}}js.modules.support.suggested_solution{{/translate}}</div>\n        <div class=\"cms-content\">\n        </div>\n    </div>\n</div>\n{{/showVerticalPageFlow}}", Hogan);
},{"hogan.js":248}],35:[function(require,module,exports){
var Hogan = require('hogan.js');
module.exports = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");if(t.s(t.f("isChatClicked",c,p,1),c,p,0,18,776,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("  <div class=\"help-wizard-content\">");t.b("\n" + i);t.b("    <div class=\"row\">");t.b("\n" + i);t.b("      <span class=\"chat-icon-container\"></span>");t.b("\n" + i);t.b("      <span class=\"article-title\">");t.b("\n" + i);t.b("        ");if(t.s(t.f("translate",c,p,1),c,p,0,182,220,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.v2.live_chat_header");});c.pop();}t.b("\n" + i);t.b("      </span>");t.b("\n" + i);t.b("    </div>");t.b("\n" + i);t.b("    <div class=\"chat-action-row\">");t.b("\n" + i);t.b("      <span> ");t.b("\n" + i);t.b("        ");if(t.s(t.f("translate",c,p,1),c,p,0,330,364,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.v2.chat_resolve");});c.pop();}t.b("\n" + i);t.b("      </span>");t.b("\n" + i);t.b("      <button class=\"btn-invert action-btn\" id=\"ChatSuccess\" data-bhw=\"chat-success\">");t.b("\n" + i);t.b("      ");if(t.s(t.f("translate",c,p,1),c,p,0,499,527,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.v2_solved");});c.pop();}t.b("\n" + i);t.b("      </button> ");t.b("\n");t.b("\n" + i);t.b("      <button class=\"btn-invert action-btn\" id=\"otherContactChannel\" data-bhw=\"chat-other-channel\">");t.b("\n" + i);t.b("      ");if(t.s(t.f("translate",c,p,1),c,p,0,680,723,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.v2.need_to_contact_again");});c.pop();}t.b("\n" + i);t.b("      </button>  ");t.b("\n" + i);t.b("    </div>");t.b("\n" + i);t.b("  </div>");t.b("\n" + i);});c.pop();}t.b("\n" + i);if(t.s(t.f("isCallClicked",c,p,1),c,p,0,814,1141,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("  <div class=\"phone-number-container row\"></div>");t.b("\n" + i);t.b("  <div class=\"contact-channel-container row\">  </div>");t.b("\n" + i);t.b("  <div class=\"return-container row\">  ");t.b("\n" + i);t.b("  <button class=\"btn-invert other-contact-channel\" id=\"returnHome\" data-bhw=\"return-home-page\">");t.b("\n" + i);t.b("    ");if(t.s(t.f("translate",c,p,1),c,p,0,1071,1104,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.v2.return_home");});c.pop();}t.b("\n" + i);t.b("  </button> ");t.b("\n" + i);t.b("  </div>");t.b("\n" + i);});c.pop();}return t.fl(); },partials: {}, subs: {  }}, "{{#isChatClicked}}\n  <div class=\"help-wizard-content\">\n    <div class=\"row\">\n      <span class=\"chat-icon-container\"></span>\n      <span class=\"article-title\">\n        {{#translate}}js.modules.support.v2.live_chat_header{{/translate}}\n      </span>\n    </div>\n    <div class=\"chat-action-row\">\n      <span> \n        {{#translate}}js.modules.support.v2.chat_resolve{{/translate}}\n      </span>\n      <button class=\"btn-invert action-btn\" id=\"ChatSuccess\" data-bhw=\"chat-success\">\n      {{#translate}}js.modules.support.v2_solved{{/translate}}\n      </button> \n\n      <button class=\"btn-invert action-btn\" id=\"otherContactChannel\" data-bhw=\"chat-other-channel\">\n      {{#translate}}js.modules.support.v2.need_to_contact_again{{/translate}}\n      </button>  \n    </div>\n  </div>\n{{/isChatClicked}}\n\n{{#isCallClicked}}\n  <div class=\"phone-number-container row\"></div>\n  <div class=\"contact-channel-container row\">  </div>\n  <div class=\"return-container row\">  \n  <button class=\"btn-invert other-contact-channel\" id=\"returnHome\" data-bhw=\"return-home-page\">\n    {{#translate}}js.modules.support.v2.return_home{{/translate}}\n  </button> \n  </div>\n{{/isCallClicked}}\n", Hogan);
},{"hogan.js":248}],36:[function(require,module,exports){
var Hogan = require('hogan.js');
module.exports = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");if(!t.s(t.f("isV2",c,p,1),c,p,1,0,0,"")){t.b("  <div class=\"deal-image\">");t.b("\n" + i);if(t.s(t.f("v1Image",c,p,1),c,p,0,55,156,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("    <img class=\"v1-image\" data-bhw=\"");t.b(t.v(t.f("dealId",c,p,0)));t.b("-deal-image\" src=\"");t.b(t.v(t.f("v1Image",c,p,0)));t.b("\" width=\"120\"></img>");t.b("\n" + i);});c.pop();}if(t.s(t.f("imageUrl",c,p,1),c,p,0,186,299,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("    <img class=\"reservation-image\" data-bhw=\"");t.b(t.v(t.f("merchant",c,p,0)));t.b("-deal-image\" src=\"");t.b(t.v(t.f("imageUrl",c,p,0)));t.b("\" width=\"120\"></img>");t.b("\n" + i);});c.pop();}t.b("  </div>");t.b("\n");t.b("\n" + i);t.b("  <div class=\"deal-info\">");t.b("\n" + i);t.b("    <p>");t.b("\n" + i);t.b("      <strong>");t.b("\n" + i);t.b("          ");t.b(t.v(t.f("merchant",c,p,0)));t.b("\n" + i);t.b("        <br />");t.b("\n" + i);t.b("      </strong>");t.b("\n" + i);t.b("      <div style=\"line-height: 1.5em;\">");t.b("\n");t.b("\n" + i);t.b("        ");t.b(t.v(t.f("title",c,p,0)));t.b("\n");t.b("\n" + i);t.b("        </div>");t.b("\n" + i);t.b("      ");t.b("\n" + i);if(t.s(t.f("finePrint",c,p,1),c,p,0,530,671,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("        <a class=\"view_fine_print anchorHover mt10\" data-bhw=\"fine-print\">");if(t.s(t.f("translate",c,p,1),c,p,0,619,644,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.viewfp");});c.pop();}t.b("</a>");t.b("\n" + i);});c.pop();}t.b("    </p>");t.b("\n" + i);t.b("  </div>");t.b("\n" + i);};t.b("\n" + i);if(t.s(t.f("isV2",c,p,1),c,p,0,728,1801,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("  <div class=\"deal-image\">");t.b("\n" + i);t.b("    <div>");t.b("\n" + i);if(t.s(t.f("v1Image",c,p,1),c,p,0,784,889,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("      <img class=\"v1-image\" data-bhw=\"");t.b(t.v(t.f("dealId",c,p,0)));t.b("-deal-image\" src=\"");t.b(t.v(t.f("v1Image",c,p,0)));t.b("\" width=\"120\"></img>");t.b("\n" + i);});c.pop();}if(t.s(t.f("imageUrl",c,p,1),c,p,0,921,1038,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("      <img class=\"reservation-image\" data-bhw=\"");t.b(t.v(t.f("merchant",c,p,0)));t.b("-deal-image\" src=\"");t.b(t.v(t.f("imageUrl",c,p,0)));t.b("\" width=\"120\"></img>");t.b("\n" + i);});c.pop();}t.b("    </div>");t.b("\n" + i);t.b("  </div>");t.b("\n");t.b("\n" + i);t.b("  <div class=\"deal-info\">");t.b("\n" + i);t.b("    <ul data-bhw=\"order__");t.b(t.v(t.f("id",c,p,0)));t.b("__");t.b(t.v(t.f("dealId",c,p,0)));t.b("__");t.b(t.v(t.f("channel",c,p,0)));t.b("__");t.b(t.v(t.f("country",c,p,0)));t.b("__");t.b(t.v(t.f("status",c,p,0)));t.b("\" class=\"order-summary-list unstyled\">");t.b("\n" + i);t.b("        <li>");t.b("\n" + i);t.b("          <strong>");t.b("\n" + i);t.b("              ");t.b(t.v(t.f("merchant",c,p,0)));t.b("\n" + i);t.b("            <br />");t.b("\n" + i);t.b("          </strong>");t.b("\n" + i);t.b("        </li>  ");t.b("\n" + i);t.b("        <li class=\"title\">");t.b("\n" + i);t.b("          ");t.b(t.v(t.f("title",c,p,0)));t.b("\n" + i);t.b("        </li>");t.b("\n" + i);t.b("        <li>");t.b("\n" + i);t.b("          <span  class=\"orderSummaryStrong\"><strong>");if(t.s(t.f("translate",c,p,1),c,p,0,1473,1495,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.pur");});c.pop();}t.b("</strong></span>");t.b("\n" + i);t.b("          <span class='localtime'>");t.b(t.v(t.f("purchasedAt",c,p,0)));t.b("</span>");t.b("\n" + i);t.b("        </li>");t.b("\n" + i);t.b("        <li>");t.b("\n" + i);t.b("          <span class=\"orderSummaryStrong\" ><strong >");if(t.s(t.f("translate",c,p,1),c,p,0,1677,1699,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.qty");});c.pop();}t.b(" </strong></span>");t.b("\n" + i);t.b("          <span>");t.b(t.v(t.f("qty",c,p,0)));t.b("</span>");t.b("\n" + i);t.b("        </li>");t.b("\n" + i);t.b("    </ul>     ");t.b("\n" + i);t.b("  </div>");t.b("\n");t.b("\n" + i);});c.pop();}return t.fl(); },partials: {}, subs: {  }}, "{{^isV2}}  \n  <div class=\"deal-image\">\n    {{#v1Image}}\n    <img class=\"v1-image\" data-bhw=\"{{dealId}}-deal-image\" src=\"{{v1Image}}\" width=\"120\"></img>\n    {{/v1Image}}\n    {{#imageUrl}}\n    <img class=\"reservation-image\" data-bhw=\"{{merchant}}-deal-image\" src=\"{{imageUrl}}\" width=\"120\"></img>\n    {{/imageUrl}}\n  </div>\n\n  <div class=\"deal-info\">\n    <p>\n      <strong>\n          {{merchant}}\n        <br />\n      </strong>\n      <div style=\"line-height: 1.5em;\">\n\n        {{title}}\n\n        </div>\n      \n        {{#finePrint}}\n        <a class=\"view_fine_print anchorHover mt10\" data-bhw=\"fine-print\">{{#translate}}js.modules.support.viewfp{{/translate}}</a>\n        {{/finePrint}}   \n    </p>\n  </div>\n{{/isV2}} \n\n{{#isV2}}\n  <div class=\"deal-image\">\n    <div>\n      {{#v1Image}}\n      <img class=\"v1-image\" data-bhw=\"{{dealId}}-deal-image\" src=\"{{v1Image}}\" width=\"120\"></img>\n      {{/v1Image}}\n      {{#imageUrl}}\n      <img class=\"reservation-image\" data-bhw=\"{{merchant}}-deal-image\" src=\"{{imageUrl}}\" width=\"120\"></img>\n      {{/imageUrl}}\n    </div>\n  </div>\n\n  <div class=\"deal-info\">\n    <ul data-bhw=\"order__{{id}}__{{dealId}}__{{channel}}__{{country}}__{{status}}\" class=\"order-summary-list unstyled\">\n        <li>\n          <strong>\n              {{merchant}}\n            <br />\n          </strong>\n        </li>  \n        <li class=\"title\">\n          {{title}}\n        </li>\n        <li>\n          <span  class=\"orderSummaryStrong\"><strong>{{#translate}}js.modules.support.pur{{/translate}}</strong></span>\n          <span class='localtime'>{{purchasedAt}}</span>\n        </li>\n        <li>\n          <span class=\"orderSummaryStrong\" ><strong >{{#translate}}js.modules.support.qty{{/translate}} </strong></span>\n          <span>{{qty}}</span>\n        </li>\n    </ul>     \n  </div>\n\n{{/isV2}} ", Hogan);
},{"hogan.js":248}],37:[function(require,module,exports){
var Hogan = require('hogan.js');
module.exports = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<div class=\"row\">");t.b("\n" + i);t.b("  <label for=\"\">");t.b("\n" + i);t.b("    <strong id='ticket_description'>");t.b("\n" + i);t.b("      ");if(t.s(t.f("translate",c,p,1),c,p,0,92,118,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.whatson");});c.pop();}t.b("\n" + i);t.b("      <span style=\"color:red\">*</span>");t.b("\n" + i);t.b("    </strong>");t.b("\n" + i);t.b("  </label>");t.b("\n" + i);t.b("  <textarea class=\"description support_textbox p10\" style=\"font-size: 14px;\" name=\"description\" cols=\"80\" rows=\"10\" placeholder=\"");t.b(t.v(t.f("placeholderText",c,p,0)));t.b("\"></textarea>");t.b("\n" + i);t.b("</div>");t.b("\n" + i);t.b("<div class=\"row credit_card_warning invalid-input error initially-hidden\">");t.b("\n" + i);t.b("  ");if(t.s(t.f("translate",c,p,1),c,p,0,457,495,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.invalid_description");});c.pop();}t.b("\n" + i);t.b("  <span style=\"color:red\">*</span>");t.b("\n" + i);t.b("</div>");return t.fl(); },partials: {}, subs: {  }}, "<div class=\"row\">\n  <label for=\"\">\n    <strong id='ticket_description'>\n      {{#translate}}js.modules.support.whatson{{/translate}}\n      <span style=\"color:red\">*</span>\n    </strong>\n  </label>\n  <textarea class=\"description support_textbox p10\" style=\"font-size: 14px;\" name=\"description\" cols=\"80\" rows=\"10\" placeholder=\"{{placeholderText}}\"></textarea>\n</div>\n<div class=\"row credit_card_warning invalid-input error initially-hidden\">\n  {{#translate}}js.modules.support.invalid_description{{/translate}}\n  <span style=\"color:red\">*</span>\n</div>", Hogan);
},{"hogan.js":248}],38:[function(require,module,exports){
var Hogan = require('hogan.js');
module.exports = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");if(t.s(t.f("isExternalDealNotesPresent",c,p,1),c,p,0,31,636,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("<div class=\"twelve columns\">");t.b("\n" + i);t.b("  <div class='externalNoteDisplay'>");t.b("\n" + i);t.b("    <span class='businessNameClass'>");if(t.s(t.f("translate",c,p,1),c,p,0,147,180,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.import_message");});c.pop();}t.b(" ");t.b(t.v(t.f("businessName",c,p,0)));t.b("</span>");t.b("\n" + i);if(t.s(t.f("externalDealNotes",c,p,1),c,p,0,245,597,"{{ }}")){t.rs(c,p,function(c,p,t){if(t.s(t.f("firstNotes",c,p,1),c,p,0,265,407,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("  <span class='externalDealNotesIdfirst' data-bhw='Ext_deal_note__");t.b(t.v(t.f("orderId",c,p,0)));t.b("__");t.b(t.v(t.f("dealId",c,p,0)));t.b("__");t.b(t.v(t.f("channelCode",c,p,0)));t.b("__");t.b(t.v(t.f("country",c,p,0)));t.b("'>");t.b(t.t(t.f("note",c,p,0)));t.b("</span>");t.b("\n" + i);});c.pop();}if(!t.s(t.f("firstNotes",c,p,1),c,p,1,0,0,"")){t.b("  <span class='externalDealNotesId' data-bhw='Ext_deal_note__");t.b(t.v(t.f("orderId",c,p,0)));t.b("__");t.b(t.v(t.f("dealId",c,p,0)));t.b("__");t.b(t.v(t.f("channelCode",c,p,0)));t.b("__");t.b(t.v(t.f("country",c,p,0)));t.b("'>");t.b(t.t(t.f("note",c,p,0)));t.b("</span>");t.b("\n" + i);};});c.pop();}t.b("  </div>");t.b("\n" + i);t.b("</div>");t.b("\n" + i);});c.pop();}t.b("\n");return t.fl(); },partials: {}, subs: {  }}, "{{#isExternalDealNotesPresent}}\n<div class=\"twelve columns\">\n  <div class='externalNoteDisplay'>\n    <span class='businessNameClass'>{{#translate}}js.modules.support.import_message{{/translate}} {{businessName}}</span>\n    {{#externalDealNotes}}\n    {{#firstNotes}}\n  <span class='externalDealNotesIdfirst' data-bhw='Ext_deal_note__{{orderId}}__{{dealId}}__{{channelCode}}__{{country}}'>{{{note}}}</span>\n  {{/firstNotes}}\n  {{^firstNotes}}\n  <span class='externalDealNotesId' data-bhw='Ext_deal_note__{{orderId}}__{{dealId}}__{{channelCode}}__{{country}}'>{{{note}}}</span>\n  {{/firstNotes}}\n    {{/externalDealNotes}}\n  </div>\n</div>\n{{/isExternalDealNotesPresent}}\n\n", Hogan);
},{"hogan.js":248}],39:[function(require,module,exports){
var Hogan = require('hogan.js');
module.exports = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<div id=\"popupContent\" class=\"modal show-modal\">");t.b("\n" + i);t.b("  <div class=\"modal-body\">");t.b("\n" + i);t.b("    <a href=\"javascript:;\" data-modal-id=\"popupContent\" class=\"close-modal icon-x\"></a>");t.b("\n" + i);t.b("    <h3 class=\"modal-title\">");if(t.s(t.f("translate",c,p,1),c,p,0,206,227,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.fp");});c.pop();}t.b("</h3>");t.b("\n");t.b("\n" + i);t.b("    <div class=\"row\">");t.b("\n" + i);t.b("      <div class=\"twelve columns orderPopupData border-bottom p20\">");t.b("\n" + i);t.b("        <p>");t.b(t.t(t.f("fine_print",c,p,0)));t.b("</p>");t.b("\n" + i);t.b("      </div>");t.b("\n" + i);t.b("    </div>");t.b("\n");t.b("\n" + i);t.b("  </div>");t.b("\n" + i);t.b("</div>");return t.fl(); },partials: {}, subs: {  }}, "<div id=\"popupContent\" class=\"modal show-modal\">\n  <div class=\"modal-body\">\n    <a href=\"javascript:;\" data-modal-id=\"popupContent\" class=\"close-modal icon-x\"></a>\n    <h3 class=\"modal-title\">{{#translate}}js.modules.support.fp{{/translate}}</h3>\n\n    <div class=\"row\">\n      <div class=\"twelve columns orderPopupData border-bottom p20\">\n        <p>{{{fine_print}}}</p>\n      </div>\n    </div>\n\n  </div>\n</div>", Hogan);
},{"hogan.js":248}],40:[function(require,module,exports){
var Hogan = require('hogan.js');
module.exports = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<div class=\"content\">");t.b(t.v(t.f("content",c,p,0)));t.b("</div><div class=\"close\">x</div>");return t.fl(); },partials: {}, subs: {  }}, "<div class=\"content\">{{content}}</div><div class=\"close\">x</div>", Hogan);
},{"hogan.js":248}],41:[function(require,module,exports){
var Hogan = require('hogan.js');
module.exports = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<div class=\"contact-us-phone-channel\">");t.b("\n" + i);t.b("  <span>");t.b("\n" + i);t.b("    ");t.b(t.v(t.f("call_us_message",c,p,0)));t.b("\n" + i);t.b("  </span>");t.b("\n" + i);t.b("</div>");t.b("\n" + i);t.b("<div class=\"live-chat-container phone-view normal-live-chat-container\" id=\"live-chat-container\"></div>");return t.fl(); },partials: {}, subs: {  }}, "<div class=\"contact-us-phone-channel\">\n  <span>\n    {{call_us_message}}\n  </span>\n</div>\n<div class=\"live-chat-container phone-view normal-live-chat-container\" id=\"live-chat-container\"></div>", Hogan);
},{"hogan.js":248}],42:[function(require,module,exports){
var Hogan = require('hogan.js');
module.exports = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");if(t.s(t.f("renderLayout",c,p,1),c,p,0,17,154,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("  <div class=\"help-wizard-content\">");t.b("\n" + i);t.b("    <div class=\"steps-container\"> </div>");t.b("\n" + i);t.b("    <div class=\"flex-contact-channels-without-chat\"></div>");t.b("\n" + i);});c.pop();}t.b("\n" + i);t.b("  <div class=\"flexible-contact-channels-container\">");t.b("\n" + i);if(t.s(t.f("contact_channels",c,p,1),c,p,0,250,2931,"{{ }}")){t.rs(c,p,function(c,p,t){if(t.s(t.f("primary",c,p,1),c,p,0,269,1495,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("        <div class=\"flex-primary-optional-text\">");if(t.s(t.f("translate",c,p,1),c,p,0,332,379,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.primary_contact_channel_text");});c.pop();}t.b("</div>");t.b("\n" + i);if(t.s(t.f("is_chat",c,p,1),c,p,0,420,1011,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("          <div class=\"flex-primary-chat-button\" data-bhw=\"flex-primary-chat-button\" id=\"live-chat-container\"></div>");t.b("\n" + i);t.b("          <div class=\"flex-primary-channel-text\">");t.b("\n" + i);t.b("            <span class=\"flex-primary-below-text\">");if(t.s(t.f("translate",c,p,1),c,p,0,651,685,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.best_assist_you");});c.pop();}t.b("</span>");t.b("\n" + i);t.b("            <span>");t.b("\n" + i);t.b("              <span class=\"primary-");t.b(t.v(t.f("channel",c,p,0)));t.b("-link\" data-bhw=\"flex-primary-chat-link\" id=\"live-chat-link-container\"></span>");t.b("\n" + i);t.b("            </span>");t.b("\n" + i);t.b("            <span class=\"flex-chat-team\">");if(t.s(t.f("translate",c,p,1),c,p,0,926,958,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.with_our_team");});c.pop();}t.b(" </span><br/>");t.b("\n" + i);t.b("          </div>");t.b("\n" + i);});c.pop();}t.b("\n" + i);if(!t.s(t.f("is_chat",c,p,1),c,p,1,0,0,"")){t.b("          <input class=\"btn-cta flex-primary-");t.b(t.v(t.f("channel",c,p,0)));t.b("-button flex-primary-button\" type=\"button\" value=\"");t.b(t.v(t.f("button_text",c,p,0)));t.b("\" data-bhw=\"flex-primary-");t.b(t.v(t.f("channel",c,p,0)));t.b("-button\">");t.b("\n" + i);t.b("          <span class=\"flex-primary-below-text\">");if(t.s(t.f("translate",c,p,1),c,p,0,1275,1309,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.best_assist_you");});c.pop();}t.b("</span>");t.b("\n" + i);t.b("          <a class=\"primary-");t.b(t.v(t.f("channel",c,p,0)));t.b("-link flex-");t.b(t.v(t.f("channel",c,p,0)));t.b("-link\" data-bhw=\"flex-primary-");t.b(t.v(t.f("channel",c,p,0)));t.b("-link\"> ");t.b(t.v(t.f("channel_text",c,p,0)));t.b(" </a><br/>");t.b("\n" + i);};});c.pop();}t.b("\n" + i);if(t.s(t.f("secondary",c,p,1),c,p,0,1529,2215,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("        <span class=\"flex-secondary-channel-also-text\">");if(t.s(t.f("translate",c,p,1),c,p,0,1599,1630,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.you_can_also");});c.pop();}t.b("</span>");t.b("\n" + i);if(t.s(t.f("is_chat",c,p,1),c,p,0,1672,2012,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("          <span class=\"secondary-flex-");t.b(t.v(t.f("channel",c,p,0)));t.b("-channel secondary-flex-channel\">");t.b("\n" + i);t.b("            <span class=\"secondary-chat-link\" id=\"live-chat-link-container\" data-bhw=\"flex-secondary-chat-link\"></span>");t.b("\n" + i);t.b("            <span class=\"flex-chat-team\">");if(t.s(t.f("translate",c,p,1),c,p,0,1931,1963,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.with_our_team");});c.pop();}t.b(" </span>");t.b("\n" + i);t.b("          </span>");t.b("\n" + i);});c.pop();}if(!t.s(t.f("is_chat",c,p,1),c,p,1,0,0,"")){t.b("          <a class=\"secondary-flex-");t.b(t.v(t.f("channel",c,p,0)));t.b("-channel flex-");t.b(t.v(t.f("channel",c,p,0)));t.b("-link\" data-bhw=\"flex-secondary-");t.b(t.v(t.f("channel",c,p,0)));t.b("-link\">");t.b(t.v(t.f("channel_text",c,p,0)));t.b("</a>");t.b("\n" + i);};});c.pop();}t.b("\n" + i);if(t.s(t.f("tertiary",c,p,1),c,p,0,2250,2913,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("        <span class=\"flex-channel-or-text tertiary-flex-channel\">");if(t.s(t.f("translate",c,p,1),c,p,0,2330,2351,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.or");});c.pop();}t.b("</span>");t.b("\n" + i);if(t.s(t.f("is_chat",c,p,1),c,p,0,2393,2712,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("          <span class=\"tertiary-flex-");t.b(t.v(t.f("channel",c,p,0)));t.b("-channel\">");t.b("\n" + i);t.b("            <span class=\"tertiary-chat-link\" id=\"live-chat-link-container\" data-bhw=\"flex-tertiary-chat-link\"></span>");t.b("\n" + i);t.b("            <span class=\"flex-chat-team\">");if(t.s(t.f("translate",c,p,1),c,p,0,2626,2658,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.with_our_team");});c.pop();}t.b(" </span><br/>");t.b("\n" + i);t.b("          </span>");t.b("\n" + i);});c.pop();}if(!t.s(t.f("is_chat",c,p,1),c,p,1,0,0,"")){t.b("          <a class=\"tertiary-flex-");t.b(t.v(t.f("channel",c,p,0)));t.b("-channel flex-");t.b(t.v(t.f("channel",c,p,0)));t.b("-link\" data-bhw=\"flex-tertiary-");t.b(t.v(t.f("channel",c,p,0)));t.b("-link\">");t.b(t.v(t.f("channel_text",c,p,0)));t.b("</a>");t.b("\n" + i);};});c.pop();}});c.pop();}t.b("  </div>");t.b("\n");t.b("\n" + i);if(t.s(t.f("renderLayout",c,p,1),c,p,0,2980,2990,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("  </div>");t.b("\n" + i);});c.pop();}t.b("\n");return t.fl(); },partials: {}, subs: {  }}, "{{#renderLayout}}\n  <div class=\"help-wizard-content\">\n    <div class=\"steps-container\"> </div>\n    <div class=\"flex-contact-channels-without-chat\"></div>\n{{/renderLayout}}\n\n  <div class=\"flexible-contact-channels-container\">\n    {{#contact_channels}}\n      {{#primary}}\n        <div class=\"flex-primary-optional-text\">{{#translate}}js.modules.support.primary_contact_channel_text{{/translate}}</div>\n        {{#is_chat}}\n          <div class=\"flex-primary-chat-button\" data-bhw=\"flex-primary-chat-button\" id=\"live-chat-container\"></div>\n          <div class=\"flex-primary-channel-text\">\n            <span class=\"flex-primary-below-text\">{{#translate}}js.modules.support.best_assist_you{{/translate}}</span>\n            <span>\n              <span class=\"primary-{{channel}}-link\" data-bhw=\"flex-primary-chat-link\" id=\"live-chat-link-container\"></span>\n            </span>\n            <span class=\"flex-chat-team\">{{#translate}}js.modules.support.with_our_team{{/translate}} </span><br/>\n          </div>\n        {{/is_chat}}\n\n        {{^is_chat}}\n          <input class=\"btn-cta flex-primary-{{channel}}-button flex-primary-button\" type=\"button\" value=\"{{button_text}}\" data-bhw=\"flex-primary-{{channel}}-button\">\n          <span class=\"flex-primary-below-text\">{{#translate}}js.modules.support.best_assist_you{{/translate}}</span>\n          <a class=\"primary-{{channel}}-link flex-{{channel}}-link\" data-bhw=\"flex-primary-{{channel}}-link\"> {{channel_text}} </a><br/>\n        {{/is_chat}}\n      {{/primary}}\n\n      {{#secondary}}\n        <span class=\"flex-secondary-channel-also-text\">{{#translate}}js.modules.support.you_can_also{{/translate}}</span>\n        {{#is_chat}}\n          <span class=\"secondary-flex-{{channel}}-channel secondary-flex-channel\">\n            <span class=\"secondary-chat-link\" id=\"live-chat-link-container\" data-bhw=\"flex-secondary-chat-link\"></span>\n            <span class=\"flex-chat-team\">{{#translate}}js.modules.support.with_our_team{{/translate}} </span>\n          </span>\n        {{/is_chat}}\n        {{^is_chat}}\n          <a class=\"secondary-flex-{{channel}}-channel flex-{{channel}}-link\" data-bhw=\"flex-secondary-{{channel}}-link\">{{channel_text}}</a>\n        {{/is_chat}}\n      {{/secondary}}\n\n      {{#tertiary}}\n        <span class=\"flex-channel-or-text tertiary-flex-channel\">{{#translate}}js.modules.support.or{{/translate}}</span>\n        {{#is_chat}}\n          <span class=\"tertiary-flex-{{channel}}-channel\">\n            <span class=\"tertiary-chat-link\" id=\"live-chat-link-container\" data-bhw=\"flex-tertiary-chat-link\"></span>\n            <span class=\"flex-chat-team\">{{#translate}}js.modules.support.with_our_team{{/translate}} </span><br/>\n          </span>\n        {{/is_chat}}\n        {{^is_chat}}\n          <a class=\"tertiary-flex-{{channel}}-channel flex-{{channel}}-link\" data-bhw=\"flex-tertiary-{{channel}}-link\">{{channel_text}}</a>\n        {{/is_chat}}\n      {{/tertiary}}\n    {{/contact_channels}}\n  </div>\n\n{{#renderLayout}}\n  </div>\n{{/renderLayout}}  \n\n", Hogan);
},{"hogan.js":248}],43:[function(require,module,exports){
var Hogan = require('hogan.js');
module.exports = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");if(t.s(t.f("checkbox_input_template",c,p,1),c,p,0,28,540,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("    <input type=\"checkbox\" class=\"checkbox_input\" data-bhw='");t.b(t.v(t.f("stepThreeType",c,p,0)));t.b("__checkbox_input_");t.b(t.v(t.f("counter",c,p,0)));t.b("' id='");t.b(t.v(t.f("stepThreeType",c,p,0)));t.b("__checkbox_input_");t.b(t.v(t.f("counter",c,p,0)));t.b("'>");t.b("\n" + i);t.b("    <label for='");t.b(t.v(t.f("stepThreeType",c,p,0)));t.b("__checkbox_input_");t.b(t.v(t.f("counter",c,p,0)));t.b("'>");if(t.s(t.f("required",c,p,1),c,p,0,264,305,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("<span class=\"mandatory-field\"> * </span> ");});c.pop();}t.b("\n" + i);t.b("    <span><strong>");t.b(t.v(t.f("label",c,p,0)));t.b("</strong></span></label>");t.b("\n" + i);t.b("    <span class=\"inputInvalidMsgID invalid-input initially-hidden error\" >");t.b("\n" + i);t.b("        ");if(t.s(t.f("translate",c,p,1),c,p,0,468,513,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.checkbox_invalid_input_msg");});c.pop();}t.b("\n" + i);t.b("    </span>");t.b("\n" + i);});c.pop();}t.b("\n" + i);if(t.s(t.f("date_input_template",c,p,1),c,p,0,594,899,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("    <label><span><strong>");t.b(t.v(t.f("label",c,p,0)));t.b("</strong></span>");t.b("\n" + i);t.b("    ");if(t.s(t.f("required",c,p,1),c,p,0,663,704,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("<span class=\"mandatory-field\"> * </span> ");});c.pop();}t.b("</label>");t.b("\n" + i);t.b("    <input class=\"inputField date_input\" size=\"20\" maxLength=\"15\" type=\"text\" readonly=\"readonly\" data-bhw='");t.b(t.v(t.f("stepThreeType",c,p,0)));t.b("__date_input_");t.b(t.v(t.f("counter",c,p,0)));t.b("' aria-label=");t.b(t.v(t.f("label",c,p,0)));t.b(">");t.b("\n" + i);});c.pop();}t.b("\n" + i);if(t.s(t.f("date_time_input_template",c,p,1),c,p,0,954,1923,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("    <label><strong>");t.b(t.v(t.f("label",c,p,0)));t.b("</strong>");t.b("\n" + i);t.b("    ");if(t.s(t.f("required",c,p,1),c,p,0,1010,1051,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("<span class=\"mandatory-field\"> * </span> ");});c.pop();}t.b("</label>");t.b("\n" + i);t.b("    <input class=\"inputField date_time_input\" size=\"20\" maxLength=\"15\" type=\"text\" readonly=\"readonly\" data-bhw='");t.b(t.v(t.f("stepThreeType",c,p,0)));t.b("__date_time_input_");t.b(t.v(t.f("counter",c,p,0)));t.b("' aria-label=");t.b(t.v(t.f("label",c,p,0)));t.b(">");t.b("\n" + i);t.b("    <span >");t.b("\n" + i);t.b("      <select class=\"time_slot\">");t.b("\n" + i);t.b("        <option value=");if(t.s(t.f("translate",c,p,1),c,p,0,1337,1363,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.morning");});c.pop();}t.b(">");if(t.s(t.f("translate",c,p,1),c,p,0,1392,1418,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.morning");});c.pop();}t.b("</option>");t.b("\n" + i);t.b("        <option value=");if(t.s(t.f("translate",c,p,1),c,p,0,1478,1512,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.early_afternoon");});c.pop();}t.b(">");if(t.s(t.f("translate",c,p,1),c,p,0,1541,1575,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.early_afternoon");});c.pop();}t.b("</option>");t.b("\n" + i);t.b("        <option value=");if(t.s(t.f("translate",c,p,1),c,p,0,1635,1668,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.late_afternoon");});c.pop();}t.b(">");if(t.s(t.f("translate",c,p,1),c,p,0,1697,1730,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.late_afternoon");});c.pop();}t.b("</option>");t.b("\n" + i);t.b("        <option value=");if(t.s(t.f("translate",c,p,1),c,p,0,1790,1816,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.evening");});c.pop();}t.b(">");if(t.s(t.f("translate",c,p,1),c,p,0,1845,1871,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.evening");});c.pop();}t.b("</option>");t.b("\n" + i);t.b("      </select>");t.b("\n" + i);t.b("    </span>");t.b("\n" + i);});c.pop();}t.b("\n" + i);if(t.s(t.f("dropdown_input_template",c,p,1),c,p,0,1982,2453,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("    <label><strong>");t.b(t.v(t.f("label",c,p,0)));t.b("</strong>");t.b("\n" + i);t.b("    ");if(t.s(t.f("required",c,p,1),c,p,0,2038,2079,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("<span class=\"mandatory-field\"> * </span> ");});c.pop();}t.b("</label>");t.b("\n" + i);t.b("    <div >");t.b("\n" + i);t.b("      <select class=\"dropdown_input\" data-bhw='");t.b(t.v(t.f("stepThreeType",c,p,0)));t.b("__dropdown_input_");t.b(t.v(t.f("counter",c,p,0)));t.b("' aria-label=");t.b(t.v(t.f("label",c,p,0)));t.b(">");t.b("\n" + i);t.b("        <option value=\"\" selected>");if(t.s(t.f("translate",c,p,1),c,p,0,2276,2309,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.categoryselect");});c.pop();}t.b("</option>");t.b("\n" + i);if(t.s(t.f("options",c,p,1),c,p,0,2353,2413,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("          <option value=\"");t.b(t.v(t.f("id",c,p,0)));t.b("\">");t.b(t.v(t.f("text",c,p,0)));t.b("</option>");t.b("\n" + i);});c.pop();}t.b("      </select>");t.b("\n" + i);t.b("    </div>");t.b("\n" + i);});c.pop();}t.b("\n" + i);if(t.s(t.f("email_input_template",c,p,1),c,p,0,2508,2965,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("    <label><strong>");t.b(t.v(t.f("label",c,p,0)));t.b("</strong>");t.b("\n" + i);t.b("    ");if(t.s(t.f("required",c,p,1),c,p,0,2564,2605,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("<span class=\"mandatory-field\"> * </span> ");});c.pop();}t.b("</label>");t.b("\n" + i);t.b("    <input class=\"inputField email_input\" size=\"40\" maxLength=");t.b(t.v(t.f("maxLength",c,p,0)));t.b(" type=\"text\" name=\"contactEmail\" data-bhw='");t.b(t.v(t.f("stepThreeType",c,p,0)));t.b("__email_input_");t.b(t.v(t.f("counter",c,p,0)));t.b("' aria-label=");t.b(t.v(t.f("label",c,p,0)));t.b(">");t.b("\n" + i);t.b("    <span class=\"validateEmailInput invalid-input error initially-hidden\">");t.b("\n" + i);t.b("       ");if(t.s(t.f("translate",c,p,1),c,p,0,2907,2938,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.invalidemail");});c.pop();}t.b("\n" + i);t.b("    </span>");t.b("\n" + i);});c.pop();}t.b("\n" + i);if(t.s(t.f("user_name_input_template",c,p,1),c,p,0,3021,3335,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("    <label><strong>");t.b(t.v(t.f("label",c,p,0)));t.b("</strong>");t.b("\n" + i);t.b("    ");if(t.s(t.f("required",c,p,1),c,p,0,3077,3118,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("<span class=\"mandatory-field\"> * </span> ");});c.pop();}t.b("</label>");t.b("\n" + i);t.b("    <input class=\"inputField user_name_input\" size=\"40\" maxLength=");t.b(t.v(t.f("maxLength",c,p,0)));t.b(" type=\"text\" name=\"contactUserName\" data-bhw='");t.b(t.v(t.f("stepThreeType",c,p,0)));t.b("__user_name_input_");t.b(t.v(t.f("counter",c,p,0)));t.b("' aria-label=");t.b(t.v(t.f("label",c,p,0)));t.b(">");t.b("\n" + i);});c.pop();}t.b("\n" + i);if(t.s(t.f("file_input_template",c,p,1),c,p,0,3390,3800,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("    <label><strong>");t.b(t.v(t.f("label",c,p,0)));t.b("</strong>");t.b("\n" + i);t.b("    ");if(t.s(t.f("required",c,p,1),c,p,0,3446,3487,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("<span class=\"mandatory-field\"> * </span> ");});c.pop();}t.b("</label>");t.b("\n" + i);t.b("    <input id='fileupload' name=\"fileupload\" class=\"fileupload pull-left\" type='file' value='' data-bhw='");t.b(t.v(t.f("stepThreeType",c,p,0)));t.b("__file_input_");t.b(t.v(t.f("counter",c,p,0)));t.b("' aria-label=");t.b(t.v(t.f("label",c,p,0)));t.b(">");t.b("\n" + i);t.b("    <span id='file_reset' class='icon-x hide pull-left'></span>");t.b("\n" + i);t.b("    <span style=\"color:red\" class='error_upload'></span>");t.b("\n" + i);});c.pop();}t.b("\n" + i);if(t.s(t.f("number_input_template",c,p,1),c,p,0,3852,4138,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("    <label><strong>");t.b(t.v(t.f("label",c,p,0)));t.b("</strong>");t.b("\n" + i);t.b("    ");if(t.s(t.f("required",c,p,1),c,p,0,3908,3949,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("<span class=\"mandatory-field\"> * </span> ");});c.pop();}t.b("</label>");t.b("\n" + i);t.b("    <input class=\"inputField number_input\" size=\"20\" maxLength=");t.b(t.v(t.f("maxLength",c,p,0)));t.b(" type=\"text\"  data-bhw='");t.b(t.v(t.f("stepThreeType",c,p,0)));t.b("__number_input_");t.b(t.v(t.f("counter",c,p,0)));t.b("' aria-label=");t.b(t.v(t.f("label",c,p,0)));t.b(">");t.b("\n" + i);});c.pop();}t.b("\n" + i);if(t.s(t.f("phone_input_template",c,p,1),c,p,0,4191,4675,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("    <label><strong>");t.b(t.v(t.f("label",c,p,0)));t.b("</strong>");t.b("\n" + i);t.b("    ");if(t.s(t.f("required",c,p,1),c,p,0,4247,4288,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("<span class=\"mandatory-field\"> * </span> ");});c.pop();}t.b("</label>");t.b("\n" + i);t.b("      <input class=\"inputField phone_number_input\" maxLength=");t.b(t.v(t.f("maxLength",c,p,0)));t.b(" type=\"text\" name=\"contactPhone\"");t.b("\n" + i);t.b("     placeholder=\"\" data-bhw='");t.b(t.v(t.f("stepThreeType",c,p,0)));t.b("__phone_input_");t.b(t.v(t.f("counter",c,p,0)));t.b("' aria-label=");t.b(t.v(t.f("label",c,p,0)));t.b(">");t.b("\n");t.b("\n" + i);t.b("    <span class=\"validatePhoneNumberInput invalid-input initially-hidden error\">");t.b("\n" + i);t.b("        ");if(t.s(t.f("translate",c,p,1),c,p,0,4617,4648,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.invalidphone");});c.pop();}t.b("\n" + i);t.b("    </span>");t.b("\n" + i);});c.pop();}t.b("\n" + i);if(t.s(t.f("text_line_input_template",c,p,1),c,p,0,4731,5022,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("    <label><strong>");t.b(t.v(t.f("label",c,p,0)));t.b("</strong>");t.b("\n" + i);t.b("    ");if(t.s(t.f("required",c,p,1),c,p,0,4787,4828,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("<span class=\"mandatory-field\"> * </span> ");});c.pop();}t.b("</label>");t.b("\n" + i);t.b("    <input class=\"inputField text_line_input\" size=\"40\" maxLength=");t.b(t.v(t.f("maxLength",c,p,0)));t.b(" type=\"text\" data-bhw='");t.b(t.v(t.f("stepThreeType",c,p,0)));t.b("__text_line_input_");t.b(t.v(t.f("counter",c,p,0)));t.b("' aria-label=");t.b(t.v(t.f("label",c,p,0)));t.b(">");t.b("\n" + i);});c.pop();}t.b("\n" + i);if(t.s(t.f("text_paragraph_input_template",c,p,1),c,p,0,5087,5493,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("    <label>");t.b("\n" + i);t.b("    <strong id='ticket_description'>");t.b("\n" + i);t.b("        ");t.b(t.v(t.f("label",c,p,0)));t.b("\n" + i);t.b("        ");if(t.s(t.f("required",c,p,1),c,p,0,5176,5217,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("<span class=\"mandatory-field\"> * </span> ");});c.pop();}t.b("\n" + i);t.b("    </strong>");t.b("\n" + i);t.b("    </label>");t.b("\n" + i);t.b("    <textarea class=\"description support_textbox p10 text_paragraph_input\" maxLength=");t.b(t.v(t.f("maxLength",c,p,0)));t.b(" name=\"description\" cols=\"80\" rows=\"10\" data-bhw='");t.b(t.v(t.f("stepThreeType",c,p,0)));t.b("__text_paragraph_input_");t.b(t.v(t.f("counter",c,p,0)));t.b("' aria-label=");t.b(t.v(t.f("label",c,p,0)));t.b("></textarea>");t.b("\n");t.b("\n" + i);});c.pop();}t.b("\n" + i);if(t.s(t.f("text_paragraph_template",c,p,1),c,p,0,5557,6041,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("    <div class=\"important-note-container\" data-bhw='");t.b(t.v(t.f("stepThreeType",c,p,0)));t.b("__text_paragraph_");t.b(t.v(t.f("counter",c,p,0)));t.b("'>");t.b("\n" + i);t.b("        <p class=\"important-note-header\">");t.b("\n" + i);t.b("        <label class=\"stepThreeLabel\">  <strong>");if(t.s(t.f("translate",c,p,1),c,p,0,5762,5795,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.important_note");});c.pop();}t.b("</strong>");t.b("\n" + i);t.b("        </label>");t.b("\n" + i);t.b("        </p>");t.b("\n" + i);if(t.s(t.f("labels",c,p,1),c,p,0,5868,6018,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("              <p class=\"important-note\">");t.b("\n" + i);t.b("                <label class=\"stepThreeLabel\"> ");t.b(t.v(t.f("text",c,p,0)));t.b("\n" + i);t.b("                </label>");t.b("\n" + i);t.b("              </p>");t.b("\n" + i);});c.pop();}t.b("    </div>");t.b("\n" + i);});c.pop();}return t.fl(); },partials: {}, subs: {  }}, "{{#checkbox_input_template}}\n    <input type=\"checkbox\" class=\"checkbox_input\" data-bhw='{{stepThreeType}}__checkbox_input_{{counter}}' id='{{stepThreeType}}__checkbox_input_{{counter}}'>\n    <label for='{{stepThreeType}}__checkbox_input_{{counter}}'>{{#required}}<span class=\"mandatory-field\"> * </span> {{/required}}\n    <span><strong>{{label}}</strong></span></label>\n    <span class=\"inputInvalidMsgID invalid-input initially-hidden error\" >\n        {{#translate}}js.modules.support.checkbox_invalid_input_msg{{/translate}}\n    </span>\n{{/checkbox_input_template}}\n\n{{#date_input_template}}\n    <label><span><strong>{{label}}</strong></span>\n    {{#required}}<span class=\"mandatory-field\"> * </span> {{/required}}</label>\n    <input class=\"inputField date_input\" size=\"20\" maxLength=\"15\" type=\"text\" readonly=\"readonly\" data-bhw='{{stepThreeType}}__date_input_{{counter}}' aria-label={{label}}>\n{{/date_input_template}}\n\n{{#date_time_input_template}}\n    <label><strong>{{label}}</strong>\n    {{#required}}<span class=\"mandatory-field\"> * </span> {{/required}}</label>\n    <input class=\"inputField date_time_input\" size=\"20\" maxLength=\"15\" type=\"text\" readonly=\"readonly\" data-bhw='{{stepThreeType}}__date_time_input_{{counter}}' aria-label={{label}}>\n    <span >\n      <select class=\"time_slot\">\n        <option value={{#translate}}js.modules.support.morning{{/translate}}>{{#translate}}js.modules.support.morning{{/translate}}</option>\n        <option value={{#translate}}js.modules.support.early_afternoon{{/translate}}>{{#translate}}js.modules.support.early_afternoon{{/translate}}</option>\n        <option value={{#translate}}js.modules.support.late_afternoon{{/translate}}>{{#translate}}js.modules.support.late_afternoon{{/translate}}</option>\n        <option value={{#translate}}js.modules.support.evening{{/translate}}>{{#translate}}js.modules.support.evening{{/translate}}</option>\n      </select>\n    </span>\n{{/date_time_input_template}}\n\n{{#dropdown_input_template}}\n    <label><strong>{{label}}</strong>\n    {{#required}}<span class=\"mandatory-field\"> * </span> {{/required}}</label>\n    <div >\n      <select class=\"dropdown_input\" data-bhw='{{stepThreeType}}__dropdown_input_{{counter}}' aria-label={{label}}>\n        <option value=\"\" selected>{{#translate}}js.modules.support.categoryselect{{/translate}}</option>\n        {{#options}}\n          <option value=\"{{id}}\">{{text}}</option>\n        {{/options}}\n      </select>\n    </div>\n{{/dropdown_input_template}}\n\n{{#email_input_template}}\n    <label><strong>{{label}}</strong>\n    {{#required}}<span class=\"mandatory-field\"> * </span> {{/required}}</label>\n    <input class=\"inputField email_input\" size=\"40\" maxLength={{maxLength}} type=\"text\" name=\"contactEmail\" data-bhw='{{stepThreeType}}__email_input_{{counter}}' aria-label={{label}}>\n    <span class=\"validateEmailInput invalid-input error initially-hidden\">\n       {{#translate}}js.modules.support.invalidemail{{/translate}}\n    </span>\n{{/email_input_template}}\n\n{{#user_name_input_template}}\n    <label><strong>{{label}}</strong>\n    {{#required}}<span class=\"mandatory-field\"> * </span> {{/required}}</label>\n    <input class=\"inputField user_name_input\" size=\"40\" maxLength={{maxLength}} type=\"text\" name=\"contactUserName\" data-bhw='{{stepThreeType}}__user_name_input_{{counter}}' aria-label={{label}}>\n{{/user_name_input_template}}\n\n{{#file_input_template}}\n    <label><strong>{{label}}</strong>\n    {{#required}}<span class=\"mandatory-field\"> * </span> {{/required}}</label>\n    <input id='fileupload' name=\"fileupload\" class=\"fileupload pull-left\" type='file' value='' data-bhw='{{stepThreeType}}__file_input_{{counter}}' aria-label={{label}}>\n    <span id='file_reset' class='icon-x hide pull-left'></span>\n    <span style=\"color:red\" class='error_upload'></span>\n{{/file_input_template}}\n\n{{#number_input_template}}\n    <label><strong>{{label}}</strong>\n    {{#required}}<span class=\"mandatory-field\"> * </span> {{/required}}</label>\n    <input class=\"inputField number_input\" size=\"20\" maxLength={{maxLength}} type=\"text\"  data-bhw='{{stepThreeType}}__number_input_{{counter}}' aria-label={{label}}>\n{{/number_input_template}}\n\n{{#phone_input_template}}\n    <label><strong>{{label}}</strong>\n    {{#required}}<span class=\"mandatory-field\"> * </span> {{/required}}</label>\n      <input class=\"inputField phone_number_input\" maxLength={{maxLength}} type=\"text\" name=\"contactPhone\"\n     placeholder=\"\" data-bhw='{{stepThreeType}}__phone_input_{{counter}}' aria-label={{label}}>\n\n    <span class=\"validatePhoneNumberInput invalid-input initially-hidden error\">\n        {{#translate}}js.modules.support.invalidphone{{/translate}}\n    </span>\n{{/phone_input_template}}\n\n{{#text_line_input_template}}\n    <label><strong>{{label}}</strong>\n    {{#required}}<span class=\"mandatory-field\"> * </span> {{/required}}</label>\n    <input class=\"inputField text_line_input\" size=\"40\" maxLength={{maxLength}} type=\"text\" data-bhw='{{stepThreeType}}__text_line_input_{{counter}}' aria-label={{label}}>\n{{/text_line_input_template}}\n\n{{#text_paragraph_input_template}}\n    <label>\n    <strong id='ticket_description'>\n        {{label}}\n        {{#required}}<span class=\"mandatory-field\"> * </span> {{/required}}\n    </strong>\n    </label>\n    <textarea class=\"description support_textbox p10 text_paragraph_input\" maxLength={{maxLength}} name=\"description\" cols=\"80\" rows=\"10\" data-bhw='{{stepThreeType}}__text_paragraph_input_{{counter}}' aria-label={{label}}></textarea>\n\n{{/text_paragraph_input_template}}\n\n{{#text_paragraph_template}}\n    <div class=\"important-note-container\" data-bhw='{{stepThreeType}}__text_paragraph_{{counter}}'>\n        <p class=\"important-note-header\">\n        <label class=\"stepThreeLabel\">  <strong>{{#translate}}js.modules.support.important_note{{/translate}}</strong>\n        </label>\n        </p>\n        {{#labels}}\n              <p class=\"important-note\">\n                <label class=\"stepThreeLabel\"> {{text}}\n                </label>\n              </p>\n        {{/labels}}\n    </div>\n{{/text_paragraph_template}}", Hogan);
},{"hogan.js":248}],44:[function(require,module,exports){
var Hogan = require('hogan.js');
module.exports = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");if(!t.s(t.f("isVertical",c,p,1),c,p,1,0,0,"")){t.b("  <div class=\"help-wizard-content\">");t.b("\n" + i);t.b("  <div class=\"steps-container\"> </div>");t.b("\n" + i);t.b("  <form method=\"post\" accept-charset=\"UTF-8\" id=\"contact-us\" enctype=\"multipart/form-data\" class=\"cb\" style=\"padding-bottom: 10px;\">");t.b("\n" + i);t.b("    <div class=\"row\">");t.b("\n" + i);if(t.s(t.f("email_channel",c,p,1),c,p,0,270,2332,"{{ }}")){t.rs(c,p,function(c,p,t){if(!t.s(t.f("escalate_to_merchant",c,p,1),c,p,1,0,0,"")){if(!t.s(t.f("faqInsteadHelpWizard",c,p,1),c,p,1,0,0,"")){t.b("          <h4>");if(t.s(t.f("translate",c,p,1),c,p,0,365,393,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.contactus");});c.pop();}t.b("</h4>");t.b("\n" + i);};if(t.s(t.f("faqInsteadHelpWizard",c,p,1),c,p,0,480,563,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("          <h4>");if(t.s(t.f("translate",c,p,1),c,p,0,509,535,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.emailus");});c.pop();}t.b("</h4>");t.b("\n" + i);});c.pop();}};t.b("\n" + i);if(t.s(t.f("escalate_to_merchant",c,p,1),c,p,0,653,741,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("        <h4>");if(t.s(t.f("translate",c,p,1),c,p,0,680,715,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.contact_merchant");});c.pop();}t.b("</h4>");t.b("\n" + i);});c.pop();}t.b("\n" + i);if(t.s(t.f("show_all_fields_required",c,p,1),c,p,0,803,968,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("      <p> <strong><span style=\"color:red\">*</span></strong> <span style=\"color:#333\">");if(t.s(t.f("translate",c,p,1),c,p,0,903,936,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.all_fields_req");});c.pop();}t.b("</span></p>");t.b("\n" + i);});c.pop();}if(!t.s(t.f("show_all_fields_required",c,p,1),c,p,1,0,0,"")){t.b("      <p> <span style=\"color:red\">*</span> <span style=\"color:#333\">");if(t.s(t.f("translate",c,p,1),c,p,0,1116,1145,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.req_fields");});c.pop();}t.b("</span></p>");t.b("\n" + i);};if(t.s(t.f("is_order",c,p,1),c,p,0,1226,1431,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("      <p class=\"merchant-info\">");t.b("\n" + i);t.b("        <label class=\"stepThreeLabel\"> <strong>");if(t.s(t.f("translate",c,p,1),c,p,0,1320,1347,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.merchant");});c.pop();}t.b("</strong>");t.b("\n" + i);t.b("        ");t.b(t.v(t.f("merchant_name",c,p,0)));t.b("\n" + i);t.b("        </label>");t.b("\n" + i);t.b("      </p>");t.b("\n" + i);});c.pop();}if(t.s(t.f("show_reason",c,p,1),c,p,0,1467,1690,"{{ }}")){t.rs(c,p,function(c,p,t){if(t.s(t.f("reason",c,p,1),c,p,0,1485,1672,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("      <p class=\"issue\">");t.b("\n" + i);t.b("        <label class=\"stepThreeLabel\"> <strong>");if(t.s(t.f("translate",c,p,1),c,p,0,1571,1595,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.issue");});c.pop();}t.b("</strong>");t.b("\n" + i);t.b("        ");t.b(t.v(t.f("reason",c,p,0)));t.b("\n" + i);t.b("        </label>");t.b("\n" + i);t.b("      </p>");t.b("\n" + i);});c.pop();}});c.pop();}if(t.s(t.f("escalate_to_merchant",c,p,1),c,p,0,1738,1964,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("        <p class=\"deal_concerned\">");t.b("\n" + i);t.b("          <label class=\"stepThreeLabel\"> <strong>");if(t.s(t.f("translate",c,p,1),c,p,0,1837,1870,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.deal_concerned");});c.pop();}t.b("</strong>");t.b("\n" + i);t.b("          ");t.b(t.v(t.f("deal_option_title",c,p,0)));t.b("\n" + i);t.b("          </label>");t.b("\n" + i);t.b("        </p>");t.b("\n" + i);});c.pop();}if(t.s(t.f("is_refund_eligible",c,p,1),c,p,0,2019,2208,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("        <p class=\"step-three-voucher\">");t.b("\n" + i);t.b("          <label class=\"stepThreeLabel\"> <strong>");if(t.s(t.f("translate",c,p,1),c,p,0,2122,2146,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.vouch");});c.pop();}t.b("</strong>");t.b("\n" + i);t.b("          </label>");t.b("\n" + i);t.b("        </p>");t.b("\n" + i);});c.pop();}t.b("      <ol style=\"padding-left:0px\" id=\"componentList\" class=\"contact-us-componont-list\"></ol>");t.b("\n" + i);});c.pop();}t.b("    </div>");t.b("\n" + i);t.b("  </form>");t.b("\n" + i);t.b("</div>");t.b("\n" + i);};t.b("\n");t.b("\n" + i);if(t.s(t.f("isVertical",c,p,1),c,p,0,2412,4867,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("  <div class=\"help-wizard-content\">");t.b("\n" + i);if(t.s(t.f("email_channel",c,p,1),c,p,0,2471,4839,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("      <div class=\"row\">");t.b("\n" + i);t.b("        <span class=\"icon-email\"></span>");t.b("\n" + i);t.b("        <span class=\"article-title\">");t.b("\n" + i);if(!t.s(t.f("escalate_to_merchant",c,p,1),c,p,1,0,0,"")){t.b("            ");if(t.s(t.f("translate",c,p,1),c,p,0,2634,2660,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.emailus");});c.pop();}t.b("\n" + i);};if(t.s(t.f("escalate_to_merchant",c,p,1),c,p,0,2742,2832,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("            ");if(t.s(t.f("translate",c,p,1),c,p,0,2769,2804,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.contact_merchant");});c.pop();}t.b("</h4>");t.b("\n" + i);});c.pop();}t.b("        </span>");t.b("\n" + i);t.b("      </div>");t.b("\n" + i);t.b("      <form method=\"post\" accept-charset=\"UTF-8\" id=\"contact-us\" enctype=\"multipart/form-data\" class=\"cb\" style=\"padding-bottom: 10px;\">");t.b("\n" + i);t.b("        <div class=\"row\" id=\"v2-step3-form\">");t.b("\n" + i);if(t.s(t.f("show_all_fields_required",c,p,1),c,p,0,3108,3283,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("            <p> <strong><span style=\"color:red\">*</span></strong> <span style=\"color:#333\">");if(t.s(t.f("translate",c,p,1),c,p,0,3214,3247,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.all_fields_req");});c.pop();}t.b("</span></p>");t.b("\n" + i);});c.pop();}if(!t.s(t.f("show_all_fields_required",c,p,1),c,p,1,0,0,"")){t.b("            <p> <span style=\"color:red\">*</span> <span style=\"color:#333\">");if(t.s(t.f("translate",c,p,1),c,p,0,3441,3470,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.req_fields");});c.pop();}t.b("</span></p>");t.b("\n" + i);};if(t.s(t.f("is_order",c,p,1),c,p,0,3559,3788,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("          <p class=\"merchant-info\">");t.b("\n" + i);t.b("            <label class=\"stepThreeLabel\"> <strong>");if(t.s(t.f("translate",c,p,1),c,p,0,3661,3688,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.merchant");});c.pop();}t.b("</strong>");t.b("\n" + i);t.b("            ");t.b(t.v(t.f("merchant_name",c,p,0)));t.b("\n" + i);t.b("            </label>");t.b("\n" + i);t.b("          </p>");t.b("\n" + i);});c.pop();}if(t.s(t.f("show_reason",c,p,1),c,p,0,3828,4097,"{{ }}")){t.rs(c,p,function(c,p,t){if(t.s(t.f("reason",c,p,1),c,p,0,3852,4075,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("            <p class=\"issue\">");t.b("\n" + i);t.b("              <label class=\"stepThreeLabel\"> <strong>");if(t.s(t.f("translate",c,p,1),c,p,0,3950,3974,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.issue");});c.pop();}t.b("</strong>");t.b("\n" + i);t.b("              ");t.b(t.v(t.f("reason",c,p,0)));t.b("\n" + i);t.b("              </label>");t.b("\n" + i);t.b("            </p>");t.b("\n" + i);});c.pop();}});c.pop();}if(t.s(t.f("escalate_to_merchant",c,p,1),c,p,0,4149,4399,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("            <p class=\"deal_concerned\">");t.b("\n" + i);t.b("              <label class=\"stepThreeLabel\"> <strong>");if(t.s(t.f("translate",c,p,1),c,p,0,4256,4289,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.deal_concerned");});c.pop();}t.b("</strong>");t.b("\n" + i);t.b("              ");t.b(t.v(t.f("deal_option_title",c,p,0)));t.b("\n" + i);t.b("              </label>");t.b("\n" + i);t.b("            </p>");t.b("\n" + i);});c.pop();}if(t.s(t.f("is_refund_eligible",c,p,1),c,p,0,4458,4667,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("            <p class=\"step-three-voucher\">");t.b("\n" + i);t.b("              <label class=\"stepThreeLabel\"> <strong>");if(t.s(t.f("translate",c,p,1),c,p,0,4569,4593,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.vouch");});c.pop();}t.b("</strong>");t.b("\n" + i);t.b("              </label>");t.b("\n" + i);t.b("            </p>");t.b("\n" + i);});c.pop();}t.b("          <ul style=\"padding-left:0px;list-style:none;\" id=\"componentList\" class=\"contact-us-componont-list\"></ul>");t.b("\n" + i);t.b("        </div>");t.b("\n" + i);t.b("      </form>");t.b("\n" + i);});c.pop();}t.b("  </div>");t.b("\n" + i);});c.pop();}return t.fl(); },partials: {}, subs: {  }}, "{{^isVertical}}\n  <div class=\"help-wizard-content\">\n  <div class=\"steps-container\"> </div>\n  <form method=\"post\" accept-charset=\"UTF-8\" id=\"contact-us\" enctype=\"multipart/form-data\" class=\"cb\" style=\"padding-bottom: 10px;\">\n    <div class=\"row\">\n      {{#email_channel}}\n      {{^escalate_to_merchant}}\n        {{^faqInsteadHelpWizard}}\n          <h4>{{#translate}}js.modules.support.contactus{{/translate}}</h4>\n        {{/faqInsteadHelpWizard}}\n        {{#faqInsteadHelpWizard}}\n          <h4>{{#translate}}js.modules.support.emailus{{/translate}}</h4>\n        {{/faqInsteadHelpWizard}}\n      {{/escalate_to_merchant}}\n\n      {{#escalate_to_merchant}}\n        <h4>{{#translate}}js.modules.support.contact_merchant{{/translate}}</h4>\n      {{/escalate_to_merchant}}\n\n      {{#show_all_fields_required}}\n      <p> <strong><span style=\"color:red\">*</span></strong> <span style=\"color:#333\">{{#translate}}js.modules.support.all_fields_req{{/translate}}</span></p>\n      {{/show_all_fields_required}}\n      {{^show_all_fields_required}}\n      <p> <span style=\"color:red\">*</span> <span style=\"color:#333\">{{#translate}}js.modules.support.req_fields{{/translate}}</span></p>\n      {{/show_all_fields_required}}\n      {{#is_order}}\n      <p class=\"merchant-info\">\n        <label class=\"stepThreeLabel\"> <strong>{{#translate}}js.modules.support.merchant{{/translate}}</strong>\n        {{merchant_name}}\n        </label>\n      </p>\n      {{/is_order}}\n      {{#show_reason}}\n      {{#reason}}\n      <p class=\"issue\">\n        <label class=\"stepThreeLabel\"> <strong>{{#translate}}js.modules.support.issue{{/translate}}</strong>\n        {{reason}}\n        </label>\n      </p>\n      {{/reason}}\n      {{/show_reason}}\n      {{#escalate_to_merchant}}\n        <p class=\"deal_concerned\">\n          <label class=\"stepThreeLabel\"> <strong>{{#translate}}js.modules.support.deal_concerned{{/translate}}</strong>\n          {{deal_option_title}}\n          </label>\n        </p>\n      {{/escalate_to_merchant}}\n      {{#is_refund_eligible}}\n        <p class=\"step-three-voucher\">\n          <label class=\"stepThreeLabel\"> <strong>{{#translate}}js.modules.support.vouch{{/translate}}</strong>\n          </label>\n        </p>\n      {{/is_refund_eligible}}\n      <ol style=\"padding-left:0px\" id=\"componentList\" class=\"contact-us-componont-list\"></ol>\n      {{/email_channel}}\n    </div>\n  </form>\n</div>\n{{/isVertical}}\n\n\n{{#isVertical}}\n  <div class=\"help-wizard-content\">\n    {{#email_channel}}\n      <div class=\"row\">\n        <span class=\"icon-email\"></span>\n        <span class=\"article-title\">\n        {{^escalate_to_merchant}}\n            {{#translate}}js.modules.support.emailus{{/translate}}\n        {{/escalate_to_merchant}}\n        {{#escalate_to_merchant}}\n            {{#translate}}js.modules.support.contact_merchant{{/translate}}</h4>\n        {{/escalate_to_merchant}}\n        </span>\n      </div>\n      <form method=\"post\" accept-charset=\"UTF-8\" id=\"contact-us\" enctype=\"multipart/form-data\" class=\"cb\" style=\"padding-bottom: 10px;\">\n        <div class=\"row\" id=\"v2-step3-form\">\n          {{#show_all_fields_required}}\n            <p> <strong><span style=\"color:red\">*</span></strong> <span style=\"color:#333\">{{#translate}}js.modules.support.all_fields_req{{/translate}}</span></p>\n          {{/show_all_fields_required}}\n          {{^show_all_fields_required}}\n            <p> <span style=\"color:red\">*</span> <span style=\"color:#333\">{{#translate}}js.modules.support.req_fields{{/translate}}</span></p>\n          {{/show_all_fields_required}}\n          {{#is_order}}\n          <p class=\"merchant-info\">\n            <label class=\"stepThreeLabel\"> <strong>{{#translate}}js.modules.support.merchant{{/translate}}</strong>\n            {{merchant_name}}\n            </label>\n          </p>\n          {{/is_order}}\n          {{#show_reason}}\n            {{#reason}}\n            <p class=\"issue\">\n              <label class=\"stepThreeLabel\"> <strong>{{#translate}}js.modules.support.issue{{/translate}}</strong>\n              {{reason}}\n              </label>\n            </p>\n            {{/reason}}\n          {{/show_reason}}\n          {{#escalate_to_merchant}}\n            <p class=\"deal_concerned\">\n              <label class=\"stepThreeLabel\"> <strong>{{#translate}}js.modules.support.deal_concerned{{/translate}}</strong>\n              {{deal_option_title}}\n              </label>\n            </p>\n          {{/escalate_to_merchant}}\n          {{#is_refund_eligible}}\n            <p class=\"step-three-voucher\">\n              <label class=\"stepThreeLabel\"> <strong>{{#translate}}js.modules.support.vouch{{/translate}}</strong>\n              </label>\n            </p>\n          {{/is_refund_eligible}}\n          <ul style=\"padding-left:0px;list-style:none;\" id=\"componentList\" class=\"contact-us-componont-list\"></ul>\n        </div>\n      </form>\n    {{/email_channel}}\n  </div>\n{{/isVertical}}\n", Hogan);
},{"hogan.js":248}],45:[function(require,module,exports){
var Backbone, SupportAppRouter, SupportHelpWizardController, directlyAccessed, handleAbruptStepTwoFlow, hideComponents,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Backbone = require('backbone');

Backbone.$ = $;

SupportHelpWizardController = require('./helpWizardController');

SupportAppRouter = (function(superClass) {
  extend(SupportAppRouter, superClass);

  function SupportAppRouter() {
    return SupportAppRouter.__super__.constructor.apply(this, arguments);
  }

  SupportAppRouter.prototype.routes = {
    '': 'initialRedirection',
    'pick-order': 'renderStepOne',
    'select-issue': 'renderStepTwo',
    'contact-us': 'renderStepThree',
    'problem-solved': 'renderProblemSolved',
    'ticket-success': 'renderTicketSuccess',
    'chat-success': 'renderChatSuccess'
  };

  SupportAppRouter.prototype.initialRedirection = function() {
    if (window.landingStep != null) {
      if (window.landingStep === "intermediate_page") {
        return this.renderIntermediatePage();
      } else if (window.landingStep === "step_1") {
        return SupportHelpWizardController.initOrdersFetch();
      } else if (window.landingStep === "step_2") {
        return handleAbruptStepTwoFlow();
      }
    } else {
      return handleAbruptStepTwoFlow();
    }
  };

  SupportAppRouter.prototype.renderIntermediatePage = function() {
    return SupportHelpWizardController.intermediatePage();
  };

  SupportAppRouter.prototype.renderStepOne = function() {
    if (!Groupon.Support.OrdersCollection.hasOrders()) {
      return Backbone.history.navigate('', {
        trigger: true
      });
    }
    if (directlyAccessed()) {
      return Backbone.history.navigate('', {
        trigger: true
      });
    }
    hideComponents();
    return SupportHelpWizardController.stepOne(Groupon.Support.currentOrder);
  };

  SupportAppRouter.prototype.renderStepTwo = function() {
    if (directlyAccessed()) {
      return Backbone.history.navigate('', {
        trigger: true
      });
    }
    hideComponents();
    return SupportHelpWizardController.stepTwo();
  };

  SupportAppRouter.prototype.renderStepThree = function() {
    if (directlyAccessed()) {
      return Backbone.history.navigate('', {
        trigger: true
      });
    }
    hideComponents();
    return SupportHelpWizardController.stepThree();
  };

  SupportAppRouter.prototype.renderProblemSolved = function() {
    if (directlyAccessed()) {
      return Backbone.history.navigate('', {
        trigger: true
      });
    }
    hideComponents();
    return SupportHelpWizardController.problemSolved();
  };

  SupportAppRouter.prototype.renderTicketSuccess = function() {
    if (directlyAccessed()) {
      return Backbone.history.navigate('', {
        trigger: true
      });
    }
    hideComponents();
    return SupportHelpWizardController.ticketSuccess();
  };

  SupportAppRouter.prototype.renderChatSuccess = function() {
    if (directlyAccessed()) {
      return Backbone.history.navigate('', {
        trigger: true
      });
    }
    hideComponents();
    return SupportHelpWizardController.chatSuccess();
  };

  return SupportAppRouter;

})(Backbone.Router);

handleAbruptStepTwoFlow = function() {
  var listener;
  if (!isCMSEnabled() && Groupon.Support.FeatureFlagModel.isSearchBasedDropDownsEnabled()) {
    listener = function() {
      $(document).off("inbenta-help-wizard-loaded", listener);
      return SupportHelpWizardController.abruptStepTwoFlow();
    };
    return $(document).on('inbenta-help-wizard-loaded', listener);
  } else {
    return SupportHelpWizardController.abruptStepTwoFlow();
  }
};

directlyAccessed = function() {
  return !((Groupon.Support.currentOrder != null) || (Groupon.Support.NOT_ORDER_RELATED != null) || (Groupon.Support.ORDER_NOT_LISTED != null));
};

hideComponents = function() {
  return window.hideFooterLinks();
};

module.exports = SupportAppRouter;



},{"./helpWizardController":50,"backbone":245}],46:[function(require,module,exports){
var SupportAPIHelper, SupportOrderModel, SupportOrdersCollection, SupportOrdersFilterCollection, SupportUtilsHelper;

SupportAPIHelper = require('../helpers/API');

SupportOrderModel = require('../models/order');

SupportOrdersFilterCollection = require('./orders_filter');

SupportUtilsHelper = require('../helpers/utils');

SupportOrdersCollection = (function() {
  function SupportOrdersCollection() {
    this.hotelImages = {};
    this.orders = {};
  }

  SupportOrdersCollection.prototype.saveHotelImage = function(order) {
    var reservationSource;
    if (order.DEAL_TYPE === 'GETAWAYS_MARKET_RATE') {
      reservationSource = SupportUtilsHelper.getReservationSource(order);
      if (reservationSource) {
        return this.hotelImages[order.id] = {
          images: reservationSource.images
        };
      }
    }
  };

  SupportOrdersCollection.prototype.orderListPath = function(options) {
    var baseUrl, query, url;
    baseUrl = window.SUPPORTBASEURL + "/user/" + currentUser.id + "/orders";
    query = "";
    if (options.page != null) {
      query = query + "page=" + (encodeURIComponent(options.page)) + "&";
    }
    if (options.limit != null) {
      query = query + "limit=" + (encodeURIComponent(options.limit)) + "&";
    }
    if (options.sort_attribute != null) {
      query = query + "sort_attribute=" + (encodeURIComponent(options.sort_attribute)) + "&";
    }
    if (options.sort_order != null) {
      query = query + "sort_order=" + (encodeURIComponent(options.sort_order)) + "&";
    }
    return url = baseUrl + "?" + query;
  };

  SupportOrdersCollection.prototype.fetchOrders = function(options, successCallback, errorCallback) {
    var _successCb, url;
    options.sort_attribute || (options.sort_attribute = 'purchased_at');
    options.sort_order || (options.sort_order = 'descending');
    url = this.orderListPath(options);
    _successCb = (function(_this) {
      return function(response) {
        var ref;
        if ((response != null ? (ref = response.orders) != null ? ref.length : void 0 : void 0) > 0) {
          _this.updateOrderIndexDetails(response);
          return successCallback(response);
        } else {
          return successCallback(response || {});
        }
      };
    })(this);
    return SupportAPIHelper.get(url, null, _successCb, errorCallback, false);
  };

  SupportOrdersCollection.prototype.findOrderById = function(orderId) {
    if (this.hasOrders() && orderId) {
      orderId = orderId.toString();
      return this.orders[orderId];
    } else {
      return null;
    }
  };

  SupportOrdersCollection.prototype.setOrderSummary = function(order) {
    var orderId;
    if (order != null ? order.id : void 0) {
      orderId = order.id.toString();
      return this.orders[orderId] = order;
    }
  };

  SupportOrdersCollection.prototype.updateOrderIndexDetails = function(response) {
    _.each(response.orders, (function(_this) {
      return function(responseOrder) {
        var orderFound;
        orderFound = _this.findOrderById(responseOrder.id);
        if (orderFound) {
          return false;
        } else {
          _this.saveHotelImage(responseOrder);
          _this.setOrderSummary(responseOrder);
          return true;
        }
      };
    })(this));
    return response;
  };

  SupportOrdersCollection.prototype.hasOrders = function() {
    return _.size(this.orders) > 0;
  };

  SupportOrdersCollection.prototype.getNumberOfOrdersFetched = function() {
    return _.size(this.orders);
  };

  SupportOrdersCollection.prototype.getHotelImageByOrderId = function(orderId) {
    if (this.hasOrders()) {
      return this.hotelImages[orderId];
    } else {
      return null;
    }
  };

  SupportOrdersCollection.prototype.getFilterInstance = function(options) {
    var sort_attribute, sort_order;
    sort_attribute = options.sort_attribute, sort_order = options.sort_order;
    if (sort_attribute === 'purchased_at') {
      if (sort_order === "descending") {
        return this.createPurchaseDateDescendingFilter();
      } else {
        return this.createPurchaseDateAscendingFilter();
      }
    } else {
      if (sort_order === "descending") {
        return this.createMerchantNameDescendingFilter();
      } else {
        return this.createMerchantNameAscendingFilter();
      }
    }
  };

  SupportOrdersCollection.prototype.createPurchaseDateAscendingFilter = function() {
    var options;
    if (this.purchaseDateAscendingFilter) {
      return this.purchaseDateAscendingFilter;
    }
    options = {
      sort_attribute: "purchased_at",
      sort_order: "ascending"
    };
    return this.purchaseDateAscendingFilter = this.createFilter(options);
  };

  SupportOrdersCollection.prototype.createPurchaseDateDescendingFilter = function() {
    var options;
    if (this.purchaseDateDescendingFilter) {
      return this.purchaseDateDescendingFilter;
    }
    options = {
      sort_attribute: "purchased_at",
      sort_order: "descending"
    };
    return this.purchaseDateDescendingFilter = this.createFilter(options);
  };

  SupportOrdersCollection.prototype.createMerchantNameAscendingFilter = function() {
    var options;
    if (this.merchantNameAscendingFilter) {
      return this.merchantNameAscendingFilter;
    }
    options = {
      sort_attribute: "merchant_name",
      sort_order: "ascending"
    };
    return this.merchantNameAscendingFilter = this.createFilter(options);
  };

  SupportOrdersCollection.prototype.createMerchantNameDescendingFilter = function() {
    var options;
    if (this.merchantNameDescendingFilter) {
      return this.merchantNameDescendingFilter;
    }
    options = {
      sort_attribute: "merchant_name",
      sort_order: "descending"
    };
    return this.merchantNameDescendingFilter = this.createFilter(options);
  };

  SupportOrdersCollection.prototype.createFilter = function(options) {
    return new SupportOrdersFilterCollection(options);
  };

  return SupportOrdersCollection;

})();

module.exports = SupportOrdersCollection;



},{"../helpers/API":51,"../helpers/utils":54,"../models/order":67,"./orders_filter":47}],47:[function(require,module,exports){
var SupportOrdersFilterCollection, SupportOrdersFilterConditionsModel, SupportOrdersIteratorNonPaginatedCollection, SupportOrdersIteratorPaginatedCollection;

SupportOrdersIteratorNonPaginatedCollection = require('./orders_iterator_nonpaginated');

SupportOrdersIteratorPaginatedCollection = require('./orders_iterator_paginated');

SupportOrdersFilterConditionsModel = require('../models/orders_filter_conditions');

SupportOrdersFilterCollection = (function() {
  function SupportOrdersFilterCollection(options) {
    this.ordersModel = Groupon.Support.OrdersCollection;
    this.setSortAttribute(options.sort_attribute);
    this.setSortOrder(options.sort_order);
    this.sortedOrders = [];
    this.conditions = new SupportOrdersFilterConditionsModel;
    if (window.ordersPaginationEnabled) {
      this.iterator = new SupportOrdersIteratorPaginatedCollection(this);
    } else {
      this.iterator = new SupportOrdersIteratorNonPaginatedCollection(this, this.ordersModel);
    }
    this.pagination = null;
  }

  SupportOrdersFilterCollection.prototype.setSortAttribute = function(val) {
    switch (val) {
      case 'purchased_at':
        return this.sort_attribute = 'purchased_at';
      case 'merchant_name':
        return this.sort_attribute = 'merchant_name';
      default:
        return this.sort_attribute = 'purchased_at';
    }
  };

  SupportOrdersFilterCollection.prototype.getSortAttribute = function() {
    return this.sort_attribute;
  };

  SupportOrdersFilterCollection.prototype.setSortOrder = function(val) {
    switch (val) {
      case 'descending':
        return this.sort_order = 'descending';
      case 'ascending':
        return this.sort_order = 'ascending';
      default:
        return this.sort_order = 'descending';
    }
  };

  SupportOrdersFilterCollection.prototype.getSortOrder = function() {
    return this.sort_order;
  };

  SupportOrdersFilterCollection.prototype.getOrders = function(options, sucessCallback, errorCallback) {
    var _sucessCb, hash;
    _sucessCb = (function(_this) {
      return function(response) {
        var ref;
        if (response != null ? response.pagination : void 0) {
          _this.pagination = response.pagination;
        }
        if ((response != null ? (ref = response.orders) != null ? ref.length : void 0 : void 0) > 0) {
          response.orders = _this.sortOrders(response.orders);
        }
        return sucessCallback(response);
      };
    })(this);
    hash = {
      sort_order: this.sort_order,
      sort_attribute: this.sort_attribute
    };
    options = _.extend(options, hash);
    return this.ordersModel.fetchOrders(options, _sucessCb, errorCallback);
  };

  SupportOrdersFilterCollection.prototype.sortOrders = function(orders) {
    if (this.ordersModel.getNumberOfOrdersFetched() > this.sortedOrders.length) {
      if (this.sort_attribute === 'merchant_name') {
        if (this.sort_order === 'descending') {
          orders.sort((function(_this) {
            return function(a, b) {
              return _this.conditions.sortMerchantNameDescendingFn(a, b);
            };
          })(this));
        } else {
          orders.sort((function(_this) {
            return function(a, b) {
              return _this.conditions.sortMerchantNameAscendingFn(a, b);
            };
          })(this));
        }
      } else if (this.sort_attribute === 'purchased_at') {
        if (this.sort_order === 'descending') {
          orders.sort((function(_this) {
            return function(a, b) {
              return _this.conditions.sortPurchasedDateDescendingFn(a, b);
            };
          })(this));
        } else {
          orders.sort((function(_this) {
            return function(a, b) {
              return _this.conditions.sortPurchasedDateAscendingFn(a, b);
            };
          })(this));
        }
      }
      orders = _.filter(orders, (function(_this) {
        return function(order) {
          var orderFound;
          orderFound = _this.findOrderById(order.id);
          if (orderFound) {
            return false;
          } else {
            _this.sortedOrders.push(order);
            return true;
          }
        };
      })(this));
    }
    return orders;
  };

  SupportOrdersFilterCollection.prototype.findOrderById = function(orderId) {
    if (orderId) {
      orderId = orderId.toString();
      return _.find(this.sortedOrders, function(order) {
        var ref;
        return ((ref = order.id) != null ? ref.toString() : void 0) === orderId;
      });
    } else {
      return null;
    }
  };

  SupportOrdersFilterCollection.prototype.getFirstOrder = function() {
    if (this.sortedOrders.length > 0) {
      return this.sortedOrders[0];
    } else {
      return null;
    }
  };

  SupportOrdersFilterCollection.prototype.isOrdersInfoValid = function() {
    return this.iterator.isOrdersInfoValid();
  };

  return SupportOrdersFilterCollection;

})();

module.exports = SupportOrdersFilterCollection;



},{"../models/orders_filter_conditions":68,"./orders_iterator_nonpaginated":48,"./orders_iterator_paginated":49}],48:[function(require,module,exports){
var SupportOrdersIteratorNonPaginatedCollection;

SupportOrdersIteratorNonPaginatedCollection = (function() {
  function SupportOrdersIteratorNonPaginatedCollection(ordersFilter, orderModel) {
    this.ordersFilter = ordersFilter;
    this.resetIterator();
    this.size = 10;
    if (orderModel.hasOrders()) {
      this.state = "SUCCESS";
      this.ordersFilter.sortOrders(_.map(orderModel.orders, function(order) {
        return order;
      }));
    } else {
      this.state = "NOT_STARTED";
    }
  }

  SupportOrdersIteratorNonPaginatedCollection.prototype.resetIterator = function() {
    return this.currentOrdersOffset = 0;
  };

  SupportOrdersIteratorNonPaginatedCollection.prototype.resetState = function() {
    return this.state;
  };

  SupportOrdersIteratorNonPaginatedCollection.prototype.hasNext = function() {
    if (this.isStateNotStarted()) {
      return true;
    } else if (this.isOrderCallQueued() || this.currentOrdersOffset >= this.getNumberOfOrdersFetched()) {
      return false;
    }
    return true;
  };

  SupportOrdersIteratorNonPaginatedCollection.prototype.next = function(sucessCallback, errorCallback) {
    var _errorCb, _sucessCb, options;
    if (this.hasNext()) {
      _sucessCb = (function(_this) {
        return function() {
          var offset;
          _this.state = "SUCCESS";
          offset = _this.currentOrdersOffset;
          _this.currentOrdersOffset = Math.min(_this.currentOrdersOffset + _this.size, _this.getNumberOfOrdersFetched());
          return sucessCallback(_this.ordersFilter.sortedOrders.slice(offset, offset + _this.size));
        };
      })(this);
      if (this.currentOrdersOffset < this.getNumberOfOrdersFetched()) {
        return _sucessCb();
      } else {
        options = {};
        this.state = "QUEUED";
        _errorCb = (function(_this) {
          return function() {
            _this.state = "ERROR";
            return errorCallback();
          };
        })(this);
        return this.ordersFilter.getOrders(options, _sucessCb, _errorCb);
      }
    }
  };

  SupportOrdersIteratorNonPaginatedCollection.prototype.isStateNotStarted = function() {
    return this.state === "NOT_STARTED";
  };

  SupportOrdersIteratorNonPaginatedCollection.prototype.isOrderCallQueued = function() {
    return this.state === "QUEUED";
  };

  SupportOrdersIteratorNonPaginatedCollection.prototype.hasOrderCallFailed = function() {
    return this.state === "ERROR";
  };

  SupportOrdersIteratorNonPaginatedCollection.prototype.getNumberOfOrdersFetched = function() {
    return this.ordersFilter.sortedOrders.length;
  };

  SupportOrdersIteratorNonPaginatedCollection.prototype.getNumberOfItemPerPage = function() {
    return this.size;
  };

  SupportOrdersIteratorNonPaginatedCollection.prototype.isOrdersInfoValid = function() {
    return !(this.isStateNotStarted() || this.hasOrderCallFailed());
  };

  return SupportOrdersIteratorNonPaginatedCollection;

})();

module.exports = SupportOrdersIteratorNonPaginatedCollection;



},{}],49:[function(require,module,exports){
var SupportOrdersIteratorPaginatedCollection;

SupportOrdersIteratorPaginatedCollection = (function() {
  function SupportOrdersIteratorPaginatedCollection(ordersFilter) {
    this.ordersFilter = ordersFilter;
    this.size = 10;
    this.resetIterator();
    this.pagesRead = 0;
  }

  SupportOrdersIteratorPaginatedCollection.prototype.resetIterator = function() {
    this.currentOrdersOffset = 0;
    return this.state = "NOT_STARTED";
  };

  SupportOrdersIteratorPaginatedCollection.prototype.resetState = function() {
    return this.state = "NOT_STARTED";
  };

  SupportOrdersIteratorPaginatedCollection.prototype.hasNext = function() {
    if (this.isStateNotStarted()) {
      return true;
    } else if (this.isOrderCallQueued()) {
      return false;
    } else if (this.hasOrderCallFailed()) {
      return false;
    } else if (this.currentOrdersOffset < this.getNumberOfOrdersFetched()) {
      return true;
    } else if ((this.pagesRead * this.size) >= this.getTotalNumberOfGroupons()) {
      return false;
    }
    return true;
  };

  SupportOrdersIteratorPaginatedCollection.prototype.next = function(sucessCallback, errorCallback) {
    var _errorFilterCb, _sucessCb, _sucessFilterCb, options;
    if (this.hasNext()) {
      _sucessCb = (function(_this) {
        return function() {
          var offset;
          _this.state = "SUCCESS";
          offset = _this.currentOrdersOffset;
          _this.currentOrdersOffset = Math.min(_this.currentOrdersOffset + _this.size, _this.getNumberOfOrdersFetched());
          return sucessCallback(_this.ordersFilter.sortedOrders.slice(offset, offset + _this.size));
        };
      })(this);
      if (this.currentOrdersOffset < this.getNumberOfOrdersFetched()) {
        return _sucessCb();
      } else {
        options = {
          limit: 10,
          page: this.pagesRead
        };
        _errorFilterCb = (function(_this) {
          return function() {
            _this.state = "ERROR";
            return errorCallback();
          };
        })(this);
        _sucessFilterCb = (function(_this) {
          return function() {
            _this.pagesRead++;
            return _sucessCb();
          };
        })(this);
        this.state = "QUEUED";
        return this.ordersFilter.getOrders(options, _sucessFilterCb, _errorFilterCb);
      }
    }
  };

  SupportOrdersIteratorPaginatedCollection.prototype.isStateNotStarted = function() {
    return this.state === "NOT_STARTED";
  };

  SupportOrdersIteratorPaginatedCollection.prototype.isOrderCallQueued = function() {
    return this.state === "QUEUED";
  };

  SupportOrdersIteratorPaginatedCollection.prototype.hasOrderCallFailed = function() {
    return this.state === "ERROR";
  };

  SupportOrdersIteratorPaginatedCollection.prototype.getTotalNumberOfGroupons = function() {
    if (this.ordersFilter.pagination) {
      return this.ordersFilter.pagination.count;
    } else {
      return 0;
    }
  };

  SupportOrdersIteratorPaginatedCollection.prototype.getNumberOfOrdersFetched = function() {
    return this.ordersFilter.sortedOrders.length;
  };

  SupportOrdersIteratorPaginatedCollection.prototype.getNumberOfItemPerPage = function() {
    return this.size;
  };

  SupportOrdersIteratorPaginatedCollection.prototype.isOrdersInfoValid = function() {
    return !(this.isStateNotStarted() || (this.hasOrderCallFailed() && this.getNumberOfOrdersFetched() === 0));
  };

  return SupportOrdersIteratorPaginatedCollection;

})();

module.exports = SupportOrdersIteratorPaginatedCollection;



},{}],50:[function(require,module,exports){
var SupportAPIHelper, SupportHelpWizardController, SupportTaglineHelper;

SupportAPIHelper = require('./helpers/API');

SupportTaglineHelper = require('./helpers/Tagline');

SupportHelpWizardController = {
  intermediatePage: function() {
    activateIntermediatePage();
    return Groupon.Support.HelpWizardViewManager.renderIntermediateView();
  },
  initOrdersFetch: function() {
    activateHelpWizard();
    Backbone.history.navigate("#pick-order", {
      trigger: false
    });
    setTrackingInformation("customer_support#pick-order", window.location.href);
    return Groupon.Support.HelpWizardViewManager.renderOrders();
  },
  stepOne: function(order) {
    activateHelpWizard();
    Backbone.history.navigate("#pick-order", {
      trigger: false
    });
    setTrackingInformation("customer_support#pick-order", window.location.href);
    return Groupon.Support.HelpWizardViewManager.renderOrderDetails(order);
  },
  abruptStepTwoFlow: function() {
    setDefaultSettingsForAbruptStepTwoFlow();
    return this.stepTwo();
  },
  stepTwo: function() {
    activateHelpWizard();
    setFlowAttributes();
    Backbone.history.navigate('#select-issue', {
      trigger: false
    });
    setTrackingInformation("customer_support#select-issue", window.location.href);
    Groupon.Support.Tagline = SupportTaglineHelper.create();
    Groupon.Support.HelpWizardViewManager.renderDropDowns();
    return Groupon.Support.ContentModel.onUnloadStepOne();
  },
  renderUserSignIn: function(options) {
    activateHelpWizard();
    return Groupon.Support.HelpWizardViewManager.renderUserSignIn(options);
  },
  stepThree: function() {
    var stepThreeView;
    activateHelpWizard();
    setTrackingInformation("customer_support#contact-us", window.location.href);
    return stepThreeView = Groupon.Support.HelpWizardViewManager.renderContactChannels();
  },
  problemSolved: function() {
    activateHelpWizard();
    setTrackingInformation("customer_support#problem-solved", window.location.href);
    return Groupon.Support.HelpWizardViewManager.renderProblemSolved();
  },
  ticketSuccess: function() {
    activateHelpWizard();
    setTrackingInformation("customer_support#ticket-success", window.location.href);
    return Groupon.Support.HelpWizardViewManager.ticketSuccess();
  },
  chatSuccess: function() {
    activateHelpWizard();
    setTrackingInformation("customer_support#chat-success", window.location.href);
    return Groupon.Support.HelpWizardViewManager.chatSuccess();
  },
  changeCurrentOrder: function(order) {
    Groupon.Support.currentOrder = order;
    return Groupon.Support.ContentModel.init(order);
  }
};

window.setFlowAttributes = function() {
  if (notLandingFlow()) {
    return;
  }
  if (window.landingFlow === "my_account") {
    return Groupon.Support.ACCOUNT_RELATED = true;
  } else if (window.landingFlow === "my_order") {
    return Groupon.Support.ABOUT_AN_ORDER = true;
  }
};

window.notLandingFlow = function() {
  return !window.landingFlow || oneOfFlowVariablesSet();
};

window.oneOfFlowVariablesSet = function() {
  return Groupon.Support.ACCOUNT_RELATED || Groupon.Support.ABOUT_AN_ORDER || Groupon.Support.SOMETHING_ELSE || Groupon.Support.PRE_PURCHASE;
};

window.setDefaultSettingsForAbruptStepTwoFlow = function() {
  Groupon.Support.MAXINDEX = 2;
  SupportHelpWizardController.changeCurrentOrder(null);
  Groupon.Support.ORDER_NOT_LISTED = false;
  if (window.isLoggedIn) {
    return Groupon.Support.NOT_ORDER_RELATED = true;
  }
};

window.activateHelpWizard = function() {
  $("#intermediate-page-container").hide();
  $('#contact-us-body-content').show();
  $('#footer-content').show();
  return showLoading($('#help-wizard'));
};

window.activateIntermediatePage = function() {
  $("#intermediate-page-container").show();
  $('#contact-us-body-content').hide();
  return $('#footer-content').hide();
};

module.exports = SupportHelpWizardController;



},{"./helpers/API":51,"./helpers/Tagline":52}],51:[function(require,module,exports){
var SharedUser, SupportAPIHelper, SupportAjaxShimTemplate, async, callWasInterrupted;

async = require('../../../../core/frontend/vendor_modules/async');

SharedUser = require('../../../shared/frontend/helpers/user');

SupportAjaxShimTemplate = require('../../ajax_shim.html.mustache');

callWasInterrupted = function(status, errorMessage) {
  return status === 'abort' || (errorMessage == null) || (errorMessage != null ? errorMessage.length : void 0) === 0;
};

SupportAPIHelper = {
  httpErrorHandler: (function(_this) {
    return function(response, status, errorMessage) {
      if (callWasInterrupted(status, errorMessage)) {
        return;
      }
      flash('error', 'Sorry something went wrong');
      return $('#g-spinner').hide();
    };
  })(this),
  errorHandler: function(errorMessage) {
    return flash('error', errorMessage);
  },
  parallel: function(urls, datas, responseCallback, blockUI, timer, timeout, methods) {
    var callbacks, errorCb, requests, successCb;
    if (methods == null) {
      methods = [];
    }
    successCb = function(cb) {
      return (function(_this) {
        return function(response) {
          return cb(null, response);
        };
      })(this);
    };
    errorCb = function(cb) {
      return (function(_this) {
        return function(errorMessage) {
          return cb(null, null);
        };
      })(this);
    };
    requests = [];
    callbacks = [];
    _.each(urls, (function(_this) {
      return function(url, index) {
        return callbacks.push(function(cb) {
          var req;
          if (methods[index] != null) {
            req = _this.call(url, methods[index], datas[index], successCb(cb), errorCb(cb), blockUI, timer, timeout);
          } else {
            req = _this.get(url, datas[index], successCb(cb), errorCb(cb), blockUI, timer, timeout);
          }
          return requests.push(req);
        });
      };
    })(this));
    async.parallel(callbacks, (function(_this) {
      return function(err, results) {
        if (err != null) {
          return responseCallback(null);
        }
        return responseCallback(results);
      };
    })(this));
    return requests;
  },
  get: function(url, data, success, error, blockUI, timer, timeout) {
    var args;
    if (timer == null) {
      timer = null;
    }
    if (timeout == null) {
      timeout = 70000;
    }
    args = Array.prototype.slice.call(arguments);
    switch (args.length) {
      case 2:
        success = data;
        data = void 0;
        break;
      case 3:
        if (typeof args[1] === 'function') {
          error = success;
          success = data;
          data = void 0;
        }
    }
    return this.call(url, 'GET', data, success, error, blockUI, timer, timeout);
  },
  call: function(url, method, data, successHandler, customErrorHandler, blockUI, timer, timeout) {
    var ajaxShimTemplate, options, request;
    if (timer == null) {
      timer = null;
    }
    if (timeout == null) {
      timeout = 70000;
    }
    data || (data = {});
    switch (method) {
      case 'PUT':
        method = 'POST';
        data._method = 'PUT';
        break;
      case 'DELETE':
        method = 'POST';
        data._method = 'DELETE';
    }
    if (blockUI) {
      ajaxShimTemplate = SupportAjaxShimTemplate.render({});
      $('body').append(ajaxShimTemplate);
    }
    options = {
      url: url,
      type: method,
      dataType: 'json',
      headers: {},
      timeout: timeout,
      data: data,
      error: (function(_this) {
        return function(err, status, errorMessage) {
          if (timer != null) {
            stopTimer(timer);
          }
          if (blockUI) {
            $('.ajaxshim').remove();
          }
          if (customErrorHandler) {
            return customErrorHandler(errorMessage);
          } else {
            return _this.httpErrorHandler(err, status, errorMessage);
          }
        };
      })(this),
      success: (function(_this) {
        return function(response) {
          if (timer != null) {
            stopTimer(timer);
          }
          $('.ajaxshim').remove();
          if (!response || response.length === 0 || (response.error != null)) {
            if (customErrorHandler != null) {
              return customErrorHandler(response);
            } else {
              return _this.errorHandler(null);
            }
          } else {
            return successHandler(response);
          }
        };
      })(this)
    };
    SharedUser.setGrpnUsrHeader(options);
    if (timer != null) {
      startTimer(timer);
    }
    request = $.ajax(options);
    return request;
  }
};

module.exports = SupportAPIHelper;



},{"../../../../core/frontend/vendor_modules/async":2,"../../../shared/frontend/helpers/user":16,"../../ajax_shim.html.mustache":31}],52:[function(require,module,exports){
var SupportTaglineHelper;

SupportTaglineHelper = {
  create: function() {
    var memo, ref, tagLine;
    if ((ref = Groupon.Support.currentOrder) != null ? ref.tagLine : void 0) {
      if (Groupon.Support.ABOUT_AN_ORDER === true) {
        return Groupon.Support.currentOrder.tagLine + ",about_an_order";
      } else {
        return Groupon.Support.currentOrder.tagLine;
      }
    }
    tagLine = {};
    memo = "";
    if (typeof currentUser === "undefined" || currentUser === null) {
      tagLine.userState = "not_signed_in";
    }
    if (Groupon.Support.ORDER_NOT_LISTED === true) {
      tagLine.orderNotListed = "order_not_listed";
    }
    if (Groupon.Support.NOT_ORDER_RELATED === true) {
      tagLine.notOrderRelated = "not_order_related";
    }
    if (Groupon.Support.ACCOUNT_RELATED === true) {
      tagLine.accountRelated = "account_related";
    }
    if (Groupon.Support.PRE_PURCHASE === true) {
      tagLine.prePurchase = "making_a_purchase";
    }
    if (Groupon.Support.SOMETHING_ELSE === true) {
      tagLine.others = "something_else";
    }
    if (!_.isEmpty(tagLine)) {
      return _.reduce(tagLine, (function(_this) {
        return function(memo, tag) {
          return memo + "," + tag;
        };
      })(this));
    } else {
      return "";
    }
  }
};

module.exports = SupportTaglineHelper;



},{}],53:[function(require,module,exports){
var SupportErrorHelper;

SupportErrorHelper = {
  constructInbentaLoadErrorMessage: function() {
    var Error, errorMessage;
    Error = {
      ErrorType: "InbentaNotLoaded",
      Tagline: Groupon.Support.Tagline || {},
      SubCategory: Groupon.Support.ContentModel.getSubCategory() || {},
      Category: Groupon.Support.ContentModel.getCategory() || {}
    };
    return errorMessage = "Inbenta Content not loaded for : " + (JSON.stringify(Error));
  },
  constructFlexibleContactChannelMissingMessage: function() {
    var Error;
    return Error = {
      ErrorType: "FlexibleContactChannelMissing",
      Tagline: Groupon.Support.Tagline || {},
      SubCategory: Groupon.Support.ContentModel.getSubCategory() || {},
      Category: Groupon.Support.ContentModel.getCategory() || {}
    };
  }
};

module.exports = SupportErrorHelper;



},{}],54:[function(require,module,exports){
var SharedSpinnerView, SupportCMSModel, SupportFinePrintView, SupportFlashView, SupportInbentaModel, SupportUtilsHelper;

SupportFlashView = require('../views/flash_view');

SupportFinePrintView = require('../views/order_related/fine_print_view');

SupportCMSModel = require('../models/CMS');

SupportInbentaModel = require('../models/Inbenta');

SharedSpinnerView = require('../../../shared/frontend/views/spinner_view');

SupportUtilsHelper = {
  delay: function(ms, func) {
    return setTimeout(func, ms);
  },
  flash: function(type, content, sticky) {
    var view;
    if (sticky == null) {
      sticky = false;
    }
    view = new SupportFlashView({
      type: type,
      content: content,
      sticky: sticky
    });
    view.render();
    return $('#flash_container').html(view.$el);
  },
  highlight: function($element, callback, className) {
    if (className == null) {
      className = 'flash_highlight';
    }
    $element.addClass(className);
    return delay(Groupon.Support.DELAY_TIMES.flash, function() {
      $element.removeClass(className);
      if (callback) {
        return callback();
      }
    });
  },
  highlightText: function($element, callback) {
    $element.addClass('flash_text');
    return delay(Groupon.Support.DELAY_TIMES.flash, function() {
      $element.removeClass('flash_text');
      if (callback) {
        return callback();
      }
    });
  },
  openLocation: function(url) {
    return window.open(url);
  },
  isFileUploadSupported: function() {
    return window.FileReader != null;
  },
  showLoading: function(div, height) {
    var hash, spinner;
    if (height == null) {
      height = "250px";
    }
    if ($(".g-spinner", div).length === 0) {
      div.empty();
      spinner = new SharedSpinnerView();
      hash = {
        container: div,
        id: "g-spinner",
        height: height
      };
      return spinner.show(hash);
    }
  },
  openLinksInNewTab: function(div_links) {
    return div_links.attr("target", "_blank");
  },
  replaceNewLineWithBreak: function(text) {
    return text != null ? text.replace(/\n|\\x0a/gi, '<br />') : void 0;
  },
  renderFinePrint: function() {
    var finePrintView;
    finePrintView = new SupportFinePrintView();
    return finePrintView.render();
  },
  textOverflowEllipsis: function(length) {
    return function() {
      return function(text, render) {
        var content, delimitedContent;
        content = render(text);
        content = content.trim();
        if (content.length > length) {
          delimitedContent = content.substring(0, length - 3) + '...';
          return '<span title="' + content + '">' + delimitedContent + '</span>';
        } else {
          return content;
        }
      };
    };
  },
  addToTrackingHub: function(c, sc) {
    var data;
    data = {
      category: c,
      subcategory: sc
    };
    return TrackingHub.add("support-app-user-dropdown-change", {
      data: data
    });
  },
  activateieHacks: function() {
    ieISODateStringHack();
    return ieStringTrimHack();
  },
  ieISODateStringHack: function() {
    if (!Date.prototype.toISOString) {
      if (!Date.prototype.toJSON) {
        Date.prototype.toJSON = function(key) {
          var f;
          f = function(n) {};
          if (n < 10) {
            "0" + n;
          } else {
            n;
          }
          return this.getUTCFullYear() + "-" + f(this.getUTCMonth() + 1) + "-" + f(this.getUTCDate()) + "T" + f(this.getUTCHours()) + ":" + f(this.getUTCMinutes()) + ":" + f(this.getUTCSeconds()) + "Z";
        };
      }
      return Date.prototype.toISOString = Date.prototype.toJSON;
    }
  },
  ieStringTrimHack: function() {
    if (typeof String.prototype.trim !== 'function') {
      return String.prototype.trim = function() {
        return this.replace(/^\s+|\s+$/g, '');
      };
    }
  },
  isUserLogged: function() {
    if (typeof currentUser !== "undefined" && currentUser !== null) {
      return true;
    } else {
      return false;
    }
  },
  match: function(arg1, arg2) {
    var diff, split1, split2;
    split1 = arg1 != null ? arg1.split(";") : void 0;
    split2 = arg2 != null ? arg2.split(";") : void 0;
    diff = _.difference(split1, split2);
    return diff.length === 0;
  },
  addParameterToUrlConsideringTheHash: function(url, parameterName, parameterValue, atStart) {
    var cl, i, newQueryString, parameterParts, parameters, replaceDuplicates, sourceUrl, urlParts, urlhash;
    replaceDuplicates = true;
    if (url.indexOf("#") > 0) {
      cl = url.indexOf("#");
      urlhash = url.substring(url.indexOf("#"), url.length);
    } else {
      urlhash = "";
      cl = url.length;
    }
    sourceUrl = url.substring(0, cl);
    urlParts = sourceUrl.split("?");
    newQueryString = "";
    if (urlParts.length > 1) {
      parameters = urlParts[1].split("&");
      i = 0;
      while (i < parameters.length) {
        parameterParts = parameters[i].split("=");
        if (!(replaceDuplicates && parameterParts[0] === parameterName)) {
          if (newQueryString === "") {
            newQueryString = "?";
          } else {
            newQueryString += "&";
          }
          newQueryString += parameterParts[0] + "=" + (parameterParts[1] ? parameterParts[1] : "");
        }
        i++;
      }
    }
    if (newQueryString === "") {
      newQueryString = "?";
    }
    if (atStart) {
      newQueryString = "?" + parameterName + "=" + parameterValue + (newQueryString.length > 1 ? "&" + newQueryString.substring(1) : "");
    } else {
      if (newQueryString !== "" && newQueryString !== "?") {
        newQueryString += "&";
      }
      newQueryString += parameterName + "=" + (parameterValue ? parameterValue : "");
    }
    return urlParts[0] + newQueryString + urlhash;
  },
  getURLParameter: function(name) {
    return decodeURI((RegExp(name + "=" + "(.+?)(&|$)").exec(location.search) || [null, null])[1]);
  },
  isCurrentOrderMarketRateDeal: function() {
    return this.isCurrentOrderOfDealType("GETAWAYS_MARKET_RATE");
  },
  isCurrentOrderGetawaysTonightDeal: function() {
    return this.isCurrentOrderOfDealType("GETAWAYS_TONIGHT");
  },
  isCurrentOrderGetawaysBookingDeal: function() {
    return this.isCurrentOrderOfDealType("GETAWAYS_BOOKING");
  },
  isCurrentOrderGoodsDeal: function() {
    return this.isCurrentOrderGoodsShippingDeal() || this.isCurrentOrderGoodsVoucherDeal();
  },
  isCurrentOrderGoodsShippingDeal: function() {
    return this.isCurrentOrderOfDealType("GOODS_SHIPPING");
  },
  isCurrentOrderGoodsVoucherDeal: function() {
    return this.isCurrentOrderOfDealType("GOODS_VOUCHER");
  },
  isCurrentOrderLiveDeal: function() {
    return this.isCurrentOrderOfDealType("LIVE");
  },
  isCurrentOrderLocalDeal: function() {
    return this.isCurrentOrderOfDealType("LOCAL");
  },
  isCurrentOrderOfDealType: function(deal_type) {
    var ref;
    return ((ref = Groupon.Support.currentOrder) != null ? ref.DEAL_TYPE : void 0) === deal_type;
  },
  isCurrentOrderEditable: function() {
    var ref;
    return ((ref = Groupon.Support.currentOrder) != null ? ref.editable : void 0) === true;
  },
  isOrderPurchasedWithinHours: function(specifiedHours) {
    var ref;
    return ((ref = Groupon.Support.currentOrder) != null ? ref.hoursAfterPurchase : void 0) < specifiedHours;
  },
  isCurrentOrderGetawaysDeal: function() {
    return isCurrentOrderMarketRateDeal() || isCurrentOrderGetawaysTonightDeal() || isCurrentOrderGetawaysBookingDeal();
  },
  checkIfCategoryIsAboutEditingOrCancelling: function() {
    return checkIfCategoryIdMatches("editing_or_canceling_an_order");
  },
  checkIfCategoryIdMatches: function(categoryId) {
    var ref;
    return ((ref = Groupon.Support.ContentModel.getCategory()) != null ? ref.id : void 0) === categoryId;
  },
  getCurrentUserFullName: function() {
    if (typeof currentUser !== "undefined" && currentUser !== null) {
      return (($.trim(currentUser.firstName)) + " " + ($.trim(currentUser.lastName))).trim();
    }
  },
  setTrackingInformation: function(type, url) {
    TrackingHub.page.metadata.type = type;
    return OptimizeSuite.treatAsNewPage(url);
  },
  getMillisecondsOfUTCDateFromISOStringDate: function(ISOStringDate) {
    var base;
    base = 10;
    return Date.UTC(parseInt(ISOStringDate.substring(0, 4), base), parseInt(ISOStringDate.substring(5, 7), base) - 1, parseInt(ISOStringDate.substring(8, 10), base), parseInt(ISOStringDate.substring(11, 13), base), parseInt(ISOStringDate.substring(14, 16), base));
  },
  redirectToFaqHack: function() {
    var hash;
    hash = window.location.hash;
    if (hash.indexOf("#faqs:") > -1) {
      return window.location.assign("/faq" + hash);
    }
  },
  hideFloatingBoldChat: function() {
    var floatingChatElement;
    floatingChatElement = $('.bcFloat');
    if ((floatingChatElement != null ? floatingChatElement.length : void 0) > 0) {
      floatingChatElement.hide();
      return floatingChatElement.children().hide();
    }
  },
  showFloatingBoldChat: function() {
    var floatingChatElement;
    floatingChatElement = $('.bcFloat');
    if ((floatingChatElement != null ? floatingChatElement.length : void 0) > 0) {
      floatingChatElement.show();
      return floatingChatElement.children().show();
    }
  },
  getDealMerchantName: function() {
    var ref, ref1, reservationSource;
    if (isCurrentOrderMarketRateDeal() || isCurrentOrderGetawaysTonightDeal() || (isCurrentOrderGetawaysBookingDeal() && isIntl())) {
      reservationSource = this.getReservationSource(Groupon.Support.currentOrder);
      return reservationSource != null ? reservationSource.hotelName : void 0;
    } else {
      return (ref = Groupon.Support.currentOrder) != null ? (ref1 = ref.merchant) != null ? ref1.name : void 0 : void 0;
    }
  },
  isStaticLiveChat: function(mode) {
    return mode === 'static';
  },
  isBothLiveChats: function(mode) {
    return mode === 'both';
  },
  isFloatingLiveChat: function(mode) {
    return mode === 'floating';
  },
  getOrderInfoForBH: function(order) {
    var hash, ref;
    hash = {
      id: order != null ? order.id : void 0,
      country: window.country.name,
      dealId: order != null ? (ref = order.deal) != null ? ref.id : void 0 : void 0,
      channel: order != null ? order.DEAL_TYPE : void 0
    };
    if (window.showRedesign()) {
      hash.showActionButtonAsLinks = true;
    }
    return hash;
  },
  showRedesign: function() {
    var ref;
    return Groupon.Support.FeatureFlagModel.isRedesignOrdersUSEnabled() || window.evaluate((ref = window.experiments) != null ? ref.showVerticalPageFlow : void 0);
  },
  priorityViewsEnabled: function() {
    var ref, ref1;
    return ((ref = Groupon.Support.ContentModel) != null ? ref.isRefundEligible : void 0) || ((ref1 = Groupon.Support.ContentModel) != null ? ref1.escalateToMerchant : void 0);
  },
  liveChatVisible: function(liveChatDOMElem) {
    var clearImgurl;
    clearImgurl = /images.boldchat.com\/images\/clear/;
    return (liveChatDOMElem != null) && !(_.isEmpty(liveChatDOMElem.attr('src'))) && !clearImgurl.test(liveChatDOMElem.attr('src'));
  },
  setLiveChatDisplayCallBack: function(liveChatDOMElem, liveChatDisplayCallback) {
    if (((liveChatDOMElem != null ? liveChatDOMElem[0] : void 0) != null) && !window.liveChatCallBackSet) {
      window.liveChatCallBackSet = true;
      return liveChatDOMElem.on('load', function() {
        return liveChatDisplayCallback();
      });
    } else if ((liveChatDOMElem != null ? liveChatDOMElem[0] : void 0) == null) {
      return window.liveChatCallBackSet = false;
    }
  },
  liveChatLinkVisible: function() {
    var liveChatImageElem;
    liveChatImageElem = $("#live-chat-link-container div a div");
    return !_.isEmpty(liveChatImageElem.text());
  },
  getReservationSource: function(currentOrder) {
    var ref;
    return (currentOrder != null ? currentOrder.reservation : void 0) || (currentOrder != null ? (ref = currentOrder.travelBookingInfo) != null ? ref.reservation : void 0 : void 0);
  },
  findGrouponQuantity: function(groupons) {
    var quantity;
    quantity = 0;
    if (groupons != null) {
      _.each(groupons, function(groupon) {
        if (groupon.availability) {
          if (groupon.availability.toLowerCase() !== 'refunded') {
            return quantity++;
          }
        }
      });
    }
    return quantity;
  },
  shouldShowOptimizedChannel: function() {
    return evaluate(typeof experiments !== "undefined" && experiments !== null ? experiments.showOptimizedContactChannel : void 0) && !window.priorityViewsEnabled();
  },
  shouldShowFlexibleChannel: function() {
    return evaluate(typeof experiments !== "undefined" && experiments !== null ? experiments.showFlexibleContactChannels : void 0) && !window.priorityViewsEnabled();
  },
  hideFooterLinks: function() {
    return window.hideDOMElems($("#footer_dynamic_links"));
  },
  showFooterLinks: function() {
    return window.showDOMElems($("#footer_dynamic_links"));
  }
};

module.exports = SupportUtilsHelper;



},{"../../../shared/frontend/views/spinner_view":24,"../models/CMS":55,"../models/Inbenta":56,"../views/flash_view":152,"../views/order_related/fine_print_view":160}],55:[function(require,module,exports){
var SupportCMSModel, SupportDropDownCombinationsModel, SupportDropDownModel;

SupportDropDownModel = require('./dropdowns');

SupportDropDownCombinationsModel = require('./dropdown_combinations');

SupportCMSModel = (function() {
  function SupportCMSModel() {
    this.init(null);
    this.dropDowns = new SupportDropDownModel();
    this.dropDownCombinations = new SupportDropDownCombinationsModel();
  }

  SupportCMSModel.prototype.init = function(currentOrder) {
    this.isCurrentOrderSelected = currentOrder ? true : false;
    window.Groupon.Support.CMS = {
      Category: null,
      SubCategory: null,
      SearchInputIssue: null,
      Content: null
    };
    this.flexibleStepThree = null;
    this.displayStatus = null;
    this.displayNotes = null;
    this.externalDealNotes = null;
    this.isRefundEligible = false;
    return this.escalateToMerchant = false;
  };

  SupportCMSModel.prototype.getContentObject = function() {
    return window.Groupon.Support.CMS;
  };

  SupportCMSModel.prototype.getCategory = function() {
    return Groupon.Support.CMS.Category;
  };

  SupportCMSModel.prototype.getSubCategory = function() {
    return Groupon.Support.CMS.SubCategory;
  };

  SupportCMSModel.prototype.getSearchInputIssue = function() {
    return Groupon.Support.CMS.SearchInputIssue;
  };

  SupportCMSModel.prototype.getContent = function() {
    return Groupon.Support.CMS.Content;
  };

  SupportCMSModel.prototype.getContentId = function() {
    var ref;
    return (ref = Groupon.Support.CMS.Content) != null ? ref.id : void 0;
  };

  SupportCMSModel.prototype.setSubCategory = function(subCategory) {
    return Groupon.Support.CMS.SubCategory = subCategory;
  };

  SupportCMSModel.prototype.setCategory = function(category) {
    return Groupon.Support.CMS.Category = category;
  };

  SupportCMSModel.prototype.setContent = function(content) {
    return Groupon.Support.CMS.Content = content;
  };

  SupportCMSModel.prototype.setSearchInputIssue = function(searchInputIssue) {
    return Groupon.Support.CMS.SearchInputIssue = searchInputIssue;
  };

  SupportCMSModel.prototype.onUnloadStepOne = function() {};

  SupportCMSModel.prototype.onInitStepTwo = function() {};

  SupportCMSModel.prototype.onInitStepThree = function() {};

  SupportCMSModel.prototype.extendParams = function(params) {
    return _.extend(Groupon.Support.CMS, params);
  };

  return SupportCMSModel;

})();

module.exports = SupportCMSModel;



},{"./dropdown_combinations":60,"./dropdowns":61}],56:[function(require,module,exports){
var SupportDropDownCombinationsModel, SupportDropDownModel, SupportInbentaModel;

SupportDropDownModel = require('./dropdowns');

SupportDropDownCombinationsModel = require('./dropdown_combinations');

SupportInbentaModel = (function() {
  function SupportInbentaModel() {
    this.init(null);
    this.dropDowns = new SupportDropDownModel();
    this.dropDownCombinations = new SupportDropDownCombinationsModel();
  }

  SupportInbentaModel.prototype.init = function(currentOrder) {
    this.isCurrentOrderSelected = currentOrder ? true : false;
    window.Groupon.Support.Inbenta = {};
    this.flexibleStepThree = null;
    this.displayStatus = null;
    this.displayNotes = null;
    return this.externalDealNotes = null;
  };

  SupportInbentaModel.prototype.getCategory = function() {
    return Groupon.Support.Inbenta.Category;
  };

  SupportInbentaModel.prototype.getSubCategory = function() {
    return Groupon.Support.Inbenta.SubCategory;
  };

  SupportInbentaModel.prototype.getSearchInputIssue = function() {
    return Groupon.Support.Inbenta.searchInputIssue;
  };

  SupportInbentaModel.prototype.getContentId = function() {
    return Groupon.Support.Inbenta.ContentId;
  };

  SupportInbentaModel.prototype.setSubCategory = function(subCategory) {
    return Groupon.Support.Inbenta.SubCategory = subCategory;
  };

  SupportInbentaModel.prototype.setCategory = function(category) {
    return Groupon.Support.Inbenta.Category = category;
  };

  SupportInbentaModel.prototype.setContentId = function(contentId) {
    return Groupon.Support.Inbenta.ContentId = contentId;
  };

  SupportInbentaModel.prototype.setSearchInputIssue = function(searchInputIssue) {
    return Groupon.Support.Inbenta.searchInputIssue = searchInputIssue;
  };

  SupportInbentaModel.prototype.onUnloadStepOne = function() {
    if (Groupon.Support.FeatureFlagModel.isSearchBasedDropDownsEnabled()) {
      return $.event.trigger('inbenta-help-wizard-step1-completed');
    }
  };

  SupportInbentaModel.prototype.onInitStepTwo = function() {
    if (Groupon.Support.FeatureFlagModel.isSearchBasedDropDownsEnabled()) {
      return $.event.trigger('initiate-inbenta-help-wizard-step2');
    }
  };

  SupportInbentaModel.prototype.onInitStepThree = function() {
    if (Groupon.Support.FeatureFlagModel.isSearchBasedDropDownsEnabled()) {
      return $.event.trigger('initiate-inbenta-help-wizard-step3');
    } else if (window.shouldShowOptimizedChannel() || window.shouldShowFlexibleChannel()) {
      return $.event.trigger('inbenta-hash-change', ['#contact-us', '#contact-us']);
    }
  };

  SupportInbentaModel.prototype.extendParams = function(params) {
    return _.extend(Groupon.Support.Inbenta, params);
  };

  return SupportInbentaModel;

})();

module.exports = SupportInbentaModel;



},{"./dropdown_combinations":60,"./dropdowns":61}],57:[function(require,module,exports){
var Backbone, SupportBaseTicketModel,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Backbone = require('backbone');

SupportBaseTicketModel = (function(superClass) {
  extend(SupportBaseTicketModel, superClass);

  function SupportBaseTicketModel() {
    return SupportBaseTicketModel.__super__.constructor.apply(this, arguments);
  }

  SupportBaseTicketModel.prototype.initialize = function() {
    return this.setReasonText();
  };

  SupportBaseTicketModel.prototype.setReasonText = function() {
    var SubCategory, category;
    category = Groupon.Support.ContentModel.getCategory();
    SubCategory = Groupon.Support.ContentModel.getSubCategory();
    if ((category != null) && (SubCategory != null)) {
      this.reasonId = SubCategory.id;
      this.reasonText = SubCategory.text;
      this.reasonGroup = SubCategory.group;
      this.parentCategoryId = category.id;
      this.parentCategoryText = category.text;
      return this.isDummyCategory = false;
    } else {
      this.reasonId = "direct_email_ticket_subcategory";
      this.reasonText = I18n.translate('js.modules.support.default_reason');
      this.parentCategoryId = "direct_email_ticket";
      this.parentCategoryText = I18n.translate('js.modules.support.default_parent_category');
      return this.isDummyCategory = true;
    }
  };

  SupportBaseTicketModel.prototype.populateOrderListInfo = function(emailBasicData) {
    if ((window.currentUser != null) && Groupon.Support.currentOrdersFilter.isOrdersInfoValid()) {
      return emailBasicData.orderListInfo = {
        hasOrders: Groupon.Support.OrdersCollection.hasOrders(),
        hasSingleOrder: Groupon.Support.OrdersCollection.getNumberOfOrdersFetched() === 1
      };
    }
  };

  SupportBaseTicketModel.prototype.getBasicTicketData = function() {
    var currentUserFullName, emailBasicData;
    currentUserFullName = window.getCurrentUserFullName();
    emailBasicData = {
      support_id: "",
      reason: this.reasonId,
      reason_text: this.reasonText,
      reason_group: this.reasonGroup,
      parent_category: this.parentCategoryId,
      parent_category_text: this.parentCategoryText,
      currentOrder: Groupon.Support.currentOrder,
      description: "",
      escalate_to_merchant: Groupon.Support.ContentModel.escalateToMerchant,
      is_refund_eligible: Groupon.Support.ContentModel.isRefundEligible,
      user_name: !_.isEmpty(currentUserFullName) ? currentUserFullName : void 0,
      user_email: typeof currentUser !== "undefined" && currentUser !== null ? currentUser.email : void 0
    };
    this.populateOrderListInfo(emailBasicData);
    return emailBasicData;
  };

  return SupportBaseTicketModel;

})(Backbone.Model);

module.exports = SupportBaseTicketModel;



},{"backbone":245}],58:[function(require,module,exports){
var SupportBaseTicketModel, SupportCallBackPhoneNumberModel, SupportUtilsHelper,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportBaseTicketModel = require('./base_ticket_model');

SupportUtilsHelper = require('../helpers/utils');

SupportCallBackPhoneNumberModel = (function(superClass) {
  extend(SupportCallBackPhoneNumberModel, superClass);

  function SupportCallBackPhoneNumberModel() {
    return SupportCallBackPhoneNumberModel.__super__.constructor.apply(this, arguments);
  }

  SupportCallBackPhoneNumberModel.prototype.initialize = function() {
    var ref;
    SupportBaseTicketModel.prototype.initialize.apply(this, arguments);
    this.getDefaultPhoneForm();
    this.userName = SupportUtilsHelper.getCurrentUserFullName() || null;
    this.userEmail = ((ref = window.currentUser) != null ? ref.email : void 0) || null;
    return this.phoneNumber = null;
  };

  SupportCallBackPhoneNumberModel.prototype.toJSON = function() {
    return {
      isLoggedIn: window.currentUser != null
    };
  };

  SupportCallBackPhoneNumberModel.prototype.getDefaultPhoneForm = function() {
    return this.phoneForm = {
      method_of_contact: "callMeBackOption",
      objects: [
        {
          type: "user_name",
          label: I18n.translate('js.modules.support.call_me_back_user_label'),
          required: this.getRequired(),
          additional_attributes: {
            maximum_number_of_characters_or_digits: ""
          },
          value: this.userName
        }, {
          type: "email_address",
          label: I18n.translate('js.modules.support.call_me_back_email_label'),
          required: this.getRequired(),
          value: this.userEmail
        }, {
          type: "phone_number",
          label: I18n.translate('js.modules.support.call_me_back_your_number'),
          required: "true"
        }
      ]
    };
  };

  SupportCallBackPhoneNumberModel.prototype.getRequired = function() {
    if (window.currentUser != null) {
      return false;
    } else {
      return true;
    }
  };

  return SupportCallBackPhoneNumberModel;

})(SupportBaseTicketModel);

module.exports = SupportCallBackPhoneNumberModel;



},{"../helpers/utils":54,"./base_ticket_model":57}],59:[function(require,module,exports){
var Mustache, SupportCurrentOrderModel, SupportMarketRateImagePresenterPresentation, SupportPresenterFactoryPresentation, SupportUtilsHelper;

SupportMarketRateImagePresenterPresentation = require('../presenters/market_rate_image_presenter');

SupportPresenterFactoryPresentation = require('../presenters/presenter_factory');

Mustache = require('../../../../core/frontend/vendor_modules/mustache-0.7.2');

SupportUtilsHelper = require('../helpers/utils');

SupportCurrentOrderModel = (function() {
  function SupportCurrentOrderModel() {
    this.currentOrder = Groupon.Support.currentOrder;
    this.groupons = this.currentOrder.groupons;
    this.voucher = _.first(this.groupons || []);
  }

  SupportCurrentOrderModel.prototype.getDealFinePrint = function() {
    var ref;
    return this.currentOrder.finePrintText || ((ref = this.currentOrder.deal) != null ? ref.finePrint : void 0) || "";
  };

  SupportCurrentOrderModel.prototype.getV1ImageUrl = function() {
    var ref, ref1, ref2;
    return ((ref = this.currentOrder.deal) != null ? ref.sidebarImageUrl : void 0) || ((ref1 = this.currentOrder.deal) != null ? ref1.mediumImageUrl : void 0) || ((ref2 = this.currentOrder.deal) != null ? ref2.smallImageUrl : void 0);
  };

  SupportCurrentOrderModel.prototype.toDealHash = function() {
    var dealHash;
    dealHash = (function() {
      switch (this.currentOrder.DEAL_TYPE) {
        case 'GETAWAYS_TONIGHT':
        case 'GETAWAYS_MARKET_RATE':
          return this.getawaysMarketRateDealHash();
        case 'GETAWAYS_BOOKING':
          if (isIntl()) {
            return this.getawaysBookingDealHash();
          } else {
            return this.v1DealHash();
          }
          break;
        default:
          return this.v1DealHash();
      }
    }).call(this);
    return dealHash;
  };

  SupportCurrentOrderModel.prototype.v1DealHash = function() {
    var dealHash, ref, ref1, ref2;
    return dealHash = {
      dealId: (ref = this.currentOrder.deal) != null ? ref.id : void 0,
      merchant: (ref1 = this.currentOrder.merchant) != null ? ref1.name : void 0,
      title: (ref2 = this.currentOrder.deal) != null ? ref2.title : void 0,
      v1Image: this.getV1ImageUrl(),
      finePrint: this.getDealFinePrint()
    };
  };

  SupportCurrentOrderModel.prototype.getawaysBookingDealHash = function() {
    var dealHash, ref, ref1, ref2, reservationSource;
    reservationSource = SupportUtilsHelper.getReservationSource(this.currentOrder);
    return dealHash = {
      merchant: (reservationSource != null ? reservationSource.hotelName : void 0) || ((ref = this.currentOrder.merchant) != null ? ref.name : void 0),
      title: (reservationSource != null ? reservationSource.roomNameHtml : void 0) || ((ref1 = this.currentOrder.deal) != null ? ref1.title : void 0),
      v1Image: this.getV1ImageUrl(),
      dealId: (ref2 = this.currentOrder.deal) != null ? ref2.id : void 0,
      finePrint: this.getDealFinePrint()
    };
  };

  SupportCurrentOrderModel.prototype.getawaysMarketRateDealHash = function() {
    var dealHash, reservationSource;
    reservationSource = SupportUtilsHelper.getReservationSource(this.currentOrder);
    dealHash = {
      merchant: reservationSource != null ? reservationSource.hotelName : void 0,
      title: reservationSource != null ? reservationSource.roomNameHtml : void 0,
      finePrint: this.getDealFinePrint()
    };
    if (this.currentOrder.DEAL_TYPE === 'GETAWAYS_MARKET_RATE') {
      reservationSource = SupportUtilsHelper.getReservationSource(this.currentOrder);
      dealHash.imageUrl = this.currentOrder.imageUrl || (new SupportMarketRateImagePresenterPresentation).present(reservationSource != null ? reservationSource.images : void 0);
    } else {
      dealHash.imageUrl = this.currentOrder.imageUrl;
    }
    return dealHash;
  };

  SupportCurrentOrderModel.prototype.getOrderQuantity = function() {
    var quantity;
    quantity = this.currentOrder.quantity;
    if (quantity == null) {
      quantity = SupportUtilsHelper.findGrouponQuantity(this.groupons);
    }
    return quantity;
  };

  SupportCurrentOrderModel.prototype.buildOrderSummaryParams = function() {
    var orderSummaryParams, statusNotesHash;
    statusNotesHash = this.getDealStatusAndNotes();
    orderSummaryParams = {
      qty: this.getOrderQuantity(),
      shouldShowDeliveryMsg: this.currentOrder.shouldShowDeliveryMsg,
      purchasedAt: this.getpurchasedAt(),
      maxDeliveryDays: window.maxDeliveryDays[window.country.name],
      status: Mustache.to_html(statusNotesHash.status, this.statusParams(statusNotesHash.status)),
      notes: (statusNotesHash.notes != null) && statusNotesHash.notes.length !== 0 ? Mustache.to_html(statusNotesHash.notes, this.notesParams(statusNotesHash.notes)) : void 0,
      deliveryRange: this.getEstimatedDeliveryRange(),
      giftInfo: this.getGiftParams()
    };
    _.extend(orderSummaryParams, window.getOrderInfoForBH(this.currentOrder));
    switch (this.currentOrder.DEAL_TYPE) {
      case 'GETAWAYS_TONIGHT':
      case 'GETAWAYS_MARKET_RATE':
      case 'GETAWAYS_BOOKING':
        _.extend(orderSummaryParams, this.getReseravationParams());
    }
    return orderSummaryParams;
  };

  SupportCurrentOrderModel.prototype.getpurchasedAt = function() {
    return this.currentOrder.purchasedAtshortDatetimeStr;
  };

  SupportCurrentOrderModel.prototype.getEstimatedDeliveryRange = function() {
    var deliveryRange, ref, shipmentDetails;
    if (this.canShowEstimatedDelivery()) {
      if (this.currentOrder.shipmentDetails) {
        shipmentDetails = this.currentOrder.shipmentDetails;
        if (shipmentDetails.deliveredDate || shipmentDetails.outFordeliveryDate || shipmentDetails.shippedDate) {
          return null;
        } else {
          deliveryRange = shipmentDetails.shippingSoonRange || shipmentDetails.shippingSoonRangePlusTwoDays || shipmentDetails.estimatedDeliveryDescription;
          if (deliveryRange) {
            return deliveryRange;
          }
        }
      }
      return (ref = this.currentOrder.deal) != null ? ref.deliveryRange : void 0;
    } else {
      return null;
    }
  };

  SupportCurrentOrderModel.prototype.canShowEstimatedDelivery = function() {
    var ref;
    return (ref = this.currentOrder.STATE) !== 'FAILED' && ref !== 'REFUNDED';
  };

  SupportCurrentOrderModel.prototype.getReseravationParams = function() {
    var reservationInformation, reservationSource;
    reservationInformation = {};
    reservationSource = SupportUtilsHelper.getReservationSource(this.currentOrder);
    if (reservationSource != null ? reservationSource.formattedCheckInDate : void 0) {
      reservationInformation.checkInDate = reservationSource != null ? reservationSource.formattedCheckInDate : void 0;
    }
    if (reservationSource != null ? reservationSource.formattedCheckOutDate : void 0) {
      reservationInformation.checkOutDate = reservationSource != null ? reservationSource.formattedCheckOutDate : void 0;
    }
    return reservationInformation;
  };

  SupportCurrentOrderModel.prototype.notesParams = function(notes) {
    var notesParams;
    notesParams = {};
    if (notes != null ? notes.match("editable_deadline") : void 0) {
      notesParams.editable_deadline = this.currentOrder.editableUntillongDateTimeStr;
    }
    if (notes != null ? notes.match("expired_date") : void 0) {
      notesParams.expiration_date = this.voucher.expiresAtFormattedStr;
    }
    if (notes != null ? notes.match("merchant_name") : void 0) {
      notesParams.merchant_name = this.currentOrder.merchant.name;
    }
    if (notes != null ? notes.match("isEditableUntil") : void 0) {
      notesParams.isEditableUntil = this.currentOrder.isEditableUntil;
    }
    if (notes != null ? notes.match("number_of_business_days_ago") : void 0) {
      notesParams.number_of_business_days_ago = this.currentOrder.businessDaysAfterPurchase;
    }
    return this.setShippingNotesParams(notes, notesParams);
  };

  SupportCurrentOrderModel.prototype.setShippingNotesParams = function(notes, notesParams) {
    var ref, shipmentDetails;
    shipmentDetails = this.currentOrder.shipmentDetails;
    if (shipmentDetails) {
      if (notes != null ? notes.match("shipped_date") : void 0) {
        notesParams.shipped_date = shipmentDetails.shippedDate;
      }
      if (notes != null ? notes.match("out_for_delivery_date") : void 0) {
        notesParams.out_for_delivery_date = shipmentDetails.outFordeliveryDate;
      }
      if (notes != null ? notes.match("delivered_date") : void 0) {
        notesParams.delivered_date = shipmentDetails.deliveredDate;
      }
      if (notes != null ? notes.match("tracking_number") : void 0) {
        notesParams.tracking_number = shipmentDetails.trackingNumber;
      }
      if (notes != null ? notes.match("carrier_name") : void 0) {
        notesParams.carrier_name = (ref = shipmentDetails.carrierName) != null ? ref.toUpperCase() : void 0;
      }
      this.setShippingSoonMsg(notes, notesParams);
    }
    return notesParams;
  };

  SupportCurrentOrderModel.prototype.setShippingSoonMsg = function(notes, notesParams) {
    var ref, ref1, shipmentDetails;
    notesParams.shipping_soon_msg = ((ref = this.currentOrder.deal) != null ? ref.deliveryRange : void 0) || "";
    notesParams.shipping_soon_msg_plus_two_business_days = ((ref1 = this.currentOrder.deal) != null ? ref1.deliveryRange : void 0) | "";
    shipmentDetails = this.currentOrder.shipmentDetails;
    if (shipmentDetails) {
      if (notes != null ? notes.match("shipping_soon_msg") : void 0) {
        if (shipmentDetails.shippingSoonRange != null) {
          notesParams.shipping_soon_msg = "Your order has been prepared for shipment and will be picked up by the carrier by " + shipmentDetails.shippingSoonRange + ".";
        } else if (shipmentDetails.estimatedDeliveryDescription != null) {
          notesParams.shipping_soon_msg = shipmentDetails.estimatedDeliveryDescription;
        }
      }
      if (notes != null ? notes.match("shipping_soon_msg_plus_two_business_days") : void 0) {
        if (shipmentDetails.shippingSoonRangePlusTwoDays != null) {
          return notesParams.shipping_soon_msg_plus_two_business_days = "Your order has been prepared for shipment and will be picked up by the carrier by " + shipmentDetails.shippingSoonRangePlusTwoDays + ".";
        } else if (shipmentDetails.estimatedDeliveryDescription != null) {
          return notesParams.shipping_soon_msg_plus_two_business_days = shipmentDetails.estimatedDeliveryDescription;
        }
      }
    }
  };

  SupportCurrentOrderModel.prototype.statusParams = function(status) {
    var statusParams;
    statusParams = {};
    if (status != null ? status.match("redeemed_date") : void 0) {
      statusParams.redeemed_date = this.voucher.merchantRedeemedAtshortDatetimeStr || this.voucher.customerRedeemedAtshortDatetimeStr;
    }
    if (status != null ? status.match("expiration_date") : void 0) {
      statusParams.expiration_date = this.voucher.expiresAtFormattedStr;
    }
    if (status != null ? status.match("editable_deadline") : void 0) {
      statusParams.editable_deadline = this.currentOrder.editableUntilshortDateTimeStr;
    }
    return statusParams;
  };

  SupportCurrentOrderModel.prototype.getDealStatusAndNotes = function() {
    var displayNotes, displayStatus, presenter;
    displayStatus = Groupon.Support.ContentModel.displayStatus;
    displayNotes = Groupon.Support.ContentModel.displayNotes;
    if (checkIfIsUSByCountry(country.name)) {
      presenter = SupportPresenterFactoryPresentation.prototype.makePresenter(this.currentOrder);
      return {
        status: presenter.getStatus(),
        notes: presenter.getNotes()
      };
    } else if (displayStatus || displayNotes) {
      return {
        status: displayStatus,
        notes: displayNotes
      };
    } else {
      return {
        status: Groupon.Support.currentOrder.STATE
      };
    }
  };

  SupportCurrentOrderModel.prototype.getGiftParams = function(order, I18n) {
    var hash;
    if (this.currentOrder.isGift && this.currentOrder.giftInfo) {
      hash = {
        isSentGift: this.currentOrder.giftInfo.isSentGift,
        isReceivedGift: this.currentOrder.giftInfo.isReceivedGift,
        giftRecipientName: this.currentOrder.giftInfo.giftRecipientName,
        giftFromName: this.currentOrder.giftInfo.giftFromName,
        giftRecipientEmail: this.currentOrder.giftInfo.giftRecipientEmail,
        isGiftClaimed: this.currentOrder.isGiftClaimed,
        printedAt: this.currentOrder.giftInfo.printedAtshortDatetimeStr
      };
      switch (this.currentOrder.giftInfo.giftDeliveryMethod) {
        case 'email':
          hash.isEGift = true;
          break;
        default:
          hash.isPrintedGift = true;
      }
      return hash;
    }
  };

  return SupportCurrentOrderModel;

})();

module.exports = SupportCurrentOrderModel;



},{"../../../../core/frontend/vendor_modules/mustache-0.7.2":6,"../helpers/utils":54,"../presenters/market_rate_image_presenter":95,"../presenters/presenter_factory":98}],60:[function(require,module,exports){
var Backbone, SupportDropDownCombinationsModel,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Backbone = require('backbone');

SupportDropDownCombinationsModel = (function(superClass) {
  extend(SupportDropDownCombinationsModel, superClass);

  function SupportDropDownCombinationsModel() {
    return SupportDropDownCombinationsModel.__super__.constructor.apply(this, arguments);
  }

  SupportDropDownCombinationsModel.prototype.initialize = function() {
    return this.url = window.SUPPORTBASEURL + "/fetch?key=dropdown_combinations_for_flex_step_three&type=dropdown_combinations_for_flex_step_three";
  };

  return SupportDropDownCombinationsModel;

})(Backbone.Model);

module.exports = SupportDropDownCombinationsModel;



},{"backbone":245}],61:[function(require,module,exports){
var Backbone, SupportDropDownModel,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Backbone = require('backbone');

SupportDropDownModel = (function(superClass) {
  extend(SupportDropDownModel, superClass);

  function SupportDropDownModel() {
    return SupportDropDownModel.__super__.constructor.apply(this, arguments);
  }

  SupportDropDownModel.prototype.initialize = function() {
    return this.url = window.SUPPORTBASEURL + "/fetch?key=dropdowns&type=dropdowns&should_display_cms_content=" + experiments.shouldDisplayCMSContentForUS;
  };

  return SupportDropDownModel;

})(Backbone.Model);

module.exports = SupportDropDownModel;



},{"backbone":245}],62:[function(require,module,exports){
var SupportBaseTicketModel, SupportEmailFormModel,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportBaseTicketModel = require('./base_ticket_model');

SupportEmailFormModel = (function(superClass) {
  extend(SupportEmailFormModel, superClass);

  function SupportEmailFormModel() {
    return SupportEmailFormModel.__super__.constructor.apply(this, arguments);
  }

  SupportEmailFormModel.prototype.initialize = function() {
    SupportBaseTicketModel.prototype.initialize.apply(this, arguments);
    this.getDefaultEmailForm();
    this.setEmailForm();
    return this.initializeEmailFormObjectsCount();
  };

  SupportEmailFormModel.prototype.setEmailForm = function() {
    var contentModelFlexibleStepThree;
    contentModelFlexibleStepThree = Groupon.Support.ContentModel.flexibleStepThree;
    if (contentModelFlexibleStepThree == null) {
      this.emailForm = $.extend(true, {}, this.defaultEmailForm);
      return this.isFlexibleStepThree = false;
    } else {
      this.emailForm = $.extend(true, {}, contentModelFlexibleStepThree);
      this.addRequiredItemsToFlexibleEmailForm();
      return this.isFlexibleStepThree = true;
    }
  };

  SupportEmailFormModel.prototype.initializeEmailFormObjectsCount = function() {
    return this.emailFormObjectsCount = {
      phone_number: 0,
      email_address: 0,
      user_name: 0,
      number: 0,
      text_field_paragraph: 0,
      text_field_line: 0,
      attachment: 0,
      calendar_date: 0,
      calendar_with_hour_slot: 0,
      dropdown: 0,
      checkbox: 0,
      text_paragraph: 0
    };
  };

  SupportEmailFormModel.prototype.addRequiredItemsToFlexibleEmailForm = function() {
    var emailAddress, phoneNumber, ref, userName;
    phoneNumber = 'phone_number';
    emailAddress = 'email_address';
    userName = 'user_name';
    if (window.isUS()) {
      return this.addRequiredItemsToFlexibleEmailFormForUS();
    } else if (this.isMethodOfContactByPhone()) {
      return this.addDefaultFormObjectsToEmailForm();
    } else {
      if (!(((ref = this.emailForm.objects) != null ? ref.length : void 0) > 0)) {
        this.emailForm.objects = [];
      }
      this.addObjectToEmailForm(this.checkConditionsToAddPhoneNumbers(phoneNumber), phoneNumber);
      this.addObjectToEmailForm(!((typeof currentUser !== "undefined" && currentUser !== null ? currentUser.email : void 0) != null) && !(this.isObjectTypeAlreadyPresent(emailAddress)), emailAddress);
      return this.addObjectToEmailForm(this.checkIfUserNameIsEmpty(), userName);
    }
  };

  SupportEmailFormModel.prototype.checkIfUserNameIsEmpty = function() {
    return _.isEmpty(typeof currentUser !== "undefined" && currentUser !== null ? currentUser.firstName : void 0) && _.isEmpty(typeof currentUser !== "undefined" && currentUser !== null ? currentUser.lastName : void 0);
  };

  SupportEmailFormModel.prototype.checkConditionsToAddPhoneNumbers = function(phoneNumber) {
    return !(this.isObjectTypeAlreadyPresent(phoneNumber)) && !window.priorityViewsEnabled();
  };

  SupportEmailFormModel.prototype.isObjectTypeAlreadyPresent = function(flexStepThreeObjType) {
    var flexibleStepThreeObj, i, len, ref;
    ref = this.emailForm.objects;
    for (i = 0, len = ref.length; i < len; i++) {
      flexibleStepThreeObj = ref[i];
      if (flexibleStepThreeObj.type === flexStepThreeObjType) {
        return true;
      }
    }
    return false;
  };

  SupportEmailFormModel.prototype.addObjectToEmailForm = function(criteriaToAdd, objectToBeAdded) {
    if (criteriaToAdd) {
      return this.emailForm.objects.splice(0, 0, this.getRequiredItem(objectToBeAdded));
    }
  };

  SupportEmailFormModel.prototype.addDefaultFormObjectsToEmailForm = function() {
    return this.emailForm.objects = $.extend(true, [], this.defaultEmailForm.objects);
  };

  SupportEmailFormModel.prototype.getEmailFormInputObjects = function() {
    var ref;
    if (((ref = this.emailForm.objects) != null ? ref.length : void 0) > 0) {
      return this.emailForm.objects;
    } else {
      return this.defaultEmailForm.objects;
    }
  };

  SupportEmailFormModel.prototype.isMethodOfContactByPhone = function() {
    return this.emailForm.method_of_contact === 'phone';
  };

  SupportEmailFormModel.prototype.isMethodOfContactByPhoneWithEmail = function() {
    return this.emailForm.method_of_contact === 'phone_with_email';
  };

  SupportEmailFormModel.prototype.numberOfRedemptionLocationsAvailable = function() {
    var ref, ref1;
    if (((ref = Groupon.Support.currentOrder) != null ? (ref1 = ref.dealOption) != null ? ref1.redemptionLocations : void 0 : void 0) != null) {
      return Groupon.Support.currentOrder.dealOption.redemptionLocations.length;
    } else {
      return 0;
    }
  };

  SupportEmailFormModel.prototype.isFTRDropdownCombinationSlected = function() {
    var FTRDropDownCombination;
    FTRDropDownCombination = [
      {
        categoryId: "a_problem_with_the_business",
        subCategoryId: "the_business_is_not_returning_my_calls_or_emails"
      }, {
        categoryId: "an_expired_groupon",
        subCategoryId: "the_business_is_not_returning_my_calls_or_emails"
      }
    ];
    return this.checkIfAnyDropdownCombinationMatches(FTRDropDownCombination);
  };

  SupportEmailFormModel.prototype.checkIfAnyDropdownCombinationMatches = function(dropdownCombo) {
    return _.some(dropdownCombo, (function(_this) {
      return function(dropdown) {
        var categoryId, subCategoryId;
        categoryId = dropdown.categoryId, subCategoryId = dropdown.subCategoryId;
        return (_this.parentCategoryId.indexOf(categoryId) > -1) && (_this.reasonId.indexOf(subCategoryId) > -1);
      };
    })(this));
  };

  SupportEmailFormModel.prototype.getDefaultEmailForm = function() {
    if (this.defaultEmailForm != null) {
      return this.defaultEmailForm;
    }
    if (window.isUS()) {
      return this.defaultEmailForm = this.getDefaultEmailFormForUS();
    } else {
      return this.defaultEmailForm = this.getDefaultEmailFormForEMEA();
    }
  };

  SupportEmailFormModel.prototype.getDefaultEmailFormForUS = function() {
    var dynamicEmailForm, objects;
    objects = [];
    if (this.canShowUserIdentificatioView()) {
      objects.push({
        type: "user_identification",
        required: "true"
      });
    }
    if (this.canShowMerchantLocationInfoView()) {
      objects.push({
        type: "merchant_location",
        required: "true"
      });
    }
    if (this.canShowUserContactInfoView()) {
      objects.push({
        type: "user_contact_info",
        required: "true"
      });
    }
    objects.push({
      type: "description",
      required: "true",
      append: true
    });
    return dynamicEmailForm = {
      method_of_contact: "email",
      objects: objects
    };
  };

  SupportEmailFormModel.prototype.getDefaultEmailFormForEMEA = function() {
    var dynamicEmailForm;
    dynamicEmailForm = {
      method_of_contact: "email",
      objects: [
        {
          type: "user_name",
          label: I18n.translate('js.modules.support.userlabel'),
          required: "true",
          additional_attributes: {
            maximum_number_of_characters_or_digits: ""
          }
        }, {
          type: "email_address",
          label: I18n.translate('js.modules.support.emaillabel'),
          required: "true"
        }, {
          type: "phone_number",
          label: I18n.translate('js.modules.support.user_phone_number'),
          required: "false"
        }, {
          type: "text_field_paragraph",
          label: I18n.translate('js.modules.support.whatson'),
          required: "true",
          additional_attributes: {
            maximum_number_of_characters_or_digits: "2000"
          }
        }, {
          type: "attachment",
          label: I18n.translate('js.modules.support.attach_file'),
          required: "false"
        }
      ]
    };
    if (!this.isFileUploadEnabled()) {
      dynamicEmailForm.objects = _.reject(dynamicEmailForm.objects, function(object) {
        return object.type === 'attachment';
      });
    }
    if (!this.canShowUserIdentificatioView()) {
      dynamicEmailForm.objects = _.reject(dynamicEmailForm.objects, function(object) {
        return object.type === 'email_address';
      });
    }
    if (!this.checkIfUserNameIsEmpty()) {
      dynamicEmailForm.objects = _.reject(dynamicEmailForm.objects, function(object) {
        return object.type === 'user_name';
      });
    }
    return dynamicEmailForm;
  };

  SupportEmailFormModel.prototype.isFileUploadEnabled = function() {
    return window.evaluate(typeof experiments !== "undefined" && experiments !== null ? experiments.fileUpload : void 0);
  };

  SupportEmailFormModel.prototype.getRequiredItem = function(item) {
    var defaultEmailFormObjects, i, len, obj, requiredItem;
    defaultEmailFormObjects = this.getDefaultEmailForm().objects;
    requiredItem = {};
    for (i = 0, len = defaultEmailFormObjects.length; i < len; i++) {
      obj = defaultEmailFormObjects[i];
      if (obj.type === item) {
        requiredItem = obj;
      }
    }
    return requiredItem;
  };

  SupportEmailFormModel.prototype.canShowUserIdentificatioView = function() {
    return !isUserLogged() || (currentUser.email == null);
  };

  SupportEmailFormModel.prototype.canShowMerchantLocationInfoView = function() {
    return Groupon.Support.FeatureFlagModel.isShowMerchantInfoFieldsEnabled() && (this.isFTRDropdownCombinationSlected() && this.numberOfRedemptionLocationsAvailable() !== 1);
  };

  SupportEmailFormModel.prototype.canShowUserContactInfoView = function() {
    return Groupon.Support.FeatureFlagModel.isShowUserContactInfoFieldsEnabled() && this.isFTRDropdownCombinationSlected();
  };

  SupportEmailFormModel.prototype.addRequiredItemsToFlexibleEmailFormForUS = function() {
    var defaultEmailFormObjects, objects, objectsToBeAppended, objectsToBePrepended, ref, ref1;
    if (((ref = this.emailForm) != null ? (ref1 = ref.objects) != null ? ref1.length : void 0 : void 0) > 0) {
      defaultEmailFormObjects = this.getDefaultEmailForm().objects;
      objectsToBeAppended = [];
      objectsToBePrepended = [];
      _.each(defaultEmailFormObjects, function(obj) {
        if (obj.append) {
          return objectsToBeAppended.push(obj);
        } else {
          return objectsToBePrepended.push(obj);
        }
      });
      this.addRequiredItemsToFlexibleStepThreeForCMSUS(objectsToBePrepended);
      objects = $.merge($.merge(objectsToBePrepended, this.emailForm.objects), objectsToBeAppended);
      return this.emailForm.objects = objects;
    }
  };

  SupportEmailFormModel.prototype.addRequiredItemsToFlexibleStepThreeForCMSUS = function(objectsToBePrepended) {
    var phoneNumberDropDownCombination, textFieldDropDownCombination, userContactInfoDropDownCombination;
    if (objectsToBePrepended == null) {
      objectsToBePrepended = [];
    }
    if (window.evaluate(typeof experiments !== "undefined" && experiments !== null ? experiments.shouldDisplayCMSContentForUS : void 0)) {
      userContactInfoDropDownCombination = [
        {
          categoryId: "a_problem_with_the_business",
          subCategoryId: "the_business_won_t_accept_my_groupon"
        }
      ];
      phoneNumberDropDownCombination = [
        {
          categoryId: "a_problem_with_the_business",
          subCategoryId: "the_business_is_closed"
        }
      ];
      textFieldDropDownCombination = [
        {
          categoryId: "a_problem_with_the_business",
          subCategoryId: "the_business_won_t_accept_my_groupon"
        }
      ];
      if (this.checkIfAnyDropdownCombinationMatches(userContactInfoDropDownCombination)) {
        objectsToBePrepended.push({
          type: "user_contact_info",
          required: "true"
        });
      }
      if (this.checkIfAnyDropdownCombinationMatches(phoneNumberDropDownCombination)) {
        objectsToBePrepended.push({
          type: "phone_number",
          label: I18n.translate('js.modules.support.phone_number_called'),
          required: "false"
        });
      }
      if (this.checkIfAnyDropdownCombinationMatches(textFieldDropDownCombination)) {
        objectsToBePrepended.push({
          type: "text_field_line",
          label: I18n.translate('js.modules.support.location_visited'),
          required: "true"
        });
      }
      return objectsToBePrepended;
    }
  };

  return SupportEmailFormModel;

})(SupportBaseTicketModel);

module.exports = SupportEmailFormModel;



},{"./base_ticket_model":57}],63:[function(require,module,exports){
var Backbone, SupportFlexibleContactChannelModel,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Backbone = require('backbone');

SupportFlexibleContactChannelModel = (function(superClass) {
  extend(SupportFlexibleContactChannelModel, superClass);

  function SupportFlexibleContactChannelModel() {
    return SupportFlexibleContactChannelModel.__super__.constructor.apply(this, arguments);
  }

  SupportFlexibleContactChannelModel.prototype.initialize = function() {
    return this.url = window.SUPPORTBASEURL + "/fetch?key=contact_channels&type=contact_channels";
  };

  SupportFlexibleContactChannelModel.prototype.setFetchContactChannelFromCMS = function() {
    return this.url = this.url + "&should_display_cms_content=true";
  };

  SupportFlexibleContactChannelModel.prototype.hasContactChannels = function() {
    return this.has('contact_channels');
  };

  SupportFlexibleContactChannelModel.prototype.getContactChannels = function() {
    return this.get('contact_channels');
  };

  SupportFlexibleContactChannelModel.prototype.setFlexibleContactChannels = function(contactChannelsForSelectedSubcategory) {
    return this.set("flexbleContactChannels", contactChannelsForSelectedSubcategory);
  };

  SupportFlexibleContactChannelModel.prototype.invalidateFlexibleContactChannels = function() {
    return this.set("flexbleContactChannels", null);
  };

  SupportFlexibleContactChannelModel.prototype.presentContactChannels = function() {
    var contactChannels, formattedContactChannels;
    if (this.has('flexbleContactChannels')) {
      contactChannels = this.get('flexbleContactChannels');
      formattedContactChannels = [];
      _.each(contactChannels, (function(_this) {
        return function(value, key) {
          var formattedContactChannel;
          key = key != null ? key.toLowerCase() : void 0;
          value = value != null ? value.toLowerCase() : void 0;
          formattedContactChannel = {};
          formattedContactChannel[key] = _this.getContactChannelHash(value);
          if (value === 'chat') {
            _this.set('liveChatExists', true);
          }
          return formattedContactChannels.push(formattedContactChannel);
        };
      })(this));
      this.set("formattedContactChannels", {
        contact_channels: formattedContactChannels
      });
    } else {
      this.set('liveChatExists', true);
      this.set("formattedContactChannels", {
        contact_channels: this.getDefaultContactChannelsWithChat()
      });
    }
    return this.setBoldchatRelatedInfoInFlexibleContactChannels();
  };

  SupportFlexibleContactChannelModel.prototype.setBoldchatRelatedInfoInFlexibleContactChannels = function() {
    var formattedContactChannels, ref, ref1;
    if (this.has('formattedContactChannels')) {
      formattedContactChannels = this.get("formattedContactChannels")['contact_channels'];
      this.set('primaryChannelIsBoldChat', (formattedContactChannels != null ? (ref = formattedContactChannels[0]) != null ? (ref1 = ref['primary']) != null ? ref1.is_chat : void 0 : void 0 : void 0) === true);
      this.set('onlyBoldChatInContactChannels', (formattedContactChannels.length === 1) && this.get('primaryChannelIsBoldChat'));
    }
    return this.setContactChannelsWithoutBoldChat();
  };

  SupportFlexibleContactChannelModel.prototype.setContactChannelsWithoutBoldChat = function() {
    var channelTypes, contactChannelsWithoutBoldChat, contact_channels, i;
    if (this.get('onlyBoldChatInContactChannels')) {
      return this.set("contactChannelsWithoutBoldChat", {
        contact_channels: [
          {
            primary: this.getContactChannelHash("email")
          }
        ]
      });
    } else if (this.has('formattedContactChannels')) {
      channelTypes = ['primary', 'secondary', 'tertiary'];
      i = 0;
      contactChannelsWithoutBoldChat = [{}, {}, {}];
      contact_channels = _.each(this.get("formattedContactChannels").contact_channels, function(formattedContactChannel, key) {
        var ref;
        if (!((ref = formattedContactChannel[channelTypes[key]]) != null ? ref.is_chat : void 0)) {
          return contactChannelsWithoutBoldChat[i][channelTypes[i++]] = formattedContactChannel[channelTypes[key]];
        }
      });
      _.each(contactChannelsWithoutBoldChat, function(contactChannelWithoutBoldChat, key) {
        if (_.isEmpty(contactChannelWithoutBoldChat)) {
          return contactChannelsWithoutBoldChat.splice(key, 1);
        }
      });
      return this.set("contactChannelsWithoutBoldChat", {
        contact_channels: contactChannelsWithoutBoldChat
      });
    } else {
      return this.set("contactChannelsWithoutBoldChat", {
        contact_channels: this.getDefaultContactChannelsWithoutChat()
      });
    }
  };

  SupportFlexibleContactChannelModel.prototype.getDefaultContactChannelsWithChat = function() {
    return [
      {
        primary: this.getContactChannelHash("chat")
      }, {
        secondary: this.getContactChannelHash("email")
      }, {
        tertiary: this.getContactChannelHash("phone")
      }
    ];
  };

  SupportFlexibleContactChannelModel.prototype.getDefaultContactChannelsWithoutChat = function() {
    return [
      {
        primary: this.getContactChannelHash("email")
      }, {
        secondary: this.getContactChannelHash("phone")
      }
    ];
  };

  SupportFlexibleContactChannelModel.prototype.getContactChannelHash = function(type) {
    switch (type) {
      case "chat":
        return this.chatContactChannelHash();
      case "email":
        return this.emailContactChannelHash();
      case "phone":
        return this.phoneContactChannelHash();
    }
  };

  SupportFlexibleContactChannelModel.prototype.chatContactChannelHash = function() {
    return {
      "channel": "chat",
      button_text: I18n.translate('js.modules.support.chat'),
      channel_text: I18n.translate('js.modules.support.chat_us'),
      is_chat: true
    };
  };

  SupportFlexibleContactChannelModel.prototype.emailContactChannelHash = function() {
    return {
      "channel": "email",
      button_text: I18n.translate('js.modules.support.email'),
      channel_text: I18n.translate('js.modules.support.email_us'),
      is_chat: false
    };
  };

  SupportFlexibleContactChannelModel.prototype.phoneContactChannelHash = function() {
    return {
      "channel": "phone",
      button_text: I18n.translate("js.modules.support.flexible_phone"),
      channel_text: I18n.translate('js.modules.support.phone_us'),
      is_chat: false
    };
  };

  return SupportFlexibleContactChannelModel;

})(Backbone.Model);

module.exports = SupportFlexibleContactChannelModel;



},{"backbone":245}],64:[function(require,module,exports){
var Backbone, SupportAPIHelper, SupportHoldTimeModel,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportAPIHelper = require('../helpers/API');

Backbone = require('backbone');

SupportHoldTimeModel = (function(superClass) {
  extend(SupportHoldTimeModel, superClass);

  function SupportHoldTimeModel() {
    return SupportHoldTimeModel.__super__.constructor.apply(this, arguments);
  }

  SupportHoldTimeModel.prototype.initialize = function() {
    return this.mainView = this.attributes.mainView;
  };

  SupportHoldTimeModel.prototype.getCallMeBackFlag = function() {
    var url;
    url = this.getHoldTimeUrlToFetchCallMeBackFlag();
    return SupportAPIHelper.get(url, null, this.mainView.callMeBackFlagCb, this.mainView.callMeBackFlagCb, false);
  };

  SupportHoldTimeModel.prototype.postToHoldTime = function(data) {
    var url;
    url = this.getHoldTimeUrlToPostInHoldTime();
    return SupportAPIHelper.call(url, 'POST', data, this.mainView.renderHoldTimePostSuccess, this.mainView.renderHoldTimePostError, false);
  };

  SupportHoldTimeModel.prototype.getHoldTimeUrlToFetchCallMeBackFlag = function() {
    var channel, url;
    channel = this.getHoldTimeQueueChannel();
    return url = window.SUPPORTBASEURL + "/hold_time/fetch?channel=" + channel;
  };

  SupportHoldTimeModel.prototype.getHoldTimeUrlToPostInHoldTime = function() {
    var channel, url;
    channel = this.getHoldTimeQueueChannel();
    return url = window.SUPPORTBASEURL + "/hold_time/create?channel=" + channel;
  };

  SupportHoldTimeModel.prototype.getHoldTimeQueueChannel = function() {
    var channel, getawaysRegex, goodsRegex, holdTimeQueueChannel, ref;
    channel = (ref = Groupon.Support.currentOrder) != null ? ref.DEAL_TYPE : void 0;
    goodsRegex = /goods/;
    getawaysRegex = /getaways/;
    holdTimeQueueChannel = 'local';
    if (channel != null) {
      holdTimeQueueChannel = goodsRegex.test(channel.toLowerCase()) ? 'goods' : getawaysRegex.test(channel.toLowerCase()) ? 'travel' : 'local';
    }
    return holdTimeQueueChannel;
  };

  return SupportHoldTimeModel;

})(Backbone.Model);

module.exports = SupportHoldTimeModel;



},{"../helpers/API":51,"backbone":245}],65:[function(require,module,exports){
var Backbone, SupportLiveChatModel, SupportUtilsHelper,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportUtilsHelper = require('../helpers/utils');

Backbone = require('backbone');

SupportLiveChatModel = (function(superClass) {
  extend(SupportLiveChatModel, superClass);

  function SupportLiveChatModel() {
    return SupportLiveChatModel.__super__.constructor.apply(this, arguments);
  }

  SupportLiveChatModel.prototype.initialize = function() {
    return this.setDefaults();
  };

  SupportLiveChatModel.prototype.setDefaults = function() {
    var attrs, ref, ref1;
    attrs = {
      userEmail: (ref = window.currentUser) != null ? ref.email : void 0,
      userName: SupportUtilsHelper.getCurrentUserFullName(),
      isLogged: ((ref1 = window.currentUser) != null ? ref1.email : void 0) != null,
      liveChat: window.liveChatInfo,
      initialQuestion: ""
    };
    return this.set(attrs, {
      slient: true
    });
  };

  SupportLiveChatModel.prototype.escapePunctuationsAndSanitize = function(text) {
    text = text.replace(/\\/g, "\\\\");
    text = text.replace(/\"/g, '\\"');
    return text = text.replace(/(<([^>]+)>)/ig, "");
  };

  SupportLiveChatModel.prototype.setIntialQuestion = function(params) {
    var currentOrder, initialQuestion, issue, ref, ref1;
    initialQuestion = [];
    if ((params != null ? params.issue : void 0) != null) {
      issue = this.escapePunctuationsAndSanitize(params.issue);
      initialQuestion.push((I18n.translate('js.modules.support.issue')) + " " + issue);
    }
    if (Groupon.Support.currentOrder) {
      currentOrder = Groupon.Support.currentOrder;
      if (isUS()) {
        initialQuestion.push((I18n.translate('js.modules.support.order_no')) + ": " + currentOrder.id);
      }
      if (currentOrder.deal != null) {
        initialQuestion.push((I18n.translate('js.modules.support.deal_concerned')) + " " + currentOrder.deal.id);
      }
      if (isIntl() && (((ref = currentOrder.groupons) != null ? (ref1 = ref[0]) != null ? ref1.redemptionCode : void 0 : void 0) != null)) {
        initialQuestion.push((I18n.translate('js.modules.support.security_code')) + ": " + currentOrder.groupons[0].redemptionCode);
      }
    }
    if (initialQuestion.length > 0) {
      initialQuestion.push("\\n");
      return this.set({
        initialQuestion: initialQuestion.join("\\n")
      });
    } else {
      return this.set({
        initialQuestion: ""
      });
    }
  };

  SupportLiveChatModel.prototype.setLiveChatInfo = function(liveChatType) {
    liveChatType = this.getLiveChatType(liveChatType);
    this.setLiveChatType(liveChatType);
    return this.setLiveChatCharacter(liveChatType);
  };

  SupportLiveChatModel.prototype.setLiveChatType = function(liveChatType) {
    var ref, ref1, ref10, ref11, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
    switch (liveChatType) {
      case 'normal_live_chat':
        return this.set('liveChat', window.liveChatInfo);
      case 'optimized_live_chat':
        return this.set('liveChat', (ref = window.liveChatInfo) != null ? ref.optimizedBoldChat : void 0);
      case 'getaways_live_chat':
        return this.set('liveChat', (ref1 = window.liveChatInfo) != null ? ref1.getaways : void 0);
      case 'flexible_live_chat':
        return this.set('liveChat', (ref2 = window.liveChatInfo) != null ? ref2.flexibleBoldChat : void 0);
      case 'live_chat_link':
        return this.set('liveChat', (ref3 = window.liveChatInfo) != null ? ref3.linkBoldChat : void 0);
      case 'optimized_getaways_live_chat':
        return this.set('liveChat', (ref4 = window.liveChatInfo) != null ? (ref5 = ref4.optimizedBoldChat) != null ? ref5.getaways : void 0 : void 0);
      case 'flexible_getaways_live_chat':
        return this.set('liveChat', (ref6 = window.liveChatInfo) != null ? (ref7 = ref6.flexibleBoldChat) != null ? ref7.getaways : void 0 : void 0);
      case 'flexible_v2_live_chat':
        return this.set('liveChat', (ref8 = window.liveChatInfo) != null ? (ref9 = ref8.flexibleBoldChat) != null ? ref9.v2 : void 0 : void 0);
      case 'live_chat_getaways_link':
        return this.set('liveChat', (ref10 = window.liveChatInfo) != null ? (ref11 = ref10.linkBoldChat) != null ? ref11.getaways : void 0 : void 0);
    }
  };

  SupportLiveChatModel.prototype.setLiveChatCharacter = function(liveChatType) {
    if (liveChatType === "live_chat_link" || liveChatType === "live_chat_getaways_link") {
      return this.set("is_chat_link", true);
    } else {
      return this.set("is_chat_link", false);
    }
  };

  SupportLiveChatModel.prototype.getLiveChatType = function(liveChatType) {
    if (liveChatType != null) {
      return liveChatType;
    }
    if (this.shouldShowFlexibleLiveChat()) {
      return this.getFlexibleLiveChatType();
    } else if (this.shouldShowOptimizedLiveChat()) {
      return this.getOptimizedLiveChatType();
    } else {
      return this.getDefaultLiveChatType();
    }
  };

  SupportLiveChatModel.prototype.shouldShowOptimizedLiveChat = function() {
    return window.shouldShowOptimizedChannel();
  };

  SupportLiveChatModel.prototype.shouldShowFlexibleLiveChat = function() {
    return window.shouldShowFlexibleChannel();
  };

  SupportLiveChatModel.prototype.shouldShowGetawaysLiveChat = function() {
    return isCurrentOrderGetawaysDeal() && isUS();
  };

  SupportLiveChatModel.prototype.getDefaultStepTwoLiveChatMode = function() {
    var ref, ref1;
    return (ref = window.liveChatInfo) != null ? (ref1 = ref.mode) != null ? ref1.step_two : void 0 : void 0;
  };

  SupportLiveChatModel.prototype.getDefaultStepThreeLiveChatMode = function() {
    var ref, ref1;
    return (ref = window.liveChatInfo) != null ? (ref1 = ref.mode) != null ? ref1.step_three : void 0 : void 0;
  };

  SupportLiveChatModel.prototype.getDefaultLiveChatType = function() {
    if (this.shouldShowGetawaysLiveChat()) {
      return 'getaways_live_chat';
    } else {
      return 'normal_live_chat';
    }
  };

  SupportLiveChatModel.prototype.getOptimizedLiveChatType = function() {
    if (this.shouldShowGetawaysLiveChat()) {
      return 'optimized_getaways_live_chat';
    } else {
      return 'optimized_live_chat';
    }
  };

  SupportLiveChatModel.prototype.getFlexibleLiveChatType = function() {
    if (this.shouldShowGetawaysLiveChat()) {
      return 'flexible_getaways_live_chat';
    } else {
      return 'flexible_live_chat';
    }
  };

  SupportLiveChatModel.prototype.getFlexibleV2LiveChatType = function() {
    return 'flexible_v2_live_chat';
  };

  SupportLiveChatModel.prototype.getLinkLiveChatType = function() {
    if (this.shouldShowGetawaysLiveChat()) {
      return 'live_chat_getaways_link';
    } else {
      return 'live_chat_link';
    }
  };

  SupportLiveChatModel.prototype.shouldShowStepTwoLiveChat = function() {
    var liveChatmode;
    liveChatmode = this.getDefaultStepTwoLiveChatMode();
    return (liveChatmode != null) && isFloatingLiveChat(liveChatmode);
  };

  SupportLiveChatModel.prototype.isLiveChatEnabled = function() {
    return Groupon.Support.FeatureFlagModel.isShowLiveChatEnabled() && !(_.isEmpty(window.liveChatInfo));
  };

  return SupportLiveChatModel;

})(Backbone.Model);

module.exports = SupportLiveChatModel;



},{"../helpers/utils":54,"backbone":245}],66:[function(require,module,exports){
var Backbone, SupportOptimizedContactChannelsModel, SupportOptimizedContactChannelsTemplate,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Backbone = require('backbone');

SupportOptimizedContactChannelsTemplate = require('../../optimized_contact_channels.html.mustache');

SupportOptimizedContactChannelsModel = (function(superClass) {
  extend(SupportOptimizedContactChannelsModel, superClass);

  function SupportOptimizedContactChannelsModel() {
    return SupportOptimizedContactChannelsModel.__super__.constructor.apply(this, arguments);
  }

  SupportOptimizedContactChannelsModel.prototype.initialize = function() {
    return this.template = SupportOptimizedContactChannelsTemplate;
  };

  SupportOptimizedContactChannelsModel.prototype.toHash = function() {
    return this.toJSON();
  };

  SupportOptimizedContactChannelsModel.prototype.hidePreferencedContactChannel = function() {
    var optimizedContactChannels;
    optimizedContactChannels = [this.optimizephoneBtnElem(), this.optimizeEmailBtnElem()];
    removePreferredContactClass(optimizedContactChannels);
    return addBtnSecondaryClass(optimizedContactChannels);
  };

  SupportOptimizedContactChannelsModel.prototype.showPreferencedContactChannel = function(type) {
    var preferredContactElem;
    if (this.optimizedLiveChatVisible() || ($('.preferred-contact-channel', '.optimized-contact-channels-view').length > 0)) {
      return;
    }
    switch (type) {
      case "email":
        preferredContactElem = this.optimizeEmailBtnElem();
        break;
      case "phone":
        preferredContactElem = this.optimizephoneBtnElem();
    }
    if (preferredContactElem) {
      addPreferredContactClass(preferredContactElem);
      return removeBtnSecondaryClass(preferredContactElem);
    }
  };

  SupportOptimizedContactChannelsModel.prototype.optimizedLiveChatVisible = function() {
    return window.liveChatVisible($(".live-chat-container.optimized-contact-channel a img"));
  };

  SupportOptimizedContactChannelsModel.prototype.setOptimizedLiveChatDisplayCallBack = function(liveChatDisplayCallback) {
    return window.setLiveChatDisplayCallBack($(".live-chat-container.optimized-contact-channel a img"), liveChatDisplayCallback);
  };

  SupportOptimizedContactChannelsModel.prototype.optimizephoneBtnElem = function() {
    return $('.optimized-phone-btn');
  };

  SupportOptimizedContactChannelsModel.prototype.optimizeEmailBtnElem = function() {
    return $('.optimized-email-us');
  };

  SupportOptimizedContactChannelsModel.prototype.optimizedLiveChatContainer = function() {
    return $('.optimized-live-chat-container');
  };

  SupportOptimizedContactChannelsModel.prototype.emailRecommendationTextElement = function() {
    return $('.optimized-email-us-p');
  };

  SupportOptimizedContactChannelsModel.prototype.phoneRecommendationTextElement = function() {
    return $('.optimized-phone-p');
  };

  return SupportOptimizedContactChannelsModel;

})(Backbone.Model);

module.exports = SupportOptimizedContactChannelsModel;



},{"../../optimized_contact_channels.html.mustache":222,"backbone":245}],67:[function(require,module,exports){
var Backbone, SupportAPIHelper, SupportOrderModel, SupportUtilsHelper, async,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportAPIHelper = require('../helpers/API');

async = require('../../../../core/frontend/vendor_modules/async');

SupportUtilsHelper = require('../helpers/utils');

Backbone = require('backbone');

SupportOrderModel = (function(superClass) {
  extend(SupportOrderModel, superClass);

  function SupportOrderModel() {
    this.orderDetailMap = {};
    this.orderMetadataMap = {};
  }

  SupportOrderModel.prototype.findOrderDetailsByOrderId = function(orderId) {
    if (orderId) {
      orderId = orderId.toString();
      return this.orderDetailMap[orderId];
    } else {
      return null;
    }
  };

  SupportOrderModel.prototype.setOrderDetails = function(order) {
    var orderId;
    if (order != null ? order.id : void 0) {
      orderId = order.id.toString();
      return this.orderDetailMap[orderId] = order;
    }
  };

  SupportOrderModel.prototype.findOrderMetaDataByOrderId = function(orderId) {
    if (orderId) {
      orderId = orderId.toString();
      return this.orderMetadataMap[orderId];
    } else {
      return null;
    }
  };

  SupportOrderModel.prototype.setOrderMetaData = function(orderId, metadata) {
    if (orderId && metadata) {
      orderId = orderId.toString();
      return this.orderMetadataMap[orderId] = metadata;
    }
  };

  SupportOrderModel.prototype.getOrderDetailsForMygrouponsOrderId = function(successCallback, errorCallback) {
    var orderIdFromMyGroupons, requests;
    if (!window.orderIdFromMyGroupons) {
      return errorCallback();
    }
    orderIdFromMyGroupons = window.orderIdFromMyGroupons;
    requests = {
      orderDetailsMyGrouponOrder: (function(_this) {
        return function(cb) {
          var _errorCb, _successCb, order, params;
          params = {
            order: {
              id: orderIdFromMyGroupons
            },
            forceFetchOrderDetails: true
          };
          if (orderIdFromMyGroupons != null) {
            order = Groupon.Support.OrdersCollection.findOrderById(orderIdFromMyGroupons);
            if (order) {
              params.order = order;
              params.forceFetchOrderDetails = false;
            }
          }
          _successCb = function(response) {
            return cb(null, response);
          };
          _errorCb = function() {
            return cb(null, null);
          };
          return _this.getOrderDetails(params, _successCb, _errorCb);
        };
      })(this),
      orderDetailsFirstOrder: (function(_this) {
        return function(cb) {
          var _errorCb, _successCb, paramOrder, params;
          paramOrder = Groupon.Support.currentOrdersFilter.getFirstOrder();
          if ((paramOrder != null ? paramOrder.id : void 0) && orderIdFromMyGroupons && (paramOrder != null ? paramOrder.id.toString() : void 0) === orderIdFromMyGroupons.toString()) {
            return cb(null, null);
          }
          params = {
            order: paramOrder,
            forceFetchOrderDetails: false
          };
          _successCb = function(response) {
            return cb(null, response);
          };
          _errorCb = function() {
            return cb(null, null);
          };
          return _this.getOrderDetails(params, _successCb, _errorCb);
        };
      })(this)
    };
    return async.parallel(requests, (function(_this) {
      return function(err, results) {
        if (err) {
          return errorCallback();
        } else {
          if (results.orderDetailsMyGrouponOrder != null) {
            window.selectOrderFromMygroupons = true;
            return successCallback(results.orderDetailsMyGrouponOrder);
          } else if (results.orderDetailsFirstOrder) {
            window.selectOrderFromMygroupons = false;
            return successCallback(results.orderDetailsFirstOrder);
          } else {
            return errorCallback();
          }
        }
      };
    })(this));
  };

  SupportOrderModel.prototype.getOrderDetails = function(params, successCallback, errorCallback) {
    var _orderDetailSuccessCallback, _orderDetailsErrorCallback, orderDetails, orderSummary, ref, ref1, url;
    orderSummary = params.order;
    orderDetails = this.findOrderDetailsByOrderId(orderSummary != null ? orderSummary.id : void 0);
    if (orderDetails && (!params.forceFetchOrderDetails)) {
      return successCallback(orderDetails);
    }
    _orderDetailSuccessCallback = (function(_this) {
      return function(orderDetails) {
        orderDetails.isOrderDetailsFetched = true;
        _this.setOrderDetails(orderDetails);
        _this.associateHotelImages(orderDetails);
        return successCallback(orderDetails);
      };
    })(this);
    _orderDetailsErrorCallback = function() {
      return errorCallback(orderSummary);
    };
    if (checkIfIsUSByCountry(window.country.name)) {
      url = (function() {
        switch (orderSummary.DEAL_TYPE) {
          case 'GETAWAYS_MARKET_RATE':
            return this.getawaysHotelReservationDetailsPath(orderSummary.id);
          case 'GETAWAYS_TONIGHT':
            return this.getawaysHotelReservationDetailsPath(orderSummary.id);
          default:
            return this.orderDetailsPath(orderSummary, params);
        }
      }).call(this);
      return SupportAPIHelper.get(url, null, _orderDetailSuccessCallback, _orderDetailsErrorCallback, false);
    } else if (window.isNeedish()) {
      params.forceFetchOrderDetails = true;
      url = this.orderDetailsPath(orderSummary, params);
      return SupportAPIHelper.get(url, null, _orderDetailSuccessCallback, _orderDetailsErrorCallback, false);
    } else {
      if (((ref = orderSummary.deal) != null ? ref.isTravelBookableDeal : void 0) || ((ref1 = orderSummary.deal) != null ? ref1.isBookableTravelDeal : void 0)) {
        return _orderDetailSuccessCallback(orderSummary);
      }
      if (orderSummary.DEAL_TYPE === 'GETAWAYS_MARKET_RATE') {
        url = this.getawaysHotelReservationDetailsPath(orderSummary.id);
        return SupportAPIHelper.get(url, null, _orderDetailSuccessCallback, _orderDetailsErrorCallback, false);
      } else if (params.forceFetchOrderDetails) {
        url = this.orderDetailsPath(orderSummary, params);
        return SupportAPIHelper.get(url, null, _orderDetailSuccessCallback, _orderDetailsErrorCallback, false);
      } else {
        return this.getDealInfo(params, successCallback, errorCallback);
      }
    }
  };

  SupportOrderModel.prototype.getDealInfo = function(params, successCallback, errorCallback) {
    var _dealInfoErrorCallback, _dealInfoSuccessCallback, orderDetails, url;
    orderDetails = params.order;
    if (orderDetails.isDealDataFetched) {
      return successCallback(orderDetails);
    }
    _dealInfoSuccessCallback = (function(_this) {
      return function(deal) {
        _.extend(orderDetails.deal, deal);
        if (deal.DEAL_TYPE != null) {
          orderDetails.DEAL_TYPE = deal.DEAL_TYPE;
        }
        orderDetails.finePrintText = deal.finePrintText;
        orderDetails.isDealDataFetched = true;
        return successCallback(orderDetails);
      };
    })(this);
    _dealInfoErrorCallback = function() {
      return errorCallback(orderDetails);
    };
    url = this.dealDetailsPath(orderDetails.deal.id);
    return SupportAPIHelper.get(url, {
      purchasedAt: orderDetails.purchasedAt
    }, _dealInfoSuccessCallback, _dealInfoErrorCallback, false);
  };

  SupportOrderModel.prototype.getMetadata = function(params, successCallback, errorCallback) {
    var _metadataSuccessCallback, metadataResponse, metadataUrl, orderData, orderDetails;
    orderDetails = params.order;
    _metadataSuccessCallback = (function(_this) {
      return function(response) {
        orderDetails.isMetaDataFetched = true;
        _this.setOrderMetaData(orderDetails != null ? orderDetails.id : void 0, response);
        return _this.setCurrentOrderAttributes({
          orderDetails: orderDetails,
          orderMetadata: response
        }, successCallback);
      };
    })(this);
    metadataResponse = this.findOrderMetaDataByOrderId(orderDetails != null ? orderDetails.id : void 0);
    if (metadataResponse != null) {
      return _metadataSuccessCallback(metadataResponse);
    }
    metadataUrl = window.SUPPORTBASEURL + "/metadata?should_display_cms_content=" + experiments.shouldDisplayCMSContentForUS;
    orderData = {
      groupon: orderDetails,
      channel: orderDetails.DEAL_TYPE
    };
    orderDetails.user = currentUser;
    return SupportAPIHelper.call(metadataUrl, 'POST', orderData, _metadataSuccessCallback, errorCallback, false);
  };

  SupportOrderModel.prototype.setCurrentOrderAttributes = function(arg, callback) {
    var orderDetails, orderMetadata;
    orderMetadata = arg.orderMetadata, orderDetails = arg.orderDetails;
    orderDetails.serviceActions = orderMetadata.serviceActions;
    orderDetails.tagLine = orderMetadata.tagLine;
    if (orderMetadata.priorityTaglines != null) {
      orderDetails.priorityTaglines = orderMetadata.priorityTaglines;
    }
    if (orderMetadata.finePrintText != null) {
      orderDetails.finePrintText = orderMetadata.finePrintText;
    }
    if (orderMetadata.status != null) {
      Groupon.Support.ContentModel.displayStatus = orderMetadata.status;
    }
    if (orderMetadata.notes != null) {
      Groupon.Support.ContentModel.displayNotes = orderMetadata.notes;
    }
    if (orderMetadata.external_notes != null) {
      Groupon.Support.ContentModel.externalDealNotes = orderMetadata.external_notes;
    }
    if (orderMetadata.shouldShowDeliveryMsg != null) {
      orderDetails.shouldShowDeliveryMsg = orderMetadata.shouldShowDeliveryMsg;
    } else {
      orderDetails.shouldShowDeliveryMsg = false;
    }
    if (orderMetadata.goodsDealFulfillmentTag != null) {
      orderDetails.goodsDealFulfillmentTag = orderMetadata.goodsDealFulfillmentTag;
    }
    if (orderMetadata.isRefundEligible != null) {
      orderDetails.isRefundEligible = orderMetadata.isRefundEligible;
    }
    if (orderMetadata.escalateToMerchant != null) {
      orderDetails.escalateToMerchant = orderMetadata.escalateToMerchant;
    }
    if ($.inArray('edit_order', orderDetails.serviceActions) > -1 || $.inArray('cancel_order', orderDetails.serviceActions) > -1 || $.inArray('cancel_reservations', orderDetails.serviceActions) > -1) {
      orderDetails.isEditable = true;
      orderDetails.isEditableUntil = orderMetadata.editableUntillongDateTimeStr;
      orderDetails.editableUntilshortDateTimeStr = orderMetadata.editableUntilshortDateTimeStr;
      orderDetails.editableUntillongDateTimeStr = orderMetadata.editableUntillongDateTimeStr;
    } else {
      orderDetails.isEditable = false;
    }
    if ((orderMetadata != null ? orderMetadata.inbentaParams : void 0) != null) {
      Groupon.Support.ContentModel.extendParams(orderMetadata.inbentaParams);
    }
    return callback(orderDetails);
  };

  SupportOrderModel.prototype.associateHotelImages = function(order) {
    var reservationSource, savedData;
    if (order.DEAL_TYPE === 'GETAWAYS_MARKET_RATE') {
      savedData = Groupon.Support.OrdersCollection.getHotelImageByOrderId(order.id);
      reservationSource = SupportUtilsHelper.getReservationSource(order);
      if ((reservationSource != null) && savedData) {
        reservationSource.images = savedData.images;
      }
    }
    return order;
  };

  SupportOrderModel.prototype.dealDetailsPath = function(dealId) {
    return window.SUPPORTBASEURL + "/deal/" + dealId;
  };

  SupportOrderModel.prototype.orderDetailsPath = function(order, params) {
    var groupon, query, ref;
    query = "";
    if (order != null) {
      if (((ref = order.groupons) != null ? ref.length : void 0) > 0) {
        groupon = _.first(order.groupons);
        if (groupon.id) {
          query = query + "groupon_id=" + groupon.id + "&";
        }
      }
    }
    if (params) {
      if (params.isRefundEligible) {
        query = query + "is_refund_eligible=true&";
      }
      if (params.forceFetchOrderDetails) {
        query = query + "mygroupon_show=true&";
      }
    }
    return window.SUPPORTBASEURL + "/user/" + currentUser.id + "/order/" + order.id + "?" + query;
  };

  SupportOrderModel.prototype.getawaysHotelReservationDetailsPath = function(reservationId) {
    var consumerId, parts, ref, user_id;
    if (checkIfIsUSByCountryCluster(window.country.cluster)) {
      parts = (ref = currentUser.consumerId) != null ? ref.split("-") : void 0;
      consumerId = _.reduce(parts, function(memo, part) {
        return "" + memo + part;
      });
      return window.SUPPORTBASEURL + "/user/" + consumerId + "/getaways_hotel_reservation/" + reservationId;
    } else {
      user_id = currentUser.id;
      return window.SUPPORTBASEURL + "/user/" + user_id + "/getaways_hotel_reservation/" + reservationId;
    }
  };

  return SupportOrderModel;

})(Backbone.Model);

module.exports = SupportOrderModel;



},{"../../../../core/frontend/vendor_modules/async":2,"../helpers/API":51,"../helpers/utils":54,"backbone":245}],68:[function(require,module,exports){
var SupportOrdersFilterConditionsModel, SupportUtilsHelper;

SupportUtilsHelper = require('../helpers/utils');

SupportOrdersFilterConditionsModel = (function() {
  function SupportOrdersFilterConditionsModel() {}

  SupportOrdersFilterConditionsModel.prototype.sortPurchasedDateAscendingFn = function(a, b) {
    a = getMillisecondsOfUTCDateFromISOStringDate(a.purchasedAt);
    b = getMillisecondsOfUTCDateFromISOStringDate(b.purchasedAt);
    return this.sortAscendingFunction(a, b);
  };

  SupportOrdersFilterConditionsModel.prototype.sortPurchasedDateDescendingFn = function(a, b) {
    a = getMillisecondsOfUTCDateFromISOStringDate(a.purchasedAt);
    b = getMillisecondsOfUTCDateFromISOStringDate(b.purchasedAt);
    return this.sortDescendingFunction(a, b);
  };

  SupportOrdersFilterConditionsModel.prototype.sortMerchantNameAscendingFn = function(a, b) {
    a = this.getBusinessName(a);
    b = this.getBusinessName(b);
    return this.sortAscendingFunction(a, b);
  };

  SupportOrdersFilterConditionsModel.prototype.sortMerchantNameDescendingFn = function(a, b) {
    a = this.getBusinessName(a);
    b = this.getBusinessName(b);
    return this.sortDescendingFunction(a, b);
  };

  SupportOrdersFilterConditionsModel.prototype.sortExpiredDateAscendingFn = function(a, b) {
    a = this.parseAndAssignMaxValueIfDateIsNull(a);
    b = this.parseAndAssignMaxValueIfDateIsNull(b);
    return this.sortAscendingFunction(a, b);
  };

  SupportOrdersFilterConditionsModel.prototype.sortExpiredDateDescendingFn = function(a, b) {
    a = this.parseAndAssignMaxValueIfDateIsNull(a);
    b = this.parseAndAssignMaxValueIfDateIsNull(b);
    return this.sortDescendingFunction(a, b);
  };

  SupportOrdersFilterConditionsModel.prototype.getBusinessName = function(order) {
    var name, reservationSource;
    name = (function() {
      var ref;
      switch (order.DEAL_TYPE) {
        case 'GETAWAYS_MARKET_RATE':
          reservationSource = SupportUtilsHelper.getReservationSource(order);
          return reservationSource != null ? reservationSource.hotelName : void 0;
        default:
          return (ref = order.merchant) != null ? ref.name : void 0;
      }
    })();
    return name != null ? name.toUpperCase() : void 0;
  };

  SupportOrdersFilterConditionsModel.prototype.parseAndAssignMaxValueIfDateIsNull = function(a) {
    if (a.groupons[0].expiresAt === null) {
      return a = Number.MAX_VALUE;
    } else {
      return a = getMillisecondsOfUTCDateFromISOStringDate(a.groupons[0].expiresAt);
    }
  };

  SupportOrdersFilterConditionsModel.prototype.sortDescendingFunction = function(a, b) {
    if (a < b) {
      return 1;
    }
    if (b < a) {
      return -1;
    }
    return 0;
  };

  SupportOrdersFilterConditionsModel.prototype.sortAscendingFunction = function(a, b) {
    if (a < b) {
      return -1;
    }
    if (b < a) {
      return 1;
    }
    return 0;
  };

  return SupportOrdersFilterConditionsModel;

})();

module.exports = SupportOrdersFilterConditionsModel;



},{"../helpers/utils":54}],69:[function(require,module,exports){
var SupportV1StepActionsModel;

SupportV1StepActionsModel = (function() {
  function SupportV1StepActionsModel() {}

  SupportV1StepActionsModel.prototype.toHash = function() {
    var hash, hash1, hash2, ref;
    hash1 = {
      orderId: ((ref = Groupon.Support.currentOrder) != null ? ref.id : void 0) != null ? Groupon.Support.currentOrder.id.toString() : "noorder",
      tagline: Groupon.Support.Tagline != null ? Groupon.Support.Tagline : "",
      notOrderRelatedText: I18n.t("js.modules.support.quesorder"),
      isRefundEligible: window.evaluate(Groupon.Support.ContentModel.isRefundEligible)
    };
    if (!window.isUS()) {
      hash1.intl = "intl-not-order-related";
    }
    if (window.faqInsteadHelpWizard === true) {
      hash2 = {
        contToStepTwoBtnText: I18n.t("js.modules.support.cont_to_step2"),
        contToStepThreeBtnText: I18n.t("js.modules.support.cont_to_contact_us"),
        needHelpBtnText: I18n.t("js.modules.support.no_contact_us")
      };
    } else {
      hash2 = {
        contToStepTwoBtnText: I18n.t("js.modules.support.contorder"),
        needHelpBtnText: I18n.t("js.modules.support.needhelp"),
        refundMyRequest: I18n.t("js.modules.support.req_my_refund"),
        contToStepThreeBtnText: I18n.t("js.modules.support.cont")
      };
    }
    hash = _.extend(hash1, hash2);
    if (Groupon.Support.MAXINDEX === 3) {
      if (Groupon.Support.CURRENTVIEW.id === 1) {
        _.extend(hash, window.getOrderInfoForBH(Groupon.Support.currentOrder));
      } else if (Groupon.Support.CURRENTVIEW.id === 2) {
        hash.showChat = Groupon.Support.LiveChatModel.shouldShowStepTwoLiveChat();
      }
    } else if (Groupon.Support.MAXINDEX === 2) {
      if (Groupon.Support.CURRENTVIEW.id === 1) {
        hash.showChat = Groupon.Support.LiveChatModel.shouldShowStepTwoLiveChat();
      }
    }
    return hash;
  };

  return SupportV1StepActionsModel;

})();

module.exports = SupportV1StepActionsModel;



},{}],70:[function(require,module,exports){
var Backbone, SupportV2OptimizedContactChannelsModel, V2OptimizedContactChannelsTemplate,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Backbone = require('backbone');

V2OptimizedContactChannelsTemplate = require('../../v2_optimized_contact_channels.html.mustache');

SupportV2OptimizedContactChannelsModel = (function(superClass) {
  extend(SupportV2OptimizedContactChannelsModel, superClass);

  function SupportV2OptimizedContactChannelsModel() {
    return SupportV2OptimizedContactChannelsModel.__super__.constructor.apply(this, arguments);
  }

  SupportV2OptimizedContactChannelsModel.prototype.initialize = function() {
    return this.template = V2OptimizedContactChannelsTemplate;
  };

  SupportV2OptimizedContactChannelsModel.prototype.toHash = function() {
    this.setOrderInfo();
    this.setIssueInfo();
    return this.toJSON();
  };

  SupportV2OptimizedContactChannelsModel.prototype.setOrderInfo = function() {
    var order, ref, ref1, title;
    order = Groupon.Support.currentOrder;
    if (order) {
      title = ((ref = order.deal) != null ? ref.title : void 0) || ((ref1 = order.merchant) != null ? ref1.name : void 0);
      if (title) {
        return this.set('orderMsg', I18n.translate('js.modules.support.issue_about_this_order', {
          dealTitle: title
        }));
      }
    }
  };

  SupportV2OptimizedContactChannelsModel.prototype.setIssueInfo = function() {
    var issue, ref;
    issue = Groupon.Support.ContentModel.getSearchInputIssue() || ((ref = Groupon.Support.ContentModel.getSubCategory()) != null ? ref.text : void 0);
    if (issue) {
      return this.set('issueMsg', I18n.translate('js.modules.support.saw_you_have_issue', {
        issue: issue
      }));
    }
  };

  SupportV2OptimizedContactChannelsModel.prototype.hidePreferencedContactChannel = function() {
    var optimizedContactChannels;
    optimizedContactChannels = [this.optimizephoneBtnElem(), this.optimizeEmailBtnElem(), this.optimizedLiveChatContainer()];
    return removePreferredContactClass(optimizedContactChannels);
  };

  SupportV2OptimizedContactChannelsModel.prototype.showPreferencedContactChannel = function(type) {
    var preferredContactElem;
    switch (type) {
      case "chat":
        preferredContactElem = this.optimizedLiveChatContainer();
        break;
      case "email":
        preferredContactElem = this.optimizeEmailBtnElem();
        break;
      case "phone":
        preferredContactElem = this.optimizephoneBtnElem();
    }
    return addPreferredContactClass(preferredContactElem);
  };

  SupportV2OptimizedContactChannelsModel.prototype.optimizedLiveChatVisible = function() {
    return window.liveChatVisible($(".live-chat-container.optimized-contact-channel a img"));
  };

  SupportV2OptimizedContactChannelsModel.prototype.setOptimizedLiveChatDisplayCallBack = function(liveChatDisplayCallback) {
    return window.setLiveChatDisplayCallBack($(".live-chat-container.optimized-contact-channel a img"), liveChatDisplayCallback);
  };

  SupportV2OptimizedContactChannelsModel.prototype.optimizephoneBtnElem = function() {
    return $('.optimized-phone-btn');
  };

  SupportV2OptimizedContactChannelsModel.prototype.optimizeEmailBtnElem = function() {
    return $('.optimized-email-us');
  };

  SupportV2OptimizedContactChannelsModel.prototype.optimizedLiveChatContainer = function() {
    return $('.optimized-live-chat-container');
  };

  SupportV2OptimizedContactChannelsModel.prototype.emailRecommendationTextElement = function() {
    return $('');
  };

  SupportV2OptimizedContactChannelsModel.prototype.phoneRecommendationTextElement = function() {
    return $('');
  };

  return SupportV2OptimizedContactChannelsModel;

})(Backbone.Model);

module.exports = SupportV2OptimizedContactChannelsModel;



},{"../../v2_optimized_contact_channels.html.mustache":244,"backbone":245}],71:[function(require,module,exports){
var SupportV2StepActionsModel;

SupportV2StepActionsModel = (function() {
  function SupportV2StepActionsModel(options) {
    if (options == null) {
      options = {};
    }
    this.options = options;
  }

  SupportV2StepActionsModel.prototype.toHash = function() {
    var hash, ref;
    hash = {
      isV2: true,
      contToStepTwoBtnText: I18n.t("js.modules.support.contorder"),
      needHelpBtnText: I18n.t("js.modules.support.needhelp"),
      refundMyRequest: I18n.t("js.modules.support.req_my_refund"),
      contToStepThreeBtnText: I18n.t("js.modules.support.cont"),
      orderId: ((ref = Groupon.Support.currentOrder) != null ? ref.id : void 0) != null ? Groupon.Support.currentOrder.id.toString() : "noorder",
      tagline: Groupon.Support.Tagline != null ? Groupon.Support.Tagline : "",
      isPriorityViewsEnabled: window.priorityViewsEnabled(),
      isRefundEligible: window.evaluate(Groupon.Support.ContentModel.isRefundEligible)
    };
    if (this.options.showVerticalView) {
      hash.showVerticalView = true;
    }
    if (Groupon.Support.MAXINDEX === 3) {
      if (Groupon.Support.CURRENTVIEW.id === 1) {
        if (Groupon.Support.currentOrder) {
          _.extend(hash, window.getOrderInfoForBH(Groupon.Support.currentOrder));
          hash.showOrderDetailsActions = true;
        } else {
          hash.showOrderListingActions = true;
        }
      } else if (Groupon.Support.CURRENTVIEW.id === 2) {
        hash.showChat = Groupon.Support.LiveChatModel.shouldShowStepTwoLiveChat();
      }
    } else if (Groupon.Support.MAXINDEX === 2) {
      if (Groupon.Support.CURRENTVIEW.id === 1) {
        hash.showChat = Groupon.Support.LiveChatModel.shouldShowStepTwoLiveChat();
      }
    }
    return hash;
  };

  return SupportV2StepActionsModel;

})();

module.exports = SupportV2StepActionsModel;



},{}],72:[function(require,module,exports){
var SupportBasePresentation, SupportPresenterUtilPresentation, SupportUtilsHelper;

SupportUtilsHelper = require('../helpers/utils');

SupportPresenterUtilPresentation = require('./presenter_util');

SupportBasePresentation = (function() {
  function SupportBasePresentation(order) {
    this.order = order;
  }

  SupportBasePresentation.prototype.getStatus = function() {
    var keyPrefix, value;
    keyPrefix = this.getLookupKeySequence();
    value = SupportPresenterUtilPresentation.prototype.lookup(this.getLookupObject(), keyPrefix, SupportPresenterUtilPresentation.prototype.STATUS);
    if (value == null) {
      value = this.convertToReadableText(this.order.STATE);
    }
    return value;
  };

  SupportBasePresentation.prototype.getNotes = function() {
    var keyPrefix, value;
    keyPrefix = this.getLookupKeySequence();
    value = SupportPresenterUtilPresentation.prototype.lookup(this.getLookupObject(), keyPrefix, SupportPresenterUtilPresentation.prototype.NOTES);
    if (value == null) {
      value = '';
    }
    return value;
  };

  SupportBasePresentation.prototype.getLookupKeySequence = function() {
    var keys;
    if (this.order != null) {
      keys = [];
      if (this.canShowGiftInfo()) {
        keys.push(SupportPresenterUtilPresentation.prototype.getGiftDeliveryMethod(this.order));
      } else if (this.isGDTOrder()) {
        keys = SupportPresenterUtilPresentation.prototype.getGDTKeys(this.order);
      } else {
        keys.push(SupportPresenterUtilPresentation.prototype.getEditableKey(this.order.isEditable));
        keys.push(SupportPresenterUtilPresentation.prototype.getStatusKey(this.order));
      }
      return SupportPresenterUtilPresentation.prototype.concatenateLookupKeys(keys);
    }
  };

  SupportBasePresentation.prototype.getLookupObject = function() {
    return console.log("No implementation");
  };

  SupportBasePresentation.prototype.canShowGiftInfo = function() {
    return this.isGift(this.order) && (SupportPresenterUtilPresentation.prototype.getStatusKey(this.order) !== 'REFUNDED') && (!SupportUtilsHelper.isCurrentOrderGoodsDeal());
  };

  SupportBasePresentation.prototype.isGift = function() {
    return this.order.isGift && this.order.giftInfo;
  };

  SupportBasePresentation.prototype.isGDTOrder = function() {
    var ref;
    return SupportUtilsHelper.isCurrentOrderLocalDeal() && window.evaluate((ref = this.order.deal) != null ? ref.isGDTDeal : void 0);
  };

  SupportBasePresentation.prototype.convertToReadableText = function(value) {
    var i, len, lowercase, piece, pieces, words;
    if (!!value) {
      lowercase = value.toLowerCase();
      pieces = lowercase.split("_");
      words = [];
      for (i = 0, len = pieces.length; i < len; i++) {
        piece = pieces[i];
        if (!!piece) {
          words.push(piece.charAt(0).toUpperCase() + piece.slice(1));
        }
      }
      if (words.length > 1) {
        return words.join(" ");
      } else {
        return words[0];
      }
    }
  };

  return SupportBasePresentation;

})();

module.exports = SupportBasePresentation;



},{"../helpers/utils":54,"./presenter_util":99}],73:[function(require,module,exports){
var SupportDefaultStatusAndNotesPresentation;

SupportDefaultStatusAndNotesPresentation = {
  egift: {
    status: 'Purchased as a gift',
    notes: "This gift voucher has been sent via email—you cannot resend this gift via My Groupons. If the recipient didn't receive the email, you can still print the voucher from My Groupons and send it to them. <a href='/faq#gifts'> See more information on gifts</a>"
  },
  gdt: {
    un_redeemed: {
      status: "Ready to use",
      notes: "To use your Groupon, click \"Order Food\"."
    },
    redeemed: {
      status: "Used on <span class='localtime'>{{redeemed_date}}</span>",
      notes: ""
    }
  },
  printed_gift: {
    status: 'Purchased as a gift',
    notes: "You cannot resend this gift via My Groupons. If you still need to send the gift to the recipient, you can print the voucher from My Groupons and send it to them. <a href='/faq#gifts'> See more information on gifts</a>"
  },
  editable: {
    pending: {
      status: "Processing",
      notes: "Your credit card will be charged within 24 hours. We'll send a confirmation email with your order details as soon as we process the transaction."
    },
    failed: {
      status: "Problem charging your credit card",
      notes: "We weren’t able to complete this transaction using the credit card you provided. Please edit your payment information to receive your Groupon voucher."
    },
    refunded: {
      status: "Refunded",
      notes: "This Groupon has been refunded—please allow 10 business days for your credit or debit card statement to be updated. Refunds to Groupon Bucks are available immediately in your Groupon account."
    },
    refund_pending: {
      status: "Refund Pending",
      notes: "This Groupon has been refunded—please allow 10 business days for your credit or debit card statement to be updated. Refunds to Groupon Bucks are available immediately in your Groupon account."
    }
  },
  not_editable: {
    pending: {
      status: "Processing",
      notes: "Your credit card will be charged within 24 hours. We'll send a confirmation email with your order details as soon as we process the transaction."
    },
    failed: {
      status: "Problem charging your credit card",
      notes: "We weren’t able to complete this transaction using the credit card you provided. Please edit your payment information to receive your Groupon voucher."
    },
    refunded: {
      status: "Refunded",
      notes: "This Groupon has been refunded—please allow 10 business days for your credit or debit card statement to be updated. Refunds to Groupon Bucks are available immediately in your Groupon account."
    },
    refund_pending: {
      status: "Refund Pending",
      notes: "This Groupon has been refunded—please allow 10 business days for your credit or debit card statement to be updated. Refunds to Groupon Bucks are available immediately in your Groupon account."
    }
  }
};

module.exports = SupportDefaultStatusAndNotesPresentation;



},{}],74:[function(require,module,exports){
var SupportFinePrintPresenterPresentation, SupportUtilsHelper;

SupportUtilsHelper = require('../helpers/utils');

SupportFinePrintPresenterPresentation = (function() {
  function SupportFinePrintPresenterPresentation() {}

  SupportFinePrintPresenterPresentation.prototype.present = function(order) {
    var text;
    return text = (function() {
      switch (order.DEAL_TYPE) {
        case 'GETAWAYS_MARKET_RATE':
          return this.marketRateFinePrintConstructor(order);
        default:
          return this.v1FinePrintConstructor(order);
      }
    }).call(this);
  };

  SupportFinePrintPresenterPresentation.prototype.v1FinePrintConstructor = function(order) {
    var ref;
    if (order == null) {
      return "";
    }
    return replaceNewLineWithBreak((ref = order.deal) != null ? ref.finePrint : void 0);
  };

  SupportFinePrintPresenterPresentation.prototype.marketRateFinePrintConstructor = function(order) {
    var cancellationPolicies, reservationSource;
    reservationSource = SupportUtilsHelper.getReservationSource(order);
    if (reservationSource == null) {
      return "";
    }
    cancellationPolicies = _.reduce(reservationSource.cancellationPolicies, (function(memo, policy) {
      return "" + memo + policy.descriptionHtml + " <br />";
    }), "");
    return reservationSource.crsPolicyHtml + " <br />Cancellation Policies <br /><br /> " + cancellationPolicies;
  };

  return SupportFinePrintPresenterPresentation;

})();

module.exports = SupportFinePrintPresenterPresentation;



},{"../helpers/utils":54}],75:[function(require,module,exports){
var SupportGetawaysBookingStatusAndNotesPresentation;

SupportGetawaysBookingStatusAndNotesPresentation = {
  editable: {
    status: "Booked",
    notes: "You can cancel this reservation anytime before cancellation date listed in fine print."
  },
  not_editable: {
    available: {
      status: "Booked",
      notes: ""
    },
    non_cancellable: {
      status: "Booked",
      notes: "You may no longer edit this booking because the cancellation window has passed"
    },
    redeemed: {
      status: "Used on <span class='localtime'>{{redeemed_date}}</span>",
      notes: ""
    },
    expired: {
      status: "Reservation has passed",
      notes: ""
    },
    expired_redeemed: {
      status: "Reservation has passed",
      notes: ""
    },
    expired_unredeemed: {
      status: "Reservation has passed",
      notes: ""
    }
  }
};

module.exports = SupportGetawaysBookingStatusAndNotesPresentation;



},{}],76:[function(require,module,exports){
var SupportBasePresentation, SupportGetawaysBookingPresenterPresentation, SupportGetawaysBookingStatusAndNotesPresentation, SupportPresenterUtilPresentation,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportBasePresentation = require('./base');

SupportPresenterUtilPresentation = require('./presenter_util');

SupportGetawaysBookingStatusAndNotesPresentation = require('./getaways_booking_messages');

SupportGetawaysBookingPresenterPresentation = (function(superClass) {
  extend(SupportGetawaysBookingPresenterPresentation, superClass);

  function SupportGetawaysBookingPresenterPresentation() {
    return SupportGetawaysBookingPresenterPresentation.__super__.constructor.apply(this, arguments);
  }

  SupportGetawaysBookingPresenterPresentation.prototype.getLookupObject = function() {
    return SupportGetawaysBookingStatusAndNotesPresentation;
  };

  SupportGetawaysBookingPresenterPresentation.prototype.getLookupKeySequence = function() {
    var keys;
    keys = [];
    if (this.order != null) {
      keys.push(SupportPresenterUtilPresentation.prototype.getEditableKey(this.order.isEditable));
      keys.push(SupportPresenterUtilPresentation.prototype.getGetawaysBookingStatus(this.order));
    }
    return SupportPresenterUtilPresentation.prototype.concatenateLookupKeys(keys);
  };

  return SupportGetawaysBookingPresenterPresentation;

})(SupportBasePresentation);

module.exports = SupportGetawaysBookingPresenterPresentation;



},{"./base":72,"./getaways_booking_messages":75,"./presenter_util":99}],77:[function(require,module,exports){
var SupportGetawaysMarketRateStatusAndNotesPresentation;

SupportGetawaysMarketRateStatusAndNotesPresentation = {
  confirmed: {
    status: "Booked",
    notes: "Your reservation had been confirmed, but you can double-check by giving the merchant a call at the phone number in your order details."
  },
  used: {
    status: "Reservation has passed",
    notes: ""
  },
  cancelled: {
    status: "Cancelled",
    notes: "Your 5% Groupon Bucks credit has also been cancelled."
  }
};

module.exports = SupportGetawaysMarketRateStatusAndNotesPresentation;



},{}],78:[function(require,module,exports){
var SupportBasePresentation, SupportGetawaysMarketRatePresenterPresentation, SupportGetawaysMarketRateStatusAndNotesPresentation, SupportPresenterUtilPresentation,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportBasePresentation = require('./base');

SupportPresenterUtilPresentation = require('./presenter_util');

SupportGetawaysMarketRateStatusAndNotesPresentation = require('./getaways_market_rate_messages');

SupportGetawaysMarketRatePresenterPresentation = (function(superClass) {
  extend(SupportGetawaysMarketRatePresenterPresentation, superClass);

  function SupportGetawaysMarketRatePresenterPresentation() {
    return SupportGetawaysMarketRatePresenterPresentation.__super__.constructor.apply(this, arguments);
  }

  SupportGetawaysMarketRatePresenterPresentation.prototype.getLookupObject = function() {
    return SupportGetawaysMarketRateStatusAndNotesPresentation;
  };

  SupportGetawaysMarketRatePresenterPresentation.prototype.getLookupKeySequence = function() {
    var keys;
    keys = [];
    if (this.order != null) {
      keys.push(SupportPresenterUtilPresentation.prototype.getStatusKey(this.order));
    }
    return SupportPresenterUtilPresentation.prototype.concatenateLookupKeys(keys);
  };

  return SupportGetawaysMarketRatePresenterPresentation;

})(SupportBasePresentation);

module.exports = SupportGetawaysMarketRatePresenterPresentation;



},{"./base":72,"./getaways_market_rate_messages":77,"./presenter_util":99}],79:[function(require,module,exports){
var SupportGetawaysTonightStatusAndNotesPresentation;

SupportGetawaysTonightStatusAndNotesPresentation = {
  confirmed: {
    status: "Booked",
    notes: "Your reservation is scheduled for tonight. If you need immediate assistance, contact us at 888-963-3633 from 8 a.m. - 6 p.m. CT."
  },
  used: {
    status: "Reservation has passed"
  },
  failed: {
    status: "Problem charging your credit card"
  }
};

module.exports = SupportGetawaysTonightStatusAndNotesPresentation;



},{}],80:[function(require,module,exports){
var SupportBasePresentation, SupportGetawaysTonightPresenterPresentation, SupportGetawaysTonightStatusAndNotesPresentation, SupportPresenterUtilPresentation,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportBasePresentation = require('./base');

SupportPresenterUtilPresentation = require('./presenter_util');

SupportGetawaysTonightStatusAndNotesPresentation = require('./getaways_tonight_messages');

SupportGetawaysTonightPresenterPresentation = (function(superClass) {
  extend(SupportGetawaysTonightPresenterPresentation, superClass);

  function SupportGetawaysTonightPresenterPresentation() {
    return SupportGetawaysTonightPresenterPresentation.__super__.constructor.apply(this, arguments);
  }

  SupportGetawaysTonightPresenterPresentation.prototype.getLookupObject = function() {
    return SupportGetawaysTonightStatusAndNotesPresentation;
  };

  SupportGetawaysTonightPresenterPresentation.prototype.getLookupKeySequence = function() {
    var keys;
    keys = [];
    if (this.order != null) {
      keys.push(SupportPresenterUtilPresentation.prototype.getStatusKey(this.order));
    }
    return SupportPresenterUtilPresentation.prototype.concatenateLookupKeys(keys);
  };

  return SupportGetawaysTonightPresenterPresentation;

})(SupportBasePresentation);

module.exports = SupportGetawaysTonightPresenterPresentation;



},{"./base":72,"./getaways_tonight_messages":79,"./presenter_util":99}],81:[function(require,module,exports){
var SupportGetawaysVoucherStatusAndNotesPresentation;

SupportGetawaysVoucherStatusAndNotesPresentation = {
  editable: {
    status: "Can be edited until <span class='localtime'>{{editable_deadline}}</span>",
    notes: "You can edit this order until <span class='longlocaltime'>{{editable_deadline}}</span>. However, it cannot be edited after you have viewed or printed your Groupon voucher."
  },
  not_editable: {
    redeemed: {
      status: "Used on <span class='localtime'>{{redeemed_date}}</span>",
      notes: ""
    },
    purchased: {
      status: "Processing",
      notes: ""
    },
    available: {
      status: "Ready to print",
      notes: "To use your Groupon, click \"View Voucher\" and follow the steps under \"How to Use This\" on your Groupon. "
    },
    expired: {
      status: "Expired",
      notes: ""
    },
    expired_unredeemed: {
      status: "Promotional value expired on <span class='utctime'>{{expiration_date}}</span>",
      notes: "Even though your Groupon has expired, you can still redeem it at <strong>{{merchant_name}}</strong> for the amount you paid for it."
    },
    expired_redeemed: {
      status: "Used on <span class='localtime'>{{redeemed_date}}</span>",
      notes: ""
    }
  }
};

module.exports = SupportGetawaysVoucherStatusAndNotesPresentation;



},{}],82:[function(require,module,exports){
var SupportBasePresentation, SupportGetawaysVoucherPresenterPresentation, SupportGetawaysVoucherStatusAndNotesPresentation, SupportPresenterUtilPresentation,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportBasePresentation = require('./base');

SupportPresenterUtilPresentation = require('./presenter_util');

SupportGetawaysVoucherStatusAndNotesPresentation = require('./getaways_voucher_messages');

SupportGetawaysVoucherPresenterPresentation = (function(superClass) {
  extend(SupportGetawaysVoucherPresenterPresentation, superClass);

  function SupportGetawaysVoucherPresenterPresentation() {
    return SupportGetawaysVoucherPresenterPresentation.__super__.constructor.apply(this, arguments);
  }

  SupportGetawaysVoucherPresenterPresentation.prototype.getLookupObject = function() {
    return SupportGetawaysVoucherStatusAndNotesPresentation;
  };

  return SupportGetawaysVoucherPresenterPresentation;

})(SupportBasePresentation);

module.exports = SupportGetawaysVoucherPresenterPresentation;



},{"./base":72,"./getaways_voucher_messages":81,"./presenter_util":99}],83:[function(require,module,exports){
var SupportGoodsShippingStatusAndNotesPresentation;

SupportGoodsShippingStatusAndNotesPresentation = {
  editable: {
    notes: "You can edit this order and your shipping details until it is processed.",
    status: "Processing",
    available: {
      fulfilled_enabled: {
        status: "Ordered",
        notes: "You can still make changes to this order until {{isEditableUntil}}"
      },
      shipments_available: {
        status: "Shipped",
        notes: "Unless the deal's Fine Print states otherwise, you can return Groupon Goods anytime within 14 days of delivery.",
        returnable: {
          notes: "Unless the deal's Fine Print states otherwise, you can return Groupon Goods anytime within 14 days of delivery.",
          return_initiated_label_not_printed: {
            status: "Returns Initiated",
            notes: "Your return for this item is currently in progress."
          },
          return_initiated_label_printed: {
            status: "Processing Returns",
            notes: "Your return for this item is currently in progress."
          }
        },
        not_returnable: {
          time_exceeded: {
            notes: "This Groupon Goods purchase is no longer returnable. Items must be returned within 14 days of delivery."
          },
          non_returnable: {
            notes: "As stated in the deal's Fine Print, this Groupon Goods purchase is not returnable."
          }
        }
      },
      shipments_processing: {
        status: "Ordered",
        notes: "Tracking information is not available for this order, but your Groupon Goods should arrive within two and a half weeks of your purchase date.",
        returnable: {
          notes: "Unless the deal's Fine Print states otherwise, you can return Groupon Goods anytime within 14 days of delivery.",
          return_initiated_label_not_printed: {
            status: "Returns Initiated",
            notes: "Your return for this item is currently in progress."
          },
          return_initiated_label_printed: {
            status: "Processing Returns",
            notes: "Your return for this item is currently in progress."
          }
        }
      },
      shipments_not_available: {
        status: "Ordered",
        notes: "Tracking information is not available for this order, but your Groupon Goods should arrive within two and a half weeks of your purchase date.",
        returnable: {
          notes: "Unless the deal's Fine Print states otherwise, you can return Groupon Goods anytime within 14 days of delivery.",
          return_initiated_label_not_printed: {
            status: "Returns Initiated",
            notes: "Your return for this item is currently in progress."
          },
          return_initiated_label_printed: {
            status: "Processing Returns",
            notes: "Your return for this item is currently in progress."
          }
        }
      }
    }
  },
  not_editable: {
    order_received: {
      status: "Ordered",
      dropship: {
        notes: "Your order was placed {{number_of_business_days_ago}} business days ago and can no longer be changed. You can expect to receive an email with tracking information within 2-4 business days of your purchase."
      },
      "post-deal_purchase_3pl": {
        notes: "Your order was placed {{number_of_business_days_ago}} business days ago and can no longer be changed. You can expect to receive an email with tracking information within 6-9 business days of your purchase."
      },
      "pre-deal_purchase_3pl": {
        notes: "Your order was placed {{number_of_business_days_ago}} business days ago and can no longer be changed. You can expect to receive an email with tracking information within 2-4 business days of your purchase."
      }
    },
    processing_order: {
      status: "Processing order",
      dropship: {
        notes: "You can expect to receive an email with tracking information within 2-4 business days of your purchase. Your order was placed {{number_of_business_days_ago}} business days ago and can no longer be changed."
      },
      "post-deal_purchase_3pl": {
        notes: "You can expect to receive an email with tracking information within 6-9 business days of your purchase. Your order was placed {{number_of_business_days_ago}} business days ago and can no longer be changed. "
      },
      "pre-deal_purchase_3pl": {
        notes: "You can expect to receive an email with tracking information within 2-4 business days of your purchase. Your order was placed {{number_of_business_days_ago}} business days ago and can no longer be changed."
      }
    },
    preparing_shipment: {
      status: "Preparing to Ship",
      dropship: {
        notes: "{{shipping_soon_msg_plus_two_business_days}} This order can no longer be changed."
      },
      "post-deal_purchase_3pl": {
        notes: "{{shipping_soon_msg}} This order can no longer be changed."
      },
      "pre-deal_purchase_3pl": {
        notes: "{{shipping_soon_msg_plus_two_business_days}} This order can no longer be changed."
      }
    },
    shipped: {
      status: "In Transit",
      dropship: {
        notes: "Your order shipped on {{shipped_date}} and is on its way to you!. You can expect delivery within 4-7 business days from this date."
      },
      "post-deal_purchase_3pl": {
        notes: "Your order shipped on {{shipped_date}} and is on its way to you!. You can expect delivery within 4-7 business days from this date."
      },
      "pre-deal_purchase_3pl": {
        notes: "Your order shipped on {{shipped_date}} and is on its way to you!. You can expect delivery within 4-7 business days from this date. Please allow up to 72 hours for tracking information to be available from the shipping company."
      }
    },
    out_for_delivery: {
      status: "Out for delivery",
      notes: "Your order is out for delivery on {{out_for_delivery_date}}!"
    },
    delivered: {
      status: "Delivered",
      notes: "Your order was delivered on {{delivered_date}}"
    },
    error: {
      status: "Shipped",
      notes: "Please visit {{carrier_name}} website for progress on you shipment. Your tracking number is {{tracking_number}}"
    },
    available: {
      shipments_available: {
        status: "Shipped",
        notes: "Unless the deal's Fine Print states otherwise, you can return Groupon Goods anytime within 14 days of delivery.",
        returnable: {
          notes: "Unless the deal's Fine Print states otherwise, you can return Groupon Goods anytime within 14 days of delivery.",
          return_initiated_label_not_printed: {
            status: "Returns Initiated",
            notes: "Your return for this item is currently in progress."
          },
          return_initiated_label_printed: {
            status: "Processing Returns",
            notes: "Your return for this item is currently in progress."
          }
        },
        not_returnable: {
          time_exceeded: {
            notes: "This Groupon Goods purchase is no longer returnable. Items must be returned within 14 days of delivery."
          },
          non_returnable: {
            notes: "As stated in the deal's Fine Print, this Groupon Goods purchase is not returnable."
          }
        }
      },
      shipments_processing: {
        status: "Processing order",
        notes: "Tracking information is not available for this order, but your Groupon Goods should arrive within two and a half weeks of your purchase date.",
        returnable: {
          notes: "Unless the deal's Fine Print states otherwise, you can return Groupon Goods anytime within 14 days of delivery.",
          return_initiated_label_not_printed: {
            status: "Returns Initiated",
            notes: "Your return for this item is currently in progress."
          },
          return_initiated_label_printed: {
            status: "Processing Returns",
            notes: "Your return for this item is currently in progress."
          }
        }
      },
      shipments_not_available: {
        status: "Processing order",
        notes: "Tracking information is not available for this order, but your Groupon Goods should arrive within two and a half weeks of your purchase date.",
        returnable: {
          notes: "Unless the deal's Fine Print states otherwise, you can return Groupon Goods anytime within 14 days of delivery.",
          return_initiated_label_not_printed: {
            status: "Returns Initiated",
            notes: "Your return for this item is currently in progress."
          },
          return_initiated_label_printed: {
            status: "Processing Returns",
            notes: "Your return for this item is currently in progress."
          }
        }
      }
    },
    redeemed: {
      status: "Used on <span class='localtime'>{{redeemed_date}}</span>",
      notes: ""
    },
    expired: {
      status: "Expired",
      notes: ""
    },
    expired_unredeemed: {
      status: "Expired",
      notes: ""
    },
    expired_redeemed: {
      status: "Used on <span class='localtime'>{{redeemed_date}}</span>",
      notes: ""
    }
  }
};

module.exports = SupportGoodsShippingStatusAndNotesPresentation;



},{}],84:[function(require,module,exports){
var SupportBasePresentation, SupportGoodsShippingPresenterPresentation, SupportGoodsShippingStatusAndNotesPresentation, SupportPresenterUtilPresentation,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportBasePresentation = require('./base');

SupportPresenterUtilPresentation = require('./presenter_util');

SupportGoodsShippingStatusAndNotesPresentation = require('./goods_shipping_messages');

SupportGoodsShippingPresenterPresentation = (function(superClass) {
  extend(SupportGoodsShippingPresenterPresentation, superClass);

  function SupportGoodsShippingPresenterPresentation() {
    return SupportGoodsShippingPresenterPresentation.__super__.constructor.apply(this, arguments);
  }


  /*
  This function aims to get the lookup key for messages lookup for goods.
  The lookup key should be constructed in the sequence GOODS$$<<editabfle>>$$<<status>>$$..
   */

  SupportGoodsShippingPresenterPresentation.prototype.getLookupKeySequence = function() {
    var keys;
    keys = [];
    if (this.order != null) {
      keys.push(SupportPresenterUtilPresentation.prototype.getEditableKey(this.order.isEditable));
      if (this.order.isEditable) {
        this.addReturnableKeys(this.order, keys);
      } else if (this.shouldUseFulfillmentInfo()) {
        keys.push(SupportPresenterUtilPresentation.prototype.getShipmentStatusKey(this.order));
        keys.push(SupportPresenterUtilPresentation.prototype.getFulfillmentMethodKey(this.order));
      } else {
        this.addReturnableKeys(this.order, keys);
      }
      return SupportPresenterUtilPresentation.prototype.concatenateLookupKeys(keys);
    }
  };

  SupportGoodsShippingPresenterPresentation.prototype.shouldUseFulfillmentInfo = function() {
    var ref;
    return this.order.STATE !== 'REFUNDED' && ((ref = this.order.shipmentDetails) != null ? ref.SHIPMENT_STATE : void 0) && this.order.shipmentDetails.SHIPMENT_STATE !== 'ORDER_CANCELLED';
  };

  SupportGoodsShippingPresenterPresentation.prototype.getLookupObject = function() {
    return SupportGoodsShippingStatusAndNotesPresentation;
  };

  SupportGoodsShippingPresenterPresentation.prototype.addReturnableKeys = function(order, keys) {
    var isReturnable;
    isReturnable = SupportPresenterUtilPresentation.prototype.isReturnable(order);
    keys.push(SupportPresenterUtilPresentation.prototype.getStatusKey(order));
    keys.push(SupportPresenterUtilPresentation.prototype.getShipmentKey(order));
    keys.push(SupportPresenterUtilPresentation.prototype.getReturnableKey(isReturnable));
    return keys.push(SupportPresenterUtilPresentation.prototype.getReturnabilityLabelPrintingStatus(order));
  };

  return SupportGoodsShippingPresenterPresentation;

})(SupportBasePresentation);

module.exports = SupportGoodsShippingPresenterPresentation;



},{"./base":72,"./goods_shipping_messages":83,"./presenter_util":99}],85:[function(require,module,exports){
var SupportGoodsVoucherStatusAndNotesPresentation;

SupportGoodsVoucherStatusAndNotesPresentation = {
  editable: {
    status: "Can be edited until <span class='localtime'>{{editable_deadline}}</span>",
    notes: "You can edit this order until 24 hours after purchase. However, it cannot be edited after you have viewed or printed your Groupon voucher."
  },
  not_editable: {
    available: {
      status: "Ready to print",
      notes: "To use your Groupon, click \"View Voucher\" and follow the steps under \"How to Use This\" on your Groupon."
    },
    redeemed: {
      status: "Used on <span class='localtime'>{{redeemed_date}}</span>",
      notes: ""
    },
    expired: {
      status: "Expired",
      notes: ""
    },
    expired_unredeemed: {
      status: "Promotional value expired on <span class='utctime'>{{expiration_date}}</span>",
      notes: "Even though your Groupon has expired, you can still redeem it at <strong>{{merchant_name}}</strong> for the amount you paid for it."
    },
    expired_redeemed: {
      status: "Used on <span class='localtime'>{{redeemed_date}}</span>",
      notes: ""
    }
  }
};

module.exports = SupportGoodsVoucherStatusAndNotesPresentation;



},{}],86:[function(require,module,exports){
var SupportBasePresentation, SupportGoodsVoucherPresenterPresentation, SupportGoodsVoucherStatusAndNotesPresentation,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportBasePresentation = require('./base');

SupportGoodsVoucherStatusAndNotesPresentation = require('./goods_voucher_messages');

SupportGoodsVoucherPresenterPresentation = (function(superClass) {
  extend(SupportGoodsVoucherPresenterPresentation, superClass);

  function SupportGoodsVoucherPresenterPresentation() {
    return SupportGoodsVoucherPresenterPresentation.__super__.constructor.apply(this, arguments);
  }

  SupportGoodsVoucherPresenterPresentation.prototype.getLookupObject = function() {
    return SupportGoodsVoucherStatusAndNotesPresentation;
  };

  return SupportGoodsVoucherPresenterPresentation;

})(SupportBasePresentation);

module.exports = SupportGoodsVoucherPresenterPresentation;



},{"./base":72,"./goods_voucher_messages":85}],87:[function(require,module,exports){
var SupportGPassStatusAndNotesPresentation;

SupportGPassStatusAndNotesPresentation = {
  editable: {
    status: "Awaiting seating information",
    notes: "We'll make seating information available at least 24 hours before the event. You'll be able to print your G-Pass as soon as you receive the information."
  },
  not_editable: {
    purchased: {
      status: "Awaiting seating information",
      notes: "We'll make seating information available at least 24 hours before the event. You'll be able to print your G-Pass once you receive the information."
    },
    available: {
      status: "Ready to print",
      notes: "You can find your seating information on your G-pass. You'll be able to bypass will-call when you arrive at the event."
    },
    redeemed: {
      status: "Event has passed",
      notes: ""
    },
    expired: {
      status: "Event has passed",
      notes: ""
    },
    expired_unredeemed: {
      status: "Event has passed",
      notes: ""
    },
    expired_redeemed: {
      status: "Event has passed",
      notes: ""
    }
  }
};

module.exports = SupportGPassStatusAndNotesPresentation;



},{}],88:[function(require,module,exports){
var SupportBasePresentation, SupportGPassPresenterPresentation, SupportGPassStatusAndNotesPresentation,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportBasePresentation = require('./base');

SupportGPassStatusAndNotesPresentation = require('./gpass_messages');

SupportGPassPresenterPresentation = (function(superClass) {
  extend(SupportGPassPresenterPresentation, superClass);

  function SupportGPassPresenterPresentation() {
    return SupportGPassPresenterPresentation.__super__.constructor.apply(this, arguments);
  }

  SupportGPassPresenterPresentation.prototype.getLookupObject = function() {
    return SupportGPassStatusAndNotesPresentation;
  };

  return SupportGPassPresenterPresentation;

})(SupportBasePresentation);

module.exports = SupportGPassPresenterPresentation;



},{"./base":72,"./gpass_messages":87}],89:[function(require,module,exports){
var SupportLiveStatusAndNotesPresentation;

SupportLiveStatusAndNotesPresentation = {
  editable: {
    status: "Can be edited until <span class='localtime'>{{editable_deadline}}</span>",
    notes: "You can edit this order until 11:59 p.m. on the day you purchased. However, it cannot be edited after you view or print your Groupon."
  },
  not_editable: {
    redeemed: {
      status: "Event has passed",
      notes: ""
    },
    expired: {
      status: "Event has passed",
      notes: ""
    },
    expired_unredeemed: {
      status: "Event has passed",
      notes: ""
    },
    expired_redeemed: {
      status: "Event has passed",
      notes: ""
    },
    available: {
      status: "Ready to print",
      notes: ""
    }
  }
};

module.exports = SupportLiveStatusAndNotesPresentation;



},{}],90:[function(require,module,exports){
var SupportBasePresentation, SupportLivePresenterPresentation, SupportLiveStatusAndNotesPresentation,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportBasePresentation = require('./base');

SupportLiveStatusAndNotesPresentation = require('./live_messages');

SupportLivePresenterPresentation = (function(superClass) {
  extend(SupportLivePresenterPresentation, superClass);

  function SupportLivePresenterPresentation() {
    return SupportLivePresenterPresentation.__super__.constructor.apply(this, arguments);
  }

  SupportLivePresenterPresentation.prototype.getLookupObject = function() {
    return SupportLiveStatusAndNotesPresentation;
  };

  return SupportLivePresenterPresentation;

})(SupportBasePresentation);

module.exports = SupportLivePresenterPresentation;



},{"./base":72,"./live_messages":89}],91:[function(require,module,exports){
var SupportLiveVoucherStatusAndNotesPresentation;

SupportLiveVoucherStatusAndNotesPresentation = {
  editable: {
    status: "Can be edited until <span class='localtime'>{{editable_deadline}}</span>",
    notes: "You can edit this order until 11:59 p.m. on the day you purchased. However, it cannot be edited after you view or print your Groupon."
  },
  not_editable: {
    redeemed: {
      status: "Used on <span class='localtime'>{{redeemed_date}}</span>",
      notes: ""
    },
    expired: {
      status: "Event has passed",
      notes: ""
    },
    expired_unredeemed: {
      status: "Event has passed",
      notes: ""
    },
    expired_redeemed: {
      status: "Event has passed",
      notes: ""
    },
    redeemed: {
      status: "Used on <span class='localtime'>{{redeemed_date}}</span>",
      notes: ""
    },
    available: {
      status: "Ready to print",
      notes: "To use your Groupon, click \"View Voucher\" and follow the steps under \"How to Use This\" on your Groupon. "
    }
  }
};

module.exports = SupportLiveVoucherStatusAndNotesPresentation;



},{}],92:[function(require,module,exports){
var SupportBasePresentation, SupportLiveVoucherPresenterPresentation, SupportLiveVoucherStatusAndNotesPresentation,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportBasePresentation = require('./base');

SupportLiveVoucherStatusAndNotesPresentation = require('./live_voucher_messages');

SupportLiveVoucherPresenterPresentation = (function(superClass) {
  extend(SupportLiveVoucherPresenterPresentation, superClass);

  function SupportLiveVoucherPresenterPresentation() {
    return SupportLiveVoucherPresenterPresentation.__super__.constructor.apply(this, arguments);
  }

  SupportLiveVoucherPresenterPresentation.prototype.getLookupObject = function() {
    return SupportLiveVoucherStatusAndNotesPresentation;
  };

  return SupportLiveVoucherPresenterPresentation;

})(SupportBasePresentation);

module.exports = SupportLiveVoucherPresenterPresentation;



},{"./base":72,"./live_voucher_messages":91}],93:[function(require,module,exports){
var SupportLocalStatusAndNotesPresentation;

SupportLocalStatusAndNotesPresentation = {
  editable: {
    status: "Can be edited until <span class='localtime'>{{editable_deadline}}</span>",
    notes: "You can edit this order until <span class='longlocaltime'>{{editable_deadline}}</span>. However, it cannot be edited after you have viewed or printed your Groupon voucher."
  },
  not_editable: {
    purchased: {
      status: "Ready to print",
      notes: "To use your Groupon, click \"View Voucher\" and follow the steps under \"How to Use This\" on your Groupon."
    },
    redeemed: {
      status: "Used on <span class='localtime'>{{redeemed_date}}</span>",
      notes: ""
    },
    available: {
      status: "Ready to print",
      notes: "To use your Groupon, click \"View Voucher\" and follow the steps under \"How to Use This\" on your Groupon. "
    },
    expired: {
      status: "Expired",
      notes: ""
    },
    expired_unredeemed: {
      status: "Promotional value expired on <span class='utctime'>{{expiration_date}}</span>",
      notes: "Even though your Groupon has expired, you can still redeem it at <strong>{{merchant_name}}</strong> for the amount you paid for it."
    },
    expired_redeemed: {
      status: "Used on <span class='localtime'>{{redeemed_date}}</span>",
      notes: ""
    }
  }
};

module.exports = SupportLocalStatusAndNotesPresentation;



},{}],94:[function(require,module,exports){
var SupportBasePresentation, SupportLocalPresenterPresentation, SupportLocalStatusAndNotesPresentation,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportBasePresentation = require('./base');

SupportLocalStatusAndNotesPresentation = require('./local_messages');

SupportLocalPresenterPresentation = (function(superClass) {
  extend(SupportLocalPresenterPresentation, superClass);

  function SupportLocalPresenterPresentation() {
    return SupportLocalPresenterPresentation.__super__.constructor.apply(this, arguments);
  }

  SupportLocalPresenterPresentation.prototype.getLookupObject = function() {
    return SupportLocalStatusAndNotesPresentation;
  };

  return SupportLocalPresenterPresentation;

})(SupportBasePresentation);

module.exports = SupportLocalPresenterPresentation;



},{"./base":72,"./local_messages":93}],95:[function(require,module,exports){
var SupportMarketRateImagePresenterPresentation;

SupportMarketRateImagePresenterPresentation = (function() {
  function SupportMarketRateImagePresenterPresentation() {}

  SupportMarketRateImagePresenterPresentation.prototype.present = function(images) {
    var image, parts, ref, url;
    if (!((images != null ? images.length : void 0) > 0)) {
      return null;
    }
    image = _.first(images);
    url = image != null ? image.url : void 0;
    if (url != null) {
      if (!(((ref = url.match(/http/)) != null ? ref.index : void 0) === 0 || url.indexOf("//") === 0)) {
        url = "https://" + url;
      }
      parts = url.split("/v1/");
      if ((_.last(parts)) === '') {
        parts = _.initial(parts);
      }
      if (parts != null) {
        return _.reduce(parts, function(memo, part) {
          return memo + "/" + part;
        });
      }
    }
  };

  return SupportMarketRateImagePresenterPresentation;

})();

module.exports = SupportMarketRateImagePresenterPresentation;



},{}],96:[function(require,module,exports){
var SupportNowStatusAndNotesPresentation;

SupportNowStatusAndNotesPresentation = {
  editable: {
    status: "Can be edited until <span class='localtime'>{{editable_deadline}}</span>",
    notes: "You can edit this order until <span class='longlocaltime'>{{editable_deadline}}</span>. However, it cannot be edited after you have viewed or printed your Groupon voucher."
  },
  not_editable: {
    purchased: {
      status: "Ready to print",
      notes: "To use your Groupon, click \"View Voucher\" and follow the steps under \"How to Use This\" on your Groupon."
    },
    redeemed: {
      status: "Used on <span class='localtime'>{{redeemed_date}}</span>",
      notes: ""
    },
    available: {
      status: "Ready to print",
      notes: "To use your Groupon, click \"View Voucher\" and follow the steps under \"How to Use This\" on your Groupon. "
    },
    expired: {
      status: "Expired",
      notes: ""
    },
    expired_unredeemed: {
      status: "Promotional value expired on <span class='utctime'>{{expiration_date}}</span>",
      notes: "Even though your Groupon has expired, you can still redeem it at <strong>{{merchant_name}}</strong> for the amount you paid for it."
    },
    expired_redeemed: {
      status: "Used on <span class='localtime'>{{redeemed_date}}</span>",
      notes: ""
    }
  }
};

module.exports = SupportNowStatusAndNotesPresentation;



},{}],97:[function(require,module,exports){
var SupportBasePresentation, SupportNowPresenterPresentation, SupportNowStatusAndNotesPresentation,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportBasePresentation = require('./base');

SupportNowStatusAndNotesPresentation = require('./now_messages');

SupportNowPresenterPresentation = (function(superClass) {
  extend(SupportNowPresenterPresentation, superClass);

  function SupportNowPresenterPresentation() {
    return SupportNowPresenterPresentation.__super__.constructor.apply(this, arguments);
  }

  SupportNowPresenterPresentation.prototype.getLookupObject = function() {
    return SupportNowStatusAndNotesPresentation;
  };

  return SupportNowPresenterPresentation;

})(SupportBasePresentation);

module.exports = SupportNowPresenterPresentation;



},{"./base":72,"./now_messages":96}],98:[function(require,module,exports){
var SupportGPassPresenterPresentation, SupportGetawaysBookingPresenterPresentation, SupportGetawaysMarketRatePresenterPresentation, SupportGetawaysTonightPresenterPresentation, SupportGetawaysVoucherPresenterPresentation, SupportGoodsShippingPresenterPresentation, SupportGoodsVoucherPresenterPresentation, SupportLivePresenterPresentation, SupportLiveVoucherPresenterPresentation, SupportLocalPresenterPresentation, SupportNowPresenterPresentation, SupportPresenterFactoryPresentation;

SupportGetawaysBookingPresenterPresentation = require('./getaways_booking_presenter');

SupportGetawaysVoucherPresenterPresentation = require('./getaways_voucher_presenter');

SupportGoodsShippingPresenterPresentation = require('./goods_shipping_presenter');

SupportGoodsVoucherPresenterPresentation = require('./goods_voucher_presenter');

SupportGPassPresenterPresentation = require('./gpass_presenter');

SupportLivePresenterPresentation = require('./live_presenter');

SupportLiveVoucherPresenterPresentation = require('./live_voucher_presenter');

SupportLocalPresenterPresentation = require('./local_presenter');

SupportNowPresenterPresentation = require('./now_presenter');

SupportGetawaysMarketRatePresenterPresentation = require('./getaways_market_rate_presenter');

SupportGetawaysTonightPresenterPresentation = require('./getaways_tonight_presenter');

SupportPresenterFactoryPresentation = (function() {
  function SupportPresenterFactoryPresentation() {}

  SupportPresenterFactoryPresentation.prototype.makePresenter = function(order) {
    var deal_type, ref;
    if (order != null) {
      deal_type = order.DEAL_TYPE;
      if (deal_type != null) {
        switch (deal_type.toLowerCase()) {
          case 'goods_shipping':
            return new SupportGoodsShippingPresenterPresentation(order);
          case 'goods_voucher':
            return new SupportGoodsVoucherPresenterPresentation(order);
          case 'getaways_booking':
            return new SupportGetawaysBookingPresenterPresentation(order);
          case 'getaways_voucher':
            return new SupportGetawaysVoucherPresenterPresentation(order);
          case 'live_voucher':
            return new SupportLiveVoucherPresenterPresentation(order);
          case 'live':
            if ((ref = order.dealOption) != null ? ref.isTicketedDealOption : void 0) {
              return new SupportGPassPresenterPresentation(order);
            } else {
              return new SupportLivePresenterPresentation(order);
            }
            break;
          case 'local':
            return new SupportLocalPresenterPresentation(order);
          case 'now':
            return new SupportNowPresenterPresentation(order);
          case 'getaways_market_rate':
            return new SupportGetawaysMarketRatePresenterPresentation(order);
          case 'getaways_tonight':
            return new SupportGetawaysTonightPresenterPresentation(order);
          default:
            return new SupportLocalPresenterPresentation(order);
        }
      }
    }
  };

  return SupportPresenterFactoryPresentation;

})();

module.exports = SupportPresenterFactoryPresentation;



},{"./getaways_booking_presenter":76,"./getaways_market_rate_presenter":78,"./getaways_tonight_presenter":80,"./getaways_voucher_presenter":82,"./goods_shipping_presenter":84,"./goods_voucher_presenter":86,"./gpass_presenter":88,"./live_presenter":90,"./live_voucher_presenter":92,"./local_presenter":94,"./now_presenter":97}],99:[function(require,module,exports){
var PresenterUtil, SupportDefaultStatusAndNotesPresentation, SupportUtilsHelper;

SupportDefaultStatusAndNotesPresentation = require('./default_messages');

SupportUtilsHelper = require('../helpers/utils');

PresenterUtil = (function() {
  function PresenterUtil() {}

  PresenterUtil.prototype.DELIMITER = "$$";

  PresenterUtil.prototype.STATUS = "status";

  PresenterUtil.prototype.NOTES = "notes";


  /*
  it is a strong assumption in the below logic that the keys in the key string would be
  unique. And the same key would not be repeating in the lookup hierarchy.
   */

  PresenterUtil.prototype.lookup = function(source, key_string, attribute) {
    var check_value, defaultLookup, hierarchy, i, keys, len, lookup_obj, obj, value;
    if ((attribute != null) && (source != null) && (key_string != null)) {
      defaultLookup = SupportDefaultStatusAndNotesPresentation;
      lookup_obj = $.extend(true, defaultLookup, source);
      value = lookup_obj[attribute];
      keys = key_string.split(PresenterUtil.prototype.DELIMITER);
      hierarchy = [lookup_obj];
      hierarchy = PresenterUtil.prototype.recursiveLookup(keys, hierarchy);
      for (i = 0, len = hierarchy.length; i < len; i++) {
        obj = hierarchy[i];
        check_value = obj[attribute];
        if (check_value != null) {
          value = obj[attribute];
        }
      }
    }
    return value;
  };


  /*
  Aim to find the deepest possible successful check. If available, pick it up
   */

  PresenterUtil.prototype.recursiveLookup = function(keys, matched_hierarchy) {
    var best_matched_hierarchy, child_object, further_lookups, i, idx, key, len, lookup_object, matched_hierarchySoFar, new_keys;
    if (!!matched_hierarchy) {
      best_matched_hierarchy = matched_hierarchy;
      if (!!keys && keys.length > 0) {
        lookup_object = matched_hierarchy[matched_hierarchy.length - 1];
        idx = -1;
        for (i = 0, len = keys.length; i < len; i++) {
          key = keys[i];
          idx = idx + 1;
          if (!!key) {
            child_object = lookup_object[key];
            if (!!child_object) {
              matched_hierarchySoFar = $.map(matched_hierarchy, function(m) {
                return m;
              });
              matched_hierarchySoFar.push(child_object);
              new_keys = $.map(keys, function(k) {
                return k;
              });
              new_keys.splice(idx, 1);
              further_lookups = PresenterUtil.prototype.recursiveLookup(new_keys, matched_hierarchySoFar);
              if (further_lookups.length > best_matched_hierarchy.length) {
                best_matched_hierarchy = further_lookups;
              }
            }
          }
        }
      }
      return best_matched_hierarchy;
    }
  };

  PresenterUtil.prototype.isShipmentAvailable = function(order) {
    var voucher;
    voucher = PresenterUtil.prototype.getFirstVoucher(order);
    if (voucher != null) {
      return (voucher.shipments != null) && voucher.shipments.length > 0;
    }
  };

  PresenterUtil.prototype.isReturnable = function(order) {
    if ((order != null ? order.isReturnable : void 0) != null) {
      return evaluate(order.isReturnable);
    } else {
      return false;
    }
  };

  PresenterUtil.prototype.getFirstVoucher = function(order) {
    var groupons;
    if (order != null) {
      groupons = order.groupons;
      if (groupons != null) {
        return groupons[0];
      }
    }
  };

  PresenterUtil.prototype.isRedeemed = function(order) {
    var voucher;
    voucher = PresenterUtil.prototype.getFirstVoucher(order);
    if (voucher != null) {
      return voucher.isMerchantRedeemed || voucher.isCustomerRedeemed;
    }
  };

  PresenterUtil.prototype.concatenateLookupKeys = function(keys) {
    var key;
    return ((function() {
      var i, len, results;
      results = [];
      for (i = 0, len = keys.length; i < len; i++) {
        key = keys[i];
        results.push(key.toLowerCase());
      }
      return results;
    })()).join("$$");
  };

  PresenterUtil.prototype.getEditableKey = function(is_editable) {
    if ((is_editable != null) && is_editable === true) {
      return 'EDITABLE';
    } else {
      return 'NOT_EDITABLE';
    }
  };

  PresenterUtil.prototype.getStatusKey = function(order) {
    var is_redeemed, status;
    if (order != null) {
      status = order.STATE;
      if (status === "EXPIRED") {
        is_redeemed = PresenterUtil.prototype.isRedeemed(order);
        if ((is_redeemed != null) && is_redeemed === true) {
          status = "EXPIRED_REDEEMED";
        } else {
          status = "EXPIRED_UNREDEEMED";
        }
      }
      return status;
    }
  };

  PresenterUtil.prototype.getFulfillmentMethodKey = function(order) {
    var fulfillmentKey, fulfillmentMethod, ref;
    fulfillmentKey = 'fulfilled_enabled';
    fulfillmentMethod = order != null ? (ref = order.deal) != null ? ref.fulfillmentMethod : void 0 : void 0;
    if ((fulfillmentMethod != null ? fulfillmentMethod.length : void 0) > 0) {
      fulfillmentMethod = fulfillmentMethod.toUpperCase();
      if ((new RegExp("DROP")).test(fulfillmentMethod)) {
        return "DROPSHIP";
      } else {
        return _.compact(fulfillmentMethod.split(" ")).join("_");
      }
    }
    return fulfillmentKey;
  };

  PresenterUtil.prototype.getShipmentStatusKey = function(order) {
    if (order != null ? order.shipmentDetails : void 0) {
      return order.shipmentDetails.SHIPMENT_STATE;
    }
  };

  PresenterUtil.prototype.getGiftStatusKey = function(order) {
    if (order.isGiftClaimed === true) {
      return "GIFT_CLAIMED";
    } else {
      return "GIFT_UNCLAIMED";
    }
  };

  PresenterUtil.prototype.getGiftDeliveryMethod = function(order) {
    if (order.giftInfo) {
      switch (order.giftInfo.giftDeliveryMethod) {
        case 'email':
          return 'EGIFT';
        default:
          return 'PRINTED_GIFT';
      }
    }
  };

  PresenterUtil.prototype.getGDTKeys = function(order) {
    var is_redeemed, keys;
    keys = ['GDT'];
    is_redeemed = PresenterUtil.prototype.isRedeemed(order);
    if ((is_redeemed != null) && is_redeemed === true) {
      keys.push('REDEEMED');
    } else {
      keys.push('UN_REDEEMED');
    }
    return keys;
  };

  PresenterUtil.prototype.getShipmentKey = function(order) {
    var voucher;
    if (order != null) {
      if (PresenterUtil.prototype.isShipmentAvailable(order)) {
        voucher = PresenterUtil.prototype.getFirstVoucher(order);
        if (voucher.shipments[0].carrier === "Processing") {
          return 'SHIPMENTS_PROCESSING';
        } else {
          return 'SHIPMENTS_AVAILABLE';
        }
      } else {
        return 'SHIPMENTS_NOT_AVAILABLE';
      }
    }
  };

  PresenterUtil.prototype.getReturnableKey = function(is_returnable) {
    if (!!is_returnable) {
      if (is_returnable === true) {
        return 'RETURNABLE';
      } else {
        return 'NOT_RETURNABLE';
      }
    } else {
      return 'NA';
    }
  };

  PresenterUtil.prototype.getNotReturnableReasonKey = function(is_timelimit_exceeded) {
    if ((is_timelimit_exceeded != null) && is_timelimit_exceeded === true) {
      return 'TIME_EXECEEDED';
    } else {
      return 'NON_RETURNABLE';
    }
  };

  PresenterUtil.prototype.getShippingAddressRequiredKey = function(order) {
    if ((order != null) && (order.deal != null) && order.deal.shippingAddressRequired) {
      return 'SHIPPING_ADDRESS_REQUIRED';
    } else {
      return 'SHIPPING_ADDRESS_NOT_REQUIRED';
    }
  };

  PresenterUtil.prototype.getGetawaysBookingStatus = function(order) {
    if (PresenterUtil.prototype.getStatusKey(order) === 'REFUNDED') {
      return 'REFUNDED';
    } else if (PresenterUtil.prototype.isBookingNonCancellable(order) && !PresenterUtil.prototype.isCheckInDatePassed(order)) {
      return 'NON_CANCELLABLE';
    } else if (PresenterUtil.prototype.isCheckInDatePassed(order)) {
      return 'EXPIRED';
    } else {
      return PresenterUtil.prototype.getStatusKey(order);
    }
  };

  PresenterUtil.prototype.isCheckInDatePassed = function(order) {
    var reservationSource;
    reservationSource = SupportUtilsHelper.getReservationSource(order);
    if (((reservationSource != null ? reservationSource.checkInDate : void 0) != null) && Date.now() > getMillisecondsOfUTCDateFromISOStringDate(reservationSource.checkInDate)) {
      return true;
    }
    return false;
  };

  PresenterUtil.prototype.isBookingNonCancellable = function(order) {
    var reservationSource;
    reservationSource = SupportUtilsHelper.getReservationSource(order);
    if (((reservationSource != null ? reservationSource.cancellationDeadlineDate : void 0) != null) && Date.now > getMillisecondsOfUTCDateFromISOStringDate(reservationSource.cancellationDeadlineDate)) {
      return true;
    }
    return false;
  };

  PresenterUtil.prototype.getReturnabilityLabelPrintingStatus = function(order) {
    var length, ref, ref1, ref2, returnStatus;
    length = (ref = order.goodsReturnInfo) != null ? (ref1 = ref.returns) != null ? ref1.length : void 0 : void 0;
    if (length > 0) {
      returnStatus = (ref2 = order.goodsReturnInfo) != null ? ref2.returns[length - 1].returnStatus : void 0;
      if (returnStatus === 'return_initiated' || returnStatus === 'warehouse_received' || returnStatus === 'auto_refunded' || returnStatus === 'closed') {
        return "return_initiated_label_not_printed";
      } else if (returnStatus === 'label_printed') {
        return "return_initiated_label_printed";
      } else {
        return 'NA';
      }
    } else {
      return 'NA';
    }
  };

  return PresenterUtil;

})();

module.exports = PresenterUtil;



},{"../helpers/utils":54,"./default_messages":73}],100:[function(require,module,exports){
var SharedFeatureFlagModel, SharedUtilsHelper, Support, SupportAppRouter, SupportUtilsHelper, SupportViewManagerFactoryView;

SupportAppRouter = require('./AppRouter');

SupportViewManagerFactoryView = require('./view_manager/view_manager_factory');

SupportUtilsHelper = require('./helpers/utils');

SharedUtilsHelper = require('../../shared/frontend/helpers/utils');

SharedFeatureFlagModel = require('../../shared/frontend/models/feature_flag_model');

Date.now = Date.now || function() {
  return +(new Date);
};

if (!(typeof String.prototype.trim === 'function')) {
  String.prototype.trim = function() {
    return this.replace(/^\s+|\s+$/g, '');
  };
}

Support = {
  createSupportNameSpace: function() {
    var base;
    if (window.Groupon == null) {
      window.Groupon = {};
    }
    if ((base = window.Groupon).Support == null) {
      base.Support = {};
    }
    Groupon.Support.Email = {};
    _.extend(window, SupportUtilsHelper);
    return _.extend(window, SharedUtilsHelper);
  },
  initializeConstants: function() {
    Groupon.Support.FeatureFlagModel = new SharedFeatureFlagModel();
    return Groupon.Support.DELAY_TIMES = {
      flash: 2500
    };
  },
  constructViewManager: function() {
    Groupon.Support.HelpWizardViewManager = SupportViewManagerFactoryView.getViewManager();
    return Groupon.Support.HelpWizardViewManager.render();
  }
};

$(document).ready(function() {
  Support.createSupportNameSpace();
  redirectToFaqHack();
  Support.initializeConstants();
  activateieHacks();
  Support.constructViewManager();
  Groupon.Support.Router = new SupportAppRouter();
  Backbone.history.start({
    root: window.SUPPORTBASEURL
  });
  $('.help-wizard-menu').on('click', function() {
    redirectToHelpWizard();
    return false;
  });
  $('.faqs-menu').on('click', function() {
    redirectToFaq();
    return false;
  });
  Groupon.Performance.pageReady();
  return window.Groupon.ready = true;
});



},{"../../shared/frontend/helpers/utils":17,"../../shared/frontend/models/feature_flag_model":18,"./AppRouter":45,"./helpers/utils":54,"./view_manager/view_manager_factory":106}],101:[function(require,module,exports){
var StepTwoV1CMSView, SupportCMSModel, SupportHorizontalViewManagerBase, SupportOptimizedContactChannelsModel, SupportV1INTLStepThreeView, SupportV1INTLViewManager, SupportV1StepActionsModel, SupportV1StepOneView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportV1INTLStepThreeView = require('../../views/step_three/INTL/v1_view');

SupportV1StepOneView = require('../../views/step_one/v1_view');

SupportV1StepActionsModel = require('../../models/v1_step_action');

SupportCMSModel = require('../../models/CMS');

StepTwoV1CMSView = require('../../views/step_two/CMS/v1_cms_view');

SupportHorizontalViewManagerBase = require('../horizontal_view_manager_base');

SupportOptimizedContactChannelsModel = require('../../models/optimized_contact_channels');

SupportV1INTLViewManager = (function(superClass) {
  extend(SupportV1INTLViewManager, superClass);

  function SupportV1INTLViewManager() {
    SupportHorizontalViewManagerBase.prototype.constructor.apply(this, arguments);
    Groupon.Support.stepActionModel = new SupportV1StepActionsModel;
  }

  SupportV1INTLViewManager.prototype.getStepOneView = function() {
    return new SupportV1StepOneView();
  };

  SupportV1INTLViewManager.prototype.getStepTwoView = function() {
    return Groupon.Support.StepTwoView = new StepTwoV1CMSView({
      dropDownModel: Groupon.Support.ContentModel.dropDowns
    });
  };

  SupportV1INTLViewManager.prototype.getStepThreeView = function() {
    return new SupportV1INTLStepThreeView();
  };

  SupportV1INTLViewManager.prototype.configureContentModel = function() {
    return Groupon.Support.ContentModel = new SupportCMSModel;
  };

  SupportV1INTLViewManager.prototype.configureOptimizedContactChannelsModel = function() {
    return Groupon.Support.OptimizedContactChannelsModel = new SupportOptimizedContactChannelsModel;
  };

  return SupportV1INTLViewManager;

})(SupportHorizontalViewManagerBase);

module.exports = SupportV1INTLViewManager;



},{"../../models/CMS":55,"../../models/optimized_contact_channels":66,"../../models/v1_step_action":69,"../../views/step_one/v1_view":195,"../../views/step_three/INTL/v1_view":198,"../../views/step_two/CMS/v1_cms_view":204,"../horizontal_view_manager_base":104}],102:[function(require,module,exports){
var SharedFooterUSMainView, StepTwoInbentaNLPView, StepTwoInbentaNonNLPView, StepTwoV1CMSView, SupportCMSModel, SupportHorizontalViewManagerBase, SupportInbentaModel, SupportV1StepActionsModel, SupportV1StepOneView, SupportV1USStepThreeView, SupportV1USViewManager, SupportV2OptimizedContactChannelsModel,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportHorizontalViewManagerBase = require('../horizontal_view_manager_base');

SupportV1StepOneView = require('../../views/step_one/v1_view');

SupportV1StepActionsModel = require('../../models/v1_step_action');

SupportV1USStepThreeView = require('../../views/step_three/US/v1_view');

SharedFooterUSMainView = require('../../../../shared/frontend/views/footer/US/main_view');

StepTwoInbentaNLPView = require('../../views/step_two/inbenta/nlp_view');

StepTwoInbentaNonNLPView = require('../../views/step_two/inbenta/non_nlp_view');

StepTwoV1CMSView = require('../../views/step_two/CMS/v1_cms_view');

SupportInbentaModel = require('../../models/Inbenta');

SupportCMSModel = require('../../models/CMS');

SupportV2OptimizedContactChannelsModel = require('../../models/v2_optimized_contact_channels');

SupportV1USViewManager = (function(superClass) {
  extend(SupportV1USViewManager, superClass);

  function SupportV1USViewManager() {
    SupportHorizontalViewManagerBase.prototype.constructor.apply(this, arguments);
    Groupon.Support.stepActionModel = new SupportV1StepActionsModel;
  }

  SupportV1USViewManager.prototype.render = function() {
    return this.renderFooter();
  };

  SupportV1USViewManager.prototype.renderFooter = function() {
    var supportFooter;
    supportFooter = new SharedFooterUSMainView();
    supportFooter.render();
    $("#footer-content").html(supportFooter.el);
    return addWrapperLinkOverCallUs();
  };

  SupportV1USViewManager.prototype.getStepOneView = function() {
    return new SupportV1StepOneView();
  };

  SupportV1USViewManager.prototype.getStepTwoView = function() {
    var inbentaView;
    return Groupon.Support.StepTwoView = isCMSEnabled() ? new StepTwoV1CMSView({
      dropDownModel: Groupon.Support.ContentModel.dropDowns
    }) : (Groupon.Support.FeatureFlagModel.isSearchBasedDropDownsEnabled() ? inbentaView = StepTwoInbentaNLPView : inbentaView = StepTwoInbentaNonNLPView, new inbentaView({
      dropDownModel: Groupon.Support.ContentModel.dropDowns,
      dropDownCombinationsModel: Groupon.Support.ContentModel.dropDownCombinations
    }));
  };

  SupportV1USViewManager.prototype.getStepThreeView = function() {
    return new SupportV1USStepThreeView();
  };

  SupportV1USViewManager.prototype.configureContentModel = function() {
    if (isCMSEnabled()) {
      return Groupon.Support.ContentModel = new SupportCMSModel;
    } else {
      return Groupon.Support.ContentModel = new SupportInbentaModel;
    }
  };

  SupportV1USViewManager.prototype.configureOptimizedContactChannelsModel = function() {
    return Groupon.Support.OptimizedContactChannelsModel = new SupportV2OptimizedContactChannelsModel;
  };

  return SupportV1USViewManager;

})(SupportHorizontalViewManagerBase);

module.exports = SupportV1USViewManager;



},{"../../../../shared/frontend/views/footer/US/main_view":22,"../../models/CMS":55,"../../models/Inbenta":56,"../../models/v1_step_action":69,"../../models/v2_optimized_contact_channels":70,"../../views/step_one/v1_view":195,"../../views/step_three/US/v1_view":200,"../../views/step_two/CMS/v1_cms_view":204,"../../views/step_two/inbenta/nlp_view":208,"../../views/step_two/inbenta/non_nlp_view":209,"../horizontal_view_manager_base":104}],103:[function(require,module,exports){
var SharedFooterUSMainView, StepTwoInbentaNLPView, StepTwoInbentaNonNLPView, StepTwoV1CMSView, SupportCMSModel, SupportHorizontalViewManagerBase, SupportInbentaModel, SupportV2OptimizedContactChannelsModel, SupportV2StepActionsModel, SupportV2StepOneView, SupportV2USStepThreeView, SupportV2USViewManager,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportHorizontalViewManagerBase = require('../horizontal_view_manager_base');

SupportV2StepOneView = require('../../views/step_one/v2_view');

SupportV2StepActionsModel = require('../../models/v2_step_action');

SupportV2USStepThreeView = require('../../views/step_three/US/v2_view');

SharedFooterUSMainView = require('../../../../shared/frontend/views/footer/US/main_view');

StepTwoInbentaNLPView = require('../../views/step_two/inbenta/nlp_view');

StepTwoInbentaNonNLPView = require('../../views/step_two/inbenta/non_nlp_view');

StepTwoV1CMSView = require('../../views/step_two/CMS/v1_cms_view');

SupportInbentaModel = require('../../models/Inbenta');

SupportCMSModel = require('../../models/CMS');

SupportV2OptimizedContactChannelsModel = require('../../models/v2_optimized_contact_channels');

SupportV2USViewManager = (function(superClass) {
  extend(SupportV2USViewManager, superClass);

  function SupportV2USViewManager() {
    SupportHorizontalViewManagerBase.prototype.constructor.apply(this, arguments);
    Groupon.Support.stepActionModel = new SupportV2StepActionsModel({
      showHorizontalView: true
    });
  }

  SupportV2USViewManager.prototype.render = function() {
    return this.renderFooter();
  };

  SupportV2USViewManager.prototype.renderFooter = function() {
    var supportFooter;
    supportFooter = new SharedFooterUSMainView();
    supportFooter.render();
    $("#footer-content").html(supportFooter.el);
    return addWrapperLinkOverCallUs();
  };

  SupportV2USViewManager.prototype.getStepOneView = function() {
    return new SupportV2StepOneView({
      showHorizontalView: true
    });
  };

  SupportV2USViewManager.prototype.getStepTwoView = function() {
    var inbentaView;
    return Groupon.Support.StepTwoView = isCMSEnabled() ? new StepTwoV1CMSView({
      dropDownModel: Groupon.Support.ContentModel.dropDowns
    }) : (Groupon.Support.FeatureFlagModel.isSearchBasedDropDownsEnabled() ? inbentaView = StepTwoInbentaNLPView : inbentaView = StepTwoInbentaNonNLPView, new inbentaView({
      dropDownModel: Groupon.Support.ContentModel.dropDowns,
      dropDownCombinationsModel: Groupon.Support.ContentModel.dropDownCombinations
    }));
  };

  SupportV2USViewManager.prototype.getStepThreeView = function() {
    return new SupportV2USStepThreeView();
  };

  SupportV2USViewManager.prototype.configureContentModel = function() {
    if (isCMSEnabled()) {
      return Groupon.Support.ContentModel = new SupportCMSModel;
    } else {
      return Groupon.Support.ContentModel = new SupportInbentaModel;
    }
  };

  SupportV2USViewManager.prototype.configureOptimizedContactChannelsModel = function() {
    return Groupon.Support.OptimizedContactChannelsModel = new SupportV2OptimizedContactChannelsModel;
  };

  return SupportV2USViewManager;

})(SupportHorizontalViewManagerBase);

module.exports = SupportV2USViewManager;



},{"../../../../shared/frontend/views/footer/US/main_view":22,"../../models/CMS":55,"../../models/Inbenta":56,"../../models/v2_optimized_contact_channels":70,"../../models/v2_step_action":71,"../../views/step_one/v2_view":196,"../../views/step_three/US/v2_view":201,"../../views/step_two/CMS/v1_cms_view":204,"../../views/step_two/inbenta/nlp_view":208,"../../views/step_two/inbenta/non_nlp_view":209,"../horizontal_view_manager_base":104}],104:[function(require,module,exports){
var SupportChatSuccessView, SupportFlexibleContactChannelModel, SupportHorizontalViewManagerBase, SupportIntermediateView, SupportLiveChatModel, SupportLiveChatView, SupportOrderModel, SupportOrdersCollection, SupportProblemSolvedView, SupportTicketSuccessView;

SupportIntermediateView = require('../views/intermediate_view');

SupportFlexibleContactChannelModel = require('../models/flexible_contact_channels');

SupportLiveChatModel = require('../models/live_chat');

SupportLiveChatView = require('../views/live_chat_view');

SupportOrdersCollection = require('../collections/orders');

SupportOrderModel = require('../models/order');

SupportTicketSuccessView = require('../views/ticket_success_view');

SupportProblemSolvedView = require('../views/problem_solved_view');

SupportChatSuccessView = require('../views/chat_success_view');

SupportHorizontalViewManagerBase = (function() {
  function SupportHorizontalViewManagerBase() {
    this.configureContentModel();
    this.configureOptimizedContactChannelsModel();
    this.configureFlexibleContentChannelsModel();
    this.initLiveChat();
    Groupon.Support.OrdersCollection = new SupportOrdersCollection();
    Groupon.Support.currentOrdersFilter = Groupon.Support.OrdersCollection.createPurchaseDateDescendingFilter();
    Groupon.Support.OrderModel = new SupportOrderModel();
  }

  SupportHorizontalViewManagerBase.prototype.show = function(view, params) {
    this.setCurrentView(view);
    Groupon.Support.CURRENTVIEW.render(params);
    $('#help-wizard').html(Groupon.Support.CURRENTVIEW.el);
    toggleCallUs(Groupon.Support.CURRENTVIEW.id);
    return $(window).scrollTop(0);
  };

  SupportHorizontalViewManagerBase.prototype.removeElement = function(view) {
    return view.remove();
  };

  SupportHorizontalViewManagerBase.prototype.setCurrentView = function(view) {
    if (Groupon.Support.CURRENTVIEW != null) {
      this.removeElement(Groupon.Support.CURRENTVIEW);
    }
    return Groupon.Support.CURRENTVIEW = view;
  };

  SupportHorizontalViewManagerBase.prototype.render = function() {};

  SupportHorizontalViewManagerBase.prototype.renderIntermediateView = function() {
    var intermediateView;
    if ($('#intermediate_page').length > 0) {
      return intermediateView = new SupportIntermediateView({
        el: $('#intermediate_page')
      });
    } else {
      intermediateView = new SupportIntermediateView();
      intermediateView.render();
      return $("#intermediate-page-container").html(intermediateView.el);
    }
  };

  SupportHorizontalViewManagerBase.prototype.renderOrders = function() {
    var stepOneView;
    stepOneView = this.getStepOneView();
    return this.show(stepOneView);
  };

  SupportHorizontalViewManagerBase.prototype.renderOrderDetails = function(order) {
    var stepOneView;
    stepOneView = this.getStepOneView();
    return this.show(stepOneView, {
      order: order
    });
  };

  SupportHorizontalViewManagerBase.prototype.renderDropDowns = function() {
    var stepTwoView;
    stepTwoView = this.getStepTwoView();
    return this.show(stepTwoView);
  };

  SupportHorizontalViewManagerBase.prototype.renderContactChannels = function() {
    var stepThreeView;
    stepThreeView = this.getStepThreeView();
    this.show(stepThreeView);
    stepThreeView.postRenderhandler();
    return stepThreeView;
  };

  SupportHorizontalViewManagerBase.prototype.ticketSuccess = function() {
    return this.show(new SupportTicketSuccessView);
  };

  SupportHorizontalViewManagerBase.prototype.chatSuccess = function() {
    return this.show(new SupportChatSuccessView);
  };

  SupportHorizontalViewManagerBase.prototype.renderProblemSolved = function() {
    return this.show(new SupportProblemSolvedView);
  };

  SupportHorizontalViewManagerBase.prototype.getStepOneView = function() {};

  SupportHorizontalViewManagerBase.prototype.getStepTwoView = function() {};

  SupportHorizontalViewManagerBase.prototype.getStepThreeView = function() {};

  SupportHorizontalViewManagerBase.prototype.configureContentModel = function() {};

  SupportHorizontalViewManagerBase.prototype.configureOptimizedContactChannelsModel = function() {};

  SupportHorizontalViewManagerBase.prototype.renderUserSignIn = function(options) {};

  SupportHorizontalViewManagerBase.prototype.configureFlexibleContentChannelsModel = function() {
    return Groupon.Support.FlexibleContactChannelModel = new SupportFlexibleContactChannelModel;
  };

  SupportHorizontalViewManagerBase.prototype.initLiveChat = function() {
    Groupon.Support.LiveChatModel = new SupportLiveChatModel();
    return Groupon.Support.LiveChatView = new SupportLiveChatView({
      model: Groupon.Support.LiveChatModel
    });
  };

  return SupportHorizontalViewManagerBase;

})();

module.exports = SupportHorizontalViewManagerBase;



},{"../collections/orders":46,"../models/flexible_contact_channels":63,"../models/live_chat":65,"../models/order":67,"../views/chat_success_view":109,"../views/intermediate_view":153,"../views/live_chat_view":154,"../views/problem_solved_view":191,"../views/ticket_success_view":210}],105:[function(require,module,exports){
var EmailFormOptimizedContactChannelView, FAQHomeModel, FAQTrendingArticlesView, StepTwoV2CMSView, SupportCMSModel, SupportCategorizationView, SupportChatSuccessView, SupportEmailFormIntlFlexibleContactChannelsView, SupportEmailSuccessView, SupportFlexibleContactChannelModel, SupportLiveChatModel, SupportLiveChatView, SupportOptimizedContactChannelsModel, SupportOrderModel, SupportOrdersCollection, SupportProblemSolvedView, SupportUserSignInView, SupportV2StepActionsModel, SupportVerticalHelpWizardViewManager, SupportVerticalINTLStepThreeView, SupportVerticalStepOneView;

SupportVerticalINTLStepThreeView = require('../views/step_three/INTL/vertical_view');

SupportOrdersCollection = require('../collections/orders');

SupportOrderModel = require('../models/order');

SupportCategorizationView = require('../views/categorization_view');

SupportVerticalStepOneView = require('../views/step_one/vertical_view');

SupportV2StepActionsModel = require('../models/v2_step_action');

StepTwoV2CMSView = require('../views/step_two/CMS/v2_cms_view');

SupportCMSModel = require('../models/CMS');

SupportFlexibleContactChannelModel = require('../models/flexible_contact_channels');

SupportLiveChatModel = require('../models/live_chat');

SupportLiveChatView = require('../views/live_chat_view');

SupportOptimizedContactChannelsModel = require('../models/optimized_contact_channels');

FAQHomeModel = require('../../../faq/frontend/models/home');

FAQTrendingArticlesView = require('../../../faq/frontend/views/trendingArticles');

SupportEmailSuccessView = require('../views/email_success_view');

SupportChatSuccessView = require('../views/chat_success_view');

SupportProblemSolvedView = require('../views/problem_solved_view');

SupportUserSignInView = require('../views/user_sign_in_view');

SupportEmailFormIntlFlexibleContactChannelsView = require('../views/email_form/INTL/flexible_contact_channels');

EmailFormOptimizedContactChannelView = require('../views/email_form/common/optimized_contact_channel_view');

SupportVerticalHelpWizardViewManager = (function() {
  function SupportVerticalHelpWizardViewManager() {
    this.configureContentModel();
    this.configureFlexibleContentChannelsModel();
    this.configureOptimizedContactChannelsModel();
    this.configurePreEmailView();
    this.homeModel = new FAQHomeModel();
    this.initLiveChat();
    Groupon.Support.OrdersCollection = new SupportOrdersCollection();
    Groupon.Support.currentOrdersFilter = Groupon.Support.OrdersCollection.createPurchaseDateDescendingFilter();
    Groupon.Support.OrderModel = new SupportOrderModel();
    Groupon.Support.stepActionModel = new SupportV2StepActionsModel({
      showVerticalView: true
    });
    this.stackedViews = [];
  }

  SupportVerticalHelpWizardViewManager.prototype.show = function(view, params) {
    var container, isNewViewAddedToStack;
    container = params.container;
    isNewViewAddedToStack = this.setCurrentView(view, container);
    if (isNewViewAddedToStack) {
      this.moveActiveContainerToInactiveState();
      this.activateContainer(container);
      Groupon.Support.CURRENTVIEW.render(params);
      $('.step-container', container).html(Groupon.Support.CURRENTVIEW.el);
    } else {
      this.moveActiveContainerToDefaultState();
      this.activateContainer(container);
    }
    return toggleCallUs(Groupon.Support.CURRENTVIEW.id);
  };

  SupportVerticalHelpWizardViewManager.prototype.scrollTo = function($container) {
    var hash, ref;
    if ($container) {
      hash = {
        scrollTop: (ref = $container.offset()) != null ? ref.top : void 0
      };
      return $('html, body').animate(hash, 1000);
    }
  };

  SupportVerticalHelpWizardViewManager.prototype.renderTrendingArticles = function() {
    return this.homeModel.fetch({
      success: (function(_this) {
        return function(model, response, options) {
          var trendingArticlesView;
          stopTimer("t_fh");
          trendingArticlesView = new FAQTrendingArticlesView({
            model: _this.homeModel
          });
          return trendingArticlesView.render();
        };
      })(this),
      error: (function(_this) {
        return function(model, xhr, options) {
          _this.hideTrendingArticles();
          return stopTimer("t_fh");
        };
      })(this)
    });
  };

  SupportVerticalHelpWizardViewManager.prototype.hideTrendingArticles = function() {
    return $('.trending-articles-container').hide();
  };

  SupportVerticalHelpWizardViewManager.prototype.setCurrentView = function(currentView, container) {
    var peekedTopView, ref;
    if (this.removeStackedViewsAndUpdateCurrentView(currentView)) {
      return false;
    }
    peekedTopView = this.peekStackedViews();
    if (((peekedTopView != null ? (ref = peekedTopView.view) != null ? ref.id : void 0 : void 0) != null) && ((currentView != null ? currentView.id : void 0) != null) && peekedTopView.view.id === currentView.id) {
      this.removeView();
    }
    Groupon.Support.CURRENTVIEW = currentView;
    this.addView(currentView, container);
    return true;
  };

  SupportVerticalHelpWizardViewManager.prototype.removeStackedViewsAndUpdateCurrentView = function(currentView) {
    var isCurrentViewUpdated, isRemoved, peekedTopView;
    isCurrentViewUpdated = false;
    isRemoved = false;
    while (true) {
      peekedTopView = this.peekStackedViews();
      if (((peekedTopView != null ? peekedTopView.view.id : void 0) != null) && ((currentView != null ? currentView.id : void 0) != null) && peekedTopView.view.id > currentView.id) {
        isRemoved = true;
        this.moveContainerToDefaultState(peekedTopView.container);
        this.removeView();
      } else if (isRemoved && peekedTopView) {
        this.activateContainer(peekedTopView.container);
        Groupon.Support.CURRENTVIEW = peekedTopView.view;
        isCurrentViewUpdated = true;
        break;
      } else {
        break;
      }
    }
    return isCurrentViewUpdated;
  };

  SupportVerticalHelpWizardViewManager.prototype.addView = function(currentView, container) {
    return this.stackedViews.push({
      view: currentView,
      container: container
    });
  };

  SupportVerticalHelpWizardViewManager.prototype.removeAllStackedViews = function() {
    var peekedTopView;
    while (true) {
      this.removeView();
      peekedTopView = this.peekStackedViews();
      if (!peekedTopView) {
        break;
      }
    }
    this.moveAllContainerstoDefaultState();
    return Groupon.Support.CURRENTVIEW = null;
  };

  SupportVerticalHelpWizardViewManager.prototype.removeView = function() {
    var popedTopView;
    popedTopView = this.stackedViews.pop();
    if ((popedTopView != null ? popedTopView.view : void 0) != null) {
      return popedTopView.view.remove();
    }
  };

  SupportVerticalHelpWizardViewManager.prototype.peekStackedViews = function() {
    var stackedView;
    if (this.stackedViews.length > 0) {
      return stackedView = this.stackedViews[this.stackedViews.length - 1];
    } else {
      return null;
    }
  };

  SupportVerticalHelpWizardViewManager.prototype.moveActiveContainerToDefaultState = function() {
    $('.web-v2-circle.active').removeClass('active').removeClass('in-active');
    $('.web-v2-circle-text.active').removeClass('active').removeClass('in-active');
    return $('.web-v2-help-text.active').removeClass('active').removeClass('in-active');
  };

  SupportVerticalHelpWizardViewManager.prototype.moveActiveContainerToInactiveState = function() {
    $('.web-v2-circle.active').removeClass('active').addClass('in-active');
    $('.web-v2-circle-text.active').removeClass('active').addClass('in-active');
    return $('.web-v2-help-text.active').removeClass('active').addClass('in-active');
  };

  SupportVerticalHelpWizardViewManager.prototype.inActivateContainer = function(container) {
    $('.web-v2-circle', container).removeClass('active').addClass('in-active');
    $('.web-v2-circle-text', container).removeClass('active').addClass('in-active');
    return $('.web-v2-help-text', container).removeClass('active').addClass('in-active');
  };

  SupportVerticalHelpWizardViewManager.prototype.moveContainerToDefaultState = function(container) {
    $('.web-v2-circle', container).removeClass('active').removeClass('in-active');
    $('.web-v2-circle-text', container).removeClass('active').removeClass('in-active');
    return $('.web-v2-help-text', container).removeClass('active').removeClass('in-active');
  };

  SupportVerticalHelpWizardViewManager.prototype.activateContainer = function(container) {
    $('.web-v2-circle', container).removeClass('in-active').addClass('active');
    $('.web-v2-circle-text', container).removeClass('in-active').addClass('active');
    return $('.web-v2-help-text', container).removeClass('in-active').addClass('active');
  };

  SupportVerticalHelpWizardViewManager.prototype.moveAllContainerstoDefaultState = function() {
    _.each($('.web-v2-circle'), function(ele) {
      return $(ele).removeClass('active').removeClass('in-active');
    });
    _.each($('.web-v2-circle-text'), function(ele) {
      return $(ele).removeClass('active').removeClass('in-active');
    });
    return _.each($('.web-v2-help-text'), function(ele) {
      return $(ele).removeClass('active').removeClass('in-active');
    });
  };

  SupportVerticalHelpWizardViewManager.prototype.checkIfVerticalContainerIsVisible = function() {
    return $('.vertical-container').is(":visible");
  };

  SupportVerticalHelpWizardViewManager.prototype.resetVerticalContainer = function() {
    this.removeAllStackedViews();
    this.categorizationView.resetGlobalValues();
    this.categorizationView.deActivateCurrentActiveButton();
    this.activateContainer($('#v2_step1'));
    return $('.vertical-container').hide();
  };

  SupportVerticalHelpWizardViewManager.prototype.render = function() {
    var $container;
    $container = $('#v2_step1');
    this.renderTrendingArticles();
    this.categorizationView = new SupportCategorizationView({
      el: $('.category-buttons', $container)
    });
    this.categorizationView.render();
    return this.scrollTo($('.page_header'));
  };

  SupportVerticalHelpWizardViewManager.prototype.renderIntermediateView = function() {};

  SupportVerticalHelpWizardViewManager.prototype.renderOrders = function() {
    var $container, stepOneView;
    if (!currentUser) {
      this.renderUserSignIn({
        myOrder: true,
        id: "my-order-sign-in"
      });
    }
    this.removeAllStackedViews();
    $container = $('#v2_step1');
    stepOneView = this.getStepOneView();
    this.show(stepOneView, {
      container: $container
    });
    this.scrollTo($container);
    return stepOneView;
  };

  SupportVerticalHelpWizardViewManager.prototype.renderOrderDetails = function(order) {
    var $container, stepOneView;
    $container = $('#v2_step1');
    stepOneView = this.getStepOneView();
    this.show(stepOneView, {
      container: $container,
      order: order
    });
    this.scrollTo($container);
    return stepOneView;
  };

  SupportVerticalHelpWizardViewManager.prototype.renderDropDowns = function() {
    var $container, stepTwoView;
    if (this.checkIfVerticalContainerIsVisible()) {
      if (!Groupon.Support.currentOrder) {
        this.removeAllStackedViews();
        this.activateContainer($('#v2_step1'));
      }
      $container = $('#v2_step2');
      stepTwoView = this.getStepTwoView();
      this.show(stepTwoView, {
        container: $container
      });
      this.scrollTo($container);
      return stepTwoView;
    } else {
      return redirectToHelpWizard();
    }
  };

  SupportVerticalHelpWizardViewManager.prototype.renderUserSignIn = function(options) {
    var $container, userSignInView;
    this.removeAllStackedViews();
    $container = $('#v2_step1');
    userSignInView = this.getUserSignView(options);
    this.show(userSignInView, {
      container: $container
    });
    this.scrollTo($container);
    return userSignInView;
  };

  SupportVerticalHelpWizardViewManager.prototype.getUserSignView = function(options) {
    return new SupportUserSignInView(options);
  };

  SupportVerticalHelpWizardViewManager.prototype.renderContactChannels = function() {
    var $container, stepThreeView;
    if (this.checkIfVerticalContainerIsVisible()) {
      $container = $('#v2_step3');
      stepThreeView = this.getStepThreeView();
      this.show(stepThreeView, {
        container: $container
      });
      stepThreeView.postRenderhandler();
      this.scrollTo($container);
      return stepThreeView;
    } else {
      return redirectToHelpWizard();
    }
  };

  SupportVerticalHelpWizardViewManager.prototype.ticketSuccess = function() {
    var $container, ticketSuccessView;
    this.resetVerticalContainer();
    $container = $('#v2_other');
    ticketSuccessView = new SupportEmailSuccessView;
    this.show(ticketSuccessView, {
      container: $container
    });
    this.scrollTo($container);
    return ticketSuccessView;
  };

  SupportVerticalHelpWizardViewManager.prototype.chatSuccess = function() {
    var $container, chatSuccessView;
    this.resetVerticalContainer();
    $container = $('#v2_other');
    chatSuccessView = new SupportChatSuccessView;
    this.show(chatSuccessView, {
      container: $container
    });
    this.scrollTo($container);
    return chatSuccessView;
  };

  SupportVerticalHelpWizardViewManager.prototype.renderProblemSolved = function() {
    var $container, problemSolvedView;
    $('.vertical-container').hide();
    $container = $('#v2_other');
    problemSolvedView = new SupportProblemSolvedView({
      isV2: true
    });
    this.show(problemSolvedView, {
      container: $container
    });
    this.scrollTo($container);
    return problemSolvedView;
  };

  SupportVerticalHelpWizardViewManager.prototype.getStepOneView = function() {
    return new SupportVerticalStepOneView();
  };

  SupportVerticalHelpWizardViewManager.prototype.getStepTwoView = function() {
    return Groupon.Support.StepTwoView = new StepTwoV2CMSView({
      dropDownModel: Groupon.Support.ContentModel.dropDowns
    });
  };

  SupportVerticalHelpWizardViewManager.prototype.getStepThreeView = function() {
    return new SupportVerticalINTLStepThreeView();
  };

  SupportVerticalHelpWizardViewManager.prototype.configureContentModel = function() {
    return Groupon.Support.ContentModel = new SupportCMSModel;
  };

  SupportVerticalHelpWizardViewManager.prototype.configureFlexibleContentChannelsModel = function() {
    return Groupon.Support.FlexibleContactChannelModel = new SupportFlexibleContactChannelModel;
  };

  SupportVerticalHelpWizardViewManager.prototype.configureOptimizedContactChannelsModel = function() {
    return Groupon.Support.OptimizedContactChannelsModel = new SupportOptimizedContactChannelsModel;
  };

  SupportVerticalHelpWizardViewManager.prototype.configurePreEmailView = function() {
    if (window.evaluate(window.experiments.showFlexibleContactChannels)) {
      return Groupon.Support.PreEmailView = SupportEmailFormIntlFlexibleContactChannelsView;
    } else {
      return Groupon.Support.PreEmailView = EmailFormOptimizedContactChannelView;
    }
  };

  SupportVerticalHelpWizardViewManager.prototype.initLiveChat = function() {
    Groupon.Support.LiveChatModel = new SupportLiveChatModel();
    return Groupon.Support.LiveChatView = new SupportLiveChatView({
      model: Groupon.Support.LiveChatModel
    });
  };

  return SupportVerticalHelpWizardViewManager;

})();

module.exports = SupportVerticalHelpWizardViewManager;



},{"../../../faq/frontend/models/home":8,"../../../faq/frontend/views/trendingArticles":9,"../collections/orders":46,"../models/CMS":55,"../models/flexible_contact_channels":63,"../models/live_chat":65,"../models/optimized_contact_channels":66,"../models/order":67,"../models/v2_step_action":71,"../views/categorization_view":108,"../views/chat_success_view":109,"../views/email_form/INTL/flexible_contact_channels":122,"../views/email_form/common/optimized_contact_channel_view":148,"../views/email_success_view":151,"../views/live_chat_view":154,"../views/problem_solved_view":191,"../views/step_one/vertical_view":197,"../views/step_three/INTL/vertical_view":199,"../views/step_two/CMS/v2_cms_view":205,"../views/user_sign_in_view":211}],106:[function(require,module,exports){
var SupportV1INTLViewManagerHelper, SupportV1USViewManagerHelper, SupportV2USViewManagerHelper, SupportVerticalHelpWizardViewManagerHelper, SupportViewManagerFactoryView;

SupportV1USViewManagerHelper = require('./US/v1');

SupportV1INTLViewManagerHelper = require('./INTL/v1');

SupportV2USViewManagerHelper = require('./US/v2');

SupportVerticalHelpWizardViewManagerHelper = require('./vertical_view_manager');

SupportViewManagerFactoryView = {
  getViewManager: function() {
    var ref;
    if (window.isUS()) {
      if (Groupon.Support.FeatureFlagModel.isRedesignOrdersUSEnabled()) {
        return new SupportV2USViewManagerHelper;
      } else {
        return new SupportV1USViewManagerHelper;
      }
    } else {
      if (window.evaluate((ref = window.experiments) != null ? ref.showVerticalPageFlow : void 0)) {
        return new SupportVerticalHelpWizardViewManagerHelper;
      } else {
        return new SupportV1INTLViewManagerHelper;
      }
    }
  }
};

module.exports = SupportViewManagerFactoryView;



},{"./INTL/v1":101,"./US/v1":102,"./US/v2":103,"./vertical_view_manager":105}],107:[function(require,module,exports){
var Backbone, SupportBasePopupViewTemplate, SupportbasePopupView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportBasePopupViewTemplate = require('../../base_popup_view.html.mustache');

Backbone = require('backbone');

Backbone.$ = $;

SupportbasePopupView = (function(superClass) {
  extend(SupportbasePopupView, superClass);

  function SupportbasePopupView() {
    return SupportbasePopupView.__super__.constructor.apply(this, arguments);
  }

  SupportbasePopupView.prototype.initialize = function(options) {
    this.I18nScope = 'modules.support';
    this.template = SupportBasePopupViewTemplate;
    _.bindAll.apply(_, [this].concat(_.functions(this)));
    this.popup = $("#popup");
    return this.popupView = options.popupView;
  };

  SupportbasePopupView.prototype.renderHeaderAndFooter = function() {
    return toHtml(this.template, {}, this.I18nScope);
  };

  SupportbasePopupView.prototype.render = function() {
    var addEl;
    GIG.Modal.open({
      el: this.popup,
      closeOnBgClick: true,
      closeOnEscKey: true
    });
    this.$el.html(this.renderHeaderAndFooter());
    this.popup.html(this.el);
    this.popupView.render();
    addEl = $(this.el).find('.itemsPopupData');
    addEl.append(this.popupView.el);
    return this.delegateEvents();
  };

  SupportbasePopupView.prototype.closeModal = function() {
    GIG.Modal.close();
    return false;
  };

  SupportbasePopupView.prototype.events = {
    'click .close-modal': "closeModal"
  };

  return SupportbasePopupView;

})(Backbone.View);

module.exports = SupportbasePopupView;



},{"../../base_popup_view.html.mustache":32,"backbone":245}],108:[function(require,module,exports){
var Backbone, SupportCategorizationView, SupportHelpWizardController,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportHelpWizardController = require('../helpWizardController');

Backbone = require('backbone');

Backbone.$ = $;

SupportCategorizationView = (function(superClass) {
  extend(SupportCategorizationView, superClass);

  function SupportCategorizationView() {
    this.redirectingToOrder = bind(this.redirectingToOrder, this);
    return SupportCategorizationView.__super__.constructor.apply(this, arguments);
  }

  SupportCategorizationView.prototype.events = {
    'click #web-v2-my-order': 'onMyOrderSelection',
    'click #web-v2-my-account': 'onMyAccountSelection',
    'click #web-v2-something-else': 'onSomethingElseSelection',
    'click #web-v2-pre-purchase': 'onPrePuchaseSelection'
  };

  SupportCategorizationView.prototype.render = function() {
    switch (window.landingStep) {
      case 'step_1':
        $('#web-v2-my-order').addClass('active');
        break;
      case 'step_2':
        $('#web-v2-my-account').addClass('active');
    }
    return window.hideFloatingBoldChat();
  };

  SupportCategorizationView.prototype.getCurrentActiveButton = function() {
    var currentActiveButton;
    return currentActiveButton = $('.active', this.$el);
  };

  SupportCategorizationView.prototype.redirectingToOrder = function() {
    return SupportHelpWizardController.initOrdersFetch();
  };

  SupportCategorizationView.prototype.onMyOrderSelection = function() {
    var currentActiveButton, targetButtonId;
    targetButtonId = 'web-v2-my-order';
    currentActiveButton = this.getCurrentActiveButton();
    if ((currentActiveButton != null ? currentActiveButton.attr('id') : void 0) !== targetButtonId) {
      this.resetGlobalValues();
      Groupon.Support.ABOUT_AN_ORDER = true;
      this.activateTargetButton(currentActiveButton, targetButtonId);
      if (currentUser) {
        return this.redirectingToOrder();
      } else {
        return this.redirectToUserSignIn({
          myOrder: true,
          id: "my-order-sign-in"
        });
      }
    }
  };

  SupportCategorizationView.prototype.onMyAccountSelection = function() {
    var currentActiveButton, targetButtonId;
    targetButtonId = 'web-v2-my-account';
    currentActiveButton = this.getCurrentActiveButton();
    if ((currentActiveButton != null ? currentActiveButton.attr('id') : void 0) !== targetButtonId) {
      this.resetGlobalValues();
      Groupon.Support.ACCOUNT_RELATED = true;
      this.activateTargetButton(currentActiveButton, targetButtonId);
      if (currentUser) {
        return this.redirectSelectIssue();
      } else {
        return this.redirectToUserSignIn({
          myAccount: true,
          id: "my-account-sign-in"
        });
      }
    }
  };

  SupportCategorizationView.prototype.onSomethingElseSelection = function() {
    var currentActiveButton, targetButtonId;
    targetButtonId = 'web-v2-something-else';
    currentActiveButton = this.getCurrentActiveButton();
    if ((currentActiveButton != null ? currentActiveButton.attr('id') : void 0) !== targetButtonId) {
      this.resetGlobalValues();
      Groupon.Support.SOMETHING_ELSE = true;
      this.activateTargetButton(currentActiveButton, targetButtonId);
      return this.redirectSelectIssue();
    }
  };

  SupportCategorizationView.prototype.onPrePuchaseSelection = function() {
    var currentActiveButton, targetButtonId;
    targetButtonId = 'web-v2-pre-purchase';
    currentActiveButton = this.getCurrentActiveButton();
    if (this.targetButtonIsActive(currentActiveButton, targetButtonId) !== true) {
      this.resetGlobalValues();
      Groupon.Support.PRE_PURCHASE = true;
      this.activateTargetButton(currentActiveButton, targetButtonId);
      return this.redirectSelectIssue();
    }
  };

  SupportCategorizationView.prototype.targetButtonIsActive = function(currentActiveButton, targetButtonId) {
    return (currentActiveButton != null ? currentActiveButton.attr('id') : void 0) === targetButtonId;
  };

  SupportCategorizationView.prototype.resetGlobalValues = function() {
    Groupon.Support.SOMETHING_ELSE = false;
    Groupon.Support.ACCOUNT_RELATED = false;
    Groupon.Support.ABOUT_AN_ORDER = false;
    return Groupon.Support.PRE_PURCHASE = false;
  };

  SupportCategorizationView.prototype.activateTargetButton = function(currentActiveButton, targetButtonId) {
    currentActiveButton.removeClass('active');
    return $("#" + targetButtonId, this.$el).addClass('active');
  };

  SupportCategorizationView.prototype.deActivateCurrentActiveButton = function() {
    var ref;
    return (ref = this.getCurrentActiveButton()) != null ? ref.removeClass('active') : void 0;
  };

  SupportCategorizationView.prototype.redirectToUserSignIn = function(options) {
    return SupportHelpWizardController.renderUserSignIn(options);
  };

  SupportCategorizationView.prototype.redirectSelectIssue = function(targetButtonId) {
    Groupon.Support.ContentModel.init(null);
    return SupportHelpWizardController.abruptStepTwoFlow();
  };

  return SupportCategorizationView;

})(Backbone.View);

module.exports = SupportCategorizationView;



},{"../helpWizardController":50,"backbone":245}],109:[function(require,module,exports){
var SupportChatSuccessView, SupportTicketSuccessView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportTicketSuccessView = require('./ticket_success_view');

SupportChatSuccessView = (function(superClass) {
  extend(SupportChatSuccessView, superClass);

  function SupportChatSuccessView() {
    return SupportChatSuccessView.__super__.constructor.apply(this, arguments);
  }

  SupportChatSuccessView.prototype.toHash = function() {
    var hash;
    hash = {
      showDefaultThankYouMsg: false,
      showChatThankYouMsg: true,
      showNeedHelpLink: true,
      showFooter: false,
      greeting_text: this.getGreetingText(),
      isChatFlow: true
    };
    return hash;
  };

  SupportChatSuccessView.prototype.getGreetingText = function() {
    return I18n.translate('js.modules.support.v2.thanks_chat');
  };

  return SupportChatSuccessView;

})(SupportTicketSuccessView);

module.exports = SupportChatSuccessView;



},{"./ticket_success_view":210}],110:[function(require,module,exports){
var SupportCommonBaseInputsView, SupportCommonBaseView,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportCommonBaseView = require('./common_base_view');

SupportCommonBaseInputsView = (function(superClass) {
  extend(SupportCommonBaseInputsView, superClass);

  function SupportCommonBaseInputsView() {
    this.validateEmailForm = bind(this.validateEmailForm, this);
    return SupportCommonBaseInputsView.__super__.constructor.apply(this, arguments);
  }

  SupportCommonBaseInputsView.prototype.initialize = function(options) {
    this.options = options || {};
    return this.inputViews = [];
  };

  SupportCommonBaseInputsView.prototype.renderInputViews = function(objects, componentListElement) {
    var i, len, obj, results, view;
    results = [];
    for (i = 0, len = objects.length; i < len; i++) {
      obj = objects[i];
      view = this.getViewByObjectType(obj);
      if (!view) {
        continue;
      }
      this.inputViews.push(view);
      view.render();
      results.push(this.$el.find(componentListElement).append(view.el));
    }
    return results;
  };

  SupportCommonBaseInputsView.prototype.isInputValid = function() {
    var i, len, ref, view;
    ref = this.inputViews;
    for (i = 0, len = ref.length; i < len; i++) {
      view = ref[i];
      if (!view.isInputValid()) {
        return false;
      }
    }
    return true;
  };

  SupportCommonBaseInputsView.prototype.collectInputFromComponents = function(data) {
    var i, len, ref, view;
    ref = this.inputViews;
    for (i = 0, len = ref.length; i < len; i++) {
      view = ref[i];
      view.populateInput(data);
    }
    return data;
  };

  SupportCommonBaseInputsView.prototype.isRequiredInputGiven = function() {
    var i, len, ref, view;
    ref = this.inputViews;
    for (i = 0, len = ref.length; i < len; i++) {
      view = ref[i];
      if (view.isInputCompulsory && !view.isInputGiven()) {
        return false;
      }
    }
    return true;
  };

  SupportCommonBaseInputsView.prototype.validateEmailForm = function() {
    if (this.isRequiredInputGiven()) {
      return this.enableSubmit();
    } else {
      return this.disableSubmit();
    }
  };

  SupportCommonBaseInputsView.prototype.onSubmitClick = function() {
    var data;
    this.disableSubmit();
    if (this.isInputValid()) {
      data = this.getFormData();
      return this.submitForm(data);
    } else {
      return this.validateEmailForm();
    }
  };

  SupportCommonBaseInputsView.prototype.getFormData = function() {
    var data;
    data = this.model.getBasicTicketData();
    this.collectInputFromComponents(data);
    return data;
  };

  SupportCommonBaseInputsView.prototype.enableSubmit = function() {
    $('.submit-button', this.$el).removeClass('disabled');
    return $('.submit-button', this.$el).attr('disabled', false);
  };

  SupportCommonBaseInputsView.prototype.disableSubmit = function() {
    $('.submit-button', this.$el).addClass('disabled');
    return $('.submit-button', this.$el).attr('disabled', true);
  };

  SupportCommonBaseInputsView.prototype.getViewByObjectType = function() {};

  return SupportCommonBaseInputsView;

})(SupportCommonBaseView);

module.exports = SupportCommonBaseInputsView;



},{"./common_base_view":111}],111:[function(require,module,exports){
var Backbone, SupportCommonBaseView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Backbone = require('backbone');

Backbone.$ = $;

SupportCommonBaseView = (function(superClass) {
  extend(SupportCommonBaseView, superClass);

  function SupportCommonBaseView() {
    return SupportCommonBaseView.__super__.constructor.apply(this, arguments);
  }

  SupportCommonBaseView.prototype.render = function() {
    return this.$el.append(toHtml(this.template, this.toHash(), this.I18nScope));
  };

  SupportCommonBaseView.prototype.toHash = function() {
    var ref;
    return ((ref = this.model) != null ? ref.toJSON() : void 0) || {};
  };

  return SupportCommonBaseView;

})(Backbone.View);

module.exports = SupportCommonBaseView;



},{"backbone":245}],112:[function(require,module,exports){
var EmailFormEmailInputView, EmailFormTextInputView, GrouponValidate,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

EmailFormTextInputView = require('./text_input_view');

GrouponValidate = require('../../../../../groupon/frontend/validate');

EmailFormEmailInputView = (function(superClass) {
  extend(EmailFormEmailInputView, superClass);

  function EmailFormEmailInputView() {
    return EmailFormEmailInputView.__super__.constructor.apply(this, arguments);
  }

  EmailFormEmailInputView.prototype.tagName = 'li';

  EmailFormEmailInputView.prototype.events = {
    'keyup .email_input': 'validateEmail'
  };

  EmailFormEmailInputView.prototype.initialize = function() {
    EmailFormTextInputView.prototype.initialize.apply(this, arguments);
    this.elementID = ".email_input";
    this.errorElementID = ".validateEmailInput";
    return this.template = {
      email_input_template: true
    };
  };

  EmailFormEmailInputView.prototype.isInputValid = function(hideErrorMsg) {
    var email, isValidEmail, ref, ref1;
    email = (ref = this.getInputHtmlElement()) != null ? (ref1 = ref.val()) != null ? ref1.trim() : void 0 : void 0;
    isValidEmail = true;
    if ((email != null) && email !== void 0 && email !== "") {
      isValidEmail = GrouponValidate.email(email);
      if (isValidEmail) {
        this.$el.find(this.errorElementID).css('display', 'none');
        $('.call-back-email-input').removeClass('call-back-inputs-error-border');
      } else if (!hideErrorMsg) {
        this.$el.find(this.errorElementID).css('display', 'block');
        $('.call-back-email-input').addClass('call-back-inputs-error-border');
      }
    }
    return isValidEmail;
  };

  EmailFormEmailInputView.prototype.validateEmail = function() {
    this.isInputValid(true);
    return this.validateEmailForm();
  };

  EmailFormEmailInputView.prototype.populateInput = function(data) {
    if (this.isInputGiven()) {
      return data.user_email = this.readInput();
    }
  };

  return EmailFormEmailInputView;

})(EmailFormTextInputView);

module.exports = EmailFormEmailInputView;



},{"../../../../../groupon/frontend/validate":11,"./text_input_view":114}],113:[function(require,module,exports){
var EmailFormPhoneNumberInputView, EmailFormTextInputView, GrouponValidate,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

EmailFormTextInputView = require('./text_input_view');

GrouponValidate = require('../../../../../groupon/frontend/validate');

EmailFormPhoneNumberInputView = (function(superClass) {
  extend(EmailFormPhoneNumberInputView, superClass);

  function EmailFormPhoneNumberInputView() {
    return EmailFormPhoneNumberInputView.__super__.constructor.apply(this, arguments);
  }

  EmailFormPhoneNumberInputView.prototype.tagName = 'li';

  EmailFormPhoneNumberInputView.prototype.events = {
    'keyup .phone_number_input': 'checkPhoneNumber'
  };

  EmailFormPhoneNumberInputView.prototype.initialize = function() {
    EmailFormTextInputView.prototype.initialize.apply(this, arguments);
    this.elementID = ".phone_number_input";
    this.errorElementID = '.validatePhoneNumberInput';
    return this.template = {
      phone_input_template: true
    };
  };

  EmailFormPhoneNumberInputView.prototype.isInputValid = function(hideErrorMsg) {
    var isValidPhoneNumber, phoneNumber;
    phoneNumber = this.getInputHtmlElement().val();
    isValidPhoneNumber = true;
    if (phoneNumber !== "") {
      isValidPhoneNumber = window.isUS() ? GrouponValidate.phone(phoneNumber) : GrouponValidate.phoneInternational(phoneNumber);
      if (isValidPhoneNumber) {
        this.$el.find(this.errorElementID).css('display', 'none');
        $('.call-back-phone-number-input').removeClass('call-back-inputs-error-border');
      } else if (!hideErrorMsg) {
        this.$el.find(this.errorElementID).css('display', 'block');
        $('.call-back-phone-number-input').addClass('call-back-inputs-error-border');
      }
    }
    return isValidPhoneNumber;
  };

  EmailFormPhoneNumberInputView.prototype.checkPhoneNumber = function() {
    this.isInputValid(true);
    return this.validateEmailForm();
  };

  EmailFormPhoneNumberInputView.prototype.populateInput = function(data) {
    if (this.isInputGiven()) {
      data.user_given_phone = this.readInput();
      return EmailFormTextInputView.prototype.populateInput.apply(this, arguments);
    }
  };

  return EmailFormPhoneNumberInputView;

})(EmailFormTextInputView);

module.exports = EmailFormPhoneNumberInputView;



},{"../../../../../groupon/frontend/validate":11,"./text_input_view":114}],114:[function(require,module,exports){
var Backbone, EmailFormTextInputView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Backbone = require('backbone');

Backbone.$ = $;

EmailFormTextInputView = (function(superClass) {
  extend(EmailFormTextInputView, superClass);

  function EmailFormTextInputView() {
    return EmailFormTextInputView.__super__.constructor.apply(this, arguments);
  }

  EmailFormTextInputView.prototype.initialize = function(options) {
    var ref, ref1;
    this.options = options || {};
    this.I18nScope = 'modules.support';
    this.isInputFieldEmpty = true;
    this.maxLength = 250;
    this.model = this.options.model;
    this.isFlexibleStepThree = this.options.isFlexibleStepThree;
    this.label = this.model.label;
    this.value = this.model.value;
    this.base_template = this.options.template;
    this.isInputCompulsory = this.model.required === true || this.model.required === "true";
    if (((ref = this.options.model.additional_attributes) != null ? (ref1 = ref.maximum_number_of_characters_or_digits) != null ? ref1.length : void 0 : void 0) > 0) {
      return this.maxLength = parseInt(this.options.model.additional_attributes.maximum_number_of_characters_or_digits);
    }
  };

  EmailFormTextInputView.prototype.render = function() {
    return this.$el.html(toHtml(this.base_template, this.toHash()));
  };

  EmailFormTextInputView.prototype.toHash = function() {
    var hash;
    hash = {
      stepThreeType: this.isFlexibleStepThree ? 'flexibleStepThree' : 'defaultStepThree',
      label: this.label,
      required: this.isInputCompulsory,
      maxLength: this.maxLength,
      counter: this.model.counter,
      isLoggedIn: window.isLoggedIn,
      value: this.value
    };
    return _.extend(this.template, hash);
  };

  EmailFormTextInputView.prototype.getInputHtmlElement = function() {
    return this.$el.find(this.elementID);
  };

  EmailFormTextInputView.prototype.isInputGiven = function() {
    var ref, ref1, ref2;
    return ((ref = this.getInputHtmlElement()) != null ? (ref1 = ref.val()) != null ? (ref2 = ref1.trim()) != null ? ref2.length : void 0 : void 0 : void 0) > 0;
  };

  EmailFormTextInputView.prototype.readInput = function() {
    var ref, ref1;
    return (ref = this.getInputHtmlElement()) != null ? (ref1 = ref.val()) != null ? ref1.trim() : void 0 : void 0;
  };

  EmailFormTextInputView.prototype.isInputValid = function() {
    return true;
  };

  EmailFormTextInputView.prototype.validateEmailForm = function() {
    if (this.isInputCompulsory && ((this.isInputFieldEmpty && this.isInputGiven()) || !(this.isInputFieldEmpty || this.isInputGiven()))) {
      this.isInputFieldEmpty = !this.isInputGiven();
      return this.options.validateEmailForm();
    }
  };

  EmailFormTextInputView.prototype.populateInput = function(data) {
    var inputData;
    if (this.isInputGiven()) {
      inputData = this.readInput();
      return data.description += "\n\n " + this.label + " : " + inputData;
    }
  };

  return EmailFormTextInputView;

})(Backbone.View);

module.exports = EmailFormTextInputView;



},{"backbone":245}],115:[function(require,module,exports){
var EmailFormTextInputView, EmailFormTextLineInputView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

EmailFormTextInputView = require('./text_input_view');

EmailFormTextLineInputView = (function(superClass) {
  extend(EmailFormTextLineInputView, superClass);

  function EmailFormTextLineInputView() {
    return EmailFormTextLineInputView.__super__.constructor.apply(this, arguments);
  }

  EmailFormTextLineInputView.prototype.tagName = 'li';

  EmailFormTextLineInputView.prototype.events = {
    'keyup .text_line_input': 'validateEmailForm'
  };

  EmailFormTextLineInputView.prototype.initialize = function() {
    EmailFormTextInputView.prototype.initialize.apply(this, arguments);
    this.elementID = ".text_line_input";
    return this.template = {
      text_line_input_template: true
    };
  };

  return EmailFormTextLineInputView;

})(EmailFormTextInputView);

module.exports = EmailFormTextLineInputView;



},{"./text_input_view":114}],116:[function(require,module,exports){
var Backbone, EmailFormIntlBaseDateInputView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Backbone = require('backbone');

Backbone.$ = $;

EmailFormIntlBaseDateInputView = (function(superClass) {
  extend(EmailFormIntlBaseDateInputView, superClass);

  function EmailFormIntlBaseDateInputView() {
    return EmailFormIntlBaseDateInputView.__super__.constructor.apply(this, arguments);
  }

  EmailFormIntlBaseDateInputView.prototype.initialize = function(options) {
    this.options = options || {};
    this.I18nScope = 'modules.support';
    this.isInputFieldEmpty = true;
    this.maxLength = 250;
    this.base_template = this.options.template;
    this.model = this.options.model;
    this.isFlexibleStepThree = this.options.isFlexibleStepThree;
    this.label = this.model.label;
    this.isInputCompulsory = this.model.required === true || this.model.required === "true";
    return this.show_template = {};
  };

  EmailFormIntlBaseDateInputView.prototype.render = function() {
    this.$el.html(toHtml(this.base_template, this.toHash()));
    return this.$el.find(this.elementID).datepicker();
  };

  EmailFormIntlBaseDateInputView.prototype.toHash = function() {
    var hash, ref;
    hash = {
      stepThreeType: this.isFlexibleStepThree ? 'flexibleStepThree' : 'defaultStepThree',
      label: this.label,
      required: this.isInputCompulsory,
      maxLength: this.maxLength,
      counter: this.model.counter,
      options: this.dropdownOptions,
      show_dropdown: ((ref = this.dropdownOptions) != null ? ref.length : void 0) > 0
    };
    return _.extend(this.show_template, hash);
  };

  EmailFormIntlBaseDateInputView.prototype.getInputHtmlElement = function() {
    return this.$el.find(this.elementID);
  };

  EmailFormIntlBaseDateInputView.prototype.isInputGiven = function() {
    return this.getInputHtmlElement().val().trim().length > 0;
  };

  EmailFormIntlBaseDateInputView.prototype.isInputValid = function() {
    return true;
  };

  EmailFormIntlBaseDateInputView.prototype.validateEmailForm = function() {
    if (this.isInputCompulsory && ((this.isInputFieldEmpty && this.isInputGiven()) || !(this.isInputFieldEmpty || this.isInputGiven()))) {
      this.isInputFieldEmpty = !this.isInputGiven();
      return this.options.validateEmailForm();
    }
  };

  EmailFormIntlBaseDateInputView.prototype.populateInput = function(data) {
    var inputData;
    if (this.isInputGiven()) {
      inputData = this.readInput();
      return data.description += "\n\n " + this.label + " : " + inputData;
    }
  };

  EmailFormIntlBaseDateInputView.prototype.deleteKeyDownHandler = function(e) {
    if (e.keyCode === 8) {
      e.stopPropagation();
      e.preventDefault();
      return false;
    }
  };

  return EmailFormIntlBaseDateInputView;

})(Backbone.View);

module.exports = EmailFormIntlBaseDateInputView;



},{"backbone":245}],117:[function(require,module,exports){
var Backbone, EmailFormIntlCheckboxInputView, SupportFlexibleEmailFormObjectsTemplate,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportFlexibleEmailFormObjectsTemplate = require('../../../../flexible_email_form_objects.html.mustache');

Backbone = require('backbone');

Backbone.$ = $;

EmailFormIntlCheckboxInputView = (function(superClass) {
  extend(EmailFormIntlCheckboxInputView, superClass);

  function EmailFormIntlCheckboxInputView() {
    return EmailFormIntlCheckboxInputView.__super__.constructor.apply(this, arguments);
  }

  EmailFormIntlCheckboxInputView.prototype.tagName = 'li';

  EmailFormIntlCheckboxInputView.prototype.events = {
    'change .checkbox_input': 'validate'
  };

  EmailFormIntlCheckboxInputView.prototype.initialize = function(options) {
    this.options = options || {};
    this.model = this.options.model;
    this.label = this.model.label;
    this.I18nScope = 'modules.support';
    this.elementID = ".checkbox_input";
    this.inputInvalidMsgID = ".inputInvalidMsgID";
    this.isFlexibleStepThree = this.options.isFlexibleStepThree;
    this.template = SupportFlexibleEmailFormObjectsTemplate;
    return this.isInputCompulsory = this.model.required === true || this.model.required === "true";
  };

  EmailFormIntlCheckboxInputView.prototype.render = function() {
    return this.$el.html(toHtml(this.template, this.toHash()));
  };

  EmailFormIntlCheckboxInputView.prototype.toHash = function() {
    return {
      label: this.label,
      required: this.isInputCompulsory,
      counter: this.model.counter,
      stepThreeType: this.isFlexibleStepThree ? 'flexibleStepThree' : 'defaultStepThree',
      checkbox_input_template: true
    };
  };

  EmailFormIntlCheckboxInputView.prototype.isInputGiven = function() {
    return this.isInputValid();
  };

  EmailFormIntlCheckboxInputView.prototype.getInputHtmlElement = function() {
    return this.$el.find(this.elementID);
  };

  EmailFormIntlCheckboxInputView.prototype.getInputInvalidHtmlElement = function() {
    return this.$el.find(this.inputInvalidMsgID);
  };

  EmailFormIntlCheckboxInputView.prototype.readInput = function() {
    return _.first(this.getInputHtmlElement()).checked;
  };

  EmailFormIntlCheckboxInputView.prototype.isInputValid = function() {
    if (this.isInputCompulsory) {
      return this.readInput();
    }
    return true;
  };

  EmailFormIntlCheckboxInputView.prototype.validateInput = function() {
    var showInvalidInputMsg;
    showInvalidInputMsg = this.isInputCompulsory && !this.readInput();
    if (showInvalidInputMsg) {
      return this.getInputInvalidHtmlElement().css('display', 'block');
    } else {
      return this.getInputInvalidHtmlElement().css('display', 'none');
    }
  };

  EmailFormIntlCheckboxInputView.prototype.validate = function() {
    this.validateInput();
    return this.options.validateEmailForm();
  };

  EmailFormIntlCheckboxInputView.prototype.setCreditRefundBoxSelectedFlag = function(data) {
    if (window.evaluate(Groupon.Support.ContentModel.isRefundEligible && !this.isInputCompulsory)) {
      return data.credit_refund_check_box_selected = this.readInput();
    }
  };

  EmailFormIntlCheckboxInputView.prototype.populateInput = function(data) {
    var inputData;
    inputData = this.readInput();
    this.setCreditRefundBoxSelectedFlag(data);
    return data.description += "\n\n " + this.label + " : " + inputData;
  };

  return EmailFormIntlCheckboxInputView;

})(Backbone.View);

module.exports = EmailFormIntlCheckboxInputView;



},{"../../../../flexible_email_form_objects.html.mustache":43,"backbone":245}],118:[function(require,module,exports){
var Backbone, EmailFormIntlBaseDateInputView, EmailFormIntlDateInputView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

EmailFormIntlBaseDateInputView = require("./base_date_input_view.coffee");

Backbone = require('backbone');

Backbone.$ = $;

EmailFormIntlDateInputView = (function(superClass) {
  extend(EmailFormIntlDateInputView, superClass);

  function EmailFormIntlDateInputView() {
    return EmailFormIntlDateInputView.__super__.constructor.apply(this, arguments);
  }

  EmailFormIntlDateInputView.prototype.tagName = 'li';

  EmailFormIntlDateInputView.prototype.events = {
    'change .date_input': 'validateEmailForm',
    'keydown .date_input': 'deleteKeyDownHandler'
  };

  EmailFormIntlDateInputView.prototype.initialize = function() {
    EmailFormIntlBaseDateInputView.prototype.initialize.apply(this, arguments);
    this.elementID = ".date_input";
    return this.show_template = {
      date_input_template: true
    };
  };

  EmailFormIntlDateInputView.prototype.readInput = function() {
    return this.getInputHtmlElement().val().trim();
  };

  return EmailFormIntlDateInputView;

})(EmailFormIntlBaseDateInputView);

module.exports = EmailFormIntlDateInputView;



},{"./base_date_input_view.coffee":116,"backbone":245}],119:[function(require,module,exports){
var Backbone, EmailFormIntlBaseDateInputView, EmailFormIntlDateTimeInputView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

EmailFormIntlBaseDateInputView = require("./base_date_input_view.coffee");

Backbone = require('backbone');

Backbone.$ = $;

EmailFormIntlDateTimeInputView = (function(superClass) {
  extend(EmailFormIntlDateTimeInputView, superClass);

  function EmailFormIntlDateTimeInputView() {
    return EmailFormIntlDateTimeInputView.__super__.constructor.apply(this, arguments);
  }

  EmailFormIntlDateTimeInputView.prototype.tagName = 'li';

  EmailFormIntlDateTimeInputView.prototype.events = {
    'change .date_time_input': 'validateEmailForm',
    'keydown .date_time_input': 'deleteKeyDownHandler'
  };

  EmailFormIntlDateTimeInputView.prototype.initialize = function() {
    var ref;
    EmailFormIntlBaseDateInputView.prototype.initialize.apply(this, arguments);
    this.elementID = ".date_time_input";
    this.show_template = {
      date_time_input_template: true
    };
    if (((ref = this.model.additional_attributes) != null ? ref.options : void 0) != null) {
      return this.dropdownOptions = this.getDropdownOptions(this.model.additional_attributes.options);
    }
  };

  EmailFormIntlDateTimeInputView.prototype.getDropdownOptions = function(options) {
    var dropdownOptions, i, len, option;
    dropdownOptions = [];
    for (i = 0, len = options.length; i < len; i++) {
      option = options[i];
      dropdownOptions.push({
        id: option,
        text: option
      });
    }
    return dropdownOptions;
  };

  EmailFormIntlDateTimeInputView.prototype.getTimeSlotInputHtmlElement = function() {
    return this.$el.find(".time_slot option:selected");
  };

  EmailFormIntlDateTimeInputView.prototype.readInput = function() {
    var date, slot;
    date = this.getInputHtmlElement().val().trim();
    slot = this.getTimeSlotInputHtmlElement().text();
    return date + " - " + slot;
  };

  return EmailFormIntlDateTimeInputView;

})(EmailFormIntlBaseDateInputView);

module.exports = EmailFormIntlDateTimeInputView;



},{"./base_date_input_view.coffee":116,"backbone":245}],120:[function(require,module,exports){
var Backbone, EmailFormIntlDropdownInputView, SupportFlexibleEmailFormObjectsTemplate,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportFlexibleEmailFormObjectsTemplate = require('../../../../flexible_email_form_objects.html.mustache');

Backbone = require('backbone');

Backbone.$ = $;

EmailFormIntlDropdownInputView = (function(superClass) {
  extend(EmailFormIntlDropdownInputView, superClass);

  function EmailFormIntlDropdownInputView() {
    return EmailFormIntlDropdownInputView.__super__.constructor.apply(this, arguments);
  }

  EmailFormIntlDropdownInputView.prototype.tagName = 'li';

  EmailFormIntlDropdownInputView.prototype.events = {
    'change .dropdown_input': 'validateEmailForm'
  };

  EmailFormIntlDropdownInputView.prototype.initialize = function(options) {
    this.options = options || {};
    this.I18nScope = 'modules.support';
    this.isInputFieldEmpty = true;
    this.maxLength = 250;
    this.elementID = ".dropdown_input";
    this.template = SupportFlexibleEmailFormObjectsTemplate;
    this.model = this.options.model;
    this.isFlexibleStepThree = this.options.isFlexibleStepThree;
    this.label = this.model.label;
    this.dropdownOptions = this.getDropdownOptions(this.model.additional_attributes.options);
    return this.isInputCompulsory = this.model.required === true || this.model.required === "true";
  };

  EmailFormIntlDropdownInputView.prototype.render = function() {
    this.$el.html(toHtml(this.template, this.toHash()));
    return $(this.elementID).datepicker();
  };

  EmailFormIntlDropdownInputView.prototype.getDropdownOptions = function(options) {
    var dropdownOptions, i, len, option;
    dropdownOptions = [];
    for (i = 0, len = options.length; i < len; i++) {
      option = options[i];
      dropdownOptions.push({
        id: option,
        text: option
      });
    }
    return dropdownOptions;
  };

  EmailFormIntlDropdownInputView.prototype.toHash = function() {
    return {
      stepThreeType: this.isFlexibleStepThree ? 'flexibleStepThree' : 'defaultStepThree',
      dropdown_input_template: true,
      label: this.label,
      required: this.isInputCompulsory,
      maxLength: this.maxLength,
      options: this.dropdownOptions,
      counter: this.model.counter
    };
  };

  EmailFormIntlDropdownInputView.prototype.getInputHtmlElement = function() {
    return this.$el.find(this.elementID + " option:selected");
  };

  EmailFormIntlDropdownInputView.prototype.isInputGiven = function() {
    var ref;
    return ((ref = this.readInput()) != null ? ref.length : void 0) > 0;
  };

  EmailFormIntlDropdownInputView.prototype.readInput = function() {
    return this.getInputHtmlElement().val();
  };

  EmailFormIntlDropdownInputView.prototype.isInputValid = function() {
    return true;
  };

  EmailFormIntlDropdownInputView.prototype.validateEmailForm = function() {
    if (this.isInputCompulsory && ((this.isInputFieldEmpty && this.isInputGiven()) || !(this.isInputFieldEmpty || this.isInputGiven()))) {
      this.isInputFieldEmpty = !this.isInputGiven();
      return this.options.validateEmailForm();
    }
  };

  EmailFormIntlDropdownInputView.prototype.populateInput = function(data) {
    var inputData;
    if (this.isInputGiven()) {
      inputData = this.readInput();
      return data.description += "\n\n " + this.label + " : " + inputData;
    }
  };

  return EmailFormIntlDropdownInputView;

})(Backbone.View);

module.exports = EmailFormIntlDropdownInputView;



},{"../../../../flexible_email_form_objects.html.mustache":43,"backbone":245}],121:[function(require,module,exports){
var Backbone, EmailFormIntlFileInputView, SupportFlexibleEmailFormObjectsTemplate,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportFlexibleEmailFormObjectsTemplate = require('../../../../flexible_email_form_objects.html.mustache');

Backbone = require('backbone');

Backbone.$ = $;

EmailFormIntlFileInputView = (function(superClass) {
  extend(EmailFormIntlFileInputView, superClass);

  function EmailFormIntlFileInputView() {
    return EmailFormIntlFileInputView.__super__.constructor.apply(this, arguments);
  }

  EmailFormIntlFileInputView.prototype.tagName = 'li';

  EmailFormIntlFileInputView.prototype.events = {
    'change #fileupload': 'getFileData',
    'click #file_reset': 'resetFileInput'
  };

  EmailFormIntlFileInputView.prototype.initialize = function(options) {
    this.options = options || {};
    _.bindAll.apply(_, [this].concat(_.functions(this)));
    this.elementID = "#email_file_input";
    this.model = this.options.model;
    this.isFlexibleStepThree = this.options.isFlexibleStepThree;
    this.label = this.model.label;
    this.required = this.model.required === true || this.model.required === "true";
    this.isInputCompulsory = this.model.required === true || this.model.required === "true";
    this.I18nScope = 'modules.support';
    this.template = SupportFlexibleEmailFormObjectsTemplate;
    return this.resetFileData();
  };

  EmailFormIntlFileInputView.prototype.render = function() {
    return this.$el.html(toHtml(this.template, this.toHash()));
  };

  EmailFormIntlFileInputView.prototype.toHash = function() {
    return {
      stepThreeType: this.isFlexibleStepThree ? 'flexibleStepThree' : 'defaultStepThree',
      file_input_template: this.isFileUploadEnabled(),
      label: this.label,
      required: this.isInputCompulsory,
      counter: this.model.counter
    };
  };

  EmailFormIntlFileInputView.prototype.isInputGiven = function() {
    return this.fileData !== null || (!this.isFileUploadEnabled());
  };

  EmailFormIntlFileInputView.prototype.isFileUploadEnabled = function() {
    return window.evaluate(typeof experiments !== "undefined" && experiments !== null ? experiments.fileUpload : void 0);
  };

  EmailFormIntlFileInputView.prototype.isInputValid = function() {
    return this.validateFileInput();
  };

  EmailFormIntlFileInputView.prototype.validateFileInput = function() {
    var acceptedFormats, err_msg, file, fileFormat, fileSize, fileUploadHtmlElement, maxSize, ref;
    fileUploadHtmlElement = this.getFileInput();
    if ((fileUploadHtmlElement != null ? (ref = fileUploadHtmlElement.files) != null ? ref.length : void 0 : void 0) > 0) {
      file = fileUploadHtmlElement.files[0];
    }
    if (file != null) {
      this.fileName = file.name;
      fileFormat = this.getFileFormat();
      fileSize = file.size;
      acceptedFormats = ['jpg', 'jpeg', 'gif', 'bmp', 'png', 'pdf', 'xls', 'xlsx', 'doc', 'docx', 'txt', 'csv', 'tiff'];
      maxSize = 1000000;
      if (($.inArray(fileFormat, acceptedFormats) >= 0) && fileSize < maxSize) {
        this.$(".error_upload").text("");
        return true;
      } else {
        err_msg = I18n.translate('js.modules.support.invalid_file_message', {
          acceptedFormats: "" + acceptedFormats,
          max_size: 1
        });
        this.$(".error_upload").text(err_msg);
        return false;
      }
    } else {
      return true;
    }
  };

  EmailFormIntlFileInputView.prototype.renderErrorUpload = function() {
    return $(".error_upload").text('Error uploading file');
  };

  EmailFormIntlFileInputView.prototype.removeUploadError = function() {
    return $(".error_upload").text('');
  };

  EmailFormIntlFileInputView.prototype.showFileReset = function() {
    return this.$('#file_reset').show();
  };

  EmailFormIntlFileInputView.prototype.hideFileReset = function() {
    return this.$('#file_reset').hide();
  };

  EmailFormIntlFileInputView.prototype.validateEmailForm = function() {
    if (this.isInputCompulsory) {
      return this.options.validateEmailForm();
    }
  };

  EmailFormIntlFileInputView.prototype.resetFileInput = function() {
    var fileControl;
    fileControl = $('.fileupload');
    if ((fileControl != null ? fileControl.length : void 0) > 0) {
      fileControl.wrap('<form>').closest('form').get(0).reset();
      fileControl.unwrap();
    }
    this.resetFileData();
    this.hideFileReset();
    return this.validateEmailForm();
  };

  EmailFormIntlFileInputView.prototype.getFileData = function(e) {
    var reader, ref, ref1, ref2;
    if (((ref = this.getFileInput()) != null ? (ref1 = ref.files) != null ? ref1.length : void 0 : void 0) > 0) {
      this.showFileReset();
      reader = new FileReader();
      reader.onloadend = this.getFileText;
      reader.onerror = this.renderErrorUpload;
      return reader.readAsDataURL((ref2 = this.getFileInput()) != null ? ref2.files[0] : void 0);
    } else {
      this.resetFileData();
      return this.hideFileReset();
    }
  };

  EmailFormIntlFileInputView.prototype.getFileFormat = function() {
    return this.fileName.split(".")[this.fileName.split(".").length - 1].toLowerCase();
  };

  EmailFormIntlFileInputView.prototype.getFileName = function() {
    var filename, fullPath, ref, startIndex;
    fullPath = (ref = this.getFileInput()) != null ? ref.value : void 0;
    startIndex = (fullPath.indexOf("\\") >= 0 ? fullPath.lastIndexOf("\\") : fullPath.lastIndexOf("/"));
    filename = fullPath.substring(startIndex);
    if (filename.indexOf("\\") === 0 || filename.indexOf("/") === 0) {
      return filename.substring(1);
    }
  };

  EmailFormIntlFileInputView.prototype.getFileText = function(e) {
    this.fileData = e.target.result;
    this.fileName = this.getFileName();
    return this.validateEmailForm();
  };

  EmailFormIntlFileInputView.prototype.resetFileData = function() {
    this.fileData = null;
    return this.fileName = null;
  };

  EmailFormIntlFileInputView.prototype.getFileInput = function() {
    return document.getElementById('fileupload');
  };

  EmailFormIntlFileInputView.prototype.populateInput = function(data) {
    data.fileData = this.fileData;
    return data.fileName = this.fileName;
  };

  return EmailFormIntlFileInputView;

})(Backbone.View);

module.exports = EmailFormIntlFileInputView;



},{"../../../../flexible_email_form_objects.html.mustache":43,"backbone":245}],122:[function(require,module,exports){
var Backbone, EmailFormIntlFlexibleContactChannelsView, SupportFlexibleContactChannelsTemplate,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportFlexibleContactChannelsTemplate = require('../../../../flexible_contact_channels.html.mustache');

Backbone = require('backbone');

Backbone.$ = $;

EmailFormIntlFlexibleContactChannelsView = (function(superClass) {
  extend(EmailFormIntlFlexibleContactChannelsView, superClass);

  function EmailFormIntlFlexibleContactChannelsView() {
    return EmailFormIntlFlexibleContactChannelsView.__super__.constructor.apply(this, arguments);
  }

  EmailFormIntlFlexibleContactChannelsView.prototype.className = 'flexible-contact-channels-view';

  EmailFormIntlFlexibleContactChannelsView.prototype.events = {
    'DOMSubtreeModified .flex-primary-chat-button#live-chat-container': 'handleDisplayOfPrimaryLiveChat',
    'DOMSubtreeModified .primary-chat-link#live-chat-link-container': 'handleDisplayOfPrimaryLiveChatLink',
    'DOMSubtreeModified .secondary-chat-link#live-chat-link-container': 'handleDisplayOfSecondaryLiveChatLink',
    'DOMSubtreeModified .tertiary-chat-link#live-chat-link-container': 'handleDisplayOfTertiaryLiveChatLink',
    'click .flex-primary-email-button': 'renderEmailForm',
    'click .flex-primary-phone-button': 'renderPhoneView',
    'click .flex-email-link': 'renderEmailForm',
    'click .flex-phone-link': 'renderPhoneView'
  };

  EmailFormIntlFlexibleContactChannelsView.prototype.initialize = function(options) {
    this.options = options || {};
    _.bindAll.apply(_, [this].concat(_.functions(this)));
    this.I18nScope = 'modules.support';
    this.template = SupportFlexibleContactChannelsTemplate;
    this.model = Groupon.Support.FlexibleContactChannelModel;
    return this.mainView = this.options.mainView;
  };

  EmailFormIntlFlexibleContactChannelsView.prototype.render = function() {
    this.model.presentContactChannels();
    this.$el.empty();
    this.$el.append(toHtml(this.template, this.toHash({
      renderLayout: true,
      withoutChat: !this.isLiveChatEnabled()
    }), this.I18nScope));
    this.handleDisplayOfChannelsWithMoreSpace();
    return this;
  };

  EmailFormIntlFlexibleContactChannelsView.prototype.isLiveChatEnabled = function() {
    return Groupon.Support.LiveChatModel.isLiveChatEnabled();
  };

  EmailFormIntlFlexibleContactChannelsView.prototype.renderEmailForm = function(e) {
    return this.mainView.renderEmailForm();
  };

  EmailFormIntlFlexibleContactChannelsView.prototype.renderPhoneView = function() {
    return this.mainView.renderPhoneNumberView();
  };

  EmailFormIntlFlexibleContactChannelsView.prototype.handleDisplayOfChannelsWithMoreSpace = function() {
    if (window.evaluate(window.experiments.showFlexibleContactChannelsWithMoreSpace)) {
      this.$el.addClass('flexible-contact-channels-view-with-more-space');
      this.$el.find('.flex-primary-button').addClass('flex-primary-button-text-with-more-space');
      return this.$el.find('.flex-primary-chat-button').addClass('flex-primary-button-text-with-more-space');
    }
  };

  EmailFormIntlFlexibleContactChannelsView.prototype.handleDisplayOfPrimaryLiveChat = function() {
    this.$el.find('.flex-contact-channels-without-chat').empty();
    this.setFlexibleLiveChatDisplayCallBack(this.handleDisplayOfPrimaryLiveChat);
    if (this.flexiblePrimaryLiveChatVisible()) {
      window.showDOMElems($('.help-wizard-content > .flexible-contact-channels-container'));
      return window.hideDOMElems($('.flex-contact-channels-without-chat'));
    } else {
      window.hideDOMElems($('.help-wizard-content > .flexible-contact-channels-container'));
      window.showDOMElems($('.flex-contact-channels-without-chat'));
      $('.flex-contact-channels-without-chat').append(toHtml(this.template, this.toHash({
        withoutChat: true
      }), this.I18nScope));
      return this.handleDisplayOfChannelsWithMoreSpace();
    }
  };

  EmailFormIntlFlexibleContactChannelsView.prototype.handleDisplayOfPrimaryLiveChatLink = function() {
    var primaryChatTextElem;
    primaryChatTextElem = $(".flex-primary-channel-text");
    return this.toggleDomElemsBasedOnLiveChat(primaryChatTextElem);
  };

  EmailFormIntlFlexibleContactChannelsView.prototype.handleDisplayOfSecondaryLiveChatLink = function() {
    var DOMelemsToToggle, flexTertiaryOrTextElem, secondaryFlexibleLiveChatContainerElem;
    secondaryFlexibleLiveChatContainerElem = $('.secondary-flex-chat-channel');
    flexTertiaryOrTextElem = $('.flex-channel-or-text');
    DOMelemsToToggle = [secondaryFlexibleLiveChatContainerElem, flexTertiaryOrTextElem];
    if (this.model.get('formattedContactChannels').contact_channels.length === 2) {
      DOMelemsToToggle.push($('.flex-secondary-channel-also-text'));
    }
    return this.toggleDomElemsBasedOnLiveChat(DOMelemsToToggle);
  };

  EmailFormIntlFlexibleContactChannelsView.prototype.handleDisplayOfTertiaryLiveChatLink = function() {
    var flexTertiaryOrTextElem, tertiaryFlexibleLiveChatContainerElem;
    tertiaryFlexibleLiveChatContainerElem = $('.tertiary-flex-chat-channel');
    flexTertiaryOrTextElem = $('.flex-channel-or-text');
    return this.toggleDomElemsBasedOnLiveChat([tertiaryFlexibleLiveChatContainerElem, flexTertiaryOrTextElem]);
  };

  EmailFormIntlFlexibleContactChannelsView.prototype.toggleDomElemsBasedOnLiveChat = function(domElems) {
    if (window.liveChatLinkVisible()) {
      return window.showDOMElemsInline(domElems);
    } else {
      window.removeDOMElemsInline(domElems);
      return window.hideDOMElems(domElems);
    }
  };

  EmailFormIntlFlexibleContactChannelsView.prototype.setFlexibleLiveChatDisplayCallBack = function(liveChatDisplayCallback) {
    return window.setLiveChatDisplayCallBack($('.flexible-contact-channels-container #live-chat-container a img'), liveChatDisplayCallback);
  };

  EmailFormIntlFlexibleContactChannelsView.prototype.flexiblePrimaryLiveChatVisible = function() {
    return window.liveChatVisible($('.flexible-contact-channels-container #live-chat-container a img'));
  };

  EmailFormIntlFlexibleContactChannelsView.prototype.handleDisplayOfContactChannels = function() {
    if ($('.flex-primary-chat-button#live-chat-container').length > 0) {
      return this.handleDisplayOfPrimaryLiveChat();
    }
  };

  EmailFormIntlFlexibleContactChannelsView.prototype.toHash = function(arg) {
    var hash, renderLayout, withoutChat;
    withoutChat = arg.withoutChat, renderLayout = arg.renderLayout;
    hash = {};
    if (withoutChat) {
      hash = this.model.get('contactChannelsWithoutBoldChat');
    } else if (this.model.has('formattedContactChannels')) {
      hash = this.model.get('formattedContactChannels');
    } else {
      hash = this.model.get('contactChannelsWithoutBoldChat');
    }
    if (renderLayout) {
      hash = $.extend(true, {
        renderLayout: true
      }, hash);
    }
    return hash;
  };

  EmailFormIntlFlexibleContactChannelsView.prototype.renderLiveChat = function() {
    var ref;
    if ((ref = this.model) != null ? ref.get('liveChatExists') : void 0) {
      if (this.model.get("primaryChannelIsBoldChat")) {
        this.mainView.renderLiveChat({
          liveChatMode: 'static',
          liveChatType: Groupon.Support.LiveChatModel.getFlexibleLiveChatType()
        });
      }
      return this.mainView.renderLiveChat({
        liveChatMode: 'static',
        liveChatType: Groupon.Support.LiveChatModel.getLinkLiveChatType(),
        startFromSameViewState: this.model.get("primaryChannelIsBoldChat")
      });
    } else {
      return this.mainView.renderLiveChat({
        liveChatMode: 'static'
      });
    }
  };

  return EmailFormIntlFlexibleContactChannelsView;

})(Backbone.View);

module.exports = EmailFormIntlFlexibleContactChannelsView;



},{"../../../../flexible_contact_channels.html.mustache":42,"backbone":245}],123:[function(require,module,exports){
var CurrentOrderView, EmailFormBaseView, EmailFormEmailInputView, EmailFormIntlCheckboxInputView, EmailFormIntlDateInputView, EmailFormIntlDateTimeInputView, EmailFormIntlDropdownInputView, EmailFormIntlFileInputView, EmailFormIntlMainView, EmailFormIntlPhoneChannelView, EmailFormIntlTextParagraphInputView, EmailFormIntlTextParagraphView, EmailFormPhoneNumberInputView, EmailFormTextLineInputView, EmailFormUserNameInputView, SharedFooterView, SharedWidgetLayoutView, SupportFlexibleEmailFormObjectsTemplate, SupportFlexibleStepThreeTemplate,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

EmailFormPhoneNumberInputView = require("../../common/views/phone_number_input");

EmailFormIntlTextParagraphInputView = require("./text_paragraph_input_view");

EmailFormIntlTextParagraphView = require("./text_paragraph_view");

EmailFormTextLineInputView = require("../../common/views/text_line_input_view");

EmailFormIntlFileInputView = require("./file_input_view");

EmailFormIntlFileInputView = require("./number_input_view");

EmailFormEmailInputView = require("../../common/views/email_input_view");

EmailFormIntlDateTimeInputView = require("./date_time_input");

EmailFormBaseView = require("../base_view");

EmailFormIntlPhoneChannelView = require("./phone_channel_view");

CurrentOrderView = require("../../order_related/current_order_view");

SharedFooterView = require("../../../../../shared/frontend/views/footer/INTL/main_view");

EmailFormIntlDateInputView = require("./date_input_view");

EmailFormIntlDropdownInputView = require("./dropdown_input_view");

EmailFormIntlCheckboxInputView = require("./checkbox_input_view");

EmailFormUserNameInputView = require("./user_name_input_view");

SharedWidgetLayoutView = require("../../../../../shared/frontend/views/widget_layout_veiw");

SupportFlexibleStepThreeTemplate = require('../../../../flexible_step_three.html.mustache');

SupportFlexibleEmailFormObjectsTemplate = require('../../../../flexible_email_form_objects.html.mustache');

EmailFormIntlMainView = (function(superClass) {
  extend(EmailFormIntlMainView, superClass);

  function EmailFormIntlMainView() {
    return EmailFormIntlMainView.__super__.constructor.apply(this, arguments);
  }

  EmailFormIntlMainView.prototype.events = {
    'click .submit-button': 'onSubmitClick'
  };

  EmailFormIntlMainView.prototype.initialize = function(options) {
    _.bindAll.apply(_, [this].concat(_.functions(this)));
    EmailFormBaseView.prototype.initialize.apply(this, arguments);
    this.footerContainer = $("#footer-content");
    this.template = SupportFlexibleStepThreeTemplate;
    this.model = options.emailFormModel;
    this.inputObjects = this.model.getEmailFormInputObjects();
    this.emailFormViewFooter = new SharedFooterView({
      template: 'support_phone_channel_footer',
      emailUs: this.emailUsCallback,
      model: this.model
    });
    return this.currentOrderView = new CurrentOrderView({
      hideSelfServiceActions: true,
      hideExternalDealNotes: true,
      showV2View: false
    });
  };

  EmailFormIntlMainView.prototype.render = function() {
    SharedWidgetLayoutView.hideWidgets();
    if (this.isPhonePreferredChannel()) {
      return this.contactByPhone();
    } else {
      return this.contactByEmail();
    }
  };

  EmailFormIntlMainView.prototype.isPhonePreferredChannel = function() {
    return this.model.isMethodOfContactByPhone() || this.model.isMethodOfContactByPhoneWithEmail();
  };

  EmailFormIntlMainView.prototype.contactByEmail = function() {
    this.hideComponents();
    this.renderFlexStepThree();
    this.renderInputViews(this.inputObjects, "#componentList");
    if (evaluate(Groupon.Support.ContentModel.isRefundEligible) && Groupon.Support.currentOrder) {
      this.renderCurrentOrder();
    }
    this.renderStepActions();
    return this.validateEmailForm();
  };

  EmailFormIntlMainView.prototype.renderFlexStepThree = function() {
    return this.$el.html(toHtml(this.template, this.toHash(), this.I18nScope));
  };

  EmailFormIntlMainView.prototype.contactByPhone = function() {
    this.hideComponents();
    this.$el.html(toHtml(this.template, {}, this.I18nScope));
    this.renderPhoneChannelView();
    this.renderStepActions();
    if (this.isPhonePreferredChannel()) {
      this.renderEmailUsFooter();
    }
    return this.hideSubmitButton();
  };

  EmailFormIntlMainView.prototype.emailUsCallback = function() {
    return this.contactByEmail();
  };

  EmailFormIntlMainView.prototype.populateRefundParams = function(currentOrder, orderDetails) {
    var base, ref, ref1;
    currentOrder.formattedTotalPrice = orderDetails.formattedTotalPrice;
    if ((((ref = currentOrder.groupons) != null ? ref[0] : void 0) != null) && (((ref1 = orderDetails.groupons) != null ? ref1[0] : void 0) != null)) {
      return (base = currentOrder.groupons[0]).redemptionCode != null ? base.redemptionCode : base.redemptionCode = orderDetails.groupons[0].redemptionCode;
    }
  };

  EmailFormIntlMainView.prototype.renderCurrentOrder = function() {
    var _successCallback, currentOrder, params;
    currentOrder = Groupon.Support.currentOrder;
    if (!currentOrder.formattedTotalPrice) {
      params = {
        order: currentOrder,
        forceFetchOrderDetails: true,
        isRefundEligible: true
      };
      _successCallback = (function(_this) {
        return function(orderDetails) {
          if (orderDetails) {
            return _this.populateRefundParams(currentOrder, orderDetails);
          }
        };
      })(this);
      Groupon.Support.OrderModel.getOrderDetails(params, _successCallback, function() {});
    }
    this.currentOrderView.$el.addClass('step-three-order-view');
    this.currentOrderView.render();
    return this.$el.find('.step-three-voucher').append(this.currentOrderView.el);
  };

  EmailFormIntlMainView.prototype.renderPhoneChannelView = function() {
    this.phoneChannelView = new EmailFormIntlPhoneChannelView;
    this.phoneChannelView.render();
    return this.$el.append(this.phoneChannelView.el);
  };

  EmailFormIntlMainView.prototype.removePhoneChannelView = function() {
    if (this.phoneChannelView != null) {
      return this.phoneChannelView.remove();
    }
  };

  EmailFormIntlMainView.prototype.getViewByObjectType = function(obj) {
    var options;
    options = {
      model: obj,
      validateEmailForm: this.validateEmailForm,
      isFlexibleStepThree: this.model.isFlexibleStepThree,
      template: SupportFlexibleEmailFormObjectsTemplate
    };
    obj.counter = this.getEmailFormObjectCount(obj.type);
    switch (obj.type) {
      case 'phone_number':
        return new EmailFormPhoneNumberInputView(options);
      case 'email_address':
        return new EmailFormEmailInputView(options);
      case 'number':
        return new EmailFormIntlFileInputView(options);
      case 'text_field_paragraph':
        return new EmailFormIntlTextParagraphInputView(options);
      case 'text_paragraph':
        return new EmailFormIntlTextParagraphView(options);
      case 'text_field_line':
        return new EmailFormTextLineInputView(options);
      case 'attachment':
        return new EmailFormIntlFileInputView(options);
      case 'calendar_date':
        return new EmailFormIntlDateInputView(options);
      case 'calendar_with_hour_slot':
        return new EmailFormIntlDateTimeInputView(options);
      case 'dropdown':
        return new EmailFormIntlDropdownInputView(options);
      case 'checkbox':
        return new EmailFormIntlCheckboxInputView(options);
      case 'user_name':
        return new EmailFormUserNameInputView(options);
    }
  };

  EmailFormIntlMainView.prototype.getEmailFormObjectCount = function(objectType) {
    if (this.model.emailFormObjectsCount[objectType] != null) {
      return ++this.model.emailFormObjectsCount[objectType];
    }
  };

  EmailFormIntlMainView.prototype.renderEmailUsFooter = function() {
    if (this.emailFormViewFooter) {
      this.emailFormViewFooter.render();
      return this.footerContainer.html(this.emailFormViewFooter.el);
    }
  };

  EmailFormIntlMainView.prototype.hideSubmitButton = function() {
    return this.$el.find(".submit-button").hide();
  };

  EmailFormIntlMainView.prototype.showSubmitButton = function() {
    return this.$el.find(".submit-button").show();
  };

  EmailFormIntlMainView.prototype.toHash = function() {
    var ref, ref1;
    return {
      reason: this.getIssueReason(),
      is_order: Groupon.Support.currentOrder != null,
      show_reason: !this.model.isDummyCategory,
      email_channel: true,
      merchant_name: getDealMerchantName(),
      faqInsteadHelpWizard: window.faqInsteadHelpWizard,
      escalate_to_merchant: Groupon.Support.ContentModel.escalateToMerchant,
      is_refund_eligible: Groupon.Support.ContentModel.isRefundEligible,
      deal_option_title: (ref = Groupon.Support.currentOrder) != null ? (ref1 = ref.dealOption) != null ? ref1.title : void 0 : void 0
    };
  };

  EmailFormIntlMainView.prototype.getChatParams = function() {
    var params;
    return params = {
      issue: this.getIssueReason()
    };
  };

  EmailFormIntlMainView.prototype.getIssueReason = function() {
    return this.model.reasonText;
  };

  return EmailFormIntlMainView;

})(EmailFormBaseView);

module.exports = EmailFormIntlMainView;



},{"../../../../../shared/frontend/views/footer/INTL/main_view":20,"../../../../../shared/frontend/views/widget_layout_veiw":25,"../../../../flexible_email_form_objects.html.mustache":43,"../../../../flexible_step_three.html.mustache":44,"../../common/views/email_input_view":112,"../../common/views/phone_number_input":113,"../../common/views/text_line_input_view":115,"../../order_related/current_order_view":157,"../base_view":145,"./checkbox_input_view":117,"./date_input_view":118,"./date_time_input":119,"./dropdown_input_view":120,"./file_input_view":121,"./number_input_view":124,"./phone_channel_view":125,"./text_paragraph_input_view":126,"./text_paragraph_view":127,"./user_name_input_view":128}],124:[function(require,module,exports){
var EmailFormIntlNumberInputView, EmailFormTextInputView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

EmailFormTextInputView = require("../../common/views/text_input_view");

EmailFormIntlNumberInputView = (function(superClass) {
  extend(EmailFormIntlNumberInputView, superClass);

  function EmailFormIntlNumberInputView() {
    return EmailFormIntlNumberInputView.__super__.constructor.apply(this, arguments);
  }

  EmailFormIntlNumberInputView.prototype.tagName = 'li';

  EmailFormIntlNumberInputView.prototype.events = {
    'keyup .number_input': 'validateEmailForm'
  };

  EmailFormIntlNumberInputView.prototype.initialize = function() {
    EmailFormTextInputView.prototype.initialize.apply(this, arguments);
    this.elementID = ".number_input";
    return this.template = {
      number_input_template: true
    };
  };

  return EmailFormIntlNumberInputView;

})(EmailFormTextInputView);

module.exports = EmailFormIntlNumberInputView;



},{"../../common/views/text_input_view":114}],125:[function(require,module,exports){
var Backbone, EmailFormIntlPhoneChannelView, SupportFlexPhoneChannelTemplate,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportFlexPhoneChannelTemplate = require('../../../../flex_phone_channel.html.mustache');

Backbone = require('backbone');

Backbone.$ = $;

EmailFormIntlPhoneChannelView = (function(superClass) {
  extend(EmailFormIntlPhoneChannelView, superClass);

  function EmailFormIntlPhoneChannelView() {
    return EmailFormIntlPhoneChannelView.__super__.constructor.apply(this, arguments);
  }

  EmailFormIntlPhoneChannelView.prototype.initialize = function() {
    this.I18nScope = 'modules.support';
    return this.template = SupportFlexPhoneChannelTemplate;
  };

  EmailFormIntlPhoneChannelView.prototype.render = function() {
    return this.$el.html(toHtml(this.template, this.toHash(), this.I18nScope));
  };

  EmailFormIntlPhoneChannelView.prototype.toHash = function() {
    var hash, mode, ref, ref1;
    if (((ref = window.liveChatInfo) != null ? (ref1 = ref.mode) != null ? ref1.step_three : void 0 : void 0) != null) {
      mode = window.liveChatInfo.mode.step_three;
    }
    return hash = {
      call_us_message: getCallUsMsg(),
      showStaticLiveChat: isStaticLiveChat(mode) || isBothLiveChats(mode)
    };
  };

  return EmailFormIntlPhoneChannelView;

})(Backbone.View);

module.exports = EmailFormIntlPhoneChannelView;



},{"../../../../flex_phone_channel.html.mustache":41,"backbone":245}],126:[function(require,module,exports){
var EmailFormIntlTextParagraphInputView, EmailFormTextInputView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

EmailFormTextInputView = require("../../common/views/text_input_view");

EmailFormIntlTextParagraphInputView = (function(superClass) {
  extend(EmailFormIntlTextParagraphInputView, superClass);

  function EmailFormIntlTextParagraphInputView() {
    return EmailFormIntlTextParagraphInputView.__super__.constructor.apply(this, arguments);
  }

  EmailFormIntlTextParagraphInputView.prototype.tagName = 'li';

  EmailFormIntlTextParagraphInputView.prototype.events = {
    'keyup .text_paragraph_input': 'validateEmailForm'
  };

  EmailFormIntlTextParagraphInputView.prototype.initialize = function() {
    EmailFormTextInputView.prototype.initialize.apply(this, arguments);
    this.elementID = ".text_paragraph_input";
    return this.template = {
      text_paragraph_input_template: true
    };
  };

  return EmailFormIntlTextParagraphInputView;

})(EmailFormTextInputView);

module.exports = EmailFormIntlTextParagraphInputView;



},{"../../common/views/text_input_view":114}],127:[function(require,module,exports){
var Backbone, EmailFormIntlTextParagraphView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Backbone = require('backbone');

Backbone.$ = $;

EmailFormIntlTextParagraphView = (function(superClass) {
  extend(EmailFormIntlTextParagraphView, superClass);

  function EmailFormIntlTextParagraphView() {
    return EmailFormIntlTextParagraphView.__super__.constructor.apply(this, arguments);
  }

  EmailFormIntlTextParagraphView.prototype.tagName = 'li';

  EmailFormIntlTextParagraphView.prototype.initialize = function(options) {
    this.options = options || {};
    this.model = this.options.model;
    this.label = this.model.label;
    this.isFlexibleStepThree = this.options.isFlexibleStepThree;
    this.base_template = this.options.template;
    this.template = {
      text_paragraph_template: true
    };
    return this.isInputCompulsory = this.model.required === true || this.model.required === "true";
  };

  EmailFormIntlTextParagraphView.prototype.render = function() {
    return this.$el.html(toHtml(this.base_template, this.toHash()));
  };

  EmailFormIntlTextParagraphView.prototype.toHash = function() {
    var hash, labels, textLines;
    labels = this.label.split('\\n');
    textLines = [];
    _.each(labels, function(label, index) {
      textLines[index] = {};
      return textLines[index].text = label;
    });
    hash = {
      required: this.isInputCompulsory,
      stepThreeType: this.isFlexibleStepThree ? 'flexibleStepThree' : 'defaultStepThree',
      counter: this.model.counter,
      labels: textLines
    };
    return _.extend(this.template, hash);
  };

  EmailFormIntlTextParagraphView.prototype.isInputGiven = function() {
    return true;
  };

  EmailFormIntlTextParagraphView.prototype.isInputValid = function() {
    return true;
  };

  EmailFormIntlTextParagraphView.prototype.populateInput = function(data) {
    return data;
  };

  EmailFormIntlTextParagraphView.prototype.validateEmailForm = function() {
    return this.options.validateEmailForm();
  };

  return EmailFormIntlTextParagraphView;

})(Backbone.View);

module.exports = EmailFormIntlTextParagraphView;



},{"backbone":245}],128:[function(require,module,exports){
var EmailFormTextInputView, EmailFormUserNameInputView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

EmailFormTextInputView = require("../../common/views/text_input_view");

EmailFormUserNameInputView = (function(superClass) {
  extend(EmailFormUserNameInputView, superClass);

  function EmailFormUserNameInputView() {
    return EmailFormUserNameInputView.__super__.constructor.apply(this, arguments);
  }

  EmailFormUserNameInputView.prototype.tagName = 'li';

  EmailFormUserNameInputView.prototype.events = {
    'keyup .user_name_input': 'validateUserName'
  };

  EmailFormUserNameInputView.prototype.initialize = function() {
    EmailFormTextInputView.prototype.initialize.apply(this, arguments);
    this.elementID = ".user_name_input";
    return this.template = {
      user_name_input_template: true
    };
  };

  EmailFormUserNameInputView.prototype.isInputValid = function() {
    var ref, ref1, ref2;
    if (!this.isInputElementPresent()) {
      return true;
    }
    return ((ref = this.getInputHtmlElement()) != null ? (ref1 = ref.val()) != null ? (ref2 = ref1.trim()) != null ? ref2.length : void 0 : void 0 : void 0) > 0;
  };

  EmailFormUserNameInputView.prototype.isInputElementPresent = function() {
    var ref;
    return ((ref = this.getInputHtmlElement()) != null ? ref.length : void 0) > 0;
  };

  EmailFormUserNameInputView.prototype.validateUserName = function() {
    this.isInputValid();
    return this.validateEmailForm();
  };

  EmailFormUserNameInputView.prototype.populateInput = function(data) {
    if (this.isInputGiven()) {
      data.user_name = this.readInput();
      return EmailFormTextInputView.prototype.populateInput.call(this, data);
    }
  };

  return EmailFormUserNameInputView;

})(EmailFormTextInputView);

module.exports = EmailFormUserNameInputView;



},{"../../common/views/text_input_view":114}],129:[function(require,module,exports){
var EmailFormIntlV2FlexibleContactChannelsView, EmailFormV2FlexibleContactChannelsView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

EmailFormV2FlexibleContactChannelsView = require("../common/v2_flexible_contact_channels");

EmailFormIntlV2FlexibleContactChannelsView = (function(superClass) {
  extend(EmailFormIntlV2FlexibleContactChannelsView, superClass);

  function EmailFormIntlV2FlexibleContactChannelsView() {
    return EmailFormIntlV2FlexibleContactChannelsView.__super__.constructor.apply(this, arguments);
  }

  EmailFormIntlV2FlexibleContactChannelsView.prototype.toHash = function(hash) {
    hash = EmailFormV2FlexibleContactChannelsView.prototype.toHash.call(this, hash);
    hash.isVertical = true;
    return hash;
  };

  EmailFormIntlV2FlexibleContactChannelsView.prototype.arrangeLayoutView = function(hash) {
    var $container;
    $container = EmailFormV2FlexibleContactChannelsView.prototype.arrangeLayoutView.call(this, hash);
    $container.find('.flexible-contact-channel-text-container').addClass('eight columns');
    $container.find('.flexible-contact-channel-icon-container').addClass('four columns');
    return $container;
  };

  return EmailFormIntlV2FlexibleContactChannelsView;

})(EmailFormV2FlexibleContactChannelsView);

module.exports = EmailFormIntlV2FlexibleContactChannelsView;



},{"../common/v2_flexible_contact_channels":150}],130:[function(require,module,exports){
var EmailFormIntlMainView, EmailFormIntlVerticalView, SharedAjaxError,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

EmailFormIntlMainView = require("./main_view");

SharedAjaxError = require("../../../../../shared/frontend/views/ajax_error_view");

EmailFormIntlVerticalView = (function(superClass) {
  extend(EmailFormIntlVerticalView, superClass);

  function EmailFormIntlVerticalView() {
    return EmailFormIntlVerticalView.__super__.constructor.apply(this, arguments);
  }

  EmailFormIntlVerticalView.prototype.toHash = function() {
    var hash;
    hash = EmailFormIntlMainView.prototype.toHash.call(this);
    hash.isVertical = true;
    return hash;
  };

  EmailFormIntlVerticalView.prototype.renderTicketCreateError = function() {
    var errorView;
    this.hideSubmitButton();
    errorView = new SharedAjaxError();
    return errorView.render({
      container: $('#v2-step3-form'),
      isVertical: true
    });
  };

  EmailFormIntlVerticalView.prototype.hideSubmitButton = function() {
    return $('.step-three .submit-button').hide();
  };

  EmailFormIntlVerticalView.prototype.submitForm = function(data) {
    return createTicket(data, this.renderSuccess, this.renderTicketCreateError, $('#v2-step3-form'));
  };

  return EmailFormIntlVerticalView;

})(EmailFormIntlMainView);

module.exports = EmailFormIntlVerticalView;



},{"../../../../../shared/frontend/views/ajax_error_view":19,"./main_view":123}],131:[function(require,module,exports){
var CallBackOptionSuccessView, CommonBaseView, SupportThanksForContactingTemplate,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportThanksForContactingTemplate = require('../../../../thanks_for_contacting.html.mustache');

CommonBaseView = require("../../common/views/common_base_view");

CallBackOptionSuccessView = (function(superClass) {
  extend(CallBackOptionSuccessView, superClass);

  function CallBackOptionSuccessView() {
    return CallBackOptionSuccessView.__super__.constructor.apply(this, arguments);
  }

  CallBackOptionSuccessView.prototype.template = SupportThanksForContactingTemplate;

  CallBackOptionSuccessView.prototype.render = function(params) {
    if (params == null) {
      params = {};
    }
    return this.$el.append(toHtml(this.template, this.toHash(params.waitTime), this.I18nScope));
  };

  CallBackOptionSuccessView.prototype.toHash = function(waitTime) {
    if (waitTime == null) {
      waitTime = 30;
    }
    return {
      phoneCallReceivemsg: I18n.translate('js.modules.support.call_me_back_phone_call_receive_msg', {
        display_wait_time: this.getWaitTimeDisplayUnits(waitTime)
      }),
      isCallMeBackFlow: true,
      showCallBackThankYouMsg: true
    };
  };

  CallBackOptionSuccessView.prototype.getWaitTimeDisplayUnits = function(waitTime) {
    var displayWaitTime;
    if (waitTime <= 20) {
      displayWaitTime = 'half an hour';
    } else if (waitTime <= 45) {
      displayWaitTime = 'one hour';
    } else if (waitTime <= 105) {
      displayWaitTime = '2 hours';
    } else {
      displayWaitTime = 'shortly';
    }
    return displayWaitTime;
  };

  return CallBackOptionSuccessView;

})(CommonBaseView);

module.exports = CallBackOptionSuccessView;



},{"../../../../thanks_for_contacting.html.mustache":238,"../../common/views/common_base_view":111}],132:[function(require,module,exports){
var Backbone, EmailFormUSDateTimeInputView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Backbone = require('backbone');

Backbone.$ = $;

EmailFormUSDateTimeInputView = (function(superClass) {
  extend(EmailFormUSDateTimeInputView, superClass);

  function EmailFormUSDateTimeInputView() {
    return EmailFormUSDateTimeInputView.__super__.constructor.apply(this, arguments);
  }

  EmailFormUSDateTimeInputView.prototype.tagName = 'li';

  EmailFormUSDateTimeInputView.prototype.events = {
    'change .date_time_input': 'validateEmailForm',
    'change .time_input_us': 'validateEmailForm'
  };

  EmailFormUSDateTimeInputView.prototype.initialize = function(options) {
    this.options = options || {};
    this.I18nScope = 'modules.support';
    this.isInputFieldEmpty = true;
    this.dateElementSelector = ".date_time_input";
    this.timeElementSelector = ".time_input_us";
    this.template = this.options.template;
    this.model = this.options.model;
    this.label = this.model.label;
    return this.isInputCompulsory = this.model.required === true || this.model.required === "true";
  };

  EmailFormUSDateTimeInputView.prototype.render = function() {
    this.$el.html(toHtml(this.template, this.toHash()));
    this.$el.find(this.dateElementSelector).datetimepicker(this.getDatePickerOptions());
    return this.$el.find(this.timeElementSelector).datetimepicker(this.getTimePickerOptions());
  };

  EmailFormUSDateTimeInputView.prototype.getDatePickerOptions = function() {
    var options;
    return options = {
      format: 'm/d/Y',
      timepicker: false,
      closeOnDateSelect: true
    };
  };

  EmailFormUSDateTimeInputView.prototype.getTimePickerOptions = function() {
    var options;
    return options = {
      step: 30,
      format: 'g:i A',
      datepicker: false,
      formatTime: 'g:i A'
    };
  };

  EmailFormUSDateTimeInputView.prototype.toHash = function() {
    return {
      date_time_input_template: true,
      label: this.label,
      required: this.isInputCompulsory
    };
  };

  EmailFormUSDateTimeInputView.prototype.getDateInputHtmlElement = function() {
    return this.$el.find(this.dateElementSelector);
  };

  EmailFormUSDateTimeInputView.prototype.getTimeInputHtmlElement = function() {
    return this.$el.find(this.timeElementSelector);
  };

  EmailFormUSDateTimeInputView.prototype.isInputGiven = function() {
    return this.getDateInputHtmlElement().val().trim().length > 0 && this.getTimeInputHtmlElement().val().trim().length > 0;
  };

  EmailFormUSDateTimeInputView.prototype.readInput = function() {
    var date, time;
    date = this.getDateInputHtmlElement().val().trim();
    time = this.getTimeInputHtmlElement().val().trim();
    return date + " " + time;
  };

  EmailFormUSDateTimeInputView.prototype.isInputValid = function() {
    return true;
  };

  EmailFormUSDateTimeInputView.prototype.validateEmailForm = function() {
    if (this.isInputCompulsory && ((this.isInputFieldEmpty && this.isInputGiven()) || !(this.isInputFieldEmpty || this.isInputGiven()))) {
      this.isInputFieldEmpty = !this.isInputGiven();
      return this.options.validateEmailForm();
    }
  };

  EmailFormUSDateTimeInputView.prototype.populateInput = function(data) {
    var inputData;
    if (this.isInputGiven()) {
      inputData = this.readInput();
      return data.description += "\n\n " + this.label + " : " + inputData;
    }
  };

  return EmailFormUSDateTimeInputView;

})(Backbone.View);

module.exports = EmailFormUSDateTimeInputView;



},{"backbone":245}],133:[function(require,module,exports){
var Backbone, EmailFormUSEmailDescriptionView, GrouponValidate, SupportEmailDescriptionTemplate,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

GrouponValidate = require("../../../../../groupon/frontend/validate");

SupportEmailDescriptionTemplate = require('../../../../email_description.html.mustache');

Backbone = require('backbone');

Backbone.$ = $;

EmailFormUSEmailDescriptionView = (function(superClass) {
  extend(EmailFormUSEmailDescriptionView, superClass);

  function EmailFormUSEmailDescriptionView() {
    return EmailFormUSEmailDescriptionView.__super__.constructor.apply(this, arguments);
  }

  EmailFormUSEmailDescriptionView.prototype.events = {
    'customEvent .description': 'validateEmailForm',
    'keyup .description': 'validateEmailForm'
  };

  EmailFormUSEmailDescriptionView.prototype.initialize = function(options) {
    this.options = options || {};
    this.I18nScope = 'modules.support';
    this.isInputFieldEmpty = true;
    this.elementID = ".description";
    this.template = SupportEmailDescriptionTemplate;
    this.model = this.options.model;
    this.label = I18n.t("js.modules.support.whatson");
    return this.isInputCompulsory = this.model.required;
  };

  EmailFormUSEmailDescriptionView.prototype.render = function() {
    return this.$el.html(toHtml(this.template, this.toHash()));
  };

  EmailFormUSEmailDescriptionView.prototype.toHash = function() {
    var flexibleStepThree, ref, ref1;
    flexibleStepThree = Groupon.Support.ContentModel.flexibleStepThree;
    return {
      placeholderText: flexibleStepThree != null ? (ref = flexibleStepThree.attributes) != null ? (ref1 = ref.description) != null ? ref1.placeHolder : void 0 : void 0 : void 0
    };
  };

  EmailFormUSEmailDescriptionView.prototype.isInputGiven = function() {
    return this.$el.find(this.elementID).val().trim().length > 0;
  };

  EmailFormUSEmailDescriptionView.prototype.readInput = function() {
    return this.$el.find(this.elementID).val().trim();
  };

  EmailFormUSEmailDescriptionView.prototype.isInputValid = function() {
    return this.validateDescription();
  };

  EmailFormUSEmailDescriptionView.prototype.validateEmailForm = function() {
    if (this.isInputCompulsory && ((this.isInputFieldEmpty && this.isInputGiven()) || !(this.isInputFieldEmpty || this.isInputGiven()))) {
      this.isInputFieldEmpty = !this.isInputGiven();
      return this.options.validateEmailForm();
    }
  };

  EmailFormUSEmailDescriptionView.prototype.populateInput = function(data) {
    var inputData;
    if (this.isInputGiven()) {
      inputData = this.readInput();
      return data.description += "\n\n " + this.label + " : " + inputData;
    }
  };

  EmailFormUSEmailDescriptionView.prototype.creditElement = function() {
    return this.$el.find('.credit_card_warning');
  };

  EmailFormUSEmailDescriptionView.prototype.validateDescription = function() {
    var isCreditInformation;
    isCreditInformation = GrouponValidate.creditCard(this.readInput());
    if (isCreditInformation) {
      this.creditElement().css('display', 'block');
    } else {
      this.creditElement().css('display', 'none');
    }
    return !isCreditInformation;
  };

  return EmailFormUSEmailDescriptionView;

})(Backbone.View);

module.exports = EmailFormUSEmailDescriptionView;



},{"../../../../../groupon/frontend/validate":11,"../../../../email_description.html.mustache":37,"backbone":245}],134:[function(require,module,exports){
var Backbone, EmailFormUSLocationElementView, SupportLocationElementTemplate,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportLocationElementTemplate = require('../../../../location_element_view.html.mustache');

Backbone = require('backbone');

Backbone.$ = $;

EmailFormUSLocationElementView = (function(superClass) {
  extend(EmailFormUSLocationElementView, superClass);

  function EmailFormUSLocationElementView() {
    return EmailFormUSLocationElementView.__super__.constructor.apply(this, arguments);
  }

  EmailFormUSLocationElementView.prototype.initialize = function(options) {
    this.options = options || {};
    this.I18nScope = 'modules.support';
    this.template = SupportLocationElementTemplate;
    return _.bindAll.apply(_, [this].concat(_.functions(this)));
  };

  EmailFormUSLocationElementView.prototype.events = {
    'change .add': 'onChangeSelection'
  };

  EmailFormUSLocationElementView.prototype.render = function() {
    return this.$el.html(toHtml(this.template, this.toHash(), this.I18nScope));
  };

  EmailFormUSLocationElementView.prototype.toHash = function() {
    var locObj;
    locObj = this.options.location;
    if (locObj.isSelected) {
      locObj.checked = "checked";
    } else {
      locObj.checked = "";
    }
    locObj.address = locObj.streetAddress1 + "," + locObj.city + "," + locObj.state + "," + locObj.postalCode;
    return locObj;
  };

  EmailFormUSLocationElementView.prototype.onChangeSelection = function() {
    this.options.location.isSelected = !this.options.location.isSelected;
    return this.options.cb.call();
  };

  return EmailFormUSLocationElementView;

})(Backbone.View);

module.exports = EmailFormUSLocationElementView;



},{"../../../../location_element_view.html.mustache":217,"backbone":245}],135:[function(require,module,exports){
var Backbone, EmailFormUSLocationListElementView, SupportLocationListElementTemplate,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportLocationListElementTemplate = require('../../../../location_list_element_view.html.mustache');

Backbone = require('backbone');

Backbone.$ = $;

EmailFormUSLocationListElementView = (function(superClass) {
  extend(EmailFormUSLocationListElementView, superClass);

  function EmailFormUSLocationListElementView() {
    return EmailFormUSLocationListElementView.__super__.constructor.apply(this, arguments);
  }

  EmailFormUSLocationListElementView.prototype.tagName = 'td';

  EmailFormUSLocationListElementView.prototype.initialize = function(options) {
    this.options = options || {};
    this.I18nScope = 'modules.support';
    this.template = SupportLocationListElementTemplate;
    return _.bindAll.apply(_, [this].concat(_.functions(this)));
  };

  EmailFormUSLocationListElementView.prototype.events = {
    'change .add': 'onChangeSelection'
  };

  EmailFormUSLocationListElementView.prototype.render = function() {
    return this.$el.html(toHtml(this.template, this.toHash(), this.I18nScope));
  };

  EmailFormUSLocationListElementView.prototype.toHash = function() {
    var locObj;
    locObj = this.options.location;
    locObj.isMarked = locObj.isSelected;
    if (locObj.isSelected) {
      locObj.checked = "checked";
    } else {
      locObj.checked = "";
    }
    locObj.firstLine = locObj.streetAddress1 + "," + locObj.city;
    locObj.secondLine = locObj.state + "," + locObj.postalCode;
    return locObj;
  };

  EmailFormUSLocationListElementView.prototype.onChangeSelection = function() {
    return this.options.location.isMarked = !this.options.location.isMarked;
  };

  return EmailFormUSLocationListElementView;

})(Backbone.View);

module.exports = EmailFormUSLocationListElementView;



},{"../../../../location_list_element_view.html.mustache":218,"backbone":245}],136:[function(require,module,exports){
var Backbone, EmailFormUSLocationListElementView, EmailFormUSLocationListRowView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

EmailFormUSLocationListElementView = require("./location_list_element_view");

Backbone = require('backbone');

Backbone.$ = $;

EmailFormUSLocationListRowView = (function(superClass) {
  extend(EmailFormUSLocationListRowView, superClass);

  function EmailFormUSLocationListRowView() {
    return EmailFormUSLocationListRowView.__super__.constructor.apply(this, arguments);
  }

  EmailFormUSLocationListRowView.prototype.tagName = 'tr';

  EmailFormUSLocationListRowView.prototype.initialize = function(options) {
    this.options = options || {};
    this.I18nScope = 'modules.support';
    return _.bindAll.apply(_, [this].concat(_.functions(this)));
  };

  EmailFormUSLocationListRowView.prototype.render = function() {
    var element, elements, i, len, locationView, results;
    elements = this.options.elements;
    results = [];
    for (i = 0, len = elements.length; i < len; i++) {
      element = elements[i];
      locationView = new EmailFormUSLocationListElementView({
        location: element
      });
      this.$el.append(locationView.el);
      results.push(locationView.render());
    }
    return results;
  };

  return EmailFormUSLocationListRowView;

})(Backbone.View);

module.exports = EmailFormUSLocationListRowView;



},{"./location_list_element_view":135,"backbone":245}],137:[function(require,module,exports){
var Backbone, EmailFormUSLocationListRowView, EmailFormUSLocationListView, EmailFormUSLocationSelectPaginationView, SupportLocationListTemplate,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportLocationListTemplate = require('../../../../location_list_view.html.mustache');

EmailFormUSLocationListRowView = require('./location_list_row_view');

EmailFormUSLocationSelectPaginationView = require("./location_select_pagination");

Backbone = require('backbone');

Backbone.$ = $;

EmailFormUSLocationListView = (function(superClass) {
  extend(EmailFormUSLocationListView, superClass);

  function EmailFormUSLocationListView() {
    return EmailFormUSLocationListView.__super__.constructor.apply(this, arguments);
  }

  EmailFormUSLocationListView.prototype.id = 'popupContent';

  EmailFormUSLocationListView.prototype.initialize = function(options) {
    this.options = options || {};
    _.bindAll.apply(_, [this].concat(_.functions(this)));
    this.I18nScope = 'modules.support';
    this.template = SupportLocationListTemplate;
    this.locations = Groupon.Support.currentOrder.dealOption.redemptionLocations;
    this.noOfItemsPerPage = 15;
    this.startIndex = 0;
    this.render();
    this.renderLocations();
    this.paginationView = new EmailFormUSLocationSelectPaginationView({
      paginationElement: $(this.el).find('div#locationPagination'),
      itemsPerPage: this.noOfItemsPerPage,
      totalNoOfItems: this.locations.length,
      callback: this.paginationClickHandler
    });
    this.renderPagination();
    this.popup = $("#popup");
    GIG.Modal.open({
      el: this.popup,
      closeOnBgClick: true,
      closeOnEscKey: true
    });
    return this.popup.html(this.el);
  };

  EmailFormUSLocationListView.prototype.render = function() {
    return this.renderHeaderAndFooter();
  };

  EmailFormUSLocationListView.prototype.renderPagination = function() {
    return this.paginationView.render();
  };

  EmailFormUSLocationListView.prototype.renderHeaderAndFooter = function() {
    return this.$el.html(toHtml(this.template, {}, this.I18nScope));
  };

  EmailFormUSLocationListView.prototype.renderLocations = function() {
    var elementsPushedIntoRow, endIndex, i, index, locationsTable, obj, ref, ref1, results, row, rowElements, startIndex;
    locationsTable = $(this.el).find('table#locationsTable');
    locationsTable.empty();
    startIndex = this.startIndex * this.noOfItemsPerPage;
    endIndex = startIndex + this.noOfItemsPerPage - 1;
    if (endIndex > (this.locations.length - 1)) {
      endIndex = this.locations.length - 1;
    }
    rowElements = [];
    elementsPushedIntoRow = 0;
    results = [];
    for (index = i = ref = startIndex, ref1 = endIndex; i <= ref1; index = i += 1) {
      obj = this.locations[index];
      obj.id = index;
      rowElements[elementsPushedIntoRow] = obj;
      elementsPushedIntoRow += 1;
      if (elementsPushedIntoRow === 3 || index === endIndex) {
        row = new EmailFormUSLocationListRowView({
          elements: rowElements
        });
        locationsTable.append(row.el);
        row.render();
        elementsPushedIntoRow = 0;
        results.push(rowElements = []);
      } else {
        results.push(void 0);
      }
    }
    return results;
  };

  EmailFormUSLocationListView.prototype.paginationClickHandler = function(newPageIndex, paginationContainer) {
    this.startIndex = newPageIndex;
    this.renderLocations();
    return false;
  };

  EmailFormUSLocationListView.prototype.finishChoosingLocations = function() {
    var i, len, location, ref;
    GIG.Modal.close();
    ref = Groupon.Support.currentOrder.dealOption.redemptionLocations;
    for (i = 0, len = ref.length; i < len; i++) {
      location = ref[i];
      location.isSelected = location.isMarked;
    }
    this.options.cb.call();
    return false;
  };

  EmailFormUSLocationListView.prototype.cancelChoosingLocations = function() {
    GIG.Modal.close();
    return false;
  };

  EmailFormUSLocationListView.prototype.events = {
    "click #btnsubmit": "finishChoosingLocations",
    "click #cancelLocationSelect": "cancelChoosingLocations",
    'click .close-modal': "cancelChoosingLocations"
  };

  return EmailFormUSLocationListView;

})(Backbone.View);

module.exports = EmailFormUSLocationListView;



},{"../../../../location_list_view.html.mustache":219,"./location_list_row_view":136,"./location_select_pagination":138,"backbone":245}],138:[function(require,module,exports){
var Backbone, EmailFormUSLocationSelectPaginationView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Backbone = require('backbone');

Backbone.$ = $;

EmailFormUSLocationSelectPaginationView = (function(superClass) {
  extend(EmailFormUSLocationSelectPaginationView, superClass);

  function EmailFormUSLocationSelectPaginationView() {
    return EmailFormUSLocationSelectPaginationView.__super__.constructor.apply(this, arguments);
  }

  EmailFormUSLocationSelectPaginationView.prototype.initialize = function(options) {
    this.options = options || {};
    _.bindAll.apply(_, [this].concat(_.functions(this)));
    this.I18nScope = 'modules.support';
    this.element = this.options.paginationElement;
    this.itemsPerPage = this.options.itemsPerPage;
    this.totalNoOfItems = this.options.totalNoOfItems;
    return this.paginationClickHandler = this.options.callback;
  };

  EmailFormUSLocationSelectPaginationView.prototype.render = function() {
    return this.element.pagination(this.totalNoOfItems, {
      items_per_page: this.itemsPerPage,
      callback: this.paginationClickHandler,
      prev_text: I18n.t('js.modules.support.prev_text'),
      next_text: I18n.t('js.modules.support.next_text')
    });
  };

  EmailFormUSLocationSelectPaginationView.prototype.reRender = function() {
    this.element.empty();
    return this.render();
  };

  return EmailFormUSLocationSelectPaginationView;

})(Backbone.View);

module.exports = EmailFormUSLocationSelectPaginationView;



},{"backbone":245}],139:[function(require,module,exports){
var EmailFormBaseView, EmailFormPhoneNumberInputView, EmailFormTextLineInputView, EmailFormUSEmailDescriptionView, EmailFormUSMainView, EmailFormUSMerchantLocationInfoView, EmailFormUSUserContactInfoView, EmailFormUSUserIdentificationView, EmailFormUsDateTimeInputView, SharedWidgetLayoutView, SupportStepThreeTemplate, SupportUSFlexibleEmailFormObjectsTemplate,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

EmailFormBaseView = require("../base_view");

EmailFormUsDateTimeInputView = require("./date_time_input");

EmailFormTextLineInputView = require("../../common/views/text_line_input_view");

EmailFormUSUserContactInfoView = require("./user_contact_info_view");

EmailFormPhoneNumberInputView = require("../../common/views/phone_number_input");

EmailFormUSMerchantLocationInfoView = require("./merchant_location_info_view");

EmailFormUSUserIdentificationView = require("./user_identification_view");

EmailFormUSEmailDescriptionView = require("./email_description_view");

SharedWidgetLayoutView = require("../../../../../shared/frontend/views/widget_layout_veiw");

SupportStepThreeTemplate = require('../../../../step_three.html.mustache');

SupportUSFlexibleEmailFormObjectsTemplate = require('../../../../us_flexible_email_form_objects.html.mustache');

EmailFormUSMainView = (function(superClass) {
  extend(EmailFormUSMainView, superClass);

  function EmailFormUSMainView() {
    return EmailFormUSMainView.__super__.constructor.apply(this, arguments);
  }

  EmailFormUSMainView.prototype.events = {
    'click .submit-button': 'onSubmitClick'
  };

  EmailFormUSMainView.prototype.initialize = function(options) {
    _.bindAll.apply(_, [this].concat(_.functions(this)));
    EmailFormBaseView.prototype.initialize.apply(this, arguments);
    this.template = SupportStepThreeTemplate;
    this.model = options.emailFormModel;
    return this.inputObjects = this.model.getEmailFormInputObjects();
  };

  EmailFormUSMainView.prototype.render = function() {
    SharedWidgetLayoutView.hideWidgets();
    this.renderEmailForm();
    return this;
  };

  EmailFormUSMainView.prototype.contactByEmail = function() {
    return this.renderEmailForm();
  };

  EmailFormUSMainView.prototype.renderEmailForm = function() {
    this.hideComponents();
    this.$el.html(toHtml(this.template, this.toHash(), this.I18nScope));
    this.renderInputViews(this.inputObjects, "#componentList");
    this.renderStepActions();
    this.validateEmailForm();
    return this;
  };

  EmailFormUSMainView.prototype.getViewByObjectType = function(obj) {
    var options;
    options = {
      model: obj,
      validateEmailForm: this.validateEmailForm,
      template: SupportUSFlexibleEmailFormObjectsTemplate
    };
    switch (obj.type) {
      case 'user_identification':
        return new EmailFormUSUserIdentificationView(options);
      case 'merchant_location':
        options.model = _.extend(obj, {
          numberOfRedemptionLocations: this.model.numberOfRedemptionLocationsAvailable()
        });
        return new EmailFormUSMerchantLocationInfoView(options);
      case 'user_contact_info':
        return new EmailFormUSUserContactInfoView(options);
      case 'description':
        return new EmailFormUSEmailDescriptionView(options);
      case 'text_field_line':
        return new EmailFormTextLineInputView(options);
      case 'phone_number':
        return new EmailFormPhoneNumberInputView(options);
      case 'date_time':
        return new EmailFormUsDateTimeInputView(options);
      case 'calendar_with_hour_slot':
        return new EmailFormUsDateTimeInputView(options);
    }
  };

  EmailFormUSMainView.prototype.toHash = function() {
    var hash, mode, ref, ref1;
    if (((ref = window.liveChatInfo) != null ? (ref1 = ref.mode) != null ? ref1.step_three : void 0 : void 0) != null) {
      mode = window.liveChatInfo.mode.step_three;
    }
    return hash = {
      reason: this.getIssueReason(),
      is_order: Groupon.Support.currentOrder != null,
      show_reason: !this.model.isDummyCategory,
      merchant_name: getDealMerchantName(),
      faqInsteadHelpWizard: window.faqInsteadHelpWizard,
      show_all_fields_required: !this.model.isFTRDropdownCombinationSlected()
    };
  };

  EmailFormUSMainView.prototype.getFormData = function() {
    var data;
    data = EmailFormBaseView.prototype.getFormData.apply(this, arguments);
    data.flexible_form = window.evaluate(typeof experiments !== "undefined" && experiments !== null ? experiments.flexStepThreeForUS : void 0) ? experiments.flexStepThreeForUS : false;
    data.NLPSearchQuery = Groupon.Support.ContentModel.getSearchInputIssue();
    return data;
  };

  EmailFormUSMainView.prototype.getChatParams = function() {
    var params;
    return params = {
      issue: this.getIssueReason()
    };
  };

  EmailFormUSMainView.prototype.getIssueReason = function() {
    return Groupon.Support.ContentModel.getSearchInputIssue() || this.model.reasonText;
  };

  EmailFormUSMainView.prototype.remove = function() {
    $('.xdsoft_datetimepicker').remove();
    return EmailFormBaseView.prototype.remove.call(this);
  };

  EmailFormUSMainView.prototype.close = function() {};

  EmailFormUSMainView.prototype.isPhonePreferredChannel = function() {
    return false;
  };

  return EmailFormUSMainView;

})(EmailFormBaseView);

module.exports = EmailFormUSMainView;



},{"../../../../../shared/frontend/views/widget_layout_veiw":25,"../../../../step_three.html.mustache":233,"../../../../us_flexible_email_form_objects.html.mustache":239,"../../common/views/phone_number_input":113,"../../common/views/text_line_input_view":115,"../base_view":145,"./date_time_input":132,"./email_description_view":133,"./merchant_location_info_view":140,"./user_contact_info_view":142,"./user_identification_view":143}],140:[function(require,module,exports){
var Backbone, EmailFormUSLocationElementView, EmailFormUSLocationListView, EmailFormUSMerchantLocationInfoView, SupportMerchantLocationInfoTemplate,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportMerchantLocationInfoTemplate = require('../../../../merchant_location_info.html.mustache');

EmailFormUSLocationListView = require("./location_list_view");

EmailFormUSLocationElementView = require("./location_element_view");

Backbone = require('backbone');

Backbone.$ = $;

EmailFormUSMerchantLocationInfoView = (function(superClass) {
  extend(EmailFormUSMerchantLocationInfoView, superClass);

  function EmailFormUSMerchantLocationInfoView() {
    return EmailFormUSMerchantLocationInfoView.__super__.constructor.apply(this, arguments);
  }

  EmailFormUSMerchantLocationInfoView.prototype.tagName = 'li';

  EmailFormUSMerchantLocationInfoView.prototype.className = 'requestedFields';

  EmailFormUSMerchantLocationInfoView.prototype.events = {
    'click #showAllLocations': 'showAllLocations',
    'keyup #businessLocation': 'enableDisableSubmitButton'
  };

  EmailFormUSMerchantLocationInfoView.prototype.initialize = function(options) {
    var i, j, len, location, ref, ref1, ref2, ref3;
    this.options = options || {};
    _.bindAll.apply(_, [this].concat(_.functions(this)));
    this.I18nScope = 'modules.support';
    this.template = SupportMerchantLocationInfoTemplate;
    this.model = this.options.model;
    this.isInputCompulsory = this.model.required;
    if (((ref = Groupon.Support.currentOrder) != null ? (ref1 = ref.dealOption) != null ? (ref2 = ref1.redemptionLocations) != null ? ref2.length : void 0 : void 0 : void 0) > 0) {
      ref3 = Groupon.Support.currentOrder.dealOption.redemptionLocations;
      for (i = j = 0, len = ref3.length; j < len; i = ++j) {
        location = ref3[i];
        location.isSelected = false;
        location.locationId = i;
      }
    }
    this.numberOfRedemptionLocations = this.model.numberOfRedemptionLocations;
    return this.collectFromAvailableLocations = this.numberOfRedemptionLocations > 0;
  };

  EmailFormUSMerchantLocationInfoView.prototype.render = function() {
    this.$el.append(toHtml(this.template, this.toHash(), this.I18nScope));
    return this.onLocationSelectionDone();
  };

  EmailFormUSMerchantLocationInfoView.prototype.toHash = function() {
    return {
      collectFromAvailableLocations: this.collectFromAvailableLocations,
      numOfRedemptionLocations: this.numberOfRedemptionLocations,
      showAll: this.numberOfRedemptionLocations > 3,
      currentUserAndOrderCheck: (typeof currentUser !== "undefined" && currentUser !== null) && (Groupon.Support.currentOrder != null) ? true : false
    };
  };

  EmailFormUSMerchantLocationInfoView.prototype.showAllLocations = function() {
    var locationListView;
    return locationListView = new EmailFormUSLocationListView({
      'cb': this.onLocationSelectionDone
    });
  };

  EmailFormUSMerchantLocationInfoView.prototype.enableDisableSubmitButton = function() {
    return this.options.validateEmailForm.call();
  };

  EmailFormUSMerchantLocationInfoView.prototype.onLocationSelectionDone = function() {
    var j, len, location, locationView, locationsToShowinMainPage, selectedLocations;
    if (this.numberOfRedemptionLocations > 1) {
      locationsToShowinMainPage = [];
      selectedLocations = this.getSelectedLocations();
      if (selectedLocations.length === 0) {
        locationsToShowinMainPage = _.first(Groupon.Support.currentOrder.dealOption.redemptionLocations, 5);
      } else {
        locationsToShowinMainPage = selectedLocations;
      }
      $('#locations', this.$el).empty();
      for (j = 0, len = locationsToShowinMainPage.length; j < len; j++) {
        location = locationsToShowinMainPage[j];
        locationView = new EmailFormUSLocationElementView({
          'location': location,
          'cb': this.enableDisableSubmitButton
        });
        locationView.render();
        $('#locations', this.$el).append(locationView.el);
      }
      return this.enableDisableSubmitButton();
    }
  };

  EmailFormUSMerchantLocationInfoView.prototype.getSelectedLocations = function() {
    return _.filter(Groupon.Support.currentOrder.dealOption.redemptionLocations, function(location) {
      return location.isSelected === true;
    });
  };

  EmailFormUSMerchantLocationInfoView.prototype.getBusinessLocationElement = function() {
    return this.$el.find('#businessLocation');
  };

  EmailFormUSMerchantLocationInfoView.prototype.populateInput = function(data) {
    var ref, ref1;
    data.businessLocation = (ref = this.getBusinessLocationElement()) != null ? (ref1 = ref.val()) != null ? ref1.trim() : void 0 : void 0;
    return data.merchantInfoView = true;
  };

  EmailFormUSMerchantLocationInfoView.prototype.isInputGiven = function() {
    var ref, ref1;
    if (this.numberOfRedemptionLocations > 0) {
      return this.numberOfRedemptionLocations === 1 || this.getSelectedLocations().length > 0;
    } else {
      return ((ref = this.getBusinessLocationElement()) != null ? (ref1 = ref.val()) != null ? ref1.trim().length : void 0 : void 0) > 0;
    }
  };

  EmailFormUSMerchantLocationInfoView.prototype.isInputValid = function() {
    return true;
  };

  return EmailFormUSMerchantLocationInfoView;

})(Backbone.View);

module.exports = EmailFormUSMerchantLocationInfoView;



},{"../../../../merchant_location_info.html.mustache":220,"./location_element_view":134,"./location_list_view":137,"backbone":245}],141:[function(require,module,exports){
var CallBackOptionSuccessView, CallBackPhoneNumberModel, CommonBaseInputsView, EmailFormEmailInputView, EmailFormPhoneNumberInputView, EmailFormUserNameInputView, HoldTimeModel, PhoneNumberCallBackView, SharedSpinnerView, SupportCallMeBackPhoneNumberObjectsTemplate, SupportPhoneNumberWithCallBackTemplate, SupportUtils,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportUtils = require("../../../helpers/utils");

CommonBaseInputsView = require("../../common/views/common_base_inputs_view");

CallBackPhoneNumberModel = require("../../../models/call_back_phone_number_model");

HoldTimeModel = require("../../../models/hold_time_model");

SharedSpinnerView = require("../../../../../shared/frontend/views/spinner_view");

CallBackOptionSuccessView = require("./call_me_back_success_view");

EmailFormPhoneNumberInputView = require("../../common/views/phone_number_input");

EmailFormEmailInputView = require("../../common/views/phone_number_input");

EmailFormUserNameInputView = require("../INTL/user_name_input_view");

SupportPhoneNumberWithCallBackTemplate = require('../../../../phone_number_with_call_back.html.mustache');

SupportCallMeBackPhoneNumberObjectsTemplate = require('../../../../call_me_back_phone_number_objects.html.mustache');

PhoneNumberCallBackView = (function(superClass) {
  extend(PhoneNumberCallBackView, superClass);

  function PhoneNumberCallBackView() {
    this.renderHoldTimePostError = bind(this.renderHoldTimePostError, this);
    this.renderHoldTimePostSuccess = bind(this.renderHoldTimePostSuccess, this);
    this.callMeBackFlagCb = bind(this.callMeBackFlagCb, this);
    return PhoneNumberCallBackView.__super__.constructor.apply(this, arguments);
  }

  PhoneNumberCallBackView.prototype.initialize = function() {
    CommonBaseInputsView.prototype.initialize.apply(this, arguments);
    this.template = SupportPhoneNumberWithCallBackTemplate;
    this.mainView = this.options.mainView;
    this.model = new CallBackPhoneNumberModel();
    this.holdTimeModel = new HoldTimeModel({
      mainView: this
    });
    this.popupContainer = $('#popup');
    this.spinnerView = new SharedSpinnerView();
    this.inputObjects = this.model.getDefaultPhoneForm().objects;
    return this.callBackSuccessView = new CallBackOptionSuccessView();
  };

  PhoneNumberCallBackView.prototype.render = function() {
    GIG.Modal.open({
      el: this.popupContainer,
      closeOnBgClick: true,
      closeOnEscKey: true
    });
    this.$el.append(toHtml(this.template, this.toHash(), this.I18nScope));
    this.popupContainer.html(this.el);
    this.showLoadingSpinner();
    return this.holdTimeModel.getCallMeBackFlag();
  };

  PhoneNumberCallBackView.prototype.getViewByObjectType = function(obj) {
    var options;
    options = {
      model: obj,
      validateEmailForm: this.validateEmailForm,
      template: SupportCallMeBackPhoneNumberObjectsTemplate
    };
    switch (obj.type) {
      case 'phone_number':
        return new EmailFormPhoneNumberInputView(options);
      case 'email_address':
        return new EmailFormEmailInputView(options);
      case 'user_name':
        return new EmailFormUserNameInputView(options);
    }
  };

  PhoneNumberCallBackView.prototype.callMeBackFlagCb = function(response) {
    this.hideLoadingSpinner();
    if (evaluate(response != null ? response.showCallMeOption : void 0)) {
      window.showDOMElems([$('.call-me-back-option'), $('#call-back-content-container')]);
      return this.renderInputViews(this.inputObjects, "#call-me-back-inputs");
    } else {
      return this.renderNormalPhoneNumberView();
    }
  };

  PhoneNumberCallBackView.prototype.renderNormalPhoneNumberView = function() {
    this.closeModal();
    return this.mainView.renderNormalPhoneNumberView();
  };

  PhoneNumberCallBackView.prototype.onSubmitClick = function() {
    return CommonBaseInputsView.prototype.onSubmitClick.apply(this, arguments);
  };

  PhoneNumberCallBackView.prototype.submitForm = function(data) {
    window.hideDOMElems($('.call-me-back-option'));
    this.showLoadingSpinner();
    return this.holdTimeModel.postToHoldTime(data);
  };

  PhoneNumberCallBackView.prototype.enableSubmit = function() {
    $('.call-back-submit-button', this.$el).removeClass('opacity-half');
    return CommonBaseInputsView.prototype.enableSubmit.apply(this, arguments);
  };

  PhoneNumberCallBackView.prototype.disableSubmit = function() {
    $('.call-back-submit-button', this.$el).addClass('opacity-half');
    return CommonBaseInputsView.prototype.disableSubmit.apply(this, arguments);
  };

  PhoneNumberCallBackView.prototype.renderHoldTimePostSuccess = function(response) {
    this.holdTimeModel.set({
      'estWaitTime': response.est_wait_time
    });
    this.hideLoadingSpinner();
    this.closeModal();
    window.hideDOMElems([$('.help-wizard-content form'), $('.step-three #results'), $('.step-actions'), $('.contact-channels-v2-header')]);
    this.removeCallBackStepThree();
    propagateEventBeforeReplacingElements((function(_this) {
      return function() {
        _this.callBackSuccessView.render({
          waitTime: _this.holdTimeModel.get("estWaitTime")
        });
        return $('#help-wizard').append(_this.callBackSuccessView.el);
      };
    })(this));
    return window.hideFooterLinks();
  };

  PhoneNumberCallBackView.prototype.removeCallBackStepThree = function() {
    var ref;
    return (ref = $('#help-wizard .horizontal')) != null ? ref.remove() : void 0;
  };

  PhoneNumberCallBackView.prototype.renderHoldTimePostError = function() {
    this.hideLoadingSpinner();
    window.hideDOMElems($('.call-me-back-option'));
    return propagateEventBeforeReplacingElements((function(_this) {
      return function() {
        _this.$el.find('#call-back-spinner').empty();
        return window.showDOMElems($('.no-call-me-back-option'));
      };
    })(this));
  };

  PhoneNumberCallBackView.prototype.hideLoadingSpinner = function() {
    this.$el.find('#call-back-spinner').empty();
    return window.hideDOMElems(this.$el.find('#call-back-spinner'));
  };

  PhoneNumberCallBackView.prototype.showLoadingSpinner = function() {
    window.showDOMElems($('#call-back-spinner'));
    return SupportUtils.showLoading($('#call-back-spinner'), '150px');
  };

  PhoneNumberCallBackView.prototype.closeModal = function() {
    GIG.Modal.close();
    return false;
  };

  PhoneNumberCallBackView.prototype.events = {
    'click .close-modal': "closeModal",
    'click .b-close': "closeModal",
    'click .submit-button': 'onSubmitClick'
  };

  return PhoneNumberCallBackView;

})(CommonBaseInputsView);

module.exports = PhoneNumberCallBackView;



},{"../../../../../shared/frontend/views/spinner_view":24,"../../../../call_me_back_phone_number_objects.html.mustache":33,"../../../../phone_number_with_call_back.html.mustache":227,"../../../helpers/utils":54,"../../../models/call_back_phone_number_model":58,"../../../models/hold_time_model":64,"../../common/views/common_base_inputs_view":110,"../../common/views/phone_number_input":113,"../INTL/user_name_input_view":128,"./call_me_back_success_view":131}],142:[function(require,module,exports){
var Backbone, EmailFormUSUserContactInfoView, GrouponValidate, SupportUserContactInfoTemplate,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

GrouponValidate = require("../../../../../groupon/frontend/validate");

Backbone = require('backbone');

Backbone.$ = $;

SupportUserContactInfoTemplate = require('../../../../user_contact_info.html.mustache');

EmailFormUSUserContactInfoView = (function(superClass) {
  extend(EmailFormUSUserContactInfoView, superClass);

  function EmailFormUSUserContactInfoView() {
    return EmailFormUSUserContactInfoView.__super__.constructor.apply(this, arguments);
  }

  EmailFormUSUserContactInfoView.prototype.tagName = 'li';

  EmailFormUSUserContactInfoView.prototype.className = 'requestedFields';

  EmailFormUSUserContactInfoView.prototype.initialize = function(options) {
    this.options = options || {};
    _.bindAll.apply(_, [this].concat(_.functions(this)));
    this.I18nScope = 'modules.support';
    this.model = this.options.model;
    this.isInputCompulsory = this.model.required;
    return this.template = SupportUserContactInfoTemplate;
  };

  EmailFormUSUserContactInfoView.prototype.events = {
    'change #contactOnlyByMail': 'onContactOnlyByMail',
    'keyup #contact_phone': 'enableDisableSubmitButton',
    'keyup #contact_email': 'enableDisableSubmitButton'
  };

  EmailFormUSUserContactInfoView.prototype.render = function() {
    this.$el.append(toHtml(this.template, {}, this.I18nScope));
    return this.changeDescriptionText();
  };

  EmailFormUSUserContactInfoView.prototype.enableDisableSubmitButton = function() {
    return this.options.validateEmailForm.call();
  };

  EmailFormUSUserContactInfoView.prototype.changeDescriptionText = function() {
    return $('#ticket_description').text(I18n.translate('js.modules.support.additional_details_example'));
  };

  EmailFormUSUserContactInfoView.prototype.contactOnlyByMail = function() {
    return $('#contactOnlyByMail').is(':checked');
  };

  EmailFormUSUserContactInfoView.prototype.onContactOnlyByMail = function() {
    $('#validateContactPhone').css('display', 'none');
    if (this.contactOnlyByMail()) {
      this.getUserPhoneElement().attr('disabled', 'disabled');
      this.getUserPhoneElement().val("");
      this.getUserEmailElement().css('display', 'block');
      if (typeof currentUser !== "undefined" && currentUser !== null) {
        this.getUserEmailElement().val(typeof currentUser !== "undefined" && currentUser !== null ? currentUser.email : void 0);
      } else {
        this.getUserEmailElement().val($('#tcktUsermail').val());
      }
      $(".stepThreeLabel #contactOnlyByPhonenumberMandatory").css('display', 'none');
      $("#contactOnlyByMailMandatory").css('display', 'inline');
      $(".inputField#contact_phone").val('');
    } else {
      this.getUserPhoneElement().removeAttr('disabled');
      this.getUserEmailElement().css('display', 'none');
      $('#validateContactEmail').css('display', 'none');
      $("#contactOnlyByMailMandatory").css('display', 'none');
      $(".stepThreeLabel #contactOnlyByPhonenumberMandatory").css('display', 'inline');
      $(".inputField#contact_email").val('');
    }
    return this.options.validateEmailForm.call();
  };

  EmailFormUSUserContactInfoView.prototype.validateContactEmail = function() {
    var email_id, ref, ref1;
    email_id = (ref = this.getUserEmailElement()) != null ? (ref1 = ref.val()) != null ? ref1.trim() : void 0 : void 0;
    if (GrouponValidate.email(email_id)) {
      $('#validateContactEmail').css('display', 'none');
      return true;
    } else {
      $('#validateContactEmail').css('display', 'block');
      return false;
    }
  };

  EmailFormUSUserContactInfoView.prototype.validateContactPhone = function() {
    var phoneNum, ref, ref1;
    phoneNum = (ref = this.getUserPhoneElement()) != null ? (ref1 = ref.val()) != null ? ref1.trim() : void 0 : void 0;
    if (GrouponValidate.phone(phoneNum)) {
      $('#validateContactPhone').css('display', 'none');
      return true;
    } else {
      $('#validateContactPhone').css('display', 'block');
      return false;
    }
  };

  EmailFormUSUserContactInfoView.prototype.populateInput = function(data) {
    var ref, ref1, ref2, ref3;
    data.user_given_email = (ref = this.getUserEmailElement()) != null ? (ref1 = ref.val()) != null ? ref1.trim() : void 0 : void 0;
    data.user_given_phone = (ref2 = this.getUserPhoneElement()) != null ? (ref3 = ref2.val()) != null ? ref3.trim() : void 0 : void 0;
    data.contact_only_email = this.contactOnlyByMail();
    return data.userContactInfoView = true;
  };

  EmailFormUSUserContactInfoView.prototype.isInputValid = function() {
    if (this.contactOnlyByMail()) {
      return this.validateContactEmail();
    } else {
      return this.validateContactPhone();
    }
  };

  EmailFormUSUserContactInfoView.prototype.getUserPhoneElement = function() {
    return this.$el.find('#contact_phone');
  };

  EmailFormUSUserContactInfoView.prototype.getUserEmailElement = function() {
    return this.$el.find('#contact_email');
  };

  EmailFormUSUserContactInfoView.prototype.isInputGiven = function() {
    var ref, ref1, ref2, ref3;
    if (this.contactOnlyByMail()) {
      return ((ref = this.getUserEmailElement()) != null ? (ref1 = ref.val()) != null ? ref1.trim().length : void 0 : void 0) > 0;
    } else {
      return ((ref2 = this.getUserPhoneElement()) != null ? (ref3 = ref2.val()) != null ? ref3.trim().length : void 0 : void 0) > 0;
    }
  };

  return EmailFormUSUserContactInfoView;

})(Backbone.View);

module.exports = EmailFormUSUserContactInfoView;



},{"../../../../../groupon/frontend/validate":11,"../../../../user_contact_info.html.mustache":240,"backbone":245}],143:[function(require,module,exports){
var Backbone, EmailFormUSUserIdentificationView, GrouponValidate, SupportUserIdentificationTemplate,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

GrouponValidate = require("../../../../../groupon/frontend/validate");

Backbone = require('backbone');

Backbone.$ = $;

SupportUserIdentificationTemplate = require('../../../../user_identification.html.mustache');

EmailFormUSUserIdentificationView = (function(superClass) {
  extend(EmailFormUSUserIdentificationView, superClass);

  function EmailFormUSUserIdentificationView() {
    return EmailFormUSUserIdentificationView.__super__.constructor.apply(this, arguments);
  }

  EmailFormUSUserIdentificationView.prototype.className = 'requestedFields';

  EmailFormUSUserIdentificationView.prototype.tagName = 'li';

  EmailFormUSUserIdentificationView.prototype.events = {
    'keyup #tcktUsername': 'checkUserId',
    'keyup #tcktUsermail': 'checkMailId'
  };

  EmailFormUSUserIdentificationView.prototype.initialize = function(options) {
    this.options = options || {};
    _.bindAll.apply(_, [this].concat(_.functions(this)));
    this.I18nScope = 'modules.support';
    this.model = this.options.model;
    this.isInputCompulsory = this.model.required;
    return this.template = SupportUserIdentificationTemplate;
  };

  EmailFormUSUserIdentificationView.prototype.getUsernameElement = function() {
    return this.$el.find('#tcktUsername');
  };

  EmailFormUSUserIdentificationView.prototype.getEmailIdElement = function() {
    return this.$el.find('#tcktUsermail');
  };

  EmailFormUSUserIdentificationView.prototype.checkUserId = function() {
    return this.enableDisableSubmitButton();
  };

  EmailFormUSUserIdentificationView.prototype.checkMailId = function() {
    var email_id;
    this.enableDisableSubmitButton();
    email_id = this.getEmailIdElement().val().trim();
    if (GrouponValidate.email(email_id)) {
      return $('#validateUserContactEmail').css('display', 'none');
    }
  };

  EmailFormUSUserIdentificationView.prototype.enableDisableSubmitButton = function() {
    return this.options.validateEmailForm.call();
  };

  EmailFormUSUserIdentificationView.prototype.render = function() {
    return this.$el.append(toHtml(this.template, this.toHash(), this.I18nScope));
  };

  EmailFormUSUserIdentificationView.prototype.toHash = function() {
    return {
      isLoggedIn: typeof currentUser !== "undefined" && currentUser !== null,
      is_email: (typeof currentUser !== "undefined" && currentUser !== null ? currentUser.email : void 0) != null
    };
  };

  EmailFormUSUserIdentificationView.prototype.populateInput = function(data) {
    var ref, ref1, ref2, ref3;
    data.user_name = (ref = this.getUsernameElement()) != null ? (ref1 = ref.val()) != null ? ref1.trim() : void 0 : void 0;
    data.user_email = (ref2 = this.getEmailIdElement()) != null ? (ref3 = ref2.val()) != null ? ref3.trim() : void 0 : void 0;
    return data.userIdenficiationView = true;
  };

  EmailFormUSUserIdentificationView.prototype.validateEmailId = function() {
    var email_id, ref, ref1;
    email_id = (ref = this.getEmailIdElement()) != null ? (ref1 = ref.val()) != null ? ref1.trim() : void 0 : void 0;
    if (GrouponValidate.email(email_id)) {
      $('#validateUserContactEmail').css('display', 'none');
      return true;
    } else {
      $('#validateUserContactEmail').css('display', 'block');
      return false;
    }
  };

  EmailFormUSUserIdentificationView.prototype.isInputValid = function() {
    return this.validateEmailId();
  };

  EmailFormUSUserIdentificationView.prototype.isInputGiven = function() {
    var isvalid, ref, ref1, ref2, ref3, ref4, ref5;
    isvalid = true;
    if (((ref = this.getUsernameElement()) != null ? ref.length : void 0) > 0) {
      isvalid = ((ref1 = this.getUsernameElement()) != null ? (ref2 = ref1.val()) != null ? ref2.trim().length : void 0 : void 0) > 0;
    }
    if (isvalid && ((ref3 = this.getEmailIdElement()) != null ? ref3.length : void 0) > 0) {
      isvalid = isvalid && ((ref4 = this.getEmailIdElement()) != null ? (ref5 = ref4.val()) != null ? ref5.trim().length : void 0 : void 0) > 0;
    }
    return isvalid;
  };

  EmailFormUSUserIdentificationView.prototype.close = function() {};

  return EmailFormUSUserIdentificationView;

})(Backbone.View);

module.exports = EmailFormUSUserIdentificationView;



},{"../../../../../groupon/frontend/validate":11,"../../../../user_identification.html.mustache":241,"backbone":245}],144:[function(require,module,exports){
var EmailFormUSV2FlexibleContactChannelsView, EmailFormV2FlexibleContactChannelsView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

EmailFormV2FlexibleContactChannelsView = require("../common/v2_flexible_contact_channels");

EmailFormUSV2FlexibleContactChannelsView = (function(superClass) {
  extend(EmailFormUSV2FlexibleContactChannelsView, superClass);

  function EmailFormUSV2FlexibleContactChannelsView() {
    return EmailFormUSV2FlexibleContactChannelsView.__super__.constructor.apply(this, arguments);
  }

  EmailFormUSV2FlexibleContactChannelsView.prototype.arrangeLayoutOfIcons = function(hash, $container) {
    var contact_channel, i, len, orderedContactChannelElements, primaryContactElem, ref, ref1, ref2, ref3, secondaryContactElem, tertiaryContactElem;
    orderedContactChannelElements = [];
    if (hash.contact_channels != null) {
      ref = hash.contact_channels;
      for (i = 0, len = ref.length; i < len; i++) {
        contact_channel = ref[i];
        if ((ref1 = contact_channel.primary) != null ? ref1.channel : void 0) {
          primaryContactElem = this.addAttributesToPrimaryIcon(contact_channel.primary, $container);
          orderedContactChannelElements.push(primaryContactElem);
        }
        if ((ref2 = contact_channel.secondary) != null ? ref2.channel : void 0) {
          secondaryContactElem = this.addBloodHoundTagToIcon(contact_channel.secondary.channel, $container, "secondary");
          orderedContactChannelElements.push(secondaryContactElem);
        }
        if ((ref3 = contact_channel.tertiary) != null ? ref3.channel : void 0) {
          tertiaryContactElem = this.addBloodHoundTagToIcon(contact_channel.tertiary.channel, $container, "tertiary");
          orderedContactChannelElements.push(tertiaryContactElem);
        }
      }
      this.renderIcons(orderedContactChannelElements, $container);
    }
    return $container;
  };

  EmailFormUSV2FlexibleContactChannelsView.prototype.setOrderInfo = function() {
    var order, ref, ref1;
    order = Groupon.Support.currentOrder;
    if (order) {
      return ((ref = order.deal) != null ? ref.title : void 0) || ((ref1 = order.merchant) != null ? ref1.name : void 0);
    }
  };

  EmailFormUSV2FlexibleContactChannelsView.prototype.setIssueInfo = function() {
    var ref;
    return Groupon.Support.ContentModel.getSearchInputIssue() || ((ref = Groupon.Support.ContentModel.getSubCategory()) != null ? ref.text : void 0);
  };

  EmailFormUSV2FlexibleContactChannelsView.prototype.renderLiveChat = function() {
    if (this.model.get('liveChatExists')) {
      this.mainView.renderLiveChat({
        liveChatMode: 'static',
        liveChatType: Groupon.Support.LiveChatModel.getFlexibleLiveChatType()
      });
      if (this.model.get("primaryChannelIsBoldChat")) {
        return this.mainView.renderLiveChat({
          liveChatMode: 'static',
          liveChatType: Groupon.Support.LiveChatModel.getLinkLiveChatType(),
          startFromSameViewState: true
        });
      }
    }
  };

  return EmailFormUSV2FlexibleContactChannelsView;

})(EmailFormV2FlexibleContactChannelsView);

module.exports = EmailFormUSV2FlexibleContactChannelsView;



},{"../common/v2_flexible_contact_channels":150}],145:[function(require,module,exports){
var CommonBaseInputsView, EmailFormBaseView, SharedAjaxError, StepActionsView, SupportStepThreeActionsTemplate, SupportUtils,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

StepActionsView = require("../step_actions_view");

CommonBaseInputsView = require("../common/views/common_base_inputs_view");

SupportUtils = require("../../helpers/utils");

SharedAjaxError = require("../../../../shared/frontend/views/ajax_error_view");

SupportStepThreeActionsTemplate = require('../../../step_three_actions.html.mustache');

EmailFormBaseView = (function(superClass) {
  extend(EmailFormBaseView, superClass);

  function EmailFormBaseView() {
    return EmailFormBaseView.__super__.constructor.apply(this, arguments);
  }

  EmailFormBaseView.prototype.className = 'email-form';

  EmailFormBaseView.prototype.initialize = function() {
    CommonBaseInputsView.prototype.initialize.apply(this, arguments);
    return this.I18nScope = 'modules.support';
  };

  EmailFormBaseView.prototype.renderStepActions = function() {
    var stepActionsView;
    stepActionsView = new StepActionsView({
      template: SupportStepThreeActionsTemplate
    });
    stepActionsView.render();
    return this.$el.append(stepActionsView.el);
  };

  EmailFormBaseView.prototype.hideComponents = function() {
    return SupportUtils.hideFloatingBoldChat();
  };

  EmailFormBaseView.prototype.renderSuccess = function(response) {
    return window.location.href = "#ticket-success";
  };

  EmailFormBaseView.prototype.renderError = function() {
    var errorView;
    errorView = new SharedAjaxError();
    return errorView.render({
      container: $('#help-wizard')
    });
  };

  EmailFormBaseView.prototype.submitForm = function(data) {
    return createTicket(data, this.renderSuccess, this.renderError, $('.help-wizard'));
  };

  return EmailFormBaseView;

})(CommonBaseInputsView);

module.exports = EmailFormBaseView;



},{"../../../../shared/frontend/views/ajax_error_view":19,"../../../step_three_actions.html.mustache":234,"../../helpers/utils":54,"../common/views/common_base_inputs_view":110,"../step_actions_view":194}],146:[function(require,module,exports){
var Backbone, EmailFormCallClickView, SupportContactChannelClickTemplate,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportContactChannelClickTemplate = require('../../../../contact_channel_click.html.mustache');

Backbone = require('backbone');

Backbone.$ = $;

EmailFormCallClickView = (function(superClass) {
  extend(EmailFormCallClickView, superClass);

  function EmailFormCallClickView() {
    return EmailFormCallClickView.__super__.constructor.apply(this, arguments);
  }

  EmailFormCallClickView.prototype.className = 'contact-channel-click-container';

  EmailFormCallClickView.prototype.events = {
    'click #returnHome': "returnHome"
  };

  EmailFormCallClickView.prototype.initialize = function(options) {
    this.options = options || {};
    this.I18nScope = 'modules.support';
    this.template = SupportContactChannelClickTemplate;
    this.contactChannelTextView = this.options.contactChannelTextView;
    return this.phoneNumberView = this.options.phoneNumberView;
  };

  EmailFormCallClickView.prototype.render = function() {
    this.$el.html(toHtml(this.template, this.toHash(), this.I18nScope));
    this.phoneNumberView.render();
    this.$el.find(".phone-number-container").html(this.phoneNumberView.el);
    this.contactChannelTextView.render();
    this.contactChannelTextView.$el.removeClass();
    return this.$el.find(".contact-channel-container").html(this.contactChannelTextView.el);
  };

  EmailFormCallClickView.prototype.toHash = function() {
    var hash;
    hash = {
      isCallClicked: true
    };
    return hash;
  };

  EmailFormCallClickView.prototype.returnHome = function() {
    return window.location.href = "/";
  };

  EmailFormCallClickView.prototype.postRenderhandler = function() {
    return this.contactChannelTextView.renderLiveChat();
  };

  return EmailFormCallClickView;

})(Backbone.View);

module.exports = EmailFormCallClickView;



},{"../../../../contact_channel_click.html.mustache":35,"backbone":245}],147:[function(require,module,exports){
var Backbone, EmailFormLiveChatClickView, HelpWizardController, SupportContactChannelClickTemplate,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportContactChannelClickTemplate = require('../../../../contact_channel_click.html.mustache');

HelpWizardController = require("../../../helpWizardController");

Backbone = require('backbone');

Backbone.$ = $;

EmailFormLiveChatClickView = (function(superClass) {
  extend(EmailFormLiveChatClickView, superClass);

  function EmailFormLiveChatClickView() {
    return EmailFormLiveChatClickView.__super__.constructor.apply(this, arguments);
  }

  EmailFormLiveChatClickView.prototype.className = 'contact-channel-click-container';

  EmailFormLiveChatClickView.prototype.events = {
    'click #ChatSuccess': "chatsuccess",
    'click #otherContactChannel': "chooseDifferentContactChannel"
  };

  EmailFormLiveChatClickView.prototype.initialize = function() {
    this.I18nScope = 'modules.support';
    return this.template = SupportContactChannelClickTemplate;
  };

  EmailFormLiveChatClickView.prototype.render = function() {
    return this.$el.html(toHtml(this.template, this.toHash(), this.I18nScope));
  };

  EmailFormLiveChatClickView.prototype.toHash = function() {
    var hash;
    hash = {
      isChatClicked: true
    };
    return hash;
  };

  EmailFormLiveChatClickView.prototype.chatsuccess = function() {
    return Backbone.history.navigate('#chat-success', {
      trigger: true
    });
  };

  EmailFormLiveChatClickView.prototype.chooseDifferentContactChannel = function() {
    return HelpWizardController.stepThree();
  };

  return EmailFormLiveChatClickView;

})(Backbone.View);

module.exports = EmailFormLiveChatClickView;



},{"../../../../contact_channel_click.html.mustache":35,"../../../helpWizardController":50,"backbone":245}],148:[function(require,module,exports){
var Backbone, EmailFormOptimizedContactChannelView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Backbone = require('backbone');

Backbone.$ = $;

EmailFormOptimizedContactChannelView = (function(superClass) {
  extend(EmailFormOptimizedContactChannelView, superClass);

  function EmailFormOptimizedContactChannelView() {
    return EmailFormOptimizedContactChannelView.__super__.constructor.apply(this, arguments);
  }

  EmailFormOptimizedContactChannelView.prototype.className = 'optimized-contact-channels-view';

  EmailFormOptimizedContactChannelView.prototype.events = {
    'click .optimized-email-us': 'optimizedContactByEmail',
    'DOMSubtreeModified .live-chat-container.optimized-contact-channel': 'handleDisplayOfOptimizedChannels',
    "click .optimized-phone-btn": "renderPhoneNumberView",
    'click .live-chat-container.optimized-contact-channel': 'chatClicked'
  };

  EmailFormOptimizedContactChannelView.prototype.initialize = function(options) {
    this.options = options || {};
    _.bindAll.apply(_, [this].concat(_.functions(this)));
    this.I18nScope = 'modules.support';
    this.model = Groupon.Support.OptimizedContactChannelsModel;
    this.mainView = this.options.mainView;
    return this.emailFormModel = this.options.emailFormModel;
  };

  EmailFormOptimizedContactChannelView.prototype.render = function() {
    this.$el.append(toHtml(this.model.template, this.toHash(), this.I18nScope));
    return this;
  };

  EmailFormOptimizedContactChannelView.prototype.toHash = function() {
    return $.extend({
      isLiveChatEnabled: this.isLiveChatEnabled(),
      isPhonePreferredChannel: this.mainView.isPhonePreferredChannel()
    }, this.model.toHash());
  };

  EmailFormOptimizedContactChannelView.prototype.isLiveChatEnabled = function() {
    return Groupon.Support.LiveChatModel.isLiveChatEnabled();
  };

  EmailFormOptimizedContactChannelView.prototype.optimizedContactByEmail = function(event) {
    this.model.hidePreferencedContactChannel();
    this.model.showPreferencedContactChannel("email");
    return this.mainView.renderEmailForm();
  };

  EmailFormOptimizedContactChannelView.prototype.handleDisplayOfOptimizedChannels = function() {
    var emailUsParagraphElems, liveChatContainerElem, phoneParagraphElems;
    liveChatContainerElem = this.model.optimizedLiveChatContainer();
    emailUsParagraphElems = this.model.emailRecommendationTextElement();
    phoneParagraphElems = this.model.phoneRecommendationTextElement();
    this.model.hidePreferencedContactChannel();
    this.model.setOptimizedLiveChatDisplayCallBack(this.handleDisplayOfOptimizedChannels);
    if (this.model.optimizedLiveChatVisible()) {
      showDOMElems(liveChatContainerElem);
      hideDOMElems([emailUsParagraphElems, phoneParagraphElems]);
      return this.model.showPreferencedContactChannel("chat");
    } else {
      hideDOMElems(liveChatContainerElem);
      if (this.emailFormModel.isMethodOfContactByPhone() || this.emailFormModel.isMethodOfContactByPhoneWithEmail()) {
        this.model.showPreferencedContactChannel("phone");
        hideDOMElems(emailUsParagraphElems);
        return showDOMElems(phoneParagraphElems);
      } else {
        this.model.showPreferencedContactChannel("email");
        hideDOMElems(phoneParagraphElems);
        return showDOMElems(emailUsParagraphElems);
      }
    }
  };

  EmailFormOptimizedContactChannelView.prototype.handleDisplayOfContactChannels = function() {
    return this.handleDisplayOfOptimizedChannels();
  };

  EmailFormOptimizedContactChannelView.prototype.renderPhoneNumberView = function() {
    this.model.hidePreferencedContactChannel();
    this.model.showPreferencedContactChannel("phone");
    return this.mainView.renderPhoneNumberView();
  };

  EmailFormOptimizedContactChannelView.prototype.chatClicked = function() {
    this.model.hidePreferencedContactChannel();
    this.model.showPreferencedContactChannel("chat");
    return true;
  };

  EmailFormOptimizedContactChannelView.prototype.renderLiveChat = function() {
    return this.mainView.renderLiveChat({
      liveChatMode: 'static',
      liveChatType: Groupon.Support.LiveChatModel.getOptimizedLiveChatType()
    });
  };

  return EmailFormOptimizedContactChannelView;

})(Backbone.View);

module.exports = EmailFormOptimizedContactChannelView;



},{"backbone":245}],149:[function(require,module,exports){
var Backbone, EmailFormV2FlexibleContactChannelsTextView, SupportV2FlexibleContactChannelsTemplate,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportV2FlexibleContactChannelsTemplate = require('../../../../v2_flexible_contact_channels.html.mustache');

Backbone = require('backbone');

Backbone.$ = $;

EmailFormV2FlexibleContactChannelsTextView = (function(superClass) {
  extend(EmailFormV2FlexibleContactChannelsTextView, superClass);

  function EmailFormV2FlexibleContactChannelsTextView() {
    return EmailFormV2FlexibleContactChannelsTextView.__super__.constructor.apply(this, arguments);
  }

  EmailFormV2FlexibleContactChannelsTextView.prototype.className = 'flexible-contact-channels-text-view';

  EmailFormV2FlexibleContactChannelsTextView.prototype.events = {
    'DOMSubtreeModified .primary-chat-link#live-chat-link-container': 'handleDisplayOfPrimaryLiveChatLink',
    'DOMSubtreeModified .secondary-chat-link#live-chat-link-container': 'handleDisplayOfSecondaryLiveChatLink',
    'DOMSubtreeModified .tertiary-chat-link#live-chat-link-container': 'handleDisplayOfTertiaryLiveChatLink',
    'click .flex-email-link': 'renderEmailForm',
    'click .flex-phone-link': 'renderPhoneView',
    'click .flex-chat-link': 'renderChatClickView'
  };

  EmailFormV2FlexibleContactChannelsTextView.prototype.initialize = function(options) {
    this.options = options || {};
    _.bindAll.apply(_, [this].concat(_.functions(this)));
    this.I18nScope = 'modules.support';
    this.template = SupportV2FlexibleContactChannelsTemplate;
    this.model = Groupon.Support.FlexibleContactChannelModel;
    return this.mainView = this.options.mainView;
  };

  EmailFormV2FlexibleContactChannelsTextView.prototype.render = function() {
    var options;
    this.model.presentContactChannels();
    this.$el.empty();
    options = {
      withoutChat: !this.isLiveChatEnabled(),
      renderLayout: true
    };
    this.$el.html(this.arrangeLayoutView(this.toHash(options)));
    return this;
  };

  EmailFormV2FlexibleContactChannelsTextView.prototype.isLiveChatEnabled = function() {
    return Groupon.Support.LiveChatModel.isLiveChatEnabled();
  };

  EmailFormV2FlexibleContactChannelsTextView.prototype.renderEmailForm = function(e) {
    return this.mainView.renderEmailForm();
  };

  EmailFormV2FlexibleContactChannelsTextView.prototype.renderPhoneView = function() {
    return this.mainView.renderPhoneNumberView();
  };

  EmailFormV2FlexibleContactChannelsTextView.prototype.renderChatClickView = function() {
    return this.mainView.renderChatClickView();
  };

  EmailFormV2FlexibleContactChannelsTextView.prototype.handleDisplayOfPrimaryLiveChatLink = function() {
    var primaryChatTextElem;
    primaryChatTextElem = $(".flex-chat-channel-text");
    this.toggleDomElemsBasedOnLiveChat(primaryChatTextElem);
    this.$el.find('.flex-contact-channels-without-chat').empty();
    if (window.liveChatLinkVisible()) {
      window.showDOMElems($('.help-wizard-content > .flexible-contact-channels-container'));
      return window.hideDOMElems($('.flex-contact-channels-without-chat'));
    } else {
      window.hideDOMElems($('.help-wizard-content > .flexible-contact-channels-container'));
      window.showDOMElems($('.flex-contact-channels-without-chat'));
      return $('.flex-contact-channels-without-chat').html(this.arrangeLayoutView(this.toHash({
        withoutChat: true
      })));
    }
  };

  EmailFormV2FlexibleContactChannelsTextView.prototype.handleDisplayOfSecondaryLiveChatLink = function() {
    var DOMelemsToToggle, flexTertiaryOrTextElem, secondaryFlexibleLiveChatContainerElem;
    secondaryFlexibleLiveChatContainerElem = $('.secondary-flex-chat-channel');
    flexTertiaryOrTextElem = $('.flex-channel-or-text');
    DOMelemsToToggle = [secondaryFlexibleLiveChatContainerElem, flexTertiaryOrTextElem];
    if (this.model.get('formattedContactChannels').contact_channels.length === 2) {
      DOMelemsToToggle.push($('.flex-secondary-channel-also-text'));
    }
    return this.toggleDomElemsBasedOnLiveChat(DOMelemsToToggle);
  };

  EmailFormV2FlexibleContactChannelsTextView.prototype.handleDisplayOfTertiaryLiveChatLink = function() {
    var flexTertiaryOrTextElem, tertiaryFlexibleLiveChatContainerElem;
    tertiaryFlexibleLiveChatContainerElem = $('.tertiary-flex-chat-channel');
    flexTertiaryOrTextElem = $('.flex-channel-or-text');
    return this.toggleDomElemsBasedOnLiveChat([tertiaryFlexibleLiveChatContainerElem, flexTertiaryOrTextElem]);
  };

  EmailFormV2FlexibleContactChannelsTextView.prototype.toggleDomElemsBasedOnLiveChat = function(domElems) {
    if (window.liveChatLinkVisible()) {
      return window.showDOMElemsInline(domElems);
    } else {
      window.removeDOMElemsInline(domElems);
      return window.hideDOMElems(domElems);
    }
  };

  EmailFormV2FlexibleContactChannelsTextView.prototype.toHash = function(arg) {
    var additionalInfo, contactChannelhash, hash, renderLayout, withoutChat;
    withoutChat = arg.withoutChat, renderLayout = arg.renderLayout;
    contactChannelhash = {};
    if (withoutChat) {
      contactChannelhash = this.model.get('contactChannelsWithoutBoldChat');
    } else if (this.model.has('formattedContactChannels')) {
      contactChannelhash = this.model.get('formattedContactChannels');
    } else {
      contactChannelhash = this.model.get('contactChannelsWithoutBoldChat');
    }
    additionalInfo = {
      isVertical: true
    };
    if (renderLayout) {
      additionalInfo.renderLayout = true;
    }
    hash = $.extend(true, additionalInfo, contactChannelhash);
    return hash;
  };

  EmailFormV2FlexibleContactChannelsTextView.prototype.arrangeLayoutView = function(hash) {
    var $html, html;
    html = toHtml(this.template, hash, this.I18nScope);
    $html = $(html);
    $html.find('.flexible-contact-channel-icon-container').hide();
    $html.find('.recommended').hide();
    return $html;
  };

  EmailFormV2FlexibleContactChannelsTextView.prototype.renderLiveChat = function() {
    if (this.model.get('liveChatExists')) {
      if (this.model.get("primaryChannelIsBoldChat")) {
        this.mainView.renderLiveChat({
          liveChatMode: 'static',
          liveChatType: Groupon.Support.LiveChatModel.getFlexibleV2LiveChatType()
        });
      }
      return this.mainView.renderLiveChat({
        liveChatMode: 'static',
        liveChatType: Groupon.Support.LiveChatModel.getLinkLiveChatType(),
        startFromSameViewState: this.model.get("primaryChannelIsBoldChat")
      });
    }
  };

  return EmailFormV2FlexibleContactChannelsTextView;

})(Backbone.View);

module.exports = EmailFormV2FlexibleContactChannelsTextView;



},{"../../../../v2_flexible_contact_channels.html.mustache":243,"backbone":245}],150:[function(require,module,exports){
var Backbone, EmailFormV2FlexibleContactChannelsView, SupportV2FlexibleContactChannelsTemplate,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportV2FlexibleContactChannelsTemplate = require('../../../../v2_flexible_contact_channels.html.mustache');

Backbone = require('backbone');

Backbone.$ = $;

EmailFormV2FlexibleContactChannelsView = (function(superClass) {
  extend(EmailFormV2FlexibleContactChannelsView, superClass);

  function EmailFormV2FlexibleContactChannelsView() {
    return EmailFormV2FlexibleContactChannelsView.__super__.constructor.apply(this, arguments);
  }

  EmailFormV2FlexibleContactChannelsView.prototype.className = 'flexible-contact-channels-view-v2';

  EmailFormV2FlexibleContactChannelsView.prototype.events = {
    'DOMSubtreeModified .flexible-contact-channels-container  #live-chat-container': 'handleDisplayOfLiveChatIcon',
    'DOMSubtreeModified .primary-chat-link#live-chat-link-container': 'handleDisplayOfPrimaryLiveChatLink',
    'DOMSubtreeModified .secondary-chat-link#live-chat-link-container': 'handleDisplayOfSecondaryLiveChatLink',
    'DOMSubtreeModified .tertiary-chat-link#live-chat-link-container': 'handleDisplayOfTertiaryLiveChatLink',
    'click .flexible-email-container': 'renderEmailForm',
    'click .flexible-phone-container': 'renderPhoneView',
    'click .flex-email-link': 'renderEmailForm',
    'click .flex-phone-link': 'renderPhoneView',
    'click .flex-chat-link': 'renderChatClickView',
    'click .primary-chat-link#live-chat-link-container': 'renderChatClickView',
    'click .flexible-contact-channels-container  #live-chat-container': 'renderChatClickView'
  };

  EmailFormV2FlexibleContactChannelsView.prototype.initialize = function(options) {
    this.options = options || {};
    _.bindAll.apply(_, [this].concat(_.functions(this)));
    this.I18nScope = 'modules.support';
    this.template = SupportV2FlexibleContactChannelsTemplate;
    this.model = Groupon.Support.FlexibleContactChannelModel;
    return this.mainView = this.options.mainView;
  };

  EmailFormV2FlexibleContactChannelsView.prototype.render = function() {
    var options;
    this.model.presentContactChannels();
    this.$el.empty();
    options = {
      renderLayout: true,
      withoutChat: !this.isLiveChatEnabled()
    };
    this.$el.append(this.arrangeLayoutView(this.toHash(options)));
    return this;
  };

  EmailFormV2FlexibleContactChannelsView.prototype.isLiveChatEnabled = function() {
    return Groupon.Support.LiveChatModel.isLiveChatEnabled();
  };

  EmailFormV2FlexibleContactChannelsView.prototype.renderEmailForm = function(e) {
    return this.mainView.renderEmailForm();
  };

  EmailFormV2FlexibleContactChannelsView.prototype.renderPhoneView = function() {
    return this.mainView.renderPhoneNumberView();
  };

  EmailFormV2FlexibleContactChannelsView.prototype.renderChatClickView = function() {
    return this.mainView.renderChatClickView();
  };

  EmailFormV2FlexibleContactChannelsView.prototype.handleDisplayOfLiveChatIcon = function() {
    this.$el.find('.flex-contact-channels-without-chat').empty();
    this.setFlexibleLiveChatDisplayCallBack(this.handleDisplayOfLiveChatIcon);
    if (this.isLiveChatIconVisible()) {
      window.showDOMElems($('.help-wizard-content > .flexible-contact-channels-container'));
      return window.hideDOMElems($('.flex-contact-channels-without-chat'));
    } else {
      window.hideDOMElems($('.help-wizard-content > .flexible-contact-channels-container'));
      window.showDOMElems($('.flex-contact-channels-without-chat'));
      return $('.flex-contact-channels-without-chat').html(this.arrangeLayoutView(this.toHash({
        withoutChat: true
      })));
    }
  };

  EmailFormV2FlexibleContactChannelsView.prototype.handleDisplayOfPrimaryLiveChatLink = function() {
    var primaryChatTextElem;
    primaryChatTextElem = $(".flex-chat-channel-text");
    return this.toggleDomElemsBasedOnLiveChat(primaryChatTextElem);
  };

  EmailFormV2FlexibleContactChannelsView.prototype.handleDisplayOfSecondaryLiveChatLink = function() {
    var DOMelemsToToggle, flexTertiaryOrTextElem, secondaryFlexibleLiveChatContainerElem;
    secondaryFlexibleLiveChatContainerElem = $('.secondary-flex-chat-channel');
    flexTertiaryOrTextElem = $('.flex-channel-or-text');
    DOMelemsToToggle = [secondaryFlexibleLiveChatContainerElem, flexTertiaryOrTextElem];
    if (this.model.get('formattedContactChannels').contact_channels.length === 2) {
      DOMelemsToToggle.push($('.flex-secondary-channel-also-text'));
    }
    return this.toggleDomElemsBasedOnLiveChat(DOMelemsToToggle);
  };

  EmailFormV2FlexibleContactChannelsView.prototype.handleDisplayOfTertiaryLiveChatLink = function() {
    var flexTertiaryOrTextElem, tertiaryFlexibleLiveChatContainerElem;
    tertiaryFlexibleLiveChatContainerElem = $('.tertiary-flex-chat-channel');
    flexTertiaryOrTextElem = $('.flex-channel-or-text');
    return this.toggleDomElemsBasedOnLiveChat([tertiaryFlexibleLiveChatContainerElem, flexTertiaryOrTextElem]);
  };

  EmailFormV2FlexibleContactChannelsView.prototype.toggleDomElemsBasedOnLiveChat = function(domElems) {
    if (window.liveChatLinkVisible()) {
      return window.showDOMElemsInline(domElems);
    } else {
      window.removeDOMElemsInline(domElems);
      return window.hideDOMElems(domElems);
    }
  };

  EmailFormV2FlexibleContactChannelsView.prototype.setFlexibleLiveChatDisplayCallBack = function(liveChatDisplayCallback) {
    return window.setLiveChatDisplayCallBack($('a img', this.liveChatIconContainer()), liveChatDisplayCallback);
  };

  EmailFormV2FlexibleContactChannelsView.prototype.isLiveChatIconVisible = function() {
    return window.liveChatVisible($('a img', this.liveChatIconContainer()));
  };

  EmailFormV2FlexibleContactChannelsView.prototype.handleDisplayOfContactChannels = function() {
    if (this.liveChatIconContainer().length > 0) {
      return this.handleDisplayOfLiveChatIcon();
    }
  };

  EmailFormV2FlexibleContactChannelsView.prototype.liveChatIconContainer = function() {
    return $('.flexible-contact-channels-container #live-chat-container');
  };

  EmailFormV2FlexibleContactChannelsView.prototype.toHash = function(arg) {
    var additionalInfo, contactChannelhash, hash, renderLayout, withoutChat;
    withoutChat = arg.withoutChat, renderLayout = arg.renderLayout;
    contactChannelhash = {};
    if (withoutChat) {
      contactChannelhash = this.model.get('contactChannelsWithoutBoldChat');
    } else if (this.model.has('formattedContactChannels')) {
      contactChannelhash = this.model.get('formattedContactChannels');
    } else {
      contactChannelhash = this.model.get('contactChannelsWithoutBoldChat');
    }
    additionalInfo = {
      orderMsg: this.setOrderInfo(),
      issueMsg: this.setIssueInfo()
    };
    if (renderLayout) {
      additionalInfo.renderLayout = true;
    }
    hash = $.extend(true, additionalInfo, contactChannelhash);
    return hash;
  };

  EmailFormV2FlexibleContactChannelsView.prototype.setOrderInfo = function() {
    var order, ref, ref1, title;
    order = Groupon.Support.currentOrder;
    if (order) {
      title = ((ref = order.deal) != null ? ref.title : void 0) || ((ref1 = order.merchant) != null ? ref1.name : void 0);
      if (title) {
        return I18n.translate('js.modules.support.issue_about_this_order', {
          dealTitle: title
        });
      }
    }
  };

  EmailFormV2FlexibleContactChannelsView.prototype.setIssueInfo = function() {
    var issue, ref;
    issue = Groupon.Support.ContentModel.getSearchInputIssue() || ((ref = Groupon.Support.ContentModel.getSubCategory()) != null ? ref.text : void 0);
    if (issue) {
      return I18n.translate('js.modules.support.saw_you_have_issue', {
        issue: issue
      });
    }
  };

  EmailFormV2FlexibleContactChannelsView.prototype.arrangeLayoutView = function(hash) {
    var $container, $html, html;
    html = toHtml(this.template, hash, this.I18nScope);
    $html = $(html);
    $container = this.arrangeLayoutOfIcons(hash, $html);
    return $container;
  };

  EmailFormV2FlexibleContactChannelsView.prototype.addBloodHoundTagToIcon = function(channel, $container, type) {
    var contactElem;
    contactElem = this.getContactChannelIcon(channel, $container);
    addBloodHoundTagToDOMElems(contactElem, type + "-" + channel + "-icon");
    return contactElem;
  };

  EmailFormV2FlexibleContactChannelsView.prototype.addAttributesToPrimaryIcon = function(primaryContactChannel, $container) {
    var primaryContactElem;
    primaryContactElem = this.addBloodHoundTagToIcon(primaryContactChannel.channel, $container, "primary");
    addPreferredContactClass(primaryContactElem);
    addBtnPrimaryClass(primaryContactElem);
    return primaryContactElem;
  };

  EmailFormV2FlexibleContactChannelsView.prototype.renderIcons = function(orderedContactChannelElements, $container) {
    var contactChannelElement, i, len, results;
    $('.flexible-contact-channel-icon-container', $container).empty();
    results = [];
    for (i = 0, len = orderedContactChannelElements.length; i < len; i++) {
      contactChannelElement = orderedContactChannelElements[i];
      results.push($('.flexible-contact-channel-icon-container', $container).append(contactChannelElement));
    }
    return results;
  };

  EmailFormV2FlexibleContactChannelsView.prototype.arrangeLayoutOfIcons = function(hash, $container) {
    var contact_channel, i, len, orderedContactChannelElements, primaryContactElem, ref, ref1;
    orderedContactChannelElements = [];
    if (hash.contact_channels != null) {
      ref = hash.contact_channels;
      for (i = 0, len = ref.length; i < len; i++) {
        contact_channel = ref[i];
        if ((ref1 = contact_channel.primary) != null ? ref1.channel : void 0) {
          primaryContactElem = this.addAttributesToPrimaryIcon(contact_channel.primary, $container);
          orderedContactChannelElements.push(primaryContactElem);
        }
      }
      this.renderIcons(orderedContactChannelElements, $container);
    }
    return $container;
  };

  EmailFormV2FlexibleContactChannelsView.prototype.getContactChannelIcon = function(type, $container) {
    var contactElem;
    switch (type) {
      case "chat":
        contactElem = this.liveChatIconElem($container);
        break;
      case "email":
        contactElem = this.emailIconElem($container);
        break;
      case "phone":
        contactElem = this.phoneIconElem($container);
    }
    return contactElem;
  };

  EmailFormV2FlexibleContactChannelsView.prototype.emailIconElem = function($container) {
    return $('.flexible-contact-channel-icon-container .flexible-email-container', $container);
  };

  EmailFormV2FlexibleContactChannelsView.prototype.phoneIconElem = function($container) {
    return $('.flexible-contact-channel-icon-container .flexible-phone-container', $container);
  };

  EmailFormV2FlexibleContactChannelsView.prototype.liveChatIconElem = function($container) {
    return $('.flexible-contact-channel-icon-container .flexible-chat-container', $container);
  };

  EmailFormV2FlexibleContactChannelsView.prototype.renderLiveChat = function() {
    if (this.model.get('liveChatExists')) {
      if (this.model.get("primaryChannelIsBoldChat")) {
        this.mainView.renderLiveChat({
          liveChatMode: 'static',
          liveChatType: Groupon.Support.LiveChatModel.getFlexibleV2LiveChatType()
        });
      }
      return this.mainView.renderLiveChat({
        liveChatMode: 'static',
        liveChatType: Groupon.Support.LiveChatModel.getLinkLiveChatType(),
        startFromSameViewState: this.model.get("primaryChannelIsBoldChat")
      });
    }
  };

  return EmailFormV2FlexibleContactChannelsView;

})(Backbone.View);

module.exports = EmailFormV2FlexibleContactChannelsView;



},{"../../../../v2_flexible_contact_channels.html.mustache":243,"backbone":245}],151:[function(require,module,exports){
var SupportEmailSuccessView, SupportTicketSuccessView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportTicketSuccessView = require('./ticket_success_view');

SupportEmailSuccessView = (function(superClass) {
  extend(SupportEmailSuccessView, superClass);

  function SupportEmailSuccessView() {
    return SupportEmailSuccessView.__super__.constructor.apply(this, arguments);
  }

  SupportEmailSuccessView.prototype.toHash = function() {
    var hash;
    hash = SupportTicketSuccessView.prototype.toHash.call(this);
    hash.showDefaultThankYouMsg = false;
    hash.showEmailThankYouMsg = true;
    hash.showNeedHelpLink = true;
    return hash;
  };

  SupportEmailSuccessView.prototype.shouldShowFooter = function() {
    return false;
  };

  SupportEmailSuccessView.prototype.getGreetingText = function() {
    if (this.isRefundEligible()) {
      return I18n.translate('js.modules.support.request_submitted_successfully');
    } else {
      return I18n.translate('js.modules.support.v2.thanks_email');
    }
  };

  return SupportEmailSuccessView;

})(SupportTicketSuccessView);

module.exports = SupportEmailSuccessView;



},{"./ticket_success_view":210}],152:[function(require,module,exports){
var Backbone, SupportFlashTemplate, SupportFlashView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportFlashTemplate = require('../../flash.html.mustache');

Backbone = require('backbone');

Backbone.$ = $;

SupportFlashView = (function(superClass) {
  extend(SupportFlashView, superClass);

  function SupportFlashView() {
    return SupportFlashView.__super__.constructor.apply(this, arguments);
  }

  SupportFlashView.prototype.className = 'flash';

  SupportFlashView.prototype.initialize = function(options) {
    this.options = options || {};
    this.I18nScope = 'modules.support';
    this.template = SupportFlashTemplate;
    this.type = this.options.type;
    if (this.type == null) {
      this.type = 'info';
    }
    this.content = this.options.content;
    if (!this.options.sticky) {
      return delay(20000, (function(_this) {
        return function() {
          return _this.remove();
        };
      })(this));
    }
  };

  SupportFlashView.prototype.render = function() {
    this.$el.addClass(this.type);
    return this.$el.html(toHtml(this.template, this.toHash(), this.template));
  };

  SupportFlashView.prototype.events = function() {
    return {
      'click .close': 'remove'
    };
  };

  SupportFlashView.prototype.toHash = function() {
    return {
      content: this.content
    };
  };

  SupportFlashView.prototype.close = function() {};

  return SupportFlashView;

})(Backbone.View);

module.exports = SupportFlashView;



},{"../../flash.html.mustache":40,"backbone":245}],153:[function(require,module,exports){
var Backbone, SupportHelpWizardController, SupportIntermediateView, SupportIntermediateViewTemplate,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportHelpWizardController = require('../helpWizardController');

Backbone = require('backbone');

Backbone.$ = $;

SupportIntermediateViewTemplate = require('../../intermediate_view.html.mustache');

SupportIntermediateView = (function(superClass) {
  extend(SupportIntermediateView, superClass);

  function SupportIntermediateView() {
    this.redirectingToOrder = bind(this.redirectingToOrder, this);
    return SupportIntermediateView.__super__.constructor.apply(this, arguments);
  }

  SupportIntermediateView.prototype.className = "intermediate_page";

  SupportIntermediateView.prototype.events = {
    'click #about_an_order': 'redirectingToOrder',
    'click .not_about_an_order_link': 'redirectSelectIssue'
  };

  SupportIntermediateView.prototype.initialize = function() {
    this.I18nScope = 'modules.support';
    return this.template = SupportIntermediateViewTemplate;
  };

  SupportIntermediateView.prototype.render = function() {
    window.hideFloatingBoldChat();
    return this.$el.html(toHtml(this.template, {}, this.I18nScope));
  };

  SupportIntermediateView.prototype.redirectingToOrder = function() {
    return this.redirectToLogin();
  };

  SupportIntermediateView.prototype.redirectSelectIssue = function() {
    return SupportHelpWizardController.abruptStepTwoFlow();
  };

  SupportIntermediateView.prototype.redirectToLogin = function() {
    var refUrl;
    if ((window.isTouchUserAgent != null) && window.isTouchUserAgent && isUS()) {
      refUrl = window.touchSupportUrl;
      return window.location.href = "/login?return_to=" + (encodeURIComponent(refUrl));
    } else {
      refUrl = window.SUPPORTBASEURL;
      return window.location.href = "/login?ref=" + (encodeURIComponent(refUrl));
    }
  };

  return SupportIntermediateView;

})(Backbone.View);

module.exports = SupportIntermediateView;



},{"../../intermediate_view.html.mustache":214,"../helpWizardController":50,"backbone":245}],154:[function(require,module,exports){
var Backbone, SupportLiveChatFloatingTemplate, SupportLiveChatTemplate, SupportLiveChatView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Backbone = require('backbone');

Backbone.$ = $;

SupportLiveChatTemplate = require('../../live_chat.html.mustache');

SupportLiveChatFloatingTemplate = require('../../live_chat_floating.html.mustache');

SupportLiveChatView = (function(superClass) {
  extend(SupportLiveChatView, superClass);

  function SupportLiveChatView() {
    return SupportLiveChatView.__super__.constructor.apply(this, arguments);
  }

  SupportLiveChatView.prototype.id = 'live-chat';

  SupportLiveChatView.prototype.initialize = function(options) {
    this.options = options || {};
    _.bindAll.apply(_, [this].concat(_.functions(this)));
    this.model = this.options.model;
    this.setTemplates();
    this.I18nScope = 'modules.support';
    this.liveChatImageInterval = setInterval(function() {
      var bcanchor, bcfloating;
      bcfloating = $(".bcFloat img, .bcStatic img");
      bcanchor = $(".bcFloat a, .bcStatic a");
      if (bcfloating.length) {
        bcfloating.attr("alt", I18n.translate('js.modules.support.chat_us'));
        return bcanchor.removeAttr("href").attr({
          "role": "button",
          "aria-label": I18n.translate('js.modules.support.chat_us'),
          "tabindex": "0"
        });
      }
    }, 3000);
    return this.liveChatTextInterval = setInterval(function() {
      var bcanchor;
      bcanchor = $(".bcText a");
      if (bcanchor.length) {
        return bcanchor.removeAttr("href").attr({
          "role": "button",
          "aria-label": I18n.translate('js.modules.support.chat_us'),
          "tabindex": "0"
        });
      }
    }, 3000);
  };

  SupportLiveChatView.prototype.render = function(params) {
    if (!params.startFromSameViewState) {
      this.$el.empty();
    }
    this.templates = window.getInArrayFormat(this.getTemplatesToRender());
    _.each(this.templates, (function(_this) {
      return function(template) {
        _this.setIntialQuestion(params);
        return _this.$el.append(toHtml(template, _this.model.toJSON(), _this.I18nScope));
      };
    })(this));
    return this;
  };

  SupportLiveChatView.prototype.setIntialQuestion = function(params) {
    return this.model.setIntialQuestion(params);
  };

  SupportLiveChatView.prototype.getTemplatesToRender = function() {
    if (this.model.has(this.model.get('mode'))) {
      return this.model.get(this.model.get('mode'));
    } else {
      return this.model.get('floating');
    }
  };

  SupportLiveChatView.prototype.setLiveChat = function(mode, liveChatType) {
    if (this.shouldRenderLiveChat()) {
      this.model.setLiveChatInfo(liveChatType);
      return this.model.set({
        mode: mode || 'static'
      });
    }
  };

  SupportLiveChatView.prototype.renderView = function(viewElem, params) {
    var liveChatConfig;
    if (params == null) {
      params = {};
    }
    if (this.shouldRenderLiveChat()) {
      liveChatConfig = this.model.get('liveChat');
      if (liveChatConfig && liveChatConfig.accountID) {
        this.render(params);
        return viewElem.append(this.$el);
      }
    }
  };

  SupportLiveChatView.prototype.shouldRenderLiveChat = function() {
    return this.model.isLiveChatEnabled() && this.checkForRefundEligibleConditionsToDisplayLiveChat();
  };

  SupportLiveChatView.prototype.checkForRefundEligibleConditionsToDisplayLiveChat = function() {
    var ref, ref1;
    if (evaluate(Groupon.Support.ContentModel.isRefundEligible)) {
      return ((ref = Groupon.Support.currentOrder) != null ? (ref1 = ref.STATE) != null ? ref1.toUpperCase() : void 0 : void 0) === 'AVAILABLE';
    } else {
      return true;
    }
  };

  SupportLiveChatView.prototype.setTemplates = function() {
    this.model.set({
      'static': SupportLiveChatTemplate
    });
    this.model.set({
      'floating': SupportLiveChatFloatingTemplate
    });
    return this.model.set({
      'both': [this.model.get('static'), this.model.get('floating')]
    });
  };

  return SupportLiveChatView;

})(Backbone.View);

module.exports = SupportLiveChatView;



},{"../../live_chat.html.mustache":215,"../../live_chat_floating.html.mustache":216,"backbone":245}],155:[function(require,module,exports){
var Backbone, SupportMainContentWrapperView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Backbone = require('backbone');

Backbone.$ = $;

SupportMainContentWrapperView = (function(superClass) {
  extend(SupportMainContentWrapperView, superClass);

  function SupportMainContentWrapperView() {
    return SupportMainContentWrapperView.__super__.constructor.apply(this, arguments);
  }

  SupportMainContentWrapperView.prototype.className = 'help-wizard-content';

  SupportMainContentWrapperView.prototype.initialize = function() {};

  SupportMainContentWrapperView.prototype.render = function(renderContents) {
    return renderContents(this.$el);
  };

  return SupportMainContentWrapperView;

})(Backbone.View);

module.exports = SupportMainContentWrapperView;



},{"backbone":245}],156:[function(require,module,exports){
var Backbone, SupportMultipleQtyPopupView, SupportMultipleQuantityPopupTemplate,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Backbone = require('backbone');

Backbone.$ = $;

SupportMultipleQuantityPopupTemplate = require('../../multiple_quantity_popup.html.mustache');

SupportMultipleQtyPopupView = (function(superClass) {
  extend(SupportMultipleQtyPopupView, superClass);

  function SupportMultipleQtyPopupView() {
    return SupportMultipleQtyPopupView.__super__.constructor.apply(this, arguments);
  }

  SupportMultipleQtyPopupView.prototype.initialize = function(options) {
    var BHData, groupon, i, j, len, ref;
    this.options = options || {};
    _.bindAll.apply(_, [this].concat(_.functions(this)));
    this.I18nScope = 'modules.support';
    this.template = SupportMultipleQuantityPopupTemplate;
    this.validate(this.options);
    this.orderWithMultipleQty = {};
    this.orderWithMultipleQty.userPermalink = currentUser.id;
    this.orderWithMultipleQty.vouchers = this.options.orders;
    this.parent = $('#popup');
    this.orderWithMultipleQty.title = this.options.title;
    this.orderWithMultipleQty.singleActionButtonCallback = this.options.singleActionButtonCallback;
    this.orderWithMultipleQty.groupActionButtonCallback = this.options.groupActionButtonCallback;
    this.orderWithMultipleQty.singleActionButtonName = this.options.singleActionButtonName;
    this.orderWithMultipleQty.groupActionButtonName = this.options.groupActionButtonName;
    this.orderWithMultipleQty.showgroupActionButton = this.options.showgroupActionButton;
    this.orderWithMultipleQty[this.options.serviceActionName] = true;
    this.orderWithMultipleQty.showAlertMessage = this.options.showAlertMessage;
    this.orderWithMultipleQty.alertMessage = this.options.alertMessage;
    this.orderWithMultipleQty.vouchers.expiredDate = this.options.orders.groupons[0].expiresAtFormattedStr;
    if (!!this.orderWithMultipleQty.vouchers.expiredDate) {
      this.orderWithMultipleQty.vouchers.validExpirationDate = true;
    } else {
      this.orderWithMultipleQty.vouchers.validExpirationDate = false;
    }
    this.orderWithMultipleQty.vouchers.purchasedDate = this.options.orders.purchasedAtshortDatetimeStr;
    this.orderWithMultipleQty.vouchers.orderId = this.options.orders.id;
    this.avaliableVoucherCount = 0;
    ref = this.orderWithMultipleQty.vouchers.groupons;
    for (i = j = 0, len = ref.length; j < len; i = ++j) {
      groupon = ref[i];
      groupon.index = i + 1;
      groupon.dealOptionTitle = this.options.orders.dealOption.title;
      if (((groupon != null ? groupon.availability : void 0) != null) && groupon.availability === 'refunded') {
        groupon.isRefunded = true;
      } else if (groupon.customerRedeemedAt || groupon.merchantRedeemedAt) {
        groupon.isRedeemed = true;
      } else {
        groupon.showSingleActionButton = true;
        this.avaliableVoucherCount++;
      }
      groupon.dealPermalink = this.options.orders.deal.id;
      groupon.url = this.orderWithMultipleQty.singleActionButtonCallback(groupon);
    }
    BHData = window.getOrderInfoForBH(this.orderWithMultipleQty.vouchers);
    BHData.orderId = BHData.id;
    delete BHData['id'];
    _.extend(this.orderWithMultipleQty, BHData);
    if (window.isUS() && this.avaliableVoucherCount >= this.orderWithMultipleQty.vouchers.groupons.length && this.orderWithMultipleQty.showgroupActionButton) {
      this.orderWithMultipleQty.urlForVouchers = this.orderWithMultipleQty.groupActionButtonCallback(this.orderWithMultipleQty.vouchers.orderId);
    } else {
      this.orderWithMultipleQty.urlForVouchers = false;
    }
    return this.orderWithMultipleQty.showViewOrderDetailsLink = window.showViewOrderDetailsLink;
  };

  SupportMultipleQtyPopupView.prototype.validate = function(options) {
    if (this.options.singleActionButtonName === null) {
      throw new Error("singleActionButtonName Property should be defined");
    }
    if (this.options.singleActionButtonCallback === null) {
      throw new Error("singleActionButtonCallback Property should be defined");
    }
    if (this.options.showgroupActionButton === null) {
      throw new Error("showgroupActionButton Property should be defined");
    }
    if (this.options.showgroupActionButton === true) {
      if (this.options.groupActionButtonName === null) {
        throw new Error("groupActionButtonName Property should be defined");
      }
      if (this.options.groupActionButtonCallback === null) {
        throw new Error("groupActionButtonCallback Property should be defined");
      }
    }
    if (this.options.showAlertMessage === true) {
      if (this.options.alertMessage === null) {
        throw new Error("alertMessage Property should be defined");
      }
    }
  };

  SupportMultipleQtyPopupView.prototype.render = function() {
    this.renderMultipleGroupons();
    GIG.Modal.open({
      el: this.parent,
      closeOnBgClick: true,
      closeOnEscKey: true
    });
    return this.parent.html(this.$el);
  };

  SupportMultipleQtyPopupView.prototype.renderMultipleGroupons = function() {
    return this.$el.html(toHtml(this.template, this.orderWithMultipleQty, this.I18nScope));
  };

  SupportMultipleQtyPopupView.prototype.viewOrderDetails = function(ev) {
    var orderId, url, userPermalink;
    userPermalink = currentUser.id;
    orderId = Groupon.Support.currentOrder.id;
    url = "/users/" + userPermalink + "/orders/" + orderId;
    return window.open(url);
  };

  SupportMultipleQtyPopupView.prototype.closeModal = function() {
    GIG.Modal.close();
    return false;
  };

  SupportMultipleQtyPopupView.prototype.events = {
    "click #viewOrderDtls": "viewOrderDetails",
    "click .close-modal": "closeModal"
  };

  return SupportMultipleQtyPopupView;

})(Backbone.View);

module.exports = SupportMultipleQtyPopupView;



},{"../../multiple_quantity_popup.html.mustache":221,"backbone":245}],157:[function(require,module,exports){
var Backbone, SupportCurrentOrderView, SupportDealSummaryView, SupportExternalDealNotesView, SupportOrderActionsView, SupportOrderSummaryView, SupportServiceActionMainView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportDealSummaryView = require('./deal_summary_view');

SupportOrderSummaryView = require('./order_summary_view');

SupportOrderActionsView = require('./order_actions_view');

SupportServiceActionMainView = require('./service_action_main_view');

SupportExternalDealNotesView = require('./external_deal_notes');

Backbone = require('backbone');

Backbone.$ = $;

SupportCurrentOrderView = (function(superClass) {
  extend(SupportCurrentOrderView, superClass);

  function SupportCurrentOrderView() {
    return SupportCurrentOrderView.__super__.constructor.apply(this, arguments);
  }

  SupportCurrentOrderView.prototype.className = 'row order-details';

  SupportCurrentOrderView.prototype.initialize = function(options) {
    this.I18nScope = 'modules.support';
    this.currentOrder = Groupon.Support.currentOrder;
    return this.options = options || {};
  };

  SupportCurrentOrderView.prototype.renderSubViews = function() {
    this.renderExternalDealNotes();
    this.renderDealSummary();
    this.renderOrderSummary();
    return this.renderOrderActions();
  };

  SupportCurrentOrderView.prototype.render = function() {
    this.renderSubViews();
    return this.layoutView();
  };

  SupportCurrentOrderView.prototype.layoutView = function() {
    this.dealSummary.$el.addClass('five columns');
    $('.deal-image', this.dealSummary.$el).addClass('five columns');
    $('.deal-info', this.dealSummary.$el).addClass('seven columns');
    this.orderSummary.$el.addClass('seven columns');
    if (!this.options.hideSelfServiceActions) {
      this.serviceActionMain.$el.addClass('cb');
      this.orderSummary.$el.append(this.serviceActionMain.el);
    }
    this.$el.append(this.dealSummary.el);
    return this.$el.append(this.orderSummary.el);
  };

  SupportCurrentOrderView.prototype.renderDealSummary = function() {
    this.createDealSummaryView();
    return this.dealSummary.render();
  };

  SupportCurrentOrderView.prototype.renderOrderSummary = function() {
    this.createOrderSummaryView();
    return this.orderSummary.render();
  };

  SupportCurrentOrderView.prototype.renderOrderActions = function() {
    this.createServiceActionView();
    if (!this.options.hideSelfServiceActions) {
      return this.serviceActionMain.render();
    }
  };

  SupportCurrentOrderView.prototype.renderExternalDealNotes = function(contentWrapper) {
    this.externalDealNotes = new SupportExternalDealNotesView();
    if (!this.options.hideExternalDealNotes && this.externalDealNotes.externalDealNotesPresent()) {
      this.externalDealNotes.render();
      return this.$el.append(this.externalDealNotes.el);
    }
  };

  SupportCurrentOrderView.prototype.createDealSummaryView = function() {
    return this.dealSummary = new SupportDealSummaryView();
  };

  SupportCurrentOrderView.prototype.createOrderSummaryView = function() {
    return this.orderSummary = new SupportOrderSummaryView();
  };

  SupportCurrentOrderView.prototype.createServiceActionView = function() {
    return this.serviceActionMain = new SupportServiceActionMainView({});
  };

  return SupportCurrentOrderView;

})(Backbone.View);

module.exports = SupportCurrentOrderView;



},{"./deal_summary_view":158,"./external_deal_notes":159,"./order_actions_view":162,"./order_summary_view":164,"./service_action_main_view":166,"backbone":245}],158:[function(require,module,exports){
var Backbone, SupportCurrentOrderModel, SupportDealSummaryTemplate, SupportDealSummaryView, SupportMarketRateImagePresenterPresentation, SupportUtilsHelper,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportMarketRateImagePresenterPresentation = require('../../presenters/market_rate_image_presenter');

SupportCurrentOrderModel = require('../../models/current_order');

SupportUtilsHelper = require('../../helpers/utils');

Backbone = require('backbone');

Backbone.$ = $;

SupportDealSummaryTemplate = require('../../../deal_summary.html.mustache');

SupportDealSummaryView = (function(superClass) {
  extend(SupportDealSummaryView, superClass);

  function SupportDealSummaryView() {
    return SupportDealSummaryView.__super__.constructor.apply(this, arguments);
  }

  SupportDealSummaryView.prototype.className = 'deal-summary';

  SupportDealSummaryView.prototype.initialize = function() {
    this.I18nScope = 'modules.support';
    this.template = SupportDealSummaryTemplate;
    this.order = Groupon.Support.currentOrder;
    this.orderPresenter = new SupportCurrentOrderModel;
    return this.dealData = this.toDealHash();
  };

  SupportDealSummaryView.prototype.events = {
    'click .v1-image': 'goToDealPage',
    'click .view_fine_print': 'showFinePrint'
  };

  SupportDealSummaryView.prototype.render = function() {
    return this.$el.append(toHtml(this.template, this.dealData, this.I18nScope));
  };

  SupportDealSummaryView.prototype.goToDealPage = function() {
    var ref;
    if (((ref = this.order.deal) != null ? ref.dealUrl : void 0) != null) {
      return window.open(this.order.deal.dealUrl, "_blank");
    } else if (this.dealData.dealId != null) {
      return window.open("/deals/" + this.dealData.dealId, "_blank");
    }
  };

  SupportDealSummaryView.prototype.toDealHash = function() {
    return this.orderPresenter.toDealHash();
  };

  SupportDealSummaryView.prototype.showFinePrint = function() {
    return SupportUtilsHelper.renderFinePrint();
  };

  return SupportDealSummaryView;

})(Backbone.View);

module.exports = SupportDealSummaryView;



},{"../../../deal_summary.html.mustache":36,"../../helpers/utils":54,"../../models/current_order":59,"../../presenters/market_rate_image_presenter":95,"backbone":245}],159:[function(require,module,exports){
var Backbone, SupportExternalDealNotesTemplate, SupportExternalDealNotesView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Backbone = require('backbone');

Backbone.$ = $;

SupportExternalDealNotesTemplate = require('../../../external_deal_notes.html.mustache');

SupportExternalDealNotesView = (function(superClass) {
  extend(SupportExternalDealNotesView, superClass);

  function SupportExternalDealNotesView() {
    return SupportExternalDealNotesView.__super__.constructor.apply(this, arguments);
  }

  SupportExternalDealNotesView.prototype.className = 'row external_deal_notes_row notification info';

  SupportExternalDealNotesView.prototype.initialize = function() {
    this.I18nScope = 'modules.support';
    this.template = SupportExternalDealNotesTemplate;
    return this.setExternalDealNote();
  };

  SupportExternalDealNotesView.prototype.render = function() {
    var ref;
    this.formatExternalDealNotes();
    this.sortExternalDealNotes();
    if (((ref = this.externalDealNotes) != null ? ref[0] : void 0) != null) {
      this.externalDealNotes[0].firstNotes = true;
    }
    return this.$el.append(toHtml(this.template, this.toHash(), this.I18nScope));
  };

  SupportExternalDealNotesView.prototype.setExternalDealNote = function() {
    return this.externalDealNotes = Groupon.Support.ContentModel.externalDealNotes;
  };

  SupportExternalDealNotesView.prototype.toHash = function() {
    var ref, ref1, ref2;
    return {
      isExternalDealNotesPresent: this.externalDealNotesPresent(),
      externalDealNotes: this.externalDealNotes,
      businessName: (ref = Groupon.Support.currentOrder) != null ? (ref1 = ref.merchant) != null ? ref1.name : void 0 : void 0,
      channelCode: Groupon.Support.currentOrder.DEAL_TYPE,
      dealId: (ref2 = Groupon.Support.currentOrder.deal) != null ? ref2.id : void 0,
      country: window.country.name,
      orderId: Groupon.Support.currentOrder.id
    };
  };

  SupportExternalDealNotesView.prototype.externalDealNotesPresent = function() {
    if (this.externalDealNotes != null) {
      return true;
    } else {
      return false;
    }
  };

  SupportExternalDealNotesView.prototype.sortExternalDealNotes = function() {
    var ref;
    return (ref = this.externalDealNotes) != null ? ref.sort(this.sortbyUpdatedDate) : void 0;
  };

  SupportExternalDealNotesView.prototype.sortbyUpdatedDate = function(a, b) {
    a = getMillisecondsOfUTCDateFromISOStringDate(a.updated_at);
    b = getMillisecondsOfUTCDateFromISOStringDate(b.updated_at);
    return b - a;
  };

  SupportExternalDealNotesView.prototype.formatText = function(text) {
    var formatedText, i, len, part, subtexts;
    if (text != null) {
      formatedText = "";
      subtexts = text.split('\n');
      for (i = 0, len = subtexts.length; i < len; i++) {
        part = subtexts[i];
        if ((part != null ? part.length : void 0) > 0) {
          formatedText = "" + formatedText + part + " ";
          if (part !== _.last(subtexts)) {
            formatedText = formatedText + " <br/> ";
          }
        }
      }
      return formatedText;
    } else {
      return text;
    }
  };

  SupportExternalDealNotesView.prototype.formatExternalDealNotes = function() {
    if (this.externalDealNotes != null) {
      return _.each(this.externalDealNotes, (function(_this) {
        return function(extNote) {
          return extNote.note = _this.formatText(extNote.note);
        };
      })(this));
    }
  };

  return SupportExternalDealNotesView;

})(Backbone.View);

module.exports = SupportExternalDealNotesView;



},{"../../../external_deal_notes.html.mustache":38,"backbone":245}],160:[function(require,module,exports){
var Backbone, SupportFinePrintPresenterPresentation, SupportFinePrintTemplate, SupportFinePrintView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportFinePrintPresenterPresentation = require('../../presenters/fine_print_presenter');

Backbone = require('backbone');

Backbone.$ = $;

SupportFinePrintTemplate = require('../../../fine_print.html.mustache');

SupportFinePrintView = (function(superClass) {
  extend(SupportFinePrintView, superClass);

  function SupportFinePrintView() {
    return SupportFinePrintView.__super__.constructor.apply(this, arguments);
  }

  SupportFinePrintView.prototype.id = 'popupContent';

  SupportFinePrintView.prototype.initialize = function() {
    this.I18nScope = 'modules.support';
    return this.template = SupportFinePrintTemplate;
  };

  SupportFinePrintView.prototype.render = function() {
    this.popup = $('#popup');
    GIG.Modal.open({
      el: this.popup,
      closeOnBgClick: true,
      closeOnEscKey: true
    });
    this.$el.html(toHtml(this.template, this.toHash(), this.I18nScope));
    this.popup.html(this.el);
    return openLinksInNewTab($('#popupContent a'));
  };

  SupportFinePrintView.prototype.toHash = function() {
    var ref;
    return {
      fine_print: Groupon.Support.currentOrder.finePrintText || ((ref = Groupon.Support.currentOrder.deal) != null ? ref.finePrintText : void 0)
    };
  };

  SupportFinePrintView.prototype.closeModal = function() {
    GIG.Modal.close();
    return false;
  };

  SupportFinePrintView.prototype.events = {
    'click .close-modal': "closeModal"
  };

  return SupportFinePrintView;

})(Backbone.View);

module.exports = SupportFinePrintView;



},{"../../../fine_print.html.mustache":39,"../../presenters/fine_print_presenter":74,"backbone":245}],161:[function(require,module,exports){
var Backbone, SupportAPIHelper, SupportGiftOrderPopupFormTemplate, SupportGiftOrderPopupView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportAPIHelper = require('../../helpers/API');

SupportGiftOrderPopupFormTemplate = require('../../../gift_order_popup_form.html.mustache');

Backbone = require('backbone');

Backbone.$ = $;

SupportGiftOrderPopupView = (function(superClass) {
  extend(SupportGiftOrderPopupView, superClass);

  function SupportGiftOrderPopupView() {
    return SupportGiftOrderPopupView.__super__.constructor.apply(this, arguments);
  }

  SupportGiftOrderPopupView.prototype.id = 'giftpopupContent';

  SupportGiftOrderPopupView.prototype.initialize = function(options) {
    this.options = options || {};
    _.bindAll.apply(_, [this].concat(_.functions(this)));
    this.I18nScope = 'modules.support';
    this.template = SupportGiftOrderPopupFormTemplate;
    this.order = Groupon.Support.currentOrder;
    this.attributes = this.options.userId;
    this.isEmail = true;
    return this.render();
  };

  SupportGiftOrderPopupView.prototype.render = function() {
    this.popup = $('#popup');
    GIG.Modal.open({
      el: this.popup,
      closeOnBgClick: true,
      closeOnEscKey: true
    });
    this.popup.html(toHtml(this.template, {}, this.I18nScope));
    this.giftEmailDeliveryType = $('#emailType');
    this.saveBtn = $('#gift_details_save_btn');
    this.recipientName = $('#order_gift_recipient_name');
    this.senderName = $('#order_gift_from_name');
    this.recipientEmail = $('#order_gift_recipient_email');
    this.message = $('#order_gift_message');
    this.giftEmailDeliveryType.prop('checked', true);
    this.validateToField = $('#validate_to_field');
    this.validateFromField = $('#validate_from_field');
    this.validateEmail = $('#validate_email');
    this.saveBtn.bind("click", this.saveBtnHandler);
    $("input:radio[name=deliveryType]").click(function(ev) {
      var emailInput;
      emailInput = $('#order_gift_recipient_email');
      if (ev.currentTarget.id === "emailType") {
        this.isEmail = true;
        return emailInput.removeAttr('disabled');
      } else {
        this.isEmail = false;
        emailInput.val("");
        return emailInput.prop('disabled', 'disabled');
      }
    });
    return $('#order_gift_message').keyup(function(ev) {
      var content, max, msgDiv, remaining;
      max = 330;
      msgDiv = $('#order_gift_message');
      content = msgDiv.val();
      if (content.length >= max) {
        remaining = 0;
        return $('#noOfChars').text(remaining + " characters");
      } else {
        remaining = max - content.length;
        if (remaining === 1) {
          return $('#noOfChars').text(remaining + " character");
        } else {
          return $('#noOfChars').text(remaining + " characters");
        }
      }
    });
  };

  SupportGiftOrderPopupView.prototype.clearValidationMessages = function() {
    this.validateToField.text('');
    this.validateFromField.text('');
    return this.validateEmail.text('');
  };

  SupportGiftOrderPopupView.prototype.validate = function() {
    var email, validationPass;
    validationPass = true;
    this.clearValidationMessages();
    if (this.recipientName.val().length === 0) {
      this.validateToField.text('Field cannot be empty');
      validationPass = false;
    }
    if (this.senderName.val().length === 0) {
      this.validateFromField.text('Field cannot be empty');
      validationPass = false;
    }
    if (this.isEmail === true) {
      email = this.recipientEmail.val();
      if (!this.validateEmailAddress(email)) {
        this.validateEmail.text('Enter valid email address');
        validationPass = false;
      }
    }
    return validationPass;
  };

  SupportGiftOrderPopupView.prototype.validateEmailAddress = function(email) {
    var re;
    re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  };

  SupportGiftOrderPopupView.prototype.saveBtnHandler = function() {
    var data, errorCallback, options, successCallback, url;
    if (!this.validate()) {
      return;
    }
    successCallback = this.closePopup;
    errorCallback = this.renderErrorPage;
    data = {};
    data.module_name = 'contact_us_ajax';
    data.method_name = 'giftOrder';
    options = {};
    options.gift_to_name = this.recipientName.val();
    options.gift_from_name = this.senderName.val();
    if (this.isEmail === true) {
      options.gift_recipient_email_address = this.recipientEmail.val();
      options.gift_delivery_method = "email";
    } else {
      options.gift_delivery_method = "print";
    }
    options.gift_message = this.message.val();
    options.order_id = Groupon.Support.currentOrder.id;
    options.deal_id = Groupon.Support.currentOrder.deal.id;
    url = window.SUPPORTBASEURL + "/getData";
    data = {};
    data.module_name = "orders_update";
    data.method_name = "giftOrder";
    data.options = options;
    return SupportAPIHelper.get(url, data, successCallback, errorCallback, true);
  };

  SupportGiftOrderPopupView.prototype.renderErrorPage = function() {
    return flash('error', "Error when contacting server for gift order action");
  };

  SupportGiftOrderPopupView.prototype.closePopup = function() {
    GIG.Modal.close();
    return false;
  };

  SupportGiftOrderPopupView.prototype.events = {
    "click #gift_details_cancel_btn": "closePopup"
  };

  return SupportGiftOrderPopupView;

})(Backbone.View);

module.exports = SupportGiftOrderPopupView;



},{"../../../gift_order_popup_form.html.mustache":213,"../../helpers/API":51,"backbone":245}],162:[function(require,module,exports){
var Backbone, SupportOrderActionsTemplate, SupportOrderActionsView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportOrderActionsTemplate = require('../../../order_actions.html.mustache');

Backbone = require('backbone');

Backbone.$ = $;

SupportOrderActionsView = (function(superClass) {
  extend(SupportOrderActionsView, superClass);

  function SupportOrderActionsView() {
    return SupportOrderActionsView.__super__.constructor.apply(this, arguments);
  }

  SupportOrderActionsView.prototype.className = 'order-actions';

  SupportOrderActionsView.prototype.initialize = function() {
    this.I18nScope = 'modules.support';
    this.template = SupportOrderActionsTemplate;
    return this.order = Groupon.Support.currentOrder;
  };

  SupportOrderActionsView.prototype.render = function() {
    return this.$el.append(toHtml(this.template, this.toHash(), this.I18nScope));
  };

  SupportOrderActionsView.prototype.toHash = function() {
    return {};
  };

  return SupportOrderActionsView;

})(Backbone.View);

module.exports = SupportOrderActionsView;



},{"../../../order_actions.html.mustache":223,"backbone":245}],163:[function(require,module,exports){
var Backbone, SupportOrderListElementViewTemplate, SupportOrderView, SupportUtilsHelper,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportOrderListElementViewTemplate = require('../../../order_list_element_view.html.mustache');

Backbone = require('backbone');

Backbone.$ = $;

SupportUtilsHelper = require('../../helpers/utils');

SupportOrderView = (function(superClass) {
  extend(SupportOrderView, superClass);

  function SupportOrderView() {
    return SupportOrderView.__super__.constructor.apply(this, arguments);
  }

  SupportOrderView.prototype.tagName = 'tr';

  SupportOrderView.prototype.className = 'orderTableRow';

  SupportOrderView.prototype.initialize = function() {
    _.bindAll.apply(_, [this].concat(_.functions(this)));
    this.I18nScope = 'modules.support';
    return this.template = SupportOrderListElementViewTemplate;
  };

  SupportOrderView.prototype.renderSingleItem = function(order) {
    var data;
    data = this.toHash(order);
    this.$el.html(toHtml(this.template, data, this.I18nScope));
    this.$el.attr('key', data.id);
    this.$el.attr('dateStr', data.purchasedAt);
    return data;
  };

  SupportOrderView.prototype.renderEmptyTemplate = function() {
    var data;
    data = {
      showMultipleColumns: true,
      hasData: false
    };
    return toHtml(this.template, data, this.I18nScope);
  };

  SupportOrderView.prototype.replaceEmptyTemplateWithOrderTemplate = function(emptyTd, order) {
    var data;
    data = this.toHash(order);
    data.showMultipleColumns = true;
    data.hasData = true;
    return emptyTd.replaceWith(toHtml(this.template, data, this.I18nScope));
  };

  SupportOrderView.prototype.renderMultipleItems = function(orders) {
    return _.each(orders, (function(_this) {
      return function(order) {
        var data;
        if (order) {
          data = _this.toHash(order);
          data.showMultipleColumns = true;
          data.hasData = true;
          return _this.$el.append(toHtml(_this.template, data, _this.I18nScope));
        }
      };
    })(this));
  };

  SupportOrderView.prototype.toHash = function(order) {
    var data;
    data = (function() {
      switch (order.DEAL_TYPE) {
        case 'GETAWAYS_TONIGHT':
          return this.reservationHash(order);
        case 'GETAWAYS_MARKET_RATE':
          return this.reservationHash(order);
        case 'GETAWAYS_BOOKING':
          return this.getawaysBookingHash(order);
        default:
          return this.orderHash(order);
      }
    }).call(this);
    return data;
  };

  SupportOrderView.prototype.orderHash = function(order) {
    var data, quantity, ref, ref1, ref2, ref3, ref4;
    quantity = order.quantity;
    if (quantity == null) {
      quantity = SupportUtilsHelper.findGrouponQuantity(order.groupons);
    }
    data = {
      id: order.id,
      imageUrl: ((ref = order.deal) != null ? ref.smallImageUrl : void 0) || ((ref1 = order.deal) != null ? ref1.sidebarImageUrl : void 0) || ((ref2 = order.deal) != null ? ref2.mediumImageUrl : void 0),
      merchant: (ref3 = order.merchant) != null ? ref3.name : void 0,
      purchasedAt: order.purchasedAtshortDatetimeStr,
      qty: quantity,
      title: (ref4 = order.deal) != null ? ref4.title : void 0
    };
    return data;
  };

  SupportOrderView.prototype.getawaysBookingHash = function(order) {
    var data, ref, ref1, ref2, reservationSource;
    reservationSource = SupportUtilsHelper.getReservationSource(order);
    data = {
      id: order.id,
      imageUrl: ((ref = order.deal) != null ? ref.sidebarImageUrl : void 0) || ((ref1 = order.deal) != null ? ref1.mediumImageUrl : void 0) || ((ref2 = order.deal) != null ? ref2.smallImageUrl : void 0),
      merchant: reservationSource != null ? reservationSource.hotelName : void 0,
      purchasedAt: order.purchasedAtshortDatetimeStr,
      title: reservationSource != null ? reservationSource.roomNameHtml : void 0,
      checkInDate: reservationSource != null ? reservationSource.formattedCheckInShortDate : void 0,
      checkOutDate: reservationSource != null ? reservationSource.formattedCheckOutShortDate : void 0,
      showReservatioinDates: true
    };
    return data;
  };

  SupportOrderView.prototype.reservationHash = function(order) {
    var data, reservationSource;
    reservationSource = SupportUtilsHelper.getReservationSource(order);
    data = {
      id: order.id,
      imageUrl: order.imageUrl,
      merchant: reservationSource != null ? reservationSource.hotelName : void 0,
      purchasedAt: order.purchasedAtshortDatetimeStr,
      title: reservationSource != null ? reservationSource.roomNameHtml : void 0,
      checkInDate: reservationSource != null ? reservationSource.formattedCheckInDate : void 0,
      checkOutDate: reservationSource != null ? reservationSource.formattedCheckOutDate : void 0,
      showReservatioinDates: true
    };
    return data;
  };

  return SupportOrderView;

})(Backbone.View);

module.exports = SupportOrderView;



},{"../../../order_list_element_view.html.mustache":224,"../../helpers/utils":54,"backbone":245}],164:[function(require,module,exports){
var Backbone, SupportCurrentOrderModel, SupportOrderSummaryTemplate, SupportOrderSummaryView, SupportUtilsHelper,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportUtilsHelper = require('../../helpers/utils');

SupportOrderSummaryTemplate = require('../../../order_summary.html.mustache');

SupportCurrentOrderModel = require('../../models/current_order');

Backbone = require('backbone');

Backbone.$ = $;

SupportOrderSummaryView = (function(superClass) {
  extend(SupportOrderSummaryView, superClass);

  function SupportOrderSummaryView() {
    return SupportOrderSummaryView.__super__.constructor.apply(this, arguments);
  }

  SupportOrderSummaryView.prototype.className = 'order-summary';

  SupportOrderSummaryView.prototype.initialize = function() {
    this.I18nScope = 'modules.support';
    this.template = SupportOrderSummaryTemplate;
    return this.orderPresenter = new SupportCurrentOrderModel;
  };

  SupportOrderSummaryView.prototype.render = function() {
    return this.$el.append(toHtml(this.template, this.buildOrderSummaryParams(), this.I18nScope));
  };

  SupportOrderSummaryView.prototype.buildOrderSummaryParams = function() {
    return this.orderPresenter.buildOrderSummaryParams();
  };

  return SupportOrderSummaryView;

})(Backbone.View);

module.exports = SupportOrderSummaryView;



},{"../../../order_summary.html.mustache":226,"../../helpers/utils":54,"../../models/current_order":59,"backbone":245}],165:[function(require,module,exports){
var Backbone, SupportGeneralPopupTemplate, SupportRedemptionInstructionsPopupView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportGeneralPopupTemplate = require('../../../general_popup.html.mustache');

Backbone = require('backbone');

Backbone.$ = $;

SupportRedemptionInstructionsPopupView = (function(superClass) {
  extend(SupportRedemptionInstructionsPopupView, superClass);

  function SupportRedemptionInstructionsPopupView() {
    return SupportRedemptionInstructionsPopupView.__super__.constructor.apply(this, arguments);
  }

  SupportRedemptionInstructionsPopupView.prototype.initialize = function() {
    _.bindAll.apply(_, [this].concat(_.functions(this)));
    this.I18nScope = 'modules.support';
    this.template = SupportGeneralPopupTemplate;
    return this.order = Groupon.Support.currentOrder;
  };

  SupportRedemptionInstructionsPopupView.prototype.render = function() {
    this.popup = $('#popup');
    GIG.Modal.open({
      el: this.popup,
      closeOnBgClick: true,
      closeOnEscKey: true
    });
    this.$el.html(toHtml(this.template, this.toHash(), this.I18nScope));
    this.popup.html(this.el);
    return openLinksInNewTab($('#popupContent a'));
  };

  SupportRedemptionInstructionsPopupView.prototype.toHash = function() {
    var obj;
    return obj = {
      title: I18n.t("js.modules.support.redemption_instructions"),
      instructions: replaceNewLineWithBreak(this.order.dealOption.instructions)
    };
  };

  SupportRedemptionInstructionsPopupView.prototype.closeModal = function() {
    GIG.Modal.close();
    return false;
  };

  SupportRedemptionInstructionsPopupView.prototype.events = {
    'click .close-modal': "closeModal"
  };

  return SupportRedemptionInstructionsPopupView;

})(Backbone.View);

module.exports = SupportRedemptionInstructionsPopupView;



},{"../../../general_popup.html.mustache":212,"backbone":245}],166:[function(require,module,exports){
var Backbone, SupportCancelOrderServiceActionView, SupportCancelReservationsServiceActionView, SupportEditGiftServiceActionView, SupportEditOrderServiceActionView, SupportFinePrintServiceActionView, SupportGiftOrderServiceActionView, SupportOrderFoodServiceActionView, SupportPrintGiftCardVoucherServiceActionView, SupportRedemptionInstructionsServiceActionView, SupportReturnItemsServiceActionView, SupportServiceActionMainView, SupportServiceActionsBaseView, SupportTrackOrderServiceActionView, SupportUpdateShippingServiceActionView, SupportViewOrderDetailsServiceActionView, SupportViewVoucherServiceActionView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportViewVoucherServiceActionView = require('./service_actions/view_voucher_service_action');

SupportCancelOrderServiceActionView = require('./service_actions/cancel_order_service_action');

SupportEditOrderServiceActionView = require('./service_actions/edit_order_service_action');

SupportGiftOrderServiceActionView = require('./service_actions/gift_order_service_action');

SupportUpdateShippingServiceActionView = require('./service_actions/update_shipping_address_service_action');

SupportTrackOrderServiceActionView = require('./service_actions/track_order_service_action');

SupportRedemptionInstructionsServiceActionView = require('./service_actions/redemption_instructions_service_action');

SupportReturnItemsServiceActionView = require('./service_actions/return_item_service_action');

SupportCancelReservationsServiceActionView = require('./service_actions/cancel_reservations_service_action');

SupportEditGiftServiceActionView = require('./service_actions/edit_gift_service_action');

SupportViewOrderDetailsServiceActionView = require('./service_actions/view_order_details_service_action');

SupportPrintGiftCardVoucherServiceActionView = require('./service_actions/print_gift_card_voucher_service_action');

SupportFinePrintServiceActionView = require('./service_actions/fine_print_service_action');

SupportOrderFoodServiceActionView = require('./service_actions/order_food_service_action');

SupportServiceActionsBaseView = require('./service_actions/service_action_base');

Backbone = require('backbone');

Backbone.$ = $;

SupportServiceActionMainView = (function(superClass) {
  extend(SupportServiceActionMainView, superClass);

  function SupportServiceActionMainView() {
    return SupportServiceActionMainView.__super__.constructor.apply(this, arguments);
  }

  SupportServiceActionMainView.prototype.id = 'serviceActionContainer';

  SupportServiceActionMainView.prototype.initialize = function(options) {
    this.options = options || {};
    _.bindAll.apply(_, [this].concat(_.functions(this)));
    this.I18nScope = 'modules.support';
    this.serviceActions = Groupon.Support.currentOrder.serviceActions || [];
    this.constructButtonInfo();
    return this.mapViews();
  };

  SupportServiceActionMainView.prototype.constructButtonInfo = function() {
    if (this.options.showLinksAndButtons) {
      this.secondaryButtons = ['cancel_reservations', 'view_voucher', 'order_food', 'track_order', 'edit_order', 'cancel_order', 'update_shipping', 'return_item'];
      this.linkButtons = ['view_order_details', 'edit_gift', 'gift_to_friend', 'redemption_instructions', 'print_gift_card_voucher', 'fine_print'];
      return this.defaultButtons = [];
    } else if (this.options.showOnlyLinks) {
      this.secondaryButtons = [];
      this.linkButtons = ['cancel_reservations', 'view_voucher', 'order_food', 'track_order', 'edit_order', 'cancel_order', 'update_shipping', 'return_item', 'view_order_details', 'edit_gift', 'gift_to_friend', 'redemption_instructions', 'print_gift_card_voucher', 'fine_print'];
      return this.defaultButtons = [];
    } else {
      this.secondaryButtons = [];
      this.linkButtons = [];
      return this.defaultButtons = ['cancel_reservations', 'view_voucher', 'order_food', 'track_order', 'edit_order', 'cancel_order', 'update_shipping', 'return_item', 'view_order_details', 'edit_gift', 'gift_to_friend', 'redemption_instructions', 'print_gift_card_voucher', 'fine_print'];
    }
  };

  SupportServiceActionMainView.prototype.getButtonType = function(serviceActionName) {
    if (_.contains(this.secondaryButtons, serviceActionName)) {
      return this.secondaryButtonIdentifier();
    } else if (_.contains(this.linkButtons, serviceActionName)) {
      return this.linkIdentifier();
    } else {
      return this.defaultButtonIdentifier();
    }
  };

  SupportServiceActionMainView.prototype.linkIdentifier = function() {
    return SupportServiceActionsBaseView.prototype.linkIdentifier();
  };

  SupportServiceActionMainView.prototype.defaultButtonIdentifier = function() {
    return SupportServiceActionsBaseView.prototype.defaultButtonIdentifier();
  };

  SupportServiceActionMainView.prototype.secondaryButtonIdentifier = function() {
    return SupportServiceActionsBaseView.prototype.secondaryButtonIdentifier();
  };

  SupportServiceActionMainView.prototype.mapViews = function() {
    this.map = {};
    this.map.view_order_details = {
      view: SupportViewOrderDetailsServiceActionView,
      button_type: this.getButtonType('view_order_details')
    };
    this.map.edit_gift = {
      view: SupportEditGiftServiceActionView,
      button_type: this.getButtonType('edit_gift')
    };
    this.map.cancel_reservations = {
      view: SupportCancelReservationsServiceActionView,
      button_type: this.getButtonType('cancel_reservations')
    };
    this.map.view_voucher = {
      view: SupportViewVoucherServiceActionView,
      button_type: this.getButtonType('view_voucher')
    };
    this.map.gift_to_friend = {
      view: SupportGiftOrderServiceActionView,
      button_type: this.getButtonType('gift_to_friend')
    };
    this.map.redemption_instructions = {
      view: SupportRedemptionInstructionsServiceActionView,
      button_type: this.getButtonType('redemption_instructions')
    };
    this.map.track_order = {
      view: SupportTrackOrderServiceActionView,
      button_type: this.getButtonType('track_order')
    };
    this.map.edit_order = {
      view: SupportEditOrderServiceActionView,
      button_type: this.getButtonType('edit_order')
    };
    this.map.cancel_order = {
      view: SupportCancelOrderServiceActionView,
      button_type: this.getButtonType('cancel_order')
    };
    this.map.update_shipping = {
      view: SupportUpdateShippingServiceActionView,
      button_type: this.getButtonType('update_shipping')
    };
    this.map.return_item = {
      view: SupportReturnItemsServiceActionView,
      button_type: this.getButtonType('return_item')
    };
    this.map.print_gift_card_voucher = {
      view: SupportPrintGiftCardVoucherServiceActionView,
      button_type: this.getButtonType('print_gift_card_voucher')
    };
    this.map.fine_print = {
      view: SupportFinePrintServiceActionView,
      button_type: this.getButtonType('fine_print')
    };
    return this.map.order_food = {
      view: SupportOrderFoodServiceActionView,
      button_type: this.getButtonType('order_food')
    };
  };

  SupportServiceActionMainView.prototype.render = function() {
    var action, i, len, ref, results, serviceAction, view;
    this.$el.attr('data-bhw', 'servicActions');
    ref = this.serviceActions;
    results = [];
    for (i = 0, len = ref.length; i < len; i++) {
      serviceAction = ref[i];
      action = this.map[serviceAction];
      if ((action != null ? action.view : void 0) != null) {
        view = new action.view();
        view.setButtonType(action.button_type);
        view.render();
        view.$el.addClass('service-action-item').addClass(view.button_type);
        results.push(this.$el.append(view.el));
      } else {
        results.push(void 0);
      }
    }
    return results;
  };

  return SupportServiceActionMainView;

})(Backbone.View);

module.exports = SupportServiceActionMainView;



},{"./service_actions/cancel_order_service_action":167,"./service_actions/cancel_reservations_service_action":168,"./service_actions/edit_gift_service_action":169,"./service_actions/edit_order_service_action":170,"./service_actions/fine_print_service_action":171,"./service_actions/gift_order_service_action":172,"./service_actions/order_food_service_action":173,"./service_actions/print_gift_card_voucher_service_action":174,"./service_actions/redemption_instructions_service_action":175,"./service_actions/return_item_service_action":176,"./service_actions/service_action_base":177,"./service_actions/track_order_service_action":178,"./service_actions/update_shipping_address_service_action":179,"./service_actions/view_order_details_service_action":180,"./service_actions/view_voucher_service_action":181,"backbone":245}],167:[function(require,module,exports){
var SupportCancelOrderServiceActionView, SupportServiceActionButtonTemplate, SupportServiceActionsBaseView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportServiceActionsBaseView = require('./service_action_base');

SupportServiceActionButtonTemplate = require('../../../../service_action_button.html.mustache');

SupportCancelOrderServiceActionView = (function(superClass) {
  extend(SupportCancelOrderServiceActionView, superClass);

  function SupportCancelOrderServiceActionView() {
    return SupportCancelOrderServiceActionView.__super__.constructor.apply(this, arguments);
  }

  SupportCancelOrderServiceActionView.prototype.id = 'cancel_order';

  SupportCancelOrderServiceActionView.prototype.initialize = function() {
    _.bindAll.apply(_, [this].concat(_.functions(this)));
    this.I18nScope = 'modules.support';
    this.template = SupportServiceActionButtonTemplate;
    return this.order = Groupon.Support.currentOrder;
  };

  SupportCancelOrderServiceActionView.prototype.render = function() {
    return this.$el.append(toHtml(this.template, this.toHash(), this.I18nScope));
  };

  SupportCancelOrderServiceActionView.prototype.toHash = function() {
    var hash;
    hash = {
      service_action_id: 'cancel_order',
      service_action: I18n.t("js.modules.support.cancel_order")
    };
    return this.extendHash(hash);
  };

  SupportCancelOrderServiceActionView.prototype.actionHandler = function(event) {
    var dealPermalink, orderId, url;
    dealPermalink = Groupon.Support.currentOrder.deal.id;
    orderId = Groupon.Support.currentOrder.id;
    url = "/deals/" + dealPermalink + "/confirmation/" + orderId + "#toggle-inputs";
    return openLocation(url);
  };

  SupportCancelOrderServiceActionView.prototype.events = {
    "click #cancel_order": "actionHandler"
  };

  return SupportCancelOrderServiceActionView;

})(SupportServiceActionsBaseView);

module.exports = SupportCancelOrderServiceActionView;



},{"../../../../service_action_button.html.mustache":231,"./service_action_base":177}],168:[function(require,module,exports){
var SupportCancelReservationsServiceActionView, SupportServiceActionButtonTemplate, SupportServiceActionsBaseView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportServiceActionsBaseView = require('./service_action_base');

SupportServiceActionButtonTemplate = require('../../../../service_action_button.html.mustache');

SupportCancelReservationsServiceActionView = (function(superClass) {
  extend(SupportCancelReservationsServiceActionView, superClass);

  function SupportCancelReservationsServiceActionView() {
    return SupportCancelReservationsServiceActionView.__super__.constructor.apply(this, arguments);
  }

  SupportCancelReservationsServiceActionView.prototype.id = 'cancel_reservation';

  SupportCancelReservationsServiceActionView.prototype.initialize = function() {
    _.bindAll.apply(_, [this].concat(_.functions(this)));
    this.I18nScope = 'modules.support';
    this.template = SupportServiceActionButtonTemplate;
    return this.order = Groupon.Support.currentOrder;
  };

  SupportCancelReservationsServiceActionView.prototype.render = function() {
    return this.$el.append(toHtml(this.template, this.toHash(), this.I18nScope));
  };

  SupportCancelReservationsServiceActionView.prototype.toHash = function() {
    var hash;
    hash = {
      service_action_id: "cancel_reservation",
      service_action: I18n.t("js.modules.support.cancel_reservation")
    };
    return this.extendHash(hash);
  };

  SupportCancelReservationsServiceActionView.prototype.actionHandler = function(event) {
    var url;
    url = "/users/" + currentUser.id + "/groupons";
    return openLocation(url);
  };

  SupportCancelReservationsServiceActionView.prototype.events = {
    "click #cancel_reservation": "actionHandler"
  };

  return SupportCancelReservationsServiceActionView;

})(SupportServiceActionsBaseView);

module.exports = SupportCancelReservationsServiceActionView;



},{"../../../../service_action_button.html.mustache":231,"./service_action_base":177}],169:[function(require,module,exports){
var SupportEditGiftServiceActionView, SupportGiftOrderPopupView, SupportServiceActionButtonTemplate, SupportServiceActionsBaseView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportGiftOrderPopupView = require('../gift_order_popup_view');

SupportServiceActionsBaseView = require('./service_action_base');

SupportServiceActionButtonTemplate = require('../../../../service_action_button.html.mustache');

SupportEditGiftServiceActionView = (function(superClass) {
  extend(SupportEditGiftServiceActionView, superClass);

  function SupportEditGiftServiceActionView() {
    return SupportEditGiftServiceActionView.__super__.constructor.apply(this, arguments);
  }

  SupportEditGiftServiceActionView.prototype.id = 'gift_to_friend';

  SupportEditGiftServiceActionView.prototype.initialize = function(options) {
    this.options = options || {};
    this.I18nScope = 'modules.support';
    this.template = SupportServiceActionButtonTemplate;
    _.bindAll.apply(_, [this].concat(_.functions(this)));
    this.order = Groupon.Support.currentOrder;
    return this.attributes = this.options.userId;
  };

  SupportEditGiftServiceActionView.prototype.render = function() {
    return this.$el.append(toHtml(this.template, this.toHash(), this.I18nScope));
  };

  SupportEditGiftServiceActionView.prototype.toHash = function() {
    var hash;
    hash = {
      service_action_id: 'edit_gift',
      service_action: I18n.t("js.modules.support.edit_gift")
    };
    return this.extendHash(hash);
  };

  SupportEditGiftServiceActionView.prototype.actionHandler = function(event) {
    var current_order, url;
    current_order = Groupon.Support.currentOrder;
    url = "/users/" + currentUser.id + "/gift_cards";
    window.open(url);
    return this.popup = new SupportGiftOrderPopupView();
  };

  SupportEditGiftServiceActionView.prototype.events = {
    "click #edit_gift": "actionHandler"
  };

  return SupportEditGiftServiceActionView;

})(SupportServiceActionsBaseView);

module.exports = SupportEditGiftServiceActionView;



},{"../../../../service_action_button.html.mustache":231,"../gift_order_popup_view":161,"./service_action_base":177}],170:[function(require,module,exports){
var SupportEditOrderServiceActionView, SupportServiceActionButtonTemplate, SupportServiceActionsBaseView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportServiceActionsBaseView = require('./service_action_base');

SupportServiceActionButtonTemplate = require('../../../../service_action_button.html.mustache');

SupportEditOrderServiceActionView = (function(superClass) {
  extend(SupportEditOrderServiceActionView, superClass);

  function SupportEditOrderServiceActionView() {
    return SupportEditOrderServiceActionView.__super__.constructor.apply(this, arguments);
  }

  SupportEditOrderServiceActionView.prototype.id = 'edit_order';

  SupportEditOrderServiceActionView.prototype.initialize = function() {
    this.I18nScope = 'modules.support';
    this.template = SupportServiceActionButtonTemplate;
    _.bindAll.apply(_, [this].concat(_.functions(this)));
    return this.order = Groupon.Support.currentOrder;
  };

  SupportEditOrderServiceActionView.prototype.render = function() {
    return this.$el.append(toHtml(this.template, this.toHash(), this.I18nScope));
  };

  SupportEditOrderServiceActionView.prototype.toHash = function() {
    var hash;
    hash = {
      service_action_id: "edit_order",
      service_action: I18n.t("js.modules.support.edit_order")
    };
    return this.extendHash(hash);
  };

  SupportEditOrderServiceActionView.prototype.actionHandler = function(event) {
    var current_order, dealPermalink, orderId, url;
    current_order = Groupon.Support.currentOrder;
    dealPermalink = current_order.deal.id;
    orderId = current_order.id;
    url = "/deals/" + dealPermalink + "/confirmation/" + orderId;
    return window.open(url);
  };

  SupportEditOrderServiceActionView.prototype.events = {
    "click #edit_order": "actionHandler"
  };

  return SupportEditOrderServiceActionView;

})(SupportServiceActionsBaseView);

module.exports = SupportEditOrderServiceActionView;



},{"../../../../service_action_button.html.mustache":231,"./service_action_base":177}],171:[function(require,module,exports){
var SupportFinePrintServiceActionView, SupportServiceActionButtonTemplate, SupportServiceActionsBaseView, SupportUtilsHelper,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportUtilsHelper = require('../../../helpers/utils');

SupportServiceActionsBaseView = require('./service_action_base');

SupportServiceActionButtonTemplate = require('../../../../service_action_button.html.mustache');

SupportFinePrintServiceActionView = (function(superClass) {
  extend(SupportFinePrintServiceActionView, superClass);

  function SupportFinePrintServiceActionView() {
    return SupportFinePrintServiceActionView.__super__.constructor.apply(this, arguments);
  }

  SupportFinePrintServiceActionView.prototype.id = 'fine_print';

  SupportFinePrintServiceActionView.prototype.events = {
    'click #fine_print': 'showFinePrint'
  };

  SupportFinePrintServiceActionView.prototype.initialize = function() {
    _.bindAll.apply(_, [this].concat(_.functions(this)));
    this.I18nScope = 'modules.support';
    this.template = SupportServiceActionButtonTemplate;
    return this.order = Groupon.Support.currentOrder;
  };

  SupportFinePrintServiceActionView.prototype.render = function() {
    return this.$el.append(toHtml(this.template, this.toHash(), this.I18nScope));
  };

  SupportFinePrintServiceActionView.prototype.toHash = function() {
    var hash;
    hash = {
      service_action_id: 'fine_print',
      service_action: I18n.t("js.modules.support.viewfp")
    };
    return this.extendHash(hash);
  };

  SupportFinePrintServiceActionView.prototype.showFinePrint = function() {
    return SupportUtilsHelper.renderFinePrint();
  };

  return SupportFinePrintServiceActionView;

})(SupportServiceActionsBaseView);

module.exports = SupportFinePrintServiceActionView;



},{"../../../../service_action_button.html.mustache":231,"../../../helpers/utils":54,"./service_action_base":177}],172:[function(require,module,exports){
var SupportGiftOrderPopupView, SupportGiftOrderServiceActionView, SupportServiceActionButtonTemplate, SupportServiceActionsBaseView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportGiftOrderPopupView = require('../gift_order_popup_view');

SupportServiceActionsBaseView = require('./service_action_base');

SupportServiceActionButtonTemplate = require('../../../../service_action_button.html.mustache');

SupportGiftOrderServiceActionView = (function(superClass) {
  extend(SupportGiftOrderServiceActionView, superClass);

  function SupportGiftOrderServiceActionView() {
    return SupportGiftOrderServiceActionView.__super__.constructor.apply(this, arguments);
  }

  SupportGiftOrderServiceActionView.prototype.id = 'gift_to_friend';

  SupportGiftOrderServiceActionView.prototype.initialize = function(options) {
    this.options = options || {};
    _.bindAll.apply(_, [this].concat(_.functions(this)));
    this.I18nScope = 'modules.support';
    this.template = SupportServiceActionButtonTemplate;
    this.order = Groupon.Support.currentOrder;
    return this.attributes = this.options.userId;
  };

  SupportGiftOrderServiceActionView.prototype.render = function() {
    var hash;
    return hash = this.$el.append(toHtml(this.template, this.toHash(), this.I18nScope));
  };

  SupportGiftOrderServiceActionView.prototype.toHash = function() {
    var hash;
    hash = {
      service_action_id: "gift_order",
      service_action: I18n.t("js.modules.support.gift_order")
    };
    return this.extendHash(hash);
  };

  SupportGiftOrderServiceActionView.prototype.actionHandler = function(event) {
    var current_order, dealPermalink, orderId, url;
    current_order = Groupon.Support.currentOrder;
    dealPermalink = current_order.deal.id;
    orderId = current_order.id;
    url = "/deals/" + dealPermalink + "/confirmation?pledge_id=" + current_order.dealOptionId;
    window.open(url);
    return this.popup = new SupportGiftOrderPopupView();
  };

  SupportGiftOrderServiceActionView.prototype.events = {
    "click #gift_order": "actionHandler"
  };

  return SupportGiftOrderServiceActionView;

})(SupportServiceActionsBaseView);

module.exports = SupportGiftOrderServiceActionView;



},{"../../../../service_action_button.html.mustache":231,"../gift_order_popup_view":161,"./service_action_base":177}],173:[function(require,module,exports){
var SupportMultipleQtyPopupView, SupportOrderFoodServiceActionView, SupportServiceActionButtonTemplate, SupportServiceActionsBaseView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportMultipleQtyPopupView = require('../../multiple_Qty_Popup_View');

SupportServiceActionsBaseView = require('./service_action_base');

SupportServiceActionButtonTemplate = require('../../../../service_action_button.html.mustache');

SupportOrderFoodServiceActionView = (function(superClass) {
  extend(SupportOrderFoodServiceActionView, superClass);

  function SupportOrderFoodServiceActionView() {
    return SupportOrderFoodServiceActionView.__super__.constructor.apply(this, arguments);
  }

  SupportOrderFoodServiceActionView.prototype.tag = 'td';

  SupportOrderFoodServiceActionView.prototype.initialize = function() {
    _.bindAll.apply(_, [this].concat(_.functions(this)));
    this.I18nScope = 'modules.support';
    this.template = SupportServiceActionButtonTemplate;
    return this.order = Groupon.Support.currentOrder;
  };

  SupportOrderFoodServiceActionView.prototype.render = function() {
    this.$el.append(toHtml(this.template, this.toHash(), this.I18nScope));
    if (!this.shouldShowPopup()) {
      return this.addHref(this.getUrlForVoucher(this.order.groupons[0]));
    }
  };

  SupportOrderFoodServiceActionView.prototype.toHash = function() {
    var button_title, hash;
    button_title = this.getSingleActionTitle();
    hash = {
      service_action_id: "order_food",
      service_action: button_title
    };
    if (this.isSingleGroupon()) {
      this.extendSingleGrouponParams(hash);
    }
    return this.extendHash(hash);
  };

  SupportOrderFoodServiceActionView.prototype.actionHandler = function(event) {
    var args, current_order, multipleQtyPopup;
    current_order = Groupon.Support.currentOrder;
    if (this.shouldShowPopup()) {
      args = {
        orders: this.order,
        serviceActionName: 'order_food',
        singleActionButtonCallback: this.getUrlForVoucher,
        showgroupActionButton: false,
        title: this.getSingleActionTitle(),
        singleActionButtonName: this.getSingleActionTitle(),
        showAlertMessage: false
      };
      multipleQtyPopup = new SupportMultipleQtyPopupView(args);
      multipleQtyPopup.render();
    }
    return true;
  };

  SupportOrderFoodServiceActionView.prototype.getSingleActionTitle = function() {
    return I18n.t("js.modules.support.order_food");
  };

  SupportOrderFoodServiceActionView.prototype.shouldShowPopup = function() {
    return !this.isSingleGroupon();
  };

  SupportOrderFoodServiceActionView.prototype.isSingleGroupon = function() {
    return this.order.groupons.length === 1;
  };

  SupportOrderFoodServiceActionView.prototype.getUrlForVoucher = function(groupon) {
    var ref;
    return "/biz/locations/delivery-takeout?merchantId=" + ((ref = this.order.merchant) != null ? ref.uuid : void 0) + "&voucherId=" + groupon.id;
  };

  SupportOrderFoodServiceActionView.prototype.addHref = function(url) {
    return this.$el.find('#order_food').attr('href', url);
  };

  SupportOrderFoodServiceActionView.prototype.events = {
    "click #order_food": "actionHandler"
  };

  return SupportOrderFoodServiceActionView;

})(SupportServiceActionsBaseView);

module.exports = SupportOrderFoodServiceActionView;



},{"../../../../service_action_button.html.mustache":231,"../../multiple_Qty_Popup_View":156,"./service_action_base":177}],174:[function(require,module,exports){
var SupportMultipleQtyPopupView, SupportPrintGiftCardVoucherServiceActionView, SupportServiceActionButtonTemplate, SupportServiceActionsBaseView, SupportUtilsHelper, SupportViewVoucherServiceActionView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportViewVoucherServiceActionView = require('./view_voucher_service_action');

SupportMultipleQtyPopupView = require('../../multiple_Qty_Popup_View');

SupportServiceActionsBaseView = require('./service_action_base');

SupportUtilsHelper = require('../../../helpers/utils');

SupportServiceActionButtonTemplate = require('../../../../service_action_button.html.mustache');

SupportPrintGiftCardVoucherServiceActionView = (function(superClass) {
  extend(SupportPrintGiftCardVoucherServiceActionView, superClass);

  function SupportPrintGiftCardVoucherServiceActionView() {
    return SupportPrintGiftCardVoucherServiceActionView.__super__.constructor.apply(this, arguments);
  }

  SupportPrintGiftCardVoucherServiceActionView.prototype.initialize = function() {
    _.bindAll.apply(_, [this].concat(_.functions(this)));
    this.I18nScope = 'modules.support';
    this.template = SupportServiceActionButtonTemplate;
    return this.order = Groupon.Support.currentOrder;
  };

  SupportPrintGiftCardVoucherServiceActionView.prototype.render = function() {
    this.$el.append(toHtml(this.template, this.toHash(), this.I18nScope));
    if (this.order.groupons.length === 1) {
      return this.addHref(this.getUrlForVoucher(this.order.groupons[0]));
    }
  };

  SupportPrintGiftCardVoucherServiceActionView.prototype.toHash = function() {
    var hash;
    hash = {
      service_action_id: "print_gift_card_voucher"
    };
    if (this.isSingleGroupon()) {
      hash.service_action = I18n.t("js.modules.support.print_gift_card_voucher");
      this.extendSingleGrouponParams(hash);
    } else {
      hash.service_action = I18n.t("js.modules.support.print_gift_card_vouchers");
    }
    return this.extendHash(hash);
  };

  SupportPrintGiftCardVoucherServiceActionView.prototype.actionHandler = function(event) {
    var args, current_order, multipleQtyPopup;
    current_order = Groupon.Support.currentOrder;
    if (this.order.groupons.length > 1) {
      args = {
        orders: this.order,
        serviceActionName: 'print_gift_card_voucher',
        singleActionButtonCallback: this.getUrlForVoucher,
        groupActionButtonCallback: this.getUrlForAllVouchers,
        showgroupActionButton: false,
        title: I18n.t("js.modules.support.print_gift_card_vouchers"),
        singleActionButtonName: I18n.t("js.modules.support.print_gift_card_voucher")
      };
      multipleQtyPopup = new SupportMultipleQtyPopupView(args);
      multipleQtyPopup.render();
    }
    return true;
  };

  SupportPrintGiftCardVoucherServiceActionView.prototype.getUrlForAllVouchers = function(order_id) {
    return null;
  };

  SupportPrintGiftCardVoucherServiceActionView.prototype.getUrlForVoucher = function(groupon) {
    var order, ref, ref1;
    if (SupportUtilsHelper.isCurrentOrderGoodsDeal()) {
      order = Groupon.Support.currentOrder;
      return "/deals/" + ((ref = order.deal) != null ? ref.id : void 0) + "/gift/" + ((ref1 = order.dealOption) != null ? ref1.id : void 0) + ".pdf";
    } else {
      return "/mygroupons/gifts/envelope/voucher/" + currentUser.id + "/" + groupon.id + ".pdf";
    }
  };

  SupportPrintGiftCardVoucherServiceActionView.prototype.addHref = function(url) {
    return this.$el.find('#print_gift_card_voucher').attr('href', url);
  };

  SupportPrintGiftCardVoucherServiceActionView.prototype.renderErrorPage = function() {
    return flash('error', "Error when contacting server for Voucher PDF");
  };

  SupportPrintGiftCardVoucherServiceActionView.prototype.events = {
    "click #print_gift_card_voucher": "actionHandler"
  };

  return SupportPrintGiftCardVoucherServiceActionView;

})(SupportServiceActionsBaseView);

module.exports = SupportPrintGiftCardVoucherServiceActionView;



},{"../../../../service_action_button.html.mustache":231,"../../../helpers/utils":54,"../../multiple_Qty_Popup_View":156,"./service_action_base":177,"./view_voucher_service_action":181}],175:[function(require,module,exports){
var SupportRedemptionInstructionsPopupView, SupportRedemptionInstructionsServiceActionView, SupportServiceActionButtonTemplate, SupportServiceActionsBaseView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportRedemptionInstructionsPopupView = require('../redemption_instructions_popup_view');

SupportServiceActionsBaseView = require('./service_action_base');

SupportServiceActionButtonTemplate = require('../../../../service_action_button.html.mustache');

SupportRedemptionInstructionsServiceActionView = (function(superClass) {
  extend(SupportRedemptionInstructionsServiceActionView, superClass);

  function SupportRedemptionInstructionsServiceActionView() {
    return SupportRedemptionInstructionsServiceActionView.__super__.constructor.apply(this, arguments);
  }

  SupportRedemptionInstructionsServiceActionView.prototype.id = 'redemption_instruction';

  SupportRedemptionInstructionsServiceActionView.prototype.initialize = function(options) {
    _.bindAll.apply(_, [this].concat(_.functions(this)));
    this.I18nScope = 'modules.support';
    this.template = SupportServiceActionButtonTemplate;
    return this.order = Groupon.Support.currentOrder;
  };

  SupportRedemptionInstructionsServiceActionView.prototype.render = function() {
    return this.$el.append(toHtml(this.template, this.toHash(), this.I18nScope));
  };

  SupportRedemptionInstructionsServiceActionView.prototype.toHash = function() {
    var hash;
    hash = {
      service_action_id: "redemption_instruction",
      service_action: I18n.t("js.modules.support.view_redemption_instructions")
    };
    return this.extendHash(hash);
  };

  SupportRedemptionInstructionsServiceActionView.prototype.actionHandler = function(event) {
    var current_order;
    current_order = Groupon.Support.currentOrder;
    this.popup = new SupportRedemptionInstructionsPopupView();
    return this.popup.render();
  };

  SupportRedemptionInstructionsServiceActionView.prototype.events = {
    "click #redemption_instruction": "actionHandler"
  };

  return SupportRedemptionInstructionsServiceActionView;

})(SupportServiceActionsBaseView);

module.exports = SupportRedemptionInstructionsServiceActionView;



},{"../../../../service_action_button.html.mustache":231,"../redemption_instructions_popup_view":165,"./service_action_base":177}],176:[function(require,module,exports){
var SupportMultipleQtyPopupView, SupportReturnItemsServiceActionView, SupportServiceActionButtonTemplate, SupportServiceActionsBaseView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportServiceActionsBaseView = require('./service_action_base');

SupportServiceActionButtonTemplate = require('../../../../service_action_button.html.mustache');

SupportMultipleQtyPopupView = require('../../multiple_Qty_Popup_View');

SupportReturnItemsServiceActionView = (function(superClass) {
  extend(SupportReturnItemsServiceActionView, superClass);

  function SupportReturnItemsServiceActionView() {
    return SupportReturnItemsServiceActionView.__super__.constructor.apply(this, arguments);
  }

  SupportReturnItemsServiceActionView.prototype.id = 'return_item';

  SupportReturnItemsServiceActionView.prototype.initialize = function() {
    _.bindAll.apply(_, [this].concat(_.functions(this)));
    this.I18nScope = 'modules.support';
    this.template = SupportServiceActionButtonTemplate;
    return this.order = Groupon.Support.currentOrder;
  };

  SupportReturnItemsServiceActionView.prototype.render = function() {
    return this.$el.append(toHtml(this.template, this.toHash(), this.I18nScope));
  };

  SupportReturnItemsServiceActionView.prototype.toHash = function() {
    var button_title, hash, ref;
    button_title = ((ref = this.order.groupons) != null ? ref.length : void 0) > 1 ? I18n.t("js.modules.support.return_all_items") : I18n.t("js.modules.support.return_item");
    hash = {
      service_action_id: "return_item",
      service_action: button_title
    };
    return this.extendHash(hash);
  };

  SupportReturnItemsServiceActionView.prototype.actionHandler = function(event) {
    var args, currentOrder, multipleQtyPopup, ref;
    currentOrder = Groupon.Support.currentOrder;
    if (window.showMultiReturnItemPopup && ((ref = currentOrder.groupons) != null ? ref.length : void 0) > 1) {
      args = {
        orders: this.order,
        serviceActionName: 'return_item',
        singleActionButtonCallback: this.getUrlForVoucher,
        groupActionButtonCallback: this.getUrlForAllVouchers,
        showgroupActionButton: false,
        title: I18n.t("js.modules.support.return_all_items"),
        singleActionButtonName: I18n.t("js.modules.support.return_item"),
        groupActionButtonName: I18n.t("js.modules.support.return_all_items")
      };
      multipleQtyPopup = new SupportMultipleQtyPopupView(args);
      multipleQtyPopup.render();
    } else {
      openLocation(currentOrder.returnItemUrl);
    }
    return true;
  };

  SupportReturnItemsServiceActionView.prototype.getUrlForAllVouchers = function(order_id) {
    return null;
  };

  SupportReturnItemsServiceActionView.prototype.getUrlForVoucher = function(groupon) {
    return groupon.returnItemUrl;
  };

  SupportReturnItemsServiceActionView.prototype.events = {
    "click #return_item": "actionHandler"
  };

  return SupportReturnItemsServiceActionView;

})(SupportServiceActionsBaseView);

module.exports = SupportReturnItemsServiceActionView;



},{"../../../../service_action_button.html.mustache":231,"../../multiple_Qty_Popup_View":156,"./service_action_base":177}],177:[function(require,module,exports){
var Backbone, SupportServiceActionsBaseView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Backbone = require('backbone');

Backbone.$ = $;

SupportServiceActionsBaseView = (function(superClass) {
  extend(SupportServiceActionsBaseView, superClass);

  function SupportServiceActionsBaseView() {
    return SupportServiceActionsBaseView.__super__.constructor.apply(this, arguments);
  }

  SupportServiceActionsBaseView.prototype.linkIdentifier = function() {
    return 'LINK';
  };

  SupportServiceActionsBaseView.prototype.defaultButtonIdentifier = function() {
    return "DEFAULT_BUTTON";
  };

  SupportServiceActionsBaseView.prototype.secondaryButtonIdentifier = function() {
    return 'SECONDARY_BUTTON';
  };

  SupportServiceActionsBaseView.prototype.setButtonType = function(button_type) {
    return this.button_type = button_type;
  };

  SupportServiceActionsBaseView.prototype.buttonHash = function() {
    switch (this.button_type) {
      case this.linkIdentifier():
        return {
          showLinkCTA: true
        };
      case this.secondaryButtonIdentifier():
        return {
          showSecondaryCTA: true
        };
      default:
        return {
          showDefaultCTA: true
        };
    }
  };

  SupportServiceActionsBaseView.prototype.isSingleGroupon = function() {
    return this.order.groupons.length === 1;
  };

  SupportServiceActionsBaseView.prototype.extendSingleGrouponParams = function(hash) {
    hash.showHyperlink = true;
    return _.extend(hash, {
      grouponId: this.order.groupons[0].id
    });
  };

  SupportServiceActionsBaseView.prototype.extendHash = function(hash) {
    return _.extend(hash, this.buttonHash(), window.getOrderInfoForBH(this.order));
  };

  return SupportServiceActionsBaseView;

})(Backbone.View);

module.exports = SupportServiceActionsBaseView;



},{"backbone":245}],178:[function(require,module,exports){
var SupportServiceActionButtonTemplate, SupportServiceActionsBaseView, SupportTrackOrderServiceActionView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportServiceActionsBaseView = require('./service_action_base');

SupportServiceActionButtonTemplate = require('../../../../service_action_button.html.mustache');

SupportTrackOrderServiceActionView = (function(superClass) {
  extend(SupportTrackOrderServiceActionView, superClass);

  function SupportTrackOrderServiceActionView() {
    return SupportTrackOrderServiceActionView.__super__.constructor.apply(this, arguments);
  }

  SupportTrackOrderServiceActionView.prototype.id = 'track_order';

  SupportTrackOrderServiceActionView.prototype.events = {
    "click #track_order": "actionHandler"
  };

  SupportTrackOrderServiceActionView.prototype.initialize = function() {
    this.I18nScope = 'modules.support';
    this.template = SupportServiceActionButtonTemplate;
    this.order = Groupon.Support.currentOrder;
    return this.voucher = Groupon.Support.currentOrder.groupons[0];
  };

  SupportTrackOrderServiceActionView.prototype.render = function() {
    return this.$el.append(toHtml(this.template, this.toHash(), this.I18nScope));
  };

  SupportTrackOrderServiceActionView.prototype.toHash = function() {
    var hash;
    hash = {
      service_action_id: "track_order",
      service_action: I18n.t("js.modules.support.track_order")
    };
    return this.extendHash(hash);
  };

  SupportTrackOrderServiceActionView.prototype.actionHandler = function(event) {
    var url;
    url = Groupon.Support.currentOrder.trackingUrl;
    return window.open(url, '_newtab');
  };

  return SupportTrackOrderServiceActionView;

})(SupportServiceActionsBaseView);

module.exports = SupportTrackOrderServiceActionView;



},{"../../../../service_action_button.html.mustache":231,"./service_action_base":177}],179:[function(require,module,exports){
var SupportServiceActionButtonTemplate, SupportServiceActionsBaseView, SupportUpdateShippingServiceActionView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportServiceActionsBaseView = require('./service_action_base');

SupportServiceActionButtonTemplate = require('../../../../service_action_button.html.mustache');

SupportUpdateShippingServiceActionView = (function(superClass) {
  extend(SupportUpdateShippingServiceActionView, superClass);

  function SupportUpdateShippingServiceActionView() {
    return SupportUpdateShippingServiceActionView.__super__.constructor.apply(this, arguments);
  }

  SupportUpdateShippingServiceActionView.prototype.id = 'update_shipping';

  SupportUpdateShippingServiceActionView.prototype.initialize = function() {
    _.bindAll.apply(_, [this].concat(_.functions(this)));
    this.I18nScope = 'modules.support';
    this.template = SupportServiceActionButtonTemplate;
    return this.order = Groupon.Support.currentOrder;
  };

  SupportUpdateShippingServiceActionView.prototype.render = function() {
    return this.$el.append(toHtml(this.template, this.toHash(), this.I18nScope));
  };

  SupportUpdateShippingServiceActionView.prototype.toHash = function() {
    var hash;
    hash = {
      service_action_id: "update_shipping",
      service_action: I18n.t("js.modules.support.update_shipping")
    };
    return this.extendHash(hash);
  };

  SupportUpdateShippingServiceActionView.prototype.actionHandler = function(event) {
    var dealPermalink, orderId, url;
    dealPermalink = Groupon.Support.currentOrder.deal.id;
    orderId = Groupon.Support.currentOrder.id;
    url = "/deals/" + dealPermalink + "/confirmation/" + orderId;
    return window.open(url);
  };

  SupportUpdateShippingServiceActionView.prototype.events = {
    "click #update_shipping": "actionHandler"
  };

  return SupportUpdateShippingServiceActionView;

})(SupportServiceActionsBaseView);

module.exports = SupportUpdateShippingServiceActionView;



},{"../../../../service_action_button.html.mustache":231,"./service_action_base":177}],180:[function(require,module,exports){
var SupportServiceActionButtonTemplate, SupportServiceActionsBaseView, SupportViewOrderDetailsServiceActionView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportServiceActionsBaseView = require('./service_action_base');

SupportServiceActionButtonTemplate = require('../../../../service_action_button.html.mustache');

SupportViewOrderDetailsServiceActionView = (function(superClass) {
  extend(SupportViewOrderDetailsServiceActionView, superClass);

  function SupportViewOrderDetailsServiceActionView() {
    return SupportViewOrderDetailsServiceActionView.__super__.constructor.apply(this, arguments);
  }

  SupportViewOrderDetailsServiceActionView.prototype.id = 'view_order_details';

  SupportViewOrderDetailsServiceActionView.prototype.initialize = function() {
    _.bindAll.apply(_, [this].concat(_.functions(this)));
    this.I18nScope = 'modules.support';
    this.template = SupportServiceActionButtonTemplate;
    return this.order = Groupon.Support.currentOrder;
  };

  SupportViewOrderDetailsServiceActionView.prototype.render = function() {
    var hash;
    return hash = this.$el.append(toHtml(this.template, this.toHash(), this.I18nScope));
  };

  SupportViewOrderDetailsServiceActionView.prototype.toHash = function() {
    var hash;
    hash = {
      service_action_id: "view_order_details",
      service_action: I18n.t("js.modules.support.view_details")
    };
    return this.extendHash(hash);
  };

  SupportViewOrderDetailsServiceActionView.prototype.actionHandler = function(event) {
    var url;
    url = "/users/" + currentUser.id + "/hotel_reservations/" + this.order.id;
    return window.open(url);
  };

  SupportViewOrderDetailsServiceActionView.prototype.events = {
    "click #view_order_details": "actionHandler"
  };

  return SupportViewOrderDetailsServiceActionView;

})(SupportServiceActionsBaseView);

module.exports = SupportViewOrderDetailsServiceActionView;



},{"../../../../service_action_button.html.mustache":231,"./service_action_base":177}],181:[function(require,module,exports){
var SupportMultipleQtyPopupView, SupportServiceActionButtonTemplate, SupportServiceActionsBaseView, SupportViewVoucherServiceActionView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportServiceActionsBaseView = require('./service_action_base');

SupportServiceActionButtonTemplate = require('../../../../service_action_button.html.mustache');

SupportMultipleQtyPopupView = require('../../multiple_Qty_Popup_View');

SupportViewVoucherServiceActionView = (function(superClass) {
  extend(SupportViewVoucherServiceActionView, superClass);

  function SupportViewVoucherServiceActionView() {
    return SupportViewVoucherServiceActionView.__super__.constructor.apply(this, arguments);
  }

  SupportViewVoucherServiceActionView.prototype.initialize = function() {
    _.bindAll.apply(_, [this].concat(_.functions(this)));
    this.I18nScope = 'modules.support';
    this.template = SupportServiceActionButtonTemplate;
    return this.order = Groupon.Support.currentOrder;
  };

  SupportViewVoucherServiceActionView.prototype.render = function() {
    this.$el.append(toHtml(this.template, this.toHash(), this.I18nScope));
    if (!this.shouldShowPopup()) {
      return this.addHref(this.getUrlForVoucher(this.order.groupons[0]));
    }
  };

  SupportViewVoucherServiceActionView.prototype.toHash = function() {
    var button_title, hash;
    button_title = this.isSingleGroupon() ? this.getSingleActionTitle() : this.getMultipleItemTitle();
    hash = {
      service_action_id: "view_voucher"
    };
    if (this.isSingleGroupon()) {
      hash.service_action = I18n.t("js.modules.support.view_voucher");
      this.extendSingleGrouponParams(hash);
    } else {
      hash.service_action = I18n.t("js.modules.support.view_vouchers");
    }
    return this.extendHash(hash);
  };

  SupportViewVoucherServiceActionView.prototype.actionHandler = function(event) {
    var args, current_order, multipleQtyPopup;
    current_order = Groupon.Support.currentOrder;
    if (this.shouldShowPopup()) {
      args = {
        orders: this.order,
        serviceActionName: 'view_voucher',
        singleActionButtonCallback: this.getUrlForVoucher,
        groupActionButtonCallback: this.getUrlForAllVouchers,
        showgroupActionButton: !this.isSingleGroupon(),
        title: this.getMultipleItemTitle(),
        singleActionButtonName: this.getSingleActionTitle(),
        groupActionButtonName: this.getGroupActionTitle(),
        showAlertMessage: this.shouldShowAlertMessage(),
        alertMessage: I18n.t("js.modules.support.view_voucher_warning")
      };
      multipleQtyPopup = new SupportMultipleQtyPopupView(args);
      multipleQtyPopup.render();
    }
    return true;
  };

  SupportViewVoucherServiceActionView.prototype.getMultipleItemTitle = function() {
    return I18n.t("js.modules.support.view_vouchers");
  };

  SupportViewVoucherServiceActionView.prototype.getSingleActionTitle = function() {
    return I18n.t("js.modules.support.view_voucher");
  };

  SupportViewVoucherServiceActionView.prototype.getGroupActionTitle = function() {
    return I18n.t("js.modules.support.view_all_vouchers");
  };

  SupportViewVoucherServiceActionView.prototype.shouldShowPopup = function() {
    return (!this.isSingleGroupon()) || this.shouldShowAlertMessage();
  };

  SupportViewVoucherServiceActionView.prototype.shouldShowAlertMessage = function() {
    return this.order && evaluate(this.order.isEditable);
  };

  SupportViewVoucherServiceActionView.prototype.getUrlForAllVouchers = function(order_id) {
    var url;
    url = "/users/" + currentUser.id + "/vouchers/print.pdf?order_id=" + order_id;
    return url;
  };

  SupportViewVoucherServiceActionView.prototype.getUrlForVoucher = function(groupon) {
    var url;
    if (window.isIntl()) {
      url = groupon.voucherUrl;
    } else if (window.isNeedish()) {
      url = groupon.voucherUrl || ("/users/" + currentUser.id + "/vouchers/" + groupon.redemptionCode + ".pdf");
    } else {
      url = "/users/" + currentUser.id + "/vouchers/" + groupon.id + ".pdf";
    }
    return url;
  };

  SupportViewVoucherServiceActionView.prototype.addHref = function(url) {
    return this.$el.find('#view_voucher').attr('href', url);
  };

  SupportViewVoucherServiceActionView.prototype.renderErrorPage = function() {
    return flash('error', "Error when contacting server for Voucher PDF");
  };

  SupportViewVoucherServiceActionView.prototype.events = {
    "click #view_voucher": "actionHandler"
  };

  return SupportViewVoucherServiceActionView;

})(SupportServiceActionsBaseView);

module.exports = SupportViewVoucherServiceActionView;



},{"../../../../service_action_button.html.mustache":231,"../../multiple_Qty_Popup_View":156,"./service_action_base":177}],182:[function(require,module,exports){
var Backbone, SupportHelpWizardController, SupportOrderListViewTemplate, SupportOrderView, SupportPurchaseDateTemplate, SupportV1OrderListView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportOrderView = require('./order_list_element_view');

SupportHelpWizardController = require('../../helpWizardController');

Backbone = require('backbone');

Backbone.$ = $;

SupportOrderListViewTemplate = require('../../../order_list_view.html.mustache');

SupportPurchaseDateTemplate = require('../../../purchase_date.html.mustache');

SupportV1OrderListView = (function(superClass) {
  extend(SupportV1OrderListView, superClass);

  function SupportV1OrderListView() {
    return SupportV1OrderListView.__super__.constructor.apply(this, arguments);
  }

  SupportV1OrderListView.prototype.id = 'orderContent';

  SupportV1OrderListView.prototype.events = {
    "click #purchasedDateSortOrders": "sortAndRender",
    "click #merchantNameSortOrders": "sortAndRender",
    "click .orderTableRow": "clickingItemsTableRow",
    "click #orderNotListed": "orderNotListed",
    "click .ordersRowError": "handleErrorLinkClick"
  };

  SupportV1OrderListView.prototype.initialize = function(options) {
    _.bindAll.apply(_, [this].concat(_.functions(this)));
    this.I18nScope = 'modules.support';
    this.template = SupportOrderListViewTemplate;
    this.purchaseDatetemplate = SupportPurchaseDateTemplate;
    this.currentChosenItemId = 0;
    this.currentCheckedRadioBtnSel = 0;
    this.tableId = '#ordersTable';
    this.itemView = SupportOrderView;
    this.currentOrdersFilter = options.currentOrdersFilter;
    return this.setSortParams();
  };

  SupportV1OrderListView.prototype.setSortParams = function() {
    this.sortParams = {
      sort_attribute: this.currentOrdersFilter.getSortAttribute(),
      sort_order: this.currentOrdersFilter.getSortOrder()
    };
    if (this.sortParams.sort_attribute === 'purchased_at') {
      this.currentSortElementId = 'purchasedDateSortOrders';
    } else {
      this.currentSortElementId = 'merchantNameSortOrders';
    }
    if (this.sortParams.sort_order === 'descending') {
      return this.isDescSortOrder = true;
    } else {
      return this.isDescSortOrder = false;
    }
  };

  SupportV1OrderListView.prototype.resetSortParams = function() {
    if (this.isDescSortOrder) {
      this.sortParams.sort_order = 'descending';
    } else {
      this.sortParams.sort_order = 'ascending';
    }
    if (this.currentSortElementId === 'purchasedDateSortOrders') {
      return this.sortParams.sort_attribute = 'purchased_at';
    } else {
      return this.sortParams.sort_attribute = 'merchant_name';
    }
  };

  SupportV1OrderListView.prototype.setCurrentFilter = function() {
    var filter;
    this.resetSortParams();
    filter = Groupon.Support.OrdersCollection.getFilterInstance(this.sortParams);
    filter.iterator.resetIterator();
    this.currentOrdersFilter = Groupon.Support.currentOrdersFilter = filter;
    return filter;
  };

  SupportV1OrderListView.prototype.render = function() {
    var _scrollLoad, hash;
    this.currentOrdersFilter.iterator.resetIterator();
    hash = {
      enableMerchantNameSortOrders: this.currentSortElementId === 'purchasedDateSortOrders'
    };
    this.$el.html(toHtml(this.template, hash, this.I18nScope));
    _scrollLoad = (function(_this) {
      return function() {
        var $div;
        $div = $("#ordersTablewrapper", _this.$el);
        if (($div[0].scrollHeight - $div.scrollTop()) <= ($div.height() + 40)) {
          if (!_this.currentOrdersFilter.iterator.hasNext()) {
            return;
          }
          return _this.renderOrders();
        }
      };
    })(this);
    $("#ordersTablewrapper", this.$el).scroll(_.debounce(_scrollLoad, 100));
    this.renderOrders();
    return this.delegateEvents();
  };

  SupportV1OrderListView.prototype.renderPurchaseDateView = function(dateStr) {
    var hash;
    hash = {
      purchasedAt: dateStr
    };
    return toHtml(this.purchaseDatetemplate, hash, this.I18nScope);
  };

  SupportV1OrderListView.prototype.renderItems = function(orders) {
    if (this.currentSortElementId === 'purchasedDateSortOrders') {
      return this.renderOrdersGroupedByPurchaseDate(orders);
    } else {
      return this.renderOrdersByMerchantName(orders);
    }
  };

  SupportV1OrderListView.prototype.renderOrdersByMerchantName = function(items) {
    var current, i, itemsTable, len, results;
    if (!((items != null ? items.length : void 0) > 0)) {
      return;
    }
    itemsTable = this.$el.find(this.tableId);
    results = [];
    for (i = 0, len = items.length; i < len; i++) {
      current = items[i];
      if (current) {
        results.push(this.renderSingleItem(current, itemsTable));
      } else {
        results.push(void 0);
      }
    }
    return results;
  };

  SupportV1OrderListView.prototype.renderOrdersGroupedByPurchaseDate = function(orders) {
    var i, itemView, lastRow, len, orderData, ordersTable, results;
    if (!((orders != null ? orders.length : void 0) > 0)) {
      return;
    }
    ordersTable = $(this.el).find(this.tableId);
    results = [];
    for (i = 0, len = orders.length; i < len; i++) {
      orderData = orders[i];
      lastRow = $("tr.orderTableRow[dateStr=\"" + orderData.purchasedAtshortDatetimeStr + "\"]:last-child", this.$el);
      if (lastRow.length > 0) {
        itemView = new this.itemView;
        itemView.renderSingleItem(orderData);
        results.push(lastRow.after(itemView.$el));
      } else {
        ordersTable.append(this.renderPurchaseDateView(orderData.purchasedAtshortDatetimeStr));
        results.push(this.renderSingleItem(orderData, ordersTable));
      }
    }
    return results;
  };

  SupportV1OrderListView.prototype.renderSingleItem = function(orderData, $container) {
    var itemView;
    itemView = new this.itemView;
    itemView.renderSingleItem(orderData);
    return $container.append(itemView.$el);
  };

  SupportV1OrderListView.prototype.sortAndRender = function(e) {
    var currentjQuerySel;
    currentjQuerySel = $(e.currentTarget);
    if (this.currentSortElementId === currentjQuerySel.attr('id')) {
      this.isDescSortOrder = !this.isDescSortOrder;
    } else {
      this.removeDisableClassFromPreviousSortLink();
      this.currentSortElementId = currentjQuerySel.attr('id');
      this.addDisableClassToSortLink(this.currentSortElementId);
      this.setDefaultSortOrder();
    }
    this.setCurrentFilter();
    $(this.el).find(this.tableId).empty();
    return this.renderOrders();
  };

  SupportV1OrderListView.prototype.setDefaultSortOrder = function() {
    if (this.currentSortElementId === 'purchasedDateSortOrders') {
      return this.isDescSortOrder = true;
    } else {
      return this.isDescSortOrder = false;
    }
  };

  SupportV1OrderListView.prototype.removeDisableClassFromPreviousSortLink = function() {
    var ele;
    ele = $('#' + this.currentSortElementId);
    return ele.removeClass("disabledLink");
  };

  SupportV1OrderListView.prototype.addDisableClassToSortLink = function(selectorId) {
    var ele;
    ele = $('#' + selectorId);
    return ele.addClass("disabledLink");
  };

  SupportV1OrderListView.prototype.orderNotListed = function() {
    GIG.Modal.close();
    Groupon.Support.ORDER_NOT_LISTED = true;
    Groupon.Support.NOT_ORDER_RELATED = false;
    SupportHelpWizardController.changeCurrentOrder(null);
    Backbone.history.navigate('#select-issue', {
      trigger: true
    });
    return false;
  };

  SupportV1OrderListView.prototype.finishChoosingItem = function(e) {
    var item;
    GIG.Modal.close();
    if ((this.currentChosenItemId != null) && String(Groupon.Support.currentOrder.id) !== String(this.currentChosenItemId)) {
      item = Groupon.Support.OrdersCollection.findOrderById(this.currentChosenItemId);
      if (item != null) {
        SupportHelpWizardController.stepOne(item);
      }
    }
    return false;
  };

  SupportV1OrderListView.prototype.clickingItemsTableRow = function(e) {
    var ele, radioBtn;
    ele = $(e.currentTarget);
    radioBtn = ele.find('input');
    if (this.currentCheckedRadioBtnSel !== 0) {
      this.currentCheckedRadioBtnSel.prop('checked', false);
    }
    this.currentCheckedRadioBtnSel = radioBtn;
    radioBtn.prop('checked', true);
    this.currentChosenItemId = ele.attr('key');
    this.finishChoosingItem();
    return false;
  };

  SupportV1OrderListView.prototype.handleErrorLinkClick = function() {
    this.currentOrdersFilter.iterator.resetState();
    return this.renderOrders();
  };

  SupportV1OrderListView.prototype.renderOrders = function() {
    var errCb, successCb;
    if (!this.currentOrdersFilter.iterator.hasNext()) {
      return;
    }
    this.removeOrdersFetchError();
    this.renderSpinner();
    successCb = (function(_this) {
      return function(orders) {
        _this.removeSpinner();
        if ((orders != null ? orders.length : void 0) > 0) {
          _this.renderItems(orders);
          return _this.checkIfMinimumOrdersAreShown();
        } else {
          return _this.renderOrders();
        }
      };
    })(this);
    errCb = (function(_this) {
      return function() {
        _this.removeSpinner();
        return _this.renderOrdersFetchError();
      };
    })(this);
    return this.currentOrdersFilter.iterator.next(successCb, errCb);
  };

  SupportV1OrderListView.prototype.checkIfMinimumOrdersAreShown = function() {
    if (!this.currentOrdersFilter.iterator.hasNext()) {
      return;
    }
    if (this.currentOrdersFilter.iterator.getNumberOfOrdersFetched() < this.currentOrdersFilter.iterator.getNumberOfItemPerPage()) {
      return this.renderOrders();
    }
  };

  SupportV1OrderListView.prototype.renderOrdersFetchError = function() {
    var ordersTable;
    this.removeOrdersFetchError();
    ordersTable = $(this.el).find(this.tableId);
    return ordersTable.append(this.errorHtml());
  };

  SupportV1OrderListView.prototype.errorHtml = function() {
    var $ordersRowError;
    $ordersRowError = $('.template-table tr.ordersRowErrorSample', this.$el).clone();
    $ordersRowError.removeClass('ordersRowErrorSample').addClass('ordersRowError');
    return $ordersRowError;
  };

  SupportV1OrderListView.prototype.removeOrdersFetchError = function() {
    return $('.ordersRowError', this.$el).remove();
  };

  SupportV1OrderListView.prototype.renderSpinner = function() {
    var ordersTable;
    this.removeSpinner();
    ordersTable = $(this.el).find(this.tableId);
    return ordersTable.append(this.spinnerHtml());
  };

  SupportV1OrderListView.prototype.spinnerHtml = function() {
    var $div, $ordersRowSpinner;
    $div = $("<div></div>");
    showLoading($div, "50px");
    $ordersRowSpinner = $('.template-table tr.ordersRowSpinnerSample', this.$el).clone();
    $('.content', $ordersRowSpinner).html($div.html());
    $ordersRowSpinner.removeClass('ordersRowSpinnerSample').addClass('ordersRowSpinner');
    return $ordersRowSpinner;
  };

  SupportV1OrderListView.prototype.removeSpinner = function() {
    return $('.ordersRowSpinner', this.$el).remove();
  };

  return SupportV1OrderListView;

})(Backbone.View);

module.exports = SupportV1OrderListView;



},{"../../../order_list_view.html.mustache":225,"../../../purchase_date.html.mustache":229,"../../helpWizardController":50,"./order_list_element_view":163,"backbone":245}],183:[function(require,module,exports){
var Backbone, SupportSelectDifferentOrderMenuTemplate, SupportV1OrderListView, SupportV1SelectDifferentOrderMenuView, SupportbasePopupView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportbasePopupView = require('../base_popup_view');

SupportV1OrderListView = require('./v1_order_list_view');

SupportSelectDifferentOrderMenuTemplate = require('../../../select_different_order_menu.html.mustache');

Backbone = require('backbone');

Backbone.$ = $;

SupportV1SelectDifferentOrderMenuView = (function(superClass) {
  extend(SupportV1SelectDifferentOrderMenuView, superClass);

  function SupportV1SelectDifferentOrderMenuView() {
    return SupportV1SelectDifferentOrderMenuView.__super__.constructor.apply(this, arguments);
  }

  SupportV1SelectDifferentOrderMenuView.prototype.className = 'row';

  SupportV1SelectDifferentOrderMenuView.prototype.initialize = function() {
    var orderListView;
    this.template = SupportSelectDifferentOrderMenuTemplate;
    orderListView = new SupportV1OrderListView({
      currentOrdersFilter: Groupon.Support.currentOrdersFilter
    });
    return this.baseView = new SupportbasePopupView({
      popupView: orderListView
    });
  };

  SupportV1SelectDifferentOrderMenuView.prototype.render = function() {
    return this.$el.append(toHtml(this.template, {
      faqInsteadHelpWizard: window.faqInsteadHelpWizard
    }, this.I18nScope));
  };

  SupportV1SelectDifferentOrderMenuView.prototype.actionHandler = function() {
    return this.baseView.render();
  };

  SupportV1SelectDifferentOrderMenuView.prototype.events = {
    "click #chooseOrder": "actionHandler"
  };

  return SupportV1SelectDifferentOrderMenuView;

})(Backbone.View);

module.exports = SupportV1SelectDifferentOrderMenuView;



},{"../../../select_different_order_menu.html.mustache":230,"../base_popup_view":107,"./v1_order_list_view":182,"backbone":245}],184:[function(require,module,exports){
var SupportCurrentOrderView, SupportServiceActionMainView, SupportV2CurrentOrderView, SupportV2DealSummaryView, SupportV2OrderSummaryView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportV2DealSummaryView = require('./v2_deal_summary_view');

SupportV2OrderSummaryView = require('./v2_order_summary_view');

SupportCurrentOrderView = require('./current_order_view');

SupportServiceActionMainView = require('./service_action_main_view');

SupportV2CurrentOrderView = (function(superClass) {
  extend(SupportV2CurrentOrderView, superClass);

  function SupportV2CurrentOrderView() {
    return SupportV2CurrentOrderView.__super__.constructor.apply(this, arguments);
  }

  SupportV2CurrentOrderView.prototype.createDealSummaryView = function() {
    return this.dealSummary = new SupportV2DealSummaryView();
  };

  SupportV2CurrentOrderView.prototype.createOrderSummaryView = function() {
    return this.orderSummary = new SupportV2OrderSummaryView();
  };

  SupportV2CurrentOrderView.prototype.createServiceActionView = function() {
    return this.serviceActionMain = new SupportServiceActionMainView({
      showLinksAndButtons: true
    });
  };

  SupportV2CurrentOrderView.prototype.render = function() {
    var ref, ref1;
    this.renderSubViews();
    if (((ref = this.serviceActionMain) != null ? (ref1 = ref.serviceActions) != null ? ref1.length : void 0 : void 0) > 0) {
      return this.layoutView();
    } else {
      return SupportCurrentOrderView.prototype.layoutView.call(this);
    }
  };

  SupportV2CurrentOrderView.prototype.layoutView = function() {
    var $defaultServiceActions, $linkServiceActions, $secondaryServiceActions;
    this.dealSummary.$el.addClass('eight columns');
    $('.deal-image', this.dealSummary.$el).addClass('three columns');
    $('.deal-info', this.dealSummary.$el).addClass('nine columns');
    this.orderSummary.$el.addClass('nine columns');
    this.dealSummary.$el.append(this.orderSummary.$el);
    this.$el.append(this.dealSummary.el);
    if (!this.options.hideSelfServiceActions) {
      this.serviceActionMain.$el.addClass('four columns');
      $linkServiceActions = $("." + (this.serviceActionMain.linkIdentifier()), this.serviceActionMain.el).detach();
      $defaultServiceActions = $("." + (this.serviceActionMain.defaultButtonIdentifier()), this.serviceActionMain.el);
      $secondaryServiceActions = $("." + (this.serviceActionMain.secondaryButtonIdentifier()), this.serviceActionMain.el);
      if ($defaultServiceActions.length > 0 || $secondaryServiceActions.length > 0) {
        this.$el.append(this.serviceActionMain.el);
      }
      if ($linkServiceActions.length > 0) {
        return $('.deal-image', this.dealSummary.$el).append($linkServiceActions);
      }
    }
  };

  return SupportV2CurrentOrderView;

})(SupportCurrentOrderView);

module.exports = SupportV2CurrentOrderView;



},{"./current_order_view":157,"./service_action_main_view":166,"./v2_deal_summary_view":185,"./v2_order_summary_view":187}],185:[function(require,module,exports){
var SupportDealSummaryView, SupportV2DealSummaryView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportDealSummaryView = require('./deal_summary_view');

SupportV2DealSummaryView = (function(superClass) {
  extend(SupportV2DealSummaryView, superClass);

  function SupportV2DealSummaryView() {
    return SupportV2DealSummaryView.__super__.constructor.apply(this, arguments);
  }

  SupportV2DealSummaryView.prototype.toDealHash = function() {
    var dealHash;
    dealHash = SupportDealSummaryView.prototype.toDealHash.call(this);
    dealHash.purchasedAt = this.orderPresenter.getpurchasedAt();
    dealHash.qty = this.orderPresenter.getOrderQuantity();
    dealHash.isV2 = true;
    return dealHash;
  };

  return SupportV2DealSummaryView;

})(SupportDealSummaryView);

module.exports = SupportV2DealSummaryView;



},{"./deal_summary_view":158}],186:[function(require,module,exports){
var Backbone, SupportHelpWizardController, SupportOrderListViewTemplate, SupportOrderView, SupportStepActionsView, SupportStepOneActionsTemplate, SupportV2OrderListView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportOrderView = require('./order_list_element_view');

SupportStepActionsView = require('../step_actions_view');

SupportHelpWizardController = require('../../helpWizardController');

SupportOrderListViewTemplate = require('../../../order_list_view.html.mustache');

Backbone = require('backbone');

Backbone.$ = $;

SupportStepOneActionsTemplate = require('../../../step_one_actions.html.mustache');

SupportV2OrderListView = (function(superClass) {
  extend(SupportV2OrderListView, superClass);

  function SupportV2OrderListView() {
    return SupportV2OrderListView.__super__.constructor.apply(this, arguments);
  }

  SupportV2OrderListView.prototype.id = 'orderContent';

  SupportV2OrderListView.prototype.events = {
    "click #select-current-order": "finishChoosingItem",
    "click .orderTableRow td.order-data-cell": "clickingItemsTableRow",
    "click .ordersRowError": "handleErrorLinkClick"
  };

  SupportV2OrderListView.prototype.initialize = function(options) {
    _.bindAll.apply(_, [this].concat(_.functions(this)));
    this.I18nScope = 'modules.support';
    this.template = SupportOrderListViewTemplate;
    this.currentChosenItemId = 0;
    this.currentCheckedRadioBtnSel = 0;
    this.tableId = '#ordersTable';
    this.itemView = SupportOrderView;
    this.currentOrdersFilter = options.currentOrdersFilter;
    this.stepActionsView = new SupportStepActionsView({
      template: SupportStepOneActionsTemplate
    });
    return this.itemsPerRow = 2;
  };

  SupportV2OrderListView.prototype.render = function() {
    var _scrollLoad;
    this.currentOrdersFilter.iterator.resetIterator();
    this.$el.html(toHtml(this.template, this.toHash(), this.I18nScope));
    this.renderStepActions();
    _scrollLoad = (function(_this) {
      return function() {
        var $div;
        $div = $("#ordersTablewrapper", _this.$el);
        if (($div[0].scrollHeight - $div.scrollTop()) <= ($div.height() + 100)) {
          if (!_this.currentOrdersFilter.iterator.hasNext()) {
            return;
          }
          return _this.renderOrders();
        }
      };
    })(this);
    $("#ordersTablewrapper", this.$el).scroll(_scrollLoad);
    this.renderOrders();
    return this.delegateEvents();
  };

  SupportV2OrderListView.prototype.toHash = function() {
    return {
      isV2: true
    };
  };

  SupportV2OrderListView.prototype.renderItems = function(items) {
    var emptyTds, index, itemsTable, itemviewObj, lastRow, noOfEmptyTds, noOfOrderTds, orders, results, singletonItemviewObj;
    if (!((items != null ? items.length : void 0) > 0)) {
      return;
    }
    itemsTable = this.$el.find(this.tableId);
    singletonItemviewObj = new this.itemView;
    emptyTds = $('tr.orderTableRow:last-child td.empty-data-cell', itemsTable);
    noOfEmptyTds = emptyTds.length;
    index = 0;
    while (index < noOfEmptyTds) {
      singletonItemviewObj.replaceEmptyTemplateWithOrderTemplate($(emptyTds[index]), items[index]);
      index++;
    }
    while (index < items.length) {
      orders = items.slice(index, index + this.itemsPerRow);
      itemviewObj = new this.itemView;
      itemviewObj.renderMultipleItems(orders);
      itemsTable.append(itemviewObj.$el);
      index = index + this.itemsPerRow;
    }
    lastRow = $('tr.orderTableRow:last-child', itemsTable);
    noOfOrderTds = $('td.order-data-cell', lastRow).length;
    results = [];
    while (noOfOrderTds > 0 && noOfOrderTds < this.itemsPerRow) {
      lastRow.append(singletonItemviewObj.renderEmptyTemplate());
      results.push(noOfOrderTds++);
    }
    return results;
  };

  SupportV2OrderListView.prototype.finishChoosingItem = function(e) {
    var item;
    if (this.currentChosenItemId != null) {
      item = Groupon.Support.OrdersCollection.findOrderById(this.currentChosenItemId);
      if (item != null) {
        SupportHelpWizardController.stepOne(item);
      }
    }
    return false;
  };

  SupportV2OrderListView.prototype.enableSelectOrder = function() {
    if (this.currentChosenItemId != null) {
      return $("#select-current-order", this.stepActionsView.el).removeAttr('disabled');
    }
  };

  SupportV2OrderListView.prototype.clickingItemsTableRow = function(e) {
    var $oldTd, $td, radioBtn;
    $td = $(e.currentTarget);
    radioBtn = $td.find('input');
    if (this.currentCheckedRadioBtnSel.length > 0) {
      this.currentCheckedRadioBtnSel.prop('checked', false);
      $oldTd = this.currentCheckedRadioBtnSel.closest('td.order-data-cell');
      $oldTd.removeClass('selected');
    }
    this.currentCheckedRadioBtnSel = radioBtn;
    radioBtn.prop('checked', true);
    $td.addClass('selected');
    this.currentChosenItemId = $td.attr('key');
    this.enableSelectOrder();
    return true;
  };

  SupportV2OrderListView.prototype.handleErrorLinkClick = function() {
    this.currentOrdersFilter.iterator.resetState();
    return this.renderOrders();
  };

  SupportV2OrderListView.prototype.renderOrders = function() {
    var errCb, successCb;
    if (!this.currentOrdersFilter.iterator.hasNext()) {
      return;
    }
    this.removeOrdersFetchError();
    this.renderSpinner();
    successCb = (function(_this) {
      return function(orders) {
        _this.removeSpinner();
        if ((orders != null ? orders.length : void 0) > 0) {
          _this.renderItems(orders);
          return _this.checkIfMinimumOrdersAreShown();
        } else {
          return _this.renderOrders();
        }
      };
    })(this);
    errCb = (function(_this) {
      return function() {
        _this.removeSpinner();
        return _this.renderOrdersFetchError();
      };
    })(this);
    return this.currentOrdersFilter.iterator.next(successCb, errCb);
  };

  SupportV2OrderListView.prototype.checkIfMinimumOrdersAreShown = function() {
    if (!this.currentOrdersFilter.iterator.hasNext()) {
      return;
    }
    if (this.currentOrdersFilter.iterator.getNumberOfOrdersFetched() < this.currentOrdersFilter.iterator.getNumberOfItemPerPage()) {
      return this.renderOrders();
    }
  };

  SupportV2OrderListView.prototype.renderOrdersFetchError = function() {
    var ordersTable;
    this.removeOrdersFetchError();
    ordersTable = $(this.el).find(this.tableId);
    return ordersTable.append(this.errorHtml());
  };

  SupportV2OrderListView.prototype.errorHtml = function() {
    var $ordersRowError;
    $ordersRowError = $('.template-table tr.ordersRowErrorSample', this.$el).clone();
    $ordersRowError.removeClass('ordersRowErrorSample').addClass('ordersRowError');
    return $ordersRowError;
  };

  SupportV2OrderListView.prototype.removeOrdersFetchError = function() {
    return $('.ordersRowError', this.$el).remove();
  };

  SupportV2OrderListView.prototype.renderSpinner = function() {
    var ordersTable;
    this.removeSpinner();
    ordersTable = this.$el.find(this.tableId);
    return ordersTable.append(this.spinnerHtml());
  };

  SupportV2OrderListView.prototype.spinnerHtml = function() {
    var $div, $ordersRowSpinner;
    $div = $("<div></div>");
    showLoading($div, "50px");
    $ordersRowSpinner = $('.template-table tr.ordersRowSpinnerSample', this.$el).clone();
    $('.content', $ordersRowSpinner).html($div.html());
    $ordersRowSpinner.removeClass('ordersRowSpinnerSample').addClass('ordersRowSpinner');
    return $ordersRowSpinner;
  };

  SupportV2OrderListView.prototype.removeSpinner = function() {
    return $('.ordersRowSpinner', this.$el).remove();
  };

  SupportV2OrderListView.prototype.renderStepActions = function() {
    this.stepActionsView.render();
    return this.$el.append(this.stepActionsView.el);
  };

  SupportV2OrderListView.prototype.removeView = function() {
    this.remove();
    this.$el.empty();
    this.stepActionsView.remove();
    return this.stepActionsView.$el.empty();
  };

  return SupportV2OrderListView;

})(Backbone.View);

module.exports = SupportV2OrderListView;



},{"../../../order_list_view.html.mustache":225,"../../../step_one_actions.html.mustache":232,"../../helpWizardController":50,"../step_actions_view":194,"./order_list_element_view":163,"backbone":245}],187:[function(require,module,exports){
var SupportOrderSummaryView, SupportV2OrderSummaryView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportOrderSummaryView = require('./order_summary_view');

SupportV2OrderSummaryView = (function(superClass) {
  extend(SupportV2OrderSummaryView, superClass);

  function SupportV2OrderSummaryView() {
    return SupportV2OrderSummaryView.__super__.constructor.apply(this, arguments);
  }

  SupportV2OrderSummaryView.prototype.buildOrderSummaryParams = function() {
    var orderSummaryParams;
    orderSummaryParams = SupportOrderSummaryView.prototype.buildOrderSummaryParams.call(this);
    orderSummaryParams.isV2 = true;
    return orderSummaryParams;
  };

  return SupportV2OrderSummaryView;

})(SupportOrderSummaryView);

module.exports = SupportV2OrderSummaryView;



},{"./order_summary_view":164}],188:[function(require,module,exports){
var Backbone, SupportHelpWizardController, SupportSelectDifferentOrderMenuTemplate, SupportV2OrderListView, SupportV2SelectDifferentOrderMenuView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportV2OrderListView = require('./v2_order_list_view.coffee');

SupportSelectDifferentOrderMenuTemplate = require('../../../select_different_order_menu.html.mustache');

Backbone = require('backbone');

Backbone.$ = $;

SupportHelpWizardController = require('../../helpWizardController');

SupportV2SelectDifferentOrderMenuView = (function(superClass) {
  extend(SupportV2SelectDifferentOrderMenuView, superClass);

  function SupportV2SelectDifferentOrderMenuView() {
    return SupportV2SelectDifferentOrderMenuView.__super__.constructor.apply(this, arguments);
  }

  SupportV2SelectDifferentOrderMenuView.prototype.className = 'row select-order-menu';

  SupportV2SelectDifferentOrderMenuView.prototype.events = {
    "click #purchasedDateSortOrders": "sortAndRender",
    "click #merchantNameSortOrders": "sortAndRender",
    "click #chooseOrder": "chooseDifferentOrder"
  };

  SupportV2SelectDifferentOrderMenuView.prototype.initialize = function() {
    this.setSortParams();
    this.template = SupportSelectDifferentOrderMenuTemplate;
    return this.orderListView = new SupportV2OrderListView({
      currentOrdersFilter: this.currentOrdersFilter
    });
  };

  SupportV2SelectDifferentOrderMenuView.prototype.setSortParams = function() {
    this.currentOrdersFilter = Groupon.Support.currentOrdersFilter;
    this.sortParams = {
      sort_attribute: this.currentOrdersFilter.getSortAttribute(),
      sort_order: this.currentOrdersFilter.getSortOrder()
    };
    if (this.sortParams.sort_attribute === 'purchased_at') {
      this.currentSortElementId = 'purchasedDateSortOrders';
    } else {
      this.currentSortElementId = 'merchantNameSortOrders';
    }
    if (this.sortParams.sort_order === 'descending') {
      return this.isDescSortOrder = true;
    } else {
      return this.isDescSortOrder = false;
    }
  };

  SupportV2SelectDifferentOrderMenuView.prototype.resetSortParams = function() {
    if (this.isDescSortOrder) {
      this.sortParams.sort_order = 'descending';
    } else {
      this.sortParams.sort_order = 'ascending';
    }
    if (this.currentSortElementId === 'purchasedDateSortOrders') {
      return this.sortParams.sort_attribute = 'purchased_at';
    } else {
      return this.sortParams.sort_attribute = 'merchant_name';
    }
  };

  SupportV2SelectDifferentOrderMenuView.prototype.renderOrderListing = function() {
    this.$el.html(toHtml(this.template, this.toListingHash(), this.I18nScope));
    this.renderOrders();
    return this.delegateEvents();
  };

  SupportV2SelectDifferentOrderMenuView.prototype.renderDetails = function() {
    this.$el.html(toHtml(this.template, this.toDetailHash(), this.I18nScope));
    return this.delegateEvents();
  };

  SupportV2SelectDifferentOrderMenuView.prototype.renderOrders = function() {
    this.orderListView.removeView();
    this.orderListView.currentOrdersFilter = this.currentOrdersFilter;
    this.orderListView.render();
    return this.$el.find('.order-listing').html(this.orderListView.el);
  };

  SupportV2SelectDifferentOrderMenuView.prototype.toListingHash = function() {
    return {
      enableMerchantNameSortOrders: this.currentSortElementId === 'purchasedDateSortOrders',
      isV2: true,
      isOrderListing: true
    };
  };

  SupportV2SelectDifferentOrderMenuView.prototype.toDetailHash = function() {
    return {
      isV2: true,
      isOrderdetails: true
    };
  };

  SupportV2SelectDifferentOrderMenuView.prototype.toSignInHash = function() {
    return {
      isV2: true,
      showSignIn: true
    };
  };

  SupportV2SelectDifferentOrderMenuView.prototype.setCurrentFilter = function() {
    var filter;
    this.resetSortParams();
    filter = Groupon.Support.OrdersCollection.getFilterInstance(this.sortParams);
    filter.iterator.resetIterator();
    this.currentOrdersFilter = Groupon.Support.currentOrdersFilter = filter;
    return filter;
  };

  SupportV2SelectDifferentOrderMenuView.prototype.sortAndRender = function(e) {
    var currentjQuerySel;
    currentjQuerySel = $(e.currentTarget);
    if (this.currentSortElementId === currentjQuerySel.attr('id')) {
      this.isDescSortOrder = !this.isDescSortOrder;
    } else {
      this.removeDisableClassFromPreviousSortLink();
      this.currentSortElementId = currentjQuerySel.attr('id');
      this.addDisableClassToSortLink(this.currentSortElementId);
      this.setDefaultSortOrder();
    }
    this.setCurrentFilter();
    return this.renderOrders();
  };

  SupportV2SelectDifferentOrderMenuView.prototype.setDefaultSortOrder = function() {
    if (this.currentSortElementId === 'purchasedDateSortOrders') {
      return this.isDescSortOrder = true;
    } else {
      return this.isDescSortOrder = false;
    }
  };

  SupportV2SelectDifferentOrderMenuView.prototype.removeDisableClassFromPreviousSortLink = function() {
    var ele;
    ele = $('#' + this.currentSortElementId);
    return ele.removeClass("disabledLink");
  };

  SupportV2SelectDifferentOrderMenuView.prototype.addDisableClassToSortLink = function(selectorId) {
    var ele;
    ele = $('#' + selectorId);
    return ele.addClass("disabledLink");
  };

  SupportV2SelectDifferentOrderMenuView.prototype.chooseDifferentOrder = function() {
    SupportHelpWizardController.changeCurrentOrder(null);
    return SupportHelpWizardController.initOrdersFetch();
  };

  return SupportV2SelectDifferentOrderMenuView;

})(Backbone.View);

module.exports = SupportV2SelectDifferentOrderMenuView;



},{"../../../select_different_order_menu.html.mustache":230,"../../helpWizardController":50,"./v2_order_list_view.coffee":186,"backbone":245}],189:[function(require,module,exports){
var SupportServiceActionMainView, SupportV2CurrentOrderView, SupportVerticalCurrentOrderView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportV2CurrentOrderView = require('./v2_current_order_view');

SupportServiceActionMainView = require('./service_action_main_view');

SupportVerticalCurrentOrderView = (function(superClass) {
  extend(SupportVerticalCurrentOrderView, superClass);

  function SupportVerticalCurrentOrderView() {
    return SupportVerticalCurrentOrderView.__super__.constructor.apply(this, arguments);
  }

  SupportVerticalCurrentOrderView.prototype.createServiceActionView = function() {
    return this.serviceActionMain = new SupportServiceActionMainView({
      showOnlyLinks: true
    });
  };

  SupportVerticalCurrentOrderView.prototype.layoutView = function() {
    this.orderSummary.$el.addClass('four columns');
    this.dealSummary.$el.addClass('five columns');
    $('.deal-image', this.dealSummary.$el).addClass('four columns');
    $('.deal-info', this.dealSummary.$el).addClass('eight columns');
    this.$el.append(this.dealSummary.el);
    this.$el.append(this.orderSummary.el);
    if (!this.options.hideSelfServiceActions) {
      this.serviceActionMain.$el.addClass('three columns divider');
      return this.$el.append(this.serviceActionMain.el);
    }
  };

  return SupportVerticalCurrentOrderView;

})(SupportV2CurrentOrderView);

module.exports = SupportVerticalCurrentOrderView;



},{"./service_action_main_view":166,"./v2_current_order_view":184}],190:[function(require,module,exports){
var SupportV2SelectDifferentOrderMenuView, SupportVerticalSelectDifferentOrderMenuView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportV2SelectDifferentOrderMenuView = require('./v2_select_different_order_menu_view');

SupportVerticalSelectDifferentOrderMenuView = (function(superClass) {
  extend(SupportVerticalSelectDifferentOrderMenuView, superClass);

  function SupportVerticalSelectDifferentOrderMenuView() {
    return SupportVerticalSelectDifferentOrderMenuView.__super__.constructor.apply(this, arguments);
  }

  SupportVerticalSelectDifferentOrderMenuView.prototype.toDetailHash = function() {
    var hash;
    hash = SupportV2SelectDifferentOrderMenuView.prototype.toDetailHash.call(this);
    hash.showVerticalView = true;
    return hash;
  };

  return SupportVerticalSelectDifferentOrderMenuView;

})(SupportV2SelectDifferentOrderMenuView);

module.exports = SupportVerticalSelectDifferentOrderMenuView;



},{"./v2_select_different_order_menu_view":188}],191:[function(require,module,exports){
var Backbone, SharedWidgetLayoutView, SupportProblemSolvedTemplate, SupportProblemSolvedView, SupportProgressBarView, SupportUtilsHelper,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportProgressBarView = require('./progress_bar_view');

SharedWidgetLayoutView = require('../../../shared/frontend/views/widget_layout_veiw');

SupportUtilsHelper = require('../helpers/utils');

Backbone = require('backbone');

Backbone.$ = $;

SupportProblemSolvedTemplate = require('../../problem_solved.html.mustache');

SupportProblemSolvedView = (function(superClass) {
  extend(SupportProblemSolvedView, superClass);

  function SupportProblemSolvedView() {
    return SupportProblemSolvedView.__super__.constructor.apply(this, arguments);
  }

  SupportProblemSolvedView.prototype.className = 'problem-solved';

  SupportProblemSolvedView.prototype.initialize = function(options) {
    this.options = options || {};
    this.I18nScope = 'modules.support';
    this.template = SupportProblemSolvedTemplate;
    return this.id = 'problem-solved';
  };

  SupportProblemSolvedView.prototype.events = {
    'click .contact-us-from-problem-solved': 'renderStepThree',
    'click #needHelpAgain': 'renderStepTwo'
  };

  SupportProblemSolvedView.prototype.render = function() {
    this.$el.append(toHtml(this.template, this.toHash(this.options), this.I18nScope));
    this.hideComponents();
    return this.showComponents();
  };

  SupportProblemSolvedView.prototype.renderStepThree = function() {
    return propagateEventBeforeReplacingElements(function() {
      return Backbone.history.navigate('#contact-us', {
        trigger: true
      });
    });
  };

  SupportProblemSolvedView.prototype.renderStepTwo = function() {
    $('.step-container', '#v2_other').empty();
    $('.vertical-container').show();
    SharedWidgetLayoutView.hideWidgets();
    return propagateEventBeforeReplacingElements(function() {
      return Backbone.history.navigate('#select-issue', {
        trigger: false
      });
    });
  };

  SupportProblemSolvedView.prototype.toHash = function(options) {
    if (options == null) {
      options = {};
    }
    return options;
  };

  SupportProblemSolvedView.prototype.hideComponents = function() {
    return SupportUtilsHelper.hideFloatingBoldChat();
  };

  SupportProblemSolvedView.prototype.showComponents = function() {
    return SharedWidgetLayoutView.showWidgets('problem-solved');
  };

  SupportProblemSolvedView.prototype.close = function() {};

  return SupportProblemSolvedView;

})(Backbone.View);

module.exports = SupportProblemSolvedView;



},{"../../../shared/frontend/views/widget_layout_veiw":25,"../../problem_solved.html.mustache":228,"../helpers/utils":54,"./progress_bar_view":192,"backbone":245}],192:[function(require,module,exports){
var Backbone, SupportProgressBarView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Backbone = require('backbone');

Backbone.$ = $;

SupportProgressBarView = (function(superClass) {
  extend(SupportProgressBarView, superClass);

  function SupportProgressBarView() {
    return SupportProgressBarView.__super__.constructor.apply(this, arguments);
  }

  SupportProgressBarView.prototype.tagName = 'ol';

  SupportProgressBarView.prototype.className = 'steps';

  SupportProgressBarView.prototype.initialize = function() {
    return this.I18nScope = 'modules.support';
  };

  SupportProgressBarView.prototype.render = function() {
    var results, x;
    x = 1;
    if (Groupon.Support.MAXINDEX === void 0) {
      Groupon.Support.MAXINDEX = 0;
    }
    results = [];
    while (!(x > Groupon.Support.MAXINDEX)) {
      if (x <= Groupon.Support.CURRENTVIEW.id) {
        this.$el.append("<li class='active'><a class = 'progressBar' href='javascript:;'>" + x + "</a></li>");
      } else {
        this.$el.append("<li><a class = 'progressBar' href='javascript:;'>" + x + "</a></li>");
      }
      results.push(++x);
    }
    return results;
  };

  return SupportProgressBarView;

})(Backbone.View);

module.exports = SupportProgressBarView;



},{"backbone":245}],193:[function(require,module,exports){
var Backbone, StepTwoSearchBoxTemplate, SupportSearchInputView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Backbone = require('backbone');

Backbone.$ = $;

StepTwoSearchBoxTemplate = require('../../step_two_search_box.html.mustache');

SupportSearchInputView = (function(superClass) {
  extend(SupportSearchInputView, superClass);

  function SupportSearchInputView() {
    return SupportSearchInputView.__super__.constructor.apply(this, arguments);
  }

  SupportSearchInputView.prototype.template = StepTwoSearchBoxTemplate;

  SupportSearchInputView.prototype.initialize = function() {
    return this.I18nScope = 'modules.support';
  };

  SupportSearchInputView.prototype.render = function() {
    return this.$el.append(toHtml(this.template, this.toHash(), this.I18nScope));
  };

  SupportSearchInputView.prototype.toHash = function() {
    return {
      searchInputDefaultText: I18n.t("js.modules.support.search_input_default_text")
    };
  };

  return SupportSearchInputView;

})(Backbone.View);

module.exports = SupportSearchInputView;



},{"../../step_two_search_box.html.mustache":236,"backbone":245}],194:[function(require,module,exports){
var Backbone, SupportHelpWizardController, SupportStepActionsView, getTrackingHubData,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportHelpWizardController = require('../helpWizardController');

Backbone = require('backbone');

Backbone.$ = $;

SupportStepActionsView = (function(superClass) {
  extend(SupportStepActionsView, superClass);

  function SupportStepActionsView() {
    return SupportStepActionsView.__super__.constructor.apply(this, arguments);
  }

  SupportStepActionsView.prototype.className = 'row step-actions';

  SupportStepActionsView.prototype.initialize = function(options) {
    this.options = options || {};
    this.template = this.options.template;
    this.I18nScope = 'modules.support';
    return this.model = Groupon.Support.stepActionModel;
  };

  SupportStepActionsView.prototype.events = {
    'click #continue-with-order': 'continueWithOrder',
    'click #not-order-related': 'notOrderRelated',
    'click .back': 'goToPreviousStep',
    'click #problem-solved': 'renderProblemSolved',
    'click #contact-us': 'contactUs',
    'click #request-refund': 'continueToTicket',
    'click #continueToTicket': 'continueToTicket',
    "click #orderNotListed": "orderNotListed",
    "click #chooseOrder": "chooseDifferentOrder",
    'click #otherContactChannel': 'chooseDifferentContactChannel'
  };

  SupportStepActionsView.prototype.render = function() {
    this.$el.append(toHtml(this.template, this.model.toHash(), this.I18nScope));
    return this.delegateEvents();
  };

  SupportStepActionsView.prototype.continueWithOrder = function() {
    $("#continue-with-order").hide();
    Groupon.Support.NOT_ORDER_RELATED = false;
    return propagateEventBeforeReplacingElements(function() {
      return Backbone.history.navigate("#select-issue", {
        trigger: true
      });
    });
  };

  SupportStepActionsView.prototype.contactUs = function() {
    var data;
    data = getTrackingHubData();
    TrackingHub.add("still-need-help", {
      stillNeedHelp: data
    });
    return propagateEventBeforeReplacingElements(function() {
      return Backbone.history.navigate('#contact-us', {
        trigger: true
      });
    });
  };

  SupportStepActionsView.prototype.continueToTicket = function() {
    var data;
    data = getTrackingHubData();
    TrackingHub.add("continue-to-ticket", {
      continueToTicket: data
    });
    return propagateEventBeforeReplacingElements(function() {
      this.$('.refund-my-request').hide();
      return Backbone.history.navigate('#contact-us', {
        trigger: true
      });
    });
  };

  SupportStepActionsView.prototype.renderProblemSolved = function() {
    var data;
    data = getTrackingHubData();
    TrackingHub.add("problem-solved", {
      problemSolved: data
    });
    return propagateEventBeforeReplacingElements(function() {
      return Backbone.history.navigate('#problem-solved', {
        trigger: true
      });
    });
  };

  SupportStepActionsView.prototype.notOrderRelated = function() {
    var data;
    Groupon.Support.NOT_ORDER_RELATED = true;
    data = {
      permalink: window.currentUser != null ? window.currentUser.id : "anonymous"
    };
    TrackingHub.add("order-not-related", {
      orderNotRelated: data
    });
    return propagateEventBeforeReplacingElements(function() {
      SupportHelpWizardController.changeCurrentOrder(null);
      return Backbone.history.navigate("#select-issue", {
        trigger: true
      });
    });
  };

  SupportStepActionsView.prototype.orderNotListed = function() {
    Groupon.Support.ORDER_NOT_LISTED = true;
    Groupon.Support.NOT_ORDER_RELATED = false;
    SupportHelpWizardController.changeCurrentOrder(null);
    Backbone.history.navigate('#select-issue', {
      trigger: true
    });
    return false;
  };

  SupportStepActionsView.prototype.chooseDifferentContactChannel = function() {
    return SupportHelpWizardController.stepThree();
  };

  SupportStepActionsView.prototype.chooseDifferentOrder = function() {
    SupportHelpWizardController.changeCurrentOrder(null);
    return SupportHelpWizardController.initOrdersFetch();
  };

  SupportStepActionsView.prototype.goToPreviousStep = function() {
    var index;
    if (Groupon.Support.MAXINDEX === 3) {
      index = Groupon.Support.CURRENTVIEW.id;
    } else {
      index = Groupon.Support.CURRENTVIEW.id + 1;
    }
    switch (index) {
      case 3:
        return propagateEventBeforeReplacingElements(function() {
          return Backbone.history.navigate('#select-issue', {
            trigger: true
          });
        });
      case 2:
        return propagateEventBeforeReplacingElements(function() {
          window.selectOrderFromMygroupons = false;
          return Backbone.history.navigate('#pick-order', {
            trigger: true
          });
        });
    }
  };

  return SupportStepActionsView;

})(Backbone.View);

getTrackingHubData = function() {
  var ref, ref1;
  return {
    category: (ref = Groupon.Support.ContentModel.getCategory()) != null ? ref.id : void 0,
    subCategory: (ref1 = Groupon.Support.ContentModel.getSubCategory()) != null ? ref1.id : void 0,
    permalink: window.currentUser != null ? window.currentUser.id : "anonymous"
  };
};

module.exports = SupportStepActionsView;



},{"../helpWizardController":50,"backbone":245}],195:[function(require,module,exports){
var Backbone, SharedWidgetLayoutView, SupportCurrentOrderView, SupportHelpWizardController, SupportMainContentWrapperView, SupportProgressBarView, SupportStepActionsView, SupportStepOneActionsTemplate, SupportUtilsHelper, SupportV1SelectDifferentOrderMenuView, SupportV1StepOneView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportProgressBarView = require('../progress_bar_view');

SupportV1SelectDifferentOrderMenuView = require('../order_related/v1_select_different_order_menu_view');

SupportCurrentOrderView = require('../order_related/current_order_view');

SupportMainContentWrapperView = require('../main_content_view');

SupportStepActionsView = require('../step_actions_view');

SupportUtilsHelper = require('../../helpers/utils');

SharedWidgetLayoutView = require('../../../../shared/frontend/views/widget_layout_veiw');

SupportHelpWizardController = require('../../helpWizardController');

Backbone = require('backbone');

Backbone.$ = $;

SupportStepOneActionsTemplate = require('../../../step_one_actions.html.mustache');

SupportV1StepOneView = (function(superClass) {
  extend(SupportV1StepOneView, superClass);

  function SupportV1StepOneView() {
    return SupportV1StepOneView.__super__.constructor.apply(this, arguments);
  }

  SupportV1StepOneView.prototype.className = 'v1 step-one';

  SupportV1StepOneView.prototype.initialize = function() {
    this.id = 1;
    this.I18nScope = 'modules.support';
    Groupon.Support.Email = {};
    this.progressBar = new SupportProgressBarView;
    this.selectDifferentOrderMenu = new SupportV1SelectDifferentOrderMenuView;
    this.currentOrder = new SupportCurrentOrderView;
    this.stepActions = new SupportStepActionsView({
      template: SupportStepOneActionsTemplate
    });
    return this.mainContentWrappper = new SupportMainContentWrapperView;
  };

  SupportV1StepOneView.prototype.resetContentModelParams = function() {
    if (Groupon.Support.ContentModel != null) {
      Groupon.Support.ContentModel.escalateToMerchant = false;
      return Groupon.Support.ContentModel.isRefundEligible = false;
    }
  };

  SupportV1StepOneView.prototype.renderOrderDetails = function() {
    window.hideFooterLinks();
    this.resetContentModelParams();
    this.mainContentWrappper.render((function(_this) {
      return function(contentWrapper) {
        _this.renderProgressBar(contentWrapper);
        _this.renderSelectDifferentOrderMenu(contentWrapper);
        return _this.renderCurrentOrder(contentWrapper);
      };
    })(this));
    this.$el.html(this.mainContentWrappper.el);
    this.renderStepActions();
    return this.hideComponents();
  };

  SupportV1StepOneView.prototype.renderProgressBar = function(contentWrapper) {
    this.progressBar.render();
    contentWrapper.append(this.progressBar.el);
    return contentWrapper.append("<br>");
  };

  SupportV1StepOneView.prototype.renderSelectDifferentOrderMenu = function(contentWrapper) {
    this.selectDifferentOrderMenu.render();
    return contentWrapper.append(this.selectDifferentOrderMenu.el);
  };

  SupportV1StepOneView.prototype.renderCurrentOrder = function(contentWrapper) {
    this.currentOrder.render();
    return contentWrapper.append(this.currentOrder.el);
  };

  SupportV1StepOneView.prototype.renderStepActions = function() {
    this.stepActions.render();
    return this.$el.append(this.stepActions.el);
  };

  SupportV1StepOneView.prototype.hideComponents = function() {
    SupportUtilsHelper.hideFloatingBoldChat();
    return SharedWidgetLayoutView.hideWidgets();
  };

  SupportV1StepOneView.prototype.close = function() {
    return this.$el.empty();
  };

  SupportV1StepOneView.prototype.render = function(params) {
    var order, orderSummary;
    if (params == null) {
      params = {};
    }
    order = params.order;
    showLoading(this.$el);
    if (!Groupon.Support.OrdersCollection.hasOrders()) {
      return this.initOrdersFetch();
    } else if (order) {
      return this.getOrderDetails(order);
    } else {
      orderSummary = Groupon.Support.currentOrdersFilter.getFirstOrder();
      return this.getOrderDetails(orderSummary);
    }
  };

  SupportV1StepOneView.prototype.initOrdersFetch = function() {
    var _errorCb, _successCb;
    _successCb = (function(_this) {
      return function(orders) {
        return _this.myGrouponSuccessCallback(orders);
      };
    })(this);
    _errorCb = (function(_this) {
      return function() {
        return _this.loadOrderErrorCallback();
      };
    })(this);
    if (Groupon.Support.currentOrdersFilter.iterator.hasNext()) {
      return Groupon.Support.currentOrdersFilter.iterator.next(_successCb, _errorCb);
    } else {
      return _errorCb();
    }
  };

  SupportV1StepOneView.prototype.myGrouponSuccessCallback = function(orders) {
    var _errorCb, _successCb, order;
    if ((orders != null ? orders.length : void 0) > 0) {
      if (window.orderIdFromMyGroupons != null) {
        _successCb = (function(_this) {
          return function(orderDetails) {
            return _this.getOrderMetaData(orderDetails);
          };
        })(this);
        _errorCb = (function(_this) {
          return function() {
            return _this.loadOrderErrorCallback();
          };
        })(this);
        return Groupon.Support.OrderModel.getOrderDetailsForMygrouponsOrderId(_successCb, _errorCb);
      } else {
        order = Groupon.Support.currentOrdersFilter.getFirstOrder();
        return this.getOrderDetails(order);
      }
    } else if (Groupon.Support.currentOrdersFilter.iterator.hasNext()) {
      return this.initOrdersFetch();
    } else {
      return this.loadOrderErrorCallback();
    }
  };

  SupportV1StepOneView.prototype.getOrderDetails = function(orderSummary) {
    var _successCb, params;
    _successCb = (function(_this) {
      return function(orderDetails) {
        return _this.getOrderMetaData(orderDetails);
      };
    })(this);
    params = {
      order: orderSummary
    };
    return Groupon.Support.OrderModel.getOrderDetails(params, _successCb, _successCb);
  };

  SupportV1StepOneView.prototype.getOrderMetaData = function(orderDetails) {
    var _errorCb, _successCb, params;
    SupportHelpWizardController.changeCurrentOrder(orderDetails);
    if (orderDetails != null) {
      _successCb = (function(_this) {
        return function(order) {
          return _this.handleNormalAndMyGrouponsFlow(order);
        };
      })(this);
      _errorCb = (function(_this) {
        return function() {
          return _this.loadOrderErrorCallback();
        };
      })(this);
      Groupon.Support.MAXINDEX = 3;
      Groupon.Support.ORDER_NOT_LISTED = false;
      Groupon.Support.NOT_ORDER_RELATED = false;
      params = {
        order: orderDetails
      };
      return Groupon.Support.OrderModel.getMetadata(params, _successCb, _errorCb);
    }
  };

  SupportV1StepOneView.prototype.handleNormalAndMyGrouponsFlow = function(order) {
    if (window.selectOrderFromMygroupons) {
      return SupportHelpWizardController.stepTwo();
    } else {
      return this.renderOrderDetails();
    }
  };

  SupportV1StepOneView.prototype.loadOrderErrorCallback = function() {
    return SupportHelpWizardController.abruptStepTwoFlow();
  };

  return SupportV1StepOneView;

})(Backbone.View);

module.exports = SupportV1StepOneView;



},{"../../../../shared/frontend/views/widget_layout_veiw":25,"../../../step_one_actions.html.mustache":232,"../../helpWizardController":50,"../../helpers/utils":54,"../main_content_view":155,"../order_related/current_order_view":157,"../order_related/v1_select_different_order_menu_view":183,"../progress_bar_view":192,"../step_actions_view":194,"backbone":245}],196:[function(require,module,exports){
var Backbone, SharedWidgetLayoutView, SupportHelpWizardController, SupportMainContentWrapperView, SupportProgressBarView, SupportStepActionsView, SupportStepOneActionsTemplate, SupportUtilsHelper, SupportV2CurrentOrderView, SupportV2SelectDifferentOrderMenuView, SupportV2StepOneView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportMainContentWrapperView = require('../main_content_view');

SupportV2CurrentOrderView = require('../order_related/v2_current_order_view');

SupportStepActionsView = require('../step_actions_view');

SupportV2SelectDifferentOrderMenuView = require('../order_related/v2_select_different_order_menu_view');

SupportProgressBarView = require('../progress_bar_view');

SupportUtilsHelper = require('../../helpers/utils');

SharedWidgetLayoutView = require('../../../../shared/frontend/views/widget_layout_veiw');

SupportHelpWizardController = require('../../helpWizardController');

SupportStepOneActionsTemplate = require('../../../step_one_actions.html.mustache');

Backbone = require('backbone');

Backbone.$ = $;

SupportV2StepOneView = (function(superClass) {
  extend(SupportV2StepOneView, superClass);

  function SupportV2StepOneView() {
    return SupportV2StepOneView.__super__.constructor.apply(this, arguments);
  }

  SupportV2StepOneView.prototype.className = 'v2 step-one horizontal';

  SupportV2StepOneView.prototype.initialize = function() {
    this.id = 1;
    this.I18nScope = 'modules.support';
    Groupon.Support.Email = {};
    this.stepActions = new SupportStepActionsView({
      template: SupportStepOneActionsTemplate
    });
    this.mainContentWrappper = new SupportMainContentWrapperView;
    return this.createSubViews();
  };

  SupportV2StepOneView.prototype.resetContentModelParams = function() {
    if (Groupon.Support.ContentModel != null) {
      Groupon.Support.ContentModel.escalateToMerchant = false;
      return Groupon.Support.ContentModel.isRefundEligible = false;
    }
  };

  SupportV2StepOneView.prototype.renderOrderDetails = function() {
    window.hideFooterLinks();
    this.resetContentModelParams();
    this.mainContentWrappper.render((function(_this) {
      return function(contentWrapper) {
        _this.renderProgressBar(contentWrapper);
        _this.renderSelectDifferentOrderDetailMenu(contentWrapper);
        return _this.renderCurrentOrder(contentWrapper);
      };
    })(this));
    this.$el.html(this.mainContentWrappper.el);
    this.renderOrderDetailsStepActions();
    return this.hideComponents();
  };

  SupportV2StepOneView.prototype.renderSelectDifferentOrderListingMenu = function(contentWrapper) {
    this.selectDifferentOrderMenu.renderOrderListing();
    return contentWrapper.append(this.selectDifferentOrderMenu.el);
  };

  SupportV2StepOneView.prototype.renderSelectDifferentOrderDetailMenu = function(contentWrapper) {
    this.selectDifferentOrderMenu.renderDetails();
    return contentWrapper.append(this.selectDifferentOrderMenu.el);
  };

  SupportV2StepOneView.prototype.renderCurrentOrder = function(contentWrapper) {
    this.currentOrderView.render();
    return contentWrapper.append(this.currentOrderView.el);
  };

  SupportV2StepOneView.prototype.hideComponents = function() {
    SupportUtilsHelper.hideFloatingBoldChat();
    return SharedWidgetLayoutView.hideWidgets();
  };

  SupportV2StepOneView.prototype.close = function() {
    return this.$el.empty();
  };

  SupportV2StepOneView.prototype.render = function(params) {
    var order;
    if (params == null) {
      params = {};
    }
    order = params.order;
    showLoading(this.$el);
    if (!Groupon.Support.OrdersCollection.hasOrders()) {
      return this.initOrdersFetch();
    } else if (order) {
      return this.getOrderDetails(order);
    } else {
      return this.renderOrderListing();
    }
  };

  SupportV2StepOneView.prototype.initOrdersFetch = function() {
    var _errorCb, _successCb;
    _successCb = (function(_this) {
      return function(orders) {
        return _this.myGrouponSuccessCallback(orders);
      };
    })(this);
    _errorCb = (function(_this) {
      return function() {
        return _this.loadOrderErrorCallback();
      };
    })(this);
    if (Groupon.Support.currentOrdersFilter.iterator.hasNext()) {
      return Groupon.Support.currentOrdersFilter.iterator.next(_successCb, _errorCb);
    } else {
      return _errorCb();
    }
  };

  SupportV2StepOneView.prototype.myGrouponSuccessCallback = function(orders) {
    var _errorCb, _successCb;
    if ((orders != null ? orders.length : void 0) > 0) {
      if (window.orderIdFromMyGroupons != null) {
        _successCb = (function(_this) {
          return function(orderDetails) {
            return _this.getOrderMetaData(orderDetails);
          };
        })(this);
        _errorCb = (function(_this) {
          return function() {
            return _this.loadOrderErrorCallback();
          };
        })(this);
        return Groupon.Support.OrderModel.getOrderDetailsForMygrouponsOrderId(_successCb, _errorCb);
      } else {
        return this.renderOrderListing();
      }
    } else if (Groupon.Support.currentOrdersFilter.iterator.hasNext()) {
      return this.initOrdersFetch();
    } else {
      return this.noOrdersView();
    }
  };

  SupportV2StepOneView.prototype.getOrderDetails = function(orderSummary) {
    var _successCb, params;
    _successCb = (function(_this) {
      return function(orderDetails) {
        return _this.getOrderMetaData(orderDetails);
      };
    })(this);
    params = {
      order: orderSummary
    };
    return Groupon.Support.OrderModel.getOrderDetails(params, _successCb, _successCb);
  };

  SupportV2StepOneView.prototype.getOrderMetaData = function(orderDetails) {
    var _errorCb, _successCb, params;
    SupportHelpWizardController.changeCurrentOrder(orderDetails);
    if (orderDetails != null) {
      _successCb = (function(_this) {
        return function(order) {
          return _this.handleNormalAndMyGrouponsFlow(order);
        };
      })(this);
      _errorCb = (function(_this) {
        return function() {
          SupportHelpWizardController.changeCurrentOrder(null);
          return _this.loadOrderDetailsErrorCallback();
        };
      })(this);
      Groupon.Support.MAXINDEX = 3;
      Groupon.Support.ORDER_NOT_LISTED = false;
      Groupon.Support.NOT_ORDER_RELATED = false;
      params = {
        order: orderDetails
      };
      return Groupon.Support.OrderModel.getMetadata(params, _successCb, _errorCb);
    }
  };

  SupportV2StepOneView.prototype.handleNormalAndMyGrouponsFlow = function(order) {
    if (window.selectOrderFromMygroupons) {
      return SupportHelpWizardController.stepTwo();
    } else {
      return this.renderOrderDetails();
    }
  };

  SupportV2StepOneView.prototype.loadOrderErrorCallback = function() {
    return SupportHelpWizardController.abruptStepTwoFlow();
  };

  SupportV2StepOneView.prototype.loadOrderDetailsErrorCallback = function() {
    return SupportHelpWizardController.abruptStepTwoFlow();
  };

  SupportV2StepOneView.prototype.noOrdersView = function() {
    return SupportHelpWizardController.abruptStepTwoFlow();
  };

  SupportV2StepOneView.prototype.renderOrderListing = function() {
    Groupon.Support.MAXINDEX = 3;
    window.hideFooterLinks();
    this.mainContentWrappper.render((function(_this) {
      return function(contentWrapper) {
        _this.renderProgressBar(contentWrapper);
        return _this.renderSelectDifferentOrderListingMenu(contentWrapper);
      };
    })(this));
    this.$el.html(this.mainContentWrappper.el);
    return this.hideComponents();
  };

  SupportV2StepOneView.prototype.createSubViews = function() {
    this.progressBar = new SupportProgressBarView;
    this.selectDifferentOrderMenu = new SupportV2SelectDifferentOrderMenuView();
    return this.currentOrderView = new SupportV2CurrentOrderView();
  };

  SupportV2StepOneView.prototype.renderProgressBar = function(contentWrapper) {
    this.progressBar.render();
    contentWrapper.append(this.progressBar.el);
    return contentWrapper.append("<br>");
  };

  SupportV2StepOneView.prototype.renderOrderDetailsStepActions = function() {
    this.stepActions.render();
    return this.$el.append(this.stepActions.el);
  };

  return SupportV2StepOneView;

})(Backbone.View);

module.exports = SupportV2StepOneView;



},{"../../../../shared/frontend/views/widget_layout_veiw":25,"../../../step_one_actions.html.mustache":232,"../../helpWizardController":50,"../../helpers/utils":54,"../main_content_view":155,"../order_related/v2_current_order_view":184,"../order_related/v2_select_different_order_menu_view":188,"../progress_bar_view":192,"../step_actions_view":194,"backbone":245}],197:[function(require,module,exports){
var SharedAjaxErrorView, SupportV2StepOneView, SupportVerticalCurrentOrderView, SupportVerticalSelectDifferentOrderMenuView, SupportVerticalStepOneView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SharedAjaxErrorView = require('../../../../shared/frontend/views/ajax_error_view');

SupportVerticalCurrentOrderView = require('../order_related/vertical_current_order_view');

SupportVerticalSelectDifferentOrderMenuView = require('../order_related/vertical_select_different_order_menu_view');

SupportV2StepOneView = require('./v2_view');

SupportVerticalStepOneView = (function(superClass) {
  extend(SupportVerticalStepOneView, superClass);

  function SupportVerticalStepOneView() {
    return SupportVerticalStepOneView.__super__.constructor.apply(this, arguments);
  }

  SupportVerticalStepOneView.prototype.className = 'v2 step-one vertical';

  SupportVerticalStepOneView.prototype.initialize = function() {
    SupportV2StepOneView.prototype.initialize.apply(this, arguments);
    return this.errorView = new SharedAjaxErrorView();
  };

  SupportVerticalStepOneView.prototype.render = function(params) {
    return SupportV2StepOneView.prototype.render.call(this, params);
  };

  SupportVerticalStepOneView.prototype.loadOrderErrorCallback = function() {
    this.errorView.render({
      container: this.$el,
      errorHtmlText: I18n.t("js.modules.support.order_listing_error")
    });
    return this.styleErrorView();
  };

  SupportVerticalStepOneView.prototype.loadOrderDetailsErrorCallback = function() {
    var $errorMessage;
    this.renderOrderListing();
    $errorMessage = $("<div></div>");
    this.errorView.render({
      container: $errorMessage,
      errorHtmlText: I18n.t("js.modules.support.order_details_error")
    });
    $(".help-wizard-content", this.$el).prepend($errorMessage);
    return this.styleErrorView();
  };

  SupportVerticalStepOneView.prototype.noOrdersView = function() {
    this.errorView.render({
      container: this.$el,
      errorHtmlText: I18n.t("js.modules.support.no_order_message")
    });
    return this.styleErrorView();
  };

  SupportVerticalStepOneView.prototype.styleErrorView = function() {
    return $(".page-error", this.$el).removeClass("text-center").addClass("notification");
  };

  SupportVerticalStepOneView.prototype.renderProgressBar = function(contentWrapper) {};

  SupportVerticalStepOneView.prototype.createSubViews = function() {
    this.selectDifferentOrderMenu = new SupportVerticalSelectDifferentOrderMenuView();
    return this.currentOrderView = new SupportVerticalCurrentOrderView();
  };

  SupportVerticalStepOneView.prototype.handleNormalAndMyGrouponsFlow = function(order) {
    return this.renderOrderDetails();
  };

  return SupportVerticalStepOneView;

})(SupportV2StepOneView);

module.exports = SupportVerticalStepOneView;



},{"../../../../shared/frontend/views/ajax_error_view":19,"../order_related/vertical_current_order_view":189,"../order_related/vertical_select_different_order_menu_view":190,"./v2_view":196}],198:[function(require,module,exports){
var EmailFormOptimizedContactChannelView, SharedFooterIntlMainView, SharedFooterIntlPhoneNumberView, SharedIntlFooterTemplate, SupportEmailFormIntlFlexibleContactChannelsView, SupportEmailFormIntlMainView, SupportV1INTLStepThreeView, SupportV1StepThreeBaseView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportEmailFormIntlMainView = require('../../email_form/INTL/main_view');

SharedFooterIntlMainView = require('../../../../../shared/frontend/views/footer/INTL/main_view');

SharedFooterIntlPhoneNumberView = require('../../../../../shared/frontend/views/footer/INTL/phone_number_view');

SupportV1StepThreeBaseView = require('../v1_base_view');

EmailFormOptimizedContactChannelView = require('../../email_form/common/optimized_contact_channel_view');

SupportEmailFormIntlFlexibleContactChannelsView = require('../../email_form/INTL/flexible_contact_channels');

SharedIntlFooterTemplate = require('../../../../../shared/intl_footer.html.mustache');

SupportV1INTLStepThreeView = (function(superClass) {
  extend(SupportV1INTLStepThreeView, superClass);

  function SupportV1INTLStepThreeView() {
    return SupportV1INTLStepThreeView.__super__.constructor.apply(this, arguments);
  }

  SupportV1INTLStepThreeView.prototype.shouldShowContactChannelView = function() {
    var ref;
    return (window.evaluate(typeof experiments !== "undefined" && experiments !== null ? experiments.showOptimizedContactChannel : void 0) || window.evaluate((ref = window.experiments) != null ? ref.showFlexibleContactChannels : void 0)) && !window.priorityViewsEnabled();
  };

  SupportV1INTLStepThreeView.prototype.getEmailFormView = function(options) {
    return new SupportEmailFormIntlMainView(options);
  };

  SupportV1INTLStepThreeView.prototype.renderPhoneNumberView = function() {
    return propagateEventBeforeReplacingElements((function(_this) {
      return function() {
        var phoneNumberView;
        phoneNumberView = new SharedFooterIntlPhoneNumberView({
          emailFormModel: _this.emailFormModel,
          renderPopup: true
        });
        return phoneNumberView.render();
      };
    })(this));
  };

  SupportV1INTLStepThreeView.prototype.configureContactChannelView = function(options) {
    if (this.isFlexibleContactEnabled()) {
      return new SupportEmailFormIntlFlexibleContactChannelsView(options);
    } else {
      return new EmailFormOptimizedContactChannelView(options);
    }
  };

  SupportV1INTLStepThreeView.prototype.renderEmailForm = function() {
    this.renderFooter();
    return SupportV1StepThreeBaseView.prototype.renderEmailForm.apply(this, arguments);
  };

  SupportV1INTLStepThreeView.prototype.renderFooter = function() {
    this.footerContainer = $("#footer-content");
    this.phoneViewFooter = new SharedFooterIntlMainView({
      template: SharedIntlFooterTemplate,
      model: this.emailFormModel
    });
    this.phoneViewFooter.render();
    this.footerContainer.html(this.phoneViewFooter.el);
    return toggleCallUs(Groupon.Support.CURRENTVIEW.id);
  };

  return SupportV1INTLStepThreeView;

})(SupportV1StepThreeBaseView);

module.exports = SupportV1INTLStepThreeView;



},{"../../../../../shared/frontend/views/footer/INTL/main_view":20,"../../../../../shared/frontend/views/footer/INTL/phone_number_view":21,"../../../../../shared/intl_footer.html.mustache":27,"../../email_form/INTL/flexible_contact_channels":122,"../../email_form/INTL/main_view":123,"../../email_form/common/optimized_contact_channel_view":148,"../v1_base_view":202}],199:[function(require,module,exports){
var EmailFormCallClickView, EmailFormLiveChatClickView, EmailFormOptimizedContactChannelView, EmailFormV2FlexibleContactChannelsTextView, SharedFooterIntlPhoneNumberView, SupportEmailFormIntlV2FlexibleContactChannelsView, SupportEmailFormIntlVerticalView, SupportV1StepThreeBaseView, SupportVerticalINTLStepThreeView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportEmailFormIntlVerticalView = require('../../email_form/INTL/vertical_view');

SharedFooterIntlPhoneNumberView = require('../../../../../shared/frontend/views/footer/INTL/phone_number_view');

SupportV1StepThreeBaseView = require('../v1_base_view');

EmailFormOptimizedContactChannelView = require('../../email_form/common/optimized_contact_channel_view');

SupportEmailFormIntlV2FlexibleContactChannelsView = require('../../email_form/INTL/v2_flexible_contact_channels');

EmailFormLiveChatClickView = require('../../email_form/common/live_chat_click_view');

EmailFormCallClickView = require('../../email_form/common/call_click_view');

EmailFormV2FlexibleContactChannelsTextView = require('../../email_form/common/v2_flexible_contact_channel_text_view');

SupportVerticalINTLStepThreeView = (function(superClass) {
  extend(SupportVerticalINTLStepThreeView, superClass);

  function SupportVerticalINTLStepThreeView() {
    return SupportVerticalINTLStepThreeView.__super__.constructor.apply(this, arguments);
  }

  SupportVerticalINTLStepThreeView.prototype.className = 'vertical step-three';

  SupportVerticalINTLStepThreeView.prototype.getEmailFormView = function(options) {
    return new SupportEmailFormIntlVerticalView(options);
  };

  SupportVerticalINTLStepThreeView.prototype.renderPhoneNumberView = function() {
    return propagateEventBeforeReplacingElements((function(_this) {
      return function() {
        return _this.callClickHandler();
      };
    })(this));
  };

  SupportVerticalINTLStepThreeView.prototype.callClickHandler = function() {
    if (!this.callClickView) {
      this.callClickView = new EmailFormCallClickView({
        phoneNumberView: this.getPhoneNumberView(this),
        contactChannelTextView: this.getContactChannelTextView(this)
      });
      this.callClickView.render();
      this.$el.html(this.callClickView.el);
      return this.callClickView.postRenderhandler();
    }
  };

  SupportVerticalINTLStepThreeView.prototype.getContactChannelTextView = function(stepThreeView) {
    return new EmailFormV2FlexibleContactChannelsTextView({
      mainView: stepThreeView,
      emailFormModel: stepThreeView.emailFormModel,
      showOnlyFlexibleText: true
    });
  };

  SupportVerticalINTLStepThreeView.prototype.getPhoneNumberView = function(stepThreeView) {
    return new SharedFooterIntlPhoneNumberView({
      emailFormModel: stepThreeView.emailFormModel,
      renderPopup: false
    });
  };

  SupportVerticalINTLStepThreeView.prototype.shouldShowContactChannelView = function() {
    return !window.priorityViewsEnabled();
  };

  SupportVerticalINTLStepThreeView.prototype.configureContactChannelView = function(options) {
    return new SupportEmailFormIntlV2FlexibleContactChannelsView(options);
  };

  SupportVerticalINTLStepThreeView.prototype.renderEmailForm = function() {
    return SupportV1StepThreeBaseView.prototype.renderEmailForm.apply(this, arguments);
  };

  SupportVerticalINTLStepThreeView.prototype.renderProgressBar = function() {};

  SupportVerticalINTLStepThreeView.prototype.renderChatClickView = function() {
    var liveChatClickView;
    if (this.isFlexibleContactEnabled()) {
      liveChatClickView = new EmailFormLiveChatClickView();
      liveChatClickView.render();
      return this.$el.html(liveChatClickView.el);
    }
  };

  return SupportVerticalINTLStepThreeView;

})(SupportV1StepThreeBaseView);

module.exports = SupportVerticalINTLStepThreeView;



},{"../../../../../shared/frontend/views/footer/INTL/phone_number_view":21,"../../email_form/INTL/v2_flexible_contact_channels":129,"../../email_form/INTL/vertical_view":130,"../../email_form/common/call_click_view":146,"../../email_form/common/live_chat_click_view":147,"../../email_form/common/optimized_contact_channel_view":148,"../../email_form/common/v2_flexible_contact_channel_text_view":149,"../v1_base_view":202}],200:[function(require,module,exports){
var EmailFormOptimizedContactChannelView, SharedFooterUSPhoneNumberView, SupportEmailFormUSMainView, SupportEmailFormUSV2FlexibleContactChannelsView, SupportPhoneNumberCallBackView, SupportV1StepThreeBaseView, SupportV1USStepThreeView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportEmailFormUSMainView = require('../../email_form/US/main_view');

EmailFormOptimizedContactChannelView = require('../../email_form/common/optimized_contact_channel_view');

SharedFooterUSPhoneNumberView = require('../../../../../shared/frontend/views/footer/US/phone_number_view');

SupportPhoneNumberCallBackView = require('../../email_form/US/phone_number_call_back_view');

SupportV1StepThreeBaseView = require('../v1_base_view');

SupportEmailFormUSV2FlexibleContactChannelsView = require('../../email_form/US/v2_flexible_contact_channels');

SupportV1USStepThreeView = (function(superClass) {
  extend(SupportV1USStepThreeView, superClass);

  function SupportV1USStepThreeView() {
    return SupportV1USStepThreeView.__super__.constructor.apply(this, arguments);
  }

  SupportV1USStepThreeView.prototype.getEmailFormView = function(options) {
    return new SupportEmailFormUSMainView(options);
  };

  SupportV1USStepThreeView.prototype.renderPhoneNumberView = function() {
    if (window.evaluate(typeof experiments !== "undefined" && experiments !== null ? experiments.shouldDisplayCallBackOption : void 0)) {
      return this.renderPhoneNumberCallBackView();
    } else {
      return this.renderNormalPhoneNumberView();
    }
  };

  SupportV1USStepThreeView.prototype.renderNormalPhoneNumberView = function() {
    return propagateEventBeforeReplacingElements((function(_this) {
      return function() {
        var phoneNumberView;
        phoneNumberView = new SharedFooterUSPhoneNumberView();
        return phoneNumberView.render();
      };
    })(this));
  };

  SupportV1USStepThreeView.prototype.renderPhoneNumberCallBackView = function() {
    return propagateEventBeforeReplacingElements((function(_this) {
      return function() {
        _this.phoneNumberCallBackView = new SupportPhoneNumberCallBackView({
          mainView: _this
        });
        return _this.phoneNumberCallBackView.render();
      };
    })(this));
  };

  SupportV1USStepThreeView.prototype.shouldShowContactChannelView = function() {
    return false;
  };

  SupportV1USStepThreeView.prototype.configureContactChannelView = function(options) {
    return null;
  };

  SupportV1USStepThreeView.prototype.renderContactChannelView = function() {};

  SupportV1USStepThreeView.prototype.handleDisplayOfContactChannels = function() {};

  SupportV1USStepThreeView.prototype.renderContactChannelView = function() {
    var hideInbentaResults;
    SupportV1StepThreeBaseView.prototype.renderContactChannelView.apply(this, arguments);
    hideInbentaResults = (function(_this) {
      return function() {
        var inbentaResults;
        inbentaResults = $("#results:visible");
        if (inbentaResults.length > 0) {
          inbentaResults.hide();
          return clearInterval(_this.hideInbentaResultsInterval);
        }
      };
    })(this);
    return this.hideInbentaResultsInterval = setInterval(hideInbentaResults, 0);
  };

  SupportV1USStepThreeView.prototype.renderEmailForm = function() {
    if (this.hideInbentaResultsInterval) {
      clearInterval(this.hideInbentaResultsInterval);
    }
    return SupportV1StepThreeBaseView.prototype.renderEmailForm.apply(this, arguments);
  };

  SupportV1USStepThreeView.prototype.postEmailFormRenderCallBack = function() {
    return Groupon.Support.ContentModel.onInitStepThree();
  };

  return SupportV1USStepThreeView;

})(SupportV1StepThreeBaseView);

module.exports = SupportV1USStepThreeView;



},{"../../../../../shared/frontend/views/footer/US/phone_number_view":23,"../../email_form/US/main_view":139,"../../email_form/US/phone_number_call_back_view":141,"../../email_form/US/v2_flexible_contact_channels":144,"../../email_form/common/optimized_contact_channel_view":148,"../v1_base_view":202}],201:[function(require,module,exports){
var SharedFooterUSPhoneNumberView, SupportEmailFormUSMainView, SupportEmailFormUSV2FlexibleContactChannelsView, SupportPhoneNumberCallBackView, SupportV1StepThreeBaseView, SupportV2USStepThreeView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportEmailFormUSMainView = require('../../email_form/US/main_view');

SharedFooterUSPhoneNumberView = require('../../../../../shared/frontend/views/footer/US/phone_number_view');

SupportPhoneNumberCallBackView = require('../../email_form/US/phone_number_call_back_view');

SupportV1StepThreeBaseView = require('../v1_base_view');

SupportEmailFormUSV2FlexibleContactChannelsView = require('../../email_form/US/v2_flexible_contact_channels');

SupportV2USStepThreeView = (function(superClass) {
  extend(SupportV2USStepThreeView, superClass);

  function SupportV2USStepThreeView() {
    return SupportV2USStepThreeView.__super__.constructor.apply(this, arguments);
  }

  SupportV2USStepThreeView.prototype.getEmailFormView = function(options) {
    return new SupportEmailFormUSMainView(options);
  };

  SupportV2USStepThreeView.prototype.renderPhoneNumberView = function() {
    if (window.evaluate(typeof experiments !== "undefined" && experiments !== null ? experiments.shouldDisplayCallBackOption : void 0)) {
      return this.renderPhoneNumberCallBackView();
    } else {
      return this.renderNormalPhoneNumberView();
    }
  };

  SupportV2USStepThreeView.prototype.renderNormalPhoneNumberView = function() {
    return propagateEventBeforeReplacingElements(function() {
      var phoneNumberView;
      phoneNumberView = new SharedFooterUSPhoneNumberView();
      return phoneNumberView.render();
    });
  };

  SupportV2USStepThreeView.prototype.renderPhoneNumberCallBackView = function() {
    return propagateEventBeforeReplacingElements((function(_this) {
      return function() {
        _this.phoneNumberCallBackView = new SupportPhoneNumberCallBackView({
          mainView: _this
        });
        return _this.phoneNumberCallBackView.render();
      };
    })(this));
  };

  SupportV2USStepThreeView.prototype.shouldShowContactChannelView = function() {
    var ref;
    return window.evaluate((ref = window.experiments) != null ? ref.showFlexibleContactChannels : void 0);
  };

  SupportV2USStepThreeView.prototype.configureContactChannelView = function(options) {
    return new SupportEmailFormUSV2FlexibleContactChannelsView(options);
  };

  SupportV2USStepThreeView.prototype.renderContactChannelView = function() {
    var hideInbentaResults;
    SupportV1StepThreeBaseView.prototype.renderContactChannelView.apply(this, arguments);
    hideInbentaResults = (function(_this) {
      return function() {
        var inbentaResults;
        inbentaResults = $("#results:visible");
        if (inbentaResults.length > 0) {
          inbentaResults.hide();
          return clearInterval(_this.hideInbentaResultsInterval);
        }
      };
    })(this);
    return this.hideInbentaResultsInterval = setInterval(hideInbentaResults, 0);
  };

  SupportV2USStepThreeView.prototype.renderEmailForm = function() {
    if (this.hideInbentaResultsInterval) {
      clearInterval(this.hideInbentaResultsInterval);
    }
    return SupportV1StepThreeBaseView.prototype.renderEmailForm.apply(this, arguments);
  };

  SupportV2USStepThreeView.prototype.postEmailFormRenderCallBack = function() {
    return Groupon.Support.ContentModel.onInitStepThree();
  };

  return SupportV2USStepThreeView;

})(SupportV1StepThreeBaseView);

module.exports = SupportV2USStepThreeView;



},{"../../../../../shared/frontend/views/footer/US/phone_number_view":23,"../../email_form/US/main_view":139,"../../email_form/US/phone_number_call_back_view":141,"../../email_form/US/v2_flexible_contact_channels":144,"../v1_base_view":202}],202:[function(require,module,exports){
var Backbone, SharedWidgetLayoutView, SupportEmailFormModel, SupportProgressBarView, SupportUtilsHelper, SupportV1StepThreeBaseView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportEmailFormModel = require('../../models/email_form');

SharedWidgetLayoutView = require('../../../../shared/frontend/views/widget_layout_veiw');

SupportUtilsHelper = require('../../helpers/utils');

SupportProgressBarView = require('../progress_bar_view');

Backbone = require('backbone');

Backbone.$ = $;

SupportV1StepThreeBaseView = (function(superClass) {
  extend(SupportV1StepThreeBaseView, superClass);

  function SupportV1StepThreeBaseView() {
    return SupportV1StepThreeBaseView.__super__.constructor.apply(this, arguments);
  }

  SupportV1StepThreeBaseView.prototype.className = 'horizontal step-three';

  SupportV1StepThreeBaseView.prototype.initialize = function() {
    if (Groupon.Support.MAXINDEX === 2) {
      this.id = 2;
    } else {
      this.id = 3;
    }
    this.emailFormModel = new SupportEmailFormModel;
    this.emailFormMainView = this.getEmailFormView({
      emailFormModel: this.emailFormModel
    });
    this.contactChannelView = this.configureContactChannelView({
      mainView: this,
      emailFormModel: this.emailFormModel
    });
    return this.shouldRenderEmailForm = false;
  };

  SupportV1StepThreeBaseView.prototype.postRenderhandler = function() {
    if (this.shouldShowContactChannelView()) {
      return this.handleDisplayOfContactChannels();
    } else {
      return Groupon.Support.ContentModel.onInitStepThree();
    }
  };

  SupportV1StepThreeBaseView.prototype.handleDisplayOfContactChannels = function() {
    return this.contactChannelView.handleDisplayOfContactChannels();
  };

  SupportV1StepThreeBaseView.prototype.render = function() {
    SharedWidgetLayoutView.hideWidgets();
    if (this.shouldShowContactChannelView()) {
      return this.renderContactChannelView();
    } else {
      window.showFooterLinks();
      this.shouldRenderEmailForm = true;
      this.emailFormMainView.render();
      this.$el.html(this.emailFormMainView.$el);
      this.renderProgressBar();
      return this.renderLiveChat();
    }
  };

  SupportV1StepThreeBaseView.prototype.renderContactChannelView = function() {
    this.hideComponents();
    this.contactChannelView.render();
    this.$el.html(this.contactChannelView.el);
    this.renderProgressBar();
    return this.contactChannelView.renderLiveChat();
  };

  SupportV1StepThreeBaseView.prototype.isPhonePreferredChannel = function() {
    return this.emailFormMainView.isPhonePreferredChannel();
  };

  SupportV1StepThreeBaseView.prototype.renderEmailForm = function() {
    return propagateEventBeforeReplacingElements((function(_this) {
      return function() {
        return _this.emailClickCallback();
      };
    })(this));
  };

  SupportV1StepThreeBaseView.prototype.emailClickCallback = function() {
    this.shouldRenderEmailForm = true;
    this.emailFormMainView.contactByEmail();
    this.$el.html(this.emailFormMainView.$el);
    this.renderProgressBar();
    return this.postEmailFormRenderCallBack();
  };

  SupportV1StepThreeBaseView.prototype.postEmailFormRenderCallBack = function() {};

  SupportV1StepThreeBaseView.prototype.renderPhoneNumberView = function() {};

  SupportV1StepThreeBaseView.prototype.submitFormHandler = function() {};

  SupportV1StepThreeBaseView.prototype.shouldShowContactChannelView = function() {};

  SupportV1StepThreeBaseView.prototype.hideComponents = function() {
    return SupportUtilsHelper.hideFloatingBoldChat();
  };

  SupportV1StepThreeBaseView.prototype.renderProgressBar = function() {
    var progressBar;
    progressBar = new SupportProgressBarView;
    progressBar.render();
    return this.$el.find('.steps-container').append(progressBar.el);
  };

  SupportV1StepThreeBaseView.prototype.renderLiveChat = function(params) {
    var liveChatMode, liveChatType;
    if (params == null) {
      params = {};
    }
    liveChatMode = params.liveChatMode || Groupon.Support.LiveChatModel.getDefaultStepThreeLiveChatMode();
    if (liveChatMode != null) {
      if (window.evaluate(this.shouldRenderEmailForm)) {
        liveChatType = Groupon.Support.LiveChatModel.getDefaultLiveChatType();
      }
      Groupon.Support.LiveChatView.setLiveChat(liveChatMode, liveChatType || params.liveChatType);
      Groupon.Support.LiveChatView.renderView(this.$el, $.extend(true, this.emailFormMainView.getChatParams(), {
        startFromSameViewState: params.startFromSameViewState
      }));
      if (isStaticLiveChat(liveChatMode)) {
        return SupportUtilsHelper.hideFloatingBoldChat();
      } else {
        return SupportUtilsHelper.showFloatingBoldChat();
      }
    }
  };

  SupportV1StepThreeBaseView.prototype.renderChatClickView = function() {};

  SupportV1StepThreeBaseView.prototype.isFlexibleContactEnabled = function() {
    var ref;
    return window.evaluate((ref = window.experiments) != null ? ref.showFlexibleContactChannels : void 0);
  };

  SupportV1StepThreeBaseView.prototype.isOptimizedContactEnabled = function() {
    return window.evaluate(typeof experiments !== "undefined" && experiments !== null ? experiments.showOptimizedContactChannel : void 0);
  };

  return SupportV1StepThreeBaseView;

})(Backbone.View);

module.exports = SupportV1StepThreeBaseView;



},{"../../../../shared/frontend/views/widget_layout_veiw":25,"../../helpers/utils":54,"../../models/email_form":62,"../progress_bar_view":192,"backbone":245}],203:[function(require,module,exports){
var StepTwoBaseView, StepTwoCMSBaseView, SupportAPIHelper,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

StepTwoBaseView = require('../base_view');

SupportAPIHelper = require('../../../helpers/API');

StepTwoCMSBaseView = (function(superClass) {
  extend(StepTwoCMSBaseView, superClass);

  function StepTwoCMSBaseView() {
    return StepTwoCMSBaseView.__super__.constructor.apply(this, arguments);
  }

  StepTwoCMSBaseView.prototype.initialize = function() {
    return StepTwoBaseView.prototype.initialize.apply(this, arguments);
  };

  StepTwoCMSBaseView.prototype.render = function() {
    this.categoryRendered = false;
    Groupon.Support.ContentModel.onInitStepTwo();
    this.hideComponents();
    toggleCallUs(Groupon.Support.CURRENTVIEW.id);
    return this.flexibleContactChannelModel = Groupon.Support.FlexibleContactChannelModel;
  };

  StepTwoCMSBaseView.prototype.fetchAndRenderCategory = function(contentWrapper) {
    if (_.isEmpty(this.getDropdowns())) {
      this.spinnerView.show({
        container: contentWrapper,
        append: true,
        height: '50px'
      });
      startTimer("t_dc");
      return this.dropDownModel.fetch({
        data: null,
        success: (function(_this) {
          return function(model, response, options) {
            stopTimer("t_dc");
            _this.spinnerView.remove();
            return _this.categorySuccessCallback(contentWrapper);
          };
        })(this),
        error: (function(_this) {
          return function(model, response, options) {
            stopTimer("t_dc");
            _this.spinnerView.remove();
            return _this.categoryErrorCallback(contentWrapper);
          };
        })(this)
      });
    } else {
      return this.categorySuccessCallback(contentWrapper);
    }
  };

  StepTwoCMSBaseView.prototype.fetchFlexibleContactChannels = function(contentWrapper) {
    if (this.shouldFetchFlexibleContactChannels()) {
      return this.flexibleContactChannelsCall = this.flexibleContactChannelModel.fetch({
        success: (function(_this) {
          return function(model, response, options) {
            return _this.flexibleContactChannelsCallback(contentWrapper);
          };
        })(this),
        error: (function(_this) {
          return function(model, response, options) {
            return _this.flexibleContactChannelsCallback(contentWrapper);
          };
        })(this)
      });
    } else {
      return this.categorySuccessCallback(contentWrapper);
    }
  };

  StepTwoCMSBaseView.prototype.flexibleContactChannelsCallback = function(contentWrapper) {
    this.flexibleContactChannelsCall = null;
    return this.categorySuccessCallback(contentWrapper);
  };

  StepTwoCMSBaseView.prototype.categorySuccessCallback = function(contentWrapper) {
    if (this.shouldRenderCategory()) {
      if (!this.categoryRendered) {
        return this.renderCategory(contentWrapper);
      }
    }
  };

  StepTwoCMSBaseView.prototype.shouldRenderCategory = function() {
    return !(_.isEmpty(this.getDropdowns()));
  };

  StepTwoCMSBaseView.prototype.categoryErrorCallback = function(model, xhr, options) {
    return this.handleAjaxErrors();
  };

  StepTwoCMSBaseView.prototype.renderSubCategory = function(contentWrapper) {
    var contentSubCategory, subdropdwn;
    this.disableAllButton();
    subdropdwn = $('.sub-dropdown', contentWrapper);
    subdropdwn.html("");
    subdropdwn.html(toHtml(this.subCategoryTemplate, {
      subCategories: this.getSubCategoryList()
    }, this.I18nScope));
    contentSubCategory = Groupon.Support.ContentModel.getSubCategory();
    if (contentSubCategory && contentSubCategory !== null) {
      $(".sub-category", contentWrapper).val(contentSubCategory.id);
      $(".sub-category option[value='" + contentSubCategory.id + "']", contentWrapper).attr("selected", "selected");
      if (!Groupon.Support.ContentModel.getContent()) {
        return this.fetchHelpContent(contentWrapper);
      }
    }
  };

  StepTwoCMSBaseView.prototype.fetchHelpContent = function(contentWrapper) {
    var cb, data, urls;
    if (contentWrapper != null) {
      this.spinnerView.show({
        container: $('.inbenta-content', contentWrapper),
        height: '50px'
      });
    } else {
      this.spinnerView.show({
        container: $('.inbenta-content', this.$el),
        height: '50px'
      });
    }
    urls = this.getHelpContentPaths();
    data = this.getTaglines();
    cb = (function(_this) {
      return function(results) {
        return _this.helpContentCb(results);
      };
    })(this);
    return this.contentRequests = SupportAPIHelper.parallel(urls, data, cb, false, "t_ic", 60000);
  };

  StepTwoCMSBaseView.prototype.setCategoryToWindow = function() {
    var category;
    this.contentRequests = abortAjaxRequests(this.contentRequests);
    this.disableAllButton();
    category = this.$('.category option:selected').val();
    addToTrackingHub(category, null);
    this.clearContentElement();
    if (category === '') {
      this.$(".sub-category option[value='']").attr("selected", "selected");
      this.$('.sub-category').trigger('change');
      Groupon.Support.ContentModel.setCategory(null);
      Groupon.Support.ContentModel.setSubCategory(null);
      return this.clearElement('.sub-dropdown');
    } else {
      Groupon.Support.ContentModel.setCategory({
        id: this.$('.category option:selected').val(),
        text: this.$('.category option:selected').text()
      });
      Groupon.Support.ContentModel.setSubCategory(null);
      return this.renderSubCategory(this.$el);
    }
  };

  StepTwoCMSBaseView.prototype.setSubCategoryToWindow = function() {
    var ref, ref1, subcategory;
    this.contentRequests = abortAjaxRequests(this.contentRequests);
    subcategory = this.$('.sub-category option:selected').val();
    this.disableAllButton();
    addToTrackingHub(Groupon.Support.ContentModel.getCategory().id, subcategory);
    this.clearStepThreeIfPresent();
    this.clearContentElement();
    if (subcategory === '') {
      return Groupon.Support.ContentModel.setSubCategory(null);
    } else {
      Groupon.Support.ContentModel.setSubCategory({
        id: this.$('.sub-category option:selected').val(),
        text: this.$('.sub-category option:selected').text(),
        group: (ref = this.$('.sub-category option:selected')) != null ? (ref1 = ref[0]) != null ? ref1.getAttribute("data-group") : void 0 : void 0
      });
      return this.fetchHelpContent();
    }
  };

  StepTwoCMSBaseView.prototype.resolveContent = function(contents) {
    var i, j, possibleStepTwoContentsLength, ref;
    if (contents == null) {
      return {};
    }
    possibleStepTwoContentsLength = this.getPossibleStepTwoContentsLength();
    for (i = j = 0, ref = possibleStepTwoContentsLength; 0 <= ref ? j < ref : j > ref; i = 0 <= ref ? ++j : --j) {
      if (this.isObjectNotEmpty(contents[i])) {
        contents[i];
        break;
      }
    }
    if (i < possibleStepTwoContentsLength && (contents[i] != null)) {
      return contents[i];
    } else {
      return {};
    }
  };

  StepTwoCMSBaseView.prototype.getPossibleStepTwoContentsLength = function() {
    var possibleStepTwoNormalContentsLength;
    possibleStepTwoNormalContentsLength = 1;
    return possibleStepTwoNormalContentsLength + this.getPriorityTaglinesLength();
  };

  StepTwoCMSBaseView.prototype.isObjectNotEmpty = function(object) {
    return !_.isEmpty(object);
  };

  StepTwoCMSBaseView.prototype.getPriorityTaglinesLength = function() {
    var currentOrderPriorityTaglines, ref;
    currentOrderPriorityTaglines = (ref = Groupon.Support.currentOrder) != null ? ref.priorityTaglines : void 0;
    if (currentOrderPriorityTaglines != null) {
      return currentOrderPriorityTaglines.length;
    } else {
      return 0;
    }
  };

  StepTwoCMSBaseView.prototype.resolveFlexStepThree = function(contents) {
    var flexStepThreeStartIndex, i, j, ref, ref1;
    if (contents == null) {
      return;
    }
    flexStepThreeStartIndex = this.getFlexStepThreeStartIndex(contents);
    for (i = j = ref = flexStepThreeStartIndex, ref1 = contents.length; ref <= ref1 ? j < ref1 : j > ref1; i = ref <= ref1 ? ++j : --j) {
      if (this.isObjectNotEmpty(contents[i])) {
        contents[i];
        break;
      }
    }
    if (i < contents.length) {
      return contents[i];
    }
  };

  StepTwoCMSBaseView.prototype.getPossibleFlexStepThreeContentsLength = function(contents) {
    var possibleNormalFlexStepThreeContentsLength;
    possibleNormalFlexStepThreeContentsLength = 1;
    return possibleNormalFlexStepThreeContentsLength + this.getPriorityTaglinesLength();
  };

  StepTwoCMSBaseView.prototype.getFlexStepThreeStartIndex = function(contents) {
    return contents.length - this.getPossibleFlexStepThreeContentsLength(contents);
  };

  StepTwoCMSBaseView.prototype.setPriorityContentFlags = function(contents) {
    this.setIsRefundEligibleFlag(contents);
    return this.setEscalateToMerchantFlag(contents);
  };

  StepTwoCMSBaseView.prototype.setIsRefundEligibleFlag = function(contents) {
    return Groupon.Support.ContentModel.isRefundEligible = this.isRefundEligibleFlexStepThreePresent(contents);
  };

  StepTwoCMSBaseView.prototype.setEscalateToMerchantFlag = function(contents) {
    Groupon.Support.ContentModel.escalateToMerchant = this.isEscalateToMerchantFlexStepThreePresent(contents);
    return this.prioritizeRefundEligibleOverMerchantEscalation();
  };

  StepTwoCMSBaseView.prototype.prioritizeRefundEligibleOverMerchantEscalation = function() {
    if (evaluate(Groupon.Support.ContentModel.isRefundEligible)) {
      return Groupon.Support.ContentModel.escalateToMerchant = false;
    }
  };

  StepTwoCMSBaseView.prototype.isRefundEligibleFlexStepThreePresent = function(contents) {
    var ref;
    return evaluate((ref = Groupon.Support.currentOrder) != null ? ref.isRefundEligible : void 0) && this.isObjectNotEmpty(contents[this.getFlexStepThreeStartIndex(contents)]);
  };

  StepTwoCMSBaseView.prototype.isEscalateToMerchantFlexStepThreePresent = function(contents) {
    var ref;
    return evaluate((ref = Groupon.Support.currentOrder) != null ? ref.escalateToMerchant : void 0) && this.isObjectNotEmpty(contents[contents.length - 2]);
  };

  StepTwoCMSBaseView.prototype.enableTicketDirectionButton = function() {
    this.sendTrackyCallForHelpContentBeingShown(false);
    this.$('.issue-check').hide();
    return this.handleDisplayOfTicketDirectionButtons();
  };

  StepTwoCMSBaseView.prototype.handleDisplayOfTicketDirectionButtons = function() {
    if (evaluate(Groupon.Support.ContentModel.isRefundEligible)) {
      return this.enableRefundRequestButton();
    } else {
      return this.enableContinueToEmailButton();
    }
  };

  StepTwoCMSBaseView.prototype.enableResolvedButton = function() {
    var ref;
    this.sendTrackyCallForHelpContentBeingShown(true);
    if (evaluate((ref = Groupon.Support.ContentModel) != null ? ref.isRefundEligible : void 0)) {
      return this.enableTicketDirectionButton();
    }
    this.$('.issue-check').show();
    this.$('.refund-my-request').hide();
    return this.$('.direct-ticket').hide();
  };

  StepTwoCMSBaseView.prototype.enableRefundRequestButton = function() {
    this.$('.refund-my-request').show();
    return this.$('.direct-ticket').hide();
  };

  StepTwoCMSBaseView.prototype.enableContinueToEmailButton = function() {
    this.$('.refund-my-request').hide();
    return this.$('.direct-ticket').show();
  };

  StepTwoCMSBaseView.prototype.helpContentCb = function(results) {
    if (results != null) {
      return this.helpContentSuccess(results);
    } else {
      return this.helpContentError();
    }
  };

  StepTwoCMSBaseView.prototype.checkIfTextHasClickToContinueSubString = function(text) {
    return (text != null) && (text.indexOf('"Continue"') > -1);
  };

  StepTwoCMSBaseView.prototype.getHelpContentPaths = function() {
    var url, urls;
    url = window.SUPPORTBASEURL + "/fetch?should_display_cms_content=" + experiments.shouldDisplayCMSContentForUS;
    urls = [url, url];
    this.addUrlsForPriorityContentAndFlexStepThree(urls);
    return urls;
  };

  StepTwoCMSBaseView.prototype.addUrlsForPriorityContentAndFlexStepThree = function(urls) {
    var i, j, noOfPriorityUrls, ref, ref1;
    if (((ref = Groupon.Support.currentOrder) != null ? ref.priorityTaglines : void 0) != null) {
      noOfPriorityUrls = 2 * Groupon.Support.currentOrder.priorityTaglines.length;
      for (i = j = 0, ref1 = noOfPriorityUrls; 0 <= ref1 ? j < ref1 : j > ref1; i = 0 <= ref1 ? ++j : --j) {
        urls.push(urls[0]);
      }
    }
    return urls;
  };

  StepTwoCMSBaseView.prototype.getTaglines = function() {
    var contentTagline, stepThreeTagline, tagLine, tagLines, tagLinesBase;
    tagLines = [];
    tagLinesBase = (this.getCategoryId()) + "," + (this.getSubCategoryId());
    tagLine = tagLinesBase + "," + this.tagLine;
    stepThreeTagline = {
      key: tagLine,
      base: "helpwizard_email_form",
      type: "flexible_step_three"
    };
    contentTagline = {
      key: tagLine,
      base: "helpwizard_content",
      type: "content"
    };
    this.setPriorityTaglinesForContent(tagLines, contentTagline, tagLinesBase);
    tagLines.push(contentTagline);
    this.setPriorityTaglinesForStepThree(tagLines, stepThreeTagline, tagLinesBase);
    tagLines.push(stepThreeTagline);
    return tagLines;
  };

  StepTwoCMSBaseView.prototype.isPriorityTaglinesPresent = function() {
    var ref, ref1;
    return ((ref = Groupon.Support.currentOrder) != null ? (ref1 = ref.priorityTaglines) != null ? ref1.length : void 0 : void 0) > 0;
  };

  StepTwoCMSBaseView.prototype.setPriorityTaglinesForGenericTagline = function(tagLinesData, taglineData, baseTagline) {
    var priorityTaglines;
    if (this.isPriorityTaglinesPresent()) {
      priorityTaglines = Groupon.Support.currentOrder.priorityTaglines;
      return _.each(priorityTaglines, function(priorityTagline) {
        var priorityTaglineData;
        priorityTaglineData = $.extend(true, {}, taglineData);
        priorityTaglineData.key = baseTagline + "," + priorityTagline;
        return tagLinesData.push(priorityTaglineData);
      });
    }
  };

  StepTwoCMSBaseView.prototype.setPriorityTaglinesForStepThree = function(tagLinesData, stepThreeTaglineData, baseTagline) {
    return this.setPriorityTaglinesForGenericTagline(tagLinesData, stepThreeTaglineData, baseTagline);
  };

  StepTwoCMSBaseView.prototype.setPriorityTaglinesForContent = function(tagLinesData, contentTaglineData, baseTagline) {
    return this.setPriorityTaglinesForGenericTagline(tagLinesData, contentTaglineData, baseTagline);
  };

  return StepTwoCMSBaseView;

})(StepTwoBaseView);

module.exports = StepTwoCMSBaseView;



},{"../../../helpers/API":51,"../base_view":206}],204:[function(require,module,exports){
var Mustache, StepTwoCMSBaseView, StepTwoV1CMSView, SupportMainContentWrapperView,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportMainContentWrapperView = require('../../main_content_view');

StepTwoCMSBaseView = require('./base_view');

Mustache = require('../../../../../../core/frontend/vendor_modules/mustache-0.7.2');

StepTwoV1CMSView = (function(superClass) {
  extend(StepTwoV1CMSView, superClass);

  function StepTwoV1CMSView() {
    this.helpContentError = bind(this.helpContentError, this);
    this.helpContentSuccess = bind(this.helpContentSuccess, this);
    return StepTwoV1CMSView.__super__.constructor.apply(this, arguments);
  }

  StepTwoV1CMSView.prototype.initialize = function() {
    return StepTwoCMSBaseView.prototype.initialize.apply(this, arguments);
  };

  StepTwoV1CMSView.prototype.render = function() {
    var content, mainContentWrappper;
    StepTwoCMSBaseView.prototype.render.call(this);
    mainContentWrappper = new SupportMainContentWrapperView;
    mainContentWrappper.render((function(_this) {
      return function(contentWrapper) {
        _this.renderProgressBar(contentWrapper);
        _this.renderOrderInfo(contentWrapper);
        _this.fetchFlexibleContactChannels(contentWrapper);
        return _this.fetchAndRenderCategory(contentWrapper);
      };
    })(this));
    this.$el.append(mainContentWrappper.el);
    this.renderStepTwoActions();
    this.renderLiveChat(this.$el);
    content = Groupon.Support.ContentModel.getContent();
    if (content != null) {
      return this.renderContent(content);
    }
  };

  StepTwoV1CMSView.prototype.renderContent = function(content) {
    var category_id, flexibleStepThree, sub_category_id, text;
    if (!(((content != null ? content.text : void 0) != null) && content.text !== "")) {
      this.helpContentLoadError();
      this.enableTicketDirectionButton();
      return;
    }
    text = Mustache.to_html(content.text, Groupon.Support.ContentModel.getContentObject());
    this.$('.inbenta-content').html(text);
    if ((text != null) && this.checkIfTextHasClickToContinueSubString(text)) {
      this.enableTicketDirectionButton();
    } else {
      this.enableResolvedButton();
    }
    flexibleStepThree = Groupon.Support.ContentModel.flexibleStepThree;
    if ((flexibleStepThree != null) && flexibleStepThree.method_of_contact === 'no_step_three') {
      this.hideContactUsButton();
    }
    category_id = this.getCategoryId();
    sub_category_id = this.getSubCategoryId();
    return this.$('.inbenta-content').attr("data-bhw", "hw__" + country.name + "__" + category_id + "__" + sub_category_id + "__" + content.id);
  };

  StepTwoV1CMSView.prototype.renderCategory = function(contentWrapper) {
    var contentCategory, isFilterDropdowns;
    this.categoryRendered = true;
    isFilterDropdowns = window.evaluate(typeof experiments !== "undefined" && experiments !== null ? experiments.filterDropdowns : void 0) ? true : false;
    contentWrapper.append(toHtml(this.categoryTemplate, {
      categories: this.getCategoryList(),
      isFilterDropdowns: isFilterDropdowns
    }, this.I18nScope));
    contentCategory = Groupon.Support.ContentModel.getCategory();
    if (contentCategory && contentCategory !== null) {
      $(".category", contentWrapper).val(contentCategory.id);
      $(".category option[value='" + contentCategory.id + "']", contentWrapper).attr("selected", "selected");
      return this.renderSubCategory(contentWrapper);
    }
  };

  StepTwoV1CMSView.prototype.clearContentElement = function() {
    return this.clearElement('.inbenta-content');
  };

  StepTwoV1CMSView.prototype.clearStepThreeIfPresent = function() {};

  StepTwoV1CMSView.prototype.helpContentSuccess = function(results) {
    var content;
    this.spinnerView.hide();
    content = this.resolveContent(results);
    Groupon.Support.ContentModel.flexibleStepThree = this.resolveFlexStepThree(results);
    this.setPriorityContentFlags(results);
    Groupon.Support.ContentModel.setContent(content);
    return this.renderContent(content);
  };

  StepTwoV1CMSView.prototype.helpContentError = function() {
    Groupon.Support.ContentModel.flexibleStepThree = null;
    Groupon.Support.ContentModel.setContent(null);
    this.helpContentLoadError();
    return this.enableTicketDirectionButton();
  };

  return StepTwoV1CMSView;

})(StepTwoCMSBaseView);

module.exports = StepTwoV1CMSView;



},{"../../../../../../core/frontend/vendor_modules/mustache-0.7.2":6,"../../main_content_view":155,"./base_view":203}],205:[function(require,module,exports){
var Mustache, StepTwoCMSBaseView, StepTwoV2CMSView, SupportMainContentWrapperView,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportMainContentWrapperView = require('../../main_content_view');

StepTwoCMSBaseView = require('./base_view');

Mustache = require('../../../../../../core/frontend/vendor_modules/mustache-0.7.2');

StepTwoV2CMSView = (function(superClass) {
  extend(StepTwoV2CMSView, superClass);

  function StepTwoV2CMSView() {
    this.helpContentError = bind(this.helpContentError, this);
    this.helpContentSuccess = bind(this.helpContentSuccess, this);
    return StepTwoV2CMSView.__super__.constructor.apply(this, arguments);
  }

  StepTwoV2CMSView.prototype.initialize = function() {
    return StepTwoCMSBaseView.prototype.initialize.apply(this, arguments);
  };

  StepTwoV2CMSView.prototype.render = function() {
    var content, mainContentWrappper;
    StepTwoCMSBaseView.prototype.render.call(this);
    mainContentWrappper = new SupportMainContentWrapperView;
    mainContentWrappper.render((function(_this) {
      return function(contentWrapper) {
        _this.fetchFlexibleContactChannels(contentWrapper);
        return _this.fetchAndRenderCategory(contentWrapper);
      };
    })(this));
    this.$el.append(mainContentWrappper.el);
    this.renderStepTwoActions();
    content = Groupon.Support.ContentModel.getContent();
    if (content != null) {
      return this.renderContent(content);
    }
  };

  StepTwoV2CMSView.prototype.renderContent = function(content) {
    var attributeValue, category_id, sub_category_id, text;
    if (!(((content != null ? content.text : void 0) != null) && content.text !== "")) {
      this.helpContentLoadError();
      return;
    }
    text = Mustache.to_html(content.text, Groupon.Support.ContentModel.getContentObject());
    category_id = this.getCategoryId();
    sub_category_id = this.getSubCategoryId();
    attributeValue = "hw__" + country.name + "__" + category_id + "__" + sub_category_id + "__" + content.id;
    this.renderContentData(text, attributeValue);
    return this.enableStepActions();
  };

  StepTwoV2CMSView.prototype.clearContentElement = function() {
    this.clearElement('.cms-content');
    this.$('.content-section').hide();
    return this.clearStepThreeIfPresent();
  };

  StepTwoV2CMSView.prototype.clearStepThreeIfPresent = function() {
    if ((Groupon.Support.CURRENTVIEW != null) && Groupon.Support.CURRENTVIEW.id !== this.id) {
      Groupon.Support.HelpWizardViewManager.removeStackedViewsAndUpdateCurrentView(this);
      return propagateEventBeforeReplacingElements(function() {
        return Backbone.history.navigate("#select-issue", {
          trigger: false
        });
      });
    }
  };

  StepTwoV2CMSView.prototype.renderCategory = function(contentWrapper) {
    var contentCategory;
    this.categoryRendered = true;
    contentWrapper.html(toHtml(this.categoryTemplate, {
      categories: this.getCategoryList(),
      isFilterDropdowns: true,
      showVerticalPageFlow: true
    }, this.I18nScope));
    contentCategory = Groupon.Support.ContentModel.getCategory();
    if (contentCategory && contentCategory !== null) {
      $(".category", contentWrapper).val(contentCategory.id);
      $(".category option[value='" + contentCategory.id + "']", contentWrapper).attr("selected", "selected");
      return this.renderSubCategory(contentWrapper);
    }
  };

  StepTwoV2CMSView.prototype.enableStepActions = function() {
    return this.handleDisplayOfTicketDirectionButtons();
  };

  StepTwoV2CMSView.prototype.helpContentSuccess = function(results) {
    var content;
    this.spinnerView.hide();
    content = this.resolveContent(results);
    Groupon.Support.ContentModel.flexibleStepThree = this.resolveFlexStepThree(results);
    this.setPriorityContentFlags(results);
    Groupon.Support.ContentModel.setContent(content);
    return this.renderContent(content);
  };

  StepTwoV2CMSView.prototype.helpContentLoadError = function() {
    var category_id, sub_category_id;
    this.spinnerView.hide();
    category_id = this.getCategoryId();
    sub_category_id = this.getSubCategoryId();
    this.clearElement('.cms-content');
    this.$('.content-section').hide();
    this.disableAllButton();
    return Backbone.history.navigate('#contact-us', {
      trigger: true
    });
  };

  StepTwoV2CMSView.prototype.renderContentData = function(text, attributeValue) {
    this.$('.inbenta-content').empty();
    this.$('.content-section').show();
    this.$('.cms-content').attr("data-bhw", attributeValue);
    return this.$('.cms-content').html(text);
  };

  StepTwoV2CMSView.prototype.helpContentError = function() {
    Groupon.Support.ContentModel.flexibleStepThree = null;
    Groupon.Support.ContentModel.setContent(null);
    return this.helpContentLoadError();
  };

  StepTwoV2CMSView.prototype.filterDropdowns = function(dropdowns, allTags) {
    return _.filter(dropdowns, (function(_this) {
      return function(item) {
        if (item.tagLines == null) {
          return true;
        }
        return _.some(item.tagLines, function(tl) {
          var commonTags, filterTags;
          filterTags = tl.split(",");
          commonTags = _.intersection(allTags, filterTags);
          return commonTags.length === allTags.length;
        });
      };
    })(this));
  };

  StepTwoV2CMSView.prototype.getCategoryList = function() {
    var allTags, dropdowns;
    dropdowns = this.getDropdowns();
    dropdowns = this.addTaglinesToCategories(dropdowns);
    if (this.tagLine != null) {
      allTags = this.tagLine.split(",");
      dropdowns = this.filterDropdowns(dropdowns, allTags);
    }
    return _.sortBy(dropdowns, function(category) {
      return parseInt(category.weight);
    });
  };

  StepTwoV2CMSView.prototype.getSubCategoryList = function() {
    var allTags, category, dropdowns, subCategories;
    dropdowns = this.getDropdowns();
    category = _.find(dropdowns, function(item) {
      return item.id === Groupon.Support.ContentModel.getCategory().id;
    });
    subCategories = category.subCategories;
    if (this.tagLine != null) {
      allTags = this.tagLine.split(",");
      subCategories = this.filterDropdowns(subCategories, allTags);
    }
    return _.sortBy(subCategories, function(s) {
      return parseInt(s.weight);
    });
  };

  StepTwoV2CMSView.prototype.addTaglinesToCategories = function(dropdowns) {
    _.each(dropdowns, function(category) {
      var categoryTaglines;
      categoryTaglines = [];
      _.each(category.subCategories, function(subCategory) {
        return categoryTaglines.push(subCategory.tagLines);
      });
      categoryTaglines = _.uniq(_.flatten(categoryTaglines));
      return category.tagLines = categoryTaglines;
    });
    return dropdowns;
  };

  StepTwoV2CMSView.prototype.shouldFetchFlexibleContactChannels = function() {
    return !this.flexibleContactChannelModel.hasContactChannels();
  };

  return StepTwoV2CMSView;

})(StepTwoCMSBaseView);

module.exports = StepTwoV2CMSView;



},{"../../../../../../core/frontend/vendor_modules/mustache-0.7.2":6,"../../main_content_view":155,"./base_view":203}],206:[function(require,module,exports){
var Backbone, SharedAjaxErrorView, SharedSpinnerView, SharedWidgetLayoutView, StepTwoBaseView, SupportCategoryDropdownTemplate, SupportErrorHelper, SupportProgressBarView, SupportStepActionsView, SupportStepTwoActionsTemplate, SupportSubCategoryDropdownTemplate, SupportUtilsHelper,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportProgressBarView = require('../progress_bar_view');

SupportStepActionsView = require('../step_actions_view');

SharedAjaxErrorView = require('../../../../shared/frontend/views/ajax_error_view');

SupportErrorHelper = require('../../helpers/error');

SharedSpinnerView = require('../../../../shared/frontend/views/spinner_view');

SupportUtilsHelper = require('../../helpers/utils');

SharedWidgetLayoutView = require('../../../../shared/frontend/views/widget_layout_veiw');

Backbone = require('backbone');

Backbone.$ = $;

SupportStepTwoActionsTemplate = require('../../../step_two_actions.html.mustache');

SupportCategoryDropdownTemplate = require('../../../category_dropdown.html.mustache');

SupportSubCategoryDropdownTemplate = require('../../../sub_category_dropdown.html.mustache');

StepTwoBaseView = (function(superClass) {
  extend(StepTwoBaseView, superClass);

  function StepTwoBaseView() {
    this.subCategoryChangeCallback = bind(this.subCategoryChangeCallback, this);
    return StepTwoBaseView.__super__.constructor.apply(this, arguments);
  }

  StepTwoBaseView.prototype.className = 'step-two';

  StepTwoBaseView.prototype.events = {
    'general-message .inbenta-content': 'enableTicketDirectionButton',
    'help-text .inbenta-content': 'enableResolvedButton',
    'no-answer .inbenta-content': 'enableTicketDirectionButton',
    'change .category': 'setCategoryToWindow',
    'change .sub-category': 'subCategoryChangeCallback',
    'click .view_fine_print': 'renderFinePrint',
    'click #continueToTicket': 'disableAllButton',
    "click #orderNotListed": "disableAllButton",
    'click #merchant_link': 'renderPickOrder'
  };

  StepTwoBaseView.prototype.initialize = function(options) {
    this.options = options || {};
    this.I18nScope = 'modules.support';
    if (Groupon.Support.MAXINDEX === 2) {
      this.id = 1;
    } else {
      this.id = 2;
    }
    this.categoryTemplate = SupportCategoryDropdownTemplate;
    this.subCategoryTemplate = SupportSubCategoryDropdownTemplate;
    this.tagLine = Groupon.Support.Tagline;
    this.dropDownModel = this.options.dropDownModel;
    this.errorView = new SharedAjaxErrorView();
    this.spinnerView = new SharedSpinnerView();
    return this.flexibleContactChannelModel = Groupon.Support.FlexibleContactChannelModel;
  };

  StepTwoBaseView.prototype.hideComponents = function() {
    window.hideFooterLinks();
    if ($("#intl_footer").length > 0) {
      $("#intl_footer").hide();
    }
    SupportUtilsHelper.hideFloatingBoldChat();
    return SharedWidgetLayoutView.hideWidgets();
  };

  StepTwoBaseView.prototype.renderProgressBar = function(contentWrapper) {
    var progressBar;
    progressBar = new SupportProgressBarView;
    progressBar.render();
    return contentWrapper.append(progressBar.el);
  };

  StepTwoBaseView.prototype.renderOrderInfo = function(contentWrapper) {
    var merchant, order;
    if (Groupon.Support.currentOrder && Groupon.Support.currentOrder !== null) {
      order = Groupon.Support.currentOrder;
      merchant = getDealMerchantName();
      return contentWrapper.append("<h6 class='cb'><span id='tellUs'>" + (I18n.t('js.modules.support.tellusaboutorder')) + "</span> <span id='merchant_link' data-bhw='merchant_link'><a class='deal-title'>" + merchant + "</a>.</span></h6>");
    } else {
      return contentWrapper.append("<h6 class='cb'><span id='tellUs'>" + (I18n.t('js.modules.support.tellusaboutproblem')) + "</span></h6>");
    }
  };

  StepTwoBaseView.prototype.renderLiveChat = function(childViewElem) {
    var liveChatmode;
    liveChatmode = Groupon.Support.LiveChatModel.getDefaultStepTwoLiveChatMode();
    if (Groupon.Support.LiveChatModel.shouldShowStepTwoLiveChat()) {
      Groupon.Support.LiveChatView.setLiveChat(liveChatmode, Groupon.Support.LiveChatModel.getDefaultLiveChatType());
      Groupon.Support.LiveChatView.renderView(childViewElem, {});
      return SupportUtilsHelper.showFloatingBoldChat();
    }
  };

  StepTwoBaseView.prototype.handleAjaxErrors = function() {
    return this.errorView.render({
      container: this.$el
    });
  };

  StepTwoBaseView.prototype.filterDropdowns = function(dropdowns, allTags) {
    return _.filter(dropdowns, (function(_this) {
      return function(item) {
        if (item.tagLines == null) {
          return true;
        }
        return _.some(item.tagLines, function(tl) {
          var commonTags, filterTags;
          filterTags = tl.split(";");
          commonTags = _.intersection(allTags, filterTags);
          return commonTags.length === filterTags.length;
        });
      };
    })(this));
  };

  StepTwoBaseView.prototype.getCategoryList = function() {
    var allTags, dropdowns;
    dropdowns = this.getDropdowns();
    if (window.evaluate(typeof experiments !== "undefined" && experiments !== null ? experiments.filterDropdowns : void 0) && (this.tagLine != null)) {
      allTags = this.tagLine.split(",");
      dropdowns = this.filterDropdowns(dropdowns, allTags);
    }
    return _.sortBy(dropdowns, function(category) {
      return parseInt(category.weight);
    });
  };

  StepTwoBaseView.prototype.getSubCategoryList = function() {
    var allTags, category, dropdowns, subCategories;
    dropdowns = this.getDropdowns();
    category = _.find(dropdowns, function(item) {
      return item.id === Groupon.Support.ContentModel.getCategory().id;
    });
    subCategories = category.subCategories;
    if (window.evaluate(typeof experiments !== "undefined" && experiments !== null ? experiments.filterDropdowns : void 0) && (this.tagLine != null)) {
      allTags = this.tagLine.split(",");
      subCategories = this.filterDropdowns(subCategories, allTags);
    }
    return _.sortBy(subCategories, function(s) {
      return parseInt(s.weight);
    });
  };

  StepTwoBaseView.prototype.getDropdowns = function() {
    return this.dropDownModel.attributes;
  };

  StepTwoBaseView.prototype.renderStepTwoActions = function() {
    var stepActions;
    stepActions = new SupportStepActionsView({
      template: SupportStepTwoActionsTemplate
    });
    stepActions.render();
    this.$el.append(stepActions.el);
    if (Groupon.Support.MAXINDEX === 2) {
      return this.$('.back').hide();
    }
  };

  StepTwoBaseView.prototype.hideContactUsButton = function() {
    return this.$('.contact-us').hide();
  };

  StepTwoBaseView.prototype.disableAllButton = function() {
    this.$('.issue-check').hide();
    this.$('.direct-ticket').hide();
    return this.$('.refund-my-request').hide();
  };

  StepTwoBaseView.prototype.sendTrackyCallForHelpContentBeingShown = function(isHelpContentProper) {
    var data;
    data = {
      categoryId: this.getSubCategoryId(),
      subCategoryId: this.getSubCategoryId(),
      tagline: Groupon.Support.Tagline,
      country: window.country.name,
      contentId: Groupon.Support.ContentModel.getContentId()
    };
    if (isHelpContentProper) {
      return TrackingHub.add("help-content-shown", {
        helpContentShown: data
      });
    } else {
      return TrackingHub.add("help-content-not-shown", {
        helpContentNotShown: data
      });
    }
  };

  StepTwoBaseView.prototype.helpContentLoadError = function() {
    var category_id, sub_category_id;
    this.spinnerView.hide();
    category_id = this.getCategoryId();
    sub_category_id = this.getSubCategoryId();
    this.$('.inbenta-content').attr("data-bhw", "hw__" + country.name + "__" + category_id + "__" + sub_category_id + "__no-content-shown");
    return this.$('.inbenta-content').html(I18n.t("js.modules.support.default_help_text"));
  };

  StepTwoBaseView.prototype.getCategoryId = function() {
    var category_id, contentCategory;
    contentCategory = Groupon.Support.ContentModel.getCategory();
    return category_id = (contentCategory != null ? contentCategory.id : void 0) != null ? contentCategory.id : null;
  };

  StepTwoBaseView.prototype.getSubCategoryId = function() {
    var contentSubCategory, sub_category_id;
    contentSubCategory = Groupon.Support.ContentModel.getSubCategory();
    return sub_category_id = (contentSubCategory != null ? contentSubCategory.id : void 0) != null ? contentSubCategory.id : null;
  };

  StepTwoBaseView.prototype.subCategoryChangeCallback = function() {
    this.setSubCategoryToWindow();
    return this.setFlexibleContactChannels();
  };

  StepTwoBaseView.prototype.clearElement = function(elem) {
    return this.$(elem).empty();
  };

  StepTwoBaseView.prototype.close = function() {};

  StepTwoBaseView.prototype.renderFinePrint = function() {
    return SupportUtilsHelper.renderFinePrint();
  };

  StepTwoBaseView.prototype.renderPickOrder = function() {
    window.selectOrderFromMygroupons = false;
    return propagateEventBeforeReplacingElements(function() {
      return Backbone.history.navigate('#pick-order', {
        trigger: true
      });
    });
  };

  StepTwoBaseView.prototype.shouldFetchFlexibleContactChannels = function() {
    return this.isFlexibleContactChannelsEnabled() && !this.flexibleContactChannelModel.hasContactChannels();
  };

  StepTwoBaseView.prototype.isFlexibleContactChannelsEnabled = function() {
    return window.evaluate(window.experiments.showFlexibleContactChannels);
  };

  StepTwoBaseView.prototype.areIdsSame = function(id1, id2) {
    if ((id1 != null) && (id2 != null)) {
      id1 = id1.toLowerCase();
      id2 = id2.toLowerCase();
      return (id1.indexOf(id2) > -1) || (id2.indexOf(id1) > -1);
    } else {
      return false;
    }
  };

  StepTwoBaseView.prototype.findFlexibleContactChanel = function(categoryId, subcategoryId) {
    var categoryList, contactChannels, contactChannelsForSelectedCategory, matchedCategory;
    contactChannels = this.flexibleContactChannelModel.getContactChannels();
    if ((contactChannels != null) && (categoryId != null) && (subcategoryId != null)) {
      categoryList = _.keys(contactChannels);
      matchedCategory = _.find(categoryList, (function(_this) {
        return function(source) {
          return _this.areIdsSame(source, categoryId);
        };
      })(this));
      if (matchedCategory != null) {
        contactChannelsForSelectedCategory = $.extend(true, {}, contactChannels[matchedCategory].subCategories);
        return _.find(contactChannelsForSelectedCategory, (function(_this) {
          return function(channel) {
            return _this.areIdsSame(channel != null ? channel.id : void 0, subcategoryId);
          };
        })(this));
      }
    }
  };

  StepTwoBaseView.prototype.setFlexibleContactChannels = function() {
    var categoryId, contactChannelsForDropdown, ref, ref1, subcategoryId;
    if (this.isFlexibleContactChannelsEnabled()) {
      categoryId = (ref = Groupon.Support.ContentModel.getCategory()) != null ? ref.id : void 0;
      subcategoryId = (ref1 = Groupon.Support.ContentModel.getSubCategory()) != null ? ref1.id : void 0;
      contactChannelsForDropdown = this.findFlexibleContactChanel(categoryId, subcategoryId);
      if (contactChannelsForDropdown == null) {
        if (this.flexibleContactChannelModel.getContactChannels() != null) {
          TrackingHub.add("flexible-contactChannel-missing", SupportErrorHelper.constructFlexibleContactChannelMissingMessage());
        }
        return this.flexibleContactChannelModel.invalidateFlexibleContactChannels();
      }
      delete contactChannelsForDropdown.id;
      delete contactChannelsForDropdown.text;
      _.each(contactChannelsForDropdown, (function(_this) {
        return function(value, key) {
          if (value == null) {
            return delete contactChannelsForDropdown[key];
          }
        };
      })(this));
      return this.flexibleContactChannelModel.setFlexibleContactChannels(contactChannelsForDropdown);
    }
  };

  return StepTwoBaseView;

})(Backbone.View);

module.exports = StepTwoBaseView;



},{"../../../../shared/frontend/views/ajax_error_view":19,"../../../../shared/frontend/views/spinner_view":24,"../../../../shared/frontend/views/widget_layout_veiw":25,"../../../category_dropdown.html.mustache":34,"../../../step_two_actions.html.mustache":235,"../../../sub_category_dropdown.html.mustache":237,"../../helpers/error":53,"../../helpers/utils":54,"../progress_bar_view":192,"../step_actions_view":194,"backbone":245}],207:[function(require,module,exports){
var StepTwoBaseView, StepTwoInbentaBaseView, SupportMainContentWrapperView,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportMainContentWrapperView = require('../../main_content_view');

StepTwoBaseView = require('../base_view');

StepTwoInbentaBaseView = (function(superClass) {
  extend(StepTwoInbentaBaseView, superClass);

  function StepTwoInbentaBaseView() {
    this.getHelpContenteErrorCb = bind(this.getHelpContenteErrorCb, this);
    this.getHelpContentSuccessCb = bind(this.getHelpContentSuccessCb, this);
    return StepTwoInbentaBaseView.__super__.constructor.apply(this, arguments);
  }

  StepTwoInbentaBaseView.prototype.initialize = function(options) {
    this.options = options || {};
    StepTwoBaseView.prototype.initialize.apply(this, arguments);
    this.isInbentaContentShown = false;
    this.dropDownCombinationsModel = this.options.dropDownCombinationsModel;
    if (this.dropDownCombinationsModel.has('flexStepThree')) {
      this.dropdownCombinations = this.dropDownCombinationsModel.attributes;
    }
    return this.flexStepThree = {
      allowed: false,
      responseReceived: false,
      dropdownCombinations: this.dropdownCombinations
    };
  };

  StepTwoInbentaBaseView.prototype.resetFlexStepThree = function() {
    this.flexStepThree.allowed = false;
    return this.flexStepThree.responseReceived = false;
  };

  StepTwoInbentaBaseView.prototype.render = function() {
    var mainContentWrappper;
    Groupon.Support.ContentModel.onInitStepTwo();
    this.fetchFlexibleContactChannels();
    this.hideComponents();
    toggleCallUs(Groupon.Support.CURRENTVIEW.id);
    mainContentWrappper = new SupportMainContentWrapperView;
    mainContentWrappper.render((function(_this) {
      return function(contentWrapper) {
        _this.renderProgressBar(contentWrapper);
        _this.renderOrderInfo(contentWrapper);
        _this.fetchAndRenderCategory(contentWrapper);
        return _this.renderInbentaSearchBox(contentWrapper);
      };
    })(this));
    this.$el.append(mainContentWrappper.el);
    this.renderStepTwoActions();
    return this.renderLiveChat(this.$el);
  };

  StepTwoInbentaBaseView.prototype.isFlexStepThreeAllowed = function() {
    var taglineSelected;
    taglineSelected = (this.getCategoryId()) + "," + (this.getSubCategoryId());
    this.flexStepThree['allowed'] = (typeof experiments !== "undefined" && experiments !== null ? experiments.flexStepThreeForUS : void 0) && _.indexOf(this.dropDownCombinationsModel.get('flexStepThree'), taglineSelected) !== -1;
    return this.flexStepThree['allowed'];
  };

  StepTwoInbentaBaseView.prototype.getHelpContentSuccessCb = function() {
    return this.helpContentSuccess;
  };

  StepTwoInbentaBaseView.prototype.getHelpContenteErrorCb = function() {
    return this.helpContentError;
  };

  StepTwoInbentaBaseView.prototype.isCategoryAndSubcategorySelected = function() {
    return (Groupon.Support.ContentModel.getCategory() != null) && (Groupon.Support.ContentModel.getSubCategory() != null);
  };

  StepTwoInbentaBaseView.prototype.getHelpContentPaths = function() {
    var url, urls;
    url = window.SUPPORTBASEURL + "/fetch";
    return urls = [url];
  };

  StepTwoInbentaBaseView.prototype.getTaglines = function() {
    var base;
    base = (this.getCategoryId()) + "," + (this.getSubCategoryId());
    return [
      {
        key: base,
        base: "helpwizard_email_form",
        type: "flexible_step_three"
      }
    ];
  };

  StepTwoInbentaBaseView.prototype.fetchFlexibleContactChannels = function() {
    if (this.shouldFetchFlexibleContactChannels()) {
      this.flexibleContactChannelModel.setFetchContactChannelFromCMS();
      return this.flexibleContactChannelModel.fetch();
    }
  };

  return StepTwoInbentaBaseView;

})(StepTwoBaseView);

module.exports = StepTwoInbentaBaseView;



},{"../../main_content_view":155,"../base_view":206}],208:[function(require,module,exports){
var StepTwoInbentaBaseView, StepTwoInbentaNLPView, SupportAPIHelper, SupportMainContentWrapperView, SupportSearchInputView,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportMainContentWrapperView = require('../../main_content_view');

SupportSearchInputView = require('../../search_input_view');

StepTwoInbentaBaseView = require('./base_view');

SupportAPIHelper = require('../../../helpers/API');

StepTwoInbentaNLPView = (function(superClass) {
  extend(StepTwoInbentaNLPView, superClass);

  function StepTwoInbentaNLPView() {
    this.initiateInbentaEvents = bind(this.initiateInbentaEvents, this);
    this.simulatedDropdownsCb = bind(this.simulatedDropdownsCb, this);
    this.helpContentError = bind(this.helpContentError, this);
    this.setFlexStepThreeComb = bind(this.setFlexStepThreeComb, this);
    this.helpContentSuccess = bind(this.helpContentSuccess, this);
    return StepTwoInbentaNLPView.__super__.constructor.apply(this, arguments);
  }

  StepTwoInbentaNLPView.prototype.initialize = function() {
    if (Groupon.Support.FeatureFlagModel.isSearchBasedDropDownsEnabled()) {
      window.simulateDropdownSelection();
      this.initiateInbentaEvents();
    }
    StepTwoInbentaBaseView.prototype.initialize.apply(this, arguments);
    return this.searchInputView = new SupportSearchInputView();
  };

  StepTwoInbentaNLPView.prototype.fetchAndRenderCategory = function(contentWrapper) {
    if (!this.dropDownCombinationsModel.has('flexStepThree')) {
      startTimer("t_dc");
      return this.dropDownCombinationsModel.fetch({
        data: null,
        success: (function(_this) {
          return function(model, response, options) {
            stopTimer("t_dc");
            return _this.handleDropdownsCb(contentWrapper, response);
          };
        })(this),
        error: (function(_this) {
          return function(model, response, options) {
            stopTimer("t_dc");
            return _this.handleDropdownsCb(contentWrapper, response);
          };
        })(this)
      });
    }
  };

  StepTwoInbentaNLPView.prototype.renderInbentaSearchBox = function(contentWrapper) {
    this.searchInputView.render();
    return contentWrapper.append(this.searchInputView.el);
  };

  StepTwoInbentaNLPView.prototype.handleDropdownsCb = function(contentWrapper, response) {
    return this.setFlexStepThreeComb(response);
  };

  StepTwoInbentaNLPView.prototype.helpContentSuccess = function(results) {
    this.spinnerView.hide({
      container: $('#nlp-spinner')
    });
    if (((results != null ? results.length : void 0) != null) > 0) {
      Groupon.Support.ContentModel.flexibleStepThree = results[0];
    }
    this.flexStepThree['responseReceived'] = true;
    if (this.inbentaEventType) {
      return this.callInbentaEventCb();
    }
  };

  StepTwoInbentaNLPView.prototype.fetchDropdownCombinations = function() {
    return this.dropDownCombinationsModel.attributes;
  };

  StepTwoInbentaNLPView.prototype.setFlexStepThreeComb = function(response) {
    var ref;
    this.flexStepThree.dropdownCombinations = (ref = response.flexStepThree) != null ? ref['dropdownCombinations'] : void 0;
    return this.flexStepThree['responseReceived'] = true;
  };

  StepTwoInbentaNLPView.prototype.helpContentError = function() {
    this.spinnerView.hide({
      container: $('#nlp-spinner')
    });
    this.flexStepThree['responseReceived'] = true;
    if (this.inbentaEventType != null) {
      return this.callInbentaEventCb();
    }
  };

  StepTwoInbentaNLPView.prototype.callInbentaEventCb = function() {
    if (this.inbentaEventType === 'solved-feedback') {
      return this.step2SolvedFeedBackCb();
    } else if (this.inbentaEventType === 'step2-continue-disabled') {
      return this.step2ContinueDisabledCb();
    } else if (this.inbentaEventType === 'step2-continue-enabled') {
      return this.step2ContinueEnabledCb();
    }
  };

  StepTwoInbentaNLPView.prototype.step2SolvedFeedBackCb = function() {
    var ref, ref1;
    if (((ref = this.flexStepThree) != null ? ref['allowed'] : void 0) && !((ref1 = this.flexStepThree) != null ? ref1['responseReceived'] : void 0)) {
      return this.inbentaEventType = 'solved-feedback';
    }
    this.isInbentaContentShown = true;
    this.sendTrackyCallForHelpContentBeingShown(true);
    $('.direct-ticket').css('display', 'none');
    $('.issue-check').css('display', 'block');
    return $('#contact-us').attr('disabled', false);
  };

  StepTwoInbentaNLPView.prototype.step2ContinueDisabledCb = function(event) {
    var ref, ref1;
    if (((ref = this.flexStepThree) != null ? ref['allowed'] : void 0) && !((ref1 = this.flexStepThree) != null ? ref1['responseReceived'] : void 0)) {
      return this.inbentaEventType = 'step2-continue-disabled';
    }
    this.isInbentaContentShown = true;
    this.sendTrackyCallForHelpContentBeingShown(true);
    $('.issue-check').css('display', 'none');
    $('.direct-ticket').css('display', 'block');
    return $('#continueToTicket').attr('disabled', true);
  };

  StepTwoInbentaNLPView.prototype.step2ContinueEnabledCb = function(event) {
    var ref, ref1;
    if (((ref = this.flexStepThree) != null ? ref['allowed'] : void 0) && !((ref1 = this.flexStepThree) != null ? ref1['responseReceived'] : void 0)) {
      return this.inbentaEventType = 'step2-continue-enabled';
    }
    this.isInbentaContentShown = true;
    this.sendTrackyCallForHelpContentBeingShown(false);
    $('.issue-check').css('display', 'none');
    $('.direct-ticket').css('display', 'block');
    return $('#continueToTicket').attr('disabled', false);
  };

  StepTwoInbentaNLPView.prototype.fetchHelpContent = function(inbentaEventType) {
    var data, urls;
    this.inbentaEventType = inbentaEventType;
    if (this.isFlexStepThreeAllowed()) {
      this.spinnerView.show({
        container: $('#nlp-spinner')
      });
      this.resetFlexStepThree();
      urls = this.getHelpContentPaths();
      data = this.getTaglines();
      this.contentRequests = SupportAPIHelper.parallel(urls, data, this.getHelpContentSuccessCb(), this.getHelpContenteErrorCb(), false, "t_ic", 60000);
    } else {
      Groupon.Support.ContentModel.flexibleStepThree = null;
      this.callInbentaEventCb();
    }
    return this.setFlexibleContactChannels();
  };

  StepTwoInbentaNLPView.prototype.simulatedDropdownsCb = function(inbentaEventType) {
    return this.fetchHelpContent(inbentaEventType);
  };

  StepTwoInbentaNLPView.prototype.initiateInbentaEvents = function() {
    $(document).bind('step2-solved-feedback', (function(_this) {
      return function(event) {
        return _this.step2SolvedFeedBackCb(event);
      };
    })(this));
    $(document).bind('step2-continue-disabled', (function(_this) {
      return function(event) {
        return _this.step2ContinueDisabledCb(event);
      };
    })(this));
    return $(document).bind('step2-continue-enabled', (function(_this) {
      return function(event) {
        return _this.step2ContinueEnabledCb(event);
      };
    })(this));
  };

  return StepTwoInbentaNLPView;

})(StepTwoInbentaBaseView);

window.simulateDropdownSelection = function() {
  if (Groupon.Support.FeatureFlagModel.isSearchBasedDropDownsEnabled()) {
    return window.InbentaHelpWizard.prototype.simulateDropdownSelection = function(targetElement) {
      var category, ref, searchText, subcategory;
      category = '';
      subcategory = '';
      $(targetElement).find('.hwcategories').each(function() {
        var currentCat, currentSubcat;
        if (!category || !subcategory) {
          currentCat = $.trim($(this).find('.hwcategory').text());
          currentSubcat = $.trim($(this).find('.hwsubcategory').text());
          category = currentCat;
          return subcategory = currentSubcat;
        }
      });
      if (!this.step2firstDropdownSelection && (!category || !subcategory)) {
        category = this.step2defaultDropdownSelection.category;
        subcategory = this.step2defaultDropdownSelection.subcategory;
      }
      if (category && subcategory) {
        Groupon.Support.Inbenta.Category = {
          text: category,
          id: this.getDropdownCategoryKeyValue(category)
        };
        Groupon.Support.Inbenta.SubCategory = {
          text: subcategory,
          id: this.getDropdownCategoryKeyValue(subcategory)
        };
        searchText = $('.inbenta-searchform-container #inbenta-searchform #inbenta-searchinput').val() || "";
        if ((searchText != null ? searchText.length : void 0) > 0) {
          searchText = searchText.trim();
        }
        if ((searchText != null ? searchText.length : void 0) === 0 && $(targetElement).hasClass('hwresult')) {
          this.step2firstDropdownSelection = false;
          Groupon.Support.StepTwoView.simulatedDropdownsCb('step2-continue-enabled');
          Groupon.Support.Inbenta.searchInputIssue = (ref = Groupon.Support.Inbenta.SubCategory) != null ? ref.text : void 0;
        } else {
          this.step2firstDropdownSelection = true;
          Groupon.Support.StepTwoView.simulatedDropdownsCb(null);
          Groupon.Support.Inbenta.searchInputIssue = searchText;
        }
      }
      return $.event.trigger('simulated-dropdowns');
    };
  }
};

module.exports = StepTwoInbentaNLPView;



},{"../../../helpers/API":51,"../../main_content_view":155,"../../search_input_view":193,"./base_view":207}],209:[function(require,module,exports){
var StepTwoInbentaBaseView, StepTwoInbentaNonNLPView, SupportAPIHelper, SupportErrorHelper, SupportMainContentWrapperView,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportMainContentWrapperView = require('../../main_content_view');

StepTwoInbentaBaseView = require('./base_view');

SupportAPIHelper = require('../../../helpers/API');

SupportErrorHelper = require('../../../helpers/error');

StepTwoInbentaNonNLPView = (function(superClass) {
  extend(StepTwoInbentaNonNLPView, superClass);

  function StepTwoInbentaNonNLPView() {
    this.callTimeoutFn = bind(this.callTimeoutFn, this);
    this.callInbentaEventCb = bind(this.callInbentaEventCb, this);
    this.helpContentError = bind(this.helpContentError, this);
    this.helpContentSuccess = bind(this.helpContentSuccess, this);
    this.enableTicketDirectionButton = bind(this.enableTicketDirectionButton, this);
    this.enableResolvedButton = bind(this.enableResolvedButton, this);
    return StepTwoInbentaNonNLPView.__super__.constructor.apply(this, arguments);
  }

  StepTwoInbentaNonNLPView.prototype.initialize = function() {
    return StepTwoInbentaBaseView.prototype.initialize.apply(this, arguments);
  };

  StepTwoInbentaNonNLPView.prototype.renderInbentaSearchBox = function(contentWrapper) {};

  StepTwoInbentaNonNLPView.prototype.fetchAndRenderCategory = function(contentWrapper) {
    if (this.dropDownModel.has('categories')) {
      return this.renderCategory(contentWrapper);
    } else {
      this.spinnerView.show({
        container: contentWrapper,
        append: true,
        height: '50px'
      });
      startTimer("t_dc");
      return $.when(this.dropDownModel.fetch(), this.dropDownCombinationsModel.fetch()).done((function(_this) {
        return function(model, response, options) {
          var ref;
          stopTimer("t_dc");
          _this.flexStepThree.dropdownCombinations = (ref = response.flexStepThree) != null ? ref['dropdownCombinations'] : void 0;
          _this.spinnerView.remove();
          return _this.handleDropdownsCb(contentWrapper);
        };
      })(this)).fail((function(_this) {
        return function() {
          _this.spinnerView.remove();
          return _this.handleAjaxErrors();
        };
      })(this));
    }
  };

  StepTwoInbentaNonNLPView.prototype.handleDropdownsCb = function(contentWrapper) {
    return this.renderCategory(contentWrapper);
  };

  StepTwoInbentaNonNLPView.prototype.renderCategory = function(contentWrapper) {
    var categoryArray, contentCategory, isFilterDropdowns;
    isFilterDropdowns = window.evaluate(typeof experiments !== "undefined" && experiments !== null ? experiments.filterDropdowns : void 0) ? true : false;
    categoryArray = this.getCategoryList();
    contentWrapper.append(toHtml(this.categoryTemplate, {
      categories: categoryArray,
      isFilterDropdowns: isFilterDropdowns
    }, this.I18nScope));
    contentCategory = Groupon.Support.ContentModel.getCategory();
    if (contentCategory && contentCategory !== null) {
      $(".category", contentWrapper).val(contentCategory.id);
      $(".category option[value='" + contentCategory.id + "']", contentWrapper).attr("selected", "selected");
      return this.renderSubCategory(contentWrapper);
    }
  };

  StepTwoInbentaNonNLPView.prototype.renderSubCategory = function(contentWrapper) {
    var contentSubCategory, subdropdwn;
    this.disableAllButton();
    subdropdwn = $('.sub-dropdown', contentWrapper);
    subdropdwn.html("");
    subdropdwn.html(toHtml(this.subCategoryTemplate, {
      subCategories: this.getSubCategoryList()
    }, this.I18nScope));
    contentSubCategory = Groupon.Support.ContentModel.getSubCategory();
    if (contentSubCategory && contentSubCategory !== null) {
      $(".sub-category", contentWrapper).val(contentSubCategory.id);
      $(".sub-category option[value='" + contentSubCategory.id + "']", contentWrapper).attr("selected", "selected");
      return this.fetchHelpContent(contentWrapper);
    }
  };

  StepTwoInbentaNonNLPView.prototype.enableResolvedButton = function(event) {
    var ref, ref1;
    if (((ref = this.flexStepThree) != null ? ref['allowed'] : void 0) && !((ref1 = this.flexStepThree) != null ? ref1['responseReceived'] : void 0)) {
      return this.inbentaEventType = event.type;
    }
    this.isInbentaContentShown = true;
    this.sendTrackyCallForHelpContentBeingShown(true);
    this.$('.issue-check').show();
    return this.$('.direct-ticket').hide();
  };

  StepTwoInbentaNonNLPView.prototype.disableAllButton = function() {
    this.isInbentaContentShown = false;
    return StepTwoInbentaBaseView.prototype.disableAllButton.apply(this, arguments);
  };

  StepTwoInbentaNonNLPView.prototype.enableTicketDirectionButton = function(event) {
    var ref, ref1;
    if (((ref = this.flexStepThree) != null ? ref['allowed'] : void 0) && !((ref1 = this.flexStepThree) != null ? ref1['responseReceived'] : void 0)) {
      return this.inbentaEventType = event.type;
    }
    this.isInbentaContentShown = true;
    this.sendTrackyCallForHelpContentBeingShown(false);
    this.$('.issue-check').hide();
    return this.$('.direct-ticket').show();
  };

  StepTwoInbentaNonNLPView.prototype.setCategoryToWindow = function() {
    var category;
    this.contentRequests = abortAjaxRequests(this.contentRequests);
    this.disableAllButton();
    if (this.inbentaTimeoutFn != null) {
      clearTimeout(this.inbentaTimeoutFn);
    }
    if (this.inbentaContentLoadTimeoutFn != null) {
      clearTimeout(this.inbentaContentLoadTimeoutFn);
    }
    category = this.$('.category option:selected').val();
    addToTrackingHub(category, null);
    this.clearElement('.inbenta-content');
    if (category === '') {
      this.$(".sub-category option[value='']").attr("selected", "selected");
      this.$('.sub-category').trigger('change');
      Groupon.Support.ContentModel.setCategory(null);
      Groupon.Support.ContentModel.setSubCategory(null);
      return this.clearElement('.sub-dropdown');
    } else {
      Groupon.Support.ContentModel.setCategory({
        id: this.$('.category option:selected').val(),
        text: this.$('.category option:selected').text()
      });
      Groupon.Support.ContentModel.setSubCategory(null);
      return this.renderSubCategory(this.$el);
    }
  };

  StepTwoInbentaNonNLPView.prototype.setSubCategoryToWindow = function() {
    var subcategory;
    this.contentRequests = abortAjaxRequests(this.contentRequests);
    subcategory = this.$('.sub-category option:selected').val();
    if (this.inbentaTimeoutFn != null) {
      clearTimeout(this.inbentaTimeoutFn);
    }
    if (this.inbentaContentLoadTimeoutFn != null) {
      clearTimeout(this.inbentaContentLoadTimeoutFn);
    }
    this.disableAllButton();
    addToTrackingHub(Groupon.Support.ContentModel.getCategory().id, subcategory);
    if (subcategory === '') {
      Groupon.Support.ContentModel.setSubCategory(null);
      return this.clearElement('.inbenta-content');
    } else {
      Groupon.Support.ContentModel.setSubCategory({
        id: this.$('.sub-category option:selected').val(),
        text: this.$('.sub-category option:selected').text()
      });
      return this.fetchHelpContent();
    }
  };

  StepTwoInbentaNonNLPView.prototype.fetchHelpContent = function(contentWrapper) {
    var data, urls;
    if (this.isFlexStepThreeAllowed()) {
      this.resetFlexStepThree();
      if (contentWrapper != null) {
        this.spinnerView.show({
          container: $('.inbenta-content', contentWrapper),
          height: '50px'
        });
      } else {
        this.spinnerView.show({
          container: $('.inbenta-content', this.$el),
          height: '50px'
        });
      }
      urls = this.getHelpContentPaths();
      data = this.getTaglines();
      this.contentRequests = SupportAPIHelper.parallel(urls, data, this.getHelpContentSuccessCb(), this.getHelpContenteErrorCb(), false, "t_ic", 60000);
    } else {
      Groupon.Support.ContentModel.flexibleStepThree = null;
      this.callTimeoutFn();
    }
    return this.setFlexibleContactChannels();
  };

  StepTwoInbentaNonNLPView.prototype.helpContentSuccess = function(results) {
    if (((results != null ? results.length : void 0) != null) > 0) {
      Groupon.Support.ContentModel.flexibleStepThree = results[0];
    }
    this.flexStepThree['responseReceived'] = true;
    if (!this.inbentaEventType) {
      return this.helpContentError();
    }
    return this.callInbentaEventCb();
  };

  StepTwoInbentaNonNLPView.prototype.helpContentError = function() {
    this.flexStepThree['responseReceived'] = true;
    if (this.inbentaEventType != null) {
      return this.callInbentaEventCb();
    }
    return this.callTimeoutFn();
  };

  StepTwoInbentaNonNLPView.prototype.callInbentaEventCb = function() {
    if (this.inbentaEventType === "help-text") {
      return this.enableResolvedButton();
    } else {
      return this.enableTicketDirectionButton();
    }
  };

  StepTwoInbentaNonNLPView.prototype.callTimeoutFn = function() {
    var timeoutFn;
    timeoutFn = (function(_this) {
      return function() {
        if (_this.isInbentaContentShown === false && _this.isCategoryAndSubcategorySelected()) {
          _this.helpContentLoadError();
          _this.enableTicketDirectionButton();
          _this.sendTrackyCallForHelpContentBeingShown(false);
          throw new Error(SupportErrorHelper.constructInbentaLoadErrorMessage());
        }
      };
    })(this);
    if (this.shouldHandleCbFromEmailForm()) {
      return;
    }
    if (this.inbentaContentLoadTimeoutFn != null) {
      clearTimeout(this.inbentaContentLoadTimeoutFn);
    }
    return this.inbentaTimeoutFn = setTimeout(timeoutFn, 5000);
  };

  StepTwoInbentaNonNLPView.prototype.shouldHandleCbFromEmailForm = function() {
    if ($('.inbenta-content').text().length <= 1) {
      if (!this.alreadySubCategoryChangeInitiated) {
        this.alreadySubCategoryChangeInitiated = true;
        this.$('.sub-category').trigger('change');
        this.inbentaContentLoadTimeoutFn = setTimeout(this.callTimeoutFn, 3000);
        return true;
      }
    }
  };

  return StepTwoInbentaNonNLPView;

})(StepTwoInbentaBaseView);

module.exports = StepTwoInbentaNonNLPView;



},{"../../../helpers/API":51,"../../../helpers/error":53,"../../main_content_view":155,"./base_view":207}],210:[function(require,module,exports){
var Backbone, SharedWidgetLayoutView, SupportThanksForContactingTemplate, SupportTicketSuccessView, SupportUtilsHelper,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportThanksForContactingTemplate = require('../../thanks_for_contacting.html.mustache');

Backbone = require('backbone');

Backbone.$ = $;

SharedWidgetLayoutView = require('../../../shared/frontend/views/widget_layout_veiw');

SupportUtilsHelper = require('../helpers/utils');

SupportTicketSuccessView = (function(superClass) {
  extend(SupportTicketSuccessView, superClass);

  function SupportTicketSuccessView() {
    return SupportTicketSuccessView.__super__.constructor.apply(this, arguments);
  }

  SupportTicketSuccessView.prototype.className = 'ticket-success';

  SupportTicketSuccessView.prototype.events = {
    'click #needHelpAgain': "needMoreHelpHandler"
  };

  SupportTicketSuccessView.prototype.initialize = function() {
    this.I18nScope = 'modules.support';
    this.template = SupportThanksForContactingTemplate;
    return this.id = 'ticket-success';
  };

  SupportTicketSuccessView.prototype.render = function() {
    this.$el.append(toHtml(this.template, this.toHash(), this.I18nScope));
    this.hideComponents();
    return this.showComponents();
  };

  SupportTicketSuccessView.prototype.toHash = function() {
    var hash, merchantName, ref, ref1;
    merchantName = ((ref = Groupon.Support.currentOrder) != null ? (ref1 = ref.merchant) != null ? ref1.name : void 0 : void 0) || "";
    hash = {
      currentUser: currentUser,
      showFooter: this.shouldShowFooter(),
      escalate_to_merchant: Groupon.Support.ContentModel.escalateToMerchant,
      merchant_to_contact: I18n.translate('js.modules.support.merchant_to_contact', {
        merchantName: merchantName
      }),
      refund_request_submitted: this.isRefundEligible(),
      greeting_text: this.getGreetingText(),
      showDefaultThankYouMsg: true,
      isDefaultflow: true
    };
    this.setGetBackMsgType(hash);
    return hash;
  };

  SupportTicketSuccessView.prototype.shouldShowFooter = function() {
    return checkIfIsUSByCountry(window.country.name) && !SharedWidgetLayoutView.isWidgetLayoutEnabled();
  };

  SupportTicketSuccessView.prototype.getGreetingText = function() {
    if (this.isRefundEligible()) {
      return I18n.translate('js.modules.support.request_submitted_successfully');
    } else {
      return I18n.translate('js.modules.support.thankcs');
    }
  };

  SupportTicketSuccessView.prototype.isRefundEligible = function() {
    return Groupon.Support.ContentModel.isRefundEligible;
  };

  SupportTicketSuccessView.prototype.setGetBackMsgType = function(hash) {
    if (this.isUrgentTicket()) {
      return hash.twoHoursGetBackMsg = true;
    } else {
      return hash.defaultGetBackmsg = true;
    }
  };

  SupportTicketSuccessView.prototype.isUrgentTicket = function() {
    if (isUS() && checkIfCategoryIsAboutEditingOrCancelling()) {
      return (isCurrentOrderGoodsDeal() && isOrderPurchasedWithinHours(2)) || (isCurrentOrderLiveDeal() && isOrderPurchasedWithinHours(24));
    } else {
      return false;
    }
  };

  SupportTicketSuccessView.prototype.hideComponents = function() {
    SupportUtilsHelper.hideFloatingBoldChat();
    if (!window.isUS()) {
      $('.module-body.intl-footer').children().addClass('hide');
      return $('.module-body.intl-footer').addClass('hidden-footer-content-intl');
    }
  };

  SupportTicketSuccessView.prototype.showComponents = function() {
    return SharedWidgetLayoutView.showWidgets('ticket-success');
  };

  SupportTicketSuccessView.prototype.needMoreHelpHandler = function() {
    return redirectToHelpWizard();
  };

  SupportTicketSuccessView.prototype.close = function() {};

  return SupportTicketSuccessView;

})(Backbone.View);

module.exports = SupportTicketSuccessView;



},{"../../../shared/frontend/views/widget_layout_veiw":25,"../../thanks_for_contacting.html.mustache":238,"../helpers/utils":54,"backbone":245}],211:[function(require,module,exports){
var Backbone, SupportUserSignInTemplate, SupportUserSignInView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Backbone = require('backbone');

Backbone.$ = $;

SupportUserSignInTemplate = require('../../user_sign_in.html.mustache');

SupportUserSignInView = (function(superClass) {
  extend(SupportUserSignInView, superClass);

  function SupportUserSignInView() {
    return SupportUserSignInView.__super__.constructor.apply(this, arguments);
  }

  SupportUserSignInView.prototype.initialize = function(options) {
    this.options = options || {};
    return this.template = SupportUserSignInTemplate;
  };

  SupportUserSignInView.prototype.events = {
    'click #my-account-sign-in': 'redirectToLoginFromMyAccount',
    'click #my-order-sign-in': 'redirectToLoginFromMyOrder'
  };

  SupportUserSignInView.prototype.render = function() {
    return this.$el.html(toHtml(this.template, this.options, this.I18nScope));
  };

  SupportUserSignInView.prototype.redirectToLoginFromMyAccount = function() {
    var refUrl;
    refUrl = window.SUPPORTBASEURL + "?flow=my_account";
    return window.location.href = "/login?ref=" + (encodeURIComponent(refUrl));
  };

  SupportUserSignInView.prototype.redirectToLoginFromMyOrder = function() {
    var refUrl;
    refUrl = window.SUPPORTBASEURL + "?flow=my_order";
    return window.location.href = "/login?ref=" + (encodeURIComponent(refUrl));
  };

  return SupportUserSignInView;

})(Backbone.View);

module.exports = SupportUserSignInView;



},{"../../user_sign_in.html.mustache":242,"backbone":245}],212:[function(require,module,exports){
var Hogan = require('hogan.js');
module.exports = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<div id=\"popupContent\" class=\"modal show-modal\">");t.b("\n" + i);t.b("	<div class=\"modal-body\">");t.b("\n" + i);t.b("		<a href=\"javascript:;\" data-modal-id=\"popupContent\" class=\"close-modal icon-x\"></a>");t.b("\n" + i);t.b("		<h3 class=\"modal-title\">");t.b(t.v(t.f("title",c,p,0)));t.b("</h3>");t.b("\n" + i);t.b("		<div class=\"row\">");t.b("\n" + i);t.b("			<div class=\"twelve columns p20\" id=\"generalContent\">");t.b("\n" + i);t.b("				<p>");t.b(t.t(t.f("instructions",c,p,0)));t.b("</p>");t.b("\n" + i);t.b("			</div>");t.b("\n" + i);t.b("		</div>");t.b("\n" + i);t.b("	</div>");t.b("\n" + i);t.b("</div>");t.b("\n");return t.fl(); },partials: {}, subs: {  }}, "<div id=\"popupContent\" class=\"modal show-modal\">\n\t<div class=\"modal-body\">\n\t\t<a href=\"javascript:;\" data-modal-id=\"popupContent\" class=\"close-modal icon-x\"></a>\n\t\t<h3 class=\"modal-title\">{{title}}</h3>\n\t\t<div class=\"row\">\n\t\t\t<div class=\"twelve columns p20\" id=\"generalContent\">\n\t\t\t\t<p>{{{instructions}}}</p>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>\n", Hogan);
},{"hogan.js":248}],213:[function(require,module,exports){
var Hogan = require('hogan.js');
module.exports = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<div class=\"ui-dialog-titlebar ui-popup-header popupHeader\">");t.b("\n" + i);t.b("<span class=\"ui-dialog-title popupTitle\" id=\"ui-dialog-title-dialog-form\">");if(t.s(t.f("translate",c,p,1),c,p,0,149,174,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.giftop");});c.pop();}t.b("</span>");t.b("\n" + i);t.b("<a class=\"ui-dialog-titlebar-close ui-corner-all\" role=\"button\"><span class=\"ui-button b-close\"><span>X</span></span></a>");t.b("\n" + i);t.b("</div>");t.b("\n" + i);t.b("<div class=\"giftOptsPopupData fl\">");t.b("\n" + i);t.b("<h4>");if(t.s(t.f("translate",c,p,1),c,p,0,378,405,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.giftform");});c.pop();}t.b("</h4>");t.b("\n" + i);t.b("<div>");t.b("\n" + i);t.b("<div class=\"recepient fl\">");t.b("\n" + i);t.b("<div class=\"field\">");t.b("\n" + i);t.b("<div class=\"label\">");if(t.s(t.f("translate",c,p,1),c,p,0,511,532,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.to");});c.pop();}t.b("</div>");t.b("\n" + i);t.b("<input type=\"textbox\" class=\"input\" id=\"order_gift_recipient_name\">");t.b("\n" + i);t.b("<div class=\"red label\" id=\"validate_to_field\" aria-label=\"Recipient Name\"></div>");t.b("\n" + i);t.b("</div>");t.b("\n");t.b("\n" + i);t.b("<div class=\"field\">");t.b("\n" + i);t.b("<div class=\"label\">");if(t.s(t.f("translate",c,p,1),c,p,0,763,786,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.from");});c.pop();}t.b("<span>");if(t.s(t.f("translate",c,p,1),c,p,0,820,848,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.nametosee");});c.pop();}t.b("</span></div>");t.b("\n" + i);t.b("          <input type=\"textbox\" class=\"input\" id=\"order_gift_from_name\">");t.b("\n" + i);t.b("          <div class=\"red label\" id=\"validate_from_field\" aria-label=\"From\"></div>");t.b("\n" + i);t.b("</div>");t.b("\n");t.b("\n" + i);t.b("<div class=\"field\">");t.b("\n" + i);t.b("<div class=\"label\">");if(t.s(t.f("translate",c,p,1),c,p,0,1093,1119,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.delimet");});c.pop();}t.b("</div>");t.b("\n" + i);t.b("          <input type=\"radio\" name=\"deliveryType\" id=\"emailType\" class=\"fl mt10\"><span class=\"label fl mt10 pl3\" aria-label=\"Delivery Type\">");if(t.s(t.f("translate",c,p,1),c,p,0,1294,1320,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.emailto");});c.pop();}t.b("</span>");t.b("\n" + i);t.b("<div class=\"cb\"><input type=\"textbox\" class=\"input\" id=\"order_gift_recipient_email\"></div>");t.b("\n" + i);t.b("          <div class=\"red label\" id=\"validate_email\"></div>");t.b("\n" + i);t.b("<input type=\"radio\" name=\"deliveryType\" class=\"m10 fl\" aria-label=\"Recipient Email Address\"><span class=\"label fl mt10 pl3\">");if(t.s(t.f("translate",c,p,1),c,p,0,1631,1659,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.printself");});c.pop();}t.b("</span>");t.b("\n" + i);t.b("</div>");t.b("\n" + i);t.b("</div>");t.b("\n" + i);t.b("<div class=\"message fl\">");t.b("\n" + i);t.b("<div class=\"label\">");if(t.s(t.f("translate",c,p,1),c,p,0,1753,1775,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.msg");});c.pop();}t.b("</span><span>");if(t.s(t.f("translate",c,p,1),c,p,0,1816,1841,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.msglmt");});c.pop();}t.b("</span></div>");t.b("\n" + i);t.b("<textarea rows=\"13\" cols=\"45\" class=\"pt3\" id=\"order_gift_message\" maxlength=\"330\" aria-label=\"Message\"></textarea>");t.b("\n" + i);t.b("<div class=\"label\"><span><span id=\"noOfChars\">");if(t.s(t.f("translate",c,p,1),c,p,0,2044,2067,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.c330");});c.pop();}t.b("</span> ");if(t.s(t.f("translate",c,p,1),c,p,0,2103,2125,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.rem");});c.pop();}t.b("</span></div>");t.b("\n" + i);t.b("</div>");t.b("\n" + i);t.b("</div>");t.b("\n" + i);t.b("</div>");t.b("\n" + i);t.b("<div class=\"cb h30 ui-dialog-buttonpane ui-widget-content u-helper-clearfix ui-popup-footer\">");t.b("\n" + i);t.b("<div class=\"ui-dialog-buttonset fl\">");t.b("\n" + i);t.b("<a class=\"b-close\" href=\"./support_files/support.html\" id=\"cancelOrderSelect\">");if(t.s(t.f("translate",c,p,1),c,p,0,2397,2422,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.cancel");});c.pop();}t.b("</a>");t.b("\n" + i);t.b("<input type=\"button\" value=\"");if(t.s(t.f("translate",c,p,1),c,p,0,2483,2506,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.save");});c.pop();}t.b("\"\" id=\"gift_details_save_btn\" class=\"btn-invert btn-small\" aria-label=\"Save\">");t.b("\n" + i);t.b("</div>");t.b("\n" + i);t.b("</div>");t.b("\n");return t.fl(); },partials: {}, subs: {  }}, "<div class=\"ui-dialog-titlebar ui-popup-header popupHeader\">\n<span class=\"ui-dialog-title popupTitle\" id=\"ui-dialog-title-dialog-form\">{{#translate}}js.modules.support.giftop{{/translate}}</span>\n<a class=\"ui-dialog-titlebar-close ui-corner-all\" role=\"button\"><span class=\"ui-button b-close\"><span>X</span></span></a>\n</div>\n<div class=\"giftOptsPopupData fl\">\n<h4>{{#translate}}js.modules.support.giftform{{/translate}}</h4>\n<div>\n<div class=\"recepient fl\">\n<div class=\"field\">\n<div class=\"label\">{{#translate}}js.modules.support.to{{/translate}}</div>\n<input type=\"textbox\" class=\"input\" id=\"order_gift_recipient_name\">\n<div class=\"red label\" id=\"validate_to_field\" aria-label=\"Recipient Name\"></div>\n</div>\n\n<div class=\"field\">\n<div class=\"label\">{{#translate}}js.modules.support.from{{/translate}}<span>{{#translate}}js.modules.support.nametosee{{/translate}}</span></div>\n          <input type=\"textbox\" class=\"input\" id=\"order_gift_from_name\">\n          <div class=\"red label\" id=\"validate_from_field\" aria-label=\"From\"></div>\n</div>\n\n<div class=\"field\">\n<div class=\"label\">{{#translate}}js.modules.support.delimet{{/translate}}</div>\n          <input type=\"radio\" name=\"deliveryType\" id=\"emailType\" class=\"fl mt10\"><span class=\"label fl mt10 pl3\" aria-label=\"Delivery Type\">{{#translate}}js.modules.support.emailto{{/translate}}</span>\n<div class=\"cb\"><input type=\"textbox\" class=\"input\" id=\"order_gift_recipient_email\"></div>\n          <div class=\"red label\" id=\"validate_email\"></div>\n<input type=\"radio\" name=\"deliveryType\" class=\"m10 fl\" aria-label=\"Recipient Email Address\"><span class=\"label fl mt10 pl3\">{{#translate}}js.modules.support.printself{{/translate}}</span>\n</div>\n</div>\n<div class=\"message fl\">\n<div class=\"label\">{{#translate}}js.modules.support.msg{{/translate}}</span><span>{{#translate}}js.modules.support.msglmt{{/translate}}</span></div>\n<textarea rows=\"13\" cols=\"45\" class=\"pt3\" id=\"order_gift_message\" maxlength=\"330\" aria-label=\"Message\"></textarea>\n<div class=\"label\"><span><span id=\"noOfChars\">{{#translate}}js.modules.support.c330{{/translate}}</span> {{#translate}}js.modules.support.rem{{/translate}}</span></div>\n</div>\n</div>\n</div>\n<div class=\"cb h30 ui-dialog-buttonpane ui-widget-content u-helper-clearfix ui-popup-footer\">\n<div class=\"ui-dialog-buttonset fl\">\n<a class=\"b-close\" href=\"./support_files/support.html\" id=\"cancelOrderSelect\">{{#translate}}js.modules.support.cancel{{/translate}}</a>\n<input type=\"button\" value=\"{{#translate}}js.modules.support.save{{/translate}}\"\" id=\"gift_details_save_btn\" class=\"btn-invert btn-small\" aria-label=\"Save\">\n</div>\n</div>\n", Hogan);
},{"hogan.js":248}],214:[function(require,module,exports){
var Hogan = require('hogan.js');
module.exports = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<section class=\"main row\" id=\"intermediate_page\">");t.b("\n" + i);t.b("  <div class=\"twelve columns\">");t.b("\n" + i);t.b("    <section class=\"module intermediate-page-module\">");t.b("\n" + i);t.b("      <div class=\"module-body intermediate-page\">");t.b("\n" + i);t.b("        <div class=\"page_header\">");t.b("\n" + i);t.b("          <h2>");if(t.s(t.f("translate",c,p,1),c,p,0,247,290,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.intermediate_page_header");});c.pop();}t.b("</h2>");t.b("\n" + i);t.b("        </div>");t.b("\n" + i);t.b("        <hr class = \"interLine1\">");t.b("\n" + i);t.b("        <div class='five columns not-about-order'>");t.b("\n" + i);t.b("          <div class=\"interHeadText not-about-an-order\">");t.b("\n" + i);t.b("            ");if(t.s(t.f("translate",c,p,1),c,p,0,493,533,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.ip_donot_have_account");});c.pop();}t.b("\n" + i);t.b("          </div>");t.b("\n" + i);t.b("          <div class=\"interText6\">");t.b("\n" + i);t.b("            ");if(t.s(t.f("translate",c,p,1),c,p,0,626,664,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.ip_general_question");});c.pop();}t.b("&nbsp;<span id=\"not_about_an_order_link\" class=\"not_about_an_order_link\" data-bhw='not-about-an-order-link'><a>");if(t.s(t.f("translate",c,p,1),c,p,0,803,851,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.intermediate_page_text6_click");});c.pop();}t.b("</a></span>");t.b("\n" + i);t.b("          </div>");t.b("\n" + i);t.b("        </div>");t.b("\n" + i);t.b("        <div class='seven columns about-order'>");t.b("\n" + i);t.b("          <hr class = \"vertical-line\">");t.b("\n" + i);t.b("          <div class=\"ten columns about-an-order\">");t.b("\n" + i);t.b("            <div class=\"interHeadText\">");if(t.s(t.f("translate",c,p,1),c,p,0,1100,1144,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.intermediate_page_header2");});c.pop();}t.b("\n" + i);t.b("            </div>");t.b("\n" + i);t.b("            <div class=\"interText1\">");if(t.s(t.f("translate",c,p,1),c,p,0,1228,1270,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.intermediate_page_text1");});c.pop();}t.b("\n" + i);t.b("            </div>");t.b("\n" + i);t.b("            <div class=\"interText2\">");t.b("\n" + i);t.b("              ");if(t.s(t.f("translate",c,p,1),c,p,0,1369,1411,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.intermediate_page_text2");});c.pop();}t.b("\n" + i);t.b("            </div>");t.b("\n" + i);t.b("            <input class=\"button btn\" id=\"about_an_order\" type=\"submit\" value=\"");if(t.s(t.f("translate",c,p,1),c,p,0,1538,1581,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.intermediate_page_button");});c.pop();}t.b("\" data-bhw='about-an-order-link'/>");t.b("\n" + i);t.b("        </div>");t.b("\n" + i);t.b("        </div>");t.b("\n" + i);t.b("      </div>");t.b("\n" + i);t.b("    </section>");t.b("\n" + i);t.b("  </div>");t.b("\n" + i);t.b("</section>");return t.fl(); },partials: {}, subs: {  }}, "<section class=\"main row\" id=\"intermediate_page\">\n  <div class=\"twelve columns\">\n    <section class=\"module intermediate-page-module\">\n      <div class=\"module-body intermediate-page\">\n        <div class=\"page_header\">\n          <h2>{{#translate}}js.modules.support.intermediate_page_header{{/translate}}</h2>\n        </div>\n        <hr class = \"interLine1\">\n        <div class='five columns not-about-order'>\n          <div class=\"interHeadText not-about-an-order\">\n            {{#translate}}js.modules.support.ip_donot_have_account{{/translate}}\n          </div>\n          <div class=\"interText6\">\n            {{#translate}}js.modules.support.ip_general_question{{/translate}}&nbsp;<span id=\"not_about_an_order_link\" class=\"not_about_an_order_link\" data-bhw='not-about-an-order-link'><a>{{#translate}}js.modules.support.intermediate_page_text6_click{{/translate}}</a></span>\n          </div>\n        </div>\n        <div class='seven columns about-order'>\n          <hr class = \"vertical-line\">\n          <div class=\"ten columns about-an-order\">\n            <div class=\"interHeadText\">{{#translate}}js.modules.support.intermediate_page_header2{{/translate}}\n            </div>\n            <div class=\"interText1\">{{#translate}}js.modules.support.intermediate_page_text1{{/translate}}\n            </div>\n            <div class=\"interText2\">\n              {{#translate}}js.modules.support.intermediate_page_text2{{/translate}}\n            </div>\n            <input class=\"button btn\" id=\"about_an_order\" type=\"submit\" value=\"{{#translate}}js.modules.support.intermediate_page_button{{/translate}}\" data-bhw='about-an-order-link'/>\n        </div>\n        </div>\n      </div>\n    </section>\n  </div>\n</section>", Hogan);
},{"hogan.js":248}],215:[function(require,module,exports){
var Hogan = require('hogan.js');
module.exports = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<!-- BoldChat Live Chat Button HTML v5.00 (Type=Web,ChatButton=Brazil Button,Website=sac.groupon.com.br (Groupon Brazil)) -->");t.b("\n" + i);t.b("<div style=\"text-align: center; white-space: nowrap;\">");t.b("\n" + i);if(!t.s(t.f("is_chat_link",c,p,1),c,p,1,0,0,"")){t.b("  <script type=\"text/javascript\">");t.b("\n" + i);t.b("    var liveChatContainer = document.getElementById(\"live-chat-container\")");t.b("\n" + i);t.b("    if(liveChatContainer){");t.b("\n" + i);t.b("      window.bccbId = window.bccbId || Math.random();");t.b("\n" + i);t.b("      var div= document.createElement(\"div\");");t.b("\n" + i);t.b("      var id = document.createAttribute(\"id\");");t.b("\n" + i);t.b("      id.value = bccbId;");t.b("\n" + i);t.b("      div.setAttributeNode(id);");t.b("\n" + i);t.b("      ");t.b("\n" + i);t.b("      liveChatContainer.appendChild(div);");t.b("\n" + i);t.b("      window._bcvma = window._bcvma || [];");t.b("\n" + i);t.b("      _bcvma.push([\"setAccountID\", \"");t.b(t.v(t.d("liveChat.accountID",c,p,0)));t.b("\"]);");t.b("\n" + i);t.b("      _bcvma.push([\"setParameter\", \"VisitName\", \"");t.b(t.v(t.f("userName",c,p,0)));t.b("\" ]);");t.b("\n" + i);t.b("      _bcvma.push([\"setParameter\", \"VisitEmail\", \"");t.b(t.v(t.f("userEmail",c,p,0)));t.b("\" ]);");t.b("\n" + i);t.b("      _bcvma.push([\"setParameter\", \"InitialQuestion\", \"");t.b(t.t(t.f("initialQuestion",c,p,0)));t.b("\" ]);");t.b("\n" + i);t.b("      _bcvma.push([\"setParameter\", \"WebsiteID\", \"");t.b(t.v(t.d("liveChat.websiteDefID",c,p,0)));t.b("\"]);");t.b("\n" + i);t.b("      _bcvma.push([\"setParameter\", \"CustomUrl\", \"\"]);");t.b("\n" + i);t.b("      _bcvma.push([\"setParameter\", \"WindowParameters\", \"vn=\" + encodeURIComponent(\"");t.b(t.v(t.f("userName",c,p,0)));t.b("\") + \"&ve=\" + encodeURIComponent(\"");t.b(t.v(t.f("userEmail",c,p,0)));t.b("\") + \"&iq=\" + encodeURIComponent(\"");t.b(t.t(t.f("initialQuestion",c,p,0)));t.b("\") ]);");t.b("\n" + i);t.b("      _bcvma.push([\"addStatic\", {type: \"chat\", bdid:\"");t.b(t.v(t.d("liveChat.staticBdid",c,p,0)));t.b("\", id: bccbId}]);");t.b("\n");t.b("\n" + i);t.b("      _bcvma.push([\"pageViewed\"]);      ");t.b("\n" + i);t.b("      var bcLoad = function(){");t.b("\n" + i);t.b("        if(window.bcLoaded) return; window.bcLoaded = true;");t.b("\n" + i);t.b("        var vms = document.createElement(\"script\"); vms.type = \"text/javascript\"; vms.async = true;");t.b("\n" + i);t.b("        vms.src = ('https:'==document.location.protocol?'https://':'http://') + \"vmss.boldchat.com/aid/");t.b(t.v(t.d("liveChat.accountID",c,p,0)));t.b("/bc.vms4/vms.js\";");t.b("\n" + i);t.b("        var s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(vms, s);");t.b("\n" + i);t.b("      };");t.b("\n" + i);t.b("      if(window.pageViewer && pageViewer.load) pageViewer.load();");t.b("\n" + i);t.b("      else if(document.readyState==\"complete\") bcLoad();");t.b("\n" + i);t.b("      else if(window.addEventListener) window.addEventListener('load', bcLoad, false);");t.b("\n" + i);t.b("      else window.attachEvent('onload', bcLoad);");t.b("\n" + i);t.b("    }");t.b("\n" + i);t.b("  </script>");t.b("\n" + i);};if(t.s(t.f("is_chat_link",c,p,1),c,p,0,2135,4340,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("    <!-- BoldChat Live Chat Button HTML v5.00 (Type=HTML,ChatWindow=UK & IE Window Window,Department=UK - First Level Support,Website=groupon.co.uk (Groupon UK)) -->");t.b("\n" + i);t.b("  <script type=\"text/javascript\">");t.b("\n" + i);t.b("    var liveChatContainer = document.getElementById(\"live-chat-link-container\")");t.b("\n" + i);t.b("    if(liveChatContainer){");t.b("\n" + i);t.b("      window.bccdId = window.bccdId || Math.random();");t.b("\n" + i);t.b("      var div=document.createElement(\"div\");");t.b("\n" + i);t.b("      var id = document.createAttribute(\"id\");");t.b("\n" + i);t.b("      id.value = bccdId;");t.b("\n" + i);t.b("      div.setAttributeNode(id);");t.b("\n" + i);t.b("      liveChatContainer.appendChild(div);");t.b("\n");t.b("\n" + i);t.b("      window._bcvma = window._bcvma || [];");t.b("\n" + i);t.b("      _bcvma.push([\"setAccountID\", \"");t.b(t.v(t.d("liveChat.accountID",c,p,0)));t.b("\"]);");t.b("\n" + i);t.b("      _bcvma.push([\"setParameter\", \"VisitName\", \"");t.b(t.v(t.f("userName",c,p,0)));t.b("\" ]);");t.b("\n" + i);t.b("      _bcvma.push([\"setParameter\", \"VisitEmail\", \"");t.b(t.v(t.f("userEmail",c,p,0)));t.b("\" ]);");t.b("\n" + i);t.b("      _bcvma.push([\"setParameter\", \"InitialQuestion\", \"");t.b(t.t(t.f("initialQuestion",c,p,0)));t.b("\" ]);");t.b("\n" + i);t.b("      _bcvma.push([\"setParameter\", \"WebsiteID\", \"");t.b(t.v(t.d("liveChat.websiteDefID",c,p,0)));t.b("\"]);");t.b("\n" + i);t.b("      _bcvma.push([\"setParameter\", \"CustomUrl\", \"\"])");t.b("\n" + i);t.b("      _bcvma.push([\"setParameter\", \"WindowParameters\", \"vn=\" + encodeURIComponent(\"");t.b(t.v(t.f("userName",c,p,0)));t.b("\") + \"&ve=\" + encodeURIComponent(\"");t.b(t.v(t.f("userEmail",c,p,0)));t.b("\") + \"&iq=\" + encodeURIComponent(\"");t.b(t.t(t.f("initialQuestion",c,p,0)));t.b("\") ]);");t.b("\n" + i);t.b("      _bcvma.push([\"addText\", {type: \"chat\", department: \"");t.b(t.v(t.d("liveChat.departmentID",c,p,0)));t.b("\", window: \"");t.b(t.v(t.d("liveChat.windowID",c,p,0)));t.b("\", available: \"<span>");if(t.s(t.f("translate",c,p,1),c,p,0,3500,3526,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.chat_us");});c.pop();}t.b("</span>\", unavailable: \"\", id: bccdId}]);");t.b("\n" + i);t.b("      _bcvma.push([\"pageViewed\"]);        ");t.b("\n" + i);t.b("      var bcLoad = function(){");t.b("\n" + i);t.b("        if(window.bcLoaded) return; window.bcLoaded = true;");t.b("\n" + i);t.b("        var vms = document.createElement(\"script\"); vms.type = \"text/javascript\"; vms.async = true;");t.b("\n" + i);t.b("        vms.src = ('https:'==document.location.protocol?'https://':'http://') + \"vmss.boldchat.com/aid/");t.b(t.v(t.d("liveChat.accountID",c,p,0)));t.b("/bc.vms4/vms.js\";");t.b("\n" + i);t.b("        var s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(vms, s);");t.b("\n" + i);t.b("      };");t.b("\n" + i);t.b("      if(window.pageViewer && pageViewer.load) pageViewer.load();");t.b("\n" + i);t.b("      else if(document.readyState==\"complete\") bcLoad();");t.b("\n" + i);t.b("      else if(window.addEventListener) window.addEventListener('load', bcLoad, false);");t.b("\n" + i);t.b("      else window.attachEvent('onload', bcLoad);");t.b("\n" + i);t.b("    }");t.b("\n" + i);t.b("  </script>");t.b("\n" + i);});c.pop();}t.b("\n" + i);t.b("</div>");t.b("\n");t.b("\n");return t.fl(); },partials: {}, subs: {  }}, "<!-- BoldChat Live Chat Button HTML v5.00 (Type=Web,ChatButton=Brazil Button,Website=sac.groupon.com.br (Groupon Brazil)) -->\n<div style=\"text-align: center; white-space: nowrap;\">\n{{^is_chat_link}}\n  <script type=\"text/javascript\">\n    var liveChatContainer = document.getElementById(\"live-chat-container\")\n    if(liveChatContainer){\n      window.bccbId = window.bccbId || Math.random();\n      var div= document.createElement(\"div\");\n      var id = document.createAttribute(\"id\");\n      id.value = bccbId;\n      div.setAttributeNode(id);\n      \n      liveChatContainer.appendChild(div);\n      window._bcvma = window._bcvma || [];\n      _bcvma.push([\"setAccountID\", \"{{liveChat.accountID}}\"]);\n      _bcvma.push([\"setParameter\", \"VisitName\", \"{{userName}}\" ]);\n      _bcvma.push([\"setParameter\", \"VisitEmail\", \"{{userEmail}}\" ]);\n      _bcvma.push([\"setParameter\", \"InitialQuestion\", \"{{{initialQuestion}}}\" ]);\n      _bcvma.push([\"setParameter\", \"WebsiteID\", \"{{liveChat.websiteDefID}}\"]);\n      _bcvma.push([\"setParameter\", \"CustomUrl\", \"\"]);\n      _bcvma.push([\"setParameter\", \"WindowParameters\", \"vn=\" + encodeURIComponent(\"{{userName}}\") + \"&ve=\" + encodeURIComponent(\"{{userEmail}}\") + \"&iq=\" + encodeURIComponent(\"{{{initialQuestion}}}\") ]);\n      _bcvma.push([\"addStatic\", {type: \"chat\", bdid:\"{{liveChat.staticBdid}}\", id: bccbId}]);\n\n      _bcvma.push([\"pageViewed\"]);      \n      var bcLoad = function(){\n        if(window.bcLoaded) return; window.bcLoaded = true;\n        var vms = document.createElement(\"script\"); vms.type = \"text/javascript\"; vms.async = true;\n        vms.src = ('https:'==document.location.protocol?'https://':'http://') + \"vmss.boldchat.com/aid/{{liveChat.accountID}}/bc.vms4/vms.js\";\n        var s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(vms, s);\n      };\n      if(window.pageViewer && pageViewer.load) pageViewer.load();\n      else if(document.readyState==\"complete\") bcLoad();\n      else if(window.addEventListener) window.addEventListener('load', bcLoad, false);\n      else window.attachEvent('onload', bcLoad);\n    }\n  </script>\n{{/is_chat_link}}\n{{#is_chat_link}}\n    <!-- BoldChat Live Chat Button HTML v5.00 (Type=HTML,ChatWindow=UK & IE Window Window,Department=UK - First Level Support,Website=groupon.co.uk (Groupon UK)) -->\n  <script type=\"text/javascript\">\n    var liveChatContainer = document.getElementById(\"live-chat-link-container\")\n    if(liveChatContainer){\n      window.bccdId = window.bccdId || Math.random();\n      var div=document.createElement(\"div\");\n      var id = document.createAttribute(\"id\");\n      id.value = bccdId;\n      div.setAttributeNode(id);\n      liveChatContainer.appendChild(div);\n\n      window._bcvma = window._bcvma || [];\n      _bcvma.push([\"setAccountID\", \"{{liveChat.accountID}}\"]);\n      _bcvma.push([\"setParameter\", \"VisitName\", \"{{userName}}\" ]);\n      _bcvma.push([\"setParameter\", \"VisitEmail\", \"{{userEmail}}\" ]);\n      _bcvma.push([\"setParameter\", \"InitialQuestion\", \"{{{initialQuestion}}}\" ]);\n      _bcvma.push([\"setParameter\", \"WebsiteID\", \"{{liveChat.websiteDefID}}\"]);\n      _bcvma.push([\"setParameter\", \"CustomUrl\", \"\"])\n      _bcvma.push([\"setParameter\", \"WindowParameters\", \"vn=\" + encodeURIComponent(\"{{userName}}\") + \"&ve=\" + encodeURIComponent(\"{{userEmail}}\") + \"&iq=\" + encodeURIComponent(\"{{{initialQuestion}}}\") ]);\n      _bcvma.push([\"addText\", {type: \"chat\", department: \"{{liveChat.departmentID}}\", window: \"{{liveChat.windowID}}\", available: \"<span>{{#translate}}js.modules.support.chat_us{{/translate}}</span>\", unavailable: \"\", id: bccdId}]);\n      _bcvma.push([\"pageViewed\"]);        \n      var bcLoad = function(){\n        if(window.bcLoaded) return; window.bcLoaded = true;\n        var vms = document.createElement(\"script\"); vms.type = \"text/javascript\"; vms.async = true;\n        vms.src = ('https:'==document.location.protocol?'https://':'http://') + \"vmss.boldchat.com/aid/{{liveChat.accountID}}/bc.vms4/vms.js\";\n        var s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(vms, s);\n      };\n      if(window.pageViewer && pageViewer.load) pageViewer.load();\n      else if(document.readyState==\"complete\") bcLoad();\n      else if(window.addEventListener) window.addEventListener('load', bcLoad, false);\n      else window.attachEvent('onload', bcLoad);\n    }\n  </script>\n{{/is_chat_link}}\n\n</div>\n\n", Hogan);
},{"hogan.js":248}],216:[function(require,module,exports){
var Hogan = require('hogan.js');
module.exports = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<!-- BoldChat Visitor Monitor HTML v5.00 (Website=sac.groupon.com.br (Groupon Brazil),ChatButton=Brazil Floating Chat Button,ChatInvitation=Brazil Invitation Ruleset) -->");t.b("\n" + i);t.b("<script type=\"text/javascript\">");t.b("\n" + i);t.b("  window._bcvma = window._bcvma || [];");t.b("\n" + i);t.b("  _bcvma.push([\"setAccountID\", \"");t.b(t.v(t.d("liveChat.accountID",c,p,0)));t.b("\"]);");t.b("\n" + i);t.b("  _bcvma.push([\"setParameter\", \"WebsiteID\", \"");t.b(t.v(t.d("liveChat.websiteDefID",c,p,0)));t.b("\"]);");t.b("\n" + i);t.b("  _bcvma.push([\"setParameter\", \"InvitationID\", \"");t.b(t.v(t.d("liveChat.invitationDefID",c,p,0)));t.b("\"]);");t.b("\n" + i);t.b("  _bcvma.push([\"setParameter\", \"VisitName\", \"");t.b(t.v(t.f("userName",c,p,0)));t.b("\"]);");t.b("\n" + i);t.b("  _bcvma.push([\"setParameter\", \"VisitPhone\", \"\"]);");t.b("\n" + i);t.b("  _bcvma.push([\"setParameter\", \"VisitEmail\", \"");t.b(t.v(t.f("userEmail",c,p,0)));t.b("\"]);");t.b("\n" + i);t.b("  _bcvma.push([\"setParameter\", \"VisitRef\", \"\"]);");t.b("\n" + i);t.b("  _bcvma.push([\"setParameter\", \"VisitInfo\", \"\"]);");t.b("\n" + i);t.b("  _bcvma.push([\"setParameter\", \"InitialQuestion\", \"");t.b(t.t(t.f("initialQuestion",c,p,0)));t.b("\" ]);");t.b("\n");t.b("\n" + i);if(t.s(t.f("isLogged",c,p,1),c,p,0,827,989,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("    _bcvma.push([\"setParameter\", \"CustomUrl\", \"https://cs-europe.groupon.com/search/results?commit=Search&appdomain=UK&search[email_address]=");t.b(t.v(t.f("userEmail",c,p,0)));t.b("\"]);");t.b("\n" + i);});c.pop();}t.b("\n" + i);if(!t.s(t.f("isLogged",c,p,1),c,p,1,0,0,"")){t.b("      _bcvma.push([\"setParameter\", \"CustomUrl\", \"\"]);");t.b("\n" + i);};t.b("\n" + i);t.b("  _bcvma.push([\"setParameter\", \"WindowParameters\", \"vn=\" + encodeURIComponent(\"");t.b(t.v(t.f("userName",c,p,0)));t.b("\") + \"&ve=\" + encodeURIComponent(\"");t.b(t.v(t.f("userEmail",c,p,0)));t.b("\") + \"&iq=\" + encodeURIComponent(\"");t.b(t.t(t.f("initialQuestion",c,p,0)));t.b("\") ]);");t.b("\n");t.b("\n" + i);if(t.s(t.f("isLogged",c,p,1),c,p,0,1307,1392,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("    _bcvma.push([\"addFloat\", {type: \"chat\", id: \"");t.b(t.v(t.d("liveChat.loggedInChatId",c,p,0)));t.b("\"}]);");t.b("\n" + i);});c.pop();}if(!t.s(t.f("isLogged",c,p,1),c,p,1,0,0,"")){t.b("    _bcvma.push([\"addFloat\", {type: \"chat\", id: \"");t.b(t.v(t.d("liveChat.loggedOutChatId",c,p,0)));t.b("\"}]);");t.b("\n" + i);};t.b("\n" + i);t.b("  _bcvma.push([\"pageViewed\"]);");t.b("\n" + i);t.b("  var bcLoad = function(){");t.b("\n" + i);t.b("    if(window.bcLoaded) return; window.bcLoaded = true;");t.b("\n" + i);t.b("    var vms = document.createElement(\"script\"); vms.type = \"text/javascript\"; vms.async = true;");t.b("\n" + i);t.b("    vms.src = ('https:'==document.location.protocol?'https://':'http://') + \"vmss.boldchat.com/aid/");t.b(t.v(t.d("liveChat.accountID",c,p,0)));t.b("/bc.vms4/vms.js\";");t.b("\n" + i);t.b("    var s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(vms, s);");t.b("\n" + i);t.b("  };");t.b("\n" + i);t.b("  if(window.pageViewer && pageViewer.load) pageViewer.load();");t.b("\n" + i);t.b("  else if(document.readyState==\"complete\") bcLoad();");t.b("\n" + i);t.b("  else if(window.addEventListener) window.addEventListener('load', bcLoad, false);");t.b("\n" + i);t.b("  else window.attachEvent('onload', bcLoad);");t.b("\n" + i);t.b("</script>");t.b("\n" + i);t.b("<noscript>");t.b("\n" + i);if(t.s(t.f("isLogged",c,p,1),c,p,0,2244,2593,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("  <a href=\"http://www.boldchat.com\" title=\"Visitor Monitoring\" target=\"_blank\"><img alt=\"Visitor Monitoring\" src=\"https://vms.boldchat.com/aid/");t.b(t.v(t.d("liveChat.accountID",c,p,0)));t.b("/bc.vmi?wdid=");t.b(t.v(t.d("liveChat.websiteDefID",c,p,0)));t.b("&amp;vr=&amp;vn=");t.b(t.v(t.f("userName",c,p,0)));t.b("&amp;vi=&amp;ve=");t.b(t.v(t.f("userEmail",c,p,0)));t.b("&amp;vp=&amp;iq=");t.b(t.t(t.f("initialQuestion",c,p,0)));t.b("&amp;curl=\" border=\"0\" width=\"1\" height=\"1\" /></a>");t.b("\n" + i);});c.pop();}t.b("\n" + i);if(!t.s(t.f("isLogged",c,p,1),c,p,1,0,0,"")){t.b("  <a href=\"http://www.boldchat.com\" title=\"Visitor Monitoring\" target=\"_blank\"><img alt=\"Visitor Monitoring\" src=\"https://vms.boldchat.com/aid/");t.b(t.v(t.d("liveChat.accountID",c,p,0)));t.b("/bc.vmi?wdid=");t.b(t.v(t.d("liveChat.websiteDefID",c,p,0)));t.b("&amp;vr=&amp;vn=&amp;vi=&amp;ve=&amp;vp=&amp;curl=\" border=\"0\" width=\"1\" height=\"1\" /></a>");t.b("\n" + i);};t.b("</noscript>");t.b("\n" + i);t.b("<!-- /BoldChat Visitor Monitor HTML v5.00 -->");t.b("\n");return t.fl(); },partials: {}, subs: {  }}, "<!-- BoldChat Visitor Monitor HTML v5.00 (Website=sac.groupon.com.br (Groupon Brazil),ChatButton=Brazil Floating Chat Button,ChatInvitation=Brazil Invitation Ruleset) -->\n<script type=\"text/javascript\">\n  window._bcvma = window._bcvma || [];\n  _bcvma.push([\"setAccountID\", \"{{liveChat.accountID}}\"]);\n  _bcvma.push([\"setParameter\", \"WebsiteID\", \"{{liveChat.websiteDefID}}\"]);\n  _bcvma.push([\"setParameter\", \"InvitationID\", \"{{liveChat.invitationDefID}}\"]);\n  _bcvma.push([\"setParameter\", \"VisitName\", \"{{userName}}\"]);\n  _bcvma.push([\"setParameter\", \"VisitPhone\", \"\"]);\n  _bcvma.push([\"setParameter\", \"VisitEmail\", \"{{userEmail}}\"]);\n  _bcvma.push([\"setParameter\", \"VisitRef\", \"\"]);\n  _bcvma.push([\"setParameter\", \"VisitInfo\", \"\"]);\n  _bcvma.push([\"setParameter\", \"InitialQuestion\", \"{{{initialQuestion}}}\" ]);\n\n  {{#isLogged}}\n    _bcvma.push([\"setParameter\", \"CustomUrl\", \"https://cs-europe.groupon.com/search/results?commit=Search&appdomain=UK&search[email_address]={{userEmail}}\"]);\n  {{/isLogged}}\n\n  {{^isLogged}}\n      _bcvma.push([\"setParameter\", \"CustomUrl\", \"\"]);\n  {{/isLogged}}\n\n  _bcvma.push([\"setParameter\", \"WindowParameters\", \"vn=\" + encodeURIComponent(\"{{userName}}\") + \"&ve=\" + encodeURIComponent(\"{{userEmail}}\") + \"&iq=\" + encodeURIComponent(\"{{{initialQuestion}}}\") ]);\n\n  {{#isLogged}}\n    _bcvma.push([\"addFloat\", {type: \"chat\", id: \"{{liveChat.loggedInChatId}}\"}]);\n  {{/isLogged}}\n  {{^isLogged}}\n    _bcvma.push([\"addFloat\", {type: \"chat\", id: \"{{liveChat.loggedOutChatId}}\"}]);\n  {{/isLogged}}\n\n  _bcvma.push([\"pageViewed\"]);\n  var bcLoad = function(){\n    if(window.bcLoaded) return; window.bcLoaded = true;\n    var vms = document.createElement(\"script\"); vms.type = \"text/javascript\"; vms.async = true;\n    vms.src = ('https:'==document.location.protocol?'https://':'http://') + \"vmss.boldchat.com/aid/{{liveChat.accountID}}/bc.vms4/vms.js\";\n    var s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(vms, s);\n  };\n  if(window.pageViewer && pageViewer.load) pageViewer.load();\n  else if(document.readyState==\"complete\") bcLoad();\n  else if(window.addEventListener) window.addEventListener('load', bcLoad, false);\n  else window.attachEvent('onload', bcLoad);\n</script>\n<noscript>\n{{#isLogged}}\n  <a href=\"http://www.boldchat.com\" title=\"Visitor Monitoring\" target=\"_blank\"><img alt=\"Visitor Monitoring\" src=\"https://vms.boldchat.com/aid/{{liveChat.accountID}}/bc.vmi?wdid={{liveChat.websiteDefID}}&amp;vr=&amp;vn={{userName}}&amp;vi=&amp;ve={{userEmail}}&amp;vp=&amp;iq={{{initialQuestion}}}&amp;curl=\" border=\"0\" width=\"1\" height=\"1\" /></a>\n{{/isLogged}}\n\n{{^isLogged}}\n  <a href=\"http://www.boldchat.com\" title=\"Visitor Monitoring\" target=\"_blank\"><img alt=\"Visitor Monitoring\" src=\"https://vms.boldchat.com/aid/{{liveChat.accountID}}/bc.vmi?wdid={{liveChat.websiteDefID}}&amp;vr=&amp;vn=&amp;vi=&amp;ve=&amp;vp=&amp;curl=\" border=\"0\" width=\"1\" height=\"1\" /></a>\n{{/isLogged}}\n</noscript>\n<!-- /BoldChat Visitor Monitor HTML v5.00 -->\n", Hogan);
},{"hogan.js":248}],217:[function(require,module,exports){
var Hogan = require('hogan.js');
module.exports = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<input type=\"checkbox\" class=\"add\" id=\"redemptionLocation");t.b(t.v(t.f("locationId",c,p,0)));t.b("\" ");t.b(t.v(t.f("checked",c,p,0)));t.b(" value=\"\" aria-label=\"Address\">");t.b("\n" + i);t.b(t.v(t.f("address",c,p,0)));t.b("\n");t.b("\n");t.b("\n");return t.fl(); },partials: {}, subs: {  }}, "<input type=\"checkbox\" class=\"add\" id=\"redemptionLocation{{locationId}}\" {{checked}} value=\"\" aria-label=\"Address\">\n{{address}}\n\n\n", Hogan);
},{"hogan.js":248}],218:[function(require,module,exports){
var Hogan = require('hogan.js');
module.exports = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<table>");t.b("\n" + i);t.b("<tr>");t.b("\n" + i);t.b("  <td width=\"10%\" vertical-align=\"top\">");t.b("\n" + i);t.b("  <input type=\"checkbox\" class=\"add\" id=\"locationElement");t.b(t.v(t.f("locationId",c,p,0)));t.b("\"  ");t.b(t.v(t.f("checked",c,p,0)));t.b(" value=\"\" aria-label=\"Address\"></td>");t.b("\n" + i);t.b("  <td class=\"locations\" width=\"90%\"><label>");t.b(t.v(t.f("firstLine",c,p,0)));t.b(" <br> ");t.b(t.v(t.f("secondLine",c,p,0)));t.b(" </label></td>");t.b("\n" + i);t.b("</tr>");t.b("\n" + i);t.b("</table>");t.b("\n");t.b("\n");t.b("\n");return t.fl(); },partials: {}, subs: {  }}, "<table>\n<tr>\n  <td width=\"10%\" vertical-align=\"top\">\n  <input type=\"checkbox\" class=\"add\" id=\"locationElement{{locationId}}\"  {{checked}} value=\"\" aria-label=\"Address\"></td>\n  <td class=\"locations\" width=\"90%\"><label>{{firstLine}} <br> {{secondLine}} </label></td>\n</tr>\n</table>\n\n\n", Hogan);
},{"hogan.js":248}],219:[function(require,module,exports){
var Hogan = require('hogan.js');
module.exports = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<div id=\"popupContent\" class=\"modal show-modal\">");t.b("\n" + i);t.b("	<div class=\"modal-body\">");t.b("\n" + i);t.b("		<a href=\"javascript:;\" data-modal-id=\"popupContent\" class=\"close-modal icon-x\"></a>");t.b("\n" + i);t.b("		<h3 class=\"modal-title\">");if(t.s(t.f("translate",c,p,1),c,p,0,201,234,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.selectlocation");});c.pop();}t.b("</h3>");t.b("\n" + i);t.b("		<div class=\"row\">");t.b("\n" + i);t.b("			<div class=\"twelve columns p20\" id=\"generalContent\">");t.b("\n" + i);t.b("				<div class=\"locationPopupData\">");t.b("\n" + i);t.b("	<table id=\"locationsTable\" width=\"100%\" class=\"scrollableTable\">");t.b("\n" + i);t.b("	</table>");t.b("\n" + i);t.b("</div>");t.b("\n");t.b("\n" + i);t.b("	<div class=\"w100 locationPagination\">");t.b("\n" + i);t.b("		<div id=\"locationPagination\" class=\"locationPaginationcenter\">");t.b("\n" + i);t.b("		</div>");t.b("\n" + i);t.b("	</div>");t.b("\n" + i);t.b("<div class=\"ui-dialog-buttonpane ui-widget-content u-helper-clearfix ui-popup-footer\" style=\"margin-top:0px\">");t.b("\n" + i);t.b("	<table width=\"100%\">");t.b("\n" + i);t.b("		<tbody><tr>");t.b("\n");t.b("\n" + i);t.b("		<td horizontal-align=\"right\">");t.b("\n" + i);t.b("		<div class=\"ui-dialog-buttonset\">");t.b("\n" + i);t.b("		<a class=\"b-close anchorHover\" id=\"cancelLocationSelect\">");if(t.s(t.f("translate",c,p,1),c,p,0,859,884,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.cancel");});c.pop();}t.b("</a>");t.b("\n" + i);t.b("		<input id=\"btnsubmit\" type=\"button\"");t.b("\n" + i);t.b("			class=\"testSelector button btnWhite\" value=\"");if(t.s(t.f("translate",c,p,1),c,p,0,1002,1025,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.cont");});c.pop();}t.b("\" style=\"margin-left: 15px;\">");t.b("\n" + i);t.b("		</button>");t.b("\n" + i);t.b("		</div>");t.b("\n");t.b("\n" + i);t.b("		</td>");t.b("\n" + i);t.b("		</tr>");t.b("\n" + i);t.b("		</tbody>");t.b("\n" + i);t.b("	</table>");t.b("\n" + i);t.b("</div>");t.b("\n" + i);t.b("			</div>");t.b("\n" + i);t.b("		</div>");t.b("\n" + i);t.b("	</div>");t.b("\n" + i);t.b("</div>");t.b("\n");t.b("\n");return t.fl(); },partials: {}, subs: {  }}, "<div id=\"popupContent\" class=\"modal show-modal\">\n\t<div class=\"modal-body\">\n\t\t<a href=\"javascript:;\" data-modal-id=\"popupContent\" class=\"close-modal icon-x\"></a>\n\t\t<h3 class=\"modal-title\">{{#translate}}js.modules.support.selectlocation{{/translate}}</h3>\n\t\t<div class=\"row\">\n\t\t\t<div class=\"twelve columns p20\" id=\"generalContent\">\n\t\t\t\t<div class=\"locationPopupData\">\n\t<table id=\"locationsTable\" width=\"100%\" class=\"scrollableTable\">\n\t</table>\n</div>\n\n\t<div class=\"w100 locationPagination\">\n\t\t<div id=\"locationPagination\" class=\"locationPaginationcenter\">\n\t\t</div>\n\t</div>\n<div class=\"ui-dialog-buttonpane ui-widget-content u-helper-clearfix ui-popup-footer\" style=\"margin-top:0px\">\n\t<table width=\"100%\">\n\t\t<tbody><tr>\n\n\t\t<td horizontal-align=\"right\">\n\t\t<div class=\"ui-dialog-buttonset\">\n\t\t<a class=\"b-close anchorHover\" id=\"cancelLocationSelect\">{{#translate}}js.modules.support.cancel{{/translate}}</a>\n\t\t<input id=\"btnsubmit\" type=\"button\"\n\t\t\tclass=\"testSelector button btnWhite\" value=\"{{#translate}}js.modules.support.cont{{/translate}}\" style=\"margin-left: 15px;\">\n\t\t</button>\n\t\t</div>\n\n\t\t</td>\n\t\t</tr>\n\t\t</tbody>\n\t</table>\n</div>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>\n\n", Hogan);
},{"hogan.js":248}],220:[function(require,module,exports){
var Hogan = require('hogan.js');
module.exports = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<li class=\"requestedFields mb40\">");t.b("\n" + i);t.b("  <label>");t.b("\n" + i);if(t.s(t.f("currentUserAndOrderCheck",c,p,1),c,p,0,77,198,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("    <strong class = \"userbusinnesLocation\">");if(t.s(t.f("translate",c,p,1),c,p,0,135,170,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.businesslocation");});c.pop();}t.b("</strong>");t.b("\n" + i);});c.pop();}if(!t.s(t.f("currentUserAndOrderCheck",c,p,1),c,p,1,0,0,"")){t.b("    <strong class = \"businnesNameAndLocation\">");if(t.s(t.f("translate",c,p,1),c,p,0,322,367,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.business_name_and_location");});c.pop();}t.b("</strong>");t.b("\n" + i);};t.b("    <span class=\"mandatory-field\">* </span>");t.b("\n" + i);t.b("  </label>");t.b("\n" + i);if(!t.s(t.f("collectFromAvailableLocations",c,p,1),c,p,1,0,0,"")){t.b("    <input class=\"inputField\" id=\"businessLocation\" type=\"text\" name=\"location\" size=\"40\" maxLength=\"250\"");t.b("\n" + i);t.b("    placeholder=\"");if(t.s(t.f("translate",c,p,1),c,p,0,654,701,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.business_address_placeholder");});c.pop();}t.b(" \" aria-label=\"Business Address\">");t.b("\n" + i);t.b("    <br>");t.b("\n" + i);t.b("    <span id=\"validateBusinessLocation\" class=\"invalid-input initially-hidden\">");t.b("\n" + i);t.b("      ");if(t.s(t.f("translate",c,p,1),c,p,0,858,902,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.invalid_business_location");});c.pop();}t.b("\n" + i);t.b("      <br>");t.b("\n" + i);t.b("    </span>");t.b("\n" + i);};if(t.s(t.f("collectFromAvailableLocations",c,p,1),c,p,0,1013,1309,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("    <div id=\"locations\"> ");t.b("\n" + i);t.b("    </div>");t.b("\n" + i);if(t.s(t.f("showAll",c,p,1),c,p,0,1067,1294,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("      <a id=\"showAllLocations\" data-bhw=\"SeeMoreLocations\">");t.b("\n" + i);t.b("        ");if(t.s(t.f("translate",c,p,1),c,p,0,1150,1177,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.show_all");});c.pop();}t.b(" ");t.b(t.v(t.f("numOfRedemptionLocations",c,p,0)));t.b("  ");if(t.s(t.f("translate",c,p,1),c,p,0,1236,1264,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.locations");});c.pop();}t.b("\n" + i);t.b("      </a>");t.b("\n" + i);});c.pop();}});c.pop();}t.b("</li>");t.b("\n");return t.fl(); },partials: {}, subs: {  }}, "<li class=\"requestedFields mb40\">\n  <label>\n    {{#currentUserAndOrderCheck}}\n    <strong class = \"userbusinnesLocation\">{{#translate}}js.modules.support.businesslocation{{/translate}}</strong>\n    {{/currentUserAndOrderCheck}}\n    {{^currentUserAndOrderCheck}}\n    <strong class = \"businnesNameAndLocation\">{{#translate}}js.modules.support.business_name_and_location{{/translate}}</strong>\n    {{/currentUserAndOrderCheck}}\n    <span class=\"mandatory-field\">* </span>\n  </label>\n  {{^collectFromAvailableLocations}}\n    <input class=\"inputField\" id=\"businessLocation\" type=\"text\" name=\"location\" size=\"40\" maxLength=\"250\"\n    placeholder=\"{{#translate}}js.modules.support.business_address_placeholder{{/translate}} \" aria-label=\"Business Address\">\n    <br>\n    <span id=\"validateBusinessLocation\" class=\"invalid-input initially-hidden\">\n      {{#translate}}js.modules.support.invalid_business_location{{/translate}}\n      <br>\n    </span>\n  {{/collectFromAvailableLocations}}\n  {{#collectFromAvailableLocations}}\n    <div id=\"locations\"> \n    </div>\n    {{#showAll}}\n      <a id=\"showAllLocations\" data-bhw=\"SeeMoreLocations\">\n        {{#translate}}js.modules.support.show_all{{/translate}} {{numOfRedemptionLocations}}  {{#translate}}js.modules.support.locations{{/translate}}\n      </a>\n    {{/showAll}}\n  {{/collectFromAvailableLocations}}\n</li>\n", Hogan);
},{"hogan.js":248}],221:[function(require,module,exports){
var Hogan = require('hogan.js');
module.exports = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<div class=\"modal show-modal\">");t.b("\n" + i);t.b("  <div class=\"modal-body\">");t.b("\n" + i);t.b("    <a href=\"javascript:;\" class=\"close-modal icon-x\"></a>");t.b("\n" + i);t.b("    <h3 class=\"modal-title\">");t.b(t.v(t.f("title",c,p,0)));t.b("</h3>");t.b("\n" + i);t.b("    <div class=\"row\">");t.b("\n" + i);t.b("      <div class=\"orderPopupData border-bottom p20\" style=\"overflow-y: auto;\">");t.b("\n" + i);if(t.s(t.f("showAlertMessage",c,p,1),c,p,0,290,451,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("          <div class=\"alertMsg notification warning twelve\">");t.b("\n" + i);t.b("            <span>");t.b("\n" + i);t.b("              ");t.b(t.t(t.f("alertMessage",c,p,0)));t.b("\n" + i);t.b("            </span>  ");t.b("\n" + i);t.b("          </div>");t.b("\n" + i);});c.pop();}t.b("        <div class=\"vouMsg\" style=\"margin: 0px 20px 20px 0px;\">");t.b("\n" + i);t.b("          ");if(t.s(t.f("translate",c,p,1),c,p,0,561,588,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.click_on");});c.pop();}t.b("\"");t.b(t.v(t.f("singleActionButtonName",c,p,0)));t.b("\"");if(!t.s(t.f("return_item",c,p,1),c,p,1,0,0,"")){if(t.s(t.f("translate",c,p,1),c,p,0,660,690,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.next_to_grp");});c.pop();}};if(t.s(t.f("return_item",c,p,1),c,p,0,736,801,"{{ }}")){t.rs(c,p,function(c,p,t){if(t.s(t.f("translate",c,p,1),c,p,0,750,787,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.return_next_to_grp");});c.pop();}});c.pop();}t.b("\n" + i);if(t.s(t.d("vouchers.validExpirationDate",c,p,1),c,p,0,861,1032,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("          <span class=\"expOn\">");if(t.s(t.f("translate",c,p,1),c,p,0,906,935,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.expires_on");});c.pop();}t.b("</span>");t.b("\n" + i);t.b("          <span class=\"utctime\" >");t.b(t.v(t.d("vouchers.expiredDate",c,p,0)));t.b("</span>");t.b("\n" + i);});c.pop();}if(!t.s(t.d("vouchers.validExpirationDate",c,p,1),c,p,1,0,0,"")){t.b("            <span class=\"expOn\">");if(t.s(t.f("translate",c,p,1),c,p,0,1156,1188,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.never_expires");});c.pop();}t.b("</span>");t.b("\n" + i);};t.b("        </div>");t.b("\n" + i);t.b("        <table id=\"vouchers\" class=\"scrollableTable\">");t.b("\n" + i);t.b("          <tbody>");t.b("\n" + i);t.b("            <tr>");t.b("\n" + i);t.b("              <td>");t.b("\n" + i);t.b("                <img src= ");t.b(t.v(t.d("vouchers.deal.sidebarImageUrl",c,p,0)));t.b(">");t.b("\n" + i);t.b("              </td>");t.b("\n" + i);t.b("              <td class=\"pkgDtl\">");t.b("\n" + i);t.b("                ");t.b(t.v(t.d("vouchers.merchant.name",c,p,0)));t.b("\n" + i);t.b("                <div>");t.b("\n" + i);t.b("                  <span>");if(t.s(t.f("translate",c,p,1),c,p,0,1595,1624,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.purchased1");});c.pop();}t.b("</span>");t.b("\n" + i);t.b("                  <span class=\"localtime\">");t.b(t.v(t.d("vouchers.purchasedDate",c,p,0)));t.b("</span>");t.b("\n" + i);t.b("                </div>");t.b("\n" + i);if(t.s(t.f("showViewOrderDetailsLink",c,p,1),c,p,0,1792,1998,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("                    <div>");t.b("\n" + i);t.b("                      <a id=\"viewOrderDtls\" class=\"anchorHover\">");if(t.s(t.f("translate",c,p,1),c,p,0,1897,1934,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.view_order_details");});c.pop();}t.b("</a>");t.b("\n" + i);t.b("                    </div>");t.b("\n" + i);});c.pop();}t.b("              <td style=\"padding-right: 0px;\">");t.b("\n" + i);t.b("                <table>");t.b("\n" + i);t.b("                  <tbody>");t.b("\n" + i);if(t.s(t.d("vouchers.groupons",c,p,1),c,p,0,2167,5028,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("                      <tr id=");t.b(t.v(t.f("id",c,p,0)));t.b(">");t.b("\n" + i);t.b("                        <td class=\"vcrDtl\">");t.b("\n" + i);t.b("                          ");t.b(t.v(t.f("index",c,p,0)));t.b(".");t.b("\n" + i);t.b("                          <a href=\"/deals/");t.b(t.v(t.f("dealPermalink",c,p,0)));t.b("\">");t.b(t.v(t.f("dealOptionTitle",c,p,0)));t.b("</a>");t.b("\n" + i);t.b("                        </td>");t.b("\n" + i);if(t.s(t.f("isRedeemed",c,p,1),c,p,0,2440,2627,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("                          <td style=\"padding-right: 0px\" id='redeemed_text' style=\"font-size: 12px;\">");if(t.s(t.f("translate",c,p,1),c,p,0,2556,2583,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.Redeemed");});c.pop();}t.b("</td>");t.b("\n" + i);});c.pop();}if(t.s(t.f("isRefunded",c,p,1),c,p,0,2682,2869,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("                          <td style=\"padding-right: 0px\" id='redeemed_text' style=\"font-size: 12px;\">");if(t.s(t.f("translate",c,p,1),c,p,0,2798,2825,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.refunded");});c.pop();}t.b("</td>");t.b("\n" + i);});c.pop();}if(t.s(t.f("showSingleActionButton",c,p,1),c,p,0,2936,4952,"{{ }}")){t.rs(c,p,function(c,p,t){if(t.s(t.f("view_voucher",c,p,1),c,p,0,2980,3407,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("                          <td class = \"viewVoucherTd\" style=\"padding-right: 0px\">");t.b("\n" + i);t.b("                            <a href = \"");t.b(t.v(t.f("url",c,p,0)));t.b(" \" target=\"_blank\" type=\"button\" class=\"btn btn-small fr singleActionBtn viewVoucherButton\" style=\"font-size: 13px;\" data-bhw=\"view-voucher-download__");t.b(t.v(t.f("orderId",c,p,0)));t.b("__");t.b(t.v(t.f("dealId",c,p,0)));t.b("__");t.b(t.v(t.f("channel",c,p,0)));t.b("__");t.b(t.v(t.f("country",c,p,0)));t.b("__");t.b(t.v(t.f("id",c,p,0)));t.b("\">");t.b(t.v(t.f("singleActionButtonName",c,p,0)));t.b("</a>");t.b("\n" + i);t.b("                          </td>");t.b("\n" + i);});c.pop();}if(t.s(t.f("return_item",c,p,1),c,p,0,3467,3882,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("                          <td class = \"returnItemTd\" style=\"padding-right: 0px\">");t.b("\n" + i);t.b("                            <a href = \"");t.b(t.v(t.f("url",c,p,0)));t.b(" \" target=\"_blank\" type=\"button\" class=\"btn btn-small fr singleActionBtn returnItemButton\" style=\"font-size: 13px;\" data-bhw=\"return-item__");t.b(t.v(t.f("orderId",c,p,0)));t.b("__");t.b(t.v(t.f("dealId",c,p,0)));t.b("__");t.b(t.v(t.f("channel",c,p,0)));t.b("__");t.b(t.v(t.f("country",c,p,0)));t.b("__");t.b(t.v(t.f("id",c,p,0)));t.b("\">");t.b(t.v(t.f("singleActionButtonName",c,p,0)));t.b("</a>");t.b("\n" + i);t.b("                          </td>");t.b("\n" + i);});c.pop();}if(t.s(t.f("print_gift_card_voucher",c,p,1),c,p,0,3953,4415,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("                          <td class = \"printGiftCardVoucher\" style=\"padding-right: 0px\">");t.b("\n" + i);t.b("                            <a href = \"");t.b(t.v(t.f("url",c,p,0)));t.b(" \" target=\"_blank\" type=\"button\" class=\"btn btn-small fr singleActionBtn printGiftCardVoucherButton\" style=\"font-size: 13px;text-align:center\" data-bhw=\"print_gift_card_voucher__");t.b(t.v(t.f("orderId",c,p,0)));t.b("__");t.b(t.v(t.f("dealId",c,p,0)));t.b("__");t.b(t.v(t.f("channel",c,p,0)));t.b("__");t.b(t.v(t.f("country",c,p,0)));t.b("__");t.b(t.v(t.f("id",c,p,0)));t.b("\">");t.b(t.v(t.f("singleActionButtonName",c,p,0)));t.b("</a>");t.b("\n" + i);t.b("                          </td>");t.b("\n" + i);});c.pop();}if(t.s(t.f("order_food",c,p,1),c,p,0,4485,4912,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("                          <td class = \"orderFood\" style=\"padding-right: 0px\">");t.b("\n" + i);t.b("                            <a href = \"");t.b(t.v(t.f("url",c,p,0)));t.b(" \" target=\"_blank\" type=\"button\" class=\"btn btn-small fr singleActionBtn orderFoodButton\" style=\"font-size: 13px;text-align:center\" data-bhw=\"order_food__");t.b(t.v(t.f("orderId",c,p,0)));t.b("__");t.b(t.v(t.f("dealId",c,p,0)));t.b("__");t.b(t.v(t.f("channel",c,p,0)));t.b("__");t.b(t.v(t.f("country",c,p,0)));t.b("__");t.b(t.v(t.f("id",c,p,0)));t.b("\">");t.b(t.v(t.f("singleActionButtonName",c,p,0)));t.b("</a>");t.b("\n" + i);t.b("                          </td>");t.b("\n" + i);});c.pop();}});c.pop();}t.b("                      </tr>");t.b("\n" + i);});c.pop();}if(t.s(t.f("urlForVouchers",c,p,1),c,p,0,5090,5602,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("                      <tr id='viewAllVouchers'>");t.b("\n" + i);t.b("                        <td class=\"vcrDtl\"></td>");t.b("\n" + i);t.b("                        <td style=\"padding-right: 0px\">");t.b("\n" + i);t.b("                          <a href = \"");t.b(t.v(t.f("urlForVouchers",c,p,0)));t.b("\" target=\"_blank\" type=\"button\" class=\"btn btn-small fr singleActionBtn returnItemButton\" style=\"font-size: 12px;\" data-bhw=\"return-item-popup__");t.b(t.v(t.f("orderId",c,p,0)));t.b("__");t.b(t.v(t.f("dealId",c,p,0)));t.b("__");t.b(t.v(t.f("channel",c,p,0)));t.b("__");t.b(t.v(t.f("country",c,p,0)));t.b("\">");t.b(t.v(t.f("groupActionButtonName",c,p,0)));t.b("</a>");t.b("\n" + i);t.b("                        </td>");t.b("\n" + i);t.b("                      </tr>");t.b("\n" + i);});c.pop();}t.b("                    <tr>");t.b("\n" + i);t.b("                      <td class=\"vcrDtl\"></td>");t.b("\n" + i);t.b("                    </tr>");t.b("\n" + i);t.b("                  </tbody>");t.b("\n" + i);t.b("                </table>");t.b("\n" + i);t.b("              </td>");t.b("\n" + i);t.b("            </tr>");t.b("\n" + i);t.b("          </tbody>");t.b("\n" + i);t.b("        </table>");t.b("\n" + i);t.b("      </div>");t.b("\n" + i);t.b("    </div>");t.b("\n" + i);t.b("  </div>");t.b("\n" + i);t.b("</div>");return t.fl(); },partials: {}, subs: {  }}, "<div class=\"modal show-modal\">\n  <div class=\"modal-body\">\n    <a href=\"javascript:;\" class=\"close-modal icon-x\"></a>\n    <h3 class=\"modal-title\">{{title}}</h3>\n    <div class=\"row\">\n      <div class=\"orderPopupData border-bottom p20\" style=\"overflow-y: auto;\">\n        {{#showAlertMessage}}\n          <div class=\"alertMsg notification warning twelve\">\n            <span>\n              {{{alertMessage}}}\n            </span>  \n          </div>\n        {{/showAlertMessage}}\n        <div class=\"vouMsg\" style=\"margin: 0px 20px 20px 0px;\">\n          {{#translate}}js.modules.support.click_on{{/translate}}\"{{singleActionButtonName}}\"{{^return_item}}{{#translate}}js.modules.support.next_to_grp{{/translate}}{{/return_item}}{{#return_item}}{{#translate}}js.modules.support.return_next_to_grp{{/translate}}{{/return_item}}\n          {{#vouchers.validExpirationDate}}\n          <span class=\"expOn\">{{#translate}}js.modules.support.expires_on{{/translate}}</span>\n          <span class=\"utctime\" >{{vouchers.expiredDate}}</span>\n          {{/vouchers.validExpirationDate}}\n          {{^vouchers.validExpirationDate}}\n            <span class=\"expOn\">{{#translate}}js.modules.support.never_expires{{/translate}}</span>\n          {{/vouchers.validExpirationDate}}\n        </div>\n        <table id=\"vouchers\" class=\"scrollableTable\">\n          <tbody>\n            <tr>\n              <td>\n                <img src= {{vouchers.deal.sidebarImageUrl}}>\n              </td>\n              <td class=\"pkgDtl\">\n                {{vouchers.merchant.name}}\n                <div>\n                  <span>{{#translate}}js.modules.support.purchased1{{/translate}}</span>\n                  <span class=\"localtime\">{{vouchers.purchasedDate}}</span>\n                </div>\n                  {{#showViewOrderDetailsLink}}\n                    <div>\n                      <a id=\"viewOrderDtls\" class=\"anchorHover\">{{#translate}}js.modules.support.view_order_details{{/translate}}</a>\n                    </div>\n                  {{/showViewOrderDetailsLink}}\n              <td style=\"padding-right: 0px;\">\n                <table>\n                  <tbody>\n                    {{#vouchers.groupons}}\n                      <tr id={{id}}>\n                        <td class=\"vcrDtl\">\n                          {{index}}.\n                          <a href=\"/deals/{{dealPermalink}}\">{{dealOptionTitle}}</a>\n                        </td>\n                        {{#isRedeemed}}\n                          <td style=\"padding-right: 0px\" id='redeemed_text' style=\"font-size: 12px;\">{{#translate}}js.modules.support.Redeemed{{/translate}}</td>\n                        {{/isRedeemed}}\n                        {{#isRefunded}}\n                          <td style=\"padding-right: 0px\" id='redeemed_text' style=\"font-size: 12px;\">{{#translate}}js.modules.support.refunded{{/translate}}</td>\n                        {{/isRefunded}}\n                        {{#showSingleActionButton}}\n                          {{#view_voucher}}\n                          <td class = \"viewVoucherTd\" style=\"padding-right: 0px\">\n                            <a href = \"{{url}} \" target=\"_blank\" type=\"button\" class=\"btn btn-small fr singleActionBtn viewVoucherButton\" style=\"font-size: 13px;\" data-bhw=\"view-voucher-download__{{orderId}}__{{dealId}}__{{channel}}__{{country}}__{{id}}\">{{singleActionButtonName}}</a>\n                          </td>\n                          {{/view_voucher}}\n                          {{#return_item}}\n                          <td class = \"returnItemTd\" style=\"padding-right: 0px\">\n                            <a href = \"{{url}} \" target=\"_blank\" type=\"button\" class=\"btn btn-small fr singleActionBtn returnItemButton\" style=\"font-size: 13px;\" data-bhw=\"return-item__{{orderId}}__{{dealId}}__{{channel}}__{{country}}__{{id}}\">{{singleActionButtonName}}</a>\n                          </td>\n                          {{/return_item}}\n                          {{#print_gift_card_voucher}}\n                          <td class = \"printGiftCardVoucher\" style=\"padding-right: 0px\">\n                            <a href = \"{{url}} \" target=\"_blank\" type=\"button\" class=\"btn btn-small fr singleActionBtn printGiftCardVoucherButton\" style=\"font-size: 13px;text-align:center\" data-bhw=\"print_gift_card_voucher__{{orderId}}__{{dealId}}__{{channel}}__{{country}}__{{id}}\">{{singleActionButtonName}}</a>\n                          </td>\n                          {{/print_gift_card_voucher}}\n                          {{#order_food}}\n                          <td class = \"orderFood\" style=\"padding-right: 0px\">\n                            <a href = \"{{url}} \" target=\"_blank\" type=\"button\" class=\"btn btn-small fr singleActionBtn orderFoodButton\" style=\"font-size: 13px;text-align:center\" data-bhw=\"order_food__{{orderId}}__{{dealId}}__{{channel}}__{{country}}__{{id}}\">{{singleActionButtonName}}</a>\n                          </td>\n                          {{/order_food}}\n                        {{/showSingleActionButton}}\n                      </tr>\n                    {{/vouchers.groupons}}\n                    {{#urlForVouchers}}\n                      <tr id='viewAllVouchers'>\n                        <td class=\"vcrDtl\"></td>\n                        <td style=\"padding-right: 0px\">\n                          <a href = \"{{urlForVouchers}}\" target=\"_blank\" type=\"button\" class=\"btn btn-small fr singleActionBtn returnItemButton\" style=\"font-size: 12px;\" data-bhw=\"return-item-popup__{{orderId}}__{{dealId}}__{{channel}}__{{country}}\">{{groupActionButtonName}}</a>\n                        </td>\n                      </tr>\n                    {{/urlForVouchers}}\n                    <tr>\n                      <td class=\"vcrDtl\"></td>\n                    </tr>\n                  </tbody>\n                </table>\n              </td>\n            </tr>\n          </tbody>\n        </table>\n      </div>\n    </div>\n  </div>\n</div>", Hogan);
},{"hogan.js":248}],222:[function(require,module,exports){
var Hogan = require('hogan.js');
module.exports = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<div class=\"help-wizard-content\">");t.b("\n" + i);t.b("  <div class=\"steps-container\"> </div>");t.b("\n" + i);t.b("  <h4>");if(t.s(t.f("translate",c,p,1),c,p,0,93,130,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.like_to_contact_us");});c.pop();}t.b("</h4>");t.b("\n" + i);t.b("  <div class=\"twelve columns optimized-contact-channels-v1\">");t.b("\n" + i);if(t.s(t.f("isLiveChatEnabled",c,p,1),c,p,0,237,641,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("      <div class=\"three columns optimized-live-chat-container hide text-center\">");t.b("\n" + i);t.b("          <div class=\"live-chat-container optimized-contact-channel\" data-bhw=\"optimized-chat-btn\" id=\"live-chat-container\"></div>");t.b("\n" + i);t.b("          <p> ");if(t.s(t.f("translate",c,p,1),c,p,0,478,515,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.chat_available_now");});c.pop();}t.b("</p>");t.b("\n" + i);t.b("          <p> ");if(t.s(t.f("translate",c,p,1),c,p,0,562,605,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.advantage_of_online_chat");});c.pop();}t.b("</p>");t.b("\n" + i);t.b("      </div>");t.b("\n" + i);});c.pop();}t.b("    ");t.b("\n" + i);if(!t.s(t.f("isPhonePreferredChannel",c,p,1),c,p,1,0,0,"")){t.b("    <div class=\"three columns optimized-email-container\">");t.b("\n" + i);t.b("      <div class='optimized-contact-channel text-center'>");t.b("\n" + i);t.b("        <input class=\"btn-optimized-contact-channel optimized-email-us btn btn-invert\" type=\"button\" data-bhw=\"optimized-email-btn\" value=");if(t.s(t.f("translate",c,p,1),c,p,0,970,994,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.email");});c.pop();}t.b(" />");t.b("\n" + i);t.b("        <div class='optimized-email-us-p'>");t.b("\n" + i);t.b("          <p> ");if(t.s(t.f("translate",c,p,1),c,p,0,1083,1118,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.avoid_hold_times");});c.pop();}t.b("</p>");t.b("\n" + i);t.b("          <p> ");if(t.s(t.f("translate",c,p,1),c,p,0,1165,1207,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.response_time_for_phone");});c.pop();}t.b("</p>");t.b("\n" + i);t.b("          <p> ");if(t.s(t.f("translate",c,p,1),c,p,0,1254,1291,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.sensitive_requests");});c.pop();}t.b("</p>");t.b("\n" + i);t.b("        </div>");t.b("\n" + i);t.b("      </div>");t.b("\n" + i);t.b("    </div>");t.b("\n" + i);};t.b("    <div class=\"three columns optimized-phone-container\">");t.b("\n" + i);t.b("      <div class='optimized-contact-channel text-center'>");t.b("\n" + i);t.b("        <input class=\"btn-optimized-contact-channel optimized-phone-btn btn-invert\" type=\"button\" data-bhw=\"optimized-phone-button\" value=");if(t.s(t.f("translate",c,p,1),c,p,0,1650,1674,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.phone");});c.pop();}t.b(" />");t.b("\n" + i);t.b("        <div class='optimized-phone-p'>");t.b("\n" + i);t.b("          <p>");if(t.s(t.f("translate",c,p,1),c,p,0,1759,1799,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.best_assist_for_phone");});c.pop();}t.b("</p>");t.b("\n" + i);t.b("          <p>");if(t.s(t.f("translate",c,p,1),c,p,0,1845,1878,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.please_call_us");});c.pop();}t.b("</p>");t.b("\n" + i);t.b("        </div>");t.b("\n" + i);t.b("      </div>");t.b("\n" + i);t.b("    </div>");t.b("\n" + i);if(t.s(t.f("isPhonePreferredChannel",c,p,1),c,p,0,1968,2316,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("      <div class=\"three columns optimized-email-container\">");t.b("\n" + i);t.b("        <div class='optimized-contact-channel text-center'>");t.b("\n" + i);t.b("          <input class=\"btn-optimized-contact-channel optimized-email-us btn btn-invert\" type=\"button\" data-bhw=\"optimized-email-us\" value=");if(t.s(t.f("translate",c,p,1),c,p,0,2242,2266,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.email");});c.pop();}t.b(" />");t.b("\n" + i);t.b("        </div>");t.b("\n" + i);t.b("      </div>");t.b("\n" + i);});c.pop();}t.b("  </div>");t.b("\n" + i);t.b("</div>");return t.fl(); },partials: {}, subs: {  }}, "<div class=\"help-wizard-content\">\n  <div class=\"steps-container\"> </div>\n  <h4>{{#translate}}js.modules.support.like_to_contact_us{{/translate}}</h4>\n  <div class=\"twelve columns optimized-contact-channels-v1\">\n    {{#isLiveChatEnabled}}\n      <div class=\"three columns optimized-live-chat-container hide text-center\">\n          <div class=\"live-chat-container optimized-contact-channel\" data-bhw=\"optimized-chat-btn\" id=\"live-chat-container\"></div>\n          <p> {{#translate}}js.modules.support.chat_available_now{{/translate}}</p>\n          <p> {{#translate}}js.modules.support.advantage_of_online_chat{{/translate}}</p>\n      </div>\n    {{/isLiveChatEnabled}}\n    \n    {{^isPhonePreferredChannel}}\n    <div class=\"three columns optimized-email-container\">\n      <div class='optimized-contact-channel text-center'>\n        <input class=\"btn-optimized-contact-channel optimized-email-us btn btn-invert\" type=\"button\" data-bhw=\"optimized-email-btn\" value={{#translate}}js.modules.support.email{{/translate}} />\n        <div class='optimized-email-us-p'>\n          <p> {{#translate}}js.modules.support.avoid_hold_times{{/translate}}</p>\n          <p> {{#translate}}js.modules.support.response_time_for_phone{{/translate}}</p>\n          <p> {{#translate}}js.modules.support.sensitive_requests{{/translate}}</p>\n        </div>\n      </div>\n    </div>\n    {{/isPhonePreferredChannel}}\n    <div class=\"three columns optimized-phone-container\">\n      <div class='optimized-contact-channel text-center'>\n        <input class=\"btn-optimized-contact-channel optimized-phone-btn btn-invert\" type=\"button\" data-bhw=\"optimized-phone-button\" value={{#translate}}js.modules.support.phone{{/translate}} />\n        <div class='optimized-phone-p'>\n          <p>{{#translate}}js.modules.support.best_assist_for_phone{{/translate}}</p>\n          <p>{{#translate}}js.modules.support.please_call_us{{/translate}}</p>\n        </div>\n      </div>\n    </div>\n    {{#isPhonePreferredChannel}}\n      <div class=\"three columns optimized-email-container\">\n        <div class='optimized-contact-channel text-center'>\n          <input class=\"btn-optimized-contact-channel optimized-email-us btn btn-invert\" type=\"button\" data-bhw=\"optimized-email-us\" value={{#translate}}js.modules.support.email{{/translate}} />\n        </div>\n      </div>\n    {{/isPhonePreferredChannel}}\n  </div>\n</div>", Hogan);
},{"hogan.js":248}],223:[function(require,module,exports){
var Hogan = require('hogan.js');
module.exports = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<input class=\"button\" id=\"track_orders_btn\" type=\"submit\" value=");if(t.s(t.f("translate",c,p,1),c,p,0,78,103,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.trkord");});c.pop();}t.b(" />");t.b("\n" + i);t.b("<input class=\"button\" id=\"return_item_btn\" type=\"submit\" value=");if(t.s(t.f("translate",c,p,1),c,p,0,198,223,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.retitm");});c.pop();}t.b(" onClick='showModal();' />");return t.fl(); },partials: {}, subs: {  }}, "<input class=\"button\" id=\"track_orders_btn\" type=\"submit\" value={{#translate}}js.modules.support.trkord{{/translate}} />\n<input class=\"button\" id=\"return_item_btn\" type=\"submit\" value={{#translate}}js.modules.support.retitm{{/translate}} onClick='showModal();' />", Hogan);
},{"hogan.js":248}],224:[function(require,module,exports){
var Hogan = require('hogan.js');
module.exports = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");if(!t.s(t.f("showMultipleColumns",c,p,1),c,p,1,0,0,"")){t.b("  <td width=\"10%\">");t.b("\n" + i);t.b("    <input type=\"radio\" name=\"orderSelect\"/>");t.b("\n" + i);t.b("  </td>");t.b("\n" + i);t.b("  <td width=\"20%\">");t.b("\n" + i);t.b("    <img src= \"");t.b(t.v(t.f("imageUrl",c,p,0)));t.b("\" />");t.b("\n" + i);t.b("  </td>");t.b("\n" + i);t.b("  <td width=\"30%\">");t.b("\n" + i);t.b("    <div class=\"b\">");t.b("\n" + i);t.b("      <span> ");t.b(t.v(t.f("merchant",c,p,0)));t.b(" </span>");t.b("\n" + i);t.b("    </div>");t.b("\n" + i);t.b("  </td>");t.b("\n" + i);t.b("  <td width=\"30%\">");t.b("\n" + i);t.b("    <span>");t.b(t.v(t.f("title",c,p,0)));t.b(" </span>");t.b("\n" + i);if(t.s(t.f("showReservatioinDates",c,p,1),c,p,0,325,412,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("      <br />");t.b("\n" + i);t.b("      (<span>");t.b(t.v(t.f("checkInDate",c,p,0)));t.b("</span> - <span>");t.b(t.v(t.f("checkOutDate",c,p,0)));t.b("</span>)");t.b("\n" + i);});c.pop();}t.b("  </td>");t.b("\n");t.b("\n" + i);t.b("  <td width=\"10%\">");t.b("\n" + i);if(!t.s(t.f("showReservatioinDates",c,p,1),c,p,1,0,0,"")){t.b("    <span> ");if(t.s(t.f("translate",c,p,1),c,p,0,523,545,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.qty");});c.pop();}t.b(t.v(t.f("qty",c,p,0)));t.b(" </span>");t.b("\n" + i);};t.b("  </td>");t.b("\n" + i);};t.b("\n");t.b("\n" + i);if(t.s(t.f("showMultipleColumns",c,p,1),c,p,0,665,1953,"{{ }}")){t.rs(c,p,function(c,p,t){if(t.s(t.f("hasData",c,p,1),c,p,0,680,1855,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("    <td class=\"order-data-cell\" width=\"50%\" key=\"");t.b(t.v(t.f("id",c,p,0)));t.b("\">");t.b("\n" + i);t.b("      <table class=\"cell-table\">");t.b("\n" + i);t.b("        <tr class=\"cell-row\">");t.b("\n" + i);t.b("          <td class=\"radio-btn cell-column\">");t.b("\n" + i);t.b("            <input key=\"");t.b(t.v(t.f("id",c,p,0)));t.b("\" type=\"radio\" name=\"orderSelect\"/>");t.b("\n" + i);t.b("          </td>");t.b("\n" + i);t.b("          <td class=\"image cell-column\">");t.b("\n" + i);t.b("            <img src=\"");t.b(t.v(t.f("imageUrl",c,p,0)));t.b("\" />");t.b("\n" + i);t.b("          </td>");t.b("\n" + i);t.b("          <td class=\"order-info cell-column\">");t.b("\n" + i);t.b("            <p class=\"b title\"> ");t.b(t.v(t.f("merchant",c,p,0)));t.b(" </p>");t.b("\n" + i);t.b("            <p class=\"description\">");t.b(t.v(t.f("title",c,p,0)));t.b(" </p>");t.b("\n" + i);t.b("            <p class=\"dates b\">");t.b("\n" + i);if(t.s(t.f("showReservatioinDates",c,p,1),c,p,0,1243,1337,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("                (<span>");t.b(t.v(t.f("checkInDate",c,p,0)));t.b("</span> - <span>");t.b(t.v(t.f("checkOutDate",c,p,0)));t.b("</span>)");t.b("\n" + i);});c.pop();}if(!t.s(t.f("showReservatioinDates",c,p,1),c,p,1,0,0,"")){t.b("                <span> ");t.b("\n" + i);t.b("                  ");if(t.s(t.f("translate",c,p,1),c,p,0,1461,1483,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.qty");});c.pop();}t.b(t.v(t.f("qty",c,p,0)));t.b(" ");t.b("\n" + i);t.b("                </span>");t.b("\n" + i);};t.b("            </p>  ");t.b("\n" + i);t.b("            <p>  ");t.b("\n" + i);t.b("              <span class=\"b purchase-text\">");if(t.s(t.f("translate",c,p,1),c,p,0,1666,1692,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.purdate");});c.pop();}t.b("</span>:<span class=\"purchase-date\">");t.b(t.v(t.f("purchasedAt",c,p,0)));t.b("\n" + i);t.b("              <span>");t.b("\n" + i);t.b("            </p>  ");t.b("\n" + i);t.b("          </td>");t.b("\n" + i);t.b("        </tr>");t.b("\n" + i);t.b("      </table>");t.b("\n" + i);t.b("    </td>");t.b("\n" + i);});c.pop();}if(!t.s(t.f("hasData",c,p,1),c,p,1,0,0,"")){t.b("    <td class=\"empty-data-cell\" width=\"50%\">");t.b("\n" + i);t.b("    </td>");t.b("\n" + i);};});c.pop();}return t.fl(); },partials: {}, subs: {  }}, "{{^showMultipleColumns}}\n  <td width=\"10%\">\n    <input type=\"radio\" name=\"orderSelect\"/>\n  </td>\n  <td width=\"20%\">\n    <img src= \"{{imageUrl}}\" />\n  </td>\n  <td width=\"30%\">\n    <div class=\"b\">\n      <span> {{merchant}} </span>\n    </div>\n  </td>\n  <td width=\"30%\">\n    <span>{{title}} </span>\n    {{#showReservatioinDates}}\n      <br />\n      (<span>{{checkInDate}}</span> - <span>{{checkOutDate}}</span>)\n    {{/showReservatioinDates}}\n  </td>\n\n  <td width=\"10%\">\n    {{^showReservatioinDates}}\n    <span> {{#translate}}js.modules.support.qty{{/translate}}{{qty}} </span>\n    {{/showReservatioinDates}}\n  </td>\n{{/showMultipleColumns}}\n\n\n{{#showMultipleColumns}}\n  {{#hasData}}\n    <td class=\"order-data-cell\" width=\"50%\" key=\"{{id}}\">\n      <table class=\"cell-table\">\n        <tr class=\"cell-row\">\n          <td class=\"radio-btn cell-column\">\n            <input key=\"{{id}}\" type=\"radio\" name=\"orderSelect\"/>\n          </td>\n          <td class=\"image cell-column\">\n            <img src=\"{{imageUrl}}\" />\n          </td>\n          <td class=\"order-info cell-column\">\n            <p class=\"b title\"> {{merchant}} </p>\n            <p class=\"description\">{{title}} </p>\n            <p class=\"dates b\">\n              {{#showReservatioinDates}}\n                (<span>{{checkInDate}}</span> - <span>{{checkOutDate}}</span>)\n              {{/showReservatioinDates}}\n              {{^showReservatioinDates}}\n                <span> \n                  {{#translate}}js.modules.support.qty{{/translate}}{{qty}} \n                </span>\n              {{/showReservatioinDates}}\n            </p>  \n            <p>  \n              <span class=\"b purchase-text\">{{#translate}}js.modules.support.purdate{{/translate}}</span>:<span class=\"purchase-date\">{{purchasedAt}}\n              <span>\n            </p>  \n          </td>\n        </tr>\n      </table>\n    </td>\n  {{/hasData}}\n  {{^hasData}}\n    <td class=\"empty-data-cell\" width=\"50%\">\n    </td>\n  {{/hasData}}\n{{/showMultipleColumns}}", Hogan);
},{"hogan.js":248}],225:[function(require,module,exports){
var Hogan = require('hogan.js');
module.exports = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");if(!t.s(t.f("isV2",c,p,1),c,p,1,0,0,"")){t.b("  <div id=\"sorting\" class=\"\">");t.b("\n" + i);t.b("    <span class=\"b\">");if(t.s(t.f("translate",c,p,1),c,p,0,74,100,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.sort_by");});c.pop();}t.b("</span>");t.b("\n" + i);if(t.s(t.f("enableMerchantNameSortOrders",c,p,1),c,p,0,159,502,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("      <a class='anchorHover disabledLink' id=\"purchasedDateSortOrders\" data-bhw=\"orders-filter-purchase-date\">");if(t.s(t.f("translate",c,p,1),c,p,0,284,310,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.purdate");});c.pop();}t.b("</a>");t.b("\n" + i);t.b("      &nbsp;|");t.b("\n" + i);t.b("      <a class='anchorHover' id=\"merchantNameSortOrders\" data-bhw=\"orders-filter-merchant-name\">");if(t.s(t.f("translate",c,p,1),c,p,0,453,479,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.busname");});c.pop();}t.b("</a>");t.b("\n" + i);});c.pop();}t.b("\n" + i);if(!t.s(t.f("enableMerchantNameSortOrders",c,p,1),c,p,1,0,0,"")){t.b("      <a class='anchorHover' id=\"purchasedDateSortOrders\">");if(t.s(t.f("translate",c,p,1),c,p,0,647,673,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.purdate");});c.pop();}t.b("</a>");t.b("\n" + i);t.b("      &nbsp;|");t.b("\n" + i);t.b("      <a class='anchorHover disabledLink' id=\"merchantNameSortOrders\">");if(t.s(t.f("translate",c,p,1),c,p,0,790,816,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.busname");});c.pop();}t.b("</a>");t.b("\n" + i);};t.b("\n" + i);t.b("  </div>");t.b("\n" + i);t.b("  <div id=\"ordersTablewrapper\">");t.b("\n" + i);t.b("    <table width=\"100%\" class=\"scrollableTable\">");t.b("\n" + i);t.b("      <tbody id=\"ordersTable\">");t.b("\n" + i);t.b("      </tbody>  ");t.b("\n" + i);t.b("    </table>");t.b("\n" + i);t.b("  </div>");t.b("\n" + i);t.b("  <div class=\"modal-footer\">");t.b("\n" + i);t.b("    <div class=\"ui-dialog-buttonpane ui-widget-content u-helper-clearfix ui-popup-footer\">");t.b("\n" + i);t.b("      <table width=\"100%\">");t.b("\n" + i);t.b("        <tbody>");t.b("\n" + i);t.b("          <tr>");t.b("\n" + i);t.b("            <td width=\"50%\">");t.b("\n" + i);t.b("              <a class='anchorHover orderNotListed' id=\"orderNotListed\" data-bhw=\"order-not-listed\">");if(t.s(t.f("translate",c,p,1),c,p,0,1355,1384,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.ordnotlist");});c.pop();}t.b("</a>");t.b("\n" + i);t.b("            </td>");t.b("\n" + i);t.b("            <td width=\"50%\" class=\"w100 pgrhldr\" id=\"paginationOrders\">");t.b("\n" + i);t.b("            </td>");t.b("\n" + i);t.b("          </tr>");t.b("\n" + i);t.b("        </tbody>");t.b("\n" + i);t.b("      </table>");t.b("\n" + i);t.b("    </div>");t.b("\n" + i);t.b("  </div >");t.b("\n");t.b("\n" + i);t.b("<table class=\"template-table hide\" style=\"display:none\">");t.b("\n" + i);t.b("  <tr class='ordersRowErrorSample'>");t.b("\n" + i);t.b("        <td width='10%'></td>");t.b("\n" + i);t.b("        <td width='20%'></td>");t.b("\n" + i);t.b("        <td width='30%'>");t.b("\n" + i);t.b("          <span>  ");t.b("\n" + i);t.b("            ");if(t.s(t.f("translate",c,p,1),c,p,0,1804,1827,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.oops");});c.pop();}t.b(" ");if(t.s(t.f("translate",c,p,1),c,p,0,1856,1888,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.error_happend");});c.pop();}t.b("\n" + i);t.b("            <a href='javascript:;'> ");if(t.s(t.f("translate",c,p,1),c,p,0,1953,2001,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.intermediate_page_text4_click");});c.pop();}t.b("</a>");t.b("\n" + i);t.b("            ");if(t.s(t.f("translate",c,p,1),c,p,0,2046,2076,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.reload_text");});c.pop();}t.b("\n" + i);t.b("          </span>");t.b("\n" + i);t.b("        </td>");t.b("\n" + i);t.b("        <td width='30%'></td>");t.b("\n" + i);t.b("        <td width='10%'></td> ");t.b("\n" + i);t.b("  </tr>");t.b("\n" + i);t.b("  <tr class='ordersRowSpinnerSample'>");t.b("\n" + i);t.b("    <td colspan='5' class='content'>");t.b("\n" + i);t.b("    </td>");t.b("\n" + i);t.b("  </tr>");t.b("\n" + i);t.b("</table>");t.b("\n" + i);};t.b("\n");t.b("\n" + i);if(t.s(t.f("isV2",c,p,1),c,p,0,2315,3034,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("  <div id=\"ordersTablewrapper\">");t.b("\n" + i);t.b("    <table width=\"100%\" class=\"scrollableTable\">");t.b("\n" + i);t.b("      <tbody id=\"ordersTable\">");t.b("\n" + i);t.b("      </tbody>  ");t.b("\n" + i);t.b("    </table>");t.b("\n" + i);t.b("  </div>");t.b("\n");t.b("\n" + i);t.b("<table class=\"template-table hide\"  style=\"display:none\">");t.b("\n" + i);t.b("  <tr class='ordersRowErrorSample'>");t.b("\n" + i);t.b("    <td colspan='2'>");t.b("\n" + i);t.b("      <span>  ");t.b("\n" + i);t.b("        ");if(t.s(t.f("translate",c,p,1),c,p,0,2620,2643,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.oops");});c.pop();}t.b(" ");if(t.s(t.f("translate",c,p,1),c,p,0,2672,2704,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.error_happend");});c.pop();}t.b("\n" + i);t.b("        <a href='javascript:;'> ");if(t.s(t.f("translate",c,p,1),c,p,0,2765,2813,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.intermediate_page_text4_click");});c.pop();}t.b("</a>");t.b("\n" + i);t.b("        ");if(t.s(t.f("translate",c,p,1),c,p,0,2854,2884,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.reload_text");});c.pop();}t.b("\n" + i);t.b("      </span>");t.b("\n" + i);t.b("    </td>");t.b("\n" + i);t.b("  </tr>");t.b("\n" + i);t.b("  <tr class='ordersRowSpinnerSample'>");t.b("\n" + i);t.b("    <td colspan='2' class='content'>");t.b("\n" + i);t.b("    </td>");t.b("\n" + i);t.b("  </tr>");t.b("\n" + i);t.b("</table>");t.b("\n");t.b("\n" + i);});c.pop();}return t.fl(); },partials: {}, subs: {  }}, "{{^isV2}}\n  <div id=\"sorting\" class=\"\">\n    <span class=\"b\">{{#translate}}js.modules.support.sort_by{{/translate}}</span>\n    {{#enableMerchantNameSortOrders}}\n      <a class='anchorHover disabledLink' id=\"purchasedDateSortOrders\" data-bhw=\"orders-filter-purchase-date\">{{#translate}}js.modules.support.purdate{{/translate}}</a>\n      &nbsp;|\n      <a class='anchorHover' id=\"merchantNameSortOrders\" data-bhw=\"orders-filter-merchant-name\">{{#translate}}js.modules.support.busname{{/translate}}</a>\n    {{/enableMerchantNameSortOrders}}\n\n    {{^enableMerchantNameSortOrders}}\n      <a class='anchorHover' id=\"purchasedDateSortOrders\">{{#translate}}js.modules.support.purdate{{/translate}}</a>\n      &nbsp;|\n      <a class='anchorHover disabledLink' id=\"merchantNameSortOrders\">{{#translate}}js.modules.support.busname{{/translate}}</a>\n    {{/enableMerchantNameSortOrders}}\n\n  </div>\n  <div id=\"ordersTablewrapper\">\n    <table width=\"100%\" class=\"scrollableTable\">\n      <tbody id=\"ordersTable\">\n      </tbody>  \n    </table>\n  </div>\n  <div class=\"modal-footer\">\n    <div class=\"ui-dialog-buttonpane ui-widget-content u-helper-clearfix ui-popup-footer\">\n      <table width=\"100%\">\n        <tbody>\n          <tr>\n            <td width=\"50%\">\n              <a class='anchorHover orderNotListed' id=\"orderNotListed\" data-bhw=\"order-not-listed\">{{#translate}}js.modules.support.ordnotlist{{/translate}}</a>\n            </td>\n            <td width=\"50%\" class=\"w100 pgrhldr\" id=\"paginationOrders\">\n            </td>\n          </tr>\n        </tbody>\n      </table>\n    </div>\n  </div >\n\n<table class=\"template-table hide\" style=\"display:none\">\n  <tr class='ordersRowErrorSample'>\n        <td width='10%'></td>\n        <td width='20%'></td>\n        <td width='30%'>\n          <span>  \n            {{#translate}}js.modules.support.oops{{/translate}} {{#translate}}js.modules.support.error_happend{{/translate}}\n            <a href='javascript:;'> {{#translate}}js.modules.support.intermediate_page_text4_click{{/translate}}</a>\n            {{#translate}}js.modules.support.reload_text{{/translate}}\n          </span>\n        </td>\n        <td width='30%'></td>\n        <td width='10%'></td> \n  </tr>\n  <tr class='ordersRowSpinnerSample'>\n    <td colspan='5' class='content'>\n    </td>\n  </tr>\n</table>\n{{/isV2}}\n\n\n{{#isV2}}\n  <div id=\"ordersTablewrapper\">\n    <table width=\"100%\" class=\"scrollableTable\">\n      <tbody id=\"ordersTable\">\n      </tbody>  \n    </table>\n  </div>\n\n<table class=\"template-table hide\"  style=\"display:none\">\n  <tr class='ordersRowErrorSample'>\n    <td colspan='2'>\n      <span>  \n        {{#translate}}js.modules.support.oops{{/translate}} {{#translate}}js.modules.support.error_happend{{/translate}}\n        <a href='javascript:;'> {{#translate}}js.modules.support.intermediate_page_text4_click{{/translate}}</a>\n        {{#translate}}js.modules.support.reload_text{{/translate}}\n      </span>\n    </td>\n  </tr>\n  <tr class='ordersRowSpinnerSample'>\n    <td colspan='2' class='content'>\n    </td>\n  </tr>\n</table>\n\n{{/isV2}}\n", Hogan);
},{"hogan.js":248}],226:[function(require,module,exports){
var Hogan = require('hogan.js');
module.exports = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");if(!t.s(t.f("isV2",c,p,1),c,p,1,0,0,"")){t.b("  <ul data-bhw=\"order__");t.b(t.v(t.f("id",c,p,0)));t.b("__");t.b(t.v(t.f("dealId",c,p,0)));t.b("__");t.b(t.v(t.f("channel",c,p,0)));t.b("__");t.b(t.v(t.f("country",c,p,0)));t.b("__");t.b(t.v(t.f("status",c,p,0)));t.b("\" class=\"order-summary-list unstyled\">");t.b("\n" + i);t.b("    <li>");t.b("\n" + i);t.b("      <span class=\"orderSummaryStrong\"><strong>");if(t.s(t.f("translate",c,p,1),c,p,0,198,223,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.status");});c.pop();}t.b("</strong></span>");t.b("\n" + i);t.b("      <span class='order-status'>");t.b(t.t(t.f("status",c,p,0)));t.b("</span>");t.b("\n" + i);t.b("    </li>");t.b("\n" + i);if(t.s(t.f("deliveryRange",c,p,1),c,p,0,339,628,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("      <li>");t.b("\n" + i);t.b("        <div class='estimate-delivery'>");t.b("\n" + i);t.b("          <span class=\"estimate-delivery-strong\"><strong>");if(t.s(t.f("translate",c,p,1),c,p,0,462,499,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.estimated_delivery");});c.pop();}t.b(":</strong></span>");t.b("\n" + i);t.b("          <span class='delivery-range'>");t.b(t.t(t.f("deliveryRange",c,p,0)));t.b("</span>");t.b("\n" + i);t.b("        </div>");t.b("\n" + i);t.b("      </li>");t.b("\n" + i);});c.pop();}t.b("    <li>");t.b("\n" + i);t.b("      <span  class=\"orderSummaryStrong\"><strong>");if(t.s(t.f("translate",c,p,1),c,p,0,718,740,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.pur");});c.pop();}t.b("</strong></span>");t.b("\n" + i);t.b("      <span class='localtime'>");t.b(t.v(t.f("purchasedAt",c,p,0)));t.b("</span>");t.b("\n" + i);t.b("    </li>");t.b("\n" + i);if(t.s(t.f("checkInDate",c,p,1),c,p,0,854,1042,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("      <li>");t.b("\n" + i);t.b("      <span class=\"orderSummaryStrong\"><strong>");if(t.s(t.f("translate",c,p,1),c,p,0,927,959,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.check_in_date");});c.pop();}t.b(" </strong></span>");t.b("\n" + i);t.b("      <span>");t.b(t.v(t.f("checkInDate",c,p,0)));t.b("</span>");t.b("\n" + i);t.b("      </li>");t.b("\n" + i);});c.pop();}if(t.s(t.f("checkOutDate",c,p,1),c,p,0,1080,1270,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("      <li>");t.b("\n" + i);t.b("      <span class=\"orderSummaryStrong\"><strong>");if(t.s(t.f("translate",c,p,1),c,p,0,1153,1186,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.check_out_date");});c.pop();}t.b(" </strong></span>");t.b("\n" + i);t.b("      <span>");t.b(t.v(t.f("checkOutDate",c,p,0)));t.b("</span>");t.b("\n" + i);t.b("      </li>");t.b("\n" + i);});c.pop();}t.b("    <li>");t.b("\n" + i);t.b("      <span class=\"orderSummaryStrong\" ><strong >");if(t.s(t.f("translate",c,p,1),c,p,0,1360,1382,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.qty");});c.pop();}t.b(" </strong></span>");t.b("\n" + i);t.b("      ");t.b(t.v(t.f("qty",c,p,0)));t.b("\n" + i);t.b("    </li>");t.b("\n" + i);if(t.s(t.f("shouldShowDeliveryMsg",c,p,1),c,p,0,1468,1857,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("      <li class=\"order-not-due-container\">");t.b("\n" + i);t.b("        <div class=\"order-not-due\" data-bhw='max_delivery_date__");t.b(t.v(t.f("id",c,p,0)));t.b("__");t.b(t.v(t.f("dealId",c,p,0)));t.b("__{channel}}__");t.b(t.v(t.f("country",c,p,0)));t.b("__");t.b(t.v(t.f("maxDeliveryDays",c,p,0)));t.b("'>");t.b("\n" + i);t.b("          <span class=\"icon-truck tacking-truck-icon\"> </span>");t.b("\n" + i);t.b("          <span>");t.b("\n" + i);t.b("            ");if(t.s(t.f("translate",c,p,1),c,p,0,1749,1794,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.order_not_due_for_delivery");});c.pop();}t.b("\n" + i);t.b("          </span>");t.b("\n" + i);t.b("        <div>");t.b("\n" + i);t.b("      </li>");t.b("\n" + i);});c.pop();}t.b("\n" + i);if(t.s(t.f("giftInfo",c,p,1),c,p,0,1902,3370,"{{ }}")){t.rs(c,p,function(c,p,t){if(t.s(t.f("isSentGift",c,p,1),c,p,0,1924,3120,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("        <li class=\"gift-info\">");t.b("\n" + i);t.b("            <span class=\"icon-gift green\"></span>");t.b("\n" + i);if(t.s(t.f("isEGift",c,p,1),c,p,0,2030,2903,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("              <span>");t.b("\n" + i);t.b("              ");if(t.s(t.f("t",c,p,1),c,p,0,2072,2101,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.email_gift");});c.pop();}t.b(" ");t.b(t.v(t.f("giftRecipientName",c,p,0)));t.b("\n" + i);t.b("              </span>");t.b("\n" + i);t.b("              <br/>");t.b("\n" + i);t.b("              <span>");t.b("\n" + i);t.b("              ");if(t.s(t.f("t",c,p,1),c,p,0,2213,2246,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.sent_via_email");});c.pop();}t.b(" ");t.b(t.v(t.f("giftRecipientEmail",c,p,0)));t.b("\n" + i);t.b("              </span>");t.b("\n" + i);t.b("              <br/>");t.b("\n" + i);if(t.s(t.f("isGiftClaimed",c,p,1),c,p,0,2350,2645,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("               <span>");t.b("\n" + i);t.b("                ");if(t.s(t.f("t",c,p,1),c,p,0,2395,2433,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.gift_claimed_status");});c.pop();}t.b(": ");if(t.s(t.f("t",c,p,1),c,p,0,2447,2473,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.claimed");});c.pop();}t.b("\n" + i);if(t.s(t.f("printedAt",c,p,1),c,p,0,2510,2593,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("                  ");if(t.s(t.f("t",c,p,1),c,p,0,2535,2556,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.on");});c.pop();}t.b(" ");t.b(t.v(t.f("printedAt",c,p,0)));t.b("\n" + i);});c.pop();}t.b("               </span>");t.b("\n" + i);});c.pop();}if(!t.s(t.f("isGiftClaimed",c,p,1),c,p,1,0,0,"")){t.b("                <span>");t.b("\n" + i);t.b("                ");if(t.s(t.f("t",c,p,1),c,p,0,2742,2780,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.gift_claimed_status");});c.pop();}t.b(": ");if(t.s(t.f("t",c,p,1),c,p,0,2794,2828,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.not_yet_claimed");});c.pop();}t.b("\n" + i);t.b("               </span>");t.b("\n" + i);};});c.pop();}if(t.s(t.f("isPrintedGift",c,p,1),c,p,0,2946,3081,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("              <span>");t.b("\n" + i);t.b("              ");if(t.s(t.f("t",c,p,1),c,p,0,2988,3019,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.printed_gift");});c.pop();}t.b(" ");t.b(t.v(t.f("giftRecipientName",c,p,0)));t.b("\n" + i);t.b("             </span>");t.b("\n" + i);});c.pop();}t.b("        </li>");t.b("\n" + i);});c.pop();}if(t.s(t.f("isReceivedGift",c,p,1),c,p,0,3161,3346,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("        <li>");t.b("\n" + i);t.b("            <span class=\"icon-gift green\"></span>");t.b("\n" + i);t.b("            <span> ");if(t.s(t.f("translate",c,p,1),c,p,0,3258,3286,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.gift_from");});c.pop();}t.b(" ");t.b(t.v(t.f("giftFromName",c,p,0)));t.b(" </span>");t.b("\n" + i);t.b("        </li>");t.b("\n" + i);});c.pop();}});c.pop();}t.b("\n");t.b("\n" + i);if(t.s(t.f("notes",c,p,1),c,p,0,3402,3626,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("    <li>");t.b("\n" + i);t.b("      <span class=\"notesClass\">");t.b("\n" + i);t.b("      <span class=\"orderSummaryStrong\"><strong class=\"note-heading\">");if(t.s(t.f("translate",c,p,1),c,p,0,3526,3549,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.note");});c.pop();}t.b("</strong></span>");t.b("\n" + i);t.b("      ");t.b(t.t(t.f("notes",c,p,0)));t.b("\n" + i);t.b("      </span>");t.b("\n" + i);t.b("    </li>");t.b("\n" + i);});c.pop();}t.b("  </ul>");t.b("\n" + i);};t.b("\n" + i);if(t.s(t.f("isV2",c,p,1),c,p,0,3665,7009,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("\n" + i);t.b("  <ul data-bhw=\"order__");t.b(t.v(t.f("id",c,p,0)));t.b("__");t.b(t.v(t.f("dealId",c,p,0)));t.b("__");t.b(t.v(t.f("channel",c,p,0)));t.b("__");t.b(t.v(t.f("country",c,p,0)));t.b("__");t.b(t.v(t.f("status",c,p,0)));t.b("\" class=\"order-summary-list unstyled\">");t.b("\n" + i);t.b("    <li>");t.b("\n" + i);t.b("      <span class=\"orderSummaryStrong\"><strong>");if(t.s(t.f("translate",c,p,1),c,p,0,3855,3880,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.status");});c.pop();}t.b("</strong></span>");t.b("\n" + i);t.b("      <span class='order-status'>");t.b(t.t(t.f("status",c,p,0)));t.b("</span>");t.b("\n" + i);t.b("    </li>");t.b("\n" + i);if(t.s(t.f("deliveryRange",c,p,1),c,p,0,3996,4285,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("      <li>");t.b("\n" + i);t.b("        <div class='estimate-delivery'>");t.b("\n" + i);t.b("          <span class=\"estimate-delivery-strong\"><strong>");if(t.s(t.f("translate",c,p,1),c,p,0,4119,4156,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.estimated_delivery");});c.pop();}t.b(":</strong></span>");t.b("\n" + i);t.b("          <span class='delivery-range'>");t.b(t.t(t.f("deliveryRange",c,p,0)));t.b("</span>");t.b("\n" + i);t.b("        </div>");t.b("\n" + i);t.b("      </li>");t.b("\n" + i);});c.pop();}if(t.s(t.f("checkInDate",c,p,1),c,p,0,4324,4512,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("      <li>");t.b("\n" + i);t.b("      <span class=\"orderSummaryStrong\"><strong>");if(t.s(t.f("translate",c,p,1),c,p,0,4397,4429,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.check_in_date");});c.pop();}t.b(" </strong></span>");t.b("\n" + i);t.b("      <span>");t.b(t.v(t.f("checkInDate",c,p,0)));t.b("</span>");t.b("\n" + i);t.b("      </li>");t.b("\n" + i);});c.pop();}if(t.s(t.f("checkOutDate",c,p,1),c,p,0,4550,4740,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("      <li>");t.b("\n" + i);t.b("      <span class=\"orderSummaryStrong\"><strong>");if(t.s(t.f("translate",c,p,1),c,p,0,4623,4656,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.check_out_date");});c.pop();}t.b(" </strong></span>");t.b("\n" + i);t.b("      <span>");t.b(t.v(t.f("checkOutDate",c,p,0)));t.b("</span>");t.b("\n" + i);t.b("      </li>");t.b("\n" + i);});c.pop();}t.b("    ");t.b("\n" + i);if(t.s(t.f("shouldShowDeliveryMsg",c,p,1),c,p,0,4793,5220,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("      <li class=\"order-not-due-container\">");t.b("\n" + i);t.b("        <div class=\"order-not-due row\" data-bhw='max_delivery_date__");t.b(t.v(t.f("id",c,p,0)));t.b("__");t.b(t.v(t.f("dealId",c,p,0)));t.b("__{channel}}__");t.b(t.v(t.f("country",c,p,0)));t.b("__");t.b(t.v(t.f("maxDeliveryDays",c,p,0)));t.b("'>");t.b("\n" + i);t.b("          <span class=\"icon-truck tacking-truck-icon one column\"> </span>");t.b("\n" + i);t.b("          <span class=\"eleven columns\">");t.b("\n" + i);t.b("            ");if(t.s(t.f("translate",c,p,1),c,p,0,5112,5157,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.order_not_due_for_delivery");});c.pop();}t.b("\n" + i);t.b("          </span>");t.b("\n" + i);t.b("        <div>");t.b("\n" + i);t.b("      </li>");t.b("\n" + i);});c.pop();}t.b("\n" + i);if(t.s(t.f("giftInfo",c,p,1),c,p,0,5265,6733,"{{ }}")){t.rs(c,p,function(c,p,t){if(t.s(t.f("isSentGift",c,p,1),c,p,0,5287,6483,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("        <li class=\"gift-info\">");t.b("\n" + i);t.b("            <span class=\"icon-gift green\"></span>");t.b("\n" + i);if(t.s(t.f("isEGift",c,p,1),c,p,0,5393,6266,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("              <span>");t.b("\n" + i);t.b("              ");if(t.s(t.f("t",c,p,1),c,p,0,5435,5464,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.email_gift");});c.pop();}t.b(" ");t.b(t.v(t.f("giftRecipientName",c,p,0)));t.b("\n" + i);t.b("              </span>");t.b("\n" + i);t.b("              <br/>");t.b("\n" + i);t.b("              <span>");t.b("\n" + i);t.b("              ");if(t.s(t.f("t",c,p,1),c,p,0,5576,5609,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.sent_via_email");});c.pop();}t.b(" ");t.b(t.v(t.f("giftRecipientEmail",c,p,0)));t.b("\n" + i);t.b("              </span>");t.b("\n" + i);t.b("              <br/>");t.b("\n" + i);if(t.s(t.f("isGiftClaimed",c,p,1),c,p,0,5713,6008,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("               <span>");t.b("\n" + i);t.b("                ");if(t.s(t.f("t",c,p,1),c,p,0,5758,5796,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.gift_claimed_status");});c.pop();}t.b(": ");if(t.s(t.f("t",c,p,1),c,p,0,5810,5836,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.claimed");});c.pop();}t.b("\n" + i);if(t.s(t.f("printedAt",c,p,1),c,p,0,5873,5956,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("                  ");if(t.s(t.f("t",c,p,1),c,p,0,5898,5919,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.on");});c.pop();}t.b(" ");t.b(t.v(t.f("printedAt",c,p,0)));t.b("\n" + i);});c.pop();}t.b("               </span>");t.b("\n" + i);});c.pop();}if(!t.s(t.f("isGiftClaimed",c,p,1),c,p,1,0,0,"")){t.b("                <span>");t.b("\n" + i);t.b("                ");if(t.s(t.f("t",c,p,1),c,p,0,6105,6143,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.gift_claimed_status");});c.pop();}t.b(": ");if(t.s(t.f("t",c,p,1),c,p,0,6157,6191,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.not_yet_claimed");});c.pop();}t.b("\n" + i);t.b("               </span>");t.b("\n" + i);};});c.pop();}if(t.s(t.f("isPrintedGift",c,p,1),c,p,0,6309,6444,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("              <span>");t.b("\n" + i);t.b("              ");if(t.s(t.f("t",c,p,1),c,p,0,6351,6382,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.printed_gift");});c.pop();}t.b(" ");t.b(t.v(t.f("giftRecipientName",c,p,0)));t.b("\n" + i);t.b("             </span>");t.b("\n" + i);});c.pop();}t.b("        </li>");t.b("\n" + i);});c.pop();}if(t.s(t.f("isReceivedGift",c,p,1),c,p,0,6524,6709,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("        <li>");t.b("\n" + i);t.b("            <span class=\"icon-gift green\"></span>");t.b("\n" + i);t.b("            <span> ");if(t.s(t.f("translate",c,p,1),c,p,0,6621,6649,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.gift_from");});c.pop();}t.b(" ");t.b(t.v(t.f("giftFromName",c,p,0)));t.b(" </span>");t.b("\n" + i);t.b("        </li>");t.b("\n" + i);});c.pop();}});c.pop();}t.b("\n");t.b("\n" + i);if(t.s(t.f("notes",c,p,1),c,p,0,6765,6989,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("    <li>");t.b("\n" + i);t.b("      <span class=\"notesClass\">");t.b("\n" + i);t.b("      <span class=\"orderSummaryStrong\"><strong class=\"note-heading\">");if(t.s(t.f("translate",c,p,1),c,p,0,6889,6912,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.note");});c.pop();}t.b("</strong></span>");t.b("\n" + i);t.b("      ");t.b(t.t(t.f("notes",c,p,0)));t.b("\n" + i);t.b("      </span>");t.b("\n" + i);t.b("    </li>");t.b("\n" + i);});c.pop();}t.b("  </ul>");t.b("\n");t.b("\n" + i);});c.pop();}return t.fl(); },partials: {}, subs: {  }}, "{{^isV2}}\n  <ul data-bhw=\"order__{{id}}__{{dealId}}__{{channel}}__{{country}}__{{status}}\" class=\"order-summary-list unstyled\">\n    <li>\n      <span class=\"orderSummaryStrong\"><strong>{{#translate}}js.modules.support.status{{/translate}}</strong></span>\n      <span class='order-status'>{{{status}}}</span>\n    </li>\n    {{#deliveryRange}}\n      <li>\n        <div class='estimate-delivery'>\n          <span class=\"estimate-delivery-strong\"><strong>{{#translate}}js.modules.support.estimated_delivery{{/translate}}:</strong></span>\n          <span class='delivery-range'>{{{deliveryRange}}}</span>\n        </div>\n      </li>\n    {{/deliveryRange}}\n    <li>\n      <span  class=\"orderSummaryStrong\"><strong>{{#translate}}js.modules.support.pur{{/translate}}</strong></span>\n      <span class='localtime'>{{purchasedAt}}</span>\n    </li>\n    {{#checkInDate}}\n      <li>\n      <span class=\"orderSummaryStrong\"><strong>{{#translate}}js.modules.support.check_in_date{{/translate}} </strong></span>\n      <span>{{checkInDate}}</span>\n      </li>\n    {{/checkInDate}}\n    {{#checkOutDate}}\n      <li>\n      <span class=\"orderSummaryStrong\"><strong>{{#translate}}js.modules.support.check_out_date{{/translate}} </strong></span>\n      <span>{{checkOutDate}}</span>\n      </li>\n    {{/checkOutDate}}\n    <li>\n      <span class=\"orderSummaryStrong\" ><strong >{{#translate}}js.modules.support.qty{{/translate}} </strong></span>\n      {{qty}}\n    </li>\n    {{#shouldShowDeliveryMsg}}\n      <li class=\"order-not-due-container\">\n        <div class=\"order-not-due\" data-bhw='max_delivery_date__{{id}}__{{dealId}}__{channel}}__{{country}}__{{maxDeliveryDays}}'>\n          <span class=\"icon-truck tacking-truck-icon\"> </span>\n          <span>\n            {{#translate}}js.modules.support.order_not_due_for_delivery{{/translate}}\n          </span>\n        <div>\n      </li>\n    {{/shouldShowDeliveryMsg}}\n\n    {{#giftInfo}}\n      {{#isSentGift}}\n        <li class=\"gift-info\">\n            <span class=\"icon-gift green\"></span>\n            {{#isEGift}}\n              <span>\n              {{#t}}js.modules.support.email_gift{{/t}} {{giftRecipientName}}\n              </span>\n              <br/>\n              <span>\n              {{#t}}js.modules.support.sent_via_email{{/t}} {{giftRecipientEmail}}\n              </span>\n              <br/>\n              {{#isGiftClaimed}}\n               <span>\n                {{#t}}js.modules.support.gift_claimed_status{{/t}}: {{#t}}js.modules.support.claimed{{/t}}\n                {{#printedAt}}\n                  {{#t}}js.modules.support.on{{/t}} {{printedAt}}\n                {{/printedAt}}\n               </span>\n              {{/isGiftClaimed}}\n              {{^isGiftClaimed}}\n                <span>\n                {{#t}}js.modules.support.gift_claimed_status{{/t}}: {{#t}}js.modules.support.not_yet_claimed{{/t}}\n               </span>\n              {{/isGiftClaimed}}\n            {{/isEGift}}\n            {{#isPrintedGift}}\n              <span>\n              {{#t}}js.modules.support.printed_gift{{/t}} {{giftRecipientName}}\n             </span>\n            {{/isPrintedGift}}\n        </li>\n      {{/isSentGift}}\n      {{#isReceivedGift}}\n        <li>\n            <span class=\"icon-gift green\"></span>\n            <span> {{#translate}}js.modules.support.gift_from{{/translate}} {{giftFromName}} </span>\n        </li>\n      {{/isReceivedGift}}\n    {{/giftInfo}}  \n\n\n    {{#notes}}\n    <li>\n      <span class=\"notesClass\">\n      <span class=\"orderSummaryStrong\"><strong class=\"note-heading\">{{#translate}}js.modules.support.note{{/translate}}</strong></span>\n      {{{notes}}}\n      </span>\n    </li>\n    {{/notes}}\n  </ul>\n{{/isV2}}\n\n{{#isV2}}\n\n  <ul data-bhw=\"order__{{id}}__{{dealId}}__{{channel}}__{{country}}__{{status}}\" class=\"order-summary-list unstyled\">\n    <li>\n      <span class=\"orderSummaryStrong\"><strong>{{#translate}}js.modules.support.status{{/translate}}</strong></span>\n      <span class='order-status'>{{{status}}}</span>\n    </li>\n    {{#deliveryRange}}\n      <li>\n        <div class='estimate-delivery'>\n          <span class=\"estimate-delivery-strong\"><strong>{{#translate}}js.modules.support.estimated_delivery{{/translate}}:</strong></span>\n          <span class='delivery-range'>{{{deliveryRange}}}</span>\n        </div>\n      </li>\n    {{/deliveryRange}}\n    {{#checkInDate}}\n      <li>\n      <span class=\"orderSummaryStrong\"><strong>{{#translate}}js.modules.support.check_in_date{{/translate}} </strong></span>\n      <span>{{checkInDate}}</span>\n      </li>\n    {{/checkInDate}}\n    {{#checkOutDate}}\n      <li>\n      <span class=\"orderSummaryStrong\"><strong>{{#translate}}js.modules.support.check_out_date{{/translate}} </strong></span>\n      <span>{{checkOutDate}}</span>\n      </li>\n    {{/checkOutDate}}\n    \n    {{#shouldShowDeliveryMsg}}\n      <li class=\"order-not-due-container\">\n        <div class=\"order-not-due row\" data-bhw='max_delivery_date__{{id}}__{{dealId}}__{channel}}__{{country}}__{{maxDeliveryDays}}'>\n          <span class=\"icon-truck tacking-truck-icon one column\"> </span>\n          <span class=\"eleven columns\">\n            {{#translate}}js.modules.support.order_not_due_for_delivery{{/translate}}\n          </span>\n        <div>\n      </li>\n    {{/shouldShowDeliveryMsg}}\n\n    {{#giftInfo}}\n      {{#isSentGift}}\n        <li class=\"gift-info\">\n            <span class=\"icon-gift green\"></span>\n            {{#isEGift}}\n              <span>\n              {{#t}}js.modules.support.email_gift{{/t}} {{giftRecipientName}}\n              </span>\n              <br/>\n              <span>\n              {{#t}}js.modules.support.sent_via_email{{/t}} {{giftRecipientEmail}}\n              </span>\n              <br/>\n              {{#isGiftClaimed}}\n               <span>\n                {{#t}}js.modules.support.gift_claimed_status{{/t}}: {{#t}}js.modules.support.claimed{{/t}}\n                {{#printedAt}}\n                  {{#t}}js.modules.support.on{{/t}} {{printedAt}}\n                {{/printedAt}}\n               </span>\n              {{/isGiftClaimed}}\n              {{^isGiftClaimed}}\n                <span>\n                {{#t}}js.modules.support.gift_claimed_status{{/t}}: {{#t}}js.modules.support.not_yet_claimed{{/t}}\n               </span>\n              {{/isGiftClaimed}}\n            {{/isEGift}}\n            {{#isPrintedGift}}\n              <span>\n              {{#t}}js.modules.support.printed_gift{{/t}} {{giftRecipientName}}\n             </span>\n            {{/isPrintedGift}}\n        </li>\n      {{/isSentGift}}\n      {{#isReceivedGift}}\n        <li>\n            <span class=\"icon-gift green\"></span>\n            <span> {{#translate}}js.modules.support.gift_from{{/translate}} {{giftFromName}} </span>\n        </li>\n      {{/isReceivedGift}}\n    {{/giftInfo}}  \n\n\n    {{#notes}}\n    <li>\n      <span class=\"notesClass\">\n      <span class=\"orderSummaryStrong\"><strong class=\"note-heading\">{{#translate}}js.modules.support.note{{/translate}}</strong></span>\n      {{{notes}}}\n      </span>\n    </li>\n    {{/notes}}\n  </ul>\n\n{{/isV2}}\n", Hogan);
},{"hogan.js":248}],227:[function(require,module,exports){
var Hogan = require('hogan.js');
module.exports = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<div  class=\"modal show-modal\">");t.b("\n" + i);t.b("  <div class=\"modal-body phone-number call-back-phone-number\">");t.b("\n" + i);t.b("    <a href=\"javascript:;\" data-modal-id=\"popupContent\" class=\"close-modal icon-x\"></a>");t.b("\n" + i);t.b("    <h3 class=\"modal-title\">");t.b("\n" + i);t.b("      ");if(t.s(t.f("translate",c,p,1),c,p,0,232,266,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.talk_to_groupon");});c.pop();}t.b("\n" + i);t.b("    </h3>");t.b("\n" + i);t.b("    <div id='call-back-container'>");t.b("\n" + i);t.b("      <div id='call-back-spinner'></div>");t.b("\n" + i);t.b("      <div id='call-back-content-container' class='hide'>");t.b("\n" + i);t.b("        <div class='no-call-me-back-option hide'>");t.b("\n" + i);t.b("           <div id=\"call-me-back-error\">");t.b("\n" + i);t.b("            <span class='call-me-error-msg'>");if(t.s(t.f("translate",c,p,1),c,p,0,574,615,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.call_me_back_error_msg");});c.pop();}t.b("</span>");t.b("\n" + i);t.b("            <span class='call-me-instead'>");if(t.s(t.f("translate",c,p,1),c,p,0,693,727,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.call_us_instead");});c.pop();}t.b(".</span>");t.b("\n" + i);t.b("            <span class='icon-alert call-back-alert-below'> </span>");t.b("\n" + i);t.b("          </div>");t.b("\n" + i);t.b("          <div class=\"call-groupon\">");if(t.s(t.f("translate",c,p,1),c,p,0,885,926,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.call_back_call_groupon");});c.pop();}t.b("</div>");t.b("\n" + i);t.b("          <div class=\"call-back-variant-text\">");if(t.s(t.f("translate",c,p,1),c,p,0,1007,1048,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.call_back_variant_text");});c.pop();}t.b("</div>");t.b("\n" + i);t.b("          <div class=\"call-groupon-general-msg\">");if(t.s(t.f("translate",c,p,1),c,p,0,1131,1174,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.call_groupon_general_msg");});c.pop();}t.b("</div>");t.b("\n" + i);t.b("        </div>");t.b("\n" + i);t.b("        <div class='call-me-back-option hide'>");t.b("\n" + i);t.b("          <div class='call-me-back'>");if(t.s(t.f("translate",c,p,1),c,p,0,1307,1333,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.call_me");});c.pop();}t.b("</div>");t.b("\n" + i);if(!t.s(t.f("isLoggedIn",c,p,1),c,p,1,0,0,"")){t.b("            <div class='call-me-back-provide-info-msg'>");if(t.s(t.f("translate",c,p,1),c,p,0,1449,1494,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.call_back_provide_info_msg");});c.pop();}t.b("</div>");t.b("\n" + i);};if(t.s(t.f("isLoggedIn",c,p,1),c,p,0,1566,1713,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("            <div class='call-me-back-provide-info-msg'>");if(t.s(t.f("translate",c,p,1),c,p,0,1636,1682,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.call_back_provide_phone_msg");});c.pop();}t.b("</div>");t.b("\n" + i);});c.pop();}t.b("          <div id=\"call-me-back-inputs\" class=\"unstyled\"> </div>");t.b("\n" + i);t.b("          <input class=\"submit-button btn disabled call-back-submit-button opacity-half\" disabled=\"disabled\" data-bhw=\"create-ticket__");t.b(t.v(t.f("tagline",c,p,0)));t.b("\" type=\"button\" value=\"");if(t.s(t.f("translate",c,p,1),c,p,0,1976,2011,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.call_me_btn_text");});c.pop();}t.b("\">");t.b("\n" + i);t.b("        </div>");t.b("\n" + i);t.b("      </div>");t.b("\n" + i);t.b("    </div>");t.b("\n" + i);t.b("  </div>");t.b("\n" + i);t.b("</div>");t.b("\n");return t.fl(); },partials: {}, subs: {  }}, "<div  class=\"modal show-modal\">\n  <div class=\"modal-body phone-number call-back-phone-number\">\n    <a href=\"javascript:;\" data-modal-id=\"popupContent\" class=\"close-modal icon-x\"></a>\n    <h3 class=\"modal-title\">\n      {{#translate}}js.modules.support.talk_to_groupon{{/translate}}\n    </h3>\n    <div id='call-back-container'>\n      <div id='call-back-spinner'></div>\n      <div id='call-back-content-container' class='hide'>\n        <div class='no-call-me-back-option hide'>\n           <div id=\"call-me-back-error\">\n            <span class='call-me-error-msg'>{{#translate}}js.modules.support.call_me_back_error_msg{{/translate}}</span>\n            <span class='call-me-instead'>{{#translate}}js.modules.support.call_us_instead{{/translate}}.</span>\n            <span class='icon-alert call-back-alert-below'> </span>\n          </div>\n          <div class=\"call-groupon\">{{#translate}}js.modules.support.call_back_call_groupon{{/translate}}</div>\n          <div class=\"call-back-variant-text\">{{#translate}}js.modules.support.call_back_variant_text{{/translate}}</div>\n          <div class=\"call-groupon-general-msg\">{{#translate}}js.modules.support.call_groupon_general_msg{{/translate}}</div>\n        </div>\n        <div class='call-me-back-option hide'>\n          <div class='call-me-back'>{{#translate}}js.modules.support.call_me{{/translate}}</div>\n          {{^isLoggedIn}}\n            <div class='call-me-back-provide-info-msg'>{{#translate}}js.modules.support.call_back_provide_info_msg{{/translate}}</div>\n          {{/isLoggedIn}}\n          {{#isLoggedIn}}\n            <div class='call-me-back-provide-info-msg'>{{#translate}}js.modules.support.call_back_provide_phone_msg{{/translate}}</div>\n          {{/isLoggedIn}}\n          <div id=\"call-me-back-inputs\" class=\"unstyled\"> </div>\n          <input class=\"submit-button btn disabled call-back-submit-button opacity-half\" disabled=\"disabled\" data-bhw=\"create-ticket__{{tagline}}\" type=\"button\" value=\"{{#translate}}js.modules.support.call_me_btn_text{{/translate}}\">\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n", Hogan);
},{"hogan.js":248}],228:[function(require,module,exports){
var Hogan = require('hogan.js');
module.exports = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<div class=\"help-wizard-content\">");t.b("\n" + i);if(!t.s(t.f("isV2",c,p,1),c,p,1,0,0,"")){t.b("    <div style=\"width: 100%; text-align: center;\">");t.b("\n" + i);t.b("      <div class=\"problem-solved-message\">");t.b("\n" + i);t.b("        <span> <strong>");if(t.s(t.f("translate",c,p,1),c,p,0,177,201,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.great");});c.pop();}t.b("</strong>");t.b("\n" + i);t.b("        </span>");t.b("\n" + i);t.b("        ");if(t.s(t.f("translate",c,p,1),c,p,0,263,290,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.gladhelp");});c.pop();}t.b("\n" + i);t.b("        <br>");if(t.s(t.f("translate",c,p,1),c,p,0,331,359,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.tellevery");});c.pop();}t.b("</div>");t.b("\n" + i);t.b("      <div class=\"cat-image\"></div>");t.b("\n" + i);t.b("    </div>");t.b("\n" + i);};if(t.s(t.f("isV2",c,p,1),c,p,0,450,840,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("    <div style=\"width: 100%; text-align: center;\">");t.b("\n" + i);t.b("      <div lass=\"cat-image\"></div>");t.b("\n" + i);t.b("      <div class=\"problem-solved-message\">");t.b("\n" + i);t.b("        <span> <strong>");if(t.s(t.f("translate",c,p,1),c,p,0,617,641,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.great");});c.pop();}t.b("</strong>");t.b("\n" + i);t.b("        </span>");t.b("\n" + i);t.b("        ");if(t.s(t.f("translate",c,p,1),c,p,0,703,730,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.gladhelp");});c.pop();}t.b("\n" + i);t.b("        <br>");if(t.s(t.f("translate",c,p,1),c,p,0,771,799,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.tellevery");});c.pop();}t.b("\n" + i);t.b("      </div>");t.b("\n" + i);t.b("    </div>");t.b("\n" + i);});c.pop();}t.b("</div>");t.b("\n" + i);t.b("<div class=\"step-actions clrboth text-right hint\">");t.b("\n" + i);if(!t.s(t.f("isV2",c,p,1),c,p,1,0,0,"")){t.b("    <p>");t.b("\n" + i);t.b("      <a class=\"contact-us-from-problem-solved\" id=\"contact-us-from-problem-solved\" data-bhw=\"not-yet-solved\">");if(t.s(t.f("translate",c,p,1),c,p,0,1052,1080,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.notsolved");});c.pop();}t.b("</a>");t.b("\n" + i);t.b("    </p>");t.b("\n" + i);};if(t.s(t.f("isV2",c,p,1),c,p,0,1131,1290,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("    <p class=\"align-center\">");t.b("\n" + i);t.b("      <a id=\"needHelpAgain\" data-bhw=\"not-yet-solved\">");if(t.s(t.f("translate",c,p,1),c,p,0,1229,1260,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.made_mistake");});c.pop();}t.b("</a>");t.b("\n" + i);t.b("    </p>");t.b("\n" + i);});c.pop();}t.b("</div>");t.b("\n");return t.fl(); },partials: {}, subs: {  }}, "<div class=\"help-wizard-content\">\n  {{^isV2}}\n    <div style=\"width: 100%; text-align: center;\">\n      <div class=\"problem-solved-message\">\n        <span> <strong>{{#translate}}js.modules.support.great{{/translate}}</strong>\n        </span>\n        {{#translate}}js.modules.support.gladhelp{{/translate}}\n        <br>{{#translate}}js.modules.support.tellevery{{/translate}}</div>\n      <div class=\"cat-image\"></div>\n    </div>\n  {{/isV2}}\n  {{#isV2}}\n    <div style=\"width: 100%; text-align: center;\">\n      <div lass=\"cat-image\"></div>\n      <div class=\"problem-solved-message\">\n        <span> <strong>{{#translate}}js.modules.support.great{{/translate}}</strong>\n        </span>\n        {{#translate}}js.modules.support.gladhelp{{/translate}}\n        <br>{{#translate}}js.modules.support.tellevery{{/translate}}\n      </div>\n    </div>\n  {{/isV2}}\n</div>\n<div class=\"step-actions clrboth text-right hint\">\n  {{^isV2}}\n    <p>\n      <a class=\"contact-us-from-problem-solved\" id=\"contact-us-from-problem-solved\" data-bhw=\"not-yet-solved\">{{#translate}}js.modules.support.notsolved{{/translate}}</a>\n    </p>\n  {{/isV2}}\n  {{#isV2}}\n    <p class=\"align-center\">\n      <a id=\"needHelpAgain\" data-bhw=\"not-yet-solved\">{{#translate}}js.modules.support.made_mistake{{/translate}}</a>\n    </p>\n  {{/isV2}}\n</div>\n", Hogan);
},{"hogan.js":248}],229:[function(require,module,exports){
var Hogan = require('hogan.js');
module.exports = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<tr class=\"purchased-date\">");t.b("\n" + i);t.b("<td colspan=\"5\" class=\"purchased-date-element\">");t.b("\n" + i);t.b("    <span class=\"purchase-text\">");if(t.s(t.f("translate",c,p,1),c,p,0,122,150,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.purchased");});c.pop();}t.b("</span><span class=\"b purchase-date\">");t.b(t.v(t.f("purchasedAt",c,p,0)));t.b("<span>");t.b("\n" + i);t.b("</td>");t.b("\n" + i);t.b("</tr>");return t.fl(); },partials: {}, subs: {  }}, "<tr class=\"purchased-date\">\n<td colspan=\"5\" class=\"purchased-date-element\">\n    <span class=\"purchase-text\">{{#translate}}js.modules.support.purchased{{/translate}}</span><span class=\"b purchase-date\">{{purchasedAt}}<span>\n</td>\n</tr>", Hogan);
},{"hogan.js":248}],230:[function(require,module,exports){
var Hogan = require('hogan.js');
module.exports = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");if(!t.s(t.f("isV2",c,p,1),c,p,1,0,0,"")){t.b("  <h5>");t.b("\n" + i);t.b("    <span class='quesordTag'>");t.b("\n" + i);if(!t.s(t.f("faqInsteadHelpWizard",c,p,1),c,p,1,0,0,"")){t.b("    ");if(t.s(t.f("translate",c,p,1),c,p,0,95,121,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.quesord");});c.pop();}t.b("\n" + i);};if(t.s(t.f("faqInsteadHelpWizard",c,p,1),c,p,0,195,262,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("    ");if(t.s(t.f("translate",c,p,1),c,p,0,214,243,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.quesForord");});c.pop();}t.b("\n" + i);});c.pop();}t.b("    </span>");t.b("\n" + i);t.b("    <a class='anchorHover' id='chooseOrder' data-bhw=\"select-different-order\">");if(t.s(t.f("translate",c,p,1),c,p,0,392,418,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.seldiff");});c.pop();}t.b(".</a>");t.b("\n" + i);t.b("  </h5>");t.b("\n" + i);};t.b("\n");t.b("\n" + i);if(t.s(t.f("isV2",c,p,1),c,p,0,467,2062,"{{ }}")){t.rs(c,p,function(c,p,t){if(t.s(t.f("isOrderListing",c,p,1),c,p,0,489,1589,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("    <div class=\"row select-order-issue\">");t.b("\n" + i);t.b("      <h3 class=\"seven columns\">");t.b("\n" + i);t.b("        ");if(t.s(t.f("translate",c,p,1),c,p,0,586,626,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.v2.select_order_issue");});c.pop();}t.b("\n" + i);t.b("      </h3>");t.b("\n" + i);t.b("      <div id=\"sorting\" class=\"order-listing-sort five columns\">");t.b("\n" + i);t.b("        <span class=\"b\">");if(t.s(t.f("translate",c,p,1),c,p,0,756,782,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.sort_by");});c.pop();}t.b("</span>");t.b("\n" + i);if(t.s(t.f("enableMerchantNameSortOrders",c,p,1),c,p,0,845,1128,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("          <a class='anchorHover disabledLink b' id=\"purchasedDateSortOrders\">");if(t.s(t.f("translate",c,p,1),c,p,0,937,963,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.purdate");});c.pop();}t.b("</a>");t.b("\n" + i);t.b("          &nbsp;|");t.b("\n" + i);t.b("          <a class='anchorHover' id=\"merchantNameSortOrders\">");if(t.s(t.f("translate",c,p,1),c,p,0,1075,1101,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.busname");});c.pop();}t.b("</a>");t.b("\n" + i);});c.pop();}t.b("\n" + i);if(!t.s(t.f("enableMerchantNameSortOrders",c,p,1),c,p,1,0,0,"")){t.b("          <a class='anchorHover' id=\"purchasedDateSortOrders\">");if(t.s(t.f("translate",c,p,1),c,p,0,1281,1307,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.purdate");});c.pop();}t.b("</a>");t.b("\n" + i);t.b("          &nbsp;|");t.b("\n" + i);t.b("          <a class='anchorHover disabledLink b' id=\"merchantNameSortOrders\">");if(t.s(t.f("translate",c,p,1),c,p,0,1434,1460,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.busname");});c.pop();}t.b("</a>");t.b("\n" + i);};t.b("      </div>");t.b("\n" + i);t.b("    </div>");t.b("\n" + i);t.b("    <div class=\"row order-listing\"></div>");t.b("\n" + i);});c.pop();}t.b("\n" + i);if(t.s(t.f("isOrderdetails",c,p,1),c,p,0,1632,2042,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("    <div class=\"twelve columns select-order-issue\">");t.b("\n" + i);if(t.s(t.f("showVerticalView",c,p,1),c,p,0,1712,2007,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("        <div class=\"order-listing-sort offset-by-nine three columns\">");t.b("\n" + i);t.b("          <a class=\"btn-link btn-xlarge\"  id='chooseOrder' href=\"javascript:;\" data-bhw=\"select-different-order\"> ");t.b("\n" + i);t.b("            ");if(t.s(t.f("translate",c,p,1),c,p,0,1926,1955,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.v2.seldiff");});c.pop();}t.b("\n" + i);t.b("          </a>");t.b("\n");t.b("\n" + i);t.b("        </div>");t.b("\n" + i);});c.pop();}t.b("    </div>");t.b("\n" + i);});c.pop();}});c.pop();}return t.fl(); },partials: {}, subs: {  }}, "{{^isV2}}\n  <h5>\n    <span class='quesordTag'>\n    {{^faqInsteadHelpWizard}}\n    {{#translate}}js.modules.support.quesord{{/translate}}\n    {{/faqInsteadHelpWizard}}\n    {{#faqInsteadHelpWizard}}\n    {{#translate}}js.modules.support.quesForord{{/translate}}\n    {{/faqInsteadHelpWizard}}\n    </span>\n    <a class='anchorHover' id='chooseOrder' data-bhw=\"select-different-order\">{{#translate}}js.modules.support.seldiff{{/translate}}.</a>\n  </h5>\n{{/isV2}}\n\n\n{{#isV2}}\n  {{#isOrderListing}}\n    <div class=\"row select-order-issue\">\n      <h3 class=\"seven columns\">\n        {{#translate}}js.modules.support.v2.select_order_issue{{/translate}}\n      </h3>\n      <div id=\"sorting\" class=\"order-listing-sort five columns\">\n        <span class=\"b\">{{#translate}}js.modules.support.sort_by{{/translate}}</span>\n        {{#enableMerchantNameSortOrders}}\n          <a class='anchorHover disabledLink b' id=\"purchasedDateSortOrders\">{{#translate}}js.modules.support.purdate{{/translate}}</a>\n          &nbsp;|\n          <a class='anchorHover' id=\"merchantNameSortOrders\">{{#translate}}js.modules.support.busname{{/translate}}</a>\n        {{/enableMerchantNameSortOrders}}\n\n        {{^enableMerchantNameSortOrders}}\n          <a class='anchorHover' id=\"purchasedDateSortOrders\">{{#translate}}js.modules.support.purdate{{/translate}}</a>\n          &nbsp;|\n          <a class='anchorHover disabledLink b' id=\"merchantNameSortOrders\">{{#translate}}js.modules.support.busname{{/translate}}</a>\n        {{/enableMerchantNameSortOrders}}\n      </div>\n    </div>\n    <div class=\"row order-listing\"></div>\n  {{/isOrderListing}} \n\n  {{#isOrderdetails}}\n    <div class=\"twelve columns select-order-issue\">\n      {{#showVerticalView}}  \n        <div class=\"order-listing-sort offset-by-nine three columns\">\n          <a class=\"btn-link btn-xlarge\"  id='chooseOrder' href=\"javascript:;\" data-bhw=\"select-different-order\"> \n            {{#translate}}js.modules.support.v2.seldiff{{/translate}}\n          </a>\n\n        </div>\n      {{/showVerticalView}}\n    </div>\n  {{/isOrderdetails}}\n{{/isV2}}", Hogan);
},{"hogan.js":248}],231:[function(require,module,exports){
var Hogan = require('hogan.js');
module.exports = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");if(t.s(t.f("showDefaultCTA",c,p,1),c,p,0,19,519,"{{ }}")){t.rs(c,p,function(c,p,t){if(!t.s(t.f("showHyperlink",c,p,1),c,p,1,0,0,"")){t.b("    <input class='btn' data-bhw=\"serviceAction:");t.b(t.v(t.f("service_action_id",c,p,0)));t.b("__");t.b(t.v(t.f("id",c,p,0)));t.b("__");t.b(t.v(t.f("dealId",c,p,0)));t.b("__");t.b(t.v(t.f("channel",c,p,0)));t.b("__");t.b(t.v(t.f("country",c,p,0)));t.b("\" id=\"");t.b(t.v(t.f("service_action_id",c,p,0)));t.b("\" type='submit' value=\"");t.b(t.v(t.f("service_action",c,p,0)));t.b("\" />");t.b("\n" + i);};t.b("\n" + i);if(t.s(t.f("showHyperlink",c,p,1),c,p,0,270,500,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("    <a target=\"_blank\" type=\"button\" class=\"btn fr singleActionBtn\"  id=\"");t.b(t.v(t.f("service_action_id",c,p,0)));t.b("\" data-bhw=\"serviceAction:");t.b(t.v(t.f("service_action_id",c,p,0)));t.b("__");t.b(t.v(t.f("id",c,p,0)));t.b("__");t.b(t.v(t.f("dealId",c,p,0)));t.b("__");t.b(t.v(t.f("channel",c,p,0)));t.b("__");t.b(t.v(t.f("country",c,p,0)));t.b("__");t.b(t.v(t.f("grouponId",c,p,0)));t.b("\">");t.b(t.v(t.f("service_action",c,p,0)));t.b("</a>");t.b("\n" + i);});c.pop();}});c.pop();}t.b("\n");t.b("\n" + i);if(t.s(t.f("showLinkCTA",c,p,1),c,p,0,557,1069,"{{ }}")){t.rs(c,p,function(c,p,t){if(!t.s(t.f("showHyperlink",c,p,1),c,p,1,0,0,"")){t.b("    <a class='btn-link link-added' data-bhw=\"serviceAction:");t.b(t.v(t.f("service_action_id",c,p,0)));t.b("__");t.b(t.v(t.f("id",c,p,0)));t.b("__");t.b(t.v(t.f("dealId",c,p,0)));t.b("__");t.b(t.v(t.f("channel",c,p,0)));t.b("__");t.b(t.v(t.f("country",c,p,0)));t.b(":link\" id=\"");t.b(t.v(t.f("service_action_id",c,p,0)));t.b("\">");t.b("\n" + i);t.b("      ");t.b(t.v(t.f("service_action",c,p,0)));t.b("\n" + i);t.b("    </a>");t.b("\n" + i);};t.b("\n" + i);if(t.s(t.f("showHyperlink",c,p,1),c,p,0,816,1050,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("    <a target=\"_blank\" class=\"btn-link link-added singleActionBtn\"  id=\"");t.b(t.v(t.f("service_action_id",c,p,0)));t.b("\" data-bhw=\"serviceAction:");t.b(t.v(t.f("service_action_id",c,p,0)));t.b("__");t.b(t.v(t.f("id",c,p,0)));t.b("__");t.b(t.v(t.f("dealId",c,p,0)));t.b("__");t.b(t.v(t.f("channel",c,p,0)));t.b("__");t.b(t.v(t.f("country",c,p,0)));t.b("__");t.b(t.v(t.f("grouponId",c,p,0)));t.b(":link\">");t.b(t.v(t.f("service_action",c,p,0)));t.b("</a>");t.b("\n" + i);});c.pop();}});c.pop();}t.b("\n");t.b("\n" + i);if(t.s(t.f("showSecondaryCTA",c,p,1),c,p,0,1109,1668,"{{ }}")){t.rs(c,p,function(c,p,t){if(!t.s(t.f("showHyperlink",c,p,1),c,p,1,0,0,"")){t.b("    <button class='btn-invert btn-small' data-bhw=\"serviceAction:");t.b(t.v(t.f("service_action_id",c,p,0)));t.b("__");t.b(t.v(t.f("id",c,p,0)));t.b("__");t.b(t.v(t.f("dealId",c,p,0)));t.b("__");t.b(t.v(t.f("channel",c,p,0)));t.b("__");t.b(t.v(t.f("country",c,p,0)));t.b(":secondary\" id=\"");t.b(t.v(t.f("service_action_id",c,p,0)));t.b("\">");t.b("\n" + i);t.b("      ");t.b(t.v(t.f("service_action",c,p,0)));t.b("\n" + i);t.b("    </button>");t.b("\n" + i);};t.b("\n" + i);if(t.s(t.f("showHyperlink",c,p,1),c,p,0,1384,1649,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("    <a target=\"_blank\" type=\"button\" class=\"btn-invert btn-small link-added singleActionBtn\"  id=\"");t.b(t.v(t.f("service_action_id",c,p,0)));t.b("\" data-bhw=\"serviceAction:");t.b(t.v(t.f("service_action_id",c,p,0)));t.b("__");t.b(t.v(t.f("id",c,p,0)));t.b("__");t.b(t.v(t.f("dealId",c,p,0)));t.b("__");t.b(t.v(t.f("channel",c,p,0)));t.b("__");t.b(t.v(t.f("country",c,p,0)));t.b("__");t.b(t.v(t.f("grouponId",c,p,0)));t.b(":secondary\">");t.b(t.v(t.f("service_action",c,p,0)));t.b("</a>");t.b("\n" + i);});c.pop();}});c.pop();}return t.fl(); },partials: {}, subs: {  }}, "{{#showDefaultCTA}}\n  {{^showHyperlink}}\n    <input class='btn' data-bhw=\"serviceAction:{{service_action_id}}__{{id}}__{{dealId}}__{{channel}}__{{country}}\" id=\"{{service_action_id}}\" type='submit' value=\"{{service_action}}\" />\n  {{/showHyperlink}}\n\n  {{#showHyperlink}}\n    <a target=\"_blank\" type=\"button\" class=\"btn fr singleActionBtn\"  id=\"{{service_action_id}}\" data-bhw=\"serviceAction:{{service_action_id}}__{{id}}__{{dealId}}__{{channel}}__{{country}}__{{grouponId}}\">{{service_action}}</a>\n  {{/showHyperlink}}\n{{/showDefaultCTA}}\n\n\n{{#showLinkCTA}}\n  {{^showHyperlink}}\n    <a class='btn-link link-added' data-bhw=\"serviceAction:{{service_action_id}}__{{id}}__{{dealId}}__{{channel}}__{{country}}:link\" id=\"{{service_action_id}}\">\n      {{service_action}}\n    </a>\n  {{/showHyperlink}}\n\n  {{#showHyperlink}}\n    <a target=\"_blank\" class=\"btn-link link-added singleActionBtn\"  id=\"{{service_action_id}}\" data-bhw=\"serviceAction:{{service_action_id}}__{{id}}__{{dealId}}__{{channel}}__{{country}}__{{grouponId}}:link\">{{service_action}}</a>\n  {{/showHyperlink}}\n{{/showLinkCTA}}\n\n\n{{#showSecondaryCTA}}\n  {{^showHyperlink}}\n    <button class='btn-invert btn-small' data-bhw=\"serviceAction:{{service_action_id}}__{{id}}__{{dealId}}__{{channel}}__{{country}}:secondary\" id=\"{{service_action_id}}\">\n      {{service_action}}\n    </button>\n  {{/showHyperlink}}\n\n  {{#showHyperlink}}\n    <a target=\"_blank\" type=\"button\" class=\"btn-invert btn-small link-added singleActionBtn\"  id=\"{{service_action_id}}\" data-bhw=\"serviceAction:{{service_action_id}}__{{id}}__{{dealId}}__{{channel}}__{{country}}__{{grouponId}}:secondary\">{{service_action}}</a>\n  {{/showHyperlink}}\n{{/showSecondaryCTA}}\n", Hogan);
},{"hogan.js":248}],232:[function(require,module,exports){
var Hogan = require('hogan.js');
module.exports = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");if(!t.s(t.f("isV2",c,p,1),c,p,1,0,0,"")){t.b("  <a class=\"btn-link ");t.b(t.v(t.f("intl",c,p,0)));t.b("\" id=\"not-order-related\" type=\"button\" data-bhw=\"not-order-related__");t.b(t.v(t.f("id",c,p,0)));t.b("__");t.b(t.v(t.f("dealId",c,p,0)));t.b("__");t.b(t.v(t.f("channel",c,p,0)));t.b("__");t.b(t.v(t.f("country",c,p,0)));t.b("\">");t.b(t.v(t.f("notOrderRelatedText",c,p,0)));t.b("</a>&nbsp;");t.b("\n");t.b("\n" + i);t.b("  <input class=\"btn-invert\" id=\"continue-with-order\" style=\"margin-left: 15px;\" type=\"button\" data-bhw=\"continue-with-order__");t.b(t.v(t.f("id",c,p,0)));t.b("__");t.b(t.v(t.f("dealId",c,p,0)));t.b("__");t.b(t.v(t.f("channel",c,p,0)));t.b("__");t.b(t.v(t.f("country",c,p,0)));t.b("\" value=\"");t.b(t.v(t.f("contToStepTwoBtnText",c,p,0)));t.b("\"/>");t.b("\n" + i);};t.b("\n");t.b("\n" + i);if(t.s(t.f("isV2",c,p,1),c,p,0,415,2213,"{{ }}")){t.rs(c,p,function(c,p,t){if(t.s(t.f("showOrderListingActions",c,p,1),c,p,0,446,1389,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("\n" + i);if(!t.s(t.f("showVerticalView",c,p,1),c,p,1,0,0,"")){t.b("      <input class=\"btn-invert mr15 anchorHover\" class='anchorHover orderNotListed' id=\"orderNotListed\"  type=\"button\" data-bhw=\"order-not-listed\" value=\"");if(t.s(t.f("translate",c,p,1),c,p,0,643,672,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.ordnotlist");});c.pop();}t.b("\"/>");t.b("\n");t.b("\n" + i);t.b("      <input class=\"btn-primary btn\" id=\"select-current-order\" type=\"button\" data-bhw=\"select-current-order\" value=\"");if(t.s(t.f("translate",c,p,1),c,p,0,821,860,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.v2.select_this_order");});c.pop();}t.b("\" disabled />");t.b("\n" + i);};t.b("\n");t.b("\n" + i);if(t.s(t.f("showVerticalView",c,p,1),c,p,0,941,1364,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("      <input class=\"btn-invert mr15 anchorHover\" class='anchorHover orderNotListed' id=\"orderNotListed\"  type=\"button\" data-bhw=\"order-not-listed\" value=\"");if(t.s(t.f("translate",c,p,1),c,p,0,1110,1139,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.ordnotlist");});c.pop();}t.b("\"/>");t.b("\n");t.b("\n" + i);t.b("      <input class=\"btn-primary btn mr15\" id=\"select-current-order\" type=\"button\" data-bhw=\"select-current-order\" value=\"");if(t.s(t.f("translate",c,p,1),c,p,0,1293,1332,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.v2.select_this_order");});c.pop();}t.b("\" disabled />");t.b("\n" + i);});c.pop();}t.b("\n" + i);});c.pop();}t.b("\n");t.b("\n" + i);if(t.s(t.f("showOrderDetailsActions",c,p,1),c,p,0,1450,2183,"{{ }}")){t.rs(c,p,function(c,p,t){if(!t.s(t.f("showVerticalView",c,p,1),c,p,1,0,0,"")){t.b("      <input class=\"btn-invert mr15 anchorHover\"  id='chooseOrder' type=\"button\" data-bhw=\"select-different-order\" value=\"");if(t.s(t.f("translate",c,p,1),c,p,0,1613,1639,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.seldiff");});c.pop();}t.b("\"/>");t.b("\n");t.b("\n" + i);t.b("      <input class=\"btn-primary btn\" id=\"continue-with-order\"  type=\"button\" data-bhw=\"continue-with-order__");t.b(t.v(t.f("id",c,p,0)));t.b("__");t.b(t.v(t.f("dealId",c,p,0)));t.b("__");t.b(t.v(t.f("channel",c,p,0)));t.b("__");t.b(t.v(t.f("country",c,p,0)));t.b("\" value=\"");if(t.s(t.f("translate",c,p,1),c,p,0,1833,1861,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.contorder");});c.pop();}t.b("\"/>");t.b("\n" + i);};t.b("\n" + i);if(t.s(t.f("showVerticalView",c,p,1),c,p,0,1931,2157,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("      <input class=\"btn-primary btn\" id=\"continue-with-order\"  type=\"button\" data-bhw=\"continue-with-order__");t.b(t.v(t.f("id",c,p,0)));t.b("__");t.b(t.v(t.f("dealId",c,p,0)));t.b("__");t.b(t.v(t.f("channel",c,p,0)));t.b("__");t.b(t.v(t.f("country",c,p,0)));t.b("\" value=\"");if(t.s(t.f("translate",c,p,1),c,p,0,2107,2135,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.contorder");});c.pop();}t.b("\"/>");t.b("\n" + i);});c.pop();}t.b("\n");t.b("\n" + i);});c.pop();}t.b("\n" + i);});c.pop();}return t.fl(); },partials: {}, subs: {  }}, "{{^isV2}}\n  <a class=\"btn-link {{intl}}\" id=\"not-order-related\" type=\"button\" data-bhw=\"not-order-related__{{id}}__{{dealId}}__{{channel}}__{{country}}\">{{notOrderRelatedText}}</a>&nbsp;\n\n  <input class=\"btn-invert\" id=\"continue-with-order\" style=\"margin-left: 15px;\" type=\"button\" data-bhw=\"continue-with-order__{{id}}__{{dealId}}__{{channel}}__{{country}}\" value=\"{{contToStepTwoBtnText}}\"/>\n{{/isV2}}\n\n\n{{#isV2}}\n  {{#showOrderListingActions}} \n\n    {{^showVerticalView}}\n      <input class=\"btn-invert mr15 anchorHover\" class='anchorHover orderNotListed' id=\"orderNotListed\"  type=\"button\" data-bhw=\"order-not-listed\" value=\"{{#translate}}js.modules.support.ordnotlist{{/translate}}\"/>\n\n      <input class=\"btn-primary btn\" id=\"select-current-order\" type=\"button\" data-bhw=\"select-current-order\" value=\"{{#translate}}js.modules.support.v2.select_this_order{{/translate}}\" disabled />\n    {{/showVerticalView}}\n\n\n    {{#showVerticalView}}\n      <input class=\"btn-invert mr15 anchorHover\" class='anchorHover orderNotListed' id=\"orderNotListed\"  type=\"button\" data-bhw=\"order-not-listed\" value=\"{{#translate}}js.modules.support.ordnotlist{{/translate}}\"/>\n\n      <input class=\"btn-primary btn mr15\" id=\"select-current-order\" type=\"button\" data-bhw=\"select-current-order\" value=\"{{#translate}}js.modules.support.v2.select_this_order{{/translate}}\" disabled />\n    {{/showVerticalView}}\n\n  {{/showOrderListingActions}}\n\n\n  {{#showOrderDetailsActions}}\n    {{^showVerticalView}}\n      <input class=\"btn-invert mr15 anchorHover\"  id='chooseOrder' type=\"button\" data-bhw=\"select-different-order\" value=\"{{#translate}}js.modules.support.seldiff{{/translate}}\"/>\n\n      <input class=\"btn-primary btn\" id=\"continue-with-order\"  type=\"button\" data-bhw=\"continue-with-order__{{id}}__{{dealId}}__{{channel}}__{{country}}\" value=\"{{#translate}}js.modules.support.contorder{{/translate}}\"/>\n    {{/showVerticalView}}\n\n    {{#showVerticalView}}\n      <input class=\"btn-primary btn\" id=\"continue-with-order\"  type=\"button\" data-bhw=\"continue-with-order__{{id}}__{{dealId}}__{{channel}}__{{country}}\" value=\"{{#translate}}js.modules.support.contorder{{/translate}}\"/>\n    {{/showVerticalView}}\n\n\n  {{/showOrderDetailsActions}}\n\n{{/isV2}}\n", Hogan);
},{"hogan.js":248}],233:[function(require,module,exports){
var Hogan = require('hogan.js');
module.exports = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<div class=\"help-wizard-content\">");t.b("\n" + i);t.b("  <div class=\"steps-container\"> </div>");t.b("\n" + i);t.b("  <form method=\"post\" accept-charset=\"UTF-8\" id=\"contact-us\" enctype=\"multipart/form-data\" class=\"cb\" style=\"padding-bottom: 10px;\">");t.b("\n" + i);t.b("    <div class=\"row\">");t.b("\n" + i);if(!t.s(t.f("faqInsteadHelpWizard",c,p,1),c,p,1,0,0,"")){t.b("      <h4>");if(t.s(t.f("translate",c,p,1),c,p,0,284,312,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.contactus");});c.pop();}t.b("</h4>");t.b("\n" + i);};if(t.s(t.f("faqInsteadHelpWizard",c,p,1),c,p,0,395,472,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("      <h4>");if(t.s(t.f("translate",c,p,1),c,p,0,420,446,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.emailus");});c.pop();}t.b("</h4>");t.b("\n" + i);});c.pop();}if(t.s(t.f("show_all_fields_required",c,p,1),c,p,0,533,698,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("      <p> <strong><span style=\"color:red\">*</span></strong> <span style=\"color:#333\">");if(t.s(t.f("translate",c,p,1),c,p,0,633,666,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.all_fields_req");});c.pop();}t.b("</span></p>");t.b("\n" + i);});c.pop();}if(!t.s(t.f("show_all_fields_required",c,p,1),c,p,1,0,0,"")){t.b("      <p> <span style=\"color:red\">*</span> <span style=\"color:#333\">");if(t.s(t.f("translate",c,p,1),c,p,0,846,875,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.req_fields");});c.pop();}t.b("</span></p>");t.b("\n" + i);};if(t.s(t.f("is_order",c,p,1),c,p,0,956,1161,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("      <p class=\"merchant-info\">");t.b("\n" + i);t.b("        <label class=\"stepThreeLabel\"> <strong>");if(t.s(t.f("translate",c,p,1),c,p,0,1050,1077,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.merchant");});c.pop();}t.b("</strong>");t.b("\n" + i);t.b("        ");t.b(t.v(t.f("merchant_name",c,p,0)));t.b("\n" + i);t.b("        </label>");t.b("\n" + i);t.b("      </p>");t.b("\n" + i);});c.pop();}if(t.s(t.f("show_reason",c,p,1),c,p,0,1197,1420,"{{ }}")){t.rs(c,p,function(c,p,t){if(t.s(t.f("reason",c,p,1),c,p,0,1215,1402,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("      <p class=\"issue\">");t.b("\n" + i);t.b("        <label class=\"stepThreeLabel\"> <strong>");if(t.s(t.f("translate",c,p,1),c,p,0,1301,1325,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.issue");});c.pop();}t.b("</strong>");t.b("\n" + i);t.b("        ");t.b(t.v(t.f("reason",c,p,0)));t.b("\n" + i);t.b("        </label>");t.b("\n" + i);t.b("      </p>");t.b("\n" + i);});c.pop();}});c.pop();}t.b("      <ol style=\"padding-left:0px\" id=\"componentList\" class=\"contact-us-componont-list\"></ol>");t.b("\n" + i);t.b("      <div id=\"ticket_description_container\"> </div>");t.b("\n" + i);t.b("    </div>");t.b("\n" + i);t.b("  </form>");t.b("\n" + i);t.b("</div>");t.b("\n");return t.fl(); },partials: {}, subs: {  }}, "<div class=\"help-wizard-content\">\n  <div class=\"steps-container\"> </div>\n  <form method=\"post\" accept-charset=\"UTF-8\" id=\"contact-us\" enctype=\"multipart/form-data\" class=\"cb\" style=\"padding-bottom: 10px;\">\n    <div class=\"row\">\n      {{^faqInsteadHelpWizard}}\n      <h4>{{#translate}}js.modules.support.contactus{{/translate}}</h4>\n      {{/faqInsteadHelpWizard}}\n      {{#faqInsteadHelpWizard}}\n      <h4>{{#translate}}js.modules.support.emailus{{/translate}}</h4>\n      {{/faqInsteadHelpWizard}}\n      {{#show_all_fields_required}}\n      <p> <strong><span style=\"color:red\">*</span></strong> <span style=\"color:#333\">{{#translate}}js.modules.support.all_fields_req{{/translate}}</span></p>\n      {{/show_all_fields_required}}\n      {{^show_all_fields_required}}\n      <p> <span style=\"color:red\">*</span> <span style=\"color:#333\">{{#translate}}js.modules.support.req_fields{{/translate}}</span></p>\n      {{/show_all_fields_required}}\n      {{#is_order}}\n      <p class=\"merchant-info\">\n        <label class=\"stepThreeLabel\"> <strong>{{#translate}}js.modules.support.merchant{{/translate}}</strong>\n        {{merchant_name}}\n        </label>\n      </p>\n      {{/is_order}}\n      {{#show_reason}}\n      {{#reason}}\n      <p class=\"issue\">\n        <label class=\"stepThreeLabel\"> <strong>{{#translate}}js.modules.support.issue{{/translate}}</strong>\n        {{reason}}\n        </label>\n      </p>\n      {{/reason}}\n      {{/show_reason}}\n      <ol style=\"padding-left:0px\" id=\"componentList\" class=\"contact-us-componont-list\"></ol>\n      <div id=\"ticket_description_container\"> </div>\n    </div>\n  </form>\n</div>\n", Hogan);
},{"hogan.js":248}],234:[function(require,module,exports){
var Hogan = require('hogan.js');
module.exports = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");if(!t.s(t.f("showVerticalView",c,p,1),c,p,1,0,0,"")){t.b("  <input class=\"btn-invert back\" id=\"back\" type=\"button\" value=\"");if(t.s(t.f("translate",c,p,1),c,p,0,100,123,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.back");});c.pop();}t.b("\" data-bhw=\"Step-3-back\">");t.b("\n" + i);t.b("  <div class=\"live-chat-container normal-live-chat-container\" id=\"live-chat-container\"></div>");t.b("\n" + i);if(!t.s(t.f("isRefundEligible",c,p,1),c,p,1,0,0,"")){t.b("    <input class=\"submit-button btn disabled\" disabled=\"disabled\" data-bhw=\"create-ticket__");t.b(t.v(t.f("orderId",c,p,0)));t.b("__");t.b(t.v(t.f("tagline",c,p,0)));t.b("\" type=\"button\" value=\"");if(t.s(t.f("translate",c,p,1),c,p,0,433,458,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.submit");});c.pop();}t.b("\">");t.b("\n" + i);};if(t.s(t.f("isRefundEligible",c,p,1),c,p,0,522,734,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("    <input class=\"submit-button btn disabled\" disabled=\"disabled\" data-bhw=\"create-ticket__");t.b(t.v(t.f("orderId",c,p,0)));t.b("__");t.b(t.v(t.f("tagline",c,p,0)));t.b("\" type=\"button\" value=\"");if(t.s(t.f("translate",c,p,1),c,p,0,675,715,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.submit_refund_request");});c.pop();}t.b("\">");t.b("\n" + i);});c.pop();}};t.b("\n");t.b("\n" + i);if(t.s(t.f("showVerticalView",c,p,1),c,p,0,801,1597,"{{ }}")){t.rs(c,p,function(c,p,t){if(!t.s(t.f("isPriorityViewsEnabled",c,p,1),c,p,1,0,0,"")){t.b("    <button class=\"btn-invert other-contact-channel\" id=\"otherContactChannel\" data-bhw=\"email-other-channel\">");t.b("\n" + i);t.b("      ");if(t.s(t.f("translate",c,p,1),c,p,0,962,1012,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.v2.choose_other_contact_options");});c.pop();}t.b("\n" + i);t.b("    </button>  ");t.b("\n" + i);};if(!t.s(t.f("isRefundEligible",c,p,1),c,p,1,0,0,"")){t.b("    <input class=\"submit-button btn-primary btn disabled\" disabled=\"disabled\" data-bhw=\"create-ticket__");t.b(t.v(t.f("orderId",c,p,0)));t.b("__");t.b(t.v(t.f("tagline",c,p,0)));t.b("\" type=\"button\" value=\"");if(t.s(t.f("translate",c,p,1),c,p,0,1262,1287,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.submit");});c.pop();}t.b("\">");t.b("\n" + i);};if(t.s(t.f("isRefundEligible",c,p,1),c,p,0,1351,1575,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("    <input class=\"submit-button btn-primary btn disabled\" disabled=\"disabled\" data-bhw=\"create-ticket__");t.b(t.v(t.f("orderId",c,p,0)));t.b("__");t.b(t.v(t.f("tagline",c,p,0)));t.b("\" type=\"button\" value=\"");if(t.s(t.f("translate",c,p,1),c,p,0,1516,1556,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.submit_refund_request");});c.pop();}t.b("\">");t.b("\n" + i);});c.pop();}});c.pop();}return t.fl(); },partials: {}, subs: {  }}, "{{^showVerticalView}}\n  <input class=\"btn-invert back\" id=\"back\" type=\"button\" value=\"{{#translate}}js.modules.support.back{{/translate}}\" data-bhw=\"Step-3-back\">\n  <div class=\"live-chat-container normal-live-chat-container\" id=\"live-chat-container\"></div>\n  {{^isRefundEligible}}\n    <input class=\"submit-button btn disabled\" disabled=\"disabled\" data-bhw=\"create-ticket__{{orderId}}__{{tagline}}\" type=\"button\" value=\"{{#translate}}js.modules.support.submit{{/translate}}\">\n  {{/isRefundEligible}}\n  {{#isRefundEligible}}\n    <input class=\"submit-button btn disabled\" disabled=\"disabled\" data-bhw=\"create-ticket__{{orderId}}__{{tagline}}\" type=\"button\" value=\"{{#translate}}js.modules.support.submit_refund_request{{/translate}}\">\n  {{/isRefundEligible}}\n{{/showVerticalView}}\n\n\n{{#showVerticalView}}\n  {{^isPriorityViewsEnabled}}\n    <button class=\"btn-invert other-contact-channel\" id=\"otherContactChannel\" data-bhw=\"email-other-channel\">\n      {{#translate}}js.modules.support.v2.choose_other_contact_options{{/translate}}\n    </button>  \n  {{/isPriorityViewsEnabled}} \n  {{^isRefundEligible}}\n    <input class=\"submit-button btn-primary btn disabled\" disabled=\"disabled\" data-bhw=\"create-ticket__{{orderId}}__{{tagline}}\" type=\"button\" value=\"{{#translate}}js.modules.support.submit{{/translate}}\">\n  {{/isRefundEligible}}\n  {{#isRefundEligible}}\n    <input class=\"submit-button btn-primary btn disabled\" disabled=\"disabled\" data-bhw=\"create-ticket__{{orderId}}__{{tagline}}\" type=\"button\" value=\"{{#translate}}js.modules.support.submit_refund_request{{/translate}}\">\n  {{/isRefundEligible}}\n{{/showVerticalView}}", Hogan);
},{"hogan.js":248}],235:[function(require,module,exports){
var Hogan = require('hogan.js');
module.exports = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");if(!t.s(t.f("showVerticalView",c,p,1),c,p,1,0,0,"")){t.b("<input class=\"btn-invert back\" id=\"back\" type=\"button\" value=\"");if(t.s(t.f("translate",c,p,1),c,p,0,98,121,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.back");});c.pop();}t.b("\" data-bhw=\"Step-2-back\">");t.b("\n");t.b("\n" + i);if(t.s(t.f("showChat",c,p,1),c,p,0,175,293,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("  <div class=\"live-chat-container normal-live-chat-container\" id=\"live-chat-container\" style=\"display: none;\"></div>");t.b("\n" + i);});c.pop();}t.b("<div class=\"issue-check\" style=\"display: none;\">");t.b("\n" + i);t.b("  <span>");if(t.s(t.f("translate",c,p,1),c,p,0,378,405,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.didweres");});c.pop();}t.b("</span>");t.b("\n" + i);t.b("  <input class=\"btn problem-solved ml10\" id=\"problem-solved\" type=\"button\" value=\"");if(t.s(t.f("translate",c,p,1),c,p,0,523,548,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.solved");});c.pop();}t.b("\" data-bhw=\"problem-solved__");t.b(t.v(t.f("orderId",c,p,0)));t.b("__");t.b(t.v(t.f("tagline",c,p,0)));t.b("\"/>");t.b("\n" + i);t.b("  <input class=\"btn contact-us ml10\" id=\"contact-us\" type=\"button\" value=\"");t.b(t.v(t.f("needHelpBtnText",c,p,0)));t.b("\" data-bhw=\"contact-us-btn__");t.b(t.v(t.f("orderId",c,p,0)));t.b("__");t.b(t.v(t.f("tagline",c,p,0)));t.b("\"/>");t.b("\n" + i);t.b("</div>");t.b("\n");t.b("\n" + i);t.b("<div class=\"direct-ticket\" style=\"display: none;\">");t.b("\n" + i);t.b("  <input class=\"btn contact-us\" id=\"continueToTicket\" type=\"button\" value=\"");t.b(t.v(t.f("contToStepThreeBtnText",c,p,0)));t.b("\" data-bhw=\"continue-to-ticket__");t.b(t.v(t.f("orderId",c,p,0)));t.b("__");t.b(t.v(t.f("tagline",c,p,0)));t.b("\"/>");t.b("\n" + i);t.b("</div>");t.b("\n");t.b("\n" + i);t.b("<div class=\"refund-my-request\" style=\"display: none;\">");t.b("\n" + i);t.b("  <input class=\"btn contact-us\" id=\"request-refund\" type=\"button\" value=\"");t.b(t.v(t.f("refundMyRequest",c,p,0)));t.b("\" data-bhw=\"continue-to-ticket__");t.b(t.v(t.f("orderId",c,p,0)));t.b("__");t.b(t.v(t.f("tagline",c,p,0)));t.b("\"/>");t.b("\n" + i);t.b("</div>");t.b("\n" + i);};t.b("\n" + i);if(t.s(t.f("showVerticalView",c,p,1),c,p,0,1253,2012,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("\n" + i);t.b("<div class=\"refund-my-request\" style=\"display: none;\">");t.b("\n" + i);t.b("  <input class=\"btn\" id=\"request-refund\" type=\"button\" value=\"");t.b(t.v(t.f("refundMyRequest",c,p,0)));t.b("\" data-bhw=\"continue-to-ticket__");t.b(t.v(t.f("orderId",c,p,0)));t.b("__");t.b(t.v(t.f("tagline",c,p,0)));t.b("\"/>");t.b("\n" + i);t.b("</div>");t.b("\n");t.b("\n" + i);t.b("<div class=\"direct-ticket\" style=\"display: none;\">");t.b("\n" + i);t.b("  <span class=\"question\">");if(t.s(t.f("translate",c,p,1),c,p,0,1549,1576,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.didweres");});c.pop();}t.b("</span>");t.b("\n" + i);t.b("  <input class=\"btn-invert problem-solved ml10\" id=\"problem-solved\" type=\"button\" value=\"");if(t.s(t.f("translate",c,p,1),c,p,0,1701,1729,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.v2_solved");});c.pop();}t.b("\" data-bhw=\"problem-solved__");t.b(t.v(t.f("orderId",c,p,0)));t.b("__");t.b(t.v(t.f("tagline",c,p,0)));t.b("\"/>");t.b("\n" + i);t.b("  <input class=\"btn-invert contact-us\" id=\"continueToTicket\" type=\"button\" value=\"");if(t.s(t.f("translate",c,p,1),c,p,0,1895,1931,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.v2_need_more_help");});c.pop();}t.b("\" data-bhw=\"continue-to-ticket__");t.b(t.v(t.f("orderId",c,p,0)));t.b("__");t.b(t.v(t.f("tagline",c,p,0)));t.b("\"/>");t.b("\n" + i);t.b("</div>");t.b("\n" + i);});c.pop();}t.b("\n");t.b("\n");return t.fl(); },partials: {}, subs: {  }}, "{{^showVerticalView}}\n<input class=\"btn-invert back\" id=\"back\" type=\"button\" value=\"{{#translate}}js.modules.support.back{{/translate}}\" data-bhw=\"Step-2-back\">\n\n{{#showChat}}\n  <div class=\"live-chat-container normal-live-chat-container\" id=\"live-chat-container\" style=\"display: none;\"></div>\n{{/showChat}}\n<div class=\"issue-check\" style=\"display: none;\">\n  <span>{{#translate}}js.modules.support.didweres{{/translate}}</span>\n  <input class=\"btn problem-solved ml10\" id=\"problem-solved\" type=\"button\" value=\"{{#translate}}js.modules.support.solved{{/translate}}\" data-bhw=\"problem-solved__{{orderId}}__{{tagline}}\"/>\n  <input class=\"btn contact-us ml10\" id=\"contact-us\" type=\"button\" value=\"{{needHelpBtnText}}\" data-bhw=\"contact-us-btn__{{orderId}}__{{tagline}}\"/>\n</div>\n\n<div class=\"direct-ticket\" style=\"display: none;\">\n  <input class=\"btn contact-us\" id=\"continueToTicket\" type=\"button\" value=\"{{contToStepThreeBtnText}}\" data-bhw=\"continue-to-ticket__{{orderId}}__{{tagline}}\"/>\n</div>\n\n<div class=\"refund-my-request\" style=\"display: none;\">\n  <input class=\"btn contact-us\" id=\"request-refund\" type=\"button\" value=\"{{refundMyRequest}}\" data-bhw=\"continue-to-ticket__{{orderId}}__{{tagline}}\"/>\n</div>\n{{/showVerticalView}}\n\n{{#showVerticalView}}\n\n<div class=\"refund-my-request\" style=\"display: none;\">\n  <input class=\"btn\" id=\"request-refund\" type=\"button\" value=\"{{refundMyRequest}}\" data-bhw=\"continue-to-ticket__{{orderId}}__{{tagline}}\"/>\n</div>\n\n<div class=\"direct-ticket\" style=\"display: none;\">\n  <span class=\"question\">{{#translate}}js.modules.support.didweres{{/translate}}</span>\n  <input class=\"btn-invert problem-solved ml10\" id=\"problem-solved\" type=\"button\" value=\"{{#translate}}js.modules.support.v2_solved{{/translate}}\" data-bhw=\"problem-solved__{{orderId}}__{{tagline}}\"/>\n  <input class=\"btn-invert contact-us\" id=\"continueToTicket\" type=\"button\" value=\"{{#translate}}js.modules.support.v2_need_more_help{{/translate}}\" data-bhw=\"continue-to-ticket__{{orderId}}__{{tagline}}\"/>\n</div>\n{{/showVerticalView}}\n\n\n", Hogan);
},{"hogan.js":248}],236:[function(require,module,exports){
var Hogan = require('hogan.js');
module.exports = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<div class=\"inbenta-searchform-container\">");t.b("\n" + i);t.b(" <form id=\"inbenta-searchform\">");t.b("\n" + i);t.b("  <input id='inbenta-searchinput' class=\"inbenta-search-input\" type=\"text\" value=\"\" placeholder=\"");t.b(t.v(t.f("searchInputDefaultText",c,p,0)));t.b("\" data-bhw=\"nlp_inbenta_search_input\" aria-label=\"Search\">");t.b("\n" + i);t.b(" </form>");t.b("\n" + i);t.b("</div>");t.b("\n" + i);t.b("</div>");t.b("\n" + i);t.b("<div class=\"row\">");t.b("\n" + i);t.b("  <div class=\"twelve columns\">");t.b("\n" + i);t.b("    <div class=\"inbenta-content search-based-topics\" data-bhw=\"nlp_inbenta_topics\"></div>");t.b("\n" + i);t.b("  </div>");t.b("\n" + i);t.b("</div>");t.b("\n" + i);t.b("<div id=\"nlp-spinner\">");return t.fl(); },partials: {}, subs: {  }}, "<div class=\"inbenta-searchform-container\">\n <form id=\"inbenta-searchform\">\n  <input id='inbenta-searchinput' class=\"inbenta-search-input\" type=\"text\" value=\"\" placeholder=\"{{searchInputDefaultText}}\" data-bhw=\"nlp_inbenta_search_input\" aria-label=\"Search\">\n </form>\n</div>\n</div>\n<div class=\"row\">\n  <div class=\"twelve columns\">\n    <div class=\"inbenta-content search-based-topics\" data-bhw=\"nlp_inbenta_topics\"></div>\n  </div>\n</div>\n<div id=\"nlp-spinner\">", Hogan);
},{"hogan.js":248}],237:[function(require,module,exports){
var Hogan = require('hogan.js');
module.exports = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<select class=\"sub-category eight columns small-grid-four\">");t.b("\n" + i);t.b("  <option value=\"\" selected>");if(t.s(t.f("translate",c,p,1),c,p,0,102,139,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.subcategory_select");});c.pop();}t.b("</option>");t.b("\n" + i);if(t.s(t.f("subCategories",c,p,1),c,p,0,183,291,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("    <option data-bhw='category_dropdown__");t.b(t.v(t.f("id",c,p,0)));t.b("' value=\"");t.b(t.v(t.f("id",c,p,0)));t.b("\" data-group=\"");t.b(t.v(t.f("group",c,p,0)));t.b("\">");t.b(t.v(t.f("text",c,p,0)));t.b("</option>");t.b("\n" + i);});c.pop();}t.b("</select>");return t.fl(); },partials: {}, subs: {  }}, "<select class=\"sub-category eight columns small-grid-four\">\n  <option value=\"\" selected>{{#translate}}js.modules.support.subcategory_select{{/translate}}</option>\n  {{#subCategories}}\n    <option data-bhw='category_dropdown__{{id}}' value=\"{{id}}\" data-group=\"{{group}}\">{{text}}</option>\n  {{/subCategories}}\n</select>", Hogan);
},{"hogan.js":248}],238:[function(require,module,exports){
var Hogan = require('hogan.js');
module.exports = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<div class=\"help-wizard-content\">");t.b("\n" + i);t.b("  <div class=\"message ticket-success-message\">");t.b("\n" + i);if(t.s(t.f("showDefaultThankYouMsg",c,p,1),c,p,0,112,240,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("      <div class=\"icon-check-circle\"> </div>");t.b("\n" + i);t.b("      <h5 class=\"thanks-for-contacting\"><span>");t.b(t.v(t.f("greeting_text",c,p,0)));t.b("</span></h5>  ");t.b("\n" + i);});c.pop();}t.b("\n" + i);if(t.s(t.f("showEmailThankYouMsg",c,p,1),c,p,0,298,433,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("      <div class=\"email-success\"></div>");t.b("\n" + i);t.b("      <h5 class=\"thanks-for-emailing\">");t.b("\n" + i);t.b("        <span>");t.b(t.v(t.f("greeting_text",c,p,0)));t.b("</span>");t.b("\n" + i);t.b("      </h5>");t.b("\n" + i);});c.pop();}t.b("\n" + i);if(t.s(t.f("showChatThankYouMsg",c,p,1),c,p,0,490,632,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("      <div class=\"chat-icon-container\"> </div>");t.b("\n" + i);t.b("      <h5 class=\"thanks-for-chatting\">");t.b("\n" + i);t.b("        <span>");t.b(t.v(t.f("greeting_text",c,p,0)));t.b("</span>");t.b("\n" + i);t.b("      </h5>");t.b("\n" + i);});c.pop();}t.b("\n" + i);if(t.s(t.f("showCallBackThankYouMsg",c,p,1),c,p,0,692,927,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("    <div class=\"call-me-back-success\">");t.b("\n" + i);t.b("      <div class=\"icon-check-circle\"> </div>");t.b("\n" + i);t.b("      <h5 class=\"thanks-for-calling\">");t.b("\n" + i);t.b("        <span>");if(t.s(t.f("translate",c,p,1),c,p,0,843,876,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.v2.thanks_call");});c.pop();}t.b("</span>  ");t.b("\n" + i);t.b("      </h5>");t.b("\n" + i);t.b("    </div>");t.b("\n" + i);});c.pop();}t.b("  </div> ");t.b("\n" + i);t.b("    ");t.b("\n" + i);if(t.s(t.f("isDefaultflow",c,p,1),c,p,0,991,1690,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("    <div>");t.b("\n" + i);if(!t.s(t.f("refund_request_submitted",c,p,1),c,p,1,0,0,"")){if(!t.s(t.f("escalate_to_merchant",c,p,1),c,p,1,0,0,"")){if(t.s(t.f("defaultGetBackmsg",c,p,1),c,p,0,1104,1235,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("            <p class=\"thanks-for-contacting align-center\">");if(t.s(t.f("translate",c,p,1),c,p,0,1177,1206,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.getbackmsg");});c.pop();}t.b("</p>");t.b("\n" + i);});c.pop();}if(t.s(t.f("twoHoursGetBackMsg",c,p,1),c,p,0,1291,1430,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("            <p class=\"thanks-for-contacting align-center\">");if(t.s(t.f("translate",c,p,1),c,p,0,1364,1401,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.twoHoursGetBackMsg");});c.pop();}t.b("</p>");t.b("\n" + i);});c.pop();}};t.b("\n" + i);if(t.s(t.f("escalate_to_merchant",c,p,1),c,p,0,1522,1615,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("          <p class=\"thanks-for-contacting align-center\">");t.b(t.v(t.f("merchant_to_contact",c,p,0)));t.b("</p>");t.b("\n" + i);});c.pop();}};t.b("    </div>");t.b("\n" + i);});c.pop();}t.b("\n" + i);if(t.s(t.f("isChatFlow",c,p,1),c,p,0,1727,1855,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("    <div>");t.b("\n" + i);t.b("      <p class=\"align-center\">");if(t.s(t.f("translate",c,p,1),c,p,0,1782,1823,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.v2.transcript_to_email");});c.pop();}t.b("</p>");t.b("\n" + i);t.b("    </div>");t.b("\n" + i);});c.pop();}t.b("\n" + i);if(t.s(t.f("showNeedHelpLink",c,p,1),c,p,0,1895,2059,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("    <div class=\"align-center\">");t.b("\n" + i);t.b("      <a id=\"needHelpAgain\" href=\"javascript:;\"> ");if(t.s(t.f("translate",c,p,1),c,p,0,1990,2027,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.v2.need_help_again");});c.pop();}t.b("</a>");t.b("\n" + i);t.b("    </div>");t.b("\n" + i);});c.pop();}t.b("\n" + i);if(t.s(t.f("isCallMeBackFlow",c,p,1),c,p,0,2105,2366,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("    <div class=\"align-center call-me-back-flow\">");t.b("\n" + i);t.b("      <span class='call-back-request-sent'>");if(t.s(t.f("translate",c,p,1),c,p,0,2212,2247,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.recieved_request");});c.pop();}t.b("</span>");t.b("\n" + i);t.b("      <span class='call-back-phone-call-receive-msg'>");t.b(t.v(t.f("phoneCallReceivemsg",c,p,0)));t.b("</span>");t.b("\n" + i);t.b("    </div>");t.b("\n" + i);});c.pop();}t.b("</div>");t.b("\n");t.b("\n");t.b("\n" + i);if(t.s(t.f("showFooter",c,p,1),c,p,0,2412,2935,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("<div class=\"step-actions row hint\">");t.b("\n" + i);t.b("  <h3>");if(t.s(t.f("translate",c,p,1),c,p,0,2469,2491,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.dyk");});c.pop();}t.b("</h3>");t.b("\n" + i);t.b("  In");t.b("\n" + i);t.b("  <a  href=\"");if(t.s(t.f("translate",c,p,1),c,p,0,2542,2582,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.deal_preferences_link");});c.pop();}t.b("\">");t.b("\n" + i);t.b("  ");if(t.s(t.f("translate",c,p,1),c,p,0,2615,2643,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.myprofile");});c.pop();}t.b("</a>");t.b("\n" + i);t.b("  ");if(t.s(t.f("translate",c,p,1),c,p,0,2678,2704,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.setyour");});c.pop();}t.b("<a href=\"");if(t.s(t.f("translate",c,p,1),c,p,0,2741,2781,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.deal_preferences_link");});c.pop();}t.b("\">");t.b("\n" + i);t.b("  ");if(t.s(t.f("translate",c,p,1),c,p,0,2814,2841,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.dealpref");});c.pop();}t.b("</a>");if(t.s(t.f("translate",c,p,1),c,p,0,2873,2913,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.find_deals_fit_better");});c.pop();}t.b("\n" + i);t.b("</div>");t.b("\n" + i);});c.pop();}return t.fl(); },partials: {}, subs: {  }}, "<div class=\"help-wizard-content\">\n  <div class=\"message ticket-success-message\">\n    {{#showDefaultThankYouMsg}}\n      <div class=\"icon-check-circle\"> </div>\n      <h5 class=\"thanks-for-contacting\"><span>{{greeting_text}}</span></h5>  \n    {{/showDefaultThankYouMsg}}\n\n    {{#showEmailThankYouMsg}}\n      <div class=\"email-success\"></div>\n      <h5 class=\"thanks-for-emailing\">\n        <span>{{greeting_text}}</span>\n      </h5>\n    {{/showEmailThankYouMsg}}  \n\n    {{#showChatThankYouMsg}}\n      <div class=\"chat-icon-container\"> </div>\n      <h5 class=\"thanks-for-chatting\">\n        <span>{{greeting_text}}</span>\n      </h5>\n    {{/showChatThankYouMsg}}  \n\n    {{#showCallBackThankYouMsg}}\n    <div class=\"call-me-back-success\">\n      <div class=\"icon-check-circle\"> </div>\n      <h5 class=\"thanks-for-calling\">\n        <span>{{#translate}}js.modules.support.v2.thanks_call{{/translate}}</span>  \n      </h5>\n    </div>\n    {{/showCallBackThankYouMsg}}\n  </div> \n    \n  {{#isDefaultflow}}\n    <div>\n      {{^refund_request_submitted}}\n        {{^escalate_to_merchant}}\n          {{#defaultGetBackmsg}}\n            <p class=\"thanks-for-contacting align-center\">{{#translate}}js.modules.support.getbackmsg{{/translate}}</p>\n          {{/defaultGetBackmsg}}\n          {{#twoHoursGetBackMsg}}\n            <p class=\"thanks-for-contacting align-center\">{{#translate}}js.modules.support.twoHoursGetBackMsg{{/translate}}</p>\n          {{/twoHoursGetBackMsg}}\n        {{/escalate_to_merchant}}\n\n        {{#escalate_to_merchant}}\n          <p class=\"thanks-for-contacting align-center\">{{merchant_to_contact}}</p>\n        {{/escalate_to_merchant}}\n      {{/refund_request_submitted}}\n    </div>\n  {{/isDefaultflow}}\n\n  {{#isChatFlow}}\n    <div>\n      <p class=\"align-center\">{{#translate}}js.modules.support.v2.transcript_to_email{{/translate}}</p>\n    </div>\n  {{/isChatFlow}}\n\n  {{#showNeedHelpLink}}\n    <div class=\"align-center\">\n      <a id=\"needHelpAgain\" href=\"javascript:;\"> {{#translate}}js.modules.support.v2.need_help_again{{/translate}}</a>\n    </div>\n  {{/showNeedHelpLink}}\n\n  {{#isCallMeBackFlow}}\n    <div class=\"align-center call-me-back-flow\">\n      <span class='call-back-request-sent'>{{#translate}}js.modules.support.recieved_request{{/translate}}</span>\n      <span class='call-back-phone-call-receive-msg'>{{phoneCallReceivemsg}}</span>\n    </div>\n  {{/isCallMeBackFlow}}\n</div>\n\n\n{{#showFooter}}\n<div class=\"step-actions row hint\">\n  <h3>{{#translate}}js.modules.support.dyk{{/translate}}</h3>\n  In\n  <a  href=\"{{#translate}}js.modules.support.deal_preferences_link{{/translate}}\">\n  {{#translate}}js.modules.support.myprofile{{/translate}}</a>\n  {{#translate}}js.modules.support.setyour{{/translate}}<a href=\"{{#translate}}js.modules.support.deal_preferences_link{{/translate}}\">\n  {{#translate}}js.modules.support.dealpref{{/translate}}</a>{{#translate}}js.modules.support.find_deals_fit_better{{/translate}}\n</div>\n{{/showFooter}}", Hogan);
},{"hogan.js":248}],239:[function(require,module,exports){
var Hogan = require('hogan.js');
module.exports = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");if(t.s(t.f("date_time_input_template",c,p,1),c,p,0,29,608,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("    <label><strong>");t.b(t.v(t.f("label",c,p,0)));t.b("\n" + i);t.b("    ");if(t.s(t.f("required",c,p,1),c,p,0,76,117,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("<span class=\"mandatory-field\"> * </span> ");});c.pop();}t.b("</strong></label>");t.b("\n" + i);t.b("    <input class=\"inputField date_time_input\" class=\"date_time_input_us\" placeholder=\"\" size=\"20\" maxLength=\"15\" type=\"text\" readonly=\"readonly\" data-bhw='flex_step_three_us_date_time_input' aria-label=\"Date and Time\">");t.b("\n" + i);t.b("    ");if(t.s(t.f("translate",c,p,1),c,p,0,385,406,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.at");});c.pop();}t.b("\n" + i);t.b("    <input class=\"inputField time_input time_input_us\" placeholder=\"\" size=\"10\" maxLength=\"15\" type=\"text\" readonly=\"readonly\" data-bhw='flex_step_three_us_time_input' aria-label=\"Time\">");t.b("\n" + i);});c.pop();}t.b("\n" + i);if(t.s(t.f("phone_input_template",c,p,1),c,p,0,664,1235,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("    <label><strong>");t.b(t.v(t.f("label",c,p,0)));t.b("</span>");t.b("\n" + i);t.b("    ");if(t.s(t.f("required",c,p,1),c,p,0,718,759,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("<span class=\"mandatory-field\"> * </span> ");});c.pop();}t.b("</strong></label>");t.b("\n" + i);t.b("      ");if(t.s(t.f("translate",c,p,1),c,p,0,810,841,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.solutionhint");});c.pop();}t.b("\n" + i);t.b("      <input class=\"inputField phone_number_input\" maxLength=");t.b(t.v(t.f("maxLength",c,p,0)));t.b(" type=\"text\" name=\"contactPhone\"");t.b("\n" + i);t.b("      placeholder=\"( ___ ) ___ - ____\" data-bhw='flex_step_three_us_phone_number_input' aria-label=");t.b(t.v(t.f("label",c,p,0)));t.b(">");t.b("\n");t.b("\n" + i);t.b("    <span class=\"validatePhoneNumberInput invalid-input initially-hidden error\">");t.b("\n" + i);t.b("        ");if(t.s(t.f("translate",c,p,1),c,p,0,1177,1208,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.invalidphone");});c.pop();}t.b("\n" + i);t.b("    </span>");t.b("\n" + i);});c.pop();}t.b("\n" + i);if(t.s(t.f("text_line_input_template",c,p,1),c,p,0,1291,1603,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("    <label><strong>");t.b(t.v(t.f("label",c,p,0)));t.b("</span>");t.b("\n" + i);t.b("    ");if(t.s(t.f("required",c,p,1),c,p,0,1345,1386,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("<span class=\"mandatory-field\"> * </span> ");});c.pop();}t.b("</strong></label>");t.b("\n" + i);t.b("    <input class=\"inputField text_line_input\" class=\"text_line_input_us\"size=\"40\" maxLength=");t.b(t.v(t.f("maxLength",c,p,0)));t.b(" type=\"text\" data-bhw='flex_step_three_us_text_line_input' aria-label=");t.b(t.v(t.f("label",c,p,0)));t.b(">");t.b("\n" + i);});c.pop();}return t.fl(); },partials: {}, subs: {  }}, "{{#date_time_input_template}}\n    <label><strong>{{label}}\n    {{#required}}<span class=\"mandatory-field\"> * </span> {{/required}}</strong></label>\n    <input class=\"inputField date_time_input\" class=\"date_time_input_us\" placeholder=\"\" size=\"20\" maxLength=\"15\" type=\"text\" readonly=\"readonly\" data-bhw='flex_step_three_us_date_time_input' aria-label=\"Date and Time\">\n    {{#translate}}js.modules.support.at{{/translate}}\n    <input class=\"inputField time_input time_input_us\" placeholder=\"\" size=\"10\" maxLength=\"15\" type=\"text\" readonly=\"readonly\" data-bhw='flex_step_three_us_time_input' aria-label=\"Time\">\n{{/date_time_input_template}}\n\n{{#phone_input_template}}\n    <label><strong>{{label}}</span>\n    {{#required}}<span class=\"mandatory-field\"> * </span> {{/required}}</strong></label>\n      {{#translate}}js.modules.support.solutionhint{{/translate}}\n      <input class=\"inputField phone_number_input\" maxLength={{maxLength}} type=\"text\" name=\"contactPhone\"\n      placeholder=\"( ___ ) ___ - ____\" data-bhw='flex_step_three_us_phone_number_input' aria-label={{label}}>\n\n    <span class=\"validatePhoneNumberInput invalid-input initially-hidden error\">\n        {{#translate}}js.modules.support.invalidphone{{/translate}}\n    </span>\n{{/phone_input_template}}\n\n{{#text_line_input_template}}\n    <label><strong>{{label}}</span>\n    {{#required}}<span class=\"mandatory-field\"> * </span> {{/required}}</strong></label>\n    <input class=\"inputField text_line_input\" class=\"text_line_input_us\"size=\"40\" maxLength={{maxLength}} type=\"text\" data-bhw='flex_step_three_us_text_line_input' aria-label={{label}}>\n{{/text_line_input_template}}", Hogan);
},{"hogan.js":248}],240:[function(require,module,exports){
var Hogan = require('hogan.js');
module.exports = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<li class=\"requestedFields mb40\">");t.b("\n" + i);t.b("    <label class=\"stepThreeLabel\">");t.b("\n" + i);t.b("        <strong>");if(t.s(t.f("translate",c,p,1),c,p,0,99,128,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.user_phone");});c.pop();}t.b("</strong>");t.b("\n" + i);t.b("        <span class=\"mandatory-field\" id=\"contactOnlyByPhonenumberMandatory\">* </span>");t.b("\n" + i);t.b("    </label>");t.b("\n" + i);if(t.s(t.f("translate",c,p,1),c,p,0,266,297,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.solutionhint");});c.pop();}t.b("<br>");t.b("\n" + i);t.b(" <input class=\"inputField\" id =\"contact_phone\" maxLength=\"250\" type=\"text\" name=\"contactPhone\"");t.b("\n" + i);t.b(" placeholder=\"( ___ ) ___ - ____\" aria-label=\"Phone Number\"><br>");t.b("\n");t.b("\n" + i);t.b("<span id=\"validateContactPhone\" class=\"invalid-input initially-hidden error\">");t.b("\n" + i);t.b("    ");if(t.s(t.f("translate",c,p,1),c,p,0,573,604,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.invalidphone");});c.pop();}t.b("\n" + i);t.b("    <br>");t.b("\n" + i);t.b("</span>");t.b("\n" + i);t.b("<input type=\"checkbox\" id=\"contactOnlyByMail\" name=\"onlymail\" value=\"\" data-bhw=\"ContactViaEmail\" aria-label=\"Contact by Email\">");t.b("\n" + i);if(t.s(t.f("translate",c,p,1),c,p,0,779,815,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.contactbymailonly");});c.pop();}t.b("\n" + i);t.b("<span class=\"mandatory-field\" id=\"contactOnlyByMailMandatory\" style= \"display:none;\">* </span>");t.b("\n" + i);t.b("<br>");t.b("\n" + i);t.b("<input class=\"inputField initially-hidden\" id =\"contact_email\" size=\"40\" maxLength=\"250\" type=\"text\" name=\"contactEmail\" aria-label=\"Email Address\">");t.b("\n" + i);t.b("<span id=\"validateContactEmail\" class=\"invalid-input error initially-hidden\">");t.b("\n" + i);t.b("   ");if(t.s(t.f("translate",c,p,1),c,p,0,1174,1205,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.invalidemail");});c.pop();}t.b("\n" + i);t.b("</span>");t.b("\n" + i);t.b("</li>");t.b("\n");return t.fl(); },partials: {}, subs: {  }}, "<li class=\"requestedFields mb40\">\n    <label class=\"stepThreeLabel\">\n        <strong>{{#translate}}js.modules.support.user_phone{{/translate}}</strong>\n        <span class=\"mandatory-field\" id=\"contactOnlyByPhonenumberMandatory\">* </span>\n    </label>\n{{#translate}}js.modules.support.solutionhint{{/translate}}<br>\n <input class=\"inputField\" id =\"contact_phone\" maxLength=\"250\" type=\"text\" name=\"contactPhone\"\n placeholder=\"( ___ ) ___ - ____\" aria-label=\"Phone Number\"><br>\n\n<span id=\"validateContactPhone\" class=\"invalid-input initially-hidden error\">\n    {{#translate}}js.modules.support.invalidphone{{/translate}}\n    <br>\n</span>\n<input type=\"checkbox\" id=\"contactOnlyByMail\" name=\"onlymail\" value=\"\" data-bhw=\"ContactViaEmail\" aria-label=\"Contact by Email\">\n{{#translate}}js.modules.support.contactbymailonly{{/translate}}\n<span class=\"mandatory-field\" id=\"contactOnlyByMailMandatory\" style= \"display:none;\">* </span>\n<br>\n<input class=\"inputField initially-hidden\" id =\"contact_email\" size=\"40\" maxLength=\"250\" type=\"text\" name=\"contactEmail\" aria-label=\"Email Address\">\n<span id=\"validateContactEmail\" class=\"invalid-input error initially-hidden\">\n   {{#translate}}js.modules.support.invalidemail{{/translate}}\n</span>\n</li>\n", Hogan);
},{"hogan.js":248}],241:[function(require,module,exports){
var Hogan = require('hogan.js');
module.exports = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");if(!t.s(t.f("isLoggedIn",c,p,1),c,p,1,0,0,"")){t.b("<li class=\"requestedFields\">");t.b("\n" + i);t.b("  <label>");t.b("\n" + i);t.b("    <strong>");if(t.s(t.f("translate",c,p,1),c,p,0,81,109,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.userlabel");});c.pop();}t.b("\n" + i);t.b("       <span class=\"mandatory-field\">* </span>");t.b("\n" + i);t.b("    </strong>");t.b("\n" + i);t.b("  </label>");t.b("\n" + i);t.b("  <input class=\"inputField userName\" id =\"tcktUsername\" size=\"40\" maxLength=\"250\" type=\"text\" name=\"username\">");t.b("\n" + i);t.b("</li>");t.b("\n" + i);};t.b("\n" + i);if(!t.s(t.f("is_email",c,p,1),c,p,1,0,0,"")){t.b("<li class=\"requestedFields\">");t.b("\n" + i);t.b("  <label>");t.b("\n" + i);t.b("    <strong>");if(t.s(t.f("translate",c,p,1),c,p,0,409,438,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.emaillabel");});c.pop();}t.b("\n" + i);t.b("      <span class=\"mandatory-field\">* </span>");t.b("\n" + i);t.b("    </strong>");t.b("\n" + i);t.b("  </label>");t.b("\n" + i);t.b("    <input class=\"inputField\" id=\"tcktUsermail\" type=\"text\" name=\"email\" size=\"40\" maxLength=\"250\">");t.b("\n" + i);t.b("    <span id=\"validateUserContactEmail\" style=\"display:none\" class=\"error invalid-input initially-hidden\">");if(t.s(t.f("translate",c,p,1),c,p,0,744,775,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.invalidemail");});c.pop();}t.b("</span>");t.b("\n" + i);t.b(" </li>");t.b("\n" + i);};return t.fl(); },partials: {}, subs: {  }}, "{{^isLoggedIn}}\n<li class=\"requestedFields\">\n  <label>\n    <strong>{{#translate}}js.modules.support.userlabel{{/translate}}\n       <span class=\"mandatory-field\">* </span>\n    </strong>\n  </label>\n  <input class=\"inputField userName\" id =\"tcktUsername\" size=\"40\" maxLength=\"250\" type=\"text\" name=\"username\">\n</li>\n{{/isLoggedIn}}\n\n{{^is_email}}\n<li class=\"requestedFields\">\n  <label>\n    <strong>{{#translate}}js.modules.support.emaillabel{{/translate}}\n      <span class=\"mandatory-field\">* </span>\n    </strong>\n  </label>\n    <input class=\"inputField\" id=\"tcktUsermail\" type=\"text\" name=\"email\" size=\"40\" maxLength=\"250\">\n    <span id=\"validateUserContactEmail\" style=\"display:none\" class=\"error invalid-input initially-hidden\">{{#translate}}js.modules.support.invalidemail{{/translate}}</span>\n </li>\n {{/is_email}}\n", Hogan);
},{"hogan.js":248}],242:[function(require,module,exports){
var Hogan = require('hogan.js');
module.exports = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");if(t.s(t.f("myAccount",c,p,1),c,p,0,14,374,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("<div class=\"my-account-sign-in\">");t.b("\n" + i);t.b("  <div class=\"notification warning\"  id=\"account-sign-in-notification\">");t.b("\n" + i);t.b("    <span>");t.b("\n" + i);t.b("      ");if(t.s(t.f("translate",c,p,1),c,p,0,151,179,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.v2.please");});c.pop();}t.b("\n" + i);t.b("      <a id=");t.b(t.v(t.f("id",c,p,0)));t.b(">");if(t.s(t.f("translate",c,p,1),c,p,0,227,256,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.v2.sign_in");});c.pop();}t.b("</a>");t.b("\n" + i);t.b("      ");if(t.s(t.f("translate",c,p,1),c,p,0,295,331,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.v2.access_account");});c.pop();}t.b("\n" + i);t.b("    </span>");t.b("\n" + i);t.b("  </div>");t.b("\n" + i);t.b("</div>");t.b("\n" + i);});c.pop();}if(t.s(t.f("myOrder",c,p,1),c,p,0,401,749,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("<div class=\"my-order-sign-in\">");t.b("\n" + i);t.b("  <div class=\"notification warning\"  id=\"order-sign-in-notification\">");t.b("\n" + i);t.b("    <span>");t.b("\n" + i);t.b("      ");if(t.s(t.f("translate",c,p,1),c,p,0,534,562,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.v2.please");});c.pop();}t.b("\n" + i);t.b("      <a id=");t.b(t.v(t.f("id",c,p,0)));t.b(">");if(t.s(t.f("translate",c,p,1),c,p,0,610,639,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.v2.sign_in");});c.pop();}t.b("</a>");t.b("\n" + i);t.b("      ");if(t.s(t.f("translate",c,p,1),c,p,0,678,712,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.v2.access_order");});c.pop();}t.b("\n" + i);t.b("    </span>");t.b("\n" + i);t.b("  </div> ");t.b("\n" + i);});c.pop();}t.b("</div>");t.b("\n" + i);t.b(" ");return t.fl(); },partials: {}, subs: {  }}, "{{#myAccount}}\n<div class=\"my-account-sign-in\">\n  <div class=\"notification warning\"  id=\"account-sign-in-notification\">\n    <span>\n      {{#translate}}js.modules.support.v2.please{{/translate}}\n      <a id={{id}}>{{#translate}}js.modules.support.v2.sign_in{{/translate}}</a>\n      {{#translate}}js.modules.support.v2.access_account{{/translate}}\n    </span>\n  </div>\n</div>\n{{/myAccount}}\n{{#myOrder}}\n<div class=\"my-order-sign-in\">\n  <div class=\"notification warning\"  id=\"order-sign-in-notification\">\n    <span>\n      {{#translate}}js.modules.support.v2.please{{/translate}}\n      <a id={{id}}>{{#translate}}js.modules.support.v2.sign_in{{/translate}}</a>\n      {{#translate}}js.modules.support.v2.access_order{{/translate}}\n    </span>\n  </div> \n{{/myOrder}}\n</div>\n ", Hogan);
},{"hogan.js":248}],243:[function(require,module,exports){
var Hogan = require('hogan.js');
module.exports = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");if(!t.s(t.f("isVertical",c,p,1),c,p,1,0,0,"")){if(t.s(t.f("renderLayout",c,p,1),c,p,0,35,283,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("    <div class=\"help-wizard-content\">");t.b("\n" + i);t.b("      <div class=\"steps-container\"> </div>");t.b("\n" + i);t.b("    <h3 class=\"contact-channels-v2-header\">");if(t.s(t.f("translate",c,p,1),c,p,0,174,202,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.contactus");});c.pop();}t.b("</h3>");t.b("\n" + i);t.b("    <div class=\"flex-contact-channels-without-chat\"></div>");t.b("\n" + i);});c.pop();}t.b("\n" + i);t.b("    <div class=\"flexible-contact-channels-container horizontal\">");t.b("\n" + i);t.b("      <div class=\"flexible-contact-channel-text-container\">");t.b("\n" + i);t.b("        <div class='subheader-header'> ");t.b("\n" + i);if(t.s(t.f("orderMsg",c,p,1),c,p,0,490,707,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("            <p class='order-message'>");t.b("\n" + i);t.b("              <h4 class='msg-header'>");if(t.s(t.f("translate",c,p,1),c,p,0,580,613,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.order_selected");});c.pop();}t.b("</h4> ");t.b("\n" + i);t.b("              <p class='msg'>");t.b(t.v(t.f("orderMsg",c,p,0)));t.b("</p>");t.b("\n" + i);t.b("            </p>");t.b("\n" + i);});c.pop();}if(t.s(t.f("issueMsg",c,p,1),c,p,0,744,958,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("            <p class='issue-message'>");t.b("\n" + i);t.b("              <h4 class='msg-header'>");if(t.s(t.f("translate",c,p,1),c,p,0,834,864,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.order_issue");});c.pop();}t.b("</h4>");t.b("\n" + i);t.b("              <p class='msg'>");t.b(t.v(t.f("issueMsg",c,p,0)));t.b("</p>");t.b("\n" + i);t.b("            </p> ");t.b("\n" + i);});c.pop();}t.b("        </div>   ");t.b("\n" + i);t.b("      </div>");t.b("\n" + i);t.b("      ");t.b("\n" + i);t.b("      <h4 class=\"contact-options\">");t.b("\n" + i);t.b("        ");if(t.s(t.f("translate",c,p,1),c,p,0,1067,1101,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.contact_options");});c.pop();}t.b("\n" + i);t.b("      </h4>");t.b("\n");t.b("\n" + i);t.b("      <div class=\"flexible-contact-channel-icon-container\">");t.b("\n" + i);t.b("        <div class=\"columns flexible-chat-container text-center\">");t.b("\n" + i);t.b("          <div class=\"live-chat-container flexible-contact-channel\" id=\"live-chat-container\"></div>");t.b("\n" + i);t.b("        </div>");t.b("\n" + i);t.b("        <div class=\"columns contact-channel-v2-container flexible-email-container\">");t.b("\n" + i);t.b("          <div class='text-center'>");t.b("\n" + i);t.b("            <div class=\"icon-email contact-channel-v2-icons\"> </div>");t.b("\n" + i);t.b("            <div  class=\"contact-channel-msg\">");t.b("\n" + i);t.b("              <p> ");if(t.s(t.f("translate",c,p,1),c,p,0,1638,1670,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.email_groupon");});c.pop();}t.b("</p>");t.b("\n" + i);t.b("              <p> ");if(t.s(t.f("translate",c,p,1),c,p,0,1721,1757,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.give_your_contact");});c.pop();}t.b("</p>");t.b("\n" + i);t.b("              <p> ");if(t.s(t.f("translate",c,p,1),c,p,0,1808,1840,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.info_get_back");});c.pop();}t.b("</p>");t.b("\n" + i);t.b("              <p> ");if(t.s(t.f("translate",c,p,1),c,p,0,1891,1922,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.you_in_hours");});c.pop();}t.b("</p>");t.b("\n" + i);t.b("            </div>");t.b("\n" + i);t.b("          </div>");t.b("\n" + i);t.b("        </div>");t.b("\n" + i);t.b("        <div class=\"columns contact-channel-v2-container flexible-phone-container\">");t.b("\n" + i);t.b("          <div class='text-center'>");t.b("\n" + i);t.b("            <div class='icon-phone contact-channel-v2-icons'></div>");t.b("\n" + i);t.b("            <div  class=\"contact-channel-msg\">");t.b("\n" + i);t.b("              <p>");if(t.s(t.f("translate",c,p,1),c,p,0,2258,2292,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.talk_to_groupon");});c.pop();}t.b("</p>");t.b("\n" + i);t.b("              <p>");if(t.s(t.f("translate",c,p,1),c,p,0,2342,2389,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.urgent_issue_talk_to_groupon");});c.pop();}t.b("</p>");t.b("\n" + i);t.b("              <p class=\"phone-time-table\">");if(t.s(t.f("translate",c,p,1),c,p,0,2464,2498,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.talk_time_table");});c.pop();}t.b("</p>");t.b("\n" + i);t.b("            </div>");t.b("\n" + i);t.b("          </div>");t.b("\n" + i);t.b("        </div>");t.b("\n" + i);t.b("      </div>");t.b("\n" + i);t.b("      <div class=\"recommended\">");t.b("\n" + i);t.b("        <p>");if(t.s(t.f("translate",c,p,1),c,p,0,2638,2668,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.recommended");});c.pop();}t.b("</p>");t.b("\n" + i);t.b("      </div>");t.b("\n" + i);t.b("    </div>");t.b("\n");t.b("\n" + i);if(t.s(t.f("renderLayout",c,p,1),c,p,0,2731,2745,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("    </div>");t.b("\n" + i);});c.pop();}};t.b("\n" + i);if(t.s(t.f("isVertical",c,p,1),c,p,0,2797,7644,"{{ }}")){t.rs(c,p,function(c,p,t){if(t.s(t.f("renderLayout",c,p,1),c,p,0,2817,2919,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("    <div class=\"help-wizard-content\">");t.b("\n" + i);t.b("      <div class=\"flex-contact-channels-without-chat\"></div>");t.b("\n" + i);});c.pop();}t.b("\n" + i);t.b("    <div class=\"flexible-contact-channels-container vertical\">");t.b("\n" + i);t.b("      <div class=\"recommended\">");t.b("\n" + i);t.b("        <p>");if(t.s(t.f("translate",c,p,1),c,p,0,3058,3088,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.recommended");});c.pop();}t.b("</p>");t.b("\n" + i);t.b("      </div>");t.b("\n");t.b("\n" + i);t.b("      <div class=\"flexible-contact-channel-icon-container\">");t.b("\n" + i);t.b("        <div class=\"columns flexible-chat-container text-center\">");t.b("\n" + i);t.b("          <div class=\"live-chat-container flexible-contact-channel\" id=\"live-chat-container\"></div>");t.b("\n" + i);t.b("        </div>");t.b("\n" + i);t.b("        <div class=\"columns contact-channel-v2-container flexible-email-container\">");t.b("\n" + i);t.b("          <div class='text-center'>");t.b("\n" + i);t.b("            <p class=\"icon-container\"> ");t.b("\n" + i);t.b("              <span class=\"icon-email contact-channel-v2-icons\"> </span>");t.b("\n" + i);t.b("              <span> ");if(t.s(t.f("translate",c,p,1),c,p,0,3630,3662,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.email_groupon");});c.pop();}t.b("</span>");t.b("\n" + i);t.b("            </p>");t.b("\n" + i);t.b("            <div class=\"contact-channel-msg\">");t.b("\n" + i);t.b("              <p> ");if(t.s(t.f("translate",c,p,1),c,p,0,3779,3811,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.info_get_back");});c.pop();}t.b("</p>");t.b("\n" + i);t.b("              <p> ");if(t.s(t.f("translate",c,p,1),c,p,0,3862,3893,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.you_in_hours");});c.pop();}t.b("</p>");t.b("\n" + i);t.b("            </div>");t.b("\n" + i);t.b("          </div>");t.b("\n" + i);t.b("        </div>");t.b("\n" + i);t.b("        <div class=\"columns contact-channel-v2-container flexible-phone-container\">");t.b("\n" + i);t.b("          <div class='text-center'>");t.b("\n" + i);t.b("            <p class=\"icon-container\"> ");t.b("\n" + i);t.b("              <span class='icon-phone contact-channel-v2-icons'></span>");t.b("\n" + i);t.b("              <span>");if(t.s(t.f("translate",c,p,1),c,p,0,4229,4263,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.talk_to_groupon");});c.pop();}t.b("</span>");t.b("\n" + i);t.b("            </p>    ");t.b("\n" + i);t.b("            <div class=\"contact-channel-msg\">");t.b("\n" + i);t.b("              <p>");if(t.s(t.f("translate",c,p,1),c,p,0,4383,4430,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.urgent_issue_talk_to_groupon");});c.pop();}t.b("</p>");t.b("\n" + i);t.b("              <p class=\"phone-time-table\">");if(t.s(t.f("translate",c,p,1),c,p,0,4505,4539,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.talk_time_table");});c.pop();}t.b("</p>");t.b("\n" + i);t.b("            </div>");t.b("\n" + i);t.b("          </div>");t.b("\n" + i);t.b("        </div>");t.b("\n" + i);t.b("      </div>");t.b("\n");t.b("\n" + i);t.b("      <div class=\"flexible-contact-channel-text-container\">");t.b("\n" + i);if(t.s(t.f("contact_channels",c,p,1),c,p,0,4712,7539,"{{ }}")){t.rs(c,p,function(c,p,t){if(t.s(t.f("primary",c,p,1),c,p,0,4735,5739,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("            <span class=\"flex-primary-channel-text\">");t.b("\n" + i);if(t.s(t.f("is_chat",c,p,1),c,p,0,4815,5374,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("                <span class=\"flex-chat-channel-text flex-");t.b(t.v(t.f("channel",c,p,0)));t.b("-link\">");t.b("\n" + i);t.b("                  <span class=\"flex-primary-below-text\">");if(t.s(t.f("translate",c,p,1),c,p,0,4962,4996,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.best_assist_you");});c.pop();}t.b("</span>");t.b("\n" + i);t.b("                  <span>");t.b("\n" + i);t.b("                    <span class=\"primary-");t.b(t.v(t.f("channel",c,p,0)));t.b("-link flex-chat-link\" data-bhw=\"flex-primary-chat-link\" id=\"live-chat-link-container\"></span>");t.b("\n" + i);t.b("                  </span>");t.b("\n" + i);t.b("                  <span class=\"flex-chat-team\">");if(t.s(t.f("translate",c,p,1),c,p,0,5276,5308,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.with_our_team");});c.pop();}t.b(" </span><br/>");t.b("\n" + i);t.b("                </span>");t.b("\n" + i);});c.pop();}t.b("\n" + i);if(!t.s(t.f("is_chat",c,p,1),c,p,1,0,0,"")){t.b("                <span class=\"flex-primary-below-text\">");if(t.s(t.f("translate",c,p,1),c,p,0,5483,5517,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.best_assist_you");});c.pop();}t.b("</span>");t.b("\n" + i);t.b("                <a class=\"primary-");t.b(t.v(t.f("channel",c,p,0)));t.b("-link flex-");t.b(t.v(t.f("channel",c,p,0)));t.b("-link\" data-bhw=\"flex-primary-");t.b(t.v(t.f("channel",c,p,0)));t.b("-link\"> ");t.b(t.v(t.f("channel_text",c,p,0)));t.b(" </a><br/>");t.b("\n" + i);};t.b("            </span>");t.b("\n" + i);});c.pop();}t.b("\n" + i);if(t.s(t.f("secondary",c,p,1),c,p,0,5777,6639,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("            <span class=\"flex-secondary-channel-text\">");t.b("\n" + i);t.b("              <span class=\"flex-secondary-channel-also-text\">");if(t.s(t.f("translate",c,p,1),c,p,0,5908,5939,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.you_can_also");});c.pop();}t.b("</span>");t.b("\n" + i);if(t.s(t.f("is_chat",c,p,1),c,p,0,5987,6394,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("                <span class=\"secondary-flex-");t.b(t.v(t.f("channel",c,p,0)));t.b("-channel secondary-flex-channel flex-");t.b(t.v(t.f("channel",c,p,0)));t.b("-link\">");t.b("\n" + i);t.b("                  <span class=\"secondary-chat-link flex-chat-link\" id=\"live-chat-link-container\" data-bhw=\"flex-secondary-chat-link\"></span>");t.b("\n" + i);t.b("                  <span class=\"flex-chat-team\">");if(t.s(t.f("translate",c,p,1),c,p,0,6301,6333,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.with_our_team");});c.pop();}t.b(" </span>");t.b("\n" + i);t.b("                </span>");t.b("\n" + i);});c.pop();}if(!t.s(t.f("is_chat",c,p,1),c,p,1,0,0,"")){t.b("                <a class=\"secondary-flex-");t.b(t.v(t.f("channel",c,p,0)));t.b("-channel flex-");t.b(t.v(t.f("channel",c,p,0)));t.b("-link\" data-bhw=\"flex-secondary-");t.b(t.v(t.f("channel",c,p,0)));t.b("-link\">");t.b(t.v(t.f("channel_text",c,p,0)));t.b("</a>");t.b("\n" + i);};t.b("            </span>");t.b("\n" + i);});c.pop();}if(t.s(t.f("tertiary",c,p,1),c,p,0,6677,7515,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("            <span class=\"flex-tertiary-channel-text\">");t.b("\n" + i);t.b("              <span class=\"flex-channel-or-text tertiary-flex-channel\">");if(t.s(t.f("translate",c,p,1),c,p,0,6817,6838,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.or");});c.pop();}t.b("</span>");t.b("\n" + i);if(t.s(t.f("is_chat",c,p,1),c,p,0,6886,7272,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("                <span class=\"tertiary-flex-");t.b(t.v(t.f("channel",c,p,0)));t.b("-channel flex-");t.b(t.v(t.f("channel",c,p,0)));t.b("-link\">");t.b("\n" + i);t.b("                  <span class=\"tertiary-chat-link flex-chat-link\" id=\"live-chat-link-container\" data-bhw=\"flex-tertiary-chat-link\"></span>");t.b("\n" + i);t.b("                  <span class=\"flex-chat-team\">");if(t.s(t.f("translate",c,p,1),c,p,0,7174,7206,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.with_our_team");});c.pop();}t.b(" </span><br/>");t.b("\n" + i);t.b("                </span>");t.b("\n" + i);});c.pop();}if(!t.s(t.f("is_chat",c,p,1),c,p,1,0,0,"")){t.b("                <a class=\"tertiary-flex-");t.b(t.v(t.f("channel",c,p,0)));t.b("-channel flex-");t.b(t.v(t.f("channel",c,p,0)));t.b("-link\" data-bhw=\"flex-tertiary-");t.b(t.v(t.f("channel",c,p,0)));t.b("-link\">");t.b(t.v(t.f("channel_text",c,p,0)));t.b("</a>");t.b("\n" + i);};t.b("            </span>");t.b("\n" + i);});c.pop();}});c.pop();}t.b("      </div>");t.b("\n");t.b("\n" + i);t.b("    </div>");t.b("\n");t.b("\n" + i);if(t.s(t.f("renderLayout",c,p,1),c,p,0,7610,7624,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("    </div>");t.b("\n" + i);});c.pop();}});c.pop();}return t.fl(); },partials: {}, subs: {  }}, "{{^isVertical}}\n  {{#renderLayout}}\n    <div class=\"help-wizard-content\">\n      <div class=\"steps-container\"> </div>\n    <h3 class=\"contact-channels-v2-header\">{{#translate}}js.modules.support.contactus{{/translate}}</h3>\n    <div class=\"flex-contact-channels-without-chat\"></div>\n  {{/renderLayout}}\n\n    <div class=\"flexible-contact-channels-container horizontal\">\n      <div class=\"flexible-contact-channel-text-container\">\n        <div class='subheader-header'> \n          {{#orderMsg}}\n            <p class='order-message'>\n              <h4 class='msg-header'>{{#translate}}js.modules.support.order_selected{{/translate}}</h4> \n              <p class='msg'>{{orderMsg}}</p>\n            </p>\n          {{/orderMsg}}\n          {{#issueMsg}}\n            <p class='issue-message'>\n              <h4 class='msg-header'>{{#translate}}js.modules.support.order_issue{{/translate}}</h4>\n              <p class='msg'>{{issueMsg}}</p>\n            </p> \n          {{/issueMsg}}\n        </div>   \n      </div>\n      \n      <h4 class=\"contact-options\">\n        {{#translate}}js.modules.support.contact_options{{/translate}}\n      </h4>\n\n      <div class=\"flexible-contact-channel-icon-container\">\n        <div class=\"columns flexible-chat-container text-center\">\n          <div class=\"live-chat-container flexible-contact-channel\" id=\"live-chat-container\"></div>\n        </div>\n        <div class=\"columns contact-channel-v2-container flexible-email-container\">\n          <div class='text-center'>\n            <div class=\"icon-email contact-channel-v2-icons\"> </div>\n            <div  class=\"contact-channel-msg\">\n              <p> {{#translate}}js.modules.support.email_groupon{{/translate}}</p>\n              <p> {{#translate}}js.modules.support.give_your_contact{{/translate}}</p>\n              <p> {{#translate}}js.modules.support.info_get_back{{/translate}}</p>\n              <p> {{#translate}}js.modules.support.you_in_hours{{/translate}}</p>\n            </div>\n          </div>\n        </div>\n        <div class=\"columns contact-channel-v2-container flexible-phone-container\">\n          <div class='text-center'>\n            <div class='icon-phone contact-channel-v2-icons'></div>\n            <div  class=\"contact-channel-msg\">\n              <p>{{#translate}}js.modules.support.talk_to_groupon{{/translate}}</p>\n              <p>{{#translate}}js.modules.support.urgent_issue_talk_to_groupon{{/translate}}</p>\n              <p class=\"phone-time-table\">{{#translate}}js.modules.support.talk_time_table{{/translate}}</p>\n            </div>\n          </div>\n        </div>\n      </div>\n      <div class=\"recommended\">\n        <p>{{#translate}}js.modules.support.recommended{{/translate}}</p>\n      </div>\n    </div>\n\n  {{#renderLayout}}\n    </div>\n  {{/renderLayout}}  \n{{/isVertical}}\n\n{{#isVertical}}\n  {{#renderLayout}}\n    <div class=\"help-wizard-content\">\n      <div class=\"flex-contact-channels-without-chat\"></div>\n  {{/renderLayout}}\n\n    <div class=\"flexible-contact-channels-container vertical\">\n      <div class=\"recommended\">\n        <p>{{#translate}}js.modules.support.recommended{{/translate}}</p>\n      </div>\n\n      <div class=\"flexible-contact-channel-icon-container\">\n        <div class=\"columns flexible-chat-container text-center\">\n          <div class=\"live-chat-container flexible-contact-channel\" id=\"live-chat-container\"></div>\n        </div>\n        <div class=\"columns contact-channel-v2-container flexible-email-container\">\n          <div class='text-center'>\n            <p class=\"icon-container\"> \n              <span class=\"icon-email contact-channel-v2-icons\"> </span>\n              <span> {{#translate}}js.modules.support.email_groupon{{/translate}}</span>\n            </p>\n            <div class=\"contact-channel-msg\">\n              <p> {{#translate}}js.modules.support.info_get_back{{/translate}}</p>\n              <p> {{#translate}}js.modules.support.you_in_hours{{/translate}}</p>\n            </div>\n          </div>\n        </div>\n        <div class=\"columns contact-channel-v2-container flexible-phone-container\">\n          <div class='text-center'>\n            <p class=\"icon-container\"> \n              <span class='icon-phone contact-channel-v2-icons'></span>\n              <span>{{#translate}}js.modules.support.talk_to_groupon{{/translate}}</span>\n            </p>    \n            <div class=\"contact-channel-msg\">\n              <p>{{#translate}}js.modules.support.urgent_issue_talk_to_groupon{{/translate}}</p>\n              <p class=\"phone-time-table\">{{#translate}}js.modules.support.talk_time_table{{/translate}}</p>\n            </div>\n          </div>\n        </div>\n      </div>\n\n      <div class=\"flexible-contact-channel-text-container\">\n        {{#contact_channels}}\n          {{#primary}}\n            <span class=\"flex-primary-channel-text\">\n              {{#is_chat}}\n                <span class=\"flex-chat-channel-text flex-{{channel}}-link\">\n                  <span class=\"flex-primary-below-text\">{{#translate}}js.modules.support.best_assist_you{{/translate}}</span>\n                  <span>\n                    <span class=\"primary-{{channel}}-link flex-chat-link\" data-bhw=\"flex-primary-chat-link\" id=\"live-chat-link-container\"></span>\n                  </span>\n                  <span class=\"flex-chat-team\">{{#translate}}js.modules.support.with_our_team{{/translate}} </span><br/>\n                </span>\n              {{/is_chat}}\n\n              {{^is_chat}}\n                <span class=\"flex-primary-below-text\">{{#translate}}js.modules.support.best_assist_you{{/translate}}</span>\n                <a class=\"primary-{{channel}}-link flex-{{channel}}-link\" data-bhw=\"flex-primary-{{channel}}-link\"> {{channel_text}} </a><br/>\n              {{/is_chat}}\n            </span>\n          {{/primary}}\n\n          {{#secondary}}\n            <span class=\"flex-secondary-channel-text\">\n              <span class=\"flex-secondary-channel-also-text\">{{#translate}}js.modules.support.you_can_also{{/translate}}</span>\n              {{#is_chat}}\n                <span class=\"secondary-flex-{{channel}}-channel secondary-flex-channel flex-{{channel}}-link\">\n                  <span class=\"secondary-chat-link flex-chat-link\" id=\"live-chat-link-container\" data-bhw=\"flex-secondary-chat-link\"></span>\n                  <span class=\"flex-chat-team\">{{#translate}}js.modules.support.with_our_team{{/translate}} </span>\n                </span>\n              {{/is_chat}}\n              {{^is_chat}}\n                <a class=\"secondary-flex-{{channel}}-channel flex-{{channel}}-link\" data-bhw=\"flex-secondary-{{channel}}-link\">{{channel_text}}</a>\n              {{/is_chat}}\n            </span>\n          {{/secondary}}\n          {{#tertiary}}\n            <span class=\"flex-tertiary-channel-text\">\n              <span class=\"flex-channel-or-text tertiary-flex-channel\">{{#translate}}js.modules.support.or{{/translate}}</span>\n              {{#is_chat}}\n                <span class=\"tertiary-flex-{{channel}}-channel flex-{{channel}}-link\">\n                  <span class=\"tertiary-chat-link flex-chat-link\" id=\"live-chat-link-container\" data-bhw=\"flex-tertiary-chat-link\"></span>\n                  <span class=\"flex-chat-team\">{{#translate}}js.modules.support.with_our_team{{/translate}} </span><br/>\n                </span>\n              {{/is_chat}}\n              {{^is_chat}}\n                <a class=\"tertiary-flex-{{channel}}-channel flex-{{channel}}-link\" data-bhw=\"flex-tertiary-{{channel}}-link\">{{channel_text}}</a>\n              {{/is_chat}}\n            </span>\n          {{/tertiary}}  \n        {{/contact_channels}}    \n      </div>\n\n    </div>\n\n  {{#renderLayout}}\n    </div>\n  {{/renderLayout}}  \n{{/isVertical}}\n", Hogan);
},{"hogan.js":248}],244:[function(require,module,exports){
var Hogan = require('hogan.js');
module.exports = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<div class=\"help-wizard-content\">");t.b("\n" + i);t.b("  <div class=\"steps-container\"> </div>");t.b("\n" + i);t.b("    <h4 class='optimized-contact-channels-v2-header'>");if(t.s(t.f("translate",c,p,1),c,p,0,140,174,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.contact_options");});c.pop();}t.b("</h4>");t.b("\n" + i);t.b("    <div class=\"twelve columns optimized-contact-channels-v2\">");t.b("\n" + i);t.b("      <span class='subheader-header'> <p>");if(t.s(t.f("issueMsg",c,p,1),c,p,0,311,323,"{{ }}")){t.rs(c,p,function(c,p,t){t.b(t.v(t.f("issueMsg",c,p,0)));});c.pop();}t.b("</p> <p>");if(t.s(t.f("orderMsg",c,p,1),c,p,0,357,369,"{{ }}")){t.rs(c,p,function(c,p,t){t.b(t.v(t.f("orderMsg",c,p,0)));});c.pop();}t.b("</p></span>");t.b("\n" + i);t.b("      <div class=\"recommended\">");t.b("\n" + i);t.b("        <p>");if(t.s(t.f("translate",c,p,1),c,p,0,451,481,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.recommended");});c.pop();}t.b("</p>");t.b("\n" + i);t.b("      </div>");t.b("\n" + i);if(t.s(t.f("isLiveChatEnabled",c,p,1),c,p,0,541,774,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("        <div class=\"columns optimized-live-chat-container hide text-center\">");t.b("\n" + i);t.b("          <div class=\"live-chat-container optimized-contact-channel\" data-bhw=\"optimized-chat-btn-v2\" id=\"live-chat-container\"></div>");t.b("\n" + i);t.b("        </div>");t.b("\n" + i);});c.pop();}t.b("\n" + i);if(!t.s(t.f("isPhonePreferredChannel",c,p,1),c,p,1,0,0,"")){t.b("        <div class=\"columns optimized-contact-channel-v2-container optimized-email-us\">");t.b("\n" + i);t.b("          <div class='text-center'>");t.b("\n" + i);t.b("            <div class=\"icon-email optimized-icon-email optimized-contact-channel-v2-icons\"> </div>");t.b("\n" + i);t.b("            <div data-bhw=\"optimized-email-btn-v2\" class=\"contact-channel-msg\">");t.b("\n" + i);t.b("              <p> ");if(t.s(t.f("translate",c,p,1),c,p,0,1169,1201,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.email_groupon");});c.pop();}t.b("</p>");t.b("\n" + i);t.b("              <p> ");if(t.s(t.f("translate",c,p,1),c,p,0,1252,1288,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.give_your_contact");});c.pop();}t.b("</p>");t.b("\n" + i);t.b("              <p> ");if(t.s(t.f("translate",c,p,1),c,p,0,1339,1371,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.info_get_back");});c.pop();}t.b("</p>");t.b("\n" + i);t.b("              <p> ");if(t.s(t.f("translate",c,p,1),c,p,0,1422,1453,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.you_in_hours");});c.pop();}t.b("</p>");t.b("\n" + i);t.b("            </div>");t.b("\n" + i);t.b("          </div>");t.b("\n" + i);t.b("        </div>");t.b("\n" + i);};t.b("        <div class=\"columns optimized-contact-channel-v2-container optimized-phone-btn\">");t.b("\n" + i);t.b("          <div class='text-center'>");t.b("\n" + i);t.b("            <div class='icon-phone optimized-icon-phone optimized-contact-channel-v2-icons'></div>");t.b("\n" + i);t.b("            <div data-bhw=\"optimized-phone-button-v2\" class=\"contact-channel-msg\">");t.b("\n" + i);t.b("              <p>");if(t.s(t.f("translate",c,p,1),c,p,0,1896,1930,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.talk_to_groupon");});c.pop();}t.b("</p>");t.b("\n" + i);t.b("              <p>");if(t.s(t.f("translate",c,p,1),c,p,0,1980,2027,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.urgent_issue_talk_to_groupon");});c.pop();}t.b("</p>");t.b("\n" + i);t.b("              <p>");if(t.s(t.f("translate",c,p,1),c,p,0,2077,2111,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.talk_time_table");});c.pop();}t.b("</p>");t.b("\n" + i);t.b("            </div>");t.b("\n" + i);t.b("          </div>");t.b("\n" + i);t.b("        </div>");t.b("\n" + i);if(t.s(t.f("isPhonePreferredChannel",c,p,1),c,p,0,2215,2912,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("        <div class=\"columns optimized-contact-channel-v2-container optimized-email-us\">");t.b("\n" + i);t.b("          <div class='text-center'>");t.b("\n" + i);t.b("            <div class=\"icon-email optimized-icon-email optimized-contact-channel-v2-icons\"> </div>");t.b("\n" + i);t.b("            <div data-bhw=\"optimized-email-btn-v2\" class=\"contact-channel-msg\">");t.b("\n" + i);t.b("              <p> ");if(t.s(t.f("translate",c,p,1),c,p,0,2552,2584,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.email_groupon");});c.pop();}t.b("</p>");t.b("\n" + i);t.b("              <p> ");if(t.s(t.f("translate",c,p,1),c,p,0,2635,2671,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.give_your_contact");});c.pop();}t.b("</p>");t.b("\n" + i);t.b("              <p> ");if(t.s(t.f("translate",c,p,1),c,p,0,2722,2754,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.info_get_back");});c.pop();}t.b("</p>");t.b("\n" + i);t.b("              <p> ");if(t.s(t.f("translate",c,p,1),c,p,0,2805,2836,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.you_in_hours");});c.pop();}t.b("</p>");t.b("\n" + i);t.b("            </div>");t.b("\n" + i);t.b("          </div>");t.b("\n" + i);t.b("        </div>");t.b("\n" + i);});c.pop();}t.b("    </div>");t.b("\n" + i);t.b("</div>");return t.fl(); },partials: {}, subs: {  }}, "<div class=\"help-wizard-content\">\n  <div class=\"steps-container\"> </div>\n    <h4 class='optimized-contact-channels-v2-header'>{{#translate}}js.modules.support.contact_options{{/translate}}</h4>\n    <div class=\"twelve columns optimized-contact-channels-v2\">\n      <span class='subheader-header'> <p>{{#issueMsg}}{{issueMsg}}{{/issueMsg}}</p> <p>{{#orderMsg}}{{orderMsg}}{{/orderMsg}}</p></span>\n      <div class=\"recommended\">\n        <p>{{#translate}}js.modules.support.recommended{{/translate}}</p>\n      </div>\n      {{#isLiveChatEnabled}}\n        <div class=\"columns optimized-live-chat-container hide text-center\">\n          <div class=\"live-chat-container optimized-contact-channel\" data-bhw=\"optimized-chat-btn-v2\" id=\"live-chat-container\"></div>\n        </div>\n      {{/isLiveChatEnabled}}\n\n      {{^isPhonePreferredChannel}}\n        <div class=\"columns optimized-contact-channel-v2-container optimized-email-us\">\n          <div class='text-center'>\n            <div class=\"icon-email optimized-icon-email optimized-contact-channel-v2-icons\"> </div>\n            <div data-bhw=\"optimized-email-btn-v2\" class=\"contact-channel-msg\">\n              <p> {{#translate}}js.modules.support.email_groupon{{/translate}}</p>\n              <p> {{#translate}}js.modules.support.give_your_contact{{/translate}}</p>\n              <p> {{#translate}}js.modules.support.info_get_back{{/translate}}</p>\n              <p> {{#translate}}js.modules.support.you_in_hours{{/translate}}</p>\n            </div>\n          </div>\n        </div>\n      {{/isPhonePreferredChannel}}\n        <div class=\"columns optimized-contact-channel-v2-container optimized-phone-btn\">\n          <div class='text-center'>\n            <div class='icon-phone optimized-icon-phone optimized-contact-channel-v2-icons'></div>\n            <div data-bhw=\"optimized-phone-button-v2\" class=\"contact-channel-msg\">\n              <p>{{#translate}}js.modules.support.talk_to_groupon{{/translate}}</p>\n              <p>{{#translate}}js.modules.support.urgent_issue_talk_to_groupon{{/translate}}</p>\n              <p>{{#translate}}js.modules.support.talk_time_table{{/translate}}</p>\n            </div>\n          </div>\n        </div>\n      {{#isPhonePreferredChannel}}\n        <div class=\"columns optimized-contact-channel-v2-container optimized-email-us\">\n          <div class='text-center'>\n            <div class=\"icon-email optimized-icon-email optimized-contact-channel-v2-icons\"> </div>\n            <div data-bhw=\"optimized-email-btn-v2\" class=\"contact-channel-msg\">\n              <p> {{#translate}}js.modules.support.email_groupon{{/translate}}</p>\n              <p> {{#translate}}js.modules.support.give_your_contact{{/translate}}</p>\n              <p> {{#translate}}js.modules.support.info_get_back{{/translate}}</p>\n              <p> {{#translate}}js.modules.support.you_in_hours{{/translate}}</p>\n            </div>\n          </div>\n        </div>\n      {{/isPhonePreferredChannel}}\n    </div>\n</div>", Hogan);
},{"hogan.js":248}],245:[function(require,module,exports){
(function (global){
//     Backbone.js 1.1.2

//     (c) 2010-2014 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
//     Backbone may be freely distributed under the MIT license.
//     For all details and documentation:
//     http://backbonejs.org

(function(root, factory) {

  // Set up Backbone appropriately for the environment. Start with AMD.
  if (typeof define === 'function' && define.amd) {
    define(['underscore', 'jquery', 'exports'], function(_, $, exports) {
      // Export global even in AMD case in case this script is loaded with
      // others that may still expect a global Backbone.
      root.Backbone = factory(root, exports, _, $);
    });

  // Next for Node.js or CommonJS. jQuery may not be needed as a module.
  } else if (typeof exports !== 'undefined') {
    var _ = (typeof window !== "undefined" ? window['_'] : typeof global !== "undefined" ? global['_'] : null);
    factory(root, exports, _);

  // Finally, as a browser global.
  } else {
    root.Backbone = factory(root, {}, root._, (root.jQuery || root.Zepto || root.ender || root.$));
  }

}(this, function(root, Backbone, _, $) {

  // Initial Setup
  // -------------

  // Save the previous value of the `Backbone` variable, so that it can be
  // restored later on, if `noConflict` is used.
  var previousBackbone = root.Backbone;

  // Create local references to array methods we'll want to use later.
  var array = [];
  var push = array.push;
  var slice = array.slice;
  var splice = array.splice;

  // Current version of the library. Keep in sync with `package.json`.
  Backbone.VERSION = '1.1.2';

  // For Backbone's purposes, jQuery, Zepto, Ender, or My Library (kidding) owns
  // the `$` variable.
  Backbone.$ = $;

  // Runs Backbone.js in *noConflict* mode, returning the `Backbone` variable
  // to its previous owner. Returns a reference to this Backbone object.
  Backbone.noConflict = function() {
    root.Backbone = previousBackbone;
    return this;
  };

  // Turn on `emulateHTTP` to support legacy HTTP servers. Setting this option
  // will fake `"PATCH"`, `"PUT"` and `"DELETE"` requests via the `_method` parameter and
  // set a `X-Http-Method-Override` header.
  Backbone.emulateHTTP = false;

  // Turn on `emulateJSON` to support legacy servers that can't deal with direct
  // `application/json` requests ... will encode the body as
  // `application/x-www-form-urlencoded` instead and will send the model in a
  // form param named `model`.
  Backbone.emulateJSON = false;

  // Backbone.Events
  // ---------------

  // A module that can be mixed in to *any object* in order to provide it with
  // custom events. You may bind with `on` or remove with `off` callback
  // functions to an event; `trigger`-ing an event fires all callbacks in
  // succession.
  //
  //     var object = {};
  //     _.extend(object, Backbone.Events);
  //     object.on('expand', function(){ alert('expanded'); });
  //     object.trigger('expand');
  //
  var Events = Backbone.Events = {

    // Bind an event to a `callback` function. Passing `"all"` will bind
    // the callback to all events fired.
    on: function(name, callback, context) {
      if (!eventsApi(this, 'on', name, [callback, context]) || !callback) return this;
      this._events || (this._events = {});
      var events = this._events[name] || (this._events[name] = []);
      events.push({callback: callback, context: context, ctx: context || this});
      return this;
    },

    // Bind an event to only be triggered a single time. After the first time
    // the callback is invoked, it will be removed.
    once: function(name, callback, context) {
      if (!eventsApi(this, 'once', name, [callback, context]) || !callback) return this;
      var self = this;
      var once = _.once(function() {
        self.off(name, once);
        callback.apply(this, arguments);
      });
      once._callback = callback;
      return this.on(name, once, context);
    },

    // Remove one or many callbacks. If `context` is null, removes all
    // callbacks with that function. If `callback` is null, removes all
    // callbacks for the event. If `name` is null, removes all bound
    // callbacks for all events.
    off: function(name, callback, context) {
      var retain, ev, events, names, i, l, j, k;
      if (!this._events || !eventsApi(this, 'off', name, [callback, context])) return this;
      if (!name && !callback && !context) {
        this._events = void 0;
        return this;
      }
      names = name ? [name] : _.keys(this._events);
      for (i = 0, l = names.length; i < l; i++) {
        name = names[i];
        if (events = this._events[name]) {
          this._events[name] = retain = [];
          if (callback || context) {
            for (j = 0, k = events.length; j < k; j++) {
              ev = events[j];
              if ((callback && callback !== ev.callback && callback !== ev.callback._callback) ||
                  (context && context !== ev.context)) {
                retain.push(ev);
              }
            }
          }
          if (!retain.length) delete this._events[name];
        }
      }

      return this;
    },

    // Trigger one or many events, firing all bound callbacks. Callbacks are
    // passed the same arguments as `trigger` is, apart from the event name
    // (unless you're listening on `"all"`, which will cause your callback to
    // receive the true name of the event as the first argument).
    trigger: function(name) {
      if (!this._events) return this;
      var args = slice.call(arguments, 1);
      if (!eventsApi(this, 'trigger', name, args)) return this;
      var events = this._events[name];
      var allEvents = this._events.all;
      if (events) triggerEvents(events, args);
      if (allEvents) triggerEvents(allEvents, arguments);
      return this;
    },

    // Tell this object to stop listening to either specific events ... or
    // to every object it's currently listening to.
    stopListening: function(obj, name, callback) {
      var listeningTo = this._listeningTo;
      if (!listeningTo) return this;
      var remove = !name && !callback;
      if (!callback && typeof name === 'object') callback = this;
      if (obj) (listeningTo = {})[obj._listenId] = obj;
      for (var id in listeningTo) {
        obj = listeningTo[id];
        obj.off(name, callback, this);
        if (remove || _.isEmpty(obj._events)) delete this._listeningTo[id];
      }
      return this;
    }

  };

  // Regular expression used to split event strings.
  var eventSplitter = /\s+/;

  // Implement fancy features of the Events API such as multiple event
  // names `"change blur"` and jQuery-style event maps `{change: action}`
  // in terms of the existing API.
  var eventsApi = function(obj, action, name, rest) {
    if (!name) return true;

    // Handle event maps.
    if (typeof name === 'object') {
      for (var key in name) {
        obj[action].apply(obj, [key, name[key]].concat(rest));
      }
      return false;
    }

    // Handle space separated event names.
    if (eventSplitter.test(name)) {
      var names = name.split(eventSplitter);
      for (var i = 0, l = names.length; i < l; i++) {
        obj[action].apply(obj, [names[i]].concat(rest));
      }
      return false;
    }

    return true;
  };

  // A difficult-to-believe, but optimized internal dispatch function for
  // triggering events. Tries to keep the usual cases speedy (most internal
  // Backbone events have 3 arguments).
  var triggerEvents = function(events, args) {
    var ev, i = -1, l = events.length, a1 = args[0], a2 = args[1], a3 = args[2];
    switch (args.length) {
      case 0: while (++i < l) (ev = events[i]).callback.call(ev.ctx); return;
      case 1: while (++i < l) (ev = events[i]).callback.call(ev.ctx, a1); return;
      case 2: while (++i < l) (ev = events[i]).callback.call(ev.ctx, a1, a2); return;
      case 3: while (++i < l) (ev = events[i]).callback.call(ev.ctx, a1, a2, a3); return;
      default: while (++i < l) (ev = events[i]).callback.apply(ev.ctx, args); return;
    }
  };

  var listenMethods = {listenTo: 'on', listenToOnce: 'once'};

  // Inversion-of-control versions of `on` and `once`. Tell *this* object to
  // listen to an event in another object ... keeping track of what it's
  // listening to.
  _.each(listenMethods, function(implementation, method) {
    Events[method] = function(obj, name, callback) {
      var listeningTo = this._listeningTo || (this._listeningTo = {});
      var id = obj._listenId || (obj._listenId = _.uniqueId('l'));
      listeningTo[id] = obj;
      if (!callback && typeof name === 'object') callback = this;
      obj[implementation](name, callback, this);
      return this;
    };
  });

  // Aliases for backwards compatibility.
  Events.bind   = Events.on;
  Events.unbind = Events.off;

  // Allow the `Backbone` object to serve as a global event bus, for folks who
  // want global "pubsub" in a convenient place.
  _.extend(Backbone, Events);

  // Backbone.Model
  // --------------

  // Backbone **Models** are the basic data object in the framework --
  // frequently representing a row in a table in a database on your server.
  // A discrete chunk of data and a bunch of useful, related methods for
  // performing computations and transformations on that data.

  // Create a new model with the specified attributes. A client id (`cid`)
  // is automatically generated and assigned for you.
  var Model = Backbone.Model = function(attributes, options) {
    var attrs = attributes || {};
    options || (options = {});
    this.cid = _.uniqueId('c');
    this.attributes = {};
    if (options.collection) this.collection = options.collection;
    if (options.parse) attrs = this.parse(attrs, options) || {};
    attrs = _.defaults({}, attrs, _.result(this, 'defaults'));
    this.set(attrs, options);
    this.changed = {};
    this.initialize.apply(this, arguments);
  };

  // Attach all inheritable methods to the Model prototype.
  _.extend(Model.prototype, Events, {

    // A hash of attributes whose current and previous value differ.
    changed: null,

    // The value returned during the last failed validation.
    validationError: null,

    // The default name for the JSON `id` attribute is `"id"`. MongoDB and
    // CouchDB users may want to set this to `"_id"`.
    idAttribute: 'id',

    // Initialize is an empty function by default. Override it with your own
    // initialization logic.
    initialize: function(){},

    // Return a copy of the model's `attributes` object.
    toJSON: function(options) {
      return _.clone(this.attributes);
    },

    // Proxy `Backbone.sync` by default -- but override this if you need
    // custom syncing semantics for *this* particular model.
    sync: function() {
      return Backbone.sync.apply(this, arguments);
    },

    // Get the value of an attribute.
    get: function(attr) {
      return this.attributes[attr];
    },

    // Get the HTML-escaped value of an attribute.
    escape: function(attr) {
      return _.escape(this.get(attr));
    },

    // Returns `true` if the attribute contains a value that is not null
    // or undefined.
    has: function(attr) {
      return this.get(attr) != null;
    },

    // Set a hash of model attributes on the object, firing `"change"`. This is
    // the core primitive operation of a model, updating the data and notifying
    // anyone who needs to know about the change in state. The heart of the beast.
    set: function(key, val, options) {
      var attr, attrs, unset, changes, silent, changing, prev, current;
      if (key == null) return this;

      // Handle both `"key", value` and `{key: value}` -style arguments.
      if (typeof key === 'object') {
        attrs = key;
        options = val;
      } else {
        (attrs = {})[key] = val;
      }

      options || (options = {});

      // Run validation.
      if (!this._validate(attrs, options)) return false;

      // Extract attributes and options.
      unset           = options.unset;
      silent          = options.silent;
      changes         = [];
      changing        = this._changing;
      this._changing  = true;

      if (!changing) {
        this._previousAttributes = _.clone(this.attributes);
        this.changed = {};
      }
      current = this.attributes, prev = this._previousAttributes;

      // Check for changes of `id`.
      if (this.idAttribute in attrs) this.id = attrs[this.idAttribute];

      // For each `set` attribute, update or delete the current value.
      for (attr in attrs) {
        val = attrs[attr];
        if (!_.isEqual(current[attr], val)) changes.push(attr);
        if (!_.isEqual(prev[attr], val)) {
          this.changed[attr] = val;
        } else {
          delete this.changed[attr];
        }
        unset ? delete current[attr] : current[attr] = val;
      }

      // Trigger all relevant attribute changes.
      if (!silent) {
        if (changes.length) this._pending = options;
        for (var i = 0, l = changes.length; i < l; i++) {
          this.trigger('change:' + changes[i], this, current[changes[i]], options);
        }
      }

      // You might be wondering why there's a `while` loop here. Changes can
      // be recursively nested within `"change"` events.
      if (changing) return this;
      if (!silent) {
        while (this._pending) {
          options = this._pending;
          this._pending = false;
          this.trigger('change', this, options);
        }
      }
      this._pending = false;
      this._changing = false;
      return this;
    },

    // Remove an attribute from the model, firing `"change"`. `unset` is a noop
    // if the attribute doesn't exist.
    unset: function(attr, options) {
      return this.set(attr, void 0, _.extend({}, options, {unset: true}));
    },

    // Clear all attributes on the model, firing `"change"`.
    clear: function(options) {
      var attrs = {};
      for (var key in this.attributes) attrs[key] = void 0;
      return this.set(attrs, _.extend({}, options, {unset: true}));
    },

    // Determine if the model has changed since the last `"change"` event.
    // If you specify an attribute name, determine if that attribute has changed.
    hasChanged: function(attr) {
      if (attr == null) return !_.isEmpty(this.changed);
      return _.has(this.changed, attr);
    },

    // Return an object containing all the attributes that have changed, or
    // false if there are no changed attributes. Useful for determining what
    // parts of a view need to be updated and/or what attributes need to be
    // persisted to the server. Unset attributes will be set to undefined.
    // You can also pass an attributes object to diff against the model,
    // determining if there *would be* a change.
    changedAttributes: function(diff) {
      if (!diff) return this.hasChanged() ? _.clone(this.changed) : false;
      var val, changed = false;
      var old = this._changing ? this._previousAttributes : this.attributes;
      for (var attr in diff) {
        if (_.isEqual(old[attr], (val = diff[attr]))) continue;
        (changed || (changed = {}))[attr] = val;
      }
      return changed;
    },

    // Get the previous value of an attribute, recorded at the time the last
    // `"change"` event was fired.
    previous: function(attr) {
      if (attr == null || !this._previousAttributes) return null;
      return this._previousAttributes[attr];
    },

    // Get all of the attributes of the model at the time of the previous
    // `"change"` event.
    previousAttributes: function() {
      return _.clone(this._previousAttributes);
    },

    // Fetch the model from the server. If the server's representation of the
    // model differs from its current attributes, they will be overridden,
    // triggering a `"change"` event.
    fetch: function(options) {
      options = options ? _.clone(options) : {};
      if (options.parse === void 0) options.parse = true;
      var model = this;
      var success = options.success;
      options.success = function(resp) {
        if (!model.set(model.parse(resp, options), options)) return false;
        if (success) success(model, resp, options);
        model.trigger('sync', model, resp, options);
      };
      wrapError(this, options);
      return this.sync('read', this, options);
    },

    // Set a hash of model attributes, and sync the model to the server.
    // If the server returns an attributes hash that differs, the model's
    // state will be `set` again.
    save: function(key, val, options) {
      var attrs, method, xhr, attributes = this.attributes;

      // Handle both `"key", value` and `{key: value}` -style arguments.
      if (key == null || typeof key === 'object') {
        attrs = key;
        options = val;
      } else {
        (attrs = {})[key] = val;
      }

      options = _.extend({validate: true}, options);

      // If we're not waiting and attributes exist, save acts as
      // `set(attr).save(null, opts)` with validation. Otherwise, check if
      // the model will be valid when the attributes, if any, are set.
      if (attrs && !options.wait) {
        if (!this.set(attrs, options)) return false;
      } else {
        if (!this._validate(attrs, options)) return false;
      }

      // Set temporary attributes if `{wait: true}`.
      if (attrs && options.wait) {
        this.attributes = _.extend({}, attributes, attrs);
      }

      // After a successful server-side save, the client is (optionally)
      // updated with the server-side state.
      if (options.parse === void 0) options.parse = true;
      var model = this;
      var success = options.success;
      options.success = function(resp) {
        // Ensure attributes are restored during synchronous saves.
        model.attributes = attributes;
        var serverAttrs = model.parse(resp, options);
        if (options.wait) serverAttrs = _.extend(attrs || {}, serverAttrs);
        if (_.isObject(serverAttrs) && !model.set(serverAttrs, options)) {
          return false;
        }
        if (success) success(model, resp, options);
        model.trigger('sync', model, resp, options);
      };
      wrapError(this, options);

      method = this.isNew() ? 'create' : (options.patch ? 'patch' : 'update');
      if (method === 'patch') options.attrs = attrs;
      xhr = this.sync(method, this, options);

      // Restore attributes.
      if (attrs && options.wait) this.attributes = attributes;

      return xhr;
    },

    // Destroy this model on the server if it was already persisted.
    // Optimistically removes the model from its collection, if it has one.
    // If `wait: true` is passed, waits for the server to respond before removal.
    destroy: function(options) {
      options = options ? _.clone(options) : {};
      var model = this;
      var success = options.success;

      var destroy = function() {
        model.trigger('destroy', model, model.collection, options);
      };

      options.success = function(resp) {
        if (options.wait || model.isNew()) destroy();
        if (success) success(model, resp, options);
        if (!model.isNew()) model.trigger('sync', model, resp, options);
      };

      if (this.isNew()) {
        options.success();
        return false;
      }
      wrapError(this, options);

      var xhr = this.sync('delete', this, options);
      if (!options.wait) destroy();
      return xhr;
    },

    // Default URL for the model's representation on the server -- if you're
    // using Backbone's restful methods, override this to change the endpoint
    // that will be called.
    url: function() {
      var base =
        _.result(this, 'urlRoot') ||
        _.result(this.collection, 'url') ||
        urlError();
      if (this.isNew()) return base;
      return base.replace(/([^\/])$/, '$1/') + encodeURIComponent(this.id);
    },

    // **parse** converts a response into the hash of attributes to be `set` on
    // the model. The default implementation is just to pass the response along.
    parse: function(resp, options) {
      return resp;
    },

    // Create a new model with identical attributes to this one.
    clone: function() {
      return new this.constructor(this.attributes);
    },

    // A model is new if it has never been saved to the server, and lacks an id.
    isNew: function() {
      return !this.has(this.idAttribute);
    },

    // Check if the model is currently in a valid state.
    isValid: function(options) {
      return this._validate({}, _.extend(options || {}, { validate: true }));
    },

    // Run validation against the next complete set of model attributes,
    // returning `true` if all is well. Otherwise, fire an `"invalid"` event.
    _validate: function(attrs, options) {
      if (!options.validate || !this.validate) return true;
      attrs = _.extend({}, this.attributes, attrs);
      var error = this.validationError = this.validate(attrs, options) || null;
      if (!error) return true;
      this.trigger('invalid', this, error, _.extend(options, {validationError: error}));
      return false;
    }

  });

  // Underscore methods that we want to implement on the Model.
  var modelMethods = ['keys', 'values', 'pairs', 'invert', 'pick', 'omit'];

  // Mix in each Underscore method as a proxy to `Model#attributes`.
  _.each(modelMethods, function(method) {
    Model.prototype[method] = function() {
      var args = slice.call(arguments);
      args.unshift(this.attributes);
      return _[method].apply(_, args);
    };
  });

  // Backbone.Collection
  // -------------------

  // If models tend to represent a single row of data, a Backbone Collection is
  // more analagous to a table full of data ... or a small slice or page of that
  // table, or a collection of rows that belong together for a particular reason
  // -- all of the messages in this particular folder, all of the documents
  // belonging to this particular author, and so on. Collections maintain
  // indexes of their models, both in order, and for lookup by `id`.

  // Create a new **Collection**, perhaps to contain a specific type of `model`.
  // If a `comparator` is specified, the Collection will maintain
  // its models in sort order, as they're added and removed.
  var Collection = Backbone.Collection = function(models, options) {
    options || (options = {});
    if (options.model) this.model = options.model;
    if (options.comparator !== void 0) this.comparator = options.comparator;
    this._reset();
    this.initialize.apply(this, arguments);
    if (models) this.reset(models, _.extend({silent: true}, options));
  };

  // Default options for `Collection#set`.
  var setOptions = {add: true, remove: true, merge: true};
  var addOptions = {add: true, remove: false};

  // Define the Collection's inheritable methods.
  _.extend(Collection.prototype, Events, {

    // The default model for a collection is just a **Backbone.Model**.
    // This should be overridden in most cases.
    model: Model,

    // Initialize is an empty function by default. Override it with your own
    // initialization logic.
    initialize: function(){},

    // The JSON representation of a Collection is an array of the
    // models' attributes.
    toJSON: function(options) {
      return this.map(function(model){ return model.toJSON(options); });
    },

    // Proxy `Backbone.sync` by default.
    sync: function() {
      return Backbone.sync.apply(this, arguments);
    },

    // Add a model, or list of models to the set.
    add: function(models, options) {
      return this.set(models, _.extend({merge: false}, options, addOptions));
    },

    // Remove a model, or a list of models from the set.
    remove: function(models, options) {
      var singular = !_.isArray(models);
      models = singular ? [models] : _.clone(models);
      options || (options = {});
      var i, l, index, model;
      for (i = 0, l = models.length; i < l; i++) {
        model = models[i] = this.get(models[i]);
        if (!model) continue;
        delete this._byId[model.id];
        delete this._byId[model.cid];
        index = this.indexOf(model);
        this.models.splice(index, 1);
        this.length--;
        if (!options.silent) {
          options.index = index;
          model.trigger('remove', model, this, options);
        }
        this._removeReference(model, options);
      }
      return singular ? models[0] : models;
    },

    // Update a collection by `set`-ing a new list of models, adding new ones,
    // removing models that are no longer present, and merging models that
    // already exist in the collection, as necessary. Similar to **Model#set**,
    // the core operation for updating the data contained by the collection.
    set: function(models, options) {
      options = _.defaults({}, options, setOptions);
      if (options.parse) models = this.parse(models, options);
      var singular = !_.isArray(models);
      models = singular ? (models ? [models] : []) : _.clone(models);
      var i, l, id, model, attrs, existing, sort;
      var at = options.at;
      var targetModel = this.model;
      var sortable = this.comparator && (at == null) && options.sort !== false;
      var sortAttr = _.isString(this.comparator) ? this.comparator : null;
      var toAdd = [], toRemove = [], modelMap = {};
      var add = options.add, merge = options.merge, remove = options.remove;
      var order = !sortable && add && remove ? [] : false;

      // Turn bare objects into model references, and prevent invalid models
      // from being added.
      for (i = 0, l = models.length; i < l; i++) {
        attrs = models[i] || {};
        if (attrs instanceof Model) {
          id = model = attrs;
        } else {
          id = attrs[targetModel.prototype.idAttribute || 'id'];
        }

        // If a duplicate is found, prevent it from being added and
        // optionally merge it into the existing model.
        if (existing = this.get(id)) {
          if (remove) modelMap[existing.cid] = true;
          if (merge) {
            attrs = attrs === model ? model.attributes : attrs;
            if (options.parse) attrs = existing.parse(attrs, options);
            existing.set(attrs, options);
            if (sortable && !sort && existing.hasChanged(sortAttr)) sort = true;
          }
          models[i] = existing;

        // If this is a new, valid model, push it to the `toAdd` list.
        } else if (add) {
          model = models[i] = this._prepareModel(attrs, options);
          if (!model) continue;
          toAdd.push(model);
          this._addReference(model, options);
        }

        // Do not add multiple models with the same `id`.
        model = existing || model;
        if (order && (model.isNew() || !modelMap[model.id])) order.push(model);
        modelMap[model.id] = true;
      }

      // Remove nonexistent models if appropriate.
      if (remove) {
        for (i = 0, l = this.length; i < l; ++i) {
          if (!modelMap[(model = this.models[i]).cid]) toRemove.push(model);
        }
        if (toRemove.length) this.remove(toRemove, options);
      }

      // See if sorting is needed, update `length` and splice in new models.
      if (toAdd.length || (order && order.length)) {
        if (sortable) sort = true;
        this.length += toAdd.length;
        if (at != null) {
          for (i = 0, l = toAdd.length; i < l; i++) {
            this.models.splice(at + i, 0, toAdd[i]);
          }
        } else {
          if (order) this.models.length = 0;
          var orderedModels = order || toAdd;
          for (i = 0, l = orderedModels.length; i < l; i++) {
            this.models.push(orderedModels[i]);
          }
        }
      }

      // Silently sort the collection if appropriate.
      if (sort) this.sort({silent: true});

      // Unless silenced, it's time to fire all appropriate add/sort events.
      if (!options.silent) {
        for (i = 0, l = toAdd.length; i < l; i++) {
          (model = toAdd[i]).trigger('add', model, this, options);
        }
        if (sort || (order && order.length)) this.trigger('sort', this, options);
      }

      // Return the added (or merged) model (or models).
      return singular ? models[0] : models;
    },

    // When you have more items than you want to add or remove individually,
    // you can reset the entire set with a new list of models, without firing
    // any granular `add` or `remove` events. Fires `reset` when finished.
    // Useful for bulk operations and optimizations.
    reset: function(models, options) {
      options || (options = {});
      for (var i = 0, l = this.models.length; i < l; i++) {
        this._removeReference(this.models[i], options);
      }
      options.previousModels = this.models;
      this._reset();
      models = this.add(models, _.extend({silent: true}, options));
      if (!options.silent) this.trigger('reset', this, options);
      return models;
    },

    // Add a model to the end of the collection.
    push: function(model, options) {
      return this.add(model, _.extend({at: this.length}, options));
    },

    // Remove a model from the end of the collection.
    pop: function(options) {
      var model = this.at(this.length - 1);
      this.remove(model, options);
      return model;
    },

    // Add a model to the beginning of the collection.
    unshift: function(model, options) {
      return this.add(model, _.extend({at: 0}, options));
    },

    // Remove a model from the beginning of the collection.
    shift: function(options) {
      var model = this.at(0);
      this.remove(model, options);
      return model;
    },

    // Slice out a sub-array of models from the collection.
    slice: function() {
      return slice.apply(this.models, arguments);
    },

    // Get a model from the set by id.
    get: function(obj) {
      if (obj == null) return void 0;
      return this._byId[obj] || this._byId[obj.id] || this._byId[obj.cid];
    },

    // Get the model at the given index.
    at: function(index) {
      return this.models[index];
    },

    // Return models with matching attributes. Useful for simple cases of
    // `filter`.
    where: function(attrs, first) {
      if (_.isEmpty(attrs)) return first ? void 0 : [];
      return this[first ? 'find' : 'filter'](function(model) {
        for (var key in attrs) {
          if (attrs[key] !== model.get(key)) return false;
        }
        return true;
      });
    },

    // Return the first model with matching attributes. Useful for simple cases
    // of `find`.
    findWhere: function(attrs) {
      return this.where(attrs, true);
    },

    // Force the collection to re-sort itself. You don't need to call this under
    // normal circumstances, as the set will maintain sort order as each item
    // is added.
    sort: function(options) {
      if (!this.comparator) throw new Error('Cannot sort a set without a comparator');
      options || (options = {});

      // Run sort based on type of `comparator`.
      if (_.isString(this.comparator) || this.comparator.length === 1) {
        this.models = this.sortBy(this.comparator, this);
      } else {
        this.models.sort(_.bind(this.comparator, this));
      }

      if (!options.silent) this.trigger('sort', this, options);
      return this;
    },

    // Pluck an attribute from each model in the collection.
    pluck: function(attr) {
      return _.invoke(this.models, 'get', attr);
    },

    // Fetch the default set of models for this collection, resetting the
    // collection when they arrive. If `reset: true` is passed, the response
    // data will be passed through the `reset` method instead of `set`.
    fetch: function(options) {
      options = options ? _.clone(options) : {};
      if (options.parse === void 0) options.parse = true;
      var success = options.success;
      var collection = this;
      options.success = function(resp) {
        var method = options.reset ? 'reset' : 'set';
        collection[method](resp, options);
        if (success) success(collection, resp, options);
        collection.trigger('sync', collection, resp, options);
      };
      wrapError(this, options);
      return this.sync('read', this, options);
    },

    // Create a new instance of a model in this collection. Add the model to the
    // collection immediately, unless `wait: true` is passed, in which case we
    // wait for the server to agree.
    create: function(model, options) {
      options = options ? _.clone(options) : {};
      if (!(model = this._prepareModel(model, options))) return false;
      if (!options.wait) this.add(model, options);
      var collection = this;
      var success = options.success;
      options.success = function(model, resp) {
        if (options.wait) collection.add(model, options);
        if (success) success(model, resp, options);
      };
      model.save(null, options);
      return model;
    },

    // **parse** converts a response into a list of models to be added to the
    // collection. The default implementation is just to pass it through.
    parse: function(resp, options) {
      return resp;
    },

    // Create a new collection with an identical list of models as this one.
    clone: function() {
      return new this.constructor(this.models);
    },

    // Private method to reset all internal state. Called when the collection
    // is first initialized or reset.
    _reset: function() {
      this.length = 0;
      this.models = [];
      this._byId  = {};
    },

    // Prepare a hash of attributes (or other model) to be added to this
    // collection.
    _prepareModel: function(attrs, options) {
      if (attrs instanceof Model) return attrs;
      options = options ? _.clone(options) : {};
      options.collection = this;
      var model = new this.model(attrs, options);
      if (!model.validationError) return model;
      this.trigger('invalid', this, model.validationError, options);
      return false;
    },

    // Internal method to create a model's ties to a collection.
    _addReference: function(model, options) {
      this._byId[model.cid] = model;
      if (model.id != null) this._byId[model.id] = model;
      if (!model.collection) model.collection = this;
      model.on('all', this._onModelEvent, this);
    },

    // Internal method to sever a model's ties to a collection.
    _removeReference: function(model, options) {
      if (this === model.collection) delete model.collection;
      model.off('all', this._onModelEvent, this);
    },

    // Internal method called every time a model in the set fires an event.
    // Sets need to update their indexes when models change ids. All other
    // events simply proxy through. "add" and "remove" events that originate
    // in other collections are ignored.
    _onModelEvent: function(event, model, collection, options) {
      if ((event === 'add' || event === 'remove') && collection !== this) return;
      if (event === 'destroy') this.remove(model, options);
      if (model && event === 'change:' + model.idAttribute) {
        delete this._byId[model.previous(model.idAttribute)];
        if (model.id != null) this._byId[model.id] = model;
      }
      this.trigger.apply(this, arguments);
    }

  });

  // Underscore methods that we want to implement on the Collection.
  // 90% of the core usefulness of Backbone Collections is actually implemented
  // right here:
  var methods = ['forEach', 'each', 'map', 'collect', 'reduce', 'foldl',
    'inject', 'reduceRight', 'foldr', 'find', 'detect', 'filter', 'select',
    'reject', 'every', 'all', 'some', 'any', 'include', 'contains', 'invoke',
    'max', 'min', 'toArray', 'size', 'first', 'head', 'take', 'initial', 'rest',
    'tail', 'drop', 'last', 'without', 'difference', 'indexOf', 'shuffle',
    'lastIndexOf', 'isEmpty', 'chain', 'sample'];

  // Mix in each Underscore method as a proxy to `Collection#models`.
  _.each(methods, function(method) {
    Collection.prototype[method] = function() {
      var args = slice.call(arguments);
      args.unshift(this.models);
      return _[method].apply(_, args);
    };
  });

  // Underscore methods that take a property name as an argument.
  var attributeMethods = ['groupBy', 'countBy', 'sortBy', 'indexBy'];

  // Use attributes instead of properties.
  _.each(attributeMethods, function(method) {
    Collection.prototype[method] = function(value, context) {
      var iterator = _.isFunction(value) ? value : function(model) {
        return model.get(value);
      };
      return _[method](this.models, iterator, context);
    };
  });

  // Backbone.View
  // -------------

  // Backbone Views are almost more convention than they are actual code. A View
  // is simply a JavaScript object that represents a logical chunk of UI in the
  // DOM. This might be a single item, an entire list, a sidebar or panel, or
  // even the surrounding frame which wraps your whole app. Defining a chunk of
  // UI as a **View** allows you to define your DOM events declaratively, without
  // having to worry about render order ... and makes it easy for the view to
  // react to specific changes in the state of your models.

  // Creating a Backbone.View creates its initial element outside of the DOM,
  // if an existing element is not provided...
  var View = Backbone.View = function(options) {
    this.cid = _.uniqueId('view');
    options || (options = {});
    _.extend(this, _.pick(options, viewOptions));
    this._ensureElement();
    this.initialize.apply(this, arguments);
    this.delegateEvents();
  };

  // Cached regex to split keys for `delegate`.
  var delegateEventSplitter = /^(\S+)\s*(.*)$/;

  // List of view options to be merged as properties.
  var viewOptions = ['model', 'collection', 'el', 'id', 'attributes', 'className', 'tagName', 'events'];

  // Set up all inheritable **Backbone.View** properties and methods.
  _.extend(View.prototype, Events, {

    // The default `tagName` of a View's element is `"div"`.
    tagName: 'div',

    // jQuery delegate for element lookup, scoped to DOM elements within the
    // current view. This should be preferred to global lookups where possible.
    $: function(selector) {
      return this.$el.find(selector);
    },

    // Initialize is an empty function by default. Override it with your own
    // initialization logic.
    initialize: function(){},

    // **render** is the core function that your view should override, in order
    // to populate its element (`this.el`), with the appropriate HTML. The
    // convention is for **render** to always return `this`.
    render: function() {
      return this;
    },

    // Remove this view by taking the element out of the DOM, and removing any
    // applicable Backbone.Events listeners.
    remove: function() {
      this.$el.remove();
      this.stopListening();
      return this;
    },

    // Change the view's element (`this.el` property), including event
    // re-delegation.
    setElement: function(element, delegate) {
      if (this.$el) this.undelegateEvents();
      this.$el = element instanceof Backbone.$ ? element : Backbone.$(element);
      this.el = this.$el[0];
      if (delegate !== false) this.delegateEvents();
      return this;
    },

    // Set callbacks, where `this.events` is a hash of
    //
    // *{"event selector": "callback"}*
    //
    //     {
    //       'mousedown .title':  'edit',
    //       'click .button':     'save',
    //       'click .open':       function(e) { ... }
    //     }
    //
    // pairs. Callbacks will be bound to the view, with `this` set properly.
    // Uses event delegation for efficiency.
    // Omitting the selector binds the event to `this.el`.
    // This only works for delegate-able events: not `focus`, `blur`, and
    // not `change`, `submit`, and `reset` in Internet Explorer.
    delegateEvents: function(events) {
      if (!(events || (events = _.result(this, 'events')))) return this;
      this.undelegateEvents();
      for (var key in events) {
        var method = events[key];
        if (!_.isFunction(method)) method = this[events[key]];
        if (!method) continue;

        var match = key.match(delegateEventSplitter);
        var eventName = match[1], selector = match[2];
        method = _.bind(method, this);
        eventName += '.delegateEvents' + this.cid;
        if (selector === '') {
          this.$el.on(eventName, method);
        } else {
          this.$el.on(eventName, selector, method);
        }
      }
      return this;
    },

    // Clears all callbacks previously bound to the view with `delegateEvents`.
    // You usually don't need to use this, but may wish to if you have multiple
    // Backbone views attached to the same DOM element.
    undelegateEvents: function() {
      this.$el.off('.delegateEvents' + this.cid);
      return this;
    },

    // Ensure that the View has a DOM element to render into.
    // If `this.el` is a string, pass it through `$()`, take the first
    // matching element, and re-assign it to `el`. Otherwise, create
    // an element from the `id`, `className` and `tagName` properties.
    _ensureElement: function() {
      if (!this.el) {
        var attrs = _.extend({}, _.result(this, 'attributes'));
        if (this.id) attrs.id = _.result(this, 'id');
        if (this.className) attrs['class'] = _.result(this, 'className');
        var $el = Backbone.$('<' + _.result(this, 'tagName') + '>').attr(attrs);
        this.setElement($el, false);
      } else {
        this.setElement(_.result(this, 'el'), false);
      }
    }

  });

  // Backbone.sync
  // -------------

  // Override this function to change the manner in which Backbone persists
  // models to the server. You will be passed the type of request, and the
  // model in question. By default, makes a RESTful Ajax request
  // to the model's `url()`. Some possible customizations could be:
  //
  // * Use `setTimeout` to batch rapid-fire updates into a single request.
  // * Send up the models as XML instead of JSON.
  // * Persist models via WebSockets instead of Ajax.
  //
  // Turn on `Backbone.emulateHTTP` in order to send `PUT` and `DELETE` requests
  // as `POST`, with a `_method` parameter containing the true HTTP method,
  // as well as all requests with the body as `application/x-www-form-urlencoded`
  // instead of `application/json` with the model in a param named `model`.
  // Useful when interfacing with server-side languages like **PHP** that make
  // it difficult to read the body of `PUT` requests.
  Backbone.sync = function(method, model, options) {
    var type = methodMap[method];

    // Default options, unless specified.
    _.defaults(options || (options = {}), {
      emulateHTTP: Backbone.emulateHTTP,
      emulateJSON: Backbone.emulateJSON
    });

    // Default JSON-request options.
    var params = {type: type, dataType: 'json'};

    // Ensure that we have a URL.
    if (!options.url) {
      params.url = _.result(model, 'url') || urlError();
    }

    // Ensure that we have the appropriate request data.
    if (options.data == null && model && (method === 'create' || method === 'update' || method === 'patch')) {
      params.contentType = 'application/json';
      params.data = JSON.stringify(options.attrs || model.toJSON(options));
    }

    // For older servers, emulate JSON by encoding the request into an HTML-form.
    if (options.emulateJSON) {
      params.contentType = 'application/x-www-form-urlencoded';
      params.data = params.data ? {model: params.data} : {};
    }

    // For older servers, emulate HTTP by mimicking the HTTP method with `_method`
    // And an `X-HTTP-Method-Override` header.
    if (options.emulateHTTP && (type === 'PUT' || type === 'DELETE' || type === 'PATCH')) {
      params.type = 'POST';
      if (options.emulateJSON) params.data._method = type;
      var beforeSend = options.beforeSend;
      options.beforeSend = function(xhr) {
        xhr.setRequestHeader('X-HTTP-Method-Override', type);
        if (beforeSend) return beforeSend.apply(this, arguments);
      };
    }

    // Don't process data on a non-GET request.
    if (params.type !== 'GET' && !options.emulateJSON) {
      params.processData = false;
    }

    // If we're sending a `PATCH` request, and we're in an old Internet Explorer
    // that still has ActiveX enabled by default, override jQuery to use that
    // for XHR instead. Remove this line when jQuery supports `PATCH` on IE8.
    if (params.type === 'PATCH' && noXhrPatch) {
      params.xhr = function() {
        return new ActiveXObject("Microsoft.XMLHTTP");
      };
    }

    // Make the request, allowing the user to override any Ajax options.
    var xhr = options.xhr = Backbone.ajax(_.extend(params, options));
    model.trigger('request', model, xhr, options);
    return xhr;
  };

  var noXhrPatch =
    typeof window !== 'undefined' && !!window.ActiveXObject &&
      !(window.XMLHttpRequest && (new XMLHttpRequest).dispatchEvent);

  // Map from CRUD to HTTP for our default `Backbone.sync` implementation.
  var methodMap = {
    'create': 'POST',
    'update': 'PUT',
    'patch':  'PATCH',
    'delete': 'DELETE',
    'read':   'GET'
  };

  // Set the default implementation of `Backbone.ajax` to proxy through to `$`.
  // Override this if you'd like to use a different library.
  Backbone.ajax = function() {
    return Backbone.$.ajax.apply(Backbone.$, arguments);
  };

  // Backbone.Router
  // ---------------

  // Routers map faux-URLs to actions, and fire events when routes are
  // matched. Creating a new one sets its `routes` hash, if not set statically.
  var Router = Backbone.Router = function(options) {
    options || (options = {});
    if (options.routes) this.routes = options.routes;
    this._bindRoutes();
    this.initialize.apply(this, arguments);
  };

  // Cached regular expressions for matching named param parts and splatted
  // parts of route strings.
  var optionalParam = /\((.*?)\)/g;
  var namedParam    = /(\(\?)?:\w+/g;
  var splatParam    = /\*\w+/g;
  var escapeRegExp  = /[\-{}\[\]+?.,\\\^$|#\s]/g;

  // Set up all inheritable **Backbone.Router** properties and methods.
  _.extend(Router.prototype, Events, {

    // Initialize is an empty function by default. Override it with your own
    // initialization logic.
    initialize: function(){},

    // Manually bind a single named route to a callback. For example:
    //
    //     this.route('search/:query/p:num', 'search', function(query, num) {
    //       ...
    //     });
    //
    route: function(route, name, callback) {
      if (!_.isRegExp(route)) route = this._routeToRegExp(route);
      if (_.isFunction(name)) {
        callback = name;
        name = '';
      }
      if (!callback) callback = this[name];
      var router = this;
      Backbone.history.route(route, function(fragment) {
        var args = router._extractParameters(route, fragment);
        router.execute(callback, args);
        router.trigger.apply(router, ['route:' + name].concat(args));
        router.trigger('route', name, args);
        Backbone.history.trigger('route', router, name, args);
      });
      return this;
    },

    // Execute a route handler with the provided parameters.  This is an
    // excellent place to do pre-route setup or post-route cleanup.
    execute: function(callback, args) {
      if (callback) callback.apply(this, args);
    },

    // Simple proxy to `Backbone.history` to save a fragment into the history.
    navigate: function(fragment, options) {
      Backbone.history.navigate(fragment, options);
      return this;
    },

    // Bind all defined routes to `Backbone.history`. We have to reverse the
    // order of the routes here to support behavior where the most general
    // routes can be defined at the bottom of the route map.
    _bindRoutes: function() {
      if (!this.routes) return;
      this.routes = _.result(this, 'routes');
      var route, routes = _.keys(this.routes);
      while ((route = routes.pop()) != null) {
        this.route(route, this.routes[route]);
      }
    },

    // Convert a route string into a regular expression, suitable for matching
    // against the current location hash.
    _routeToRegExp: function(route) {
      route = route.replace(escapeRegExp, '\\$&')
                   .replace(optionalParam, '(?:$1)?')
                   .replace(namedParam, function(match, optional) {
                     return optional ? match : '([^/?]+)';
                   })
                   .replace(splatParam, '([^?]*?)');
      return new RegExp('^' + route + '(?:\\?([\\s\\S]*))?$');
    },

    // Given a route, and a URL fragment that it matches, return the array of
    // extracted decoded parameters. Empty or unmatched parameters will be
    // treated as `null` to normalize cross-browser behavior.
    _extractParameters: function(route, fragment) {
      var params = route.exec(fragment).slice(1);
      return _.map(params, function(param, i) {
        // Don't decode the search params.
        if (i === params.length - 1) return param || null;
        return param ? decodeURIComponent(param) : null;
      });
    }

  });

  // Backbone.History
  // ----------------

  // Handles cross-browser history management, based on either
  // [pushState](http://diveintohtml5.info/history.html) and real URLs, or
  // [onhashchange](https://developer.mozilla.org/en-US/docs/DOM/window.onhashchange)
  // and URL fragments. If the browser supports neither (old IE, natch),
  // falls back to polling.
  var History = Backbone.History = function() {
    this.handlers = [];
    _.bindAll(this, 'checkUrl');

    // Ensure that `History` can be used outside of the browser.
    if (typeof window !== 'undefined') {
      this.location = window.location;
      this.history = window.history;
    }
  };

  // Cached regex for stripping a leading hash/slash and trailing space.
  var routeStripper = /^[#\/]|\s+$/g;

  // Cached regex for stripping leading and trailing slashes.
  var rootStripper = /^\/+|\/+$/g;

  // Cached regex for detecting MSIE.
  var isExplorer = /msie [\w.]+/;

  // Cached regex for removing a trailing slash.
  var trailingSlash = /\/$/;

  // Cached regex for stripping urls of hash.
  var pathStripper = /#.*$/;

  // Has the history handling already been started?
  History.started = false;

  // Set up all inheritable **Backbone.History** properties and methods.
  _.extend(History.prototype, Events, {

    // The default interval to poll for hash changes, if necessary, is
    // twenty times a second.
    interval: 50,

    // Are we at the app root?
    atRoot: function() {
      return this.location.pathname.replace(/[^\/]$/, '$&/') === this.root;
    },

    // Gets the true hash value. Cannot use location.hash directly due to bug
    // in Firefox where location.hash will always be decoded.
    getHash: function(window) {
      var match = (window || this).location.href.match(/#(.*)$/);
      return match ? match[1] : '';
    },

    // Get the cross-browser normalized URL fragment, either from the URL,
    // the hash, or the override.
    getFragment: function(fragment, forcePushState) {
      if (fragment == null) {
        if (this._hasPushState || !this._wantsHashChange || forcePushState) {
          fragment = decodeURI(this.location.pathname + this.location.search);
          var root = this.root.replace(trailingSlash, '');
          if (!fragment.indexOf(root)) fragment = fragment.slice(root.length);
        } else {
          fragment = this.getHash();
        }
      }
      return fragment.replace(routeStripper, '');
    },

    // Start the hash change handling, returning `true` if the current URL matches
    // an existing route, and `false` otherwise.
    start: function(options) {
      if (History.started) throw new Error("Backbone.history has already been started");
      History.started = true;

      // Figure out the initial configuration. Do we need an iframe?
      // Is pushState desired ... is it available?
      this.options          = _.extend({root: '/'}, this.options, options);
      this.root             = this.options.root;
      this._wantsHashChange = this.options.hashChange !== false;
      this._wantsPushState  = !!this.options.pushState;
      this._hasPushState    = !!(this.options.pushState && this.history && this.history.pushState);
      var fragment          = this.getFragment();
      var docMode           = document.documentMode;
      var oldIE             = (isExplorer.exec(navigator.userAgent.toLowerCase()) && (!docMode || docMode <= 7));

      // Normalize root to always include a leading and trailing slash.
      this.root = ('/' + this.root + '/').replace(rootStripper, '/');

      if (oldIE && this._wantsHashChange) {
        var frame = Backbone.$('<iframe src="javascript:0" tabindex="-1">');
        this.iframe = frame.hide().appendTo('body')[0].contentWindow;
        this.navigate(fragment);
      }

      // Depending on whether we're using pushState or hashes, and whether
      // 'onhashchange' is supported, determine how we check the URL state.
      if (this._hasPushState) {
        Backbone.$(window).on('popstate', this.checkUrl);
      } else if (this._wantsHashChange && ('onhashchange' in window) && !oldIE) {
        Backbone.$(window).on('hashchange', this.checkUrl);
      } else if (this._wantsHashChange) {
        this._checkUrlInterval = setInterval(this.checkUrl, this.interval);
      }

      // Determine if we need to change the base url, for a pushState link
      // opened by a non-pushState browser.
      this.fragment = fragment;
      var loc = this.location;

      // Transition from hashChange to pushState or vice versa if both are
      // requested.
      if (this._wantsHashChange && this._wantsPushState) {

        // If we've started off with a route from a `pushState`-enabled
        // browser, but we're currently in a browser that doesn't support it...
        if (!this._hasPushState && !this.atRoot()) {
          this.fragment = this.getFragment(null, true);
          this.location.replace(this.root + '#' + this.fragment);
          // Return immediately as browser will do redirect to new url
          return true;

        // Or if we've started out with a hash-based route, but we're currently
        // in a browser where it could be `pushState`-based instead...
        } else if (this._hasPushState && this.atRoot() && loc.hash) {
          this.fragment = this.getHash().replace(routeStripper, '');
          this.history.replaceState({}, document.title, this.root + this.fragment);
        }

      }

      if (!this.options.silent) return this.loadUrl();
    },

    // Disable Backbone.history, perhaps temporarily. Not useful in a real app,
    // but possibly useful for unit testing Routers.
    stop: function() {
      Backbone.$(window).off('popstate', this.checkUrl).off('hashchange', this.checkUrl);
      if (this._checkUrlInterval) clearInterval(this._checkUrlInterval);
      History.started = false;
    },

    // Add a route to be tested when the fragment changes. Routes added later
    // may override previous routes.
    route: function(route, callback) {
      this.handlers.unshift({route: route, callback: callback});
    },

    // Checks the current URL to see if it has changed, and if it has,
    // calls `loadUrl`, normalizing across the hidden iframe.
    checkUrl: function(e) {
      var current = this.getFragment();
      if (current === this.fragment && this.iframe) {
        current = this.getFragment(this.getHash(this.iframe));
      }
      if (current === this.fragment) return false;
      if (this.iframe) this.navigate(current);
      this.loadUrl();
    },

    // Attempt to load the current URL fragment. If a route succeeds with a
    // match, returns `true`. If no defined routes matches the fragment,
    // returns `false`.
    loadUrl: function(fragment) {
      fragment = this.fragment = this.getFragment(fragment);
      return _.any(this.handlers, function(handler) {
        if (handler.route.test(fragment)) {
          handler.callback(fragment);
          return true;
        }
      });
    },

    // Save a fragment into the hash history, or replace the URL state if the
    // 'replace' option is passed. You are responsible for properly URL-encoding
    // the fragment in advance.
    //
    // The options object can contain `trigger: true` if you wish to have the
    // route callback be fired (not usually desirable), or `replace: true`, if
    // you wish to modify the current URL without adding an entry to the history.
    navigate: function(fragment, options) {
      if (!History.started) return false;
      if (!options || options === true) options = {trigger: !!options};

      var url = this.root + (fragment = this.getFragment(fragment || ''));

      // Strip the hash for matching.
      fragment = fragment.replace(pathStripper, '');

      if (this.fragment === fragment) return;
      this.fragment = fragment;

      // Don't include a trailing slash on the root.
      if (fragment === '' && url !== '/') url = url.slice(0, -1);

      // If pushState is available, we use it to set the fragment as a real URL.
      if (this._hasPushState) {
        this.history[options.replace ? 'replaceState' : 'pushState']({}, document.title, url);

      // If hash changes haven't been explicitly disabled, update the hash
      // fragment to store history.
      } else if (this._wantsHashChange) {
        this._updateHash(this.location, fragment, options.replace);
        if (this.iframe && (fragment !== this.getFragment(this.getHash(this.iframe)))) {
          // Opening and closing the iframe tricks IE7 and earlier to push a
          // history entry on hash-tag change.  When replace is true, we don't
          // want this.
          if(!options.replace) this.iframe.document.open().close();
          this._updateHash(this.iframe.location, fragment, options.replace);
        }

      // If you've told us that you explicitly don't want fallback hashchange-
      // based history, then `navigate` becomes a page refresh.
      } else {
        return this.location.assign(url);
      }
      if (options.trigger) return this.loadUrl(fragment);
    },

    // Update the hash location, either replacing the current entry, or adding
    // a new one to the browser history.
    _updateHash: function(location, fragment, replace) {
      if (replace) {
        var href = location.href.replace(/(javascript:|#).*$/, '');
        location.replace(href + '#' + fragment);
      } else {
        // Some browsers require that `hash` contains a leading #.
        location.hash = '#' + fragment;
      }
    }

  });

  // Create the default Backbone.history.
  Backbone.history = new History;

  // Helpers
  // -------

  // Helper function to correctly set up the prototype chain, for subclasses.
  // Similar to `goog.inherits`, but uses a hash of prototype properties and
  // class properties to be extended.
  var extend = function(protoProps, staticProps) {
    var parent = this;
    var child;

    // The constructor function for the new subclass is either defined by you
    // (the "constructor" property in your `extend` definition), or defaulted
    // by us to simply call the parent's constructor.
    if (protoProps && _.has(protoProps, 'constructor')) {
      child = protoProps.constructor;
    } else {
      child = function(){ return parent.apply(this, arguments); };
    }

    // Add static properties to the constructor function, if supplied.
    _.extend(child, parent, staticProps);

    // Set the prototype chain to inherit from `parent`, without calling
    // `parent`'s constructor function.
    var Surrogate = function(){ this.constructor = child; };
    Surrogate.prototype = parent.prototype;
    child.prototype = new Surrogate;

    // Add prototype properties (instance properties) to the subclass,
    // if supplied.
    if (protoProps) _.extend(child.prototype, protoProps);

    // Set a convenience property in case the parent's prototype is needed
    // later.
    child.__super__ = parent.prototype;

    return child;
  };

  // Set up inheritance for the model, collection, router, view and history.
  Model.extend = Collection.extend = Router.extend = View.extend = History.extend = extend;

  // Throw an error when a URL is needed, and none is supplied.
  var urlError = function() {
    throw new Error('A "url" property or function must be specified');
  };

  // Wrap an optional error callback with a fallback error event.
  var wrapError = function(model, options) {
    var error = options.error;
    options.error = function(resp) {
      if (error) error(model, resp, options);
      model.trigger('error', model, resp, options);
    };
  };

  return Backbone;

}));

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{}],246:[function(require,module,exports){
// shim for using process in browser

var process = module.exports = {};

process.nextTick = (function () {
    var canSetImmediate = typeof window !== 'undefined'
    && window.setImmediate;
    var canMutationObserver = typeof window !== 'undefined'
    && window.MutationObserver;
    var canPost = typeof window !== 'undefined'
    && window.postMessage && window.addEventListener
    ;

    if (canSetImmediate) {
        return function (f) { return window.setImmediate(f) };
    }

    var queue = [];

    if (canMutationObserver) {
        var hiddenDiv = document.createElement("div");
        var observer = new MutationObserver(function () {
            var queueList = queue.slice();
            queue.length = 0;
            queueList.forEach(function (fn) {
                fn();
            });
        });

        observer.observe(hiddenDiv, { attributes: true });

        return function nextTick(fn) {
            if (!queue.length) {
                hiddenDiv.setAttribute('yes', 'no');
            }
            queue.push(fn);
        };
    }

    if (canPost) {
        window.addEventListener('message', function (ev) {
            var source = ev.source;
            if ((source === window || source === null) && ev.data === 'process-tick') {
                ev.stopPropagation();
                if (queue.length > 0) {
                    var fn = queue.shift();
                    fn();
                }
            }
        }, true);

        return function nextTick(fn) {
            queue.push(fn);
            window.postMessage('process-tick', '*');
        };
    }

    return function nextTick(fn) {
        setTimeout(fn, 0);
    };
})();

process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

// TODO(shtylman)
process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};

},{}],247:[function(require,module,exports){
/*
 *  Copyright 2011 Twitter, Inc.
 *  Licensed under the Apache License, Version 2.0 (the "License");
 *  you may not use this file except in compliance with the License.
 *  You may obtain a copy of the License at
 *
 *  http://www.apache.org/licenses/LICENSE-2.0
 *
 *  Unless required by applicable law or agreed to in writing, software
 *  distributed under the License is distributed on an "AS IS" BASIS,
 *  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *  See the License for the specific language governing permissions and
 *  limitations under the License.
 */

(function (Hogan) {
  // Setup regex  assignments
  // remove whitespace according to Mustache spec
  var rIsWhitespace = /\S/,
      rQuot = /\"/g,
      rNewline =  /\n/g,
      rCr = /\r/g,
      rSlash = /\\/g,
      rLineSep = /\u2028/,
      rParagraphSep = /\u2029/;

  Hogan.tags = {
    '#': 1, '^': 2, '<': 3, '$': 4,
    '/': 5, '!': 6, '>': 7, '=': 8, '_v': 9,
    '{': 10, '&': 11, '_t': 12
  };

  Hogan.scan = function scan(text, delimiters) {
    var len = text.length,
        IN_TEXT = 0,
        IN_TAG_TYPE = 1,
        IN_TAG = 2,
        state = IN_TEXT,
        tagType = null,
        tag = null,
        buf = '',
        tokens = [],
        seenTag = false,
        i = 0,
        lineStart = 0,
        otag = '{{',
        ctag = '}}';

    function addBuf() {
      if (buf.length > 0) {
        tokens.push({tag: '_t', text: new String(buf)});
        buf = '';
      }
    }

    function lineIsWhitespace() {
      var isAllWhitespace = true;
      for (var j = lineStart; j < tokens.length; j++) {
        isAllWhitespace =
          (Hogan.tags[tokens[j].tag] < Hogan.tags['_v']) ||
          (tokens[j].tag == '_t' && tokens[j].text.match(rIsWhitespace) === null);
        if (!isAllWhitespace) {
          return false;
        }
      }

      return isAllWhitespace;
    }

    function filterLine(haveSeenTag, noNewLine) {
      addBuf();

      if (haveSeenTag && lineIsWhitespace()) {
        for (var j = lineStart, next; j < tokens.length; j++) {
          if (tokens[j].text) {
            if ((next = tokens[j+1]) && next.tag == '>') {
              // set indent to token value
              next.indent = tokens[j].text.toString()
            }
            tokens.splice(j, 1);
          }
        }
      } else if (!noNewLine) {
        tokens.push({tag:'\n'});
      }

      seenTag = false;
      lineStart = tokens.length;
    }

    function changeDelimiters(text, index) {
      var close = '=' + ctag,
          closeIndex = text.indexOf(close, index),
          delimiters = trim(
            text.substring(text.indexOf('=', index) + 1, closeIndex)
          ).split(' ');

      otag = delimiters[0];
      ctag = delimiters[delimiters.length - 1];

      return closeIndex + close.length - 1;
    }

    if (delimiters) {
      delimiters = delimiters.split(' ');
      otag = delimiters[0];
      ctag = delimiters[1];
    }

    for (i = 0; i < len; i++) {
      if (state == IN_TEXT) {
        if (tagChange(otag, text, i)) {
          --i;
          addBuf();
          state = IN_TAG_TYPE;
        } else {
          if (text.charAt(i) == '\n') {
            filterLine(seenTag);
          } else {
            buf += text.charAt(i);
          }
        }
      } else if (state == IN_TAG_TYPE) {
        i += otag.length - 1;
        tag = Hogan.tags[text.charAt(i + 1)];
        tagType = tag ? text.charAt(i + 1) : '_v';
        if (tagType == '=') {
          i = changeDelimiters(text, i);
          state = IN_TEXT;
        } else {
          if (tag) {
            i++;
          }
          state = IN_TAG;
        }
        seenTag = i;
      } else {
        if (tagChange(ctag, text, i)) {
          tokens.push({tag: tagType, n: trim(buf), otag: otag, ctag: ctag,
                       i: (tagType == '/') ? seenTag - otag.length : i + ctag.length});
          buf = '';
          i += ctag.length - 1;
          state = IN_TEXT;
          if (tagType == '{') {
            if (ctag == '}}') {
              i++;
            } else {
              cleanTripleStache(tokens[tokens.length - 1]);
            }
          }
        } else {
          buf += text.charAt(i);
        }
      }
    }

    filterLine(seenTag, true);

    return tokens;
  }

  function cleanTripleStache(token) {
    if (token.n.substr(token.n.length - 1) === '}') {
      token.n = token.n.substring(0, token.n.length - 1);
    }
  }

  function trim(s) {
    if (s.trim) {
      return s.trim();
    }

    return s.replace(/^\s*|\s*$/g, '');
  }

  function tagChange(tag, text, index) {
    if (text.charAt(index) != tag.charAt(0)) {
      return false;
    }

    for (var i = 1, l = tag.length; i < l; i++) {
      if (text.charAt(index + i) != tag.charAt(i)) {
        return false;
      }
    }

    return true;
  }

  // the tags allowed inside super templates
  var allowedInSuper = {'_t': true, '\n': true, '$': true, '/': true};

  function buildTree(tokens, kind, stack, customTags) {
    var instructions = [],
        opener = null,
        tail = null,
        token = null;

    tail = stack[stack.length - 1];

    while (tokens.length > 0) {
      token = tokens.shift();

      if (tail && tail.tag == '<' && !(token.tag in allowedInSuper)) {
        throw new Error('Illegal content in < super tag.');
      }

      if (Hogan.tags[token.tag] <= Hogan.tags['$'] || isOpener(token, customTags)) {
        stack.push(token);
        token.nodes = buildTree(tokens, token.tag, stack, customTags);
      } else if (token.tag == '/') {
        if (stack.length === 0) {
          throw new Error('Closing tag without opener: /' + token.n);
        }
        opener = stack.pop();
        if (token.n != opener.n && !isCloser(token.n, opener.n, customTags)) {
          throw new Error('Nesting error: ' + opener.n + ' vs. ' + token.n);
        }
        opener.end = token.i;
        return instructions;
      } else if (token.tag == '\n') {
        token.last = (tokens.length == 0) || (tokens[0].tag == '\n');
      }

      instructions.push(token);
    }

    if (stack.length > 0) {
      throw new Error('missing closing tag: ' + stack.pop().n);
    }

    return instructions;
  }

  function isOpener(token, tags) {
    for (var i = 0, l = tags.length; i < l; i++) {
      if (tags[i].o == token.n) {
        token.tag = '#';
        return true;
      }
    }
  }

  function isCloser(close, open, tags) {
    for (var i = 0, l = tags.length; i < l; i++) {
      if (tags[i].c == close && tags[i].o == open) {
        return true;
      }
    }
  }

  function stringifySubstitutions(obj) {
    var items = [];
    for (var key in obj) {
      items.push('"' + esc(key) + '": function(c,p,t,i) {' + obj[key] + '}');
    }
    return "{ " + items.join(",") + " }";
  }

  function stringifyPartials(codeObj) {
    var partials = [];
    for (var key in codeObj.partials) {
      partials.push('"' + esc(key) + '":{name:"' + esc(codeObj.partials[key].name) + '", ' + stringifyPartials(codeObj.partials[key]) + "}");
    }
    return "partials: {" + partials.join(",") + "}, subs: " + stringifySubstitutions(codeObj.subs);
  }

  Hogan.stringify = function(codeObj, text, options) {
    return "{code: function (c,p,i) { " + Hogan.wrapMain(codeObj.code) + " }," + stringifyPartials(codeObj) +  "}";
  }

  var serialNo = 0;
  Hogan.generate = function(tree, text, options) {
    serialNo = 0;
    var context = { code: '', subs: {}, partials: {} };
    Hogan.walk(tree, context);

    if (options.asString) {
      return this.stringify(context, text, options);
    }

    return this.makeTemplate(context, text, options);
  }

  Hogan.wrapMain = function(code) {
    return 'var t=this;t.b(i=i||"");' + code + 'return t.fl();';
  }

  Hogan.template = Hogan.Template;

  Hogan.makeTemplate = function(codeObj, text, options) {
    var template = this.makePartials(codeObj);
    template.code = new Function('c', 'p', 'i', this.wrapMain(codeObj.code));
    return new this.template(template, text, this, options);
  }

  Hogan.makePartials = function(codeObj) {
    var key, template = {subs: {}, partials: codeObj.partials, name: codeObj.name};
    for (key in template.partials) {
      template.partials[key] = this.makePartials(template.partials[key]);
    }
    for (key in codeObj.subs) {
      template.subs[key] = new Function('c', 'p', 't', 'i', codeObj.subs[key]);
    }
    return template;
  }

  function esc(s) {
    return s.replace(rSlash, '\\\\')
            .replace(rQuot, '\\\"')
            .replace(rNewline, '\\n')
            .replace(rCr, '\\r')
            .replace(rLineSep, '\\u2028')
            .replace(rParagraphSep, '\\u2029');
  }

  function chooseMethod(s) {
    return (~s.indexOf('.')) ? 'd' : 'f';
  }

  function createPartial(node, context) {
    var prefix = "<" + (context.prefix || "");
    var sym = prefix + node.n + serialNo++;
    context.partials[sym] = {name: node.n, partials: {}};
    context.code += 't.b(t.rp("' +  esc(sym) + '",c,p,"' + (node.indent || '') + '"));';
    return sym;
  }

  Hogan.codegen = {
    '#': function(node, context) {
      context.code += 'if(t.s(t.' + chooseMethod(node.n) + '("' + esc(node.n) + '",c,p,1),' +
                      'c,p,0,' + node.i + ',' + node.end + ',"' + node.otag + " " + node.ctag + '")){' +
                      't.rs(c,p,' + 'function(c,p,t){';
      Hogan.walk(node.nodes, context);
      context.code += '});c.pop();}';
    },

    '^': function(node, context) {
      context.code += 'if(!t.s(t.' + chooseMethod(node.n) + '("' + esc(node.n) + '",c,p,1),c,p,1,0,0,"")){';
      Hogan.walk(node.nodes, context);
      context.code += '};';
    },

    '>': createPartial,
    '<': function(node, context) {
      var ctx = {partials: {}, code: '', subs: {}, inPartial: true};
      Hogan.walk(node.nodes, ctx);
      var template = context.partials[createPartial(node, context)];
      template.subs = ctx.subs;
      template.partials = ctx.partials;
    },

    '$': function(node, context) {
      var ctx = {subs: {}, code: '', partials: context.partials, prefix: node.n};
      Hogan.walk(node.nodes, ctx);
      context.subs[node.n] = ctx.code;
      if (!context.inPartial) {
        context.code += 't.sub("' + esc(node.n) + '",c,p,i);';
      }
    },

    '\n': function(node, context) {
      context.code += write('"\\n"' + (node.last ? '' : ' + i'));
    },

    '_v': function(node, context) {
      context.code += 't.b(t.v(t.' + chooseMethod(node.n) + '("' + esc(node.n) + '",c,p,0)));';
    },

    '_t': function(node, context) {
      context.code += write('"' + esc(node.text) + '"');
    },

    '{': tripleStache,

    '&': tripleStache
  }

  function tripleStache(node, context) {
    context.code += 't.b(t.t(t.' + chooseMethod(node.n) + '("' + esc(node.n) + '",c,p,0)));';
  }

  function write(s) {
    return 't.b(' + s + ');';
  }

  Hogan.walk = function(nodelist, context) {
    var func;
    for (var i = 0, l = nodelist.length; i < l; i++) {
      func = Hogan.codegen[nodelist[i].tag];
      func && func(nodelist[i], context);
    }
    return context;
  }

  Hogan.parse = function(tokens, text, options) {
    options = options || {};
    return buildTree(tokens, '', [], options.sectionTags || []);
  }

  Hogan.cache = {};

  Hogan.cacheKey = function(text, options) {
    return [text, !!options.asString, !!options.disableLambda, options.delimiters, !!options.modelGet].join('||');
  }

  Hogan.compile = function(text, options) {
    options = options || {};
    var key = Hogan.cacheKey(text, options);
    var template = this.cache[key];

    if (template) {
      var partials = template.partials;
      for (var name in partials) {
        delete partials[name].instance;
      }
      return template;
    }

    template = this.generate(this.parse(this.scan(text, options.delimiters), text, options), text, options);
    return this.cache[key] = template;
  }
})(typeof exports !== 'undefined' ? exports : Hogan);

},{}],248:[function(require,module,exports){
/*
 *  Copyright 2011 Twitter, Inc.
 *  Licensed under the Apache License, Version 2.0 (the "License");
 *  you may not use this file except in compliance with the License.
 *  You may obtain a copy of the License at
 *
 *  http://www.apache.org/licenses/LICENSE-2.0
 *
 *  Unless required by applicable law or agreed to in writing, software
 *  distributed under the License is distributed on an "AS IS" BASIS,
 *  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *  See the License for the specific language governing permissions and
 *  limitations under the License.
 */

// This file is for use with Node.js. See dist/ for browser files.

var Hogan = require('./compiler');
Hogan.Template = require('./template').Template;
Hogan.template = Hogan.Template;
module.exports = Hogan;

},{"./compiler":247,"./template":249}],249:[function(require,module,exports){
/*
 *  Copyright 2011 Twitter, Inc.
 *  Licensed under the Apache License, Version 2.0 (the "License");
 *  you may not use this file except in compliance with the License.
 *  You may obtain a copy of the License at
 *
 *  http://www.apache.org/licenses/LICENSE-2.0
 *
 *  Unless required by applicable law or agreed to in writing, software
 *  distributed under the License is distributed on an "AS IS" BASIS,
 *  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *  See the License for the specific language governing permissions and
 *  limitations under the License.
 */

var Hogan = {};

(function (Hogan) {
  Hogan.Template = function (codeObj, text, compiler, options) {
    codeObj = codeObj || {};
    this.r = codeObj.code || this.r;
    this.c = compiler;
    this.options = options || {};
    this.text = text || '';
    this.partials = codeObj.partials || {};
    this.subs = codeObj.subs || {};
    this.buf = '';
  }

  Hogan.Template.prototype = {
    // render: replaced by generated code.
    r: function (context, partials, indent) { return ''; },

    // variable escaping
    v: hoganEscape,

    // triple stache
    t: coerceToString,

    render: function render(context, partials, indent) {
      return this.ri([context], partials || {}, indent);
    },

    // render internal -- a hook for overrides that catches partials too
    ri: function (context, partials, indent) {
      return this.r(context, partials, indent);
    },

    // ensurePartial
    ep: function(symbol, partials) {
      var partial = this.partials[symbol];

      // check to see that if we've instantiated this partial before
      var template = partials[partial.name];
      if (partial.instance && partial.base == template) {
        return partial.instance;
      }

      if (typeof template == 'string') {
        if (!this.c) {
          throw new Error("No compiler available.");
        }
        template = this.c.compile(template, this.options);
      }

      if (!template) {
        return null;
      }

      // We use this to check whether the partials dictionary has changed
      this.partials[symbol].base = template;

      if (partial.subs) {
        // Make sure we consider parent template now
        if (!partials.stackText) partials.stackText = {};
        for (key in partial.subs) {
          if (!partials.stackText[key]) {
            partials.stackText[key] = (this.activeSub !== undefined && partials.stackText[this.activeSub]) ? partials.stackText[this.activeSub] : this.text;
          }
        }
        template = createSpecializedPartial(template, partial.subs, partial.partials,
          this.stackSubs, this.stackPartials, partials.stackText);
      }
      this.partials[symbol].instance = template;

      return template;
    },

    // tries to find a partial in the current scope and render it
    rp: function(symbol, context, partials, indent) {
      var partial = this.ep(symbol, partials);
      if (!partial) {
        return '';
      }

      return partial.ri(context, partials, indent);
    },

    // render a section
    rs: function(context, partials, section) {
      var tail = context[context.length - 1];

      if (!isArray(tail)) {
        section(context, partials, this);
        return;
      }

      for (var i = 0; i < tail.length; i++) {
        context.push(tail[i]);
        section(context, partials, this);
        context.pop();
      }
    },

    // maybe start a section
    s: function(val, ctx, partials, inverted, start, end, tags) {
      var pass;

      if (isArray(val) && val.length === 0) {
        return false;
      }

      if (typeof val == 'function') {
        val = this.ms(val, ctx, partials, inverted, start, end, tags);
      }

      pass = !!val;

      if (!inverted && pass && ctx) {
        ctx.push((typeof val == 'object') ? val : ctx[ctx.length - 1]);
      }

      return pass;
    },

    // find values with dotted names
    d: function(key, ctx, partials, returnFound) {
      var found,
          names = key.split('.'),
          val = this.f(names[0], ctx, partials, returnFound),
          doModelGet = this.options.modelGet,
          cx = null;

      if (key === '.' && isArray(ctx[ctx.length - 2])) {
        val = ctx[ctx.length - 1];
      } else {
        for (var i = 1; i < names.length; i++) {
          found = findInScope(names[i], val, doModelGet);
          if (found !== undefined) {
            cx = val;
            val = found;
          } else {
            val = '';
          }
        }
      }

      if (returnFound && !val) {
        return false;
      }

      if (!returnFound && typeof val == 'function') {
        ctx.push(cx);
        val = this.mv(val, ctx, partials);
        ctx.pop();
      }

      return val;
    },

    // find values with normal names
    f: function(key, ctx, partials, returnFound) {
      var val = false,
          v = null,
          found = false,
          doModelGet = this.options.modelGet;

      for (var i = ctx.length - 1; i >= 0; i--) {
        v = ctx[i];
        val = findInScope(key, v, doModelGet);
        if (val !== undefined) {
          found = true;
          break;
        }
      }

      if (!found) {
        return (returnFound) ? false : "";
      }

      if (!returnFound && typeof val == 'function') {
        val = this.mv(val, ctx, partials);
      }

      return val;
    },

    // higher order templates
    ls: function(func, cx, partials, text, tags) {
      var oldTags = this.options.delimiters;

      this.options.delimiters = tags;
      this.b(this.ct(coerceToString(func.call(cx, text)), cx, partials));
      this.options.delimiters = oldTags;

      return false;
    },

    // compile text
    ct: function(text, cx, partials) {
      if (this.options.disableLambda) {
        throw new Error('Lambda features disabled.');
      }
      return this.c.compile(text, this.options).render(cx, partials);
    },

    // template result buffering
    b: function(s) { this.buf += s; },

    fl: function() { var r = this.buf; this.buf = ''; return r; },

    // method replace section
    ms: function(func, ctx, partials, inverted, start, end, tags) {
      var textSource,
          cx = ctx[ctx.length - 1],
          result = func.call(cx);

      if (typeof result == 'function') {
        if (inverted) {
          return true;
        } else {
          textSource = (this.activeSub && this.subsText && this.subsText[this.activeSub]) ? this.subsText[this.activeSub] : this.text;
          return this.ls(result, cx, partials, textSource.substring(start, end), tags);
        }
      }

      return result;
    },

    // method replace variable
    mv: function(func, ctx, partials) {
      var cx = ctx[ctx.length - 1];
      var result = func.call(cx);

      if (typeof result == 'function') {
        return this.ct(coerceToString(result.call(cx)), cx, partials);
      }

      return result;
    },

    sub: function(name, context, partials, indent) {
      var f = this.subs[name];
      if (f) {
        this.activeSub = name;
        f(context, partials, this, indent);
        this.activeSub = false;
      }
    }

  };

  //Find a key in an object
  function findInScope(key, scope, doModelGet) {
    var val;

    if (scope && typeof scope == 'object') {

      if (scope[key] !== undefined) {
        val = scope[key];

      // try lookup with get for backbone or similar model data
      } else if (doModelGet && scope.get && typeof scope.get == 'function') {
        val = scope.get(key);
      }
    }

    return val;
  }

  function createSpecializedPartial(instance, subs, partials, stackSubs, stackPartials, stackText) {
    function PartialTemplate() {};
    PartialTemplate.prototype = instance;
    function Substitutions() {};
    Substitutions.prototype = instance.subs;
    var key;
    var partial = new PartialTemplate();
    partial.subs = new Substitutions();
    partial.subsText = {};  //hehe. substext.
    partial.buf = '';

    stackSubs = stackSubs || {};
    partial.stackSubs = stackSubs;
    partial.subsText = stackText;
    for (key in subs) {
      if (!stackSubs[key]) stackSubs[key] = subs[key];
    }
    for (key in stackSubs) {
      partial.subs[key] = stackSubs[key];
    }

    stackPartials = stackPartials || {};
    partial.stackPartials = stackPartials;
    for (key in partials) {
      if (!stackPartials[key]) stackPartials[key] = partials[key];
    }
    for (key in stackPartials) {
      partial.partials[key] = stackPartials[key];
    }

    return partial;
  }

  var rAmp = /&/g,
      rLt = /</g,
      rGt = />/g,
      rApos = /\'/g,
      rQuot = /\"/g,
      hChars = /[&<>\"\']/;

  function coerceToString(val) {
    return String((val === null || val === undefined) ? '' : val);
  }

  function hoganEscape(str) {
    str = coerceToString(str);
    return hChars.test(str) ?
      str
        .replace(rAmp, '&amp;')
        .replace(rLt, '&lt;')
        .replace(rGt, '&gt;')
        .replace(rApos, '&#39;')
        .replace(rQuot, '&quot;') :
      str;
  }

  var isArray = Array.isArray || function(a) {
    return Object.prototype.toString.call(a) === '[object Array]';
  };

})(typeof exports !== 'undefined' ? exports : Hogan);

},{}],250:[function(require,module,exports){
var CountdownTimerView, FourPackCarouselView, FullWidthCarousel, GoodsCarouselView, ResponsiveCarouselView, RightRailView, VideoWidgetView, base,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

FourPackCarouselView = (function(superClass) {
  extend(FourPackCarouselView, superClass);

  function FourPackCarouselView() {
    return FourPackCarouselView.__super__.constructor.apply(this, arguments);
  }

  FourPackCarouselView.prototype.events = {
    'click .carousel-previous': 'moveLeft',
    'click .carousel-next': 'moveRight'
  };

  FourPackCarouselView.prototype.initialize = function() {
    this.$carousel = this.$('.carousel');
    this.$leftButton = this.$('.carousel-previous');
    this.$rightButton = this.$('.carousel-next');
    this.$pagesList = this.$('.carousel-pages');
    this.currentPosition = 0;
    this.currentPage = 1;
    this.maxPosition = this.$('.deal-card').length - 1;
    this.visibleCards = 4;
    this._buildNavigation();
    return this._lazyLoadAllImages();
  };

  FourPackCarouselView.prototype._buildNavigation = function() {
    var i, lastPage, page, ref;
    lastPage = Math.ceil((this.maxPosition + 1) / this.visibleCards);
    for (page = i = 1, ref = lastPage; 1 <= ref ? i <= ref : i >= ref; page = 1 <= ref ? ++i : --i) {
      this.$pagesList.append("<li class='page-count page-" + page + "'></li>");
    }
    return this.$('.page-1').addClass('active');
  };

  FourPackCarouselView.prototype._lazyLoadAllImages = function() {
    return this.$('.lazy-load').lazyload({
      container: this.$carousel,
      threshold: this.$carousel.width()
    });
  };

  FourPackCarouselView.prototype.moveLeft = function() {
    if (!this.canMoveLeft()) {
      return;
    }
    if (this.$leftButton.hasClass('inactive')) {
      return;
    }
    this.currentPage -= 1;
    if (this.currentPosition - this.visibleCards < 0) {
      return this.animate(0);
    } else {
      return this.animate(this.currentPosition - this.visibleCards);
    }
  };

  FourPackCarouselView.prototype.moveRight = function() {
    if (!this.canMoveRight()) {
      return;
    }
    if (this.$rightButton.hasClass('inactive')) {
      return;
    }
    this.currentPage += 1;
    if (this.currentPosition + (this.visibleCards - 1) + this.visibleCards > this.maxPosition) {
      return this.animate(this.maxPosition - (this.visibleCards - 1));
    } else {
      return this.animate(this.currentPosition + this.visibleCards);
    }
  };

  FourPackCarouselView.prototype.canMoveRight = function() {
    return (this.currentPosition + this.visibleCards) <= this.maxPosition;
  };

  FourPackCarouselView.prototype.canMoveLeft = function() {
    return this.currentPosition >= 1;
  };

  FourPackCarouselView.prototype.showButton = function($button) {
    return $button.removeClass('inactive');
  };

  FourPackCarouselView.prototype.hideButton = function($button) {
    return $button.addClass('inactive');
  };

  FourPackCarouselView.prototype.animate = function(newPosition) {
    if (Modernizr.csstransitions) {
      this.$carousel.css({
        left: -(newPosition * 239)
      });
      return this.finishAnimation(newPosition);
    } else {
      return this.$carousel.animate({
        left: -(newPosition * 239)
      }, {
        duration: 250,
        complete: (function(_this) {
          return function() {
            return _this.finishAnimation(newPosition);
          };
        })(this)
      });
    }
  };

  FourPackCarouselView.prototype.finishAnimation = function(newPosition) {
    this.currentPosition = newPosition;
    this.$('.page-count').removeClass('active');
    this.$(".page-" + this.currentPage).addClass('active');
    if (this.canMoveLeft()) {
      this.showButton(this.$leftButton);
    } else {
      this.hideButton(this.$leftButton);
    }
    if (this.canMoveRight()) {
      return this.showButton(this.$rightButton);
    } else {
      return this.hideButton(this.$rightButton);
    }
  };

  return FourPackCarouselView;

})(Backbone.View);

RightRailView = (function(superClass) {
  extend(RightRailView, superClass);

  function RightRailView() {
    this.setFixPoint = bind(this.setFixPoint, this);
    this.shouldFix = bind(this.shouldFix, this);
    this.atBottom = bind(this.atBottom, this);
    this.floatView = bind(this.floatView, this);
    return RightRailView.__super__.constructor.apply(this, arguments);
  }

  RightRailView.prototype.initialize = function() {
    this.container = $(window);
    this.document = $(document);
    this.header = $(".header");
    this.banner = $(".in-app-msg-banner");
    this.bannerCloseBtn = $(".in-app-msg-banner .hide-link");
    this.footer = $(".footer-i18n");
    this.fixedTopMargin = 50;
    this.fixPoint = 0;
    this.setFixPoint();
    this.floatView();
    this.container.scroll(this.floatView);
    return this.bannerCloseBtn.click(this.setFixPoint);
  };

  RightRailView.prototype.floatView = function() {
    this.$el.removeClass('fixed top bottom');
    if (this.shouldFix()) {
      return this.$el.addClass('fixed');
    } else if (this.atBottom()) {
      return this.$el.addClass('bottom');
    } else {
      return this.$el.addClass('top');
    }
  };

  RightRailView.prototype.atBottom = function() {
    return this.container.scrollTop() + this.$el.outerHeight() + this.fixedTopMargin > this.document.height() - this.footer.outerHeight();
  };

  RightRailView.prototype.shouldFix = function() {
    return this.container.scrollTop() > this.fixPoint && !this.atBottom();
  };

  RightRailView.prototype.setFixPoint = function() {
    return this.fixPoint = this.header.position().top + this.outerHeightWithMargin(this.header) + this.outerHeightWithMargin(this.banner) - this.fixedTopMargin;
  };

  RightRailView.prototype.outerHeightWithMargin = function(element) {
    if (!element.is(':visible')) {
      return 0;
    }
    return element.outerHeight(true);
  };

  return RightRailView;

})(Backbone.View);

VideoWidgetView = (function(superClass) {
  extend(VideoWidgetView, superClass);

  function VideoWidgetView() {
    this.resetVideoPlayer = bind(this.resetVideoPlayer, this);
    this.onCreate = bind(this.onCreate, this);
    return VideoWidgetView.__super__.constructor.apply(this, arguments);
  }

  VideoWidgetView.prototype.events = {
    'click .image-container': 'playVideo'
  };

  VideoWidgetView.videoIsloaded = false;

  VideoWidgetView.prototype.initialize = function() {
    if (this.$el == null) {
      this.$el = $(this.el);
    }
    this.video = this.$('.video-container');
    this.imageContainer = this.$('.image-container');
    this.previewImageAndPlayButton = this.$('.image-container img');
    this.videoId = this.video.data('video-id');
    if (!this.videoIsloaded) {
      return this.loadVideoPlayer();
    }
  };

  VideoWidgetView.prototype.onCreate = function(player) {
    return player.subscribe('played', 'myPage', this.resetVideoPlayer);
  };

  VideoWidgetView.prototype.resetVideoPlayer = function() {
    this.imageContainer.removeClass('hidden');
    this.previewImageAndPlayButton.animate({
      opacity: 0.8,
      duration: 100
    });
    return this.videoPlayer.seek(0);
  };

  VideoWidgetView.prototype.fetchVideoPlayer = function() {
    return OO.ready((function(_this) {
      return function() {
        var options;
        options = {
          flashParams: {
            hide: 'info,endscreen'
          },
          onCreate: _this.onCreate
        };
        return _this.videoPlayer = OO.Player.create('ooyala-player', _this.videoId, options);
      };
    })(this));
  };

  VideoWidgetView.prototype.loadVideoPlayer = function() {
    var script;
    script = document.createElement("script");
    script.type = "text/javascript";
    script.src = "//player.ooyala.com/v3/4e60e82cdbc14def8b05623206f02388";
    if (script.readyState) {
      script.onreadystatechange = function() {
        if (script.readyState === "loaded" || script.readyState === "complete") {
          this.videoIsloaded = true;
        }
      };
    } else {
      script.onload = function() {
        this.videoIsloaded = true;
      };
    }
    $("head").append(script);
  };

  VideoWidgetView.prototype.playVideo = function() {
    if (!this.videoPlayer) {
      this.fetchVideoPlayer();
    }
    this.videoPlayer.play();
    this.imageContainer.addClass('hidden');
    return this.previewImageAndPlayButton.css({
      opacity: 0
    });
  };

  return VideoWidgetView;

})(Backbone.View);

CountdownTimerView = (function(superClass) {
  extend(CountdownTimerView, superClass);

  function CountdownTimerView() {
    this.getNewTimeStamp = bind(this.getNewTimeStamp, this);
    this.updateCountdown = bind(this.updateCountdown, this);
    return CountdownTimerView.__super__.constructor.apply(this, arguments);
  }

  CountdownTimerView.prototype.initialize = function() {
    if (this.$el == null) {
      this.$el = $(this.el);
    }
    this.offerEndTime = $('.steals-timer').data('offer-end-time');
    this.tick = 1000;
    this.getNewTimeStamp();
    return this.updateCountdown();
  };

  CountdownTimerView.prototype.updateCountdown = function() {
    return setInterval(this.getNewTimeStamp, this.tick);
  };

  CountdownTimerView.prototype.timeRemaining = function(timeRemainingMilliseconds) {
    var days, hours, millisecondsLeft, minutes, seconds;
    if (timeRemainingMilliseconds == null) {
      return {
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0
      };
    }
    days = Math.floor(timeRemainingMilliseconds / (1000 * 3600 * 24));
    millisecondsLeft = Math.floor(timeRemainingMilliseconds - days * (1000 * 3600 * 24));
    hours = Math.floor(millisecondsLeft / (1000 * 3600));
    millisecondsLeft = Math.floor(millisecondsLeft - hours * (1000 * 3600));
    minutes = Math.floor(millisecondsLeft / (1000 * 60));
    millisecondsLeft = Math.floor(millisecondsLeft - minutes * 1000 * 60);
    seconds = Math.floor(millisecondsLeft / 1000);
    return {
      days: days,
      hours: hours,
      minutes: minutes,
      seconds: seconds
    };
  };

  CountdownTimerView.prototype.millisRemaining = function(endTime) {
    var millsRemaining, rightNow;
    if (endTime == null) {
      return 0;
    }
    rightNow = new Date().getTime();
    millsRemaining = endTime - rightNow;
    if (millsRemaining < 0) {
      return 0;
    } else {
      return millsRemaining;
    }
  };

  CountdownTimerView.prototype.countdownTimestamp = function(timeLeft) {
    var hh, mm, ss;
    hh = this.addLeadingZero(timeLeft.hours);
    mm = this.addLeadingZero(timeLeft.minutes);
    ss = this.addLeadingZero(timeLeft.seconds);
    return " " + hh + ":" + mm + ":" + ss;
  };

  CountdownTimerView.prototype.addLeadingZero = function(number) {
    if (number < 0) {
      return;
    }
    if (number < 10) {
      return "0" + number;
    } else {
      return "" + number;
    }
  };

  CountdownTimerView.prototype.getNewTimeStamp = function() {
    var endTime, millisLeft, newTimeStamp, ref;
    if (((ref = this.offerEndTime) != null ? ref.length : void 0) < 1) {
      this.offerEndTime = this.getEndOfDayTime();
    }
    endTime = Date.parse(this.offerEndTime);
    millisLeft = this.millisRemaining(endTime);
    newTimeStamp = this.countdownTimestamp(this.timeRemaining(millisLeft));
    return this.$el.html(newTimeStamp);
  };

  CountdownTimerView.prototype.getEndOfDayTime = function() {
    var date;
    date = new Date();
    date.setDate(date.getDate() + 1);
    date.setHours(0);
    date.setMinutes(0);
    date.setSeconds(0);
    return date;
  };

  return CountdownTimerView;

})(Backbone.View);

GoodsCarouselView = (function(superClass) {
  extend(GoodsCarouselView, superClass);

  function GoodsCarouselView() {
    this.start = bind(this.start, this);
    return GoodsCarouselView.__super__.constructor.apply(this, arguments);
  }

  GoodsCarouselView.prototype.events = {
    "click .goods-carousel-navbar .icon-arrow-left-large": "slideLeft",
    "click .goods-carousel-navbar .icon-arrow-right-large": "slideRight",
    "click .goods-carousel-navbar .icon-circle": "navigateToNavItem"
  };

  GoodsCarouselView.prototype.initialize = function() {
    this.interval = 6000;
    this.size = this.$(".carousel-slide").length;
    this.fadeDuration = 20;
    if (this.size > 1) {
      this.position = 1;
      this.$slides = this.$('.carousel-slide');
      this.$navs = this.$('.goods-carousel-navbar .icon-circle');
      return setTimeout(this.start, this.interval);
    }
  };

  GoodsCarouselView.prototype.slideLeft = function() {
    this.stop();
    return this.slide('left');
  };

  GoodsCarouselView.prototype.slideRight = function() {
    this.stop();
    return this.slide();
  };

  GoodsCarouselView.prototype.navigateToNavItem = function(e) {
    var position;
    position = $(e.currentTarget).data('position');
    this.stop();
    return this.updateCarousel(position);
  };

  GoodsCarouselView.prototype.start = function() {
    this.slide();
    return this.slider = setTimeout(this.start, this.interval);
  };

  GoodsCarouselView.prototype.stop = function() {
    return window.clearTimeout(this.slider);
  };

  GoodsCarouselView.prototype.slide = function(direction) {
    if (direction == null) {
      direction = 'right';
    }
    return this.updateCarousel(this.nextPosition(direction));
  };

  GoodsCarouselView.prototype.nextPosition = function(direction) {
    if (direction === 'right') {
      if (this.position < this.size) {
        return this.position + 1;
      } else {
        return 1;
      }
    } else {
      if (this.position > 1) {
        return this.position - 1;
      } else {
        return this.size;
      }
    }
  };

  GoodsCarouselView.prototype.updateCarousel = function(nextPosition) {
    if (this.position === nextPosition) {
      return;
    }
    this.updateSlide(nextPosition);
    this.updateNav(nextPosition);
    return this.position = nextPosition;
  };

  GoodsCarouselView.prototype.updateSlide = function(nextPosition) {
    var currentSlide, nextSlide;
    currentSlide = this.$slides.filter('.current-slide');
    nextSlide = this.$slides.filter("[data-position='" + nextPosition + "']");
    currentSlide.fadeTo(this.fadeDuration, 0);
    currentSlide.hide().removeClass("current-slide");
    return nextSlide.show().fadeTo(this.fadeDuration, 1).addClass("current-slide");
  };

  GoodsCarouselView.prototype.updateNav = function(nextPosition) {
    var currentNav, nextNav;
    currentNav = this.$navs.filter('.current-slide');
    nextNav = this.$navs.filter("[data-position='" + nextPosition + "']");
    currentNav.removeClass("current-slide");
    return nextNav.addClass("current-slide");
  };

  return GoodsCarouselView;

})(Backbone.View);

FullWidthCarousel = (function(superClass) {
  extend(FullWidthCarousel, superClass);

  function FullWidthCarousel() {
    this._setGutters = bind(this._setGutters, this);
    return FullWidthCarousel.__super__.constructor.apply(this, arguments);
  }

  FullWidthCarousel.prototype.events = {
    'click .full-width-carousel-prev': 'triggerPrev',
    'click .full-width-carousel-next': 'triggerNext',
    'click .full-width-carousel-dot': 'triggerNavDot'
  };

  FullWidthCarousel.prototype.initialize = function() {
    this.$listbox = this.$el.find('[role=listbox]');
    this.pixelsToMove = this._pixelsToMove();
    this.centeredViewportLeft = this.$listbox.css('left');
    this._initalizeGutters();
    this._animationDuration = 200;
    this._numberNavDots = this.$el.find('.full-width-carousel-dot').length;
    this._lazyLoadAllImages();
    return this._updateSelectedDeals();
  };

  FullWidthCarousel.prototype._lazyLoadAllImages = function() {
    var container;
    container = this.$('.full-width-carousel-container');
    return this.$('.lazy-load').lazyload({
      container: container,
      threshold: this.$listbox.width()
    });
  };

  FullWidthCarousel.prototype.triggerNavDot = function(event) {
    var newPosition, oldPosition;
    event.preventDefault();
    newPosition = $(event.currentTarget).data('index');
    oldPosition = this.$el.find('.full-width-carousel-dot-selected').data('index');
    this._updateNavDotSelected(newPosition);
    switch (false) {
      case !(oldPosition < newPosition):
        return this._moveRight(newPosition - oldPosition);
      case !(newPosition < oldPosition):
        return this._moveLeft(oldPosition - newPosition);
    }
  };

  FullWidthCarousel.prototype.triggerNext = function(event) {
    var currentSelected, newPosition;
    event.preventDefault();
    currentSelected = this.$el.find('.full-width-carousel-dot-selected').data('index');
    newPosition = this._wrapPosition(currentSelected + 1);
    this._updateNavDotSelected(newPosition);
    return this._moveRight();
  };

  FullWidthCarousel.prototype.triggerPrev = function(event) {
    var currentSelected, newPosition;
    event.preventDefault();
    currentSelected = this.$el.find('.full-width-carousel-dot-selected').data('index');
    newPosition = this._wrapPosition(currentSelected - 1);
    this._updateNavDotSelected(newPosition);
    return this._moveLeft();
  };

  FullWidthCarousel.prototype._initalizeGutters = function() {
    var throttledGutters;
    throttledGutters = _.throttle(this._setGutters, 300);
    throttledGutters();
    return $(window).on("resize", throttledGutters);
  };

  FullWidthCarousel.prototype._setGutters = function() {
    return $(".full-width-carousel-viewport").css("left", this._gutterWidth());
  };

  FullWidthCarousel.prototype._gutterWidth = function() {
    var carouselViewport, carouselViewportWidth, windowWidth;
    windowWidth = $(window).width();
    carouselViewport = this.$el.find(".full-width-carousel-viewport");
    carouselViewportWidth = carouselViewport.width();
    return (windowWidth - carouselViewportWidth) / 2;
  };

  FullWidthCarousel.prototype._wrapPosition = function(index) {
    return (index + this._numberNavDots) % this._numberNavDots;
  };

  FullWidthCarousel.prototype._moveRight = function(numberOfMoves) {
    var $images, nextAnimation;
    if (numberOfMoves == null) {
      numberOfMoves = 1;
    }
    $images = this.$listbox.find(".full-width-carousel-item").slice(0, 3);
    this.$listbox.append($images);
    this.$listbox.css('left', -960);
    if (numberOfMoves > 1) {
      nextAnimation = (function(_this) {
        return function() {
          return _this._moveRight(numberOfMoves - 1);
        };
      })(this);
    }
    return this._transition(-this.pixelsToMove, nextAnimation);
  };

  FullWidthCarousel.prototype._moveLeft = function(numberOfMoves) {
    var $images, nextAnimation;
    if (numberOfMoves == null) {
      numberOfMoves = 1;
    }
    $images = this.$listbox.find(".full-width-carousel-item").slice(-3);
    this.$listbox.prepend($images);
    this.$listbox.css('left', -(960 * 3));
    if (numberOfMoves > 1) {
      nextAnimation = (function(_this) {
        return function() {
          return _this._moveLeft(numberOfMoves - 1);
        };
      })(this);
    }
    return this._transition(this.pixelsToMove, nextAnimation);
  };

  FullWidthCarousel.prototype._transition = function(movePixels, nextAnimation) {
    var completionCallback;
    completionCallback = (function(_this) {
      return function() {
        if (nextAnimation) {
          nextAnimation();
        }
        return _this._updateSelectedDeals();
      };
    })(this);
    return this.$listbox.stop().animate({
      left: "+=" + movePixels
    }, {
      easing: 'linear',
      duration: this._animationDuration,
      complete: completionCallback
    });
  };

  FullWidthCarousel.prototype._updateSelectedDeals = function() {
    var items;
    items = this.$listbox.find('.full-width-carousel-item');
    items.removeClass('full-width-carousel-item-selected');
    return items.slice(6, 9).addClass('full-width-carousel-item-selected');
  };

  FullWidthCarousel.prototype._pixelsToMove = function() {
    var activeItems, fullWidthItemFinalWidth, includeMargin;
    activeItems = 3;
    includeMargin = true;
    fullWidthItemFinalWidth = $(".full-width-carousel-item").first().outerWidth(includeMargin);
    return fullWidthItemFinalWidth * activeItems;
  };

  FullWidthCarousel.prototype._updateNavDotSelected = function(indexToSelect) {
    this.$el.find('.full-width-carousel-dot').removeClass('full-width-carousel-dot-selected');
    return this.$el.find(".full-width-carousel-dot[data-index=" + indexToSelect + "]").addClass('full-width-carousel-dot-selected');
  };

  return FullWidthCarousel;

})(Backbone.View);

ResponsiveCarouselView = (function(superClass) {
  extend(ResponsiveCarouselView, superClass);

  function ResponsiveCarouselView() {
    this.recalculate = bind(this.recalculate, this);
    return ResponsiveCarouselView.__super__.constructor.apply(this, arguments);
  }

  ResponsiveCarouselView.prototype.events = {
    'click .carousel-previous': 'moveLeft',
    'click .carousel-next': 'moveRight'
  };

  ResponsiveCarouselView.prototype.initialize = function() {
    this.$carousel = this.$('.carousel');
    this.$leftButton = this.$('.carousel-previous');
    this.$rightButton = this.$('.carousel-next');
    this.$pagesList = this.$('.carousel-pages');
    this.$header = this.$('.section-head');
    this.containerWidth = this.$el.outerWidth();
    this.currentPosition = 0;
    this.currentPage = 0;
    this.maxPosition = this.$('.deal-card').length - 1;
    this.gap = 70;
    this.cardSize = 240;
    this.mainContentWidth = 960;
    this.visibleCards = Math.floor((this.containerWidth - this.gap) / this.cardSize);
    this.rightPixelsRemainder = (this.containerWidth - this.gap) % this.cardSize;
    $(window).resize(this, this.recalculate);
    this._alignTitle();
    this._buildNavigation();
    return this._lazyLoadAllImages();
  };

  ResponsiveCarouselView.prototype._buildNavigation = function() {
    var i, page, ref;
    this.lastPage = Math.ceil((this.maxPosition + 1) / this.visibleCards) - 1;
    for (page = i = 0, ref = this.lastPage; 0 <= ref ? i <= ref : i >= ref; page = 0 <= ref ? ++i : --i) {
      this.$pagesList.append("<li class='page-count page-" + page + "' data-page='" + page + "' data-bhc='control:circle" + page + "'></li>");
    }
    $('.page-count').on('click', (function(_this) {
      return function(e) {
        _this.currentPage = $(e.currentTarget).data('page');
        if (_this.currentPage === _this.lastPage) {
          return _this.animateLastRight(_this.maxPosition - (_this.visibleCards - 1));
        } else {
          return _this.animate(_this.currentPage * _this.visibleCards);
        }
      };
    })(this));
    return this._calculateCurrentPage();
  };

  ResponsiveCarouselView.prototype._calculateCurrentPage = function() {
    this.currentPage = Math.floor(this.currentPosition / this.visibleCards);
    this.$('.page-count').removeClass('active');
    this.$(".page-" + this.currentPage).addClass('active');
    if (this.currentPage === this.lastPage) {
      return this.animateLastRight(this.maxPosition - (this.visibleCards - 1));
    }
  };

  ResponsiveCarouselView.prototype._lazyLoadAllImages = function() {
    return this.$('.lazy-load').lazyload({
      container: this.$carousel,
      threshold: this.$carousel.width()
    });
  };

  ResponsiveCarouselView.prototype._alignTitle = function() {
    if (this.containerWidth > this.mainContentWidth) {
      return this.$header.css({
        'margin-left': Math.floor((this.containerWidth - this.mainContentWidth) / 2)
      });
    }
  };

  ResponsiveCarouselView.prototype.recalculate = function() {
    this.containerWidth = this.$el.outerWidth();
    this.visibleCards = Math.floor((this.containerWidth - this.gap) / this.cardSize);
    this.rightPixelsRemainder = (this.containerWidth - this.gap) % this.cardSize;
    this._alignTitle();
    this.$pagesList.empty();
    return this._buildNavigation();
  };

  ResponsiveCarouselView.prototype.moveLeft = function() {
    if (!this.canMoveLeft()) {
      return;
    }
    if (this.$leftButton.hasClass('inactive')) {
      return;
    }
    if (this.currentPage > 0) {
      this.currentPage -= 1;
    }
    if (this.currentPosition - this.visibleCards < 0) {
      return this.animate(0);
    } else {
      return this.animate(this.currentPosition - this.visibleCards);
    }
  };

  ResponsiveCarouselView.prototype.moveRight = function() {
    if (!this.canMoveRight()) {
      return;
    }
    if (this.$rightButton.hasClass('inactive')) {
      return;
    }
    if (this.currentPage < this.lastPage) {
      this.currentPage += 1;
    }
    if (this.currentPosition + (this.visibleCards - 1) + this.visibleCards >= this.maxPosition) {
      return this.animateLastRight(this.maxPosition - (this.visibleCards - 1));
    } else {
      return this.animate(this.currentPosition + this.visibleCards);
    }
  };

  ResponsiveCarouselView.prototype.canMoveRight = function() {
    return (this.currentPosition + this.visibleCards) <= this.maxPosition;
  };

  ResponsiveCarouselView.prototype.canMoveLeft = function() {
    return this.currentPosition >= 1;
  };

  ResponsiveCarouselView.prototype.showButton = function($button) {
    return $button.removeClass('inactive');
  };

  ResponsiveCarouselView.prototype.hideButton = function($button) {
    return $button.addClass('inactive');
  };

  ResponsiveCarouselView.prototype.animate = function(newPosition) {
    if (Modernizr.csstransitions) {
      this.$carousel.css({
        left: -(newPosition * this.cardSize) + this.gap
      });
      return this.finishAnimation(newPosition);
    } else {
      return this.$carousel.animate({
        left: -(newPosition * this.cardSize) + this.gap
      }, {
        duration: 250,
        complete: (function(_this) {
          return function() {
            return _this.finishAnimation(newPosition);
          };
        })(this)
      });
    }
  };

  ResponsiveCarouselView.prototype.animateLastRight = function(newPosition) {
    if (Modernizr.csstransitions) {
      this.$carousel.css({
        left: -(newPosition * this.cardSize) + this.rightPixelsRemainder
      });
      return this.finishAnimation(newPosition);
    } else {
      return this.$carousel.animate({
        left: -(newPosition * this.cardSize) + this.rightPixelsRemainder
      }, {
        duration: 250,
        complete: (function(_this) {
          return function() {
            return _this.finishAnimation(newPosition);
          };
        })(this)
      });
    }
  };

  ResponsiveCarouselView.prototype.finishAnimation = function(newPosition) {
    this.currentPosition = newPosition;
    this.$('.page-count').removeClass('active');
    this.$(".page-" + this.currentPage).addClass('active');
    if (this.canMoveLeft()) {
      this.showButton(this.$leftButton);
    } else {
      this.hideButton(this.$leftButton);
    }
    if (this.canMoveRight()) {
      return this.showButton(this.$rightButton);
    } else {
      return this.hideButton(this.$rightButton);
    }
  };

  return ResponsiveCarouselView;

})(Backbone.View);

if (window.WLS == null) {
  window.WLS = {};
}

if ((base = window.WLS).Views == null) {
  base.Views = {};
}

window.WLS.Views.FourPackCarousel = FourPackCarouselView;

window.WLS.Views.RightRail = RightRailView;

window.WLS.Views.VideoWidget = VideoWidgetView;

window.WLS.Views.CountdownTimer = CountdownTimerView;

window.WLS.Views.GoodsCarouselView = GoodsCarouselView;

window.WLS.Views.FullWidthCarousel = FullWidthCarousel;

window.WLS.Views.ResponsiveCarousel = ResponsiveCarouselView;

WLS.init = function($el) {
  if ($el == null) {
    $el = $(document.body);
  }
  $el.find('.right-rail').each(function(index, el) {
    return new WLS.Views.RightRail({
      el: el
    });
  });
  $el.find('.carousel-widget').each(function(index, el) {
    return new WLS.Views.FourPackCarousel({
      el: el
    });
  });
  $el.find('.video-widget').each(function(index, el) {
    return new WLS.Views.VideoWidget({
      el: el
    });
  });
  $el.find('.steals-timer').each(function(index, el) {
    return new WLS.Views.CountdownTimer({
      el: el
    });
  });
  $el.find('.goods-carousel').each(function(index, el) {
    return new WLS.Views.GoodsCarouselView({
      el: el
    });
  });
  $('.full-width-carousel').each(function(index, el) {
    return new WLS.Views.FullWidthCarousel({
      el: el
    });
  });
  return $el.find('.responsive-carousel-widget').each(function(index, el) {
    return new WLS.Views.ResponsiveCarousel({
      el: el
    });
  });
};

$(window).load(function() {
  return WLS.init();
});



},{}]},{},[1])

